_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[53],{

/***/ "+2AQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_SELLER_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sellerInfoReducer; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var GET_SELLER_EMAIL = 'GET_SELLER_EMAIL';
var initialState = {
  email: null
};
var sellerInfoReducer = function sellerInfoReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case GET_SELLER_EMAIL:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          email: action.payload.sellerInfo ? action.payload.sellerInfo.email : null
        });
      }

    default:
      return state;
  }
};

/***/ }),

/***/ "+LXU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COOKIE_PREFERENCES_STATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COOKIE_PREFERENCES_PERSO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COOKIE_PREFERENCES_MEDIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COOKIE_PREFERENCES_LAYER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return COOKIE_WARNING_LOCALSTORAGE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COOKIES_ARRAY; });
var COOKIE_PREFERENCES_STATS = 'statsCookie';
var COOKIE_PREFERENCES_PERSO = 'persoCookie';
var COOKIE_PREFERENCES_MEDIA = 'mediaCookie';
var COOKIE_PREFERENCES_LAYER = 'cookiePreferences';
var COOKIE_WARNING_LOCALSTORAGE_KEY = 'cookieBanner';
var COOKIES_ARRAY = [COOKIE_PREFERENCES_STATS, COOKIE_PREFERENCES_PERSO, COOKIE_PREFERENCES_MEDIA];

/***/ }),

/***/ "+Ugr":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("2K7v"),
    Map = __webpack_require__("McKP"),
    MapCache = __webpack_require__("pFHV");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ "+mhw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDepartureCity; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PFCZ");



function setDepartureCity(_ref) {
  var value = _ref.value;
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DEPARTURE_CITY */ "b"], {
    value: value
  });
}



/***/ }),

/***/ "/30y":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("Dhk8"),
    isObjectLike = __webpack_require__("tLQN");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ "/NZD":
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__("jbji"),
    shortOut = __webpack_require__("1iwb");

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ "/WwO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useScriptLoader; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var cachedScripts = [];
function useScriptLoader(scriptUrl) {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(cachedScripts.includes(scriptUrl)),
      scriptLoaded = _useState[0],
      setScriptLoaded = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false),
      scriptLoadingFailed = _useState2[0],
      setScriptLoadingFailed = _useState2[1];

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    if (scriptLoaded) {
      return;
    }

    var script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    new Promise(function (resolve, reject) {
      script.addEventListener('load', function () {
        return resolve(scriptUrl);
      });
      script.addEventListener('error', function (e) {
        return reject(e);
      });
    }).then(function () {
      cachedScripts.push(scriptUrl);
      setScriptLoaded(true);
    })["catch"](function () {
      script.remove();
      setScriptLoadingFailed(true);
    }); // $FlowFixMe

    document.body.appendChild(script);
  }, [scriptUrl]);
  return {
    scriptLoaded: scriptLoaded,
    scriptLoadingFailed: scriptLoadingFailed
  };
}

/***/ }),

/***/ "00cE":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "04nu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_ADDITIONAL_TRANSPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_ADDITIONAL_TRANSPORTS_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_ADDITIONAL_TRANSPORTS; });
/* unused harmony export SET_FILTERED_ADDITIONAL_TRANSPORTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TOGGLE_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DISABLE_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UPDATE_FILTERED_RESULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SORT_ADDITIONAL_TRANSPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return clearAdditionalTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return fetchAdditionalTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return disableAdditionalTransportFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return toggleAdditionalTransportFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return unselectAdditionalTransportsFilterCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return updateAdditionalTransportsSort; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("70jX");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("rJ95");
/* harmony import */ var _booking_selector__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("uL19");







var CLEAR_ADDITIONAL_TRANSPORTS = 'CLEAR_ADDITIONAL_TRANSPORTS';
var FETCH_ADDITIONAL_TRANSPORTS = 'FETCH_ADDITIONAL_TRANSPORTS';
var CREATE_ADDITIONAL_TRANSPORTS_FILTERS = 'CREATE_ADDITIONAL_TRANSPORTS_FILTERS';
var SET_FILTERED_ADDITIONAL_TRANSPORTS = 'SET_FILTERED_ADDITIONAL_TRANSPORTS';
var TOGGLE_FILTER = 'TOGGLE_FILTER';
var DISABLE_FILTERS = 'DISABLE_FILTERS';
var UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY = 'UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY';
var UPDATE_FILTERED_RESULTS = 'UPDATE_FILTERED_RESULTS';
var SORT_ADDITIONAL_TRANSPORTS = 'SORT_ADDITIONAL_TRANSPORTS';

function _createAdditionalTransportsFilters(i18n, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"])(CREATE_ADDITIONAL_TRANSPORTS_FILTERS, {
    additionalTransports: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_6__[/* getAdditionalTransports */ "f"])(getState()),
    i18n: i18n
  });
}

function _toggleFilter(filter, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"])(TOGGLE_FILTER, {
    additionalTransports: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_6__[/* getAdditionalTransports */ "f"])(getState()),
    filter: filter
  });
}

function _disableFilters(filters, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"])(DISABLE_FILTERS, {
    additionalTransports: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_6__[/* getAdditionalTransports */ "f"])(getState()),
    filters: filters
  });
}

function _unselectFiltersCategory(category, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"])(UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY, {
    additionalTransports: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_6__[/* getAdditionalTransports */ "f"])(getState()),
    category: category
  });
}

function _updateFilteredTransports(getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"])(UPDATE_FILTERED_RESULTS, {
    additionalTransports: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_6__[/* getAdditionalTransports */ "f"])(getState()),
    filters: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_6__[/* getAdditionalTransportsFilters */ "h"])(getState())
  });
}

function _runAdditionalTransportsQuery(proposalId, appContext) {
  var query = "\n    {\n      additionalTransports(proposalId : \"".concat(proposalId, "\") {\n        id\n        totalDifferentialPrice {...priceDetails}\n        inbound { ...transportsDetails }\n        outbound { ...transportsDetails }\n        filterValues {\n          cabinClasses\n          companies { id label logo }\n          layovers\n          inboundDepartureTime { hours minutes }\n          inboundArrivalTime { hours minutes }\n          outboundDepartureTime { hours minutes }\n          outboundArrivalTime { hours minutes }\n        }\n      }\n\n      config {\n        filters {\n          cabinClass {\n            economy\n            business\n          }\n          layovers {\n            direct\n            stop {\n              label_1\n              label_n\n            }\n          }\n          departureArrival {\n            timeRanges {\n              label\n              icon\n              start { hours minutes }\n              end { hours minutes }\n            }\n          }\n        }\n      }\n    }\n    ").concat(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__[/* transportDetailsFragment */ "q"], "\n    ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__[/* getPriceDetailFragment */ "h"])(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(appContext, 'locale')), "\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runNoCacheQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__[/* PROPOSAL_GET_ADDITIONAL_TRANSPORT */ "od"]
  });
}

function updateAdditionalTransportsSort(sorter) {
  return function (dispatch, getState) {
    var additionalTransports = Object(_booking_selector__WEBPACK_IMPORTED_MODULE_6__[/* getAdditionalTransports */ "f"])(getState());
    var filters = Object(_booking_selector__WEBPACK_IMPORTED_MODULE_6__[/* getAdditionalTransportsFilters */ "h"])(getState());
    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"])(SORT_ADDITIONAL_TRANSPORTS, {
      additionalTransports: additionalTransports,
      filters: filters,
      sorter: sorter
    }));
  };
}

function clearAdditionalTransports() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"])(CLEAR_ADDITIONAL_TRANSPORTS);
}

function fetchAdditionalTransports(proposalId, appContext) {
  return function (dispatch, getState) {
    dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"])(FETCH_ADDITIONAL_TRANSPORTS));
    return _runAdditionalTransportsQuery(proposalId, appContext).then(function (_ref) {
      var additionalTransports = _ref.additionalTransports,
          i18n = _ref.config;
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__["resolve"])(FETCH_ADDITIONAL_TRANSPORTS), {
        additionalTransports: additionalTransports
      }));
      dispatch(_createAdditionalTransportsFilters(i18n, getState));
      dispatch(_updateFilteredTransports(getState));
    }, function (error) {
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__["reject"])(FETCH_ADDITIONAL_TRANSPORTS), error));
    });
  };
}

function toggleAdditionalTransportFilter(filter) {
  return function (dispatch, getState) {
    dispatch(_toggleFilter(filter, getState));
    dispatch(_updateFilteredTransports(getState));
  };
}

function disableAdditionalTransportFilters(filters) {
  return function (dispatch, getState) {
    dispatch(_disableFilters(filters, getState));
    dispatch(_updateFilteredTransports(getState));
  };
}

function unselectAdditionalTransportsFilterCategory(category) {
  return function (dispatch, getState) {
    dispatch(_unselectFiltersCategory(category, getState));
    dispatch(_updateFilteredTransports(getState));
  };
}



/***/ }),

/***/ "05L9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WEB_CALLBACK_LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WEB_CALLBACK_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FooterContacts; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_tracking_footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("9sjr");
/* harmony import */ var _utils_regex_RegexHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("9BC+");
/* harmony import */ var _frameworks_block_link_BlockLink_jsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Onl6");
/* harmony import */ var _widgets_webcallback_WebCallbackBlockLink_jsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("39HS");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;






var WEB_CALLBACK_LINK = 'callMeBack';
var WEB_CALLBACK_ENABLED = _config__WEBPACK_IMPORTED_MODULE_1___default.a.get('freespee.enabled');
function FooterContacts(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;
  return __jsx("div", {
    className: "pt-4 relative w-full z-1 lg:border-b-1 border-gray-dark md:pb-4"
  }, __jsx("ul", {
    className: "reset-list flex flex-col md:flex-row md:justify-between md:-mx-1"
  }, items.map(function (_ref2) {
    var href = _ref2.href,
        text = _ref2.text,
        type = _ref2.type;
    var texts = (text || []).map(function (txt) {
      // the phone number is always written in ltr, even in he-IL (which is rtl)
      return Object(_utils_regex_RegexHelper__WEBPACK_IMPORTED_MODULE_3__[/* isPhoneNumber */ "c"])(txt) ? __jsx("span", {
        dir: "ltr"
      }, txt) : txt;
    });
    return __jsx("li", {
      className: "border-b-1 md:border-b-0 border-gray-dark mb-3 md:mb-0 md:mx-1 pb-3 md:pb-0 last-child-mb-0 last-child-border-b-0",
      key: type
    }, type === WEB_CALLBACK_LINK && WEB_CALLBACK_ENABLED ? __jsx(_widgets_webcallback_WebCallbackBlockLink_jsx__WEBPACK_IMPORTED_MODULE_5__[/* WebCallbackBlockLink */ "a"], {
      icon: type,
      trackingData: {
        actionGA: 'footer'
      },
      texts: texts,
      theme: "default"
    }) : __jsx(_frameworks_block_link_BlockLink_jsx__WEBPACK_IMPORTED_MODULE_4__[/* BlockLink */ "a"], {
      icon: type,
      target: "_blank",
      texts: texts,
      trackingData: {
        actionGA: 'footer',
        labelGA: Object(_utils_tracking_footer__WEBPACK_IMPORTED_MODULE_2__[/* formatFooterLabelName */ "a"])(type)
      },
      url: href
    }));
  })));
}

/***/ }),

/***/ "06Jt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_ADDITIONAL_ACCOMMODATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_ADDITIONAL_ACCOMMODATIONS; });
/* unused harmony export SET_FILTERED_ADDITIONAL_ACCOMMODATIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TOGGLE_ACCOMMODATIONS_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPDATE_FILTERED_ACCOMMODATIONS_RESULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return clearAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return toggleAdditionalAccommodationFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return unselectAdditionalAccommodationsFilterCategory; });
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("70jX");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("oL6k");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("rJ95");
/* harmony import */ var _booking_selector__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("uL19");









var CLEAR_ADDITIONAL_ACCOMMODATIONS = 'CLEAR_ADDITIONAL_ACCOMMODATIONS';
var FETCH_ADDITIONAL_ACCOMMODATIONS = 'FETCH_ADDITIONAL_ACCOMMODATIONS';
var CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS = 'CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS';
var SET_FILTERED_ADDITIONAL_ACCOMMODATIONS = 'SET_FILTERED_ADDITIONAL_ACCOMMODATIONS';
var TOGGLE_ACCOMMODATIONS_FILTER = 'TOGGLE_ACCOMMODATIONS_FILTER';
var UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY = 'UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY';
var UPDATE_FILTERED_ACCOMMODATIONS_RESULTS = 'UPDATE_FILTERED_ACCOMMODATIONS_RESULTS';

function _getSelectedProposal(state) {
  if (!state) return null;
  var proposals = Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getProposals */ "w"])(state) || [];
  var resort = Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getCurrentResort */ "m"])(state);
  var selectedProposal = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["find"])(proposals, {
    id: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getSelectedProposalId */ "z"])(state)
  }) || Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_3__[/* getDefaultProposal */ "d"])(proposals, resort);
  return selectedProposal;
}

function _createAdditionalAccommodationsFilters(_ref) {
  var proposal = _ref.proposal,
      resort = _ref.resort,
      getState = _ref.getState,
      i18n = _ref.i18n,
      shouldPreselectFilters = _ref.shouldPreselectFilters;
  var state = getState();
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS, {
    additionalAccommodations: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getAdditionalAccommodations */ "c"])(state),
    selectedProposal: proposal,
    i18n: i18n,
    shouldPreselectFilters: shouldPreselectFilters,
    resort: resort
  });
}

function _toggleFilter(filter, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(TOGGLE_ACCOMMODATIONS_FILTER, {
    additionalAccommodations: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getAdditionalAccommodations */ "c"])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    filter: filter
  });
}

function _unselectFiltersCategory(category, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY, {
    additionalAccommodations: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getAdditionalAccommodations */ "c"])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    category: category
  });
}

function _updateFilterAccommodations(getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(UPDATE_FILTERED_ACCOMMODATIONS_RESULTS, {
    additionalAccommodations: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getAdditionalAccommodations */ "c"])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    filters: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getAdditionalAccommodationsFilters */ "e"])(getState())
  });
}

function _runAdditionalAccommodationsQuery(_ref2) {
  var proposalId = _ref2.proposalId,
      appContext = _ref2.appContext,
      duration = _ref2.duration,
      _ref2$selectedRate = _ref2.selectedRate,
      selectedRate = _ref2$selectedRate === void 0 ? '' : _ref2$selectedRate,
      _ref2$roomsArrangemen = _ref2.roomsArrangement,
      roomsArrangement = _ref2$roomsArrangemen === void 0 ? [] : _ref2$roomsArrangemen;
  var query = "\n    {\n      additionalAccommodations(proposalId: \"".concat(proposalId, "\", roomsArrangement:").concat(Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_4__[/* graphqlify */ "d"])(roomsArrangement), ") {\n        id\n        totalDifferentialPrice(selectedRate: \"").concat(selectedRate, "\") {\n          ...priceDetails\n        }\n        differentialPriceByNight(nightsNumber: ").concat(duration, ", selectedRate: \"").concat(selectedRate, "\") {\n          formattedValue(precision: 0)\n          value\n        }\n        remainingStock\n        accommodations {\n          id\n          categories { id label }\n          category\n          categoryId\n          comfortType\n          connectingRoom\n          description\n          label\n          maxCapacity\n          roomType\n          media {\n            photos {\n              url\n            }\n          }\n          minCapacity\n          occupation\n          quantity\n          occupancies {\n            baby_count\n          }\n          outsideFacilities {\n            id\n            label\n          }\n          bathroomEquipments {\n            id\n            label\n          }\n          equipments {\n            id\n            label\n          }\n          services { id label }\n          strengths { id label }\n          surface\n          view { id label }\n          reducedMobilityAccess\n          attendeesDistribution {\n            id\n            quantity\n            attendees {\n              id\n              type\n              birthdate\n              customerId\n            }\n          }\n        }\n      }\n      config {\n        filters {\n          configuration {\n            categoryTitle\n            simpleRoom\n            simpleRooms\n            separatedRooms\n            separatedRooms3\n          }\n          comfort {\n            categoryTitle\n          }\n          extraFeatures {\n            categoryTitle\n          }\n          reducedMobility\n        }\n      }\n    }\n    ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__[/* getPriceDetailFragment */ "h"])(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(appContext, 'locale')), "\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"].runNoCacheQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__[/* PROPOSAL_GET_ADDITIONAL_ACCOMMODATIONS */ "nd"]
  });
}

function clearAdditionalAccommodations() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(CLEAR_ADDITIONAL_ACCOMMODATIONS);
}

function fetchAdditionalAccommodations(_ref3) {
  var proposal = _ref3.proposal,
      resort = _ref3.resort,
      appContext = _ref3.appContext,
      _ref3$roomsArrangemen = _ref3.roomsArrangement,
      roomsArrangement = _ref3$roomsArrangemen === void 0 ? [] : _ref3$roomsArrangemen,
      _ref3$shouldPreselect = _ref3.shouldPreselectFilters,
      shouldPreselectFilters = _ref3$shouldPreselect === void 0 ? true : _ref3$shouldPreselect;
  var id = proposal.id,
      duration = proposal.duration,
      selectedRate = proposal.price.selectedRate;
  return function (dispatch, getState) {
    dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(FETCH_ADDITIONAL_ACCOMMODATIONS));
    return _runAdditionalAccommodationsQuery({
      proposalId: id,
      appContext: appContext,
      duration: duration,
      selectedRate: selectedRate,
      roomsArrangement: roomsArrangement
    }).then(function (_ref4) {
      var additionalAccommodations = _ref4.additionalAccommodations,
          i18n = _ref4.config;
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_ADDITIONAL_ACCOMMODATIONS), {
        additionalAccommodations: additionalAccommodations
      }));
      dispatch(_createAdditionalAccommodationsFilters({
        proposal: proposal,
        resort: resort,
        getState: getState,
        i18n: i18n,
        shouldPreselectFilters: shouldPreselectFilters
      }));
      dispatch(_updateFilterAccommodations(getState));
    })["catch"](function (error) {
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_ADDITIONAL_ACCOMMODATIONS), error));
    });
  };
}

function toggleAdditionalAccommodationFilter(filter) {
  return function (dispatch, getState) {
    dispatch(_toggleFilter(filter, getState));
    dispatch(_updateFilterAccommodations(getState));
  };
}

function unselectAdditionalAccommodationsFilterCategory(category) {
  return function (dispatch, getState) {
    dispatch(_unselectFiltersCategory(category, getState));
    dispatch(_updateFilterAccommodations(getState));
  };
}



/***/ }),

/***/ "07TY":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("jP+d");

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ "0OJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var PRICE_TICKET_REQUEST = 'PRICET_TICKET_REQUEST';
/* harmony default export */ __webpack_exports__["a"] = (PRICE_TICKET_REQUEST);

/***/ }),

/***/ "0ibg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setKeywords; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");


function setKeywords(keywords) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SEARCH_SET_KEYWORDS */ "p"], {
    keywords: keywords
  });
}

/***/ }),

/***/ "0x7Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Toast; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("/Mt0");
/* harmony import */ var _portal_Portal_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Yd/I");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("kiXb");
/* harmony import */ var _icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("qBqs");
/* harmony import */ var _text_Text_jsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("qqKu");
/* harmony import */ var _portal_Portal_jsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("3uBn");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;










var Toast = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_1__["forwardRef"])(function (props, ref) {
  var _classnames;

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(_utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"]),
      isAppMounted = _useContext.isAppMounted;

  if (!isAppMounted) {
    return null;
  }

  var _props$color = props.color,
      color = _props$color === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].WATER_GREEN : _props$color,
      _props$icon = props.icon,
      icon = _props$icon === void 0 ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].CONFIRMATION : _props$icon,
      _props$label = props.label,
      label = _props$label === void 0 ? '' : _props$label,
      onClose = props.onClose,
      _props$portalName = props.portalName,
      portalName = _props$portalName === void 0 ? _portal_Portal_constants__WEBPACK_IMPORTED_MODULE_4__[/* OVER_BOT */ "d"] : _props$portalName,
      visible = props.visible;

  if (!visible) {
    return null;
  }

  return __jsx(_portal_Portal_jsx__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"], {
    name: portalName
  }, __jsx("button", {
    "aria-disabled": !visible,
    "aria-hidden": !visible,
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('reset-button bg-white fixed flex font-bold items-center p-1 rtl:right-0 rounded-small transition-all', (_classnames = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_classnames, "text-".concat(String(color)), color), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_classnames, 'rtl:translate-x-100', !visible), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_classnames, 'rtl:mr-10 shadow-md', visible), _classnames)),
    "data-testid": "Toast",
    onClick: onClose,
    ref: ref,
    style: {
      top: 150,
      width: 280
    },
    tabIndex: visible ? 0 : -1,
    type: "button"
  }, __jsx(_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_8__[/* Icon */ "a"], {
    className: "flex-shrink-0 m-1",
    name: icon,
    width: "30px"
  }), __jsx(_text_Text_jsx__WEBPACK_IMPORTED_MODULE_9__[/* Text */ "a"], {
    className: "flex-1 p-1 rtl:mr-6",
    text: Object(_i18n__WEBPACK_IMPORTED_MODULE_7__[/* t */ "f"])(label)
  }), __jsx("div", {
    className: "absolute leading-none p-3 top-0 rtl:right-0"
  }, __jsx(_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_8__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].CROSS,
    width: "10px"
  }))));
});

/***/ }),

/***/ "19WB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPrePaymentDetailsQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getInitPaymentQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFormDataQuery; });
/* harmony import */ var stringify_object__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pPFN");
/* harmony import */ var stringify_object__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(stringify_object__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _PrePayment_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("XHSI");



function getPrePaymentDetailsQuery(bookingId) {
  return "query {\n    userBooking(bookingId:\"".concat(bookingId, "\") {\n      paymentDetails {\n        duePayment {\n          deadline\n          amount {\n            value\n          }\n        }\n      }\n      information {\n        status\n        bookingId\n        stays {\n          id\n          departureDate\n          returnDate\n          departureCity\n          arrivalCity\n          adults\n          children\n          resort {\n            name\n            image\n            comfort\n            type\n            icon\n            badgeIcon\n            isExplicitEC\n            isJoyview\n            destination {\n              country\n            }\n            departureCity\n            arrivalCity\n          }\n        }\n        vendor {\n          isSoldByClubMed\n          name\n          phoneNumber\n        }\n        isPaid\n      }\n    }\n\n    legalInformations {\n      optionConfirmation {\n        id\n        label\n        description\n        url\n        required\n        preChecked\n      }\n    }\n\n    paymentProviders {\n      id\n      label\n      logo\n      description\n      requiredDelayBeforeDeparture\n      paymentMethods {\n        id\n        label\n        image\n        category\n        timePaymentConditions {\n          id\n          paymentCount\n          chargePercentage\n        }\n      }\n      token {\n        format\n        value\n      }\n    }\n  }");
}
function getInitPaymentQuery(payload) {
  var _payload$bookingId = payload.bookingId,
      bookingId = _payload$bookingId === void 0 ? '' : _payload$bookingId,
      service = payload.service,
      _payload$action = payload.action,
      action = _payload$action === void 0 ? '' : _payload$action;
  var roomSelectionServicePayload = stringify_object__WEBPACK_IMPORTED_MODULE_0___default()(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(service, 'roomSelectionServicePayload', null), {
    singleQuotes: false
  });
  var stringifiedService = stringify_object__WEBPACK_IMPORTED_MODULE_0___default()({
    amount: Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(service, 'amount', null),
    currency: Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(service, 'currency', null)
  }, {
    singleQuotes: false
  });
  return "query {\n    prePayment(bookingId: \"".concat(bookingId, "\", service: ").concat(stringifiedService, ", roomSelectionServicePayload:").concat(roomSelectionServicePayload, ", action:\"").concat(action, "\") {\n      due {\n        value\n        formattedValue(precision: 2)\n        currency\n      }\n      paymentSchedule {\n        deposit {\n          value\n          formattedValue(precision: 2)\n        }\n        remainingBalance {\n          value\n          formattedValue(precision: 2)\n        }\n        dueDate\n      }\n      bookingBalance(precision: 2)\n      serviceFormattedPrice(precision: 2)\n      remainingCreditBalance(precision: 2)\n    }\n  }");
}
function getFormDataQuery(_ref) {
  var bookingId = _ref.bookingId,
      providerId = _ref.providerId,
      redirectUri = _ref.redirectUri,
      amount = _ref.amount,
      currency = _ref.currency,
      service = _ref.service,
      redirectCancelUrl = _ref.redirectCancelUrl,
      responsive = _ref.responsive,
      paymentConditionId = _ref.paymentConditionId,
      action = _ref.action,
      tokenParam = _ref.token,
      isIframe = _ref.isIframe,
      iframeCallbackUrl = _ref.iframeCallbackUrl;
  var paymentConditionQuery = paymentConditionId ? "paymentConditionId : \"".concat(paymentConditionId, "\"") : '';
  var act = action ? "action: \"".concat(action, "\"") : '';
  var token = tokenParam ? "token: \"".concat(tokenParam, "\"") : '';
  return "mutation {\n    bookingsPaymentRedirect: bookingPaymentRedirect (\n      bookingId: \"".concat(bookingId, "\",\n      providerId:\"").concat(providerId, "\",\n      redirectUri: \"").concat(redirectUri, "\",\n      redirectCancelUrl:\"").concat(redirectCancelUrl, "\",\n      amount: ").concat(amount, ",\n      currency:\"").concat(currency, "\",\n      packages: ").concat(stringify_object__WEBPACK_IMPORTED_MODULE_0___default()(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(service, 'packages', []), {
    singleQuotes: false
  }), ",\n      additionalService:").concat(stringify_object__WEBPACK_IMPORTED_MODULE_0___default()(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(service, 'additionalService', null), {
    singleQuotes: false
  }), ",\n      roomSelectionServices:").concat(stringify_object__WEBPACK_IMPORTED_MODULE_0___default()(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(service, 'roomSelectionServicePayload', null), {
    singleQuotes: false
  }), ",\n      device: \"").concat(Object(_PrePayment_helpers__WEBPACK_IMPORTED_MODULE_2__[/* getDevice */ "c"])(responsive), "\"\n      ").concat(paymentConditionQuery, "\n      ").concat(act, "\n      ").concat(token, "\n      isIframePayment: ").concat((isIframe || false).toString(), "\n      iframeCallbackUrl: \"").concat(iframeCallbackUrl, "\"\n    ) {\n      url\n      fields\n      method\n      bookingId\n      customerId\n      price {\n        value\n      }\n    }\n  }");
}

/***/ }),

/***/ "1KeW":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("sWQB"),
    isMasked = __webpack_require__("68C9"),
    isObject = __webpack_require__("Q7Yi"),
    toSource = __webpack_require__("AVUi");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ "1MRr":
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__("YXT+"),
    isObjectLike = __webpack_require__("oS78");

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ "1P7A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFormattedLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCursorClass; });
function getFormattedLabel() {
  var placeholder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var isRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!placeholder) return '';
  return isRequired ? "".concat(placeholder, "*") : placeholder;
}
function getCursorClass(_ref) {
  var hasPointer = _ref.hasPointer,
      isDisabled = _ref.isDisabled,
      isLoading = _ref.isLoading,
      isReadOnly = _ref.isReadOnly;
  if (isDisabled) return 'cursor-not-allowed';
  if (isReadOnly) return 'cursor-default';
  if (isLoading) return 'cursor-wait';
  return hasPointer ? 'cursor-pointer' : '';
}

/***/ }),

/***/ "1TCz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/next/app.js
var app = __webpack_require__("Khd+");
var app_default = /*#__PURE__*/__webpack_require__.n(app);

// EXTERNAL MODULE: /home/circleci/project/node_modules/next/head.js
var head = __webpack_require__("vpUC");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: /home/circleci/project/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./config/index.js
var config_0 = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config_0);

// EXTERNAL MODULE: ./src/routes/nextRoutes.js
var nextRoutes = __webpack_require__("qm5D");
var nextRoutes_default = /*#__PURE__*/__webpack_require__.n(nextRoutes);

// EXTERNAL MODULE: ./src/client/tracking/utils.js
var utils = __webpack_require__("zwLB");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: /home/circleci/project/node_modules/next/dynamic.js
var dynamic = __webpack_require__("hNT8");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/store/user-info/hoc/UserInfo.jsx
var UserInfo = __webpack_require__("EEuM");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/local-storage-api/index.js
var local_storage_api = __webpack_require__("1RIK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsive_responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// CONCATENATED MODULE: ./src/client/components/widgets/crisis-alert/CrisisAlertLinkBanner.jsx
var __jsx = react_default.a.createElement;









var CRISIS_ALERT_LOCALSTORAGE_KEY = 'dismissGlobalAlert';
var CrisisAlertLinkBanner_CrisisAlertLinkBanner = function CrisisAlertLinkBanner(props) {
  var _useContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isAppMounted = _useContext.isAppMounted;

  var _useState = Object(react["useState"])(true),
      shouldDisplay = _useState[0],
      setShouldDisplay = _useState[1];

  if (!isAppMounted) {
    return null;
  }

  var alertDate = props.alertDate,
      className = props.className,
      linkLabel = props.linkLabel,
      linkUrl = props.linkUrl;

  if (!shouldDisplay || Object(lodash["isEmpty"])(alertDate) || Object(lodash["isEmpty"])(linkLabel) || Object(local_storage_api["a" /* getFromLocalStorage */])(CRISIS_ALERT_LOCALSTORAGE_KEY) === alertDate) {
    return null;
  }

  return __jsx("div", {
    className: classnames_default()(className, 'bg-white flex items-center max-w-full p-3 rtl:pr-8 relative rounded-small shadow')
  }, __jsx(Icon["a" /* Icon */], {
    className: "flex-shrink-0",
    color: colors["a" /* COLORS */].ORANGE,
    name: icons["a" /* ICONS */].LIGHTBULB,
    isNotSquare: true,
    width: "1.875rem"
  }), __jsx(TextLink["a" /* TextLink */], {
    className: "underline rtl:ml-4",
    color: colors["a" /* COLORS */].GRAY_DARKER,
    iconRightName: null,
    label: linkLabel,
    url: linkUrl
  }), __jsx("button", {
    className: "reset-button absolute leading-none p-2 top-0 rtl:right-0",
    onClick: function onClick() {
      Object(local_storage_api["d" /* setInLocalStorage */])(CRISIS_ALERT_LOCALSTORAGE_KEY, alertDate);
      setShouldDisplay(false);
    },
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "0.625rem"
  })));
};
// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// EXTERNAL MODULE: ./src/client/context/pageContext.js
var context_pageContext = __webpack_require__("RPju");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// EXTERNAL MODULE: ./src/client/components/frameworks/countdown/Countdown.jsx + 1 modules
var Countdown = __webpack_require__("mmhe");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// CONCATENATED MODULE: ./src/client/components/widgets/promotional-banner/promo-banner/PromoBanner.jsx

var PromoBanner_jsx = react_default.a.createElement;








function PromoBanner(props) {
  var _props$bgColor = props.bgColor,
      bgColor = _props$bgColor === void 0 ? colors["a" /* COLORS */].GRENADINE : _props$bgColor,
      className = props.className,
      closeLabel = props.closeLabel,
      countdown = props.countdown,
      description = props.description,
      iconName = props.iconName,
      innerRef = props.innerRef,
      label = props.label,
      link = props.link,
      onClose = props.onClose,
      title = props.title,
      _props$titleColor = props.titleColor,
      titleColor = _props$titleColor === void 0 ? colors["a" /* COLORS */].WHITE : _props$titleColor,
      trackingData = props.trackingData,
      trackingDataClose = props.trackingDataClose;
  if (!title) return null;
  return PromoBanner_jsx("aside", {
    className: classnames_default()(className, "bg-".concat(bgColor, " px-4 relative shadow w-full")),
    ref: innerRef
  }, PromoBanner_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({
    as: DynamicLink["a" /* default */]
  }, link, {
    trackingData: trackingData,
    className: "block"
  }), PromoBanner_jsx("div", {
    className: "flex flex-col lg:flex-row items-center justify-center -mx-1 py-3"
  }, countdown && PromoBanner_jsx(Countdown["a" /* Countdown */], Object(esm_extends["a" /* default */])({}, countdown, {
    size: "small",
    className: "mb-2 lg:mb-0 mx-1"
  })), PromoBanner_jsx("div", {
    className: "flex flex-col lg:flex-row items-center lg:items-baseline justify-center text-center lg:text-initial text-white"
  }, !!iconName && PromoBanner_jsx(Icon["a" /* Icon */], {
    className: "mx-1 hidden lg:block self-center",
    color: colors["a" /* COLORS */].WHITE,
    name: iconName,
    width: "2.2rem"
  }), !!label && PromoBanner_jsx("p", {
    className: "reset-paragraph hidden font-brand lg:block mx-2",
    "data-testid": "PromoBanner-label"
  }, label), PromoBanner_jsx("h2", {
    className: "reset-heading font-brand text-lg lg:text-2xl mx-2 text-".concat(titleColor, " text-shadow underline uppercase"),
    "data-testid": "PromoBanner-title"
  }, title), !!description && PromoBanner_jsx("p", {
    className: "reset-paragraph mt-1 lg:mt-0 mx-2 text-sm",
    "data-testid": "PromoBanner-description"
  }, description)))), PromoBanner_jsx(TrackClick["a" /* TrackClick */], {
    as: "button",
    className: "reset-button absolute leading-none rtl:mr-2 p-3 top-0 rtl:right-0",
    onClick: onClose,
    trackingData: trackingDataClose,
    type: "button"
  }, PromoBanner_jsx("span", {
    className: "a11y"
  }, closeLabel), PromoBanner_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].WHITE,
    name: icons["a" /* ICONS */].CROSS,
    width: "0.625rem"
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/promotional-banner/PromotionalBanner.jsx


var PromotionalBanner_jsx = react_default.a.createElement;






var PROMOTIONALBANNER_LOCALSTORAGE_KEY = 'disablePromotionalBanner';

function checkDuration() {
  var storaged = Object(local_storage_api["a" /* getFromLocalStorage */])(PROMOTIONALBANNER_LOCALSTORAGE_KEY);
  if (!storaged) return true;
  var now = Date.now();
  var storagedDate = new Date(Number(storaged));
  var tomorrow = storagedDate.setDate(storagedDate.getDate() + 1);
  return now - tomorrow > 0;
}

var PromotionalBanner_PromotionalBannerClass = function PromotionalBannerClass(_ref) {
  var _ref$enabledPages = _ref.enabledPages,
      enabledPages = _ref$enabledPages === void 0 ? [] : _ref$enabledPages,
      _ref$disabledPages = _ref.disabledPages,
      disabledPages = _ref$disabledPages === void 0 ? [] : _ref$disabledPages,
      bannerProps = Object(objectWithoutProperties["a" /* default */])(_ref, ["enabledPages", "disabledPages"]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);
  var responsiveContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]);

  var pageMatch = function pageMatch(pages) {
    var pageId = pageContext.pageId;
    return pages.some(function (page) {
      return page && ( // testing pages that correspond to a resort/tour
      pageId === "resort-".concat(page.toUpperCase()) || pageId === "tour-".concat(page.toUpperCase()) || // pages that correspond to a url
      location.pathname === page || location.pathname.startsWith("".concat(page, "/")));
    });
  };

  var isPageEnabled = enabledPages.length ? pageMatch(enabledPages) : true;
  var isPageDisabled = disabledPages.length ? pageMatch(disabledPages) : false;

  var shouldBeDisplayed = function shouldBeDisplayed() {
    return responsiveContext.isAppMounted && checkDuration() && isPageEnabled && !isPageDisabled;
  };

  var _useState = Object(react["useState"])(shouldBeDisplayed()),
      isDisplayed = _useState[0],
      setDisplay = _useState[1];

  Object(react["useEffect"])(function () {
    setDisplay(shouldBeDisplayed());
  }, [enabledPages, responsiveContext]);

  var disable = function disable() {
    setDisplay(false);
    Object(local_storage_api["d" /* setInLocalStorage */])(PROMOTIONALBANNER_LOCALSTORAGE_KEY, Date.now());
  };

  if (!isDisplayed) {
    return null;
  }

  var trackingData = {
    event: 'eventGA',
    categoryGA: 'promoBanner',
    labelGA: bannerProps.title,
    actionGA: 'click',
    valueGA: '0',
    nonInteraction: '0'
  };
  var trackingDataClose = {
    event: 'eventGA',
    categoryGA: 'promoBanner',
    labelGA: bannerProps.title,
    actionGA: 'close',
    valueGA: '0',
    nonInteraction: '0'
  };
  return PromotionalBanner_jsx(PromoBanner, Object(esm_extends["a" /* default */])({}, bannerProps, {
    onClose: disable,
    trackingData: trackingData,
    trackingDataClose: trackingDataClose
  }));
}; // $FlowFixMe


var PromotionalBanner = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  return PromotionalBanner_jsx(PromotionalBanner_PromotionalBannerClass, Object(esm_extends["a" /* default */])({
    innerRef: ref
  }, props));
});
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/Navigation.tracking.js
var categoryGA = 'headerMenu';
var NAVIGATION_TRACKING_LOGO_BUTTON = {
  categoryGA: categoryGA,
  actionGA: 'header_logo',
  labelGA: null // to override any value coming from previous tracking

};
var NAVIGATION_TRACKING_CONTACT_BUTTON = {
  categoryGA: categoryGA,
  actionGA: 'header_contact',
  labelGA: 'clickToCall'
};
var NAVIGATION_TRACKING_SEARCH_BUTTON = {
  categoryGA: 'headerMenu',
  actionGA: 'header_search'
};
var getNavigationCallCenterButtonTrackingData = function getNavigationCallCenterButtonTrackingData(label) {
  return {
    categoryGA: categoryGA,
    actionGA: 'header_contact',
    labelGA: label
  };
};
var getNavigationLanguagesButtonTrackingData = function getNavigationLanguagesButtonTrackingData(label) {
  return {
    categoryGA: categoryGA,
    actionGA: 'header_language',
    labelGA: label
  };
};
var getNavigationItemLinkTrackingData = function getNavigationItemLinkTrackingData(label) {
  return {
    categoryGA: categoryGA,
    actionGA: "header_".concat(label),
    labelGA: label
  };
};
var getNavigationSubItemLinkTrackingData = function getNavigationSubItemLinkTrackingData(_ref) {
  var label = _ref.label,
      parentLabel = _ref.parentLabel;
  return {
    categoryGA: categoryGA,
    actionGA: "header_".concat(parentLabel),
    labelGA: label
  };
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/Navigation.mapper.js




function mapSubItemsProps(parentLabel, items, index) {
  if (Object(lodash["isEmpty"])(items)) return [];
  return items.map(function (item, subIndex) {
    var dataLabel = "".concat(parentLabel, "_").concat(Object(lodash["camelCase"])(item.label));
    var subItemsProps = {
      id: "".concat(index).concat(subIndex),
      color: item.color || colors["a" /* COLORS */].GRAY_DARKER,
      hasImageBorder: item.frameForExclusiveCollection,
      label: item.label,
      link: {
        url: item.url,
        trackingData: getNavigationSubItemLinkTrackingData({
          label: dataLabel,
          parentLabel: parentLabel.split('_')[0]
        })
      },
      seeMoreLabel: item.seeMoreLabel || ''
    };

    if (!Object(lodash["isEmpty"])(item.imageUrl)) {
      subItemsProps.thumbnail = {
        imageUrl: item.imageUrl
      };
    }

    if (!Object(lodash["isEmpty"])(item.subItems)) {
      subItemsProps.subItems = mapSubItemsProps(dataLabel, item.subItems, "".concat(index).concat(subIndex));
    }

    return subItemsProps;
  });
}

var Navigation_mapper_buildNavigationMenuItems = function buildNavigationMenuItems(menus) {
  if (!menus || !menus.length) {
    return [];
  }

  return menus.map(function (menu, index) {
    return {
      color: menu.color || colors["a" /* COLORS */].GRAY_DARKER,
      id: "".concat(index),
      label: menu.label,
      link: {
        url: menu.url,
        trackingData: getNavigationItemLinkTrackingData(Object(lodash["camelCase"])(menu.label))
      },
      isList: menu.type === 'subItemsList',
      subItems: mapSubItemsProps(Object(lodash["camelCase"])(menu.label), menu.items, index)
    };
  });
};
// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-focus-on/dist/es2015/Combination.js + 8 modules
var Combination = __webpack_require__("Qt1m");

// EXTERNAL MODULE: ./src/client/components/frameworks/body-locker/BodyLocker.jsx
var BodyLocker = __webpack_require__("DHMe");

// CONCATENATED MODULE: ./src/client/components/utils/languages/SwitchLanguageModel.js


var SwitchLanguageModel_jsx = react["createElement"];


function getUrl(locale) {
  return '/?locale=' + locale;
}

function SwitchLanguageModel_getLocales(localesConfig) {
  return Object.keys(localesConfig);
}

function getSwitchLocale(localesConfig, currentLocale) {
  return SwitchLanguageModel_getLocales(localesConfig).filter(function (locale) {
    return locale !== currentLocale;
  })[0];
}

var SwitchLanguageModel_SwitchLanguage = /*#__PURE__*/function () {
  function SwitchLanguage(availableLocalesConfig, currentLocale) {
    Object(classCallCheck["a" /* default */])(this, SwitchLanguage);

    this.localesConfig = availableLocalesConfig;
    this.currentLocale = currentLocale;
  }

  Object(createClass["a" /* default */])(SwitchLanguage, [{
    key: "getAvailableLocales",
    value: function getAvailableLocales() {
      return this.localesConfig;
    }
  }, {
    key: "getCurrentLocaleLabel",
    value: function getCurrentLocaleLabel() {
      return this.localesConfig[this.currentLocale].label;
    }
  }, {
    key: "getSwitchLocaleLabel",
    value: function getSwitchLocaleLabel() {
      return this.localesConfig[getSwitchLocale(this.localesConfig, this.currentLocale)].label;
    }
  }, {
    key: "getLabelWithUrls",
    value: function getLabelWithUrls() {
      var _this = this;

      return Object.keys(this.localesConfig).map(function (locale) {
        return {
          label: _this.localesConfig[locale].label,
          countryCode: _this.localesConfig[locale].PAYS,
          langCode: _this.localesConfig[locale].LANG,
          languageNativeName: _this.localesConfig[locale].languageNativeName,
          moment: _this.localesConfig[locale].moment,
          url: getUrl(locale)
        };
      });
    }
  }, {
    key: "getSwitchUrl",
    value: function getSwitchUrl() {
      return getUrl(getSwitchLocale(this.localesConfig, this.currentLocale));
    }
  }, {
    key: "isMultiLanguage",
    value: function isMultiLanguage() {
      return SwitchLanguageModel_getLocales(this.localesConfig).length > 1;
    }
    /* todo: es6 : make this class iterable */

  }, {
    key: "map",
    value: function map(mapper) {
      var _this2 = this;

      var mapping = function mapping() {
        return _this2.getLabelWithUrls().map(mapper);
      };

      return this.or(mapping.bind(this));
    }
  }, {
    key: "or",
    value: function or(callback) {
      return this.isMultiLanguage() ? callback() : SwitchLanguageModel_jsx("noscript", null);
    }
  }]);

  return SwitchLanguage;
}();

/* harmony default export */ var SwitchLanguageModel = (SwitchLanguageModel_SwitchLanguage);
// CONCATENATED MODULE: ./src/client/components/widgets/languages/Languages.themes.js
var themes = {
  inline: {
    thRoot: 'inline-flex items-center justify-around whitespace-no-wrap',
    thItemFirst: 'border-l-0 border-gray-light capitalize flex-1 text-center text-gray-dark',
    thItem: 'border-l-1 border-gray-light capitalize flex-1 text-center text-gray-dark',
    thItemCurrent: 'font-bold text-gray-darker',
    thLink: 'inline-block py-1 px-3 focus:underline hover:underline whitespace-no-wrap'
  },
  column: {
    thRoot: '',
    thItemFirst: 'border-t-0 border-gray-light capitalize text-center text-gray-dark',
    thItem: 'border-t-1 border-gray-light capitalize text-center text-gray-dark',
    thItemCurrent: 'font-bold text-gray-darker',
    thLink: 'block p-2 focus:underline hover:underline whitespace-no-wrap'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/languages/Languages.jsx

var Languages_jsx = react_default.a.createElement;






function Languages(props) {
  var className = props.className,
      _props$currentLocale = props.currentLocale,
      currentLocale = _props$currentLocale === void 0 ? '' : _props$currentLocale,
      getTrackingData = props.getTrackingData,
      isActive = props.isActive,
      locales = props.locales,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'inline' : _props$theme;
  if (Object(lodash["isEmpty"])(locales)) return null;
  var _themes$theme = themes[theme],
      thItem = _themes$theme.thItem,
      thItemCurrent = _themes$theme.thItemCurrent,
      thItemFirst = _themes$theme.thItemFirst,
      thLink = _themes$theme.thLink,
      thRoot = _themes$theme.thRoot;
  var currentLangCode = currentLocale.split('-')[0].toUpperCase();
  var languages = new SwitchLanguageModel(locales, currentLocale);
  return Languages_jsx("ul", {
    className: classnames_default()(className, 'reset-list', thRoot)
  }, languages.map(function () {
    var localeInfos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var idx = arguments.length > 1 ? arguments[1] : undefined;
    var isCurrentItem = currentLangCode === localeInfos.langCode;
    var label = localeInfos.moment ? localeInfos.moment.slice(0, 2) : localeInfos.label;
    return Languages_jsx("li", {
      key: "".concat(localeInfos.countryCode, "-").concat(localeInfos.langCode),
      className: classnames_default()(idx === 0 ? thItemFirst : thItem, Object(defineProperty["a" /* default */])({}, "".concat(thItemCurrent), isCurrentItem))
    }, Languages_jsx(TrackClick["a" /* TrackClick */], {
      as: "a",
      "aria-current": isCurrentItem,
      "aria-label": "".concat(label, " ").concat(localeInfos.languageNativeName),
      className: classnames_default()('reset-anchor', thLink),
      "data-testid": "Languages-link",
      href: localeInfos.url,
      lang: localeInfos.moment,
      tabIndex: isActive ? 0 : -1,
      trackingData: getTrackingData ? getTrackingData(localeInfos.url.replace('/?locale=', '')) : null
    }, localeInfos.label));
  }));
}
// EXTERNAL MODULE: /home/circleci/project/node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__("pKEY");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/client/components/widgets/navigation/Navigation.constants.js
var Navigation_constants = __webpack_require__("1cDg");

// EXTERNAL MODULE: ./src/hooks/use-autocomplete/useAutocomplete.js
var useAutocomplete = __webpack_require__("aUQU");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/FacetSearch.utils.js
var FacetSearch_utils = __webpack_require__("hPQF");

// EXTERNAL MODULE: ./src/client/store/faceting/facetingSearch.action.js
var facetingSearch_action = __webpack_require__("loSl");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/store/faceting/faceting.selector.js + 1 modules
var faceting_selector = __webpack_require__("vIa8");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var storeHelper = __webpack_require__("Jsmy");

// CONCATENATED MODULE: ./src/client/components/widgets/global-search/GlobalSearchQuery.jsx


var GlobalSearchQuery_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

















var GlobalSearchQuery_ReferencedSearchQuery = function ReferencedSearchQuery(props) {
  var autocompleteQuery = props.autocompleteQuery,
      clearGlobalSearch = props.clearGlobalSearch,
      onChangeQuery = props.onChangeQuery,
      searchInputRef = props.searchInputRef,
      trackingData = props.trackingData;

  var _useContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  var departureCity = Object(es["e" /* useSelector */])(tripCriteria_selector["a" /* getDepartureCity */]);
  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);
  var duration = Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */]);
  var kids = Object(es["e" /* useSelector */])(storeHelper["c" /* getKids */]);
  var kidsValidationState = Object(es["e" /* useSelector */])(faceting_selector["k" /* getKidsValidationState */]);
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var buttonSize = isDesktop ? 'large' : 'medium';
  var containerPadding = isDesktop ? {
    paddingLeft: '15%',
    paddingRight: '15%'
  } : {};
  return GlobalSearchQuery_jsx("div", {
    className: "bg-white",
    style: containerPadding
  }, GlobalSearchQuery_jsx("div", {
    className: classnames_default()('m-auto max-w-site w-full py-6 flex flex-no-wrap items-stretch justify-between border-0 border-gray-light', {
      'border-b-1': isDesktop && autocompleteQuery.length > 0
    })
  }, GlobalSearchQuery_jsx("div", {
    className: "flex-grow h-12 lg:h-16"
  }, GlobalSearchQuery_jsx("label", {
    className: "block pb-1 text-sm lg:text-md text-gray-medium transition-color",
    htmlFor: "global-search-query-input"
  }, Object(lodash["upperFirst"])(Object(i18n["f" /* t */])('faceting.autocomplete.enterYourSearch'))), GlobalSearchQuery_jsx("input", {
    className: "reset-input text-current cursor-pointer w-full leading-normal font-bold text-xl lg:text-2xl text-gray",
    id: "global-search-query-input",
    "data-testid": "global-search-input",
    onChange: onChangeQuery,
    placeholder: Object(i18n["f" /* t */])('faceting.searchTitle'),
    ref: searchInputRef,
    type: "search",
    value: autocompleteQuery
  })), GlobalSearchQuery_jsx("div", {
    className: "flex justify-end",
    style: {
      minWidth: isDesktop ? 190 : 110
    }
  }, GlobalSearchQuery_jsx(Button["a" /* Button */], {
    className: "self-center flex-none ml-1 lg:ml-2 lg:justify-center lg:leading-none",
    color: colors["a" /* COLORS */].WHITE,
    colorBg: colors["a" /* COLORS */].BLUE,
    colorBorder: colors["a" /* COLORS */].BLUE,
    dataTestId: "global-search-search-button",
    isExternalLink: false,
    minWidth: "initial",
    onClick: function onClick() {
      var query = {
        label: autocompleteQuery
      };
      Object(FacetSearch_utils["f" /* navigateToSearchPage */])({
        criteriaKeysToPersist: FacetSearch_utils["a" /* FACET_QUERY_PARAMS */],
        location: location,
        searchCriteria: {
          query: query,
          departureCity: departureCity,
          departureDate: departureDate,
          duration: duration,
          keywords: '',
          kids: kids,
          kidsValidationState: kidsValidationState
        },
        searchPageRouteName: 'search'
      });
      dispatch(Object(facetingSearch_action["c" /* changeSearchQuery */])(query));
      clearGlobalSearch();
    },
    size: buttonSize,
    style: {
      flexBasis: isDesktop ? 80 : 50
    },
    trackingData: {
      categoryGA: 'layer',
      actionGA: 'search',
      labelGA: 'validate',
      searchReferrer: 'layer'
    },
    url: autocompleteQuery ? "/s?search=".concat(autocompleteQuery) : '/s'
  }, GlobalSearchQuery_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].SEARCH_GLASS,
    width: "1rem"
  })), GlobalSearchQuery_jsx(Button["a" /* Button */], {
    className: "self-center flex-none ml-1 lg:ml-2 lg:justify-center lg:leading-none",
    color: colors["a" /* COLORS */].WHITE,
    colorBg: colors["a" /* COLORS */].WHITE,
    colorBorder: colors["a" /* COLORS */].GRAY_MEDIUM,
    dataTestId: "global-search-close-button",
    minWidth: "initial",
    onClick: clearGlobalSearch,
    size: buttonSize,
    style: {
      flexBasis: isDesktop ? 80 : 50
    },
    trackingData: _objectSpread(_objectSpread({}, trackingData), {}, {
      labelGA: 'close'
    })
  }, GlobalSearchQuery_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    color: colors["a" /* COLORS */].GRAY_MEDIUM
  })))));
};
var SearchQuery = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  return GlobalSearchQuery_jsx(GlobalSearchQuery_ReferencedSearchQuery, Object(esm_extends["a" /* default */])({}, props, {
    searchInputRef: ref
  }));
});
// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/useTrackQueryChange.js
var useTrackQueryChange = __webpack_require__("kWbI");

// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/useTrackSearchResults.js
var useTrackSearchResults = __webpack_require__("NrqW");

// EXTERNAL MODULE: ./src/client/store/utils/autocompleteItemHelper.js
var autocompleteItemHelper = __webpack_require__("Qmkj");

// EXTERNAL MODULE: /home/circleci/project/node_modules/striptags/striptags.js
var striptags = __webpack_require__("47go");
var striptags_default = /*#__PURE__*/__webpack_require__.n(striptags);

// CONCATENATED MODULE: ./src/client/components/widgets/global-search/GlobalSearchSuggestionsList.jsx
var GlobalSearchSuggestionsList_jsx = react_default.a.createElement;


var SUGGESTION_TYPES = {
  ACTIVITY: 'activity',
  AREA: 'area',
  COUNTRY: 'country',
  RESORT: 'resort'
};
var GlobalSearchSuggestionsList_GlobalSearchSuggestionsList = function GlobalSearchSuggestionsList(props) {
  var maxNumberOfSuggestions = props.isDesktop ? 5 : 3;

  var onPress = function onPress(suggestion) {
    props.onClick(suggestion);
  };

  return GlobalSearchSuggestionsList_jsx("ul", {
    className: "list-none p-0 mb-6"
  }, props.blockSuggestions.slice(0, maxNumberOfSuggestions).map(function (_ref) {
    var label = _ref.label,
        type = _ref.type;
    return {
      label: striptags_default()(label),
      type: type
    };
  }).map(function (suggestion, index) {
    var label = suggestion.label,
        type = suggestion.type;
    return GlobalSearchSuggestionsList_jsx("li", {
      key: label,
      className: "mb-3",
      "data-testid": "".concat(type, "-link")
    }, GlobalSearchSuggestionsList_jsx("span", {
      role: "button",
      tabIndex: index,
      className: "leading-tight font-bold text-xl lg:text-2xl text-gray cursor-pointer",
      onClick: function onClick() {
        return onPress(suggestion);
      },
      onKeyUp: function onKeyUp(event) {
        /* Space & Enter */
        if (event.keyCode === 32 || event.keyCode === 13) {
          onPress(suggestion);
        }
      }
    }, label));
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/grid/Grid.jsx + 2 modules
var Grid = __webpack_require__("uLWw");

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.jsx + 6 modules
var Product = __webpack_require__("XTOr");

// CONCATENATED MODULE: ./src/client/components/widgets/global-search/GlobalSearchSuggestionsGrid.jsx

var GlobalSearchSuggestionsGrid_jsx = react_default.a.createElement;





var PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;
var MAX_GRID_SUGGESTIONS = 4;
var GlobalSearchSuggestionsGrid_GlobalSearchSuggestionsGrid = function GlobalSearchSuggestionsGrid(props) {
  var products = props.blockSuggestions.slice(0, MAX_GRID_SUGGESTIONS).map(function (_ref) {
    var icon = _ref.icon,
        image = _ref.image,
        isExclusiveCollection = _ref.isExclusiveCollection,
        label = _ref.label,
        link = _ref.link,
        productColor = _ref.productColor,
        productId = _ref.productId,
        productType = _ref.productType,
        season = _ref.season,
        subLabel1 = _ref.subLabel1,
        subLabel2 = _ref.subLabel2,
        tagsColor = _ref.tagsColor;
    return {
      header: {
        badge: season,
        badgeColor: tagsColor,
        badgeIcon: {
          alt: '',
          color: colors["a" /* COLORS */].WHITE,
          colorBg: productColor,
          colorBorder: productColor,
          iconName: icon
        },
        hasECLogo: !icon,
        heading: {
          subtitle: productType === PRODUCT_TYPES.RESORT ? subLabel1 : subLabel2,
          title: label
        }
      },
      id: productId,
      thumbnail: {
        hasBorder: isExclusiveCollection,
        pictures: [{
          altMsg: label,
          src: image
        }],
        tagsColor: tagsColor
      },
      type: productType,
      url: link
    };
  });
  var grid = {
    desktop: 2,
    mobile: 1,
    phablet: 2,
    tablet: 3
  };
  return products.length > 0 && GlobalSearchSuggestionsGrid_jsx(Grid["a" /* default */], {
    className: "mb-6",
    display: grid,
    grid: grid,
    hasSeeMore: false,
    totalNumberToDisplay: MAX_GRID_SUGGESTIONS
  }, products.map(function (product) {
    return GlobalSearchSuggestionsGrid_jsx(Product["a" /* Product */], Object(esm_extends["a" /* default */])({
      key: product.id
    }, product, {
      onClick: function onClick() {
        var query = {
          label: product.header.heading.title,
          type: 'resort'
        };
        props.onClick(query);
      }
    }));
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/global-search/GlobalSearchSuggestions.jsx


var GlobalSearchSuggestions_jsx = react_default.a.createElement;

function GlobalSearchSuggestions_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function GlobalSearchSuggestions_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { GlobalSearchSuggestions_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { GlobalSearchSuggestions_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






















var SuggestionsBlockTitle = function SuggestionsBlockTitle(_ref) {
  var title = _ref.title;
  return GlobalSearchSuggestions_jsx("h3", {
    className: "my-6 lg:my-8 font-bold font-sans leading-tight text-base text-blue uppercase"
  }, title);
};

var GlobalSearchSuggestions_SearchSuggestions = function SearchSuggestions(props) {
  var _useContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  var trackQueryChange = Object(useTrackQueryChange["a" /* useTrackQueryChange */])();
  var trackSearchResults = Object(useTrackSearchResults["a" /* useTrackSearchResults */])();
  var departureCity = Object(es["e" /* useSelector */])(tripCriteria_selector["a" /* getDepartureCity */]);
  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);
  var duration = Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */]);
  var kids = Object(es["e" /* useSelector */])(storeHelper["c" /* getKids */]);
  var kidsValidationState = Object(es["e" /* useSelector */])(faceting_selector["k" /* getKidsValidationState */]);
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var suggestionsBlocks = [{
    id: SUGGESTION_TYPES.COUNTRY,
    types: [SUGGESTION_TYPES.AREA, SUGGESTION_TYPES.COUNTRY],
    title: Object(i18n["f" /* t */])('faceting.autocomplete.destinationsTitle'),
    linkLabel: Object(i18n["f" /* t */])('faceting.autocomplete.moreDestinationsLabel'),
    linkURL: Object(i18n["f" /* t */])('faceting.autocomplete.moreDestinationsURL'),
    width: isDesktop ? 'w-1/4' : 'w-full',
    order: 1
  }, {
    id: SUGGESTION_TYPES.ACTIVITY,
    types: [SUGGESTION_TYPES.ACTIVITY],
    type: SUGGESTION_TYPES.ACTIVITY,
    title: Object(i18n["f" /* t */])('faceting.autocomplete.activitiesTitle'),
    linkLabel: Object(i18n["f" /* t */])('faceting.autocomplete.moreActivitiesLabel'),
    linkURL: Object(i18n["f" /* t */])('faceting.autocomplete.moreActivitiesURL'),
    width: isDesktop ? 'w-1/4' : 'w-full',
    order: isDesktop ? 2 : 3
  }, {
    id: SUGGESTION_TYPES.RESORT,
    types: [SUGGESTION_TYPES.RESORT],
    title: Object(i18n["f" /* t */])('faceting.autocomplete.productsTitle'),
    linkLabel: Object(i18n["f" /* t */])('faceting.autocomplete.moreProductsLabel'),
    linkURL: '/s',
    width: isDesktop ? 'w-1/2' : 'w-full',
    order: isDesktop ? 3 : 2
  }];
  var trackingPayload = {
    categoryGA: 'layer',
    searchReferrer: 'layer'
  };
  return GlobalSearchSuggestions_jsx("div", {
    id: "search-suggestions",
    className: classnames_default()('flex m-auto max-w-site', {
      'mb-15 flex-wrap': !isDesktop
    })
  }, suggestionsBlocks.map(function (block) {
    var blockSuggestions = props.autocompleteResults.filter(function (result) {
      return !!result.label && block.types.includes(result.type);
    });
    var SuggestionsBlock = block.id === SUGGESTION_TYPES.RESORT ? GlobalSearchSuggestionsGrid_GlobalSearchSuggestionsGrid : GlobalSearchSuggestionsList_GlobalSearchSuggestionsList;
    return !isDesktop && Object(lodash["isEmpty"])(blockSuggestions) ? null : GlobalSearchSuggestions_jsx("div", {
      key: "search-suggestions-".concat(block.id),
      className: classnames_default()(block.width, {
        'mb-6 border-gray-light border-t-1': !isDesktop
      }),
      style: {
        order: block.order
      }
    }, block.id !== SUGGESTION_TYPES.RESORT ? GlobalSearchSuggestions_jsx(SuggestionsBlockTitle, {
      title: block.title
    }) : GlobalSearchSuggestions_jsx("div", {
      className: "flex justify-between items-strech"
    }, GlobalSearchSuggestions_jsx(SuggestionsBlockTitle, {
      title: block.title
    }), blockSuggestions.length > MAX_GRID_SUGGESTIONS && GlobalSearchSuggestions_jsx(TrackClick["a" /* TrackClick */], {
      as: DynamicLink["a" /* default */],
      className: "my-6 lg:my-8 leading-tight font-bold text-sm text-gray underline",
      isExternalLink: false,
      onClick: function onClick() {
        props.clearGlobalSearch();
      },
      trackingData: GlobalSearchSuggestions_objectSpread(GlobalSearchSuggestions_objectSpread({}, trackingPayload), {}, {
        actionGA: 'search',
        labelGA: "viewMore_".concat(Object(utils["c" /* getSearchMappedTypeForLabelGA */])(block.id))
      }),
      url: "/s?search=".concat(props.autocompleteQuery)
    }, Object(lodash["upperFirst"])(block.linkLabel))), Object(lodash["isEmpty"])(blockSuggestions) ? GlobalSearchSuggestions_jsx("p", {
      className: "mt-0 mb-6 leading-tight text-xl lg:text-2xl text-gray-light"
    }, Object(lodash["upperFirst"])(Object(i18n["f" /* t */])('faceting.autocomplete.noResult'))) : GlobalSearchSuggestions_jsx(SuggestionsBlock, Object(esm_extends["a" /* default */])({}, props, {
      blockSuggestions: blockSuggestions,
      isDesktop: isDesktop,
      onClick: function onClick(query) {
        props.clearGlobalSearch();

        if (query.type === autocompleteItemHelper["a" /* RESORT_PRODUCT_TYPE */]) {
          trackQueryChange(query, GlobalSearchSuggestions_objectSpread(GlobalSearchSuggestions_objectSpread({}, trackingPayload), {}, {
            internalSearchEngineNbResults: 'redirection'
          }));
          trackSearchResults({
            internalSearchEngineNbResults: 'redirection',
            searchRequestType: 'Autocomplete',
            searchTerms: query.label,
            searchResorts: []
          });
        } else {
          dispatch(Object(facetingSearch_action["c" /* changeSearchQuery */])(query));
          trackQueryChange(query, trackingPayload);
          Object(FacetSearch_utils["f" /* navigateToSearchPage */])({
            criteriaKeysToPersist: FacetSearch_utils["a" /* FACET_QUERY_PARAMS */],
            location: location,
            searchCriteria: {
              query: query,
              departureCity: departureCity,
              departureDate: departureDate,
              duration: duration,
              keywords: '',
              kids: kids,
              kidsValidationState: kidsValidationState
            },
            searchPageRouteName: 'search'
          });
        }
      }
    })), block.linkLabel && block.linkURL && block.id !== SUGGESTION_TYPES.RESORT ? GlobalSearchSuggestions_jsx(TrackClick["a" /* TrackClick */], {
      as: DynamicLink["a" /* default */],
      className: "font-bold text-sm text-gray underline",
      isExternalLink: false,
      onClick: props.clearGlobalSearch,
      trackingData: {
        categoryGA: 'layer',
        actionGA: 'search',
        labelGA: "viewMore_".concat(block.id),
        searchReferrer: 'layer'
      },
      url: block.linkURL
    }, Object(lodash["upperFirst"])(block.linkLabel)) : null);
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/global-search/GlobalSearch.jsx

var GlobalSearch_jsx = react_default.a.createElement;

function GlobalSearch_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function GlobalSearch_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { GlobalSearch_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { GlobalSearch_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



















function DesktopSearchContainer(_ref) {
  var children = _ref.children,
      isOpen = _ref.isOpen,
      offsetTop = _ref.offsetTop;
  return GlobalSearch_jsx("aside", {
    className: classnames_default()('fadeIn fixed inset-0', {
      'invisible opacity-0': !isOpen
    }),
    style: {
      backgroundColor: 'rgba(1, 1, 1, 0.5)',
      top: "".concat(Navigation_constants["e" /* heights */].NAVIGATION_LARGE_HEIGHT + offsetTop, "px")
    }
  }, children);
}

var onScroll = Object(lodash["throttle"])(function () {
  Object(lib["forceCheck"])();
}, 250);

function MobileSearchContainer(_ref2) {
  var children = _ref2.children,
      isOpen = _ref2.isOpen,
      offsetTop = _ref2.offsetTop;
  return GlobalSearch_jsx("div", {
    className: classnames_default()('bg-white fixed bottom-0 rtl:right-0 p-4 overflow-y-auto w-full', {
      'translate-x-0': isOpen,
      'rtl:translate-x-100': !isOpen
    }),
    onScroll: onScroll,
    style: {
      top: Navigation_constants["e" /* heights */].NAVIGATION_NARROW_HEIGHT + offsetTop,
      transition: 'transform linear 330ms'
    }
  }, isOpen ? children : null);
}

var GlobalSearch_GlobalSearch = function GlobalSearch(props) {
  var isOpen = props.isOpen,
      offsetTop = props.offsetTop,
      toggleOpen = props.toggleOpen;

  var _useContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  var _useAutocomplete = Object(useAutocomplete["a" /* useAutocomplete */])(),
      autocompleteQuery = _useAutocomplete.autocompleteQuery,
      setAutocompleteQuery = _useAutocomplete.setAutocompleteQuery,
      autocompleteResults = _useAutocomplete.autocompleteResults,
      setAutocompleteResults = _useAutocomplete.setAutocompleteResults; // This effect is used to focus the search query input element when the GlobalSearch is opened
  // Use timer to wait for css transition


  var searchInput = /*#__PURE__*/Object(react["createRef"])();
  Object(react["useEffect"])(function () {
    var timer = null;

    if (isOpen && searchInput.current) {
      timer = setTimeout(function () {
        searchInput.current && searchInput.current.focus();
      }, 500);
    }

    return function () {
      clearTimeout(timer);
    };
  }, [isOpen]);
  var trackingData = {
    categoryGA: 'headerMenu',
    actionGA: 'header_search'
  };
  var toggleGlobalSearch = Object(react["useCallback"])(function () {
    setAutocompleteQuery('');
    setAutocompleteResults([]);
    toggleOpen();
  }, []);

  var onChangeQuery = function onChangeQuery(e) {
    var value = e.currentTarget.value;
    setAutocompleteQuery(value);
  };

  var GLOBAL_SEARCH_ENABLED = config_default.a.get('featureFlipping.faceting.globalSearchEnabled');

  var searchComponent = GlobalSearch_jsx(react["Fragment"], null, GlobalSearch_jsx(SearchQuery, {
    autocompleteQuery: autocompleteQuery,
    clearGlobalSearch: toggleGlobalSearch,
    onChangeQuery: onChangeQuery,
    ref: searchInput,
    trackingData: trackingData
  }), GlobalSearch_jsx("div", {
    className: classnames_default()('slideInTop fadeIn w-full bg-white', {
      'h-full': isDesktop,
      'pb-12': !isDesktop,
      'invisible opacity-0': autocompleteQuery.length === 0
    }),
    "data-testid": "search-suggestions-container",
    style: isDesktop ? {
      paddingLeft: '15%',
      paddingRight: '15%'
    } : {}
  }, GlobalSearch_jsx(GlobalSearchSuggestions_SearchSuggestions, {
    autocompleteQuery: autocompleteQuery,
    autocompleteResults: autocompleteResults,
    clearGlobalSearch: toggleGlobalSearch
  })));

  var searchLinkLabel = Object(i18n["f" /* t */])('faceting.searchLinkLabel');
  return GLOBAL_SEARCH_ENABLED ? GlobalSearch_jsx(react["Fragment"], null, GlobalSearch_jsx(TrackClick["a" /* TrackClick */], {
    "aria-expanded": isOpen,
    "aria-label": "Search",
    "aria-pressed": isOpen,
    as: "button",
    className: props.className,
    "data-testid": "global-search-button",
    onClick: toggleGlobalSearch,
    title: searchLinkLabel,
    trackingData: GlobalSearch_objectSpread(GlobalSearch_objectSpread({}, trackingData), {}, {
      labelGA: isOpen ? 'close' : 'open'
    }),
    type: "button",
    url: routeBuilder["a" /* buildUrl */]('search')
  }, GlobalSearch_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].SEARCH_GLASS,
    width: "1.1875rem"
  }), GlobalSearch_jsx("span", {
    className: "a11y"
  }, searchLinkLabel)), isDesktop ? GlobalSearch_jsx(DesktopSearchContainer, {
    isOpen: isOpen,
    offsetTop: offsetTop
  }, searchComponent) : GlobalSearch_jsx(MobileSearchContainer, {
    isOpen: isOpen,
    offsetTop: offsetTop
  }, searchComponent)) : GlobalSearch_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: props.className,
    "data-testid": "global-search-link",
    title: searchLinkLabel,
    trackingData: NAVIGATION_TRACKING_SEARCH_BUTTON,
    url: routeBuilder["a" /* buildUrl */]('search')
  }, GlobalSearch_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].SEARCH_GLASS,
    width: "1.1875rem"
  }), GlobalSearch_jsx("span", {
    className: "a11y"
  }, searchLinkLabel));
};
// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// CONCATENATED MODULE: ./src/client/components/widgets/navigation/member-access/member-access-button/NavigationMemberAccessButton.jsx







var NavigationMemberAccessButton_jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }









var NavigationMemberAccessButton_NavigationMemberAccessButton = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(NavigationMemberAccessButton, _Component);

  var _super = _createSuper(NavigationMemberAccessButton);

  function NavigationMemberAccessButton() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, NavigationMemberAccessButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      animate: false
    });

    return _this;
  }

  Object(createClass["a" /* default */])(NavigationMemberAccessButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var isAnimationEnable = !Object(featureFlippingUtils["a" /* isFeatureFlipped */])(this.context)('memberSpace.disableConnectionAnimation'); // $FlowFixMe

      this.timeoutID = setTimeout(function () {
        _this2.setState({
          animate: true
        });
      }, 1500);

      if (isAnimationEnable && !this.props.isAuthenticated) {
        // $FlowFixMe
        this.intervalID = setInterval(function () {
          _this2.setState({
            animate: true
          });
        }, 10000);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this3 = this;

      if (this.state.animate) {
        // $FlowFixMe
        this.timeoutID = setTimeout(function () {
          _this3.setState({
            animate: false
          });
        }, 2000);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // $FlowFixMe
      clearTimeout(this.timeoutID); // $FlowFixMe

      clearInterval(this.intervalID);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          isActive = _this$props.isActive,
          isAuthenticated = _this$props.isAuthenticated,
          isQuickLoggedIn = _this$props.isQuickLoggedIn,
          onClick = _this$props.onClick,
          _this$props$size = _this$props.size,
          size = _this$props$size === void 0 ? 1.25 : _this$props$size,
          title = _this$props.title;
      var animate = this.state.animate;
      var trackingData = {
        categoryGA: 'headerMenu',
        actionGA: 'header_memberSpace',
        labelGA: 'memberSpace'
      };
      return NavigationMemberAccessButton_jsx(TrackClick["a" /* TrackClick */], {
        "aria-expanded": isActive,
        as: "button",
        className: className,
        onClick: onClick,
        title: title,
        trackingData: isActive || isAuthenticated ? null : trackingData,
        type: "button"
      }, NavigationMemberAccessButton_jsx("span", {
        className: "flex relative"
      }, !!title && NavigationMemberAccessButton_jsx("span", {
        className: "a11y"
      }, title), NavigationMemberAccessButton_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].USER,
        width: "".concat(size, "rem")
      }), (isAuthenticated || isQuickLoggedIn) && NavigationMemberAccessButton_jsx("span", {
        className: classnames_default()('absolute flex items-center justify-center leading-none rounded-half', {
          'bg-emerald': isAuthenticated && !isQuickLoggedIn,
          'bg-blue': isQuickLoggedIn
        }),
        style: {
          top: '-0.5625rem',
          right: '-0.3125rem',
          width: '0.75rem',
          height: '0.75rem'
        }
      }, NavigationMemberAccessButton_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].CHECK,
        width: "0.5rem",
        color: colors["a" /* COLORS */].WHITE
      })), animate && NavigationMemberAccessButton_jsx("span", {
        style: {
          position: 'absolute',
          top: "".concat(size * 0.22, "rem"),
          left: "".concat(-size * 0.65, "rem"),
          width: "".concat(size * 0.8, "rem"),
          height: "".concat(size * 0.6, "rem"),
          border: "solid ".concat(size * 0.06, "rem black"),
          borderRadius: '0 0 50% 80%',
          borderColor: 'transparent transparent black transparent',
          transformOrigin: 'bottom right',
          animation: 'memberAnimation 2s'
        }
      })));
    }
  }]);

  return NavigationMemberAccessButton;
}(react["Component"]);

Object(defineProperty["a" /* default */])(NavigationMemberAccessButton_NavigationMemberAccessButton, "contextType", ReactAppContext["a" /* default */]);
// EXTERNAL MODULE: ./src/utils/graphql-client/use-gql/useGQL.js
var useGQL = __webpack_require__("0JpG");

// EXTERNAL MODULE: ./src/utils/ple-utils/index.js + 1 modules
var ple_utils = __webpack_require__("6jSF");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/utils/graphql-client/cacheFront.js
var cacheFront = __webpack_require__("ESA2");

// CONCATENATED MODULE: ./src/client/components/widgets/member-nav/member-sign-in/MemberSignIn.jsx
var MemberSignIn_jsx = react_default.a.createElement;










function MemberSignIn(_ref) {
  var hasFacebookConnect = _ref.hasFacebookConnect,
      hasQuickLogin = _ref.hasQuickLogin,
      hasWechatConnect = _ref.hasWechatConnect,
      _ref$join = _ref.join,
      join = _ref$join === void 0 ? {} : _ref$join,
      _ref$quickLogin = _ref.quickLogin,
      quickLogin = _ref$quickLogin === void 0 ? {} : _ref$quickLogin,
      _ref$signin = _ref.signin,
      signin = _ref$signin === void 0 ? {} : _ref$signin;

  var _useContext = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      locale = _useContext.locale;

  return MemberSignIn_jsx(react["Fragment"], null, MemberSignIn_jsx("div", {
    className: "flex flex-col-reverse lg:flex-row",
    "data-testid": "signInContent"
  }, MemberSignIn_jsx("div", {
    className: "border-t-1 lg:border-t-0 lg:rtl:border-r-1 border-gray-dark lg:w-1/2 lg:rtl:pr-4 mt-5 pt-5 lg:mt-0 lg:pt-0"
  }, MemberSignIn_jsx("div", {
    className: "flex items-end mb-4"
  }, MemberSignIn_jsx(Icon["a" /* Icon */], {
    className: "flex-shrink-0 text-gray-darker",
    isNotMonoChrome: true,
    name: icons["a" /* ICONS */].ICON_45,
    width: "2.5rem"
  }), MemberSignIn_jsx("div", {
    className: "rtl:ml-4"
  }, MemberSignIn_jsx("p", {
    className: "reset-paragraph text-md leading-normal font-brand"
  }, signin.title), MemberSignIn_jsx("p", {
    className: "m-0 text-sm leading-tight text-gray-darker"
  }, signin.text))), MemberSignIn_jsx("div", {
    className: "flex"
  }, MemberSignIn_jsx(Button["a" /* Button */], {
    className: "w-full",
    dataTestId: "member-nav-signIn",
    isExternalLink: true,
    onClick: function onClick() {
      Object(cacheFront["a" /* clearAllCacheFront */])();
    },
    trackingData: {
      labelGA: 'memberSpace_signIn',
      categoryGA: 'headerMenu',
      actionGA: 'header_memberSpace'
    },
    url: ple_utils["f" /* buildSigninUrl */]({
      locale: locale
    })
  }, signin.ctaLabel), hasFacebookConnect ? MemberSignIn_jsx(Button["a" /* Button */], {
    className: "rtl:ml-2 rounded-small",
    dataTestId: "MemberSignIn-facebook",
    isExternalLink: true,
    minWidth: "0",
    onClick: function onClick() {
      Object(cacheFront["a" /* clearAllCacheFront */])();
    },
    style: {
      width: '4rem',
      backgroundColor: '#4267b2',
      borderColor: '#4267b2'
    },
    trackingData: {
      categoryGA: constants["l" /* PLE */],
      actionGA: 'CTA_incentive_FB_connect',
      labelGA: 'memberSpace'
    },
    url: ple_utils["d" /* buildFacebookConnectUrl */]({
      locale: locale
    })
  }, MemberSignIn_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].FACEBOOK
  }), MemberSignIn_jsx("span", {
    className: "a11y"
  }, "Club Med - Facebook")) : null, hasWechatConnect ? MemberSignIn_jsx(Button["a" /* Button */], {
    className: "rtl:ml-2",
    colorBg: colors["a" /* COLORS */].EMERALD,
    colorBorder: colors["a" /* COLORS */].EMERALD,
    dataTestId: "MemberSignIn-wechat",
    isExternalLink: true,
    minWidth: "0",
    style: {
      width: '5rem'
    },
    trackingData: {
      categoryGA: constants["l" /* PLE */],
      actionGA: 'CTA_incentive_wechat_connect',
      labelGA: 'memberSpace'
    },
    url: ple_utils["j" /* buildWechatConnectUrl */]({
      locale: locale
    })
  }, MemberSignIn_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].WECHAT
  }), MemberSignIn_jsx("span", {
    className: "a11y"
  }, "Club Med - Wechat")) : null), MemberSignIn_jsx("div", {
    className: "flex lg:justify-center justify-between mt-5"
  }, MemberSignIn_jsx("p", {
    className: "reset-paragraph text-sm leading-tight text-gray-darker"
  }, join.text), MemberSignIn_jsx(TrackClick["a" /* TrackClick */], {
    as: "a",
    className: "reset-button inline-flex items-center ml-3 text-blue font-bold font-sans leading-tight text-sm focus:underline hover:underline",
    "data-testid": "member-nav-createAccount",
    href: ple_utils["h" /* buildSignupUrl */]({
      locale: locale
    }),
    rel: "nofollow",
    trackingData: {
      actionGA: 'header_memberSpace',
      categoryGA: 'headerMenu',
      labelGA: 'memberSpace_createAccount'
    }
  }, MemberSignIn_jsx("span", null, join.ctaLabel), MemberSignIn_jsx(Icon["a" /* Icon */], {
    className: "rtl:ml-1",
    hasRtl: true,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    width: "1em"
  })))), hasQuickLogin && MemberSignIn_jsx("div", {
    className: "lg:w-1/2 lg:rtl:pl-4"
  }, MemberSignIn_jsx("div", {
    className: "flex mb-4"
  }, MemberSignIn_jsx(Icon["a" /* Icon */], {
    className: "flex-shrink-0 text-gray-darker",
    name: icons["a" /* ICONS */].DOCUMENT_COLORED,
    width: "3.5rem",
    isNotMonoChrome: true
  }), MemberSignIn_jsx("div", {
    className: "rtl:ml-3"
  }, MemberSignIn_jsx("p", {
    className: "reset-paragraph text-grenadine text-md font-brand"
  }, quickLogin.title), MemberSignIn_jsx("p", {
    className: "m-0 text-sm text-gray-darker leading-tight font-bold"
  }, quickLogin.text))), MemberSignIn_jsx("ul", {
    className: "text-sm leading-tight m-0 p-0 list-none p-0 mb-5"
  }, quickLogin.keyPoint && quickLogin.keyPoint.map(function (key) {
    return MemberSignIn_jsx("li", {
      key: key,
      className: "flex items-start mb-2 rtl:pl-2"
    }, MemberSignIn_jsx(Icon["a" /* Icon */], {
      className: "flex-shrink-0 text-emerald",
      name: icons["a" /* ICONS */].CHECK,
      width: "1rem"
    }), MemberSignIn_jsx("span", {
      className: "rtl:pl-2"
    }, key));
  })), MemberSignIn_jsx(Button["a" /* Button */], {
    className: "w-full",
    dataTestId: "member-nav-quickLogin",
    isExternalLink: true,
    onClick: function onClick() {
      Object(cacheFront["a" /* clearAllCacheFront */])();
    },
    trackingData: {
      labelGA: 'memberSpace_quickLogin',
      categoryGA: 'headerMenu',
      actionGA: 'header_memberSpace'
    },
    url: ple_utils["f" /* buildSigninUrl */]({
      provider: 'bookingGM',
      locale: locale
    })
  }, quickLogin.ctaLabel))));
}
// CONCATENATED MODULE: ./src/client/components/widgets/member-nav/member-sign-in/MemberSignIn.container.jsx
var MemberSignIn_container_jsx = react_default.a.createElement;







var MemberSignIn_container_query = "\n  query {\n    facebookConnect {\n      isAvailable\n    }\n    wechatConnect {\n      isAvailable\n    }\n  }\n";
function MemberSignInContainer(_ref) {
  var cmsContentAuthentication = _ref.cmsContentAuthentication;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useState = Object(react["useState"])(false),
      isFacebookConnect = _useState[0],
      setIsFacebookConnect = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isWechatConnect = _useState2[0],
      setIsWechatConnect = _useState2[1];

  var _useGQL = Object(useGQL["a" /* useGQL */])({
    query: MemberSignIn_container_query,
    queryOptions: {
      requestName: requestDictionary["d" /* CORE_GET_FACEBOOK_CONNECT_CONFIG */]
    },
    cache: true
  }),
      data = _useGQL.data,
      isLoading = _useGQL.isLoading;

  Object(react["useEffect"])(function () {
    setIsFacebookConnect(Object(lodash["get"])(data, 'facebookConnect.isAvailable', false));
    setIsWechatConnect(Object(lodash["get"])(data, 'wechatConnect.isAvailable', false));
  }, [isLoading]);
  return MemberSignIn_container_jsx(MemberSignIn, {
    hasFacebookConnect: isFacebookConnect,
    hasQuickLogin: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('navigationBar.hasQuickLogin'),
    hasWechatConnect: isWechatConnect,
    join: {
      ctaLabel: Object(lodash["get"])(cmsContentAuthentication, 'createAccountLinkLabel'),
      text: Object(lodash["get"])(cmsContentAuthentication, 'newToClubMed')
    },
    quickLogin: {
      ctaLabel: Object(lodash["get"])(cmsContentAuthentication, 'quickLogin.cta'),
      text: Object(lodash["get"])(cmsContentAuthentication, 'quickLogin.text'),
      title: Object(lodash["get"])(cmsContentAuthentication, 'quickLogin.title'),
      keyPoint: Object(lodash["get"])(cmsContentAuthentication, 'quickLogin.keyPoint')
    },
    signin: {
      ctaLabel: Object(lodash["get"])(cmsContentAuthentication, 'signin'),
      text: Object(lodash["get"])(cmsContentAuthentication, 'yourAccount.text'),
      title: Object(lodash["get"])(cmsContentAuthentication, 'yourAccount.title')
    }
  });
}
// EXTERNAL MODULE: ./src/client/store/user-info/actions/signout.js
var signout = __webpack_require__("qd7E");

// CONCATENATED MODULE: ./src/client/components/widgets/member-nav/logged-nav/LoggedNav.jsx

var LoggedNav_jsx = react_default.a.createElement;

function LoggedNav_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function LoggedNav_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { LoggedNav_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { LoggedNav_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














function formatWelcomeMessage(template, firstName, lastName) {
  return Object(dist["messageFormat"])(template).format({
    firstname: firstName || '',
    lastname: lastName || ''
  });
}

function LoggedNav(_ref) {
  var cmsContent = _ref.cmsContent,
      userInfo = _ref.userInfo;
  var cmsNavigationSections = Object(lodash["get"])(cmsContent, 'navigationSections', {});
  var trackingData = {
    actionGA: 'header_memberSpace',
    categoryGA: 'headerMenu'
  };
  var items = [{
    label: cmsNavigationSections.dashboard,
    url: routeBuilder["b" /* urlPattern */]('account'),
    icon: icons["a" /* ICONS */].NOTEBOOK,
    trackingData: LoggedNav_objectSpread(LoggedNav_objectSpread({}, trackingData), {}, {
      labelGA: 'memberSpace_dashboard'
    })
  }, {
    label: cmsNavigationSections.myTrips,
    url: routeBuilder["b" /* urlPattern */]('futureTrips'),
    icon: icons["a" /* ICONS */].DETAILS,
    trackingData: LoggedNav_objectSpread(LoggedNav_objectSpread({}, trackingData), {}, {
      labelGA: 'memberSpace_myTrips'
    })
  }, {
    label: cmsNavigationSections.myProfile,
    url: routeBuilder["b" /* urlPattern */]('profile'),
    icon: icons["a" /* ICONS */].USER,
    trackingData: LoggedNav_objectSpread(LoggedNav_objectSpread({}, trackingData), {}, {
      labelGA: 'memberSpace_myProfile'
    })
  }, {
    label: cmsNavigationSections.greatMembers,
    url: routeBuilder["b" /* urlPattern */]('greatMembers'),
    icon: icons["a" /* ICONS */].BAR,
    trackingData: LoggedNav_objectSpread(LoggedNav_objectSpread({}, trackingData), {}, {
      labelGA: 'memberSpace_greatMembersProgram'
    })
  }, {
    label: Object(lodash["get"])(cmsContent, 'account.authentication.signout', ''),
    url: ple_utils["g" /* buildSignoutUrl */](),
    icon: icons["a" /* ICONS */].DISCONNECTION,
    onClick: function onClick() {
      Object(cacheFront["a" /* clearAllCacheFront */])();
      Object(signout["b" /* default */])();
    },
    isExternalLink: true,
    trackingData: LoggedNav_objectSpread(LoggedNav_objectSpread({}, trackingData), {}, {
      labelGA: 'memberSpace_signOut'
    })
  }];
  var itemClasses = 'flex items-center font-bold leading-tight text-gray-darker text-md p-3';
  return LoggedNav_jsx(react["Fragment"], null, LoggedNav_jsx("div", {
    className: itemClasses
  }, formatWelcomeMessage(cmsContent.welcomeLabelTemplate, userInfo.firstName, userInfo.lastName)), LoggedNav_jsx("nav", null, items.map(function (_ref2) {
    var icon = _ref2.icon,
        isExternalLink = _ref2.isExternalLink,
        label = _ref2.label,
        onClick = _ref2.onClick,
        target = _ref2.target,
        url = _ref2.url;
    return LoggedNav_jsx(TrackClick["a" /* TrackClick */], {
      as: DynamicLink["a" /* default */],
      className: classnames_default()(itemClasses, 'border-t-1 focus:text-blue hover:text-blue transition-color'),
      isExternalLink: isExternalLink,
      key: url,
      onClick: onClick,
      target: target,
      trackingData: trackingData,
      url: url
    }, icon && LoggedNav_jsx(Icon["a" /* Icon */], {
      className: "rtl:mr-3",
      name: icon,
      width: "1.25rem"
    }), label);
  })));
}
// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// CONCATENATED MODULE: ./src/client/components/widgets/member-nav/quicklogged-nav/QuickLoggedNav.jsx
var QuickLoggedNav_jsx = react_default.a.createElement;











function QuickLoggedNav(_ref) {
  var cmsContent = _ref.cmsContent,
      bookingId = _ref.bookingId,
      stayId = _ref.stayId;
  var track = Object(useTracking["a" /* useTracking */])({
    categoryGA: 'headerMenu',
    actionGA: 'header_memberSpace'
  });
  var items = [{
    label: Object(lodash["get"])(cmsContent, 'navigationSections.dashboard', ''),
    url: routeBuilder["b" /* urlPattern */]('account'),
    dataTestId: 'member-nav-quickdashboard-dashboard',
    icon: icons["a" /* ICONS */].NOTEBOOK,
    onClick: function onClick() {
      track({
        labelGA: 'memberSpace_dashboard'
      });
    }
  }, {
    label: Object(lodash["get"])(cmsContent, 'navigationSections.quickLogin.details', ''),
    url: routeBuilder["a" /* buildUrl */]('bookings', {
      bookingId: bookingId,
      stayId: stayId
    }),
    dataTestId: 'member-nav-quickdashboard-details',
    icon: icons["a" /* ICONS */].DETAILS,
    hide: !bookingId || !stayId,
    onClick: function onClick() {
      track({
        labelGA: 'memberSpace_bookingDetails'
      });
    }
  }, {
    label: Object(lodash["get"])(cmsContent, 'navigationSections.quickLogin.prepareMyStay', ''),
    url: routeBuilder["a" /* buildUrl */]('prepareMyStay', {
      bookingId: bookingId,
      stayId: stayId
    }),
    dataTestId: 'member-nav-quickdashboard-prepareMyStay',
    icon: icons["a" /* ICONS */].LUGGAGE,
    hide: !bookingId || !stayId,
    onClick: function onClick() {
      track({
        labelGA: 'memberSpace_prepareMyStay'
      });
    }
  }, {
    label: Object(lodash["get"])(cmsContent, 'navigationSections.quickLogin.signin', ''),
    url: routeBuilder["b" /* urlPattern */]('stepup'),
    dataTestId: 'member-nav-quickdashboard-stepup',
    icon: icons["a" /* ICONS */].CONNECT,
    description: Object(lodash["get"])(cmsContent, 'navigationSections.quickLogin.signinDescription', ''),
    isExternalLink: true,
    onClick: function onClick() {
      track({
        labelGA: 'memberSpace_stepUp'
      });
      Object(cacheFront["a" /* clearAllCacheFront */])();
    }
  }, {
    label: Object(lodash["get"])(cmsContent, 'navigationSections.quickLogin.signout', ''),
    url: ple_utils["g" /* buildSignoutUrl */](),
    dataTestId: 'member-nav-quickdashboard-Signout',
    icon: icons["a" /* ICONS */].DISCONNECTION,
    onClick: function onClick() {
      Object(cacheFront["a" /* clearAllCacheFront */])();
      Object(signout["b" /* default */])();
      track({
        labelGA: 'memberSpace_signOut'
      });
    },
    isExternalLink: true
  }];
  return QuickLoggedNav_jsx("nav", null, items.filter(function (i) {
    return !i.hide;
  }).map(function (_ref2, index) {
    var dataTestId = _ref2.dataTestId,
        description = _ref2.description,
        icon = _ref2.icon,
        isExternalLink = _ref2.isExternalLink,
        label = _ref2.label,
        onClick = _ref2.onClick,
        target = _ref2.target,
        url = _ref2.url;
    return QuickLoggedNav_jsx("div", {
      className: classnames_default()('p-3', {
        'border-t-1': index > 0
      }),
      key: url
    }, description && QuickLoggedNav_jsx("p", {
      className: "reset-paragraph text-xs text-gray-darker"
    }, description), QuickLoggedNav_jsx(DynamicLink["a" /* default */], {
      className: "flex items-center font-bold leading-tight text-gray-darker text-md focus:text-blue hover:text-blue transition-color",
      "data-testid": dataTestId,
      isExternalLink: isExternalLink,
      onClick: onClick,
      target: target,
      url: url
    }, icon && QuickLoggedNav_jsx(Icon["a" /* Icon */], {
      className: "rtl:mr-3",
      name: icon,
      width: "1.25rem"
    }), label));
  }));
}
// CONCATENATED MODULE: ./src/client/components/widgets/member-nav/quicklogged-nav/QuickLoggedNav.container.js




function mapStateToProps(state) {
  return {
    bookingId: Object(lodash["get"])(state, 'memberSpace.quickLogin.bookingId'),
    stayId: Object(lodash["get"])(state, 'memberSpace.quickLogin.stayId')
  };
}

var QuickLoggedNavContainer = Object(es["c" /* connect */])(mapStateToProps)(QuickLoggedNav);
// CONCATENATED MODULE: ./src/client/components/widgets/member-nav/MemberNav.jsx
var MemberNav_jsx = react_default.a.createElement;






function MemberNav(props) {
  var userInfo = props.userInfo,
      cmsContent = props.cmsContent;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      cxoNeolid = _useRouter.location.queryParams.cxo_neolid;

  if (!cmsContent) {
    return null;
  }

  if (userInfo.isQuickLoggedIn) {
    return MemberNav_jsx(QuickLoggedNavContainer, {
      cmsContent: cmsContent
    });
  }

  if (userInfo.isLoggedIn || cxoNeolid) {
    return MemberNav_jsx(LoggedNav, props);
  }

  return MemberNav_jsx(MemberSignInContainer, {
    cmsContentAuthentication: Object(lodash["get"])(cmsContent, 'account.authentication', {})
  });
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/member-access/NavigationMemberAccess.jsx
var NavigationMemberAccess_jsx = react_default.a.createElement;




function getUserInfo() {
  var userInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var res = {
    firstName: userInfo.unicodeFirstName || userInfo.firstName,
    lastName: userInfo.unicodeLastName || userInfo.lastName,
    isLoggedIn: !!userInfo.isLoggedIn,
    isQuickLoggedIn: !!userInfo.isQuickLoggedIn
  };
  return res;
}

var NavigationMemberAccess_NavigationMemberAccess = function NavigationMemberAccess(props) {
  var responsiveContext = react_default.a.useContext(responsive_responsiveContext["a" /* default */]);

  if (!responsiveContext.isAppMounted) {
    return null;
  }

  var cmsAccount = props.cmsAccount,
      _props$cmsMemberSpace = props.cmsMemberSpace,
      cmsMemberSpace = _props$cmsMemberSpace === void 0 ? {} : _props$cmsMemberSpace,
      userInfo = props.userInfo;
  var userInfos = getUserInfo(userInfo);
  var welcomeLabelTemplate = cmsMemberSpace.accessButtonLoggedin;
  return NavigationMemberAccess_jsx(MemberNav, {
    userInfo: userInfos,
    cmsContent: {
      welcomeLabelTemplate: welcomeLabelTemplate,
      title: cmsMemberSpace.title,
      navigationSections: cmsMemberSpace.navigationSections,
      account: cmsAccount
    }
  });
};
// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/widgets/navigation/contact/NavigationContact.jsx
var NavigationContact_jsx = react_default.a.createElement;







function NavigationContact(_ref) {
  var _ref$contact = _ref.contact,
      contact = _ref$contact === void 0 ? {} : _ref$contact,
      hasTel = _ref.hasTel;
  var description = contact.description,
      hours = contact.hours,
      _contact$phoneNumber = contact.phoneNumber,
      phoneNumber = _contact$phoneNumber === void 0 ? '' : _contact$phoneNumber,
      _contact$title = contact.title,
      title = _contact$title === void 0 ? '' : _contact$title,
      toll = contact.toll;
  var link = "tel:".concat(phoneNumber);
  return NavigationContact_jsx(react["Fragment"], null, NavigationContact_jsx(Title["a" /* Title */], {
    className: "mb-2",
    theme: "title-sans-4"
  }, title), NavigationContact_jsx(Text["a" /* Text */], {
    "data-testid": "NavigationContact-description",
    text: description
  }), toll && NavigationContact_jsx("p", {
    className: "reset-paragraph font-sans text-sm leading-normal text-gray-medium",
    "data-testid": "NavigationContact-toll"
  }, toll), NavigationContact_jsx(Text["a" /* Text */], {
    className: "mt-3",
    color: colors["a" /* COLORS */].BLUE,
    "data-testid": "NavigationContact-hours",
    text: hours,
    theme: "text-sans-2"
  }), phoneNumber && hasTel && NavigationContact_jsx("div", {
    className: "flex items-center justify-center mt-5"
  }, NavigationContact_jsx(Button["a" /* Button */], {
    colorBg: colors["a" /* COLORS */].BOOKING,
    colorBorder: colors["a" /* COLORS */].BOOKING,
    iconLeft: {
      name: icons["a" /* ICONS */].PHONE_BUBBLE
    },
    trackingData: getNavigationCallCenterButtonTrackingData(phoneNumber),
    url: link
  }, NavigationContact_jsx("span", {
    dir: "ltr"
  }, phoneNumber))));
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/panels/NavigationLargeBackPanel.jsx
var NavigationLargeBackPanel_jsx = react_default.a.createElement;


function NavigationLargeBackPanel(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 0 : _ref$height;
  return NavigationLargeBackPanel_jsx("div", {
    className: "absolute inset-x-0 pointer-events-none top-full z-0"
  }, NavigationLargeBackPanel_jsx("div", {
    className: "bg-white h-0 my-0 mx-auto max-w-site overflow-hidden pointer-events-none shadow transition-heights w-full",
    style: {
      height: "".concat(String(height), "px"),
      maxHeight: Navigation_constants["a" /* NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT */]
    }
  }));
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/panels/NavigationLargeElement.jsx

var NavigationLargeElement_jsx = react_default.a.createElement;

function NavigationLargeElement_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function NavigationLargeElement_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { NavigationLargeElement_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { NavigationLargeElement_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function NavigationLargeElement(props) {
  var children = props.children,
      className = props.className,
      closeLabel = props.closeLabel,
      id = props.id,
      onClose = props.onClose,
      style = props.style;

  if (!react["Children"].count(children)) {
    return null;
  }

  return NavigationLargeElement_jsx("div", {
    id: id,
    className: classnames_default()(className, 'absolute bg-white overflow-y-auto p-5 rtl:right-0 mt-px top-full'),
    style: NavigationLargeElement_objectSpread({
      maxHeight: Navigation_constants["a" /* NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT */]
    }, style)
  }, closeLabel && NavigationLargeElement_jsx("button", {
    className: "reset-button a11y-focusable float-right mb-2 px-1 text-blue text-sm",
    onClick: onClose,
    type: "button"
  }, closeLabel), children);
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/panels/NavigationLargePanel.jsx

var NavigationLargePanel_jsx = react_default.a.createElement;

function NavigationLargePanel_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function NavigationLargePanel_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { NavigationLargePanel_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { NavigationLargePanel_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var NavigationLargePanel = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  var children = props.children,
      isActive = props.isActive;

  if (!react["Children"].count(children)) {
    return null;
  }

  return NavigationLargePanel_jsx("div", {
    className: "absolute inset-x-0 pointer-events-none top-full z-0"
  }, NavigationLargePanel_jsx("div", {
    className: classnames_default()('my-0 mx-auto max-w-site overflow-hidden w-full transition-none', {
      'absolute opacity-0 pointer-events-none rtl:left-outOfBounds': !isActive,
      'opacity-100 pointer-events-auto': isActive
    }),
    "data-testid": "NavigationLarge-subItems",
    ref: ref,
    style: NavigationLargePanel_objectSpread({
      maxHeight: Navigation_constants["a" /* NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT */]
    }, isActive ? {
      transition: 'opacity ease-in 0.4s 0.2s'
    } : null)
  }, children));
});
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/first-level-item/NavigationLargeFirstLevelItem.jsx


var NavigationLargeFirstLevelItem_jsx = react_default.a.createElement;




function NavigationLargeFirstLevelItem(_ref) {
  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      hasSubItems = _ref.hasSubItems,
      isActive = _ref.isActive,
      link = _ref.link;

  if (!react["Children"].count(children)) {
    return null;
  }

  return NavigationLargeFirstLevelItem_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, link, {
    "aria-haspopup": hasSubItems,
    as: DynamicLink["a" /* default */],
    className: classnames_default()(className, 'reset-anchor cursor-pointer flex font-sans font-bold items-center px-4 relative focus:text-blue hover:text-blue transition-color uppercase', "text-".concat(color), Object(defineProperty["a" /* default */])({}, "focus:text-".concat(color, "-active hover:text-").concat(color, "-active"), !!color), {
      'navigation-arrow': hasSubItems
    }, {
      'navigation-arrow-active': isActive && hasSubItems
    }),
    "data-testid": "NavigationLarge-item-link",
    style: {
      fontSize: '0.8125rem'
    }
  }), children);
}
// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// CONCATENATED MODULE: ./src/client/components/frameworks/thumbnail-navigation/ThumbnailNavigation.themes.js


function ThumbnailNavigation_themes_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function ThumbnailNavigation_themes_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ThumbnailNavigation_themes_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ThumbnailNavigation_themes_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var ThumbnailNavigation_themes_themes = {
  "default": function _default(_ref) {
    var hasImageBorder = _ref.hasImageBorder,
        hasLink = _ref.hasLink,
        isHovering = _ref.isHovering;
    return {
      thRoot: '',
      thLink: classnames_default()('bg-black block overflow-hidden relative', {
        'decoration-fancy-frame': hasImageBorder
      }),
      thThumbnail: classnames_default()({
        'transition-transform-opacity': hasLink,
        'opacity-50 scale-105 ': hasLink && isHovering
      }),
      thLabel: classnames_default()('absolute px-1 text-center text-md text-shadow-1 text-white -translate-y-50 w-full', {
        'top-1/2': !isHovering,
        'top-9/20': isHovering
      }),
      thLabelStyle: ThumbnailNavigation_themes_objectSpread({}, isHovering ? {
        top: '45%',
        transition: 'all ease-in 0.25s'
      } : {
        top: '50%',
        transition: 'all ease-in 0.25s 0.15s'
      }),
      thSeeMoreLabel: 'absolute flex items-center justify-center leading-one text-center text-shadow-1 text-white uppercase w-full',
      thSeeMoreLabelStyle: ThumbnailNavigation_themes_objectSpread({
        fontSize: '0.6875rem'
      }, isHovering ? {
        bottom: '30%',
        opacity: 1,
        transition: 'all ease-in 0.15s 0.2s'
      } : {
        bottom: '27%',
        opacity: 0,
        transition: 'all ease-in 0.15s'
      }),
      thSeeMoreIcon: 'mx-1',
      thSeeMoreIconSize: '0.625rem',
      thBody: 'p-3'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/thumbnail-navigation/ThumbnailNavigation.jsx

var ThumbnailNavigation_jsx = react_default.a.createElement;









var ThumbnailNavigation_ThumbnailNavigation = function ThumbnailNavigation(_ref) {
  var children = _ref.children,
      className = _ref.className,
      hasImageBorder = _ref.hasImageBorder,
      label = _ref.label,
      link = _ref.link,
      seeMoreLabel = _ref.seeMoreLabel,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      thumbnail = _ref.thumbnail;

  var _useState = Object(react["useState"])(false),
      isHovering = _useState[0],
      setHovering = _useState[1];

  if (!thumbnail.imageUrl) {
    return null;
  }

  var hasLink = link === null || link === void 0 ? void 0 : link.url;

  var _themes$theme = ThumbnailNavigation_themes_themes[theme]({
    hasImageBorder: hasImageBorder,
    hasLink: hasLink,
    isHovering: isHovering
  }),
      thBody = _themes$theme.thBody,
      thLabel = _themes$theme.thLabel,
      thLabelStyle = _themes$theme.thLabelStyle,
      thLink = _themes$theme.thLink,
      thRoot = _themes$theme.thRoot,
      thSeeMoreIcon = _themes$theme.thSeeMoreIcon,
      thSeeMoreIconSize = _themes$theme.thSeeMoreIconSize,
      thSeeMoreLabel = _themes$theme.thSeeMoreLabel,
      thSeeMoreLabelStyle = _themes$theme.thSeeMoreLabelStyle,
      thThumbnail = _themes$theme.thThumbnail;

  var onEnter = hasLink ? function () {
    return setHovering(true);
  } : null;
  var onLeave = hasLink ? function () {
    return setHovering(false);
  } : null;
  return ThumbnailNavigation_jsx("div", {
    className: classnames_default()(className, thRoot, 'image-responsive-cell')
  }, ThumbnailNavigation_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, link, {
    as: hasLink ? DynamicLink["a" /* default */] : 'div',
    className: thLink,
    onMouseEnter: onEnter,
    onMouseLeave: onLeave,
    onFocus: onEnter,
    onBlur: onLeave
  }), ThumbnailNavigation_jsx(Image["a" /* default */], Object(esm_extends["a" /* default */])({}, thumbnail, {
    className: thThumbnail,
    ratioKey: thumbnail.ratioKey || ratios_utils["a" /* default */].XL
  })), !!label && ThumbnailNavigation_jsx("div", {
    className: thLabel,
    style: thLabelStyle
  }, label), !!seeMoreLabel && ThumbnailNavigation_jsx("div", {
    className: thSeeMoreLabel,
    style: thSeeMoreLabelStyle
  }, seeMoreLabel, ThumbnailNavigation_jsx(Icon["a" /* Icon */], {
    className: thSeeMoreIcon,
    hasRtl: true,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    width: thSeeMoreIconSize
  }))), !!children && !!react["Children"].count(children) && ThumbnailNavigation_jsx("div", {
    className: thBody
  }, children));
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/subnavs/NavigationLargeSubNav.jsx

var NavigationLargeSubNav_jsx = react_default.a.createElement;









function NavigationLargeSubNav(props) {
  var _props$subItems = props.subItems,
      subItems = _props$subItems === void 0 ? [] : _props$subItems;

  if (Object(lodash["isEmpty"])(subItems)) {
    return null;
  }

  return NavigationLargeSubNav_jsx("div", {
    className: "bg-white overflow-y-auto py-6 px-12",
    style: {
      maxHeight: Navigation_constants["a" /* NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT */]
    }
  }, NavigationLargeSubNav_jsx("ul", {
    className: "flex flex-wrap -m-2 reset-list"
  }, subItems.map(function (item) {
    var _item$thumbnail;

    var thumbnail = {
      imageUrl: ((_item$thumbnail = item.thumbnail) === null || _item$thumbnail === void 0 ? void 0 : _item$thumbnail.imageUrl) || '',
      ratioKey: !Object(lodash["isEmpty"])(item.subItems) ? ratios_utils["a" /* default */].S : ratios_utils["a" /* default */].XL
    };
    return NavigationLargeSubNav_jsx("li", {
      className: "w-1/4 p-2",
      key: item.label
    }, NavigationLargeSubNav_jsx(ThumbnailNavigation_ThumbnailNavigation, {
      hasImageBorder: item.hasImageBorder,
      label: item.label,
      link: Object(lodash["isEmpty"])(item.subItems) ? item.link : null,
      seeMoreLabel: item.seeMoreLabel,
      thumbnail: thumbnail
    }, !Object(lodash["isEmpty"])(item.subItems) && NavigationLargeSubNav_jsx(react["Fragment"], null, NavigationLargeSubNav_jsx("ul", {
      className: "reset-list font-bold font-sans text-gray-darker text-sm"
    }, (item.subItems || []).map(function (subitem) {
      return subitem.label ? NavigationLargeSubNav_jsx("li", {
        key: subitem.label
      }, NavigationLargeSubNav_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, subitem.link, {
        as: DynamicLink["a" /* default */],
        className: "inline-block no-underline py-1 text-gray-darker focus:text-blue hover:text-blue transition-color",
        "data-testid": "NavigationLargeSubNav-third-link"
      }), subitem.label)) : null;
    })), item.seeMoreLabel && NavigationLargeSubNav_jsx(TextLink["a" /* TextLink */], Object(esm_extends["a" /* default */])({}, item.link, {
      className: "mt-2 uppercase",
      color: colors["a" /* COLORS */].GRAY_MEDIUM,
      label: item.seeMoreLabel,
      theme: "fancy",
      trackingData: item.link.trackingData
    })))));
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/subnavs/NavigationLargeSubNavList.jsx


var NavigationLargeSubNavList_jsx = react_default.a.createElement;






function NavigationLargeSubNavList(props) {
  var _props$subItems = props.subItems,
      subItems = _props$subItems === void 0 ? [] : _props$subItems;

  if (Object(lodash["isEmpty"])(subItems)) {
    return null;
  }

  return NavigationLargeSubNavList_jsx("div", {
    className: "bg-white overflow-y-auto py-6 px-12",
    style: {
      maxHeight: Navigation_constants["a" /* NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT */]
    }
  }, NavigationLargeSubNavList_jsx("ul", {
    className: "reset-list colum-count-5 column-gap-50"
  }, subItems.map(function (item, index) {
    return NavigationLargeSubNavList_jsx("li", {
      className: "break-inside-avoid-column ".concat(index ? 'my-4' : ''),
      "data-testid": "NavigationLargeSubNavList-sublist-item",
      key: item.label
    }, NavigationLargeSubNavList_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, item.link, {
      as: DynamicLink["a" /* default */],
      className: classnames_default()("text-".concat(item.color), Object(defineProperty["a" /* default */])({}, "focus:text-".concat(item.color, "-active hover:text-").concat(item.color, "-active"), !!item.color), 'reset-anchor font-bold font-sans text-md focus:text-blue hover:text-blue'),
      "data-testid": "NavigationLargeSubNavList-sublist-link"
    }), item.label), !Object(lodash["isEmpty"])(item.subItems) && NavigationLargeSubNavList_jsx("ul", {
      className: "reset-list mt-4"
    }, (item.subItems || []).map(function (subItem) {
      return NavigationLargeSubNavList_jsx("li", {
        key: subItem.label
      }, NavigationLargeSubNavList_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, subItem.link, {
        as: DynamicLink["a" /* default */],
        className: "reset-anchor font-bold font-sans text-gray-darker text-sm focus:text-blue hover:text-blue",
        "data-testid": "NavigationLargeSubNavList-subsublist-link"
      }), subItem.label));
    })));
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/NavigationLarge.jsx








var NavigationLarge_jsx = react_default.a.createElement;

function NavigationLarge_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function NavigationLarge_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { NavigationLarge_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { NavigationLarge_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function NavigationLarge_createSuper(Derived) { var hasNativeReflectConstruct = NavigationLarge_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function NavigationLarge_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-env browser */























var POPHOVER_IN_DELAY = 300;
var POPHOVER_OUT_DELAY = 500;
var NavigationLarge_NavigationLarge = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(NavigationLarge, _Component);

  var _super = NavigationLarge_createSuper(NavigationLarge);

  function NavigationLarge(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, NavigationLarge);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClickOutside", function (e) {
      if (_this.state.activeElement) {
        if (!_this.navigationNode.current || !_this.navigationNode.current.contains(e.target)) {
          _this.setState({
            activeElement: null
          });
        }
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "setSubnav", function (activeIndex, isFocus) {
      return function () {
        var height = 0;

        if (true) {
          // $FlowFixMe
          height = _this["subnav".concat(activeIndex)] ? _this["subnav".concat(activeIndex)].clientHeight : 0;
        }

        clearTimeout(_this.hoverOutTimeout);
        _this.hoverInTimeout = setTimeout(function () {
          _this.setState({
            activeElement: null,
            activeIndex: activeIndex,
            height: height
          });
        }, isFocus ? 0 : POPHOVER_IN_DELAY);
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "resetSubnav", function (isFocus) {
      return function () {
        clearTimeout(_this.hoverInTimeout);
        _this.hoverOutTimeout = setTimeout(function () {
          _this.setState({
            activeIndex: -1,
            height: 0
          });
        }, isFocus ? 0 : POPHOVER_OUT_DELAY);
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "toggleElement", function (activeElement) {
      return function () {
        _this.setState(function (prevState) {
          return {
            activeElement: prevState.activeElement === activeElement ? null : activeElement,
            activeIndex: -1,
            height: 0
          };
        });
      };
    });

    _this.navigationNode = /*#__PURE__*/Object(react["createRef"])();
    _this.state = {
      activeElement: null,
      activeIndex: -1,
      height: 0
    };
    return _this;
  }

  Object(createClass["a" /* default */])(NavigationLarge, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (true) {
        document.addEventListener('click', this.onClickOutside);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (true) {
        document.removeEventListener('click', this.onClickOutside);
      }

      clearTimeout(this.hoverInTimeout);
      clearTimeout(this.hoverOutTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _this$props$cmsMember;

      var _this$props = this.props,
          id = _this$props.id,
          contact = _this$props.contact,
          items = _this$props.items,
          language = _this$props.language,
          promoBannerRef = _this$props.promoBannerRef,
          userInfo = _this$props.userInfo,
          isMicePage = _this$props.isMicePage,
          backToB2CWebsiteLabel = _this$props.backToB2CWebsiteLabel,
          backToB2CWebsiteLink = _this$props.backToB2CWebsiteLink,
          MICELogoRedirectionLink = _this$props.MICELogoRedirectionLink;

      var _ref = userInfo || {},
          isLoggedIn = _ref.isLoggedIn,
          isQuickLoggedIn = _ref.isQuickLoggedIn;

      var activeElement = this.state.activeElement;
      var iconButtonClassNames = 'reset-button cursor-pointer flex items-center px-4 relative focus:text-blue hover:text-blue';
      var offsetTop = promoBannerRef && promoBannerRef.current ? promoBannerRef.current.offsetHeight : 0;
      var isGlobalSearchActiveElement = activeElement === Navigation_constants["d" /* elements */].SEARCH;
      var hasContactDetails = (contact === null || contact === void 0 ? void 0 : contact.hours) || (contact === null || contact === void 0 ? void 0 : contact.description) || (contact === null || contact === void 0 ? void 0 : contact.toll) || (contact === null || contact === void 0 ? void 0 : contact.title);
      var logoTitle = isMicePage ? 'Club Med meetings and events page' : 'Club Med Homepage';
      return NavigationLarge_jsx("nav", {
        "aria-label": "ClubMed main navigation",
        className: "".concat(Navigation_constants["b" /* NAVIGATION_OFFSET_SELECTOR */], " fadeInLong absolute bg-white top-0 inset-x-0 z-5"),
        id: id
      }, NavigationLarge_jsx(Combination["a" /* FocusOn */], {
        allowPinchZoom: true,
        enabled: isGlobalSearchActiveElement
      }, NavigationLarge_jsx(BodyLocker["a" /* BodyLocker */], {
        isLocked: isGlobalSearchActiveElement
      }, NavigationLarge_jsx(NavigationLargeBackPanel, {
        height: this.state.height
      }), NavigationLarge_jsx("div", {
        className: "border-b-1 border-gray-light flex items-stretch justify-between px-5",
        ref: this.navigationNode,
        style: {
          height: Navigation_constants["e" /* heights */].NAVIGATION_LARGE_HEIGHT
        }
      }, NavigationLarge_jsx(TrackClick["a" /* TrackClick */], {
        as: DynamicLink["a" /* default */],
        className: "cursor-pointer flex flex-shrink-0 items-center px-5 text-blue",
        "data-testid": "NavigationLarge-logo",
        onFocus: this.resetSubnav(true),
        queryParamsToIgnore: ['selectedProposalId', 'proposalIds', 'optionIds'],
        title: logoTitle,
        trackingData: NAVIGATION_TRACKING_LOGO_BUTTON,
        url: "".concat(isMicePage ? MICELogoRedirectionLink : '/')
      }, NavigationLarge_jsx(Icon["a" /* Icon */], {
        className: classnames_default()({
          '-mt-1': !isMicePage,
          'mt-1': isMicePage
        }),
        isNotSquare: true,
        name: isMicePage ? icons["a" /* ICONS */].CLUBMED_MEETINGS : icons["a" /* ICONS */].CLUBMED,
        width: "10rem"
      }), NavigationLarge_jsx("span", {
        className: "a11y"
      }, logoTitle)), NavigationLarge_jsx("ul", {
        className: "reset-list flex",
        style: {
          flex: '0 1 auto'
        }
      }, items.map(function (item, index) {
        var subItems = item.subItems || [];
        var hasSubItems = !!subItems.length;
        var isList = item.isList,
            label = item.label;
        var isActive = index === _this2.state.activeIndex;
        var subnavName = "subnav".concat(index);
        return !!label && NavigationLarge_jsx("li", {
          className: "flex items-stretch",
          "data-testid": "NavigationLarge-item",
          key: label,
          onFocus: _this2.setSubnav(index, true),
          onMouseEnter: _this2.setSubnav(index),
          onBlur: _this2.resetSubnav(true),
          onMouseLeave: _this2.resetSubnav()
        }, NavigationLarge_jsx(NavigationLargeFirstLevelItem, {
          color: item.color,
          hasSubItems: hasSubItems,
          isActive: isActive,
          link: item.link
        }, label), hasSubItems && NavigationLarge_jsx(NavigationLargePanel, {
          isActive: isActive // $FlowFixMe
          ,
          ref: function ref(elem) {
            return _this2[subnavName] = elem;
          }
        }, isList ? NavigationLarge_jsx(NavigationLargeSubNavList, {
          parentLabel: label,
          subItems: subItems
        }) : NavigationLarge_jsx(NavigationLargeSubNav, {
          subItems: subItems
        })));
      })), NavigationLarge_jsx("div", {
        className: "flex flex-shrink-0 relative"
      }, !Object(lodash["isEmpty"])(contact) && NavigationLarge_jsx(react["Fragment"], null, NavigationLarge_jsx(TrackClick["a" /* TrackClick */], {
        as: "button",
        "aria-expanded": activeElement === Navigation_constants["d" /* elements */].CONTACT,
        "data-testid": "NavigationLarge-contact-button",
        className: classnames_default()(iconButtonClassNames, 'navigation-arrow', {
          'text-blue navigation-arrow-active': activeElement === Navigation_constants["d" /* elements */].CONTACT
        }),
        onClick: hasContactDetails ? this.toggleElement(Navigation_constants["d" /* elements */].CONTACT) : undefined,
        style: {
          fontSize: '0.8125rem'
        },
        title: contact.title,
        trackingData: activeElement === Navigation_constants["d" /* elements */].CONTACT || !hasContactDetails ? null : NAVIGATION_TRACKING_CONTACT_BUTTON,
        type: "button"
      }, NavigationLarge_jsx(Icon["a" /* Icon */], {
        className: "rtl:mr-1",
        color: colors["a" /* COLORS */].BLUE,
        hasRtl: true,
        name: icons["a" /* ICONS */].PHONE,
        width: "1em"
      }), NavigationLarge_jsx("span", {
        className: "a11y"
      }, contact.title, "\xA0"), NavigationLarge_jsx("span", {
        className: "font-bold text-blue whitespace-no-wrap",
        dir: "ltr"
      }, contact.phoneNumber)), NavigationLarge_jsx(NavigationLargeElement, {
        onClose: this.toggleElement(Navigation_constants["d" /* elements */].CONTACT),
        style: {
          width: '18.75rem'
        }
      }, activeElement === Navigation_constants["d" /* elements */].CONTACT ? NavigationLarge_jsx(NavigationContact, {
        contact: contact
      }) : null)), isMicePage && NavigationLarge_jsx(TrackClick["a" /* TrackClick */], {
        as: DynamicLink["a" /* default */],
        trackingData: {
          categoryGA: 'headerMenu',
          actionGA: 'header_backToB2C',
          labelGA: 'backToB2C'
        },
        className: "text-base leading-tight font-bold underline reset-button cursor-pointer flex items-center relative px-4 focus:text-blue hover:text-blue text-gray-darker",
        url: backToB2CWebsiteLink
      }, backToB2CWebsiteLabel), !isMicePage && NavigationLarge_jsx(react["Fragment"], null, NavigationLarge_jsx(GlobalSearch_GlobalSearch, {
        className: "reset-button cursor-pointer flex items-center relative px-4 focus:text-blue hover:text-blue text-gray-darker",
        isOpen: activeElement === Navigation_constants["d" /* elements */].SEARCH,
        offsetTop: offsetTop,
        toggleOpen: this.toggleElement(Navigation_constants["d" /* elements */].SEARCH)
      }), NavigationLarge_jsx(NavigationMemberAccessButton_NavigationMemberAccessButton, {
        className: classnames_default()(iconButtonClassNames, 'navigation-arrow', {
          'text-blue navigation-arrow-active': activeElement === Navigation_constants["d" /* elements */].LOGIN
        }),
        isActive: activeElement === Navigation_constants["d" /* elements */].LOGIN,
        isAuthenticated: isLoggedIn,
        isQuickLoggedIn: isQuickLoggedIn,
        onClick: this.toggleElement(Navigation_constants["d" /* elements */].LOGIN),
        title: (_this$props$cmsMember = this.props.cmsMemberSpace) === null || _this$props$cmsMember === void 0 ? void 0 : _this$props$cmsMember.title
      }), NavigationLarge_jsx(NavigationLargeElement, {
        className: "rounded-small shadow-md",
        onClose: this.toggleElement(Navigation_constants["d" /* elements */].LOGIN),
        style: NavigationLarge_objectSpread({
          width: '40rem'
        }, isLoggedIn || isQuickLoggedIn ? {
          width: '18.125rem',
          padding: '0'
        } : {})
      }, activeElement === Navigation_constants["d" /* elements */].LOGIN ? NavigationLarge_jsx(NavigationMemberAccess_NavigationMemberAccess, {
        cmsAccount: this.props.cmsAccount,
        cmsMemberSpace: this.props.cmsMemberSpace,
        userInfo: userInfo
      }) : null)), Object.keys((language === null || language === void 0 ? void 0 : language.locales) || {}).length > 1 && NavigationLarge_jsx(react["Fragment"], null, NavigationLarge_jsx("button", {
        "aria-expanded": activeElement === Navigation_constants["d" /* elements */].LANGUAGES,
        className: classnames_default()(iconButtonClassNames, 'text-center text-sm uppercase navigation-arrow', {
          'text-blue navigation-arrow-active': activeElement === Navigation_constants["d" /* elements */].LANGUAGES
        }),
        "data-testid": "NavigationLarge-language-button",
        onClick: this.toggleElement(Navigation_constants["d" /* elements */].LANGUAGES),
        style: {
          minWidth: '3.5rem'
        },
        title: "languages",
        type: "button"
      }, NavigationLarge_jsx("span", {
        className: classnames_default()('toggler', {
          'toggler-active': activeElement === Navigation_constants["d" /* elements */].LANGUAGES
        })
      }, language.locales[language.currentLocale].label)), NavigationLarge_jsx(NavigationLargeElement, {
        className: "px-1 py-0",
        onClose: this.toggleElement(Navigation_constants["d" /* elements */].LANGUAGES)
      }, activeElement === Navigation_constants["d" /* elements */].LANGUAGES && NavigationLarge_jsx(Languages, Object(esm_extends["a" /* default */])({}, language, {
        currentLocale: language.currentLocale,
        getTrackingData: getNavigationLanguagesButtonTrackingData,
        isActive: activeElement === Navigation_constants["d" /* elements */].LANGUAGES,
        locales: language.locales,
        theme: "column"
      })))))))));
    }
  }]);

  return NavigationLarge;
}(react["Component"]);

Object(defineProperty["a" /* default */])(NavigationLarge_NavigationLarge, "defaultProps", {
  id: 'Navigation',
  language: {}
});
// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-stickynode/index.js
var react_stickynode = __webpack_require__("gyFy");
var react_stickynode_default = /*#__PURE__*/__webpack_require__.n(react_stickynode);

// CONCATENATED MODULE: ./src/client/components/widgets/navigation/NavigationSticky.jsx








var NavigationSticky_jsx = react_default.a.createElement;

function NavigationSticky_createSuper(Derived) { var hasNativeReflectConstruct = NavigationSticky_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function NavigationSticky_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






function stickyNav(WrappedComponent) {
  var _temp;

  return _temp = /*#__PURE__*/function (_Component) {
    Object(inherits["a" /* default */])(NavigationSticky, _Component);

    var _super = NavigationSticky_createSuper(NavigationSticky);

    function NavigationSticky(props) {
      var _this;

      Object(classCallCheck["a" /* default */])(this, NavigationSticky);

      _this = _super.call(this, props);

      Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onLock", function () {
        var isLocked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        _this.setState({
          isLocked: isLocked
        });
      });

      Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleScroll", Object(lodash["throttle"])(function () {
        var _this$state = _this.state,
            lastY = _this$state.lastY,
            isLocked = _this$state.isLocked;

        if (!isLocked) {
          var posY = Math.max(window.pageYOffset, 0);
          var stickyStart = Navigation_constants["e" /* heights */].NAVIGATION_NARROW_HEIGHT;
          var scrolledDown = posY > lastY;

          _this.setState(function () {
            return {
              isHidden: scrolledDown && posY > stickyStart,
              lastY: posY
            };
          });
        }
      }, 200));

      Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onStateChange", function (status) {
        _this.setState(function () {
          return {
            isSticky: status.status !== react_stickynode_default.a.STATUS_ORIGINAL
          };
        });
      });

      _this.state = {
        isHidden: false,
        isLocked: false,
        isSticky: false,
        lastY: 0
      };
      return _this;
    }

    Object(createClass["a" /* default */])(NavigationSticky, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        document.addEventListener('scroll', this.handleScroll, false);
        this.handleScroll();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        document.removeEventListener('scroll', this.handleScroll, false);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$state2 = this.state,
            isHidden = _this$state2.isHidden,
            isLocked = _this$state2.isLocked,
            isSticky = _this$state2.isSticky;
        return NavigationSticky_jsx(react_stickynode_default.a, {
          enableTransforms: false,
          innerClass: classnames_default()('w-full', {
            '-translate-y-100': isSticky && isHidden
          }),
          innerZ: isLocked ? 7 : 5,
          onStateChange: this.onStateChange
        }, NavigationSticky_jsx(WrappedComponent, Object(esm_extends["a" /* default */])({}, this.props, {
          onLock: this.onLock,
          isSticky: isSticky
        })));
      }
    }]);

    return NavigationSticky;
  }(react["Component"]), _temp;
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/narrow/SideNavigationItem.jsx

var SideNavigationItem_jsx = react_default.a.createElement;







var SideNavigationItem_SideNavigationItem = function SideNavigationItem(props) {
  var color = props.color,
      hasFocus = props.hasFocus,
      isRoot = props.isRoot,
      label = props.label,
      _props$link = props.link,
      link = _props$link === void 0 ? {} : _props$link,
      nextPanel = props.nextPanel,
      onClick = props.onClick,
      setActiveItem = props.setActiveItem,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex;
  var buttonRef = Object(react["useRef"])(null);
  Object(react["useEffect"])(function () {
    if (hasFocus && buttonRef && buttonRef.current) {
      buttonRef.current.focus();
    }
  }, [hasFocus]);

  var handleClick = function handleClick() {
    onClick(nextPanel);
    setActiveItem();
  };

  var content = SideNavigationItem_jsx(react["Fragment"], {
    key: label
  }, SideNavigationItem_jsx("span", {
    className: classnames_default()("text-".concat(color), 'font-bold font-sans text-md', {
      uppercase: isRoot
    })
  }, label), SideNavigationItem_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].GRAY_DARKER,
    hasRtl: true,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    width: "0.625rem"
  }));

  return link && link.url ? SideNavigationItem_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, link, {
    as: DynamicLink["a" /* default */],
    className: "reset-anchor cursor-pointer flex items-center w-full h-full py-4 justify-between",
    "data-testid": "SideNavigationItem-subitem-link",
    onClick: handleClick,
    tabIndex: tabIndex
  }), content) : SideNavigationItem_jsx("button", {
    className: "reset-button w-full",
    "data-testid": "SideNavigationItem-subitem-button",
    onClick: handleClick,
    ref: buttonRef,
    tabIndex: tabIndex,
    type: "button"
  }, SideNavigationItem_jsx("div", {
    className: "flex items-center w-full h-full py-4 justify-between"
  }, content));
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/narrow/SideNavigation.jsx

var SideNavigation_jsx = react_default.a.createElement;












function SideNavigation(props) {
  var backButtonLabel = props.backButtonLabel,
      backToB2CWebsiteLabel = props.backToB2CWebsiteLabel,
      backToB2CWebsiteLink = props.backToB2CWebsiteLink,
      closeMenu = props.closeMenu,
      _props$id = props.id,
      id = _props$id === void 0 ? 'SideNavigation' : _props$id,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      isActive = props.isActive,
      isHidden = props.isHidden,
      isMicePage = props.isMicePage,
      label = props.label,
      language = props.language,
      navBack = props.navBack,
      navForward = props.navForward,
      parent = props.parent,
      parentLabel = props.parentLabel,
      parentLink = props.parentLink,
      style = props.style;

  var _useState = Object(react["useState"])(-1),
      activeItem = _useState[0],
      _setActiveItem = _useState[1];

  var backButtonRef = Object(react["useRef"])(null);
  Object(react["useEffect"])(function () {
    if (!isHidden && backButtonRef && backButtonRef.current) {
      backButtonRef.current.focus();
    }

    if (isHidden) {
      _setActiveItem(-1);
    }
  }, [isHidden]);
  var classNames = isHidden ? 'rtl:-translate-x-100' : 'translate-x-0';
  var hasParentLink = parentLink && parentLink.url;
  var navItems = items.map(function (item, idx) {
    var itemProps = {
      color: item.color,
      isRoot: Object(lodash["isEmpty"])(parent),
      label: item.label,
      link: {},
      nextPanel: '',
      onClick: navForward,
      setActiveItem: function setActiveItem() {
        _setActiveItem(idx);
      },
      tabIndex: isActive ? 0 : -1
    };
    var subItems = item.subItems || [];
    var itemId = "".concat(item.label.replace(/ /g, '-').toLowerCase()).concat(item.id);

    if (subItems.length) {
      itemProps.nextPanel = itemId;
    } else {
      itemProps.link = Object(lodash["get"])(item, 'link');
    }

    return SideNavigation_jsx("li", {
      key: itemId
    }, SideNavigation_jsx(SideNavigationItem_SideNavigationItem, Object(esm_extends["a" /* default */])({}, itemProps, {
      hasFocus: isActive && activeItem === idx
    })));
  });
  return SideNavigation_jsx("div", {
    "aria-hidden": isHidden,
    className: classnames_default()('bg-white fixed bottom-0 w-full rtl:left-0', classNames),
    id: id,
    style: style
  }, SideNavigation_jsx("div", {
    className: "bg-white h-full overflow-y-scroll p-4"
  }, !!parent && !!label && SideNavigation_jsx("div", {
    className: "flex justify-between"
  }, SideNavigation_jsx("button", {
    className: "reset-button flex font-bold items-center p-3 text-base rtl:-ml-3",
    "data-testid": "SideNavigation-back",
    onClick: navBack ? function () {
      return navBack();
    } : null,
    ref: backButtonRef,
    tabIndex: isActive ? 0 : -1,
    type: "button"
  }, SideNavigation_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].BLUE,
    hasRtl: true,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    rotation: 180,
    width: "0.8125rem"
  }), !!backButtonLabel && SideNavigation_jsx("span", {
    className: "a11y",
    "data-testid": "SideNavigation-back-label"
  }, Object(dist["messageFormat"])(backButtonLabel).format({
    item: parentLabel
  }))), SideNavigation_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, hasParentLink ? parentLink : null, {
    as: hasParentLink ? DynamicLink["a" /* default */] : 'div',
    className: "block font-bold py-3 text-blue text-md uppercase",
    onClick: closeMenu,
    "data-testid": "SideNavigation-item-link",
    tabIndex: isActive ? 0 : -1,
    trackingData: parentLink && parentLink.trackingData
  }), label)), SideNavigation_jsx("ul", {
    className: "reset-list"
  }, !Object(lodash["isEmpty"])(items) && navItems), !parent && isMicePage && backToB2CWebsiteLabel && SideNavigation_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    trackingData: {
      categoryGA: 'headerMenu',
      actionGA: 'header_backToB2C',
      labelGA: 'backToB2C'
    },
    className: "block text-md py-4 leading-tight font-bold underline reset-button cursor-pointer relative focus:text-blue hover:text-blue text-gray-darker",
    url: backToB2CWebsiteLink,
    onClick: closeMenu
  }, backToB2CWebsiteLabel), !parent && language && Object.keys(Object(lodash["get"])(language, 'locales', {})).length > 1 && SideNavigation_jsx("div", {
    className: "border-b-1 border-t-1 border-gray-light overflow-x-auto"
  }, SideNavigation_jsx(Languages, Object(esm_extends["a" /* default */])({}, language, {
    className: "min-w-full py-4",
    getTrackingData: getNavigationLanguagesButtonTrackingData,
    isActive: isActive
  })))));
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/narrow/SubItems.jsx

var SubItems_jsx = react_default.a.createElement;



function SubItems(props) {
  var backButtonLabel = props.backButtonLabel,
      backButtonMainNavLabel = props.backButtonMainNavLabel,
      items = props.items,
      language = props.language,
      navBack = props.navBack,
      navForward = props.navForward,
      closeMenu = props.closeMenu,
      panelStyles = props.panelStyles,
      parentId = props.parentId,
      parentLabel = props.parentLabel,
      sideNavigationPanels = props.sideNavigationPanels;
  return items.filter(function (item) {
    return item.subItems && item.subItems.length;
  }).map(function (_ref) {
    var id = _ref.id,
        label = _ref.label,
        link = _ref.link,
        subItems = _ref.subItems;
    var itemId = "".concat(label.replace(/ /g, '-').toLowerCase()).concat(id);
    var panelProps = {
      backButtonLabel: parentId === Navigation_constants["c" /* ROOT_ID */] ? backButtonMainNavLabel : backButtonLabel,
      id: itemId,
      isActive: !!sideNavigationPanels.length && sideNavigationPanels[sideNavigationPanels.length - 1] === itemId,
      isHidden: !sideNavigationPanels.includes(itemId),
      items: subItems,
      label: label,
      language: language,
      navBack: navBack,
      navForward: navForward,
      closeMenu: closeMenu,
      parent: parentId,
      parentLabel: parentLabel,
      parentLink: link,
      style: panelStyles
    };
    return [SubItems_jsx(SideNavigation, Object(esm_extends["a" /* default */])({
      key: label
    }, panelProps)), SubItems_jsx(SubItems, Object(esm_extends["a" /* default */])({
      key: itemId
    }, props, {
      parentId: itemId,
      parentLabel: label,
      items: subItems
    }))];
  });
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/narrow/NavigationNarrowElementPanel.jsx
var NavigationNarrowElementPanel_jsx = react_default.a.createElement;


function NavigationNarrowElementPanel(_ref) {
  var children = _ref.children,
      isActive = _ref.isActive,
      className = _ref.className,
      style = _ref.style;
  return NavigationNarrowElementPanel_jsx("div", {
    className: classnames_default()(className ? className : 'bg-white fixed bottom-0 rtl:right-0 p-4 w-full', {
      'translate-x-0': isActive,
      'rtl:translate-x-100': !isActive
    }),
    style: style
  }, children);
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/narrow/NavigationNarrow.jsx








var NavigationNarrow_jsx = react_default.a.createElement;

function NavigationNarrow_createSuper(Derived) { var hasNativeReflectConstruct = NavigationNarrow_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function NavigationNarrow_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }





















var NavigationNarrow_NavigationNarrow = /*#__PURE__*/function (_PureComponent) {
  Object(inherits["a" /* default */])(NavigationNarrow, _PureComponent);

  var _super = NavigationNarrow_createSuper(NavigationNarrow);

  function NavigationNarrow(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, NavigationNarrow);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "toggleElement", function (activeElement) {
      return function () {
        _this.setState(function (prevState) {
          return {
            activeElement: prevState.activeElement === activeElement ? null : activeElement,
            sideNavigationPanels: []
          };
        }, function () {
          return _this.props.onLock(!!_this.state.activeElement);
        });
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "resetNav", function () {
      _this.setState({
        activeElement: null,
        sideNavigationPanels: []
      }, function () {
        return _this.props.onLock(false);
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "navBack", function () {
      var sideNavigationPanels = _this.state.sideNavigationPanels;

      _this.setState({
        sideNavigationPanels: sideNavigationPanels.splice(0, sideNavigationPanels.length - 1)
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "navForward", function (nextPanel) {
      var sideNavigationPanels = _this.state.sideNavigationPanels;
      nextPanel && !sideNavigationPanels.includes(nextPanel) ? _this.setState({
        sideNavigationPanels: [].concat(Object(toConsumableArray["a" /* default */])(sideNavigationPanels), [nextPanel])
      }) : _this.toggleElement(Navigation_constants["d" /* elements */].MENU)();
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "closeMenu", function () {
      _this.toggleElement(Navigation_constants["d" /* elements */].MENU)();
    });

    _this.state = {
      activeElement: null,
      sideNavigationPanels: []
    };
    return _this;
  }

  Object(createClass["a" /* default */])(NavigationNarrow, [{
    key: "render",
    value: function render() {
      var _this$props$cmsMember;

      var _this$props = this.props,
          backButtonLabel = _this$props.backButtonLabel,
          backButtonMainNavLabel = _this$props.backButtonMainNavLabel,
          backToB2CWebsiteLabel = _this$props.backToB2CWebsiteLabel,
          backToB2CWebsiteLink = _this$props.backToB2CWebsiteLink,
          closeMainNavLabel = _this$props.closeMainNavLabel,
          cmsAccount = _this$props.cmsAccount,
          cmsMemberSpace = _this$props.cmsMemberSpace,
          contact = _this$props.contact,
          id = _this$props.id,
          isMicePage = _this$props.isMicePage,
          isSticky = _this$props.isSticky,
          items = _this$props.items,
          language = _this$props.language,
          openMainNavLabel = _this$props.openMainNavLabel,
          promoBannerRef = _this$props.promoBannerRef,
          userInfo = _this$props.userInfo,
          MICELogoRedirectionLink = _this$props.MICELogoRedirectionLink;
      var _this$state = this.state,
          activeElement = _this$state.activeElement,
          sideNavigationPanels = _this$state.sideNavigationPanels;
      var offsetTop = !isSticky && promoBannerRef && promoBannerRef.current ? promoBannerRef.current.offsetHeight : 0;
      var panelStyles = {
        maxWidth: '31rem',
        top: Navigation_constants["e" /* heights */].NAVIGATION_NARROW_HEIGHT + offsetTop,
        transition: 'transform linear 330ms'
      };
      var hasContactDetails = (contact === null || contact === void 0 ? void 0 : contact.phoneNumber) || (contact === null || contact === void 0 ? void 0 : contact.hours) || (contact === null || contact === void 0 ? void 0 : contact.description) || (contact === null || contact === void 0 ? void 0 : contact.toll) || (contact === null || contact === void 0 ? void 0 : contact.title);
      return NavigationNarrow_jsx("nav", {
        className: classnames_default()('bg-white w-full', Navigation_constants["b" /* NAVIGATION_OFFSET_SELECTOR */]),
        id: id
      }, NavigationNarrow_jsx(Combination["a" /* FocusOn */], {
        allowPinchZoom: true,
        enabled: !!activeElement
      }, NavigationNarrow_jsx(BodyLocker["a" /* BodyLocker */], {
        isLocked: !!activeElement
      }, NavigationNarrow_jsx("div", {
        className: "border-b-1 flex flex-no-wrap",
        style: {
          height: Navigation_constants["e" /* heights */].NAVIGATION_NARROW_HEIGHT
        }
      }, NavigationNarrow_jsx("div", {
        className: "rtl:border-r-1 border-gray-light flex items-center h-full"
      }, NavigationNarrow_jsx("button", {
        id: "NavigationNarrow-toggleSideNav-button",
        className: "reset-button h-full p-4 text-blue",
        onClick: this.toggleElement(Navigation_constants["d" /* elements */].MENU),
        type: "button"
      }, NavigationNarrow_jsx("span", {
        className: "a11y"
      }, activeElement === Navigation_constants["d" /* elements */].MENU ? closeMainNavLabel : openMainNavLabel), NavigationNarrow_jsx("div", {
        className: "hamburger"
      }, NavigationNarrow_jsx("span", {
        className: classnames_default()('hamburger-span', {
          'hamburger-span-active': activeElement === Navigation_constants["d" /* elements */].MENU
        })
      })))), NavigationNarrow_jsx(SideNavigation, {
        id: Navigation_constants["c" /* ROOT_ID */],
        isActive: activeElement === Navigation_constants["d" /* elements */].MENU && !sideNavigationPanels.length,
        isHidden: activeElement !== Navigation_constants["d" /* elements */].MENU,
        items: items,
        language: language,
        navBack: this.navBack,
        navForward: this.navForward,
        closeMenu: this.closeMenu,
        style: panelStyles,
        isMicePage: isMicePage,
        backToB2CWebsiteLink: backToB2CWebsiteLink,
        backToB2CWebsiteLabel: backToB2CWebsiteLabel
      }), NavigationNarrow_jsx(SubItems, {
        parentId: Navigation_constants["c" /* ROOT_ID */],
        items: items,
        sideNavigationPanels: sideNavigationPanels,
        backButtonLabel: backButtonLabel,
        backButtonMainNavLabel: backButtonMainNavLabel,
        language: language,
        panelStyles: panelStyles,
        navBack: this.navBack,
        navForward: this.navForward,
        closeMenu: this.closeMenu
      }), NavigationNarrow_jsx("div", {
        className: "flex-1 px-2"
      }, NavigationNarrow_jsx(TrackClick["a" /* TrackClick */], {
        as: DynamicLink["a" /* default */],
        className: "flex items-center",
        "data-testid": "NavigationNarrow-logo-link",
        onClick: this.resetNav,
        style: {
          height: Navigation_constants["e" /* heights */].NAVIGATION_NARROW_HEIGHT
        },
        trackingData: NAVIGATION_TRACKING_LOGO_BUTTON,
        url: "".concat(isMicePage ? MICELogoRedirectionLink : '/')
      }, NavigationNarrow_jsx(Icon["a" /* Icon */], {
        className: classnames_default()({
          'mt-1': isMicePage
        }),
        color: colors["a" /* COLORS */].BLUE,
        isNotSquare: true,
        name: isMicePage ? icons["a" /* ICONS */].CLUBMED_MEETINGS : icons["a" /* ICONS */].CLUBMED,
        width: isMicePage ? '9rem' : '6rem'
      }), NavigationNarrow_jsx("span", {
        className: "a11y"
      }, isMicePage ? 'Club Med meetings and events page' : 'Club Med Homepage'))), NavigationNarrow_jsx("div", {
        className: "flex"
      }, !isMicePage && NavigationNarrow_jsx(GlobalSearch_GlobalSearch, {
        className: classnames_default()('reset-button flex items-center px-2 relative navigation-arrow', {
          'text-gray-darker': activeElement !== Navigation_constants["d" /* elements */].SEARCH,
          'text-blue navigation-arrow-active': activeElement === Navigation_constants["d" /* elements */].SEARCH
        }),
        isOpen: activeElement === Navigation_constants["d" /* elements */].SEARCH,
        offsetTop: offsetTop,
        toggleOpen: this.toggleElement(Navigation_constants["d" /* elements */].SEARCH)
      }), !Object(lodash["isEmpty"])(contact) && NavigationNarrow_jsx(react["Fragment"], null, NavigationNarrow_jsx(TrackClick["a" /* TrackClick */], {
        as: "button",
        "aria-expanded": activeElement === Navigation_constants["d" /* elements */].CONTACT,
        className: classnames_default()('reset-button flex items-center px-2 relative navigation-arrow', {
          'text-gray-darker': activeElement !== Navigation_constants["d" /* elements */].CONTACT,
          'text-blue navigation-arrow-active': activeElement === Navigation_constants["d" /* elements */].CONTACT
        }),
        "data-testid": "NavigationNarrow-contact-button",
        onClick: hasContactDetails ? this.toggleElement(Navigation_constants["d" /* elements */].CONTACT) : undefined,
        title: contact.title,
        trackingData: activeElement === Navigation_constants["d" /* elements */].CONTACT || !hasContactDetails ? null : NAVIGATION_TRACKING_CONTACT_BUTTON,
        type: "button"
      }, NavigationNarrow_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].PHONE,
        width: "1.1875rem"
      }), NavigationNarrow_jsx("span", {
        className: "a11y"
      }, contact.title)), NavigationNarrow_jsx(NavigationNarrowElementPanel, {
        isActive: activeElement === Navigation_constants["d" /* elements */].CONTACT,
        style: panelStyles
      }, activeElement === Navigation_constants["d" /* elements */].CONTACT && NavigationNarrow_jsx(NavigationContact, {
        contact: contact,
        hasTel: true
      }))), !isMicePage && NavigationNarrow_jsx(react["Fragment"], null, NavigationNarrow_jsx(NavigationMemberAccessButton_NavigationMemberAccessButton, {
        className: classnames_default()('reset-button flex items-center px-2 relative navigation-arrow', {
          'text-gray-darker': activeElement !== Navigation_constants["d" /* elements */].LOGIN,
          'text-blue navigation-arrow-active': activeElement === Navigation_constants["d" /* elements */].LOGIN
        }),
        isActive: activeElement === Navigation_constants["d" /* elements */].LOGIN,
        isAuthenticated: userInfo && userInfo.isLoggedIn,
        isQuickLoggedIn: userInfo && userInfo.isQuickLoggedIn,
        onClick: this.toggleElement(Navigation_constants["d" /* elements */].LOGIN),
        title: (_this$props$cmsMember = this.props.cmsMemberSpace) === null || _this$props$cmsMember === void 0 ? void 0 : _this$props$cmsMember.title
      }), NavigationNarrow_jsx(NavigationNarrowElementPanel, {
        className: classnames_default()('w-9/10 bg-white fixed bottom-0 rtl:right-0 p-5 rounded-small overflow-y-auto', {
          'shadow-xs': activeElement === Navigation_constants["d" /* elements */].LOGIN
        }),
        isActive: activeElement === Navigation_constants["d" /* elements */].LOGIN,
        style: panelStyles
      }, activeElement === Navigation_constants["d" /* elements */].LOGIN && NavigationNarrow_jsx(NavigationMemberAccess_NavigationMemberAccess, {
        cmsAccount: cmsAccount,
        cmsMemberSpace: cmsMemberSpace,
        userInfo: userInfo
      }))))))));
    }
  }]);

  return NavigationNarrow;
}(react["PureComponent"]);

Object(defineProperty["a" /* default */])(NavigationNarrow_NavigationNarrow, "defaultProps", {
  backButtonLabel: '',
  contact: {},
  id: 'Navigation',
  items: [],
  onLock: function onLock() {}
});

var StickyNavigationNarrow = stickyNav(NavigationNarrow_NavigationNarrow);
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/Navigation.jsx

var Navigation_jsx = react_default.a.createElement;







var Navigation_Navigation = function Navigation(props) {
  var _useContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  var _useContext2 = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]),
      pageType = _useContext2.pageType;

  var navigation = props.navigation,
      userInfo = props.userInfo,
      id = props.id,
      promoBannerRef = props.promoBannerRef,
      language = props.language,
      cmsAccount = props.cmsAccount,
      cmsMemberSpace = props.cmsMemberSpace;
  var menus = navigation.menus,
      menusMICE = navigation.menusMICE,
      contact = navigation.contact,
      contactMICE = navigation.contactMICE,
      backButtonLabel = navigation.backButtonLabel,
      backButtonMainNavLabel = navigation.backButtonMainNavLabel,
      closeMainNavLabel = navigation.closeMainNavLabel,
      openMainNavLabel = navigation.openMainNavLabel,
      backToB2CWebsiteLabel = navigation.backToB2CWebsiteLabel,
      backToB2CWebsiteLink = navigation.backToB2CWebsiteLink,
      MICELogoRedirectionLink = navigation.MICELogoRedirectionLink;
  var isMicePage = dist["b2cPagesService"].isMicePage(pageType);
  var navigationProps = {
    backToB2CWebsiteLabel: backToB2CWebsiteLabel,
    backToB2CWebsiteLink: backToB2CWebsiteLink,
    cmsAccount: cmsAccount,
    cmsMemberSpace: cmsMemberSpace,
    contact: isMicePage ? contactMICE : contact,
    id: id,
    isMicePage: isMicePage,
    items: Navigation_mapper_buildNavigationMenuItems(isMicePage ? menusMICE : menus),
    language: language,
    promoBannerRef: promoBannerRef,
    userInfo: userInfo,
    MICELogoRedirectionLink: MICELogoRedirectionLink
  };
  return isDesktop ? Navigation_jsx(NavigationLarge_NavigationLarge, navigationProps) : Navigation_jsx(StickyNavigationNarrow, Object(esm_extends["a" /* default */])({}, navigationProps, {
    backButtonLabel: backButtonLabel,
    backButtonMainNavLabel: backButtonMainNavLabel,
    closeMainNavLabel: closeMainNavLabel,
    openMainNavLabel: openMainNavLabel
  }));
};
// EXTERNAL MODULE: /home/circleci/project/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("fYnN");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./src/client/components/widgets/popin-newsletter/PopinNewsletter.jsx
var PopinNewsletter = __webpack_require__("Qosd");

// EXTERNAL MODULE: ./src/client/context/ABTestContext.js
var ABTestContext = __webpack_require__("hfZn");

// EXTERNAL MODULE: /home/circleci/project/node_modules/moment/moment.js
var moment = __webpack_require__("wgY5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/router/withRouter.js
var withRouter = __webpack_require__("MGbB");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLinkUtil.js + 1 modules
var DynamicLinkUtil = __webpack_require__("Mkub");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// CONCATENATED MODULE: ./src/client/components/widgets/cookie-warning/CookieWarningBanner.jsx
var CookieWarningBanner_jsx = react_default.a.createElement;







var CookieWarningBanner_CookieWarningBanner = function CookieWarningBanner(_ref) {
  var acceptCookies = _ref.acceptCookies,
      approveAriaLabel = _ref.approveAriaLabel,
      buttonLabel = _ref.buttonLabel,
      cookieKey = _ref.cookieKey,
      dataSelector = _ref.dataSelector,
      link = _ref.link,
      openLayer = _ref.openLayer,
      openLayerLabel = _ref.openLayerLabel,
      text = _ref.text,
      title = _ref.title;
  return CookieWarningBanner_jsx(react["Fragment"], null, CookieWarningBanner_jsx("section", {
    className: "bg-white fixed bottom-0 shadow w-full z-6"
  }, CookieWarningBanner_jsx(SiteContainer["a" /* SiteContainer */], null, CookieWarningBanner_jsx("div", {
    className: "flex flex-col sm:flex-row sm:items-center py-2"
  }, CookieWarningBanner_jsx("div", {
    className: "p-2"
  }, !!title && CookieWarningBanner_jsx("h3", {
    className: "reset-heading font-bold font-sans leading-tight mb-1 text-gray-darker text-md sm:text-lg"
  }, title), CookieWarningBanner_jsx(Text["a" /* Text */], {
    className: "font-sans leading-normal mb-1 text-gray-darker text-sm sm:text-base",
    text: text
  }), !!link.label && CookieWarningBanner_jsx("p", {
    className: "font-bold font-sans leading-normal mb-1 mt-0 text-gray-darker text-sm sm:text-base"
  }, CookieWarningBanner_jsx(DynamicLink["a" /* default */], {
    className: "no-underline text-gray-darker",
    target: "_blank",
    url: link.url
  }, link.label))), CookieWarningBanner_jsx("div", {
    className: "flex-shrink-0 p-2 text-center sm:w-1/5 sm:max-w-xs"
  }, CookieWarningBanner_jsx(Button["a" /* Button */], {
    ariaLabel: approveAriaLabel,
    className: "w-full",
    onClick: acceptCookies
  }, buttonLabel), CookieWarningBanner_jsx(TextLink["a" /* TextLink */], {
    className: "mt-4",
    isUppercase: true,
    label: openLayerLabel,
    onClick: openLayer
  }))))), CookieWarningBanner_jsx("script", {
    dangerouslySetInnerHTML: {
      __html: "\n        var banner = document.querySelector(\"div[data-selector='".concat(dataSelector, "']\");\n\n        if (banner && document && document.cookie.match(/").concat(cookieKey, "=1/)) {\n          console.log('hide')\n          banner.style.display = \"none\";\n        }\n      ")
    }
  }));
};

/* harmony default export */ var cookie_warning_CookieWarningBanner = (CookieWarningBanner_CookieWarningBanner);
// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var identifiers_constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/client/components/frameworks/layer/Layer.jsx + 4 modules
var Layer = __webpack_require__("U2fG");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.jsx + 1 modules
var InputSwitch = __webpack_require__("YjXp");

// CONCATENATED MODULE: ./src/client/components/widgets/cookie-warning/PreferencesItemSwitch.jsx
var PreferencesItemSwitch_jsx = react_default.a.createElement;




var PreferencesItemSwitch_PreferencesItemSwitch = function PreferencesItemSwitch(_ref) {
  var index = _ref.index,
      isChecked = _ref.isChecked,
      label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      title = _ref.title;
  return PreferencesItemSwitch_jsx("div", {
    className: "flex mt-4"
  }, PreferencesItemSwitch_jsx("div", {
    className: "rtl:mr-4"
  }, PreferencesItemSwitch_jsx(InputSwitch["a" /* InputSwitch */], {
    ariaDescribedby: "".concat(name, "-text"),
    ariaLabelledby: name,
    color: colors["a" /* COLORS */].EMERALD,
    isChecked: isChecked,
    isDisabled: index === 0,
    isSwitch: true,
    name: name,
    onChange: onChange(index),
    size: "medium",
    value: name
  })), PreferencesItemSwitch_jsx("div", {
    className: "flex-1"
  }, PreferencesItemSwitch_jsx("h4", {
    id: name,
    className: "reset-heading font-bold font-sans leading-normal text-gray-darker text-sm sm:text-base uppercase"
  }, title), PreferencesItemSwitch_jsx(Text["a" /* Text */], {
    id: "".concat(name, "-text"),
    className: "font-sans leading-normal text-gray-darker text-sm sm:text-base",
    text: label
  })));
};
// EXTERNAL MODULE: ./src/client/components/widgets/cookie-warning/constants.js
var cookie_warning_constants = __webpack_require__("+LXU");

// CONCATENATED MODULE: ./src/client/components/widgets/cookie-warning/CookiePreferencesLayer.jsx
var CookiePreferencesLayer_jsx = react_default.a.createElement;












var CookiePreferencesLayer_CookiePreferencesLayer = function CookiePreferencesLayer(_ref) {
  var approveAriaLabel = _ref.approveAriaLabel,
      back = _ref.back,
      backAriaLabel = _ref.backAriaLabel,
      buttonLabel = _ref.buttonLabel,
      closeLabel = _ref.closeLabel,
      closeLayer = _ref.closeLayer,
      items = _ref.items,
      link = _ref.link,
      onChange = _ref.onChange,
      onValidatePreferences = _ref.onValidatePreferences,
      personnalCookiesState = _ref.personnalCookiesState,
      text = _ref.text,
      title = _ref.title;
  return CookiePreferencesLayer_jsx(Layer["a" /* Layer */], {
    ariaLabel: title,
    ariaLabelledby: identifiers_constants["l" /* ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES */],
    bgColor: colors["a" /* COLORS */].WHITE,
    buttonLeft: {
      ariaHidden: true,
      iconName: icons["a" /* ICONS */].LEFT_ARROW,
      label: backAriaLabel,
      onClick: closeLayer,
      tabIndex: -1
    },
    closeLabel: closeLabel,
    enterAnimation: "slideInBottom",
    hasAnimateEnter: true,
    hasContainer: true,
    hasContainerHeader: true,
    onClose: closeLayer
  }, CookiePreferencesLayer_jsx("div", {
    className: "py-5"
  }, CookiePreferencesLayer_jsx("div", {
    className: "text-center"
  }, CookiePreferencesLayer_jsx(Icon["a" /* Icon */], {
    className: "mb-5",
    color: colors["a" /* COLORS */].BLUE,
    isNotSquare: true,
    name: icons["a" /* ICONS */].CLUBMED,
    width: "10rem"
  })), !!title && CookiePreferencesLayer_jsx("h3", {
    className: "reset-heading font-bold font-sans leading-tight mb-1 text-gray-darker text-md sm:text-lg",
    id: identifiers_constants["l" /* ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES */]
  }, title), CookiePreferencesLayer_jsx(Text["a" /* Text */], {
    className: "font-sans leading-normal mb-1 text-gray-darker text-sm sm:text-base",
    text: text
  }), !!link.label && CookiePreferencesLayer_jsx("p", {
    className: "font-bold font-sans leading-normal mb-1 mt-0 text-gray-darker text-sm sm:text-base"
  }, CookiePreferencesLayer_jsx(DynamicLink["a" /* default */], {
    className: "no-underline text-gray-darker",
    target: "_blank",
    url: link.url
  }, link.label)), Object.keys(items).map(function (key, i) {
    return CookiePreferencesLayer_jsx(PreferencesItemSwitch_PreferencesItemSwitch, {
      index: i,
      isChecked: i === 0 || personnalCookiesState[cookie_warning_constants["a" /* COOKIES_ARRAY */][i - 1]],
      key: key,
      label: items[key].label,
      name: "CookiePreferences-".concat(key),
      onChange: onChange,
      title: items[key].title
    });
  }), CookiePreferencesLayer_jsx("div", {
    className: "flex flex flex-col sm:flex-row-reverse sm:items-center sm:justify-between mt-4"
  }, CookiePreferencesLayer_jsx(Button["a" /* Button */], {
    ariaLabel: approveAriaLabel,
    className: "sm:w-1/6",
    onClick: onValidatePreferences
  }, buttonLabel), CookiePreferencesLayer_jsx(TextLink["a" /* TextLink */], {
    ariaHidden: true,
    className: "block justify-center mt-2 sm:mt-0",
    iconLeftName: icons["a" /* ICONS */].BOLDER_ARROW_FORTH_LEFT,
    iconRightName: null,
    isUppercase: true,
    label: back,
    onClick: closeLayer,
    tabIndex: -1
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/cookie-warning/CookieWarning.jsx








var CookieWarning_jsx = react_default.a.createElement;

function CookieWarning_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function CookieWarning_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CookieWarning_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CookieWarning_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function CookieWarning_createSuper(Derived) { var hasNativeReflectConstruct = CookieWarning_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function CookieWarning_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
















var CookieWarning_CookieWarning = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(_CookieWarning, _Component);

  var _super = CookieWarning_createSuper(_CookieWarning);

  function _CookieWarning() {
    var _personnalCookies;

    var _this;

    Object(classCallCheck["a" /* default */])(this, _CookieWarning);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      hasApproved: false,
      personnalCookies: (_personnalCookies = {}, Object(defineProperty["a" /* default */])(_personnalCookies, cookie_warning_constants["e" /* COOKIE_PREFERENCES_STATS */], true), Object(defineProperty["a" /* default */])(_personnalCookies, cookie_warning_constants["d" /* COOKIE_PREFERENCES_PERSO */], true), Object(defineProperty["a" /* default */])(_personnalCookies, cookie_warning_constants["c" /* COOKIE_PREFERENCES_MEDIA */], true), _personnalCookies),
      showBanner: true,
      showLayer: false
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handler", null);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "acceptCookies", function () {
      _this.updateCookies();

      _this.setState({
        showBanner: false,
        hasApproved: true
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onSwitchChange", function (index) {
      return function (name, checked) {
        var realIndex = index - 1;

        _this.setState(function (prevState) {
          return CookieWarning_objectSpread(CookieWarning_objectSpread({}, prevState), {}, {
            personnalCookies: CookieWarning_objectSpread(CookieWarning_objectSpread({}, prevState.personnalCookies), {}, Object(defineProperty["a" /* default */])({}, cookie_warning_constants["a" /* COOKIES_ARRAY */][realIndex], checked))
          });
        });
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onValidatePreferences", function () {
      _this.updateCookies();

      _this.setState({
        hasApproved: true
      }, _this.closeLayer);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "redirect", function (location, type) {
      var fullURL = Object(uriUtils["c" /* convertLocationToURI */])(location)[type](Object(defineProperty["a" /* default */])({}, dist["appQueryParameters"].openLayer, cookie_warning_constants["b" /* COOKIE_PREFERENCES_LAYER */])).toString();
      redirectUtils["a" /* default */].redirectTo()(Object(DynamicLinkUtil["b" /* getSpaUrl */])(new URI_default.a(fullURL)), {
        shallow: true
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "closeLayer", function () {
      _this.redirect(_this.props.location, 'removeQuery');
    });

    return _this;
  }

  Object(createClass["a" /* default */])(_CookieWarning, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.location.pathname !== this.props.location.pathname && !this.state.hasApproved) {
        this.setState({
          showBanner: false,
          showLayer: false,
          hasApproved: true
        }, this.updateCookies);
      }
    }
  }, {
    key: "updateCookies",
    value: function updateCookies() {
      var _this2 = this;

      var cookieOptions = {
        expires: moment_default()().add(13, 'month').toDate()
      };
      var cookieValue;
      js_cookie_default.a.set(cookie_warning_constants["f" /* COOKIE_WARNING_LOCALSTORAGE_KEY */], 1, cookieOptions);
      cookie_warning_constants["a" /* COOKIES_ARRAY */].forEach(function (cookieName) {
        cookieValue = _this2.state.personnalCookies[cookieName];
        js_cookie_default.a.set(cookieName, +cookieValue, cookieOptions);
      }); // retrieve current virtualPageLoadingDataLayer

      var currentPageDataLayer = tracking_api["a" /* getDataLayer */]().google.find(function (layer) {
        return layer.event === constants["y" /* VIRTUAL_PAGE_LOAD */];
      }) || {};
      tracking_api["b" /* setDataLayer */](CookieWarning_objectSpread(CookieWarning_objectSpread({}, currentPageDataLayer), {}, {
        rgpd: 'OK'
      }), this.context);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          approveAriaLabel = _this$props.approveAriaLabel,
          buttonLabel = _this$props.buttonLabel,
          closeLabel = _this$props.closeLabel,
          layerInfo = _this$props.layerInfo,
          link = _this$props.link,
          location = _this$props.location,
          text = _this$props.text,
          title = _this$props.title;

      var _ref = layerInfo || {},
          back = _ref.back,
          backAriaLabel = _ref.backAriaLabel,
          openLayerLabel = _ref.link,
          rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["back", "backAriaLabel", "link"]);

      if (this.state.showBanner && text) {
        return CookieWarning_jsx(cookie_warning_CookieWarningBanner, {
          acceptCookies: this.acceptCookies,
          approveAriaLabel: approveAriaLabel,
          buttonLabel: buttonLabel,
          cookieKey: cookie_warning_constants["f" /* COOKIE_WARNING_LOCALSTORAGE_KEY */],
          dataSelector: "cookieWarning",
          link: link,
          openLayer: function openLayer() {
            return _this3.redirect(location, 'addQuery');
          },
          openLayerLabel: openLayerLabel,
          text: text,
          title: title
        });
      }

      if (this.state.showLayer) {
        return CookieWarning_jsx(CookiePreferencesLayer_CookiePreferencesLayer, {
          approveAriaLabel: approveAriaLabel,
          back: back,
          backAriaLabel: backAriaLabel,
          buttonLabel: buttonLabel,
          closeLabel: closeLabel,
          closeLayer: this.closeLayer,
          items: rest,
          link: link,
          onChange: this.onSwitchChange,
          onValidatePreferences: this.onValidatePreferences,
          personnalCookiesState: this.state.personnalCookies,
          text: text,
          title: title
        });
      }

      return null;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // first time rendering check if cookies were already approved
      // TODO change this because it prevents the customization after having set the cookies
      if (props.isApproved) {
        return {
          showBanner: false,
          showLayer: false,
          hasApproved: true
        };
      } // check in the location if we have to open the cookie preferences layer


      if (props.isAppMounted && props.location.queryParams[dist["appQueryParameters"].openLayer] === cookie_warning_constants["b" /* COOKIE_PREFERENCES_LAYER */] && !state.showLayer) {
        return {
          showBanner: false,
          showLayer: true
        };
      }

      if ((props.location.queryParams[dist["appQueryParameters"].openLayer] !== cookie_warning_constants["b" /* COOKIE_PREFERENCES_LAYER */] || !props.location.queryParams[dist["appQueryParameters"].openLayer]) && state.showLayer) {
        return {
          showBanner: !state.hasApproved,
          showLayer: false
        };
      }

      return null;
    }
  }]);

  return _CookieWarning;
}(react["Component"]);

Object(defineProperty["a" /* default */])(CookieWarning_CookieWarning, "contextType", ReactAppContext["a" /* default */]);

Object(defineProperty["a" /* default */])(CookieWarning_CookieWarning, "defaultProps", {
  buttonLabel: '',
  isApproved: false,
  layerInfo: {
    back: '',
    link: '',
    item1: {
      title: '',
      label: ''
    },
    item2: {
      title: '',
      label: ''
    },
    item3: {
      title: '',
      label: ''
    },
    item4: {
      title: '',
      label: ''
    }
  },
  link: {
    label: '',
    url: ''
  },
  text: '',
  title: ''
});

var CookieWarning = Object(withRouter["a" /* withRouter */])(CookieWarning_CookieWarning);
// CONCATENATED MODULE: ./src/client/components/layouts/footer/footer-annexes/FooterAnnexes.jsx
var FooterAnnexes_jsx = react_default.a.createElement;


function FooterAnnexes(_ref) {
  var className = _ref.className,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;
  return FooterAnnexes_jsx("div", {
    className: className
  }, FooterAnnexes_jsx("ul", {
    className: "reset-list mb-5 -mx-2"
  }, items.map(function (_ref2) {
    var label = _ref2.label,
        links = _ref2.links;
    return FooterAnnexes_jsx("li", {
      className: "align-top inline-block mb-5 px-2 w-1/3",
      "data-testid": "FooterAnnexesItem",
      key: label
    }, FooterAnnexes_jsx("p", {
      "aria-level": "2",
      className: "reset-paragraph font-bold leading-one mb-2 text-sm uppercase",
      "data-testid": "FooterAnnexesHeading",
      role: "heading"
    }, label), FooterAnnexes_jsx("ul", {
      className: "reset-list"
    }, links.map(function (link) {
      return FooterAnnexes_jsx("li", {
        className: "leading-loose mb-1 text-sm",
        key: link.label
      }, FooterAnnexes_jsx(DynamicLink["a" /* default */], {
        className: "inline-block leading-one text-inherit focus:text-gray-light hover:text-gray-light transition-color",
        target: "_blank",
        url: link.href
      }, link.label));
    })));
  })));
}
// EXTERNAL MODULE: ./src/client/components/layouts/footer/footer-contacts/FooterContacts.jsx
var FooterContacts = __webpack_require__("05L9");

// CONCATENATED MODULE: ./src/client/components/layouts/footer/footer-policies/FooterPolicies.jsx
var FooterPolicies_jsx = react_default.a.createElement;




function FooterPolicies(_ref) {
  var className = _ref.className,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;

  if (!items.length) {
    return null;
  }

  return FooterPolicies_jsx("ul", {
    className: classnames_default()(className, 'reset-list text-sm')
  }, items.map(function (_ref2) {
    var imageSrc = _ref2.imageSrc,
        label = _ref2.label,
        url = _ref2.url;
    return FooterPolicies_jsx("li", {
      className: "my-1",
      key: url
    }, FooterPolicies_jsx(DynamicLink["a" /* default */], {
      className: "reset-anchor inline-flex items-center text-white focus:text-gray-light hover:text-gray-light",
      url: url
    }, FooterPolicies_jsx(Image["a" /* default */], {
      className: "flex-shrink-0 rtl:mr-1",
      dontChangeAnything: true,
      imageUrl: imageSrc
    }), label));
  }));
}
// EXTERNAL MODULE: ./src/routes/constants.js
var routes_constants = __webpack_require__("dNxv");

// CONCATENATED MODULE: ./src/client/components/layouts/footer/footer-seo/FooterSeo.jsx
var FooterSeo_jsx = react_default.a.createElement;



function FooterSeo(_ref) {
  var className = _ref.className,
      description = _ref.description,
      title = _ref.title,
      siteplanLinkIsDisplayed = _ref.siteplanLinkIsDisplayed,
      siteplanLinkLabel = _ref.siteplanLinkLabel;

  if (!description && !title) {
    return null;
  }

  return FooterSeo_jsx("section", {
    className: className
  }, FooterSeo_jsx("p", {
    "aria-level": "2",
    className: "mb-2 text-sm uppercase",
    role: "heading"
  }, title), FooterSeo_jsx("p", {
    className: "mb-2 reset-paragraph text-base"
  }, description), siteplanLinkIsDisplayed && FooterSeo_jsx(DynamicLink["a" /* default */], {
    className: "leading-one text-inherit text-sm focus:text-gray-light hover:text-gray-light transition-color",
    url: routes_constants["D" /* SITEPLAN_PAGE_URL */]
  }, siteplanLinkLabel));
}
// CONCATENATED MODULE: ./src/client/components/layouts/footer/footer-social-networks/FooterSocialNetworks.jsx
var FooterSocialNetworks_jsx = react_default.a.createElement;




function FooterSocialNetworks(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;

  if (!items.length) {
    return null;
  }

  return FooterSocialNetworks_jsx("div", {
    className: "decoration-strikethrough lg:rtl:pl-3 relative w-full lg:w-auto z-1"
  }, FooterSocialNetworks_jsx("ul", {
    className: "reset-list flex md:justify-center lg:justify-start -mx-1 py-5 md:py-0"
  }, items.map(function (_ref2) {
    var icon = _ref2.icon,
        href = _ref2.href,
        label = _ref2.label;
    return FooterSocialNetworks_jsx("li", {
      className: "mx-1",
      key: href
    }, FooterSocialNetworks_jsx(TrackClick["a" /* TrackClick */], {
      as: DynamicLink["a" /* default */],
      className: "bg-gray-darker border-1 border-gray-dark flex items-center justify-center text-center text-white focus:text-gray-light hover:text-gray-light",
      trackingData: {
        actionGA: 'footer',
        labelGA: icon
      },
      target: "_blank",
      url: href,
      style: {
        width: '3.125rem',
        height: '3.125rem'
      }
    }, FooterSocialNetworks_jsx(Icon["a" /* Icon */], {
      name: icon,
      width: "1.5rem",
      alt: typeof icon === 'string' ? icon : null
    }), FooterSocialNetworks_jsx("span", {
      className: "a11y"
    }, "Club Med - ".concat(label))));
  })));
}
// CONCATENATED MODULE: ./src/client/components/layouts/footer/footer-tripadvisor/FooterTripAdvisor.jsx
var FooterTripAdvisor_jsx = react_default.a.createElement;



function FooterTripAdvisor(_ref) {
  var className = _ref.className,
      text = _ref.text;

  if (!text) {
    return null;
  }

  return FooterTripAdvisor_jsx("div", {
    className: classnames_default()(className, 'rtl:text-right')
  }, FooterTripAdvisor_jsx("span", {
    className: "align-middle text-xs sm:text-base",
    "data-testid": "FooterTripAdvisor-title"
  }, text), FooterTripAdvisor_jsx(Image["a" /* default */], {
    altMsg: "Trip Advisor",
    className: "align-middle rtl:ml-2",
    dontChangeAnything: true,
    imageUrl: "https://www.tripadvisor.com/img/cdsi/langs/en/tripadvisor_logo_white_340x80-24206-0-en_US.png",
    style: {
      width: '8.5rem'
    }
  }));
}
// CONCATENATED MODULE: ./src/client/components/layouts/footer/footer-websites/footer-website/FooterWebsite.jsx
var FooterWebsite_jsx = react_default.a.createElement;



function FooterWebsite(_ref) {
  var description = _ref.description,
      href = _ref.href,
      iconAlt = _ref.iconAlt,
      iconName = _ref.iconName,
      iconWidth = _ref.iconWidth,
      isVisible = _ref.isVisible;

  if (!isVisible) {
    return null;
  }

  return FooterWebsite_jsx("li", {
    className: "align-top inline-block mb-9 px-3 w-1/2 lg:w-full"
  }, FooterWebsite_jsx(DynamicLink["a" /* default */], {
    className: "reset-anchor block focus:underline hover:underline",
    target: "_blank",
    url: href
  }, FooterWebsite_jsx("p", {
    "aria-level": "2",
    className: "reset-paragraph mb-1",
    role: "heading",
    style: {
      minHeight: '2.5rem'
    }
  }, FooterWebsite_jsx(Icon["a" /* Icon */], {
    alt: iconAlt,
    name: iconName,
    isNotSquare: true,
    width: iconWidth
  }), FooterWebsite_jsx("span", {
    className: "a11y"
  }, iconAlt)), FooterWebsite_jsx("p", {
    className: "reset-paragraph text-base"
  }, description)));
}
// CONCATENATED MODULE: ./src/client/components/layouts/footer/footer-websites/FooterWebsites.jsx

var FooterWebsites_jsx = react_default.a.createElement;



function FooterWebsites(_ref) {
  var business = _ref.business,
      className = _ref.className,
      corp = _ref.corp,
      job = _ref.job,
      property = _ref.property;
  return FooterWebsites_jsx("div", {
    className: className
  }, FooterWebsites_jsx("ul", {
    className: "reset-list -mx-3"
  }, FooterWebsites_jsx(FooterWebsite, Object(esm_extends["a" /* default */])({}, business, {
    iconAlt: "Meetings and events by Club Med",
    iconName: icons["a" /* ICONS */].CLUBMED_MEETINGS,
    iconWidth: "12.5rem"
  })), FooterWebsites_jsx(FooterWebsite, Object(esm_extends["a" /* default */])({}, property, {
    iconAlt: "Club Med Property",
    iconName: icons["a" /* ICONS */].CLUBMED_PROPERTY,
    iconWidth: "7.5rem"
  })), FooterWebsites_jsx(FooterWebsite, Object(esm_extends["a" /* default */])({}, job, {
    iconAlt: "ClubMed Jobs",
    iconName: icons["a" /* ICONS */].CLUBMED_JOBS,
    iconWidth: "7.5rem"
  })), FooterWebsites_jsx(FooterWebsite, Object(esm_extends["a" /* default */])({}, corp, {
    iconAlt: "Club M\xE9diterran\xE9e",
    iconName: icons["a" /* ICONS */].CLUBMED,
    iconWidth: "7.5rem"
  }))));
}
// CONCATENATED MODULE: ./src/client/components/layouts/footer/Footer.jsx

var Footer_jsx = react_default.a.createElement;









function Footer(props) {
  var annexes = props.annexes,
      contacts = props.contacts,
      className = props.className,
      policies = props.policies,
      socialNetworks = props.socialNetworks,
      seo = props.seo,
      tabText = props.tabText,
      tripAdvisor = props.tripAdvisor,
      websites = props.websites;
  return Footer_jsx("div", {
    className: classnames_default()(className, 'relative z-3'),
    "data-testid": "Footer"
  }, Footer_jsx("div", {
    className: "text-md text-white"
  }, Footer_jsx("div", {
    className: "m-auto w-full max-w-site"
  }, Footer_jsx("div", {
    className: "bg-gray-darker font-bold inline-block px-2 relative text-md text-gray-darker",
    style: {
      bottom: '-1px',
      height: '2.5rem',
      left: '1.5rem',
      lineHeight: '2.5rem',
      right: '1.5rem'
    }
  }, Footer_jsx("svg", {
    className: "absolute fill-current top-0",
    width: "24",
    height: "40",
    viewBox: "0 0 24 40",
    style: {
      height: '2.5rem',
      left: -23
    }
  }, Footer_jsx("path", {
    d: "M24 0c-4.3 0-8 3.1-8.7 7.3L8.6 33c-.8 4-4.5 7-8.6 7h24V0z"
  })), Footer_jsx("svg", {
    className: "absolute fill-current top-0 -scale-x-1",
    width: "24",
    height: "40",
    viewBox: "0 0 24 40",
    style: {
      height: '2.5rem',
      right: -23
    }
  }, Footer_jsx("path", {
    d: "M24 0c-4.3 0-8 3.1-8.7 7.3L8.6 33c-.8 4-4.5 7-8.6 7h24V0z"
  })), Footer_jsx("span", {
    className: "text-white"
  }, tabText))), Footer_jsx("div", {
    className: "bg-gray-darker flex items-center px-5"
  }, Footer_jsx("div", {
    className: "flex flex-col lg:flex-row md:items-end m-auto max-w-site relative w-full"
  }, Footer_jsx(FooterContacts["a" /* FooterContacts */], {
    items: contacts
  }), Footer_jsx(FooterSocialNetworks, {
    items: socialNetworks
  })))), Footer_jsx("footer", {
    className: "bg-gray-darker text-white"
  }, Footer_jsx("div", {
    className: "flex flex-wrap m-auto max-w-site px-5 lg:px-0 py-5"
  }, Footer_jsx(FooterWebsites, Object(esm_extends["a" /* default */])({}, websites, {
    className: "hidden sm:block lg:w-2/5 lg:rtl:pr-24"
  })), Footer_jsx("div", {
    className: "lg:w-3/5"
  }, Footer_jsx(FooterAnnexes, {
    items: annexes,
    className: "hidden sm:block"
  }), Footer_jsx(FooterSeo, Object(esm_extends["a" /* default */])({}, seo, {
    className: "md:w-4/5 lg:w-auto"
  })), Footer_jsx(FooterPolicies, {
    items: policies,
    className: "mt-8"
  })), Footer_jsx(FooterTripAdvisor, Object(esm_extends["a" /* default */])({}, tripAdvisor, {
    className: "mt-5 pt-5 w-full"
  })))));
}
// CONCATENATED MODULE: ./src/client/components/layouts/footer/FooterContainer.jsx



var FooterContainer_jsx = react_default.a.createElement;

function FooterContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function FooterContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FooterContainer_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FooterContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













function FooterContainer(props) {
  var ABTests = Object(react["useContext"])(ABTestContext["a" /* ABTestContext */]);

  var _useContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isAppMounted = _useContext.isAppMounted;

  var conditionToShowPopin = isAppMounted && ABTests['ab-test-popinNewsletter'] === '1' && Object(local_storage_api["a" /* getFromLocalStorage */])(PopinNewsletter["b" /* POPIN_NEWSLETTER */]) !== 'viewed';
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var newsletters = props.newsletters,
      legalInformations = props.legalInformations,
      _props$config = props.config,
      cookieWarning = _props$config.cookieWarning,
      memberSpace = _props$config.memberSpace,
      footer = _props$config.footer,
      webCallback = _props$config.webCallback,
      common = _props$config.common;

  var approve = cookieWarning.approve,
      label = cookieWarning.label,
      layer = cookieWarning.layer,
      otherCookieWarningProps = Object(objectWithoutProperties["a" /* default */])(cookieWarning, ["approve", "label", "layer"]);

  Object(i18n["a" /* addTranslationKeys */])({
    common: common,
    webCallback: FooterContainer_objectSpread(FooterContainer_objectSpread({}, webCallback), common.dateTime),
    newsletter: props.config.newsletter,
    memberSpace: memberSpace
  });
  var policies = appContext.locale === 'zh-CN' ? [{
    imageSrc: 'https://ns.clubmed.com/it/2019/footer/logo_cn_gov1.png',
    label: '沪公网安备31010102005123号',
    url: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010102005123'
  }, {
    imageSrc: 'https://ns.clubmed.com/it/2019/footer/logo_cn_gov2.png',
    label: '上海工商',
    url: 'http://www.sgs.gov.cn/lz/licenseLink.do?method=licenceView&entyId=gs20140504000004692'
  }] : [];

  var _useState = Object(react["useState"])(conditionToShowPopin),
      popinShow = _useState[0],
      setPopinShow = _useState[1];

  var onClosePopin = function onClosePopin() {
    setPopinShow(false);
    Object(local_storage_api["d" /* setInLocalStorage */])(PopinNewsletter["b" /* POPIN_NEWSLETTER */], 'viewed');
  };

  Object(react["useEffect"])(function () {
    return setPopinShow(conditionToShowPopin);
  }, [conditionToShowPopin]);
  return FooterContainer_jsx(react["Fragment"], null, popinShow && FooterContainer_jsx(PopinNewsletter["c" /* PopinNewsletter */], {
    checkboxes: newsletters,
    legalInformations: legalInformations ? legalInformations.newsletter : [],
    onClose: onClosePopin
  }), FooterContainer_jsx(CookieWarning, Object(esm_extends["a" /* default */])({}, otherCookieWarningProps, {
    buttonLabel: approve,
    closeLabel: Object(lodash["get"])(props, 'config.common.close'),
    layerInfo: layer,
    text: label,
    isAppMounted: isAppMounted,
    isApproved: !!js_cookie_default.a.get(cookie_warning_constants["f" /* COOKIE_WARNING_LOCALSTORAGE_KEY */])
  })), FooterContainer_jsx(Footer, {
    policies: policies,
    annexes: footer.annexes,
    contacts: footer.contactsBar,
    seo: footer.seo,
    socialNetworks: footer.socialNetworks,
    tabText: footer.contactsBarLabel,
    tripAdvisor: footer.tripAdvisor,
    websites: footer.websites
  }));
}
// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// CONCATENATED MODULE: ./src/utils/tracking/dataScore.js


var dataScore_getDataScore = function getDataScore(_ref) {
  var resortId = _ref.resortId,
      departureDate = _ref.departureDate,
      appContext = _ref.appContext;
  var neolaneId = appContext.neolaneId,
      googleTrackingId = appContext.googleTrackingId;
  return graphqlClient["a" /* default */].runNoCacheQuery("\n    query{\n      dataScore(\n      resortId: \"".concat(resortId || '', "\",\n      departureDate: \"").concat(departureDate || '', "\",\n      neolaneId: \"").concat(neolaneId || '', "\",\n      gaTrackingId: \"").concat(googleTrackingId || '', "\") {\n        leadScoring\n      }\n    }\n  "));
};


// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/client/store/lead-info/constants.js
var lead_info_constants = __webpack_require__("unIT");

// CONCATENATED MODULE: ./src/client/store/lead-info/leadInfos.action.js



var leadInfos_action_setDataScore = function setDataScore(score) {
  return Object(createAction["b" /* default */])(lead_info_constants["b" /* SET_DATA_SCORE */], {
    score: score
  });
};


// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/session-storage-api/sessionStorageApi.js
var sessionStorageApi = __webpack_require__("9NGo");

// CONCATENATED MODULE: ./src/client/components/widgets/data-score/DataScore.jsx


function DataScore_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function DataScore_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { DataScore_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { DataScore_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var pendingDataScoreTimeout = null;
/*
 * the following function is used to execute the fn arg on the last call only
 * the previous scheduled call to fn will be canceled at every new call
 * by clearing the setTimeout id stored in pendingDataScoreTimeout
 *
 */

var takeLast = function takeLast(fn) {
  clearTimeout(pendingDataScoreTimeout); // 5000ms is choosed arbitrarily

  pendingDataScoreTimeout = setTimeout(fn, 5000);
};

var DataScore_neolaneId = null;

var DataScore_DataScore = function DataScore() {
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isAppMounted = _useContext.isAppMounted;

  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);
  var selectedProposal = Object(es["e" /* useSelector */])(booking_selector["l" /* getCurrentProposal */]);
  var resort = Object(es["e" /* useSelector */])(booking_selector["m" /* getCurrentResort */]);
  var dispatch = Object(es["d" /* useDispatch */])();
  var dataScoreHasBeenFetched = !!Object(sessionStorageApi["b" /* getFromSessionStorage */])(lead_info_constants["a" /* DATA_SCORE_SESSION_STORAGE_KEY */]);
  Object(react["useEffect"])(function () {
    if (Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('enableLeadScoring') && isAppMounted && ( // neolaneId will change after user sign in
    !DataScore_neolaneId && appContext.neolaneId || !dataScoreHasBeenFetched && (appContext.neolaneId || appContext.googleTrackingId))) {
      DataScore_neolaneId = appContext.neolaneId;
      /*
         every calls to the lead scoring API is billed so we want to make
         sure there is only one call to be done when the app state is stabilized
       */

      takeLast(function () {
        dataScore_getDataScore(DataScore_objectSpread(DataScore_objectSpread(DataScore_objectSpread({}, selectedProposal ? {
          departureDate: selectedProposal.departureDate
        } : null), resort ? {
          resortId: resort.id
        } : null), {}, {
          appContext: appContext
        })).then(function (_ref) {
          var leadScoring = _ref.dataScore.leadScoring;
          var score = parseFloat(leadScoring);
          tracking_api["b" /* setDataLayer */](DataScore_objectSpread(DataScore_objectSpread({}, constants["i" /* GA_DEFAULT_PAYLOAD */]), {}, {
            event: 'leadScoring',
            leadScoring: score
          }), appContext, pageContext.pageId);
          dispatch(leadInfos_action_setDataScore(leadScoring));
          Object(sessionStorageApi["d" /* setInSessionStorage */])(lead_info_constants["a" /* DATA_SCORE_SESSION_STORAGE_KEY */], leadScoring);
        }).catch(function () {
          /* we don't do anything if the call fails */
        });
      });
    }
  }, [isAppMounted, appContext, selectedProposal]);
  return null;
};


// EXTERNAL MODULE: ./src/client/components/stylesheets/critical.css
var critical = __webpack_require__("yAUU");

// CONCATENATED MODULE: ./src/client/components/layouts/layout/Layout.jsx






var Layout_jsx = react_default.a.createElement;

function Layout_createSuper(Derived) { var hasNativeReflectConstruct = Layout_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function Layout_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }















var LazyLayout = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(48), __webpack_require__.e(90), __webpack_require__.e(95)]).then(__webpack_require__.bind(null, "nsiK")).then(function (c) {
    return c.LazyLayout;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("nsiK")];
    },
    modules: ["./LazyLayout.jsx"]
  }
});
var NavigationBar = Object(UserInfo["a" /* userInfoWrapper */])(Navigation_Navigation);

var Layout_getLocales = function getLocales(currentLocale, availableLocales) {
  var hiddenLocales = (config_default.a.get('featureFlipping.hiddenLocales') || '').split(',').filter(function (l) {
    return l !== currentLocale;
  });
  return Object(lodash["omit"])(availableLocales, hiddenLocales);
};

var Layout_Layout = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(Layout, _Component);

  var _super = Layout_createSuper(Layout);

  function Layout(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Layout);

    _this = _super.call(this, props);
    _this.promoBannerRef = /*#__PURE__*/react_default.a.createRef();
    return _this;
  }

  Object(createClass["a" /* default */])(Layout, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          CMSConfig = _this$props.config,
          disableFooter = _this$props.disableFooter,
          disableHeader = _this$props.disableHeader,
          className = _this$props.className,
          isMicePage = _this$props.isMicePage,
          legalInformations = _this$props.legalInformations,
          newsletters = _this$props.newsletters;
      var _this$context = this.context,
          availableLocales = _this$context.availableLocales,
          currentLocale = _this$context.locale;

      var _ref = CMSConfig || {},
          account = _ref.account,
          memberSpace = _ref.memberSpace,
          navigationBar = _ref.navigationBar,
          maybePromotionalBanner = _ref.promotionalBanner; // sometimes CMSConfig is undefined at first render witch causes error with destructuring ;


      var promotionalBanner = maybePromotionalBanner || {};
      Object(i18n["a" /* addTranslationKeys */])(CMSConfig);
      var navLanguage = {
        currentLocale: currentLocale,
        locales: Layout_getLocales(currentLocale, availableLocales)
      };
      return Layout_jsx(react["Fragment"], null, Layout_jsx(LazyLayout, null), !disableHeader && !isMicePage && promotionalBanner.enabled && (promotionalBanner.title || promotionalBanner.description) && Layout_jsx(PromotionalBanner, {
        bgColor: promotionalBanner.color,
        className: "relative z-6",
        closeLabel: promotionalBanner.closeButtonLabel,
        countdown: promotionalBanner.countdown,
        description: promotionalBanner.description,
        disabledPages: promotionalBanner.disabledPages,
        enabledPages: promotionalBanner.enabledPages,
        iconName: promotionalBanner.icon,
        label: promotionalBanner.iconTitle,
        link: {
          url: promotionalBanner.link
        },
        title: promotionalBanner.title,
        titleColor: promotionalBanner.titleColor,
        ref: this.promoBannerRef
      }), Layout_jsx("div", {
        className: classnames_default()(className, 'Layout relative table table-fixed w-full')
      }, !disableHeader ? Layout_jsx("div", {
        className: "absolute top-0 inset-x-0"
      }, Object(lodash["get"])(CMSConfig, 'crisisAlert.enabled') && Layout_jsx("div", {
        className: "absolute top-0 rtl:right-0 w-full z-5"
      }, Layout_jsx("div", {
        className: "flex p-5 max-w-site mt-navigation mx-auto"
      }, Layout_jsx(CrisisAlertLinkBanner_CrisisAlertLinkBanner, {
        alertDate: Object(lodash["get"])(CMSConfig, 'crisisAlert.alertDate', ''),
        className: "rtl:ml-auto",
        isEnabled: Object(lodash["get"])(CMSConfig, 'crisisAlert.enabled'),
        linkLabel: Object(lodash["get"])(CMSConfig, 'crisisAlert.link.label'),
        linkUrl: Object(lodash["get"])(CMSConfig, 'crisisAlert.link.url')
      }))), Layout_jsx(NavigationBar, {
        cmsAccount: account,
        cmsMemberSpace: memberSpace,
        language: navLanguage,
        navigation: navigationBar,
        promoBannerRef: this.promoBannerRef
      })) : null, this.props.children, !disableFooter && Layout_jsx(FooterContainer, {
        newsletters: newsletters,
        legalInformations: legalInformations,
        config: CMSConfig
      })), Layout_jsx(DataScore_DataScore, null));
    }
  }]);

  return Layout;
}(react["Component"]);

Object(defineProperty["a" /* default */])(Layout_Layout, "contextType", ReactAppContext["a" /* default */]);
// CONCATENATED MODULE: ./src/client/components/layouts/layout/Layout.query.js


var Layout_query_fetchLayoutConfig = function fetchLayoutConfig(appContext) {
  return graphqlClient["a" /* default */].runQuery('', appContext, {
    requestName: requestDictionary["e" /* CORE_LAYOUT */],
    queryId: requestDictionary["e" /* CORE_LAYOUT */]
  });
};
// EXTERNAL MODULE: ./src/utils/context/contextUtils.js
var contextUtils = __webpack_require__("igjW");

// CONCATENATED MODULE: ./src/utils/ple-utils/handleInvalidToken.js




var handleInvalidToken_handleInvalidToken = function handleInvalidToken(_ref) {
  var appContext = _ref.appContext,
      currentUri = _ref.currentUri,
      res = _ref.res,
      userInfo = _ref.userInfo;
  var redirectUri = Object(ple_utils["n" /* isCxoSellerContext */])(currentUri.search()) ? Object(ple_utils["e" /* buildSellerSigninUrl */])({
    locale: appContext.locale,
    redirectUri: currentUri.toString(),
    redirectURIError: Object(ple_utils["c" /* buildErrorUrl */])(currentUri.toString(), appContext.locale)
  }) : Object(ple_utils["f" /* buildSigninUrl */])({
    locale: appContext.locale,
    redirectUri: currentUri.toString(),
    redirectURIError: Object(ple_utils["c" /* buildErrorUrl */])(currentUri.toString(), appContext.locale),
    isQuickLoginFirst: currentUri.toString().includes("provider=".concat(ple_utils["a" /* QUICK_LOGIN_QUERY_PARAM */])) || Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('memberSpace.isQuickLoginFirst')
  }); // not filled because the cookie is httpOnly
  // if (!appContext.authenticationToken) {

  if (!appContext.isUserLogged && !appContext.isUserQuickLogged && !appContext.isSellerLogged) {
    if (res) {
      res.redirect(302, redirectUri);
    } else {
      dist["windowWrapper"].setLocation(redirectUri);
    }
  } else {
    var isTokenValid = userInfo && moment_default()(userInfo.expirationDate, 'X').startOf('second').isAfter();

    if ((appContext.isUserLogged || appContext.isUserQuickLogged) && !isTokenValid) {
      dist["windowWrapper"].setLocation(redirectUri);
    }
  }
};
// EXTERNAL MODULE: ./src/client/store/configureStore.js
var configureStore = __webpack_require__("Crz2");

// CONCATENATED MODULE: ./src/client/store/withReduxStore.js
// https://github.com/zeit/next.js/blob/126eb498675e6f1a27d568672c2a9da49eec09f9/examples/with-redux/lib/with-redux-store.js
// From this example https://github.com/zeit/next.js/tree/126eb498675e6f1a27d568672c2a9da49eec09f9/examples/with-redux


var isServer = false;
var __NEXT_REDUX_STORE__ = '__NEXT_REDUX_STORE__'; // The store is a singleton on the client, but is created every time on the server

function getOrCreateStore() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; // Always make a new store if server, otherwise state is shared between requests

  if (isServer) {
    return Object(configureStore["a" /* init */])(initialState);
  } // Create store if unavailable on the client and set it on the window object


  if (!window[__NEXT_REDUX_STORE__]) {
    window[__NEXT_REDUX_STORE__] = Object(configureStore["a" /* init */])(initialState);
  }

  return window[__NEXT_REDUX_STORE__];
}
// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: ../domains-service/dist/index.js
var domains_service_dist = __webpack_require__("g/E1");
var domains_service_dist_default = /*#__PURE__*/__webpack_require__.n(domains_service_dist);

// EXTERNAL MODULE: ./src/utils/ple-utils/cookies.js
var ple_utils_cookies = __webpack_require__("H6pA");

// CONCATENATED MODULE: ./src/client/context/initAppContext.js









function initAppContext(uri) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$cookies = _ref.cookies,
      cookies = _ref$cookies === void 0 ? {} : _ref$cookies,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'fr-FR' : _ref$locale,
      originalUrl = _ref.originalUrl,
      requestId = _ref.requestId,
      userAgent = _ref.userAgent;

  var _ref2 = domains_service_dist_default.a.isValidLocale(locale) ? locale.split('-') : [],
      _ref3 = Object(slicedToArray["a" /* default */])(_ref2, 2),
      language = _ref3[0],
      country = _ref3[1];

  var encodedUserInfo = cookies[ple_utils_cookies["d" /* USER_INFO */]] ? dist["oidc"].fromUriEncodedState(cookies[ple_utils_cookies["d" /* USER_INFO */]]) : undefined;
  var sellerInfo = cookies[ple_utils_cookies["b" /* SELLER_INFO */]] ? dist["oidc"].fromUriEncodedState(cookies[ple_utils_cookies["b" /* SELLER_INFO */]]) : undefined;
  var uriObject = new URI_default.a(uri);
  var queryParameters = uriObject.query(true);
  var domainServiceForHostname = domains_service_dist_default.a.forHostname(uriObject.hostname());
  var availableLocales = domainServiceForHostname.getAllLocales();
  var cm_ta = dist["appQueryParameters"].cmta.cm_ta,
      cxo_sales_network_id = dist["appQueryParameters"].cxo.cxo_sales_network_id,
      indirect = dist["appQueryParameters"].indirect;
  var isCmta = queryParameters[cm_ta] !== undefined;
  var isIndirect = queryParameters[indirect] !== undefined;
  var isDirectCxo = !!queryParameters[cxo_sales_network_id] && !isIndirect && !isCmta;
  var isIndirectCxo = !!queryParameters[cxo_sales_network_id] && isIndirect && !isCmta;
  var isCxo = isDirectCxo || isIndirectCxo;
  return {
    authenticationToken: cookies[ple_utils_cookies["a" /* ACCESS_TOKEN */]] || cookies.CM_SELLER_TOKEN || '',
    availableLocales: availableLocales,
    bypassCache: queryParameters[dist["appQueryParameters"].bypassCache] === 'true',
    canUseOnlinePayment: domains_service_dist_default.a.getEnabledPaymentProviders(locale).length > 0,
    cmsContent: queryParameters.commonContent || config_default.a.get('cms.commonContent'),
    cmsRelease: queryParameters.commonRelease || config_default.a.get('cms.commonRelease'),
    cmta: isCmta ? {
      agency: (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.agency) || '',
      agent: (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.agent) || '',
      isDelCredere: (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.isDelCredere) || false,
      email: (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.email) || '',
      searchType: uriObject.path() === routes_constants["A" /* QUICK_SEARCH_URL */] ? 'quick' : 'advanced'
    } : {},
    cookies: cookies,
    country: country || '',
    customerNeolaneId: queryParameters.cxo_neolid,
    customerType: (encodedUserInfo === null || encodedUserInfo === void 0 ? void 0 : encodedUserInfo.customerType) || '',
    cxoQueryParams: {
      cxo_azur_code: queryParameters.cxo_azur_code,
      cxo_sales_channel: queryParameters.cxo_sales_channel,
      cxo_country_code: queryParameters.cxo_country_code,
      cxo_user_id: typeof queryParameters.cxo_id === 'string' ? Object(sellerUtils["a" /* decryptHeptaSeller */])(queryParameters.cxo_id) : ''
    },
    displayUnicodeFields: domains_service_dist_default.a.shouldDisplayUnicodeFields(locale) || false,
    // TODO replace this by - and improve for SSR - GoogleAnalytics tracking helper
    googleTrackingId: queryParameters.visitorGUID || cookies._ga || null,
    headers: {},
    isProduction: Object(contextUtils["c" /* isProduction */])(),
    isCmta: isCmta,
    isCxo: isCxo,
    isDirectCxo: isDirectCxo,
    isIndirectCxo: isIndirectCxo,
    isSeller: isCmta || isDirectCxo || isIndirectCxo,
    isSellerLogged: cookies[ple_utils_cookies["c" /* SELLER_LOGGED */]] === 'true',
    isUserLogged: (encodedUserInfo === null || encodedUserInfo === void 0 ? void 0 : encodedUserInfo.isLoggedIn) || false,
    isUserQuickLogged: (encodedUserInfo === null || encodedUserInfo === void 0 ? void 0 : encodedUserInfo.isQuickLoggedIn) || false,
    language: language || '',
    lines: [],
    locale: locale,
    neolaneId: cookies.cm_client_uid || (encodedUserInfo ? encodedUserInfo.neolaneId : null),
    originalUrl: originalUrl,
    pagesContent: queryParameters.pagesContent || config_default.a.get('cms.pagesContent'),
    pagesRelease: queryParameters.pagesRelease || config_default.a.get('cms.pagesRelease'),
    requestId: requestId,
    userAgent: userAgent || ''
  };
}
// CONCATENATED MODULE: ./src/server/context/createAppContextFromReq.js


function createAppContextFromReq_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function createAppContextFromReq_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      createAppContextFromReq_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      createAppContextFromReq_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








var createAppContextFromReq_createAppContextFromProps = function createAppContextFromProps(appContext) {
  var uri = new URI_default.a(appContext.originalUrl);
  var hostname = uri.hostname();
  return createAppContextFromReq_objectSpread(createAppContextFromReq_objectSpread({}, appContext), {}, {
    availableLocales: domains_service_dist_default.a.forHostname(hostname).getAllLocales()
  }, initAppContext(appContext.originalUrl, appContext));
};
var createAppContextFromReq_createAppContextFromReq = function createAppContextFromReq(req) {
  // $FlowFixMe: id is injected from express-request-id
  var requestId = req.headers[dist["httpHeaders"].X_REQUEST_ID] || req.id;
  var uri = Object(contextUtils["b" /* getCurrentUri */])(req);
  var queryParameters = dist["url"].decodeQueryParameters(uri.query(true));
  var requestedLocale = queryParameters.locale;
  var hostname = uri.hostname(); // $FlowFixMe we have a host

  var host = req.get('host');
  var appContext = {
    availableLocales: domains_service_dist_default.a.forHostname(hostname).getAllLocales(),
    originalUrl: req.protocol + '://' + host + req.originalUrl,
    cookies: req.cookies,
    locale: Object(contextUtils["a" /* getCurrentLocale */])(requestedLocale, hostname),
    requestId: requestId,
    userAgent: req.headers['user-agent']
  };
  moment_default.a.locale(Object(lodash["get"])(appContext.availableLocales, "".concat(appContext.locale, ".moment"), 'fr'));
  return createAppContextFromReq_objectSpread(createAppContextFromReq_objectSpread({}, appContext), initAppContext(uri, appContext));
};
// CONCATENATED MODULE: ./src/client/context/createOrUpdateAppContext.js


function createOrUpdateAppContext_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function createOrUpdateAppContext_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      createOrUpdateAppContext_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      createOrUpdateAppContext_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





 // Server-side the context is created everytime
// client-side, it's first saved in the constructor of _app, then retrieved in subsequent
// getInitialProps

var localAppContext; // $FlowFixMe

var getAppContext = function getAppContext() {
  return localAppContext;
};
var createOrUpdateAppContext_saveAppContext = function saveAppContext(appContext) {
  var data = createOrUpdateAppContext_objectSpread(createOrUpdateAppContext_objectSpread({}, appContext), {}, {
    cookies: js_cookie_default.a.get(),
    userAgent: Object(lodash["get"])(window, 'navigator.userAgent')
  });

  localAppContext = createOrUpdateAppContext_objectSpread(createOrUpdateAppContext_objectSpread({}, data), initAppContext(data.originalUrl, data));
  var momentLocale = Object(lodash["get"])(localAppContext, "availableLocales.".concat(localAppContext.locale, ".moment"), 'fr');
  moment_default.a.locale(momentLocale);
  Object(i18n["e" /* setLocale */])(localAppContext.locale.slice(0, 2));
  return localAppContext;
};
// CONCATENATED MODULE: ./src/client/router/createRouterLocation.js


function createRouterLocation_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function createRouterLocation_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      createRouterLocation_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      createRouterLocation_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var createRouterLocation_createRouterLocation = function createRouterLocation(_ref) {
  var asPath = _ref.asPath,
      query = _ref.query,
      originalUrl = _ref.originalUrl;
  var uri = new URI_default.a(asPath);
  var urlParams = {};
  var queryParams = {};
  /*
   * Due to a next-route implementation with a weird `.join('/')`
   * we need to check if the current query param has a slash as separator
   * and split it into an array.
   * cf: https://github.com/fridays/next-routes/issues/250
   */

  for (var queryParameter in query) {
    if (uri.hasSearch(queryParameter)) {
      queryParams[queryParameter] = query[queryParameter];
    } else {
      urlParams[queryParameter] = query[queryParameter];
    }
  }

  return {
    origin: true ? window.location.origin : undefined,
    pathname: uri.pathname(),
    hash: uri.hash(),
    urlParams: urlParams,
    queryParams: queryParams
  };
};
var createRouterLocation_updateShallowQueryParams = function updateShallowQueryParams(_ref2) {
  var location = _ref2.location,
      href = _ref2.href;
  if (!href) return location;
  var uri = Object(uriUtils["c" /* convertLocationToURI */])(location); // We cannot reconstruct the URL simply from href since the front-end doesn't know what routes can
  // be rewritten (/r/Bali/y is {urlParams: { dynamicPage: '/r/Bali/y }})

  var currentUri = new URI_default.a(href);
  var newQueryParams = location.queryParams;
  var queryParamsList = Object.keys(uri.query(true));
  var currentQueryParamsList = Object.keys(currentUri.query(true)); // delete query params which are no longer in the new uri

  for (var queryParamName in uri.query(true)) {
    if (!currentQueryParamsList.includes(queryParamName)) {
      delete newQueryParams[queryParamName];
    }
  } // add missing query params or update the current ones


  for (var _queryParamName in currentUri.query(true)) {
    if (!queryParamsList.includes(_queryParamName) || newQueryParams[_queryParamName] !== currentUri.query(true)[_queryParamName]) {
      newQueryParams[_queryParamName] = currentUri.query(true)[_queryParamName];
    }
  }

  return createRouterLocation_objectSpread(createRouterLocation_objectSpread({}, location), {}, {
    queryParams: newQueryParams
  });
};
// EXTERNAL MODULE: ./src/client/components/third-party/thirdParty.utils.js
var thirdParty_utils = __webpack_require__("kD1E");

// CONCATENATED MODULE: ./src/client/components/third-party/GoogleTagManager.jsx
var GoogleTagManager_jsx = react_default.a.createElement;





var GoogleTagManager_GoogleTagManager = function GoogleTagManager() {
  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      queryParams = _useRouter.location.queryParams;

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var tracking = Object(thirdParty_utils["a" /* getConfigWithNoThirdPartySupport */])({
    name: 'tracking',
    locale: appContext.locale,
    queryParams: queryParams
  });
  var key = 'GTM-KJ3DSC';

  if (Object(sellerUtils["f" /* isSeller */])(appContext)) {
    key = appContext.isCmta ? 'GTM-P9H7QS7' : 'GTM-N8CQ3J6';
  }

  if (tracking.enabled) {
    return GoogleTagManager_jsx(react["Fragment"], null, GoogleTagManager_jsx("noscript", null, GoogleTagManager_jsx("iframe", {
      title: "googletagmanager",
      src: "https://www.googletagmanager.com/ns.html?id=".concat(key),
      height: "0",
      width: "0",
      style: {
        display: 'none',
        visibility: 'hidden'
      }
    })), GoogleTagManager_jsx("script", {
      dangerouslySetInnerHTML: {
        __html: "\n              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n              })(window,document,'script','clubMedLayer','".concat(key, "');\n          ")
      }
    }));
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/Sentry.jsx
var Sentry_jsx = react_default.a.createElement;



var Sentry_Sentry = function Sentry() {
  var _useContext = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      locale = _useContext.locale;

  var appVersion = config_default.a.get('APP_VERSION');
  var deploymentEnv = config_default.a.get('DEPLOYMENT_ENV');
  var sentry = config_default.a.get('clientError.sentry');

  if (sentry.enabled && sentry.url && sentry.dsn) {
    return Sentry_jsx(react["Fragment"], null, Sentry_jsx("script", {
      src: sentry.url,
      crossOrigin: "anonymous"
    }), Sentry_jsx("script", {
      dangerouslySetInnerHTML: {
        __html: "\n              if (window.Sentry) {\n                Sentry.init({\n                  dsn: '".concat(sentry.dsn, "',\n                  environment: '").concat(deploymentEnv, "',\n                  release: '").concat(appVersion, "',\n                });\n                Sentry.configureScope(function (scope) {\n                  scope.setExtra('locale', '").concat(locale, "');\n                  scope.setTag('locale', '").concat(locale, "');\n                });\n              }\n          ")
      }
    }));
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/Cedexis.jsx
var Cedexis_jsx = react_default.a.createElement;




var Cedexis_Cedexis = function Cedexis() {
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var performance = config_default.a.get('performance');

  if (!Object(sellerUtils["f" /* isSeller */])(appContext) && performance.cedexis.enabled) {
    return Cedexis_jsx("script", {
      dangerouslySetInnerHTML: {
        __html: "\n            (function(e,c,a,g,f){function d(){var b=c.createElement(\"script\");b.async=!0;\n              b.src=\"//radar.cedexis.com/1/10015/radar.js\";c.body.appendChild(b)}\n              (function(){for(var b=[/\bMSIE (5|6)/i],a=b.length;a--;)if(b[a]\n                .test(navigator.userAgent))return!1;return!0})()\n              &&(\"complete\"!==c.readyState?(a=e[a])?a(f,d,!1):(a=e[g])&&a(\"on\"+f,d):d())})\n            (window,document,\"addEventListener\",\"attachEvent\",\"load\");\n        "
      }
    });
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/PriorityThirdPartyScripts.jsx
var PriorityThirdPartyScripts_jsx = react["createElement"];




var PriorityThirdPartyScripts_PriorityThirdPartyScripts = function PriorityThirdPartyScripts() {
  return PriorityThirdPartyScripts_jsx(react["Fragment"], null, PriorityThirdPartyScripts_jsx(GoogleTagManager_GoogleTagManager, null), PriorityThirdPartyScripts_jsx(Cedexis_Cedexis, null), PriorityThirdPartyScripts_jsx(Sentry_Sentry, null));
};
// EXTERNAL MODULE: ./src/client/components/utils/ab-tasty/abTasty.utils.js
var abTasty_utils = __webpack_require__("FtaI");

// CONCATENATED MODULE: ./src/client/components/third-party/AbTasty.jsx
var AbTasty_jsx = react_default.a.createElement;



var AbTasty_AbTasty = function AbTasty() {
  var _useAbTasty = Object(abTasty_utils["b" /* useAbTasty */])(),
      abTastyScriptUrl = _useAbTasty.abTastyScriptUrl,
      isAbTastyActive = _useAbTasty.isAbTastyActive;

  return isAbTastyActive ? AbTasty_jsx(head_default.a, null, AbTasty_jsx("script", {
    key: "abtasty-lib",
    src: abTastyScriptUrl
  }), AbTasty_jsx("script", {
    key: "abtasty-inline-script"
    /* eslint-disable-next-line react/no-danger */
    ,
    dangerouslySetInnerHTML: {
      __html: "\n              document.addEventListener('cm_app_mounting', function () {\n                if (window.ABTasty && window.ABTasty.rollbackModifications) {\n                  window.ABTasty.rollbackModifications();\n                }\n              });\n              document.addEventListener('cm_app_mounted', function () {\n                if (window.ABTasty && window.ABTasty.applyModifications) {\n                  window.ABTasty.applyModifications();\n                }\n              });\n            "
    }
  })) : null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/ContentSquare.jsx
var ContentSquare_jsx = react_default.a.createElement;







var ContentSquare_ContentSquare = function ContentSquare() {
  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      queryParams = _useRouter.location.queryParams;

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var config = Object(thirdParty_utils["a" /* getConfigWithNoThirdPartySupport */])({
    name: 'tracking',
    locale: appContext.locale,
    queryParams: queryParams
  });

  if (!Object(contextUtils["f" /* isStrictlyProductionEnv */])(config_default.a) && !Object(contextUtils["h" /* isStrictlyTestEnv */])(config_default.a) && !Object(sellerUtils["f" /* isSeller */])(appContext) && config.enabled && config.contentsquare.devId) {
    return ContentSquare_jsx("script", {
      defer: true,
      src: "//t.contentsquare.net/uxa/".concat(config.contentsquare.devId, ".js"),
      type: "text/javascript",
      charSet: "utf-8"
    });
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/Freespee.jsx
var Freespee_jsx = react_default.a.createElement;





var Freespee_Freespee = function Freespee() {
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var accountId = config_default.a.get('freespee.accountId');

  if (!Object(contextUtils["f" /* isStrictlyProductionEnv */])(config_default.a) && !Object(sellerUtils["f" /* isSeller */])(appContext) && accountId) {
    return Freespee_jsx(react["Fragment"], null, Freespee_jsx("script", {
      async: true,
      type: "text/javascript",
      src: "//analytics.freespee.com/js/external/fs.js"
    }), Freespee_jsx("script", {
      dangerouslySetInnerHTML: {
        __html: "\n              var __fs_conf = __fs_conf || [];\n              __fs_conf.push(['setAdv',{'id': '".concat(accountId, "' }]);\n          ")
      }
    }));
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/Hosting.jsx
var Hosting_jsx = react_default.a.createElement;


var Hosting_Hosting = function Hosting() {
  var hosting = config_default.a.get('hosting');

  if (hosting.pixel.enabled) {
    return Hosting_jsx("img", {
      src: "https://s3.cn-north-1.amazonaws.com.cn/nscn/pixel.png",
      alt: "",
      width: "1",
      height: "1"
    });
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/Jivochat.jsx
var Jivochat_jsx = react_default.a.createElement;





var Jivochat_Jivochat = function Jivochat() {
  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      queryParams = _useRouter.location.queryParams;

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var jivochat = Object(thirdParty_utils["a" /* getConfigWithNoThirdPartySupport */])({
    name: 'jivochat',
    locale: appContext.locale,
    queryParams: queryParams
  });

  if (!Object(sellerUtils["f" /* isSeller */])(appContext) && jivochat.enabled && jivochat.id) {
    return Jivochat_jsx("script", {
      async: true,
      type: "text/javascript",
      src: "//code.jivosite.com/script/widget/".concat(jivochat.id)
    });
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/ThirdPartyScripts.jsx
var ThirdPartyScripts_jsx = react_default.a.createElement;






var ThirdPartyScripts_ThirdPartyScripts = function ThirdPartyScripts() {
  return ThirdPartyScripts_jsx(react["Fragment"], null, ThirdPartyScripts_jsx(Jivochat_Jivochat, null), ThirdPartyScripts_jsx(ContentSquare_ContentSquare, null), ThirdPartyScripts_jsx(Hosting_Hosting, null), ThirdPartyScripts_jsx(AbTasty_AbTasty, null), ThirdPartyScripts_jsx(Freespee_Freespee, null));
};
// CONCATENATED MODULE: ./src/client/components/utils/easy-testing/index.jsx
var easy_testing_jsx = react_default.a.createElement;

/* eslint-disable jsx-a11y/no-onchange */

/* eslint-env browser */




var easy_testing_EasyTesting = function EasyTesting() {
  var _useState = Object(react["useState"])('ltr'),
      currentDirection = _useState[0],
      setCurrentDirection = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isVisible = _useState2[0],
      setIsVisible = _useState2[1];

  var responsive = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]);

  var handleDirectionChange = function handleDirectionChange(event) {
    var newDirection = event.target.value;
    setCurrentDirection(newDirection); // $FlowFixMe

    var docEl = document.documentElement;
    docEl.classList.remove('ltr', 'rtl');
    docEl.classList.add(newDirection);
    docEl.dir = newDirection; // $FlowFixMe

    document.body.dir = newDirection;
  };

  var handleVisibilityChange = function handleVisibilityChange() {
    setIsVisible(!isVisible);
  }; // don't render on server and initial boot. Fixes some weird SSR problems


  if (!Object(contextUtils["d" /* isStrictlyDevelopmentEnv */])(config_default.a) || !responsive.isAppMounted) {
    return null;
  }

  var easyTestingStyle = {
    position: 'fixed',
    zIndex: 300,
    top: '210px',
    left: '10px',
    transform: 'rotateZ(-90deg)',
    WebkitTransform: 'rotateZ(-90deg)',
    transformOrigin: 'top left',
    WebkitTransformOrigin: 'top left',
    width: isVisible ? 'auto' : '25px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    direction: 'ltr'
  };
  var directionStyle = {
    margin: '0 3px',
    borderWidth: '3px',
    borderStyle: 'solid',
    borderColor: currentDirection === 'ltr' ? 'green' : 'red',
    width: '80px',
    verticalAlign: 'middle',
    outline: 0
  };
  var visibilityStyle = {
    border: 0,
    padding: 0,
    margin: '0 3px 0',
    verticalAlign: 'middle',
    background: 'transparent',
    outline: 0
  };
  var switchVisibilityStyle = {
    fontSize: 0,
    display: 'block',
    border: '2px solid rgba(0, 0, 0, 0.4)',
    width: '20px',
    height: '20px',
    backgroundColor: isVisible ? 'red' : 'yellow',
    borderRadius: '10px',
    transition: 'background-color ease-out 0.7s'
  };
  return easy_testing_jsx("div", {
    className: "easyTesting",
    style: easyTestingStyle
  }, easy_testing_jsx("button", {
    onClick: handleVisibilityChange,
    style: visibilityStyle,
    type: "button"
  }, easy_testing_jsx("span", {
    style: switchVisibilityStyle
  }, "x")), easy_testing_jsx("label", {
    className: "a11y",
    htmlFor: "switchRTL"
  }, "Switch"), easy_testing_jsx("select", {
    id: "switchRTL",
    onChange: handleDirectionChange,
    style: directionStyle,
    value: currentDirection
  }, easy_testing_jsx("option", {
    value: "ltr"
  }, "L\u2192R"), easy_testing_jsx("option", {
    value: "rtl"
  }, "R\u2192L")));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/label/SpinnerLabel.jsx
var SpinnerLabel = __webpack_require__("4SQ0");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/utils/layers/stopScroll.js
var stopScroll = __webpack_require__("qVkC");

// EXTERNAL MODULE: ./src/hooks/use-previous/usePrevious.js
var usePrevious = __webpack_require__("AbLU");

// EXTERNAL MODULE: /home/circleci/project/node_modules/reselect/lib/index.js
var reselect_lib = __webpack_require__("hqKg");

// CONCATENATED MODULE: ./src/client/store/global-loader/storeHelper.js


var globalLoaderSelector = function globalLoaderSelector(_ref) {
  var globalLoader = _ref.globalLoader;
  return globalLoader || {};
};

var getShouldDisplayGlobalLoader = Object(reselect_lib["createSelector"])(globalLoaderSelector, function (_ref2) {
  var shouldDisplay = _ref2.shouldDisplay;
  return shouldDisplay;
});
var getGlobalLoaderLabel = Object(reselect_lib["createSelector"])(globalLoaderSelector, function (_ref3) {
  var label = _ref3.label;
  return label;
});
var getIsNavigation = Object(reselect_lib["createSelector"])(globalLoaderSelector, function (_ref4) {
  var isNavigation = _ref4.isNavigation;
  return isNavigation;
});

// CONCATENATED MODULE: ./src/client/components/widgets/loading/Loading.jsx
var Loading_jsx = react_default.a.createElement;











var Loading_Loading = function Loading() {
  var _useContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isAppMounted = _useContext.isAppMounted;

  var shouldDisplay = Object(es["e" /* useSelector */])(getShouldDisplayGlobalLoader);
  var isNavigation = Object(es["e" /* useSelector */])(getIsNavigation);
  var isPreviousNavigation = Object(usePrevious["a" /* usePrevious */])(isNavigation);
  var previousShouldDisplay = Object(usePrevious["a" /* usePrevious */])(shouldDisplay);
  var label = Object(es["e" /* useSelector */])(getGlobalLoaderLabel);

  var _useState = Object(react["useState"])(0),
      bodyScrollTop = _useState[0],
      setBodyScrollTop = _useState[1];

  Object(react["useEffect"])(function () {
    if (shouldDisplay) {
      setBodyScrollTop(Object(stopScroll["a" /* getTopScrollValue */])(document));
      Object(stopScroll["b" /* lockBodyScroll */])(document);
    } else if (previousShouldDisplay) {
      // prevent removing the body locker when hydrate from server (there is no previousShouldDisplay)
      if (isPreviousNavigation) {
        // in case of navigation to another page we do not have to scroll to the last position
        Object(stopScroll["c" /* resumeBodyScroll */])(document, 0);
      } else {
        Object(stopScroll["c" /* resumeBodyScroll */])(document, bodyScrollTop);
      }

      setBodyScrollTop(0);
    }
  }, [shouldDisplay]);

  if (!isAppMounted || !shouldDisplay) {
    return null;
  }

  return Loading_jsx(Portal["a" /* default */], {
    name: Portal_constants["d" /* OVER_BOT */]
  }, Loading_jsx("div", {
    id: "loading",
    className: "fixed flex flex-col items-center justify-center bg-overlay-white-90 inset-0 z-4"
  }, Loading_jsx(Spinner["a" /* Spinner */], {
    iconName: icons["a" /* ICONS */].TRIDENT1
  }), Loading_jsx(SpinnerLabel["a" /* SpinnerLabel */], {
    label: label
  })));
};
// EXTERNAL MODULE: /home/circleci/project/node_modules/detect-browser/index.js
var detect_browser = __webpack_require__("1ih8");

// EXTERNAL MODULE: ./src/client/views/account/pre-payment/PrePayment.helpers.js
var PrePayment_helpers = __webpack_require__("XHSI");

// EXTERNAL MODULE: ./src/hooks/use-script-loader/useScriptLoader.js
var useScriptLoader = __webpack_require__("/WwO");

// CONCATENATED MODULE: ./src/client/chatbot/Chatbot.tracking.js


function Chatbot_tracking_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function Chatbot_tracking_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      Chatbot_tracking_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      Chatbot_tracking_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var CHATBOT_EVENTS = {
  INITIALIZED: 'chatbot-initialized',
  CLICKED_OPEN: 'chatbot-opened',
  CLICKED_CLOSE: 'chatbot-closed'
};
var Chatbot_tracking_trackChatbotEvent = function trackChatbotEvent(chatbotEventType, appContext, pageContext, location) {
  var pageId = pageContext.pageId;
  return Object(tracking_api["b" /* setDataLayer */])(Chatbot_tracking_objectSpread(Chatbot_tracking_objectSpread({}, constants["i" /* GA_DEFAULT_PAYLOAD */]), {}, {
    categoryGA: 'chatbot',
    actionGA: chatbotEventType,
    labelGA: pageId || location.origin || 'unknown-context'
  }), appContext, pageId);
};
// EXTERNAL MODULE: /home/circleci/project/node_modules/axios/index.js
var axios = __webpack_require__("ggb3");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./src/utils/invariant/invariant.js
var invariant = __webpack_require__("UQkB");

// CONCATENATED MODULE: ./src/client/chatbot/Chatbot.utils.js








var CHATBOT_AVATAR_PATH = '/medias/gentil-bot.svg';
var CHATBOT_LOCAL_STORAGE_KEY = 'BOTFUEL_WEBCHAT_USER_ID';

var _config$get = config_default.a.get('botfuel'),
    appToken = _config$get.appToken,
    apiUrl = _config$get.apiUrl; // localStorage API compatible with Botfuel webchat. For the Chatbot only.


function setInLocalStorage(key, value) {
  if (Object(local_storage_api["b" /* localStorageAvailable */])()) {
    localStorage.setItem(key, value);
  }
}

function getFromLocalStorage(key) {
  if (Object(local_storage_api["b" /* localStorageAvailable */])()) {
    return localStorage.getItem(key);
  }
}

function setUserId(googleTrackingId) {
  return new Promise(function (resolve) {
    if (googleTrackingId) {
      resolve(googleTrackingId);
    } else {
      var resolveTimestampedId = function resolveTimestampedId() {
        return resolve("NO.ID.".concat(Date.now()));
      };

      var requestAnimationFrame = dist["windowWrapper"].get('requestAnimationFrame');
      if (!requestAnimationFrame) return resolveTimestampedId();
      var start = null;

      var getGaId = function getGaId(timestamp) {
        if (!start) start = timestamp;
        var progress = timestamp - start;
        var gaId = js_cookie_default.a.get('_ga');

        if (gaId) {
          resolve(gaId);
        } else if (progress < 3000) {
          // Try fetching the _ga cookie at next repaint during 3s max.
          // This delays the chatbot initialization but ensures
          // more users are properly identified by their GA ID.
          requestAnimationFrame(getGaId);
        } else {
          // Or use a timestamp ID
          resolveTimestampedId();
        }
      };

      requestAnimationFrame(getGaId);
    }
  }).then(function (userId) {
    setInLocalStorage(CHATBOT_LOCAL_STORAGE_KEY, userId);
    return true;
  });
}

function sendAppContext(_ref) {
  var pageContext = _ref.pageContext,
      deviceCategory = _ref.deviceCategory,
      location = _ref.location;
  var origin = location.origin;
  var pageId = pageContext.pageId,
      pageType = pageContext.pageType,
      pageMeta = pageContext.pageMeta,
      pageTitle = pageContext.pageTitle,
      pageDescription = pageContext.pageDescription;
  var user = getFromLocalStorage(CHATBOT_LOCAL_STORAGE_KEY);
  axios_default.a.post(apiUrl, {
    user: user,
    deviceCategory: deviceCategory,
    pageId: pageId,
    pageType: pageType,
    pageMeta: pageMeta,
    pageTitle: pageTitle,
    pageDescription: pageDescription,
    origin: origin
  }, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  });
}

function createChatbot() {
  var botConfig = {
    appToken: appToken,
    // extraAllowedOrigins: ['http://localhost:3000'],
    startOpen: false,
    startFullScreen: false,
    size: {
      width: 400,
      height: 600
    },
    labels: {
      sendButtonLabel: 'Envoyer',
      messageInputPlaceholder: 'Ecrivez votre message ici',
      webchatHeaderTitle: 'GentilBot ClubMed',
      helpMessage: 'Les services et activités de nos destinations 😀'
    },
    theme: {
      layout: {
        rounded: 0
      },
      buttons: {
        close: true,
        fullScreen: true
      },
      images: {
        botAvatar: "".concat(dist["windowWrapper"].getOrigin()).concat(CHATBOT_AVATAR_PATH),
        startButton: "".concat(dist["windowWrapper"].getOrigin()).concat(CHATBOT_AVATAR_PATH)
      },
      startButtonStyle: 'bubble',
      dialogStyle: 'hover',
      fixed: true
    },
    menuActions: [{
      label: "Demander de l'aide",
      message: {
        type: 'text',
        payload: {
          value: 'Aide'
        }
      }
    }, {
      label: 'Commencer une nouvelle conversation',
      message: {
        type: 'text',
        payload: {
          value: 'Recommencer'
        }
      }
    }],
    parseHTML: true,
    sanitizeDOM: false,
    voiceEnabled: false
  };
  var botfuelWebChat = dist["windowWrapper"].get('BotfuelWebChat');

  if (botfuelWebChat) {
    botfuelWebChat.init(botConfig);
  }

  return !!botfuelWebChat;
}
var Chatbot_utils_createFreespeeObserver = function createFreespeeObserver() {
  return new MutationObserver(function (mutations) {
    var chatbotMessageMutations = mutations.filter(function (mutation) {
      var addedNodes = mutation.addedNodes; // $FlowFixMe stupid typings

      return !Object(lodash["isEmpty"])(addedNodes) && Object.values(Object(lodash["last"])(addedNodes).classList).includes('bf-bot');
    }); // If there are between 1 and 3 new chatbot messages (excludes mutations from past conversation)

    if (!Object(lodash["isEmpty"])(chatbotMessageMutations) && chatbotMessageMutations.length < 3) {
      var _last = Object(lodash["last"])(chatbotMessageMutations),
          chatbotMessageNodes = _last.addedNodes; // $FlowFixMe stupid typings


      var chatbotMessageNode = Object(lodash["last"])(chatbotMessageNodes);

      if (chatbotMessageNode.innerHTML.includes('<span class="freespee-schedule-call">')) {
        var scheduleCallNode = document.getElementById('scheduleCall');
        scheduleCallNode && scheduleCallNode.click();
      }
    }
  });
};
var createBotFuelObserver = function createBotFuelObserver(callback) {
  var targetNode = document.querySelector('body');
  var observerOptions = {
    childList: true,
    attributes: false,
    subtree: true
  };
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      // ChatbotFuel really initialized
      if (mutation.type === 'childList' && mutation.target.id === 'botfuel') {
        callback();
      }
    });
  });
  observer.observe(targetNode, observerOptions);
  setTimeout(function () {
    observer.disconnect();
  }, 5000);
};

function observeFreespee(freespeeObserver) {
  var observedNode = document.querySelector('.bf-message-list');
  freespeeObserver.observe(observedNode, {
    attributes: false,
    characterData: false,
    childList: true,
    subtree: false
  });
}

function disconnectFreespee(freespeeObserver) {
  freespeeObserver.disconnect();
} // We send the pageId when the user clicks/sends a message. This means that we need recreate the
// event listeners whenever the page url changes


var Chatbot_utils_setUpClickListeners = function setUpClickListeners(_ref2) {
  var sendAppContextCell = _ref2.sendAppContextCell,
      observerCell = _ref2.observerCell,
      trackingCell = _ref2.trackingCell,
      appContext = _ref2.appContext,
      pageContext = _ref2.pageContext,
      deviceCategory = _ref2.deviceCategory,
      location = _ref2.location;
  var startButton = document.querySelector('.bf-webchat-start-button');
  var closeButton = document.querySelector('.bf-webchat-close-button');

  if (startButton && closeButton) {
    // If listeners already exists (from a previous page), recreate them
    if (sendAppContextCell.current) {
      startButton.removeEventListener('click', sendAppContextCell.current);
    }

    if (trackingCell.open) {
      startButton.removeEventListener('click', trackingCell.open);
    }

    if (trackingCell.close) {
      closeButton.removeEventListener('click', trackingCell.close);
    } // Setup appContext click listeners


    var send = function send() {
      return sendAppContext({
        pageContext: pageContext,
        deviceCategory: deviceCategory,
        location: location
      });
    };

    startButton.addEventListener('click', send);
    sendAppContextCell.current = send; // Setup Freespee observer click listeners

    var observer = observerCell.current;
    Object(invariant["a" /* invariant */])(observer, 'The MutationObserver should always be defined');
    startButton.addEventListener('click', function () {
      return observeFreespee(observer);
    });
    closeButton.addEventListener('click', function () {
      return disconnectFreespee(observer);
    }); // Setup Chatbot Tracking click listeners

    var trackOpen = function trackOpen() {
      return Chatbot_tracking_trackChatbotEvent(CHATBOT_EVENTS.CLICKED_OPEN, appContext, pageContext, location);
    };

    startButton.addEventListener('click', trackOpen);
    trackingCell.open = trackOpen;

    var trackClose = function trackClose() {
      return Chatbot_tracking_trackChatbotEvent(CHATBOT_EVENTS.CLICKED_CLOSE, appContext, pageContext, location);
    };

    closeButton.addEventListener('click', trackClose);
    trackingCell.close = trackClose;
    var startButtonChid = startButton && startButton.firstChild;
    startButtonChid && startButtonChid.click();
  }
};
// CONCATENATED MODULE: ./src/client/chatbot/Chatbot.jsx











var Chatbot_config$get = config_default.a.get('botfuel'),
    scriptUrl = Chatbot_config$get.scriptUrl;

var Chatbot_observerCell = {
  current: null
};
var Chatbot_sendAppContextCell = {
  current: null
};
var Chatbot_trackingCell = {
  open: null,
  close: null
};
var Chatbot_Chatbot = function Chatbot(_ref) {
  var setShowFakeBtn = _ref.setShowFakeBtn;

  var _useScriptLoader = Object(useScriptLoader["a" /* useScriptLoader */])(scriptUrl),
      scriptsLoadedSuccessfully = _useScriptLoader.scriptLoaded;

  var pageContext = react["useContext"](context_pageContext["a" /* ReactPageContext */]);
  var appContext = react["useContext"](ReactAppContext["a" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var responsiveContext = react["useContext"](responsive_responsiveContext["a" /* default */]);
  var deviceCategory = Object(PrePayment_helpers["c" /* getDevice */])(responsiveContext).toLowerCase();
  react["useEffect"](function () {
    if (!scriptsLoadedSuccessfully) return; // create the chatbot & the MutationObserver only once

    Chatbot_observerCell.current = Chatbot_utils_createFreespeeObserver();
    setUserId(appContext.googleTrackingId).then(function () {
      // create the BotFuelObserver to track the DOM insersion of the real chatbot
      createBotFuelObserver(function () {
        Chatbot_tracking_trackChatbotEvent(CHATBOT_EVENTS.INITIALIZED, appContext, pageContext, location);
        Chatbot_utils_setUpClickListeners({
          observerCell: Chatbot_observerCell,
          sendAppContextCell: Chatbot_sendAppContextCell,
          trackingCell: Chatbot_trackingCell,
          appContext: appContext,
          pageContext: pageContext,
          deviceCategory: deviceCategory,
          location: location
        });
        setShowFakeBtn(false);
      });
      createChatbot();
    });
  }, [pageContext.pageId, deviceCategory, scriptsLoadedSuccessfully]);
  return null;
};
// CONCATENATED MODULE: ./src/client/chatbot/ChatbotContainer.jsx
var ChatbotContainer_jsx = react_default.a.createElement;






var ChatbotContainer_CHATBOT_AVATAR_PATH = '/medias/gentil-bot.svg';

var ChatbotContainer_config$get = config_default.a.get('botfuel'),
    chatbotEnabled = ChatbotContainer_config$get.enabled,
    chatbotPages = ChatbotContainer_config$get.enabledPages;

var chatBotStyle = {
  backgroundImage: "url(\"".concat(ChatbotContainer_CHATBOT_AVATAR_PATH, "\")"),
  bottom: '20px',
  boxShadow: '0 2px 5px 0 rgba(0,0,0,.25)',
  cursor: 'pointer',
  height: '65px',
  right: '20px',
  width: '65px',
  zIndex: '6'
};

function isCompatibleWithChatbot() {
  var browser = Object(detect_browser["detect"])();
  return browser.name !== 'ie' && browser.name !== 'edge';
}

var ChatbotContainer_ChatbotContainer = function ChatbotContainer() {
  var _useState = Object(react["useState"])(false),
      loadChatbot = _useState[0],
      setLoadChatbot = _useState[1];

  var _useState2 = Object(react["useState"])(true),
      showFakeChatbotBtn = _useState2[0],
      setShowFakeChatbotBtn = _useState2[1];

  var responsiveContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]);
  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);

  if (!responsiveContext.isAppMounted || !isCompatibleWithChatbot()) {
    return null;
  } // Livechat Dydu "do you dream up" could be inecjected by GTM


  var activeOnThisPage = chatbotPages.split(',').includes(pageContext.pageType);
  var isDyduLivechatActive = document.getElementById('dydu-popin') || document.getElementById('dydu-teaser');
  var chatbotDiv = document.getElementById('botfuel');

  if (chatbotEnabled && activeOnThisPage && !isDyduLivechatActive) {
    if (chatbotDiv) {
      chatbotDiv.style && (chatbotDiv.style.display = 'block');
      return null;
    }

    return ChatbotContainer_jsx(react["Fragment"], null, loadChatbot && ChatbotContainer_jsx(Chatbot_Chatbot, {
      setShowFakeBtn: setShowFakeChatbotBtn
    }), showFakeChatbotBtn && ChatbotContainer_jsx("div", {
      className: "rounded-full fixed",
      style: chatBotStyle,
      "data-testid": "chatbot-button",
      onClick: function onClick() {
        return setLoadChatbot(true);
      }
    }));
  }

  chatbotDiv && chatbotDiv.style && (chatbotDiv.style.display = 'none');
  return null;
};
// EXTERNAL MODULE: ./src/client/context/ErrorBoundary.jsx
var ErrorBoundary = __webpack_require__("oG87");

// EXTERNAL MODULE: ./src/client/tracking/tracking-pageload/TrackingPageLoad.jsx + 2 modules
var TrackingPageLoad = __webpack_require__("TVUe");

// EXTERNAL MODULE: ./src/client/components/widgets/hero/Hero.jsx
var Hero = __webpack_require__("2B1m");

// CONCATENATED MODULE: ./src/client/views/errors/not-found/NotFoundView.jsx


var NotFoundView_jsx = react_default.a.createElement;








var NotFoundView_getInitialProps = /*#__PURE__*/function () {
  var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref) {
    var appContext, query;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            appContext = _ref.appContext;
            query = "query {\n      config {\n        errors { notFound { image title } }\n        common { goToHome }\n      }\n    }";
            return _context.abrupt("return", graphqlClient["a" /* default */].runQuery(query, appContext, {
              requestName: requestDictionary["Nc" /* PAGE_404 */]
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getInitialProps(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var NotFoundView_NotFoundView = function NotFoundView(_ref3) {
  var _config$errors, _config$errors$notFou, _config$errors2, _config$errors2$notFo, _config$common;

  var config = _ref3.config;
  return NotFoundView_jsx(react_default.a.Fragment, null, NotFoundView_jsx(TrackingPageLoad["a" /* TrackingPageLoad */], {
    pageName: "Shopping_NotFound",
    siteSection: "Shopping_NotFound"
  }), NotFoundView_jsx("div", {
    className: "NotFoundView"
  }, NotFoundView_jsx(Hero["a" /* Hero */], {
    size: "total",
    url: config === null || config === void 0 ? void 0 : (_config$errors = config.errors) === null || _config$errors === void 0 ? void 0 : (_config$errors$notFou = _config$errors.notFound) === null || _config$errors$notFou === void 0 ? void 0 : _config$errors$notFou.image
  }), NotFoundView_jsx("div", {
    className: "NotFoundView-inner"
  }, NotFoundView_jsx(SiteContainer["a" /* SiteContainer */], {
    size: "mini"
  }, NotFoundView_jsx("h1", {
    className: "NotFoundView-title font-brand"
  }, config === null || config === void 0 ? void 0 : (_config$errors2 = config.errors) === null || _config$errors2 === void 0 ? void 0 : (_config$errors2$notFo = _config$errors2.notFound) === null || _config$errors2$notFo === void 0 ? void 0 : _config$errors2$notFo.title), NotFoundView_jsx(TextLink["a" /* TextLink */], {
    url: "/",
    label: config === null || config === void 0 ? void 0 : (_config$common = config.common) === null || _config$common === void 0 ? void 0 : _config$common.goToHome,
    theme: "solid"
  })))));
};

NotFoundView_NotFoundView.getInitialProps = NotFoundView_getInitialProps;
/* harmony default export */ var not_found_NotFoundView = (NotFoundView_NotFoundView);
// CONCATENATED MODULE: ./src/seo/canonical/index.js


function canonical_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function canonical_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      canonical_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      canonical_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var canonical_locale = dist["appQueryParameters"].locale;
var ALLOWED_QUERY_PARAMETERS = [canonical_locale];

function isAllowedQueryParameter(queryParameter) {
  return Object(lodash["includes"])(ALLOWED_QUERY_PARAMETERS, queryParameter);
}

function getCanonicalQueryParameters(queryParams) {
  return Object.keys(queryParams).filter(isAllowedQueryParameter).reduce(function (filteredQueryParams, queryParamName) {
    return canonical_objectSpread(canonical_objectSpread({}, filteredQueryParams), {}, Object(defineProperty["a" /* default */])({}, queryParamName, queryParams[queryParamName]));
  }, {});
}

function getCanonicalUrl(url) {
  var uri = URI_default()(url);
  var uriQueryParameters = URI_default.a.parseQuery(uri.query());
  var segments = uri.segmentCoded();
  return uri.segment(segments).query(getCanonicalQueryParameters(uriQueryParameters)).hash('').toString();
}

/* harmony default export */ var canonical = ({
  getCanonicalUrl: getCanonicalUrl
});
// CONCATENATED MODULE: ./src/client/components/layouts/head-info/HeadInfos.jsx
var HeadInfos_jsx = react_default.a.createElement;






var HeadInfos_HeadInfos = function HeadInfos() {
  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]); // It should be ProductQueryParams, it's in another PR not merged yet

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  return HeadInfos_jsx(react["Fragment"], null, HeadInfos_jsx(head_default.a, null, HeadInfos_jsx("meta", {
    name: "description",
    content: pageContext.pageDescription || ''
  }), HeadInfos_jsx("link", {
    rel: "canonical",
    href: canonical.getCanonicalUrl(Object(uriUtils["c" /* convertLocationToURI */])(location).toString())
  }), (pageContext.hrefLang || []).filter(function (hrefLang) {
    return hrefLang.url && hrefLang.locale;
  }).map(function (_ref) {
    var locale = _ref.locale,
        url = _ref.url;
    return HeadInfos_jsx("link", {
      key: "".concat(locale, "_").concat(url),
      rel: "alternate",
      hrefLang: locale,
      href: url
    });
  })));
};
// EXTERNAL MODULE: ./src/client/store/user-info/userInfo.selectors.js
var userInfo_selectors = __webpack_require__("apzf");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-collapse/lib/index.js
var react_collapse_lib = __webpack_require__("3OwS");

// CONCATENATED MODULE: ./src/client/components/widgets/three-sixty/ThreeSixty.jsx
var ThreeSixty_jsx = react_default.a.createElement;





var ThreeSixty_ThreeSixty = function ThreeSixty(_ref) {
  var clientName = _ref.clientName,
      lastVisitsLabel = _ref.lastVisitsLabel,
      lastVisits = _ref.lastVisits;

  var _useState = Object(react["useState"])(false),
      isOpened = _useState[0],
      toggleThreeSixty = _useState[1];

  return ThreeSixty_jsx("div", {
    className: classnames_default()('ThreeSixty', {
      open: isOpened
    })
  }, ThreeSixty_jsx("div", {
    className: classnames_default()('ThreeSixty-content', {
      open: isOpened
    }),
    onClick: function onClick() {
      return toggleThreeSixty(!isOpened);
    }
  }, ThreeSixty_jsx("div", {
    className: "ThreeSixty-header"
  }, ThreeSixty_jsx("svg", {
    className: "ThreeSixty-cxoLogo",
    width: "130px",
    height: "60px",
    viewBox: "0 0 130 60",
    version: "1.1"
  }, ThreeSixty_jsx("defs", null, ThreeSixty_jsx("linearGradient", {
    x1: "44.7159195%",
    y1: "50%",
    x2: "75.035875%",
    y2: "50%",
    id: "linearGradient-1"
  }, ThreeSixty_jsx("stop", {
    stopColor: "#235472",
    offset: "0%"
  }), ThreeSixty_jsx("stop", {
    stopColor: "#A6DADE",
    offset: "100%"
  }))), ThreeSixty_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, ThreeSixty_jsx("g", {
    id: "10-B2B/Desktop/01-1_CXO",
    transform: "translate(0.000000, -403.000000)"
  }, ThreeSixty_jsx("g", {
    id: "Group-2",
    transform: "translate(0.000000, 403.160714)"
  }, ThreeSixty_jsx("path", {
    d: "M71.2064596,29.6873674 L85.6177833,42.8646077 C90.4453086,46.8799323 94.6046143,49.5481129 100.552511,49.5481129 C111.547972,49.5481129 120.461554,40.7137316 120.461554,29.81597 C120.461554,18.9182085 111.547972,10.0838272 100.552511,10.0838272 C94.4637587,10.0838272 89.1245616,12.6929064 85.219571,16.8145493 L71.2064596,29.6873674 Z M64.84932,23.3302278 L77.7054691,11.0848976 C84.1408993,4.71799111 91.2565906,0.502982484 100.390844,0.502982484 C116.691308,0.502982484 129.905444,13.7171187 129.905444,30.0175819 C129.905444,46.318045 116.691308,58.2393852 100.390844,58.2393852 C90.5625021,58.2393852 85.6177833,56.1114281 76.0119282,47.4843048 L64.3463874,36.5474396 L55.5310792,45.6122108 L48.7298497,38.8109814 L57.5340046,29.7350568 L47.9798065,20.32894 L54.9139193,13.3948271 L64.84932,23.3302278 Z M49.9291515,8.41005929 L42.9950386,15.3441722 C39.4697613,12.110536 34.7699391,10.0838272 29.6091556,10.0838272 C18.66937,10.0838272 9.80092149,19.0053746 9.80092149,29.9451602 C9.80092149,40.8849458 18.66937,48.7579875 29.6091556,48.7579875 C34.7678471,48.7579875 39.4659509,47.7813842 42.990751,44.5500801 L49.7919804,51.3513095 C44.5137473,56.3000378 37.4153607,59.3305694 29.6091556,59.3305694 C13.3086924,59.3305694 0.0945561695,46.1164332 0.0945561695,29.81597 C0.0945561695,13.5155069 13.3086924,0.301370651 29.6091556,0.301370651 C37.483187,0.301370651 44.6370464,3.38479421 49.9291515,8.41005929 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)"
  }), ThreeSixty_jsx("path", {
    d: "M104.611739,34.6884892 L102.092025,37.2082036 L104.611739,39.7279181 L107.131453,37.2082036 L104.611739,34.6884892 Z M106.214867,18.7758278 C106.099844,18.2043091 104.726762,19.005873 101.750551,21.6370156 C102.893589,22.8950756 103.468702,22.2085343 104.496716,21.8670609 C105.29828,23.2401435 105.528326,29.764083 100.607514,31.7122788 C100.722537,25.1883392 100.837559,18.2043091 100.837559,18.2043091 C100.722537,18.0892865 100.607514,18.0892865 100.492491,18.0892865 C99.1194087,18.3193317 96.7147169,20.6090009 94.8815438,22.6686248 C95.9131529,24.3867753 97.1712129,22.7836474 98.2028221,22.4385795 C98.2028221,22.6686248 97.9727768,27.4744139 98.0877995,32.3988201 C93.0519651,32.7402935 93.853529,22.4385795 94.0799798,21.1805196 C94.1950025,20.0374822 90.8737241,22.4385795 89.1591681,23.9266848 C89.7306868,24.8432713 90.4172281,24.7282487 91.3338146,24.3831808 C90.9887468,28.9625191 94.1950025,33.1967896 98.0877995,33.0817669 C98.2028221,37.8911505 98.7743408,42.4668943 100.147423,42.8119622 C100.377469,42.8119622 100.492491,38.0025787 100.603919,32.5102483 C109.651168,29.764083 106.214867,18.7758278 106.214867,18.7758278 Z",
    id: "Shape",
    fill: "#005589",
    fillRule: "nonzero"
  }))))), isOpened ? ThreeSixty_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "16px",
    className: "ThreeSixty-closeIcon"
  }) : null), ThreeSixty_jsx(react_collapse_lib["UnmountClosed"], {
    theme: {
      collapse: 'ThreeSixty-collapse',
      content: 'ThreeSixty-collapseContent'
    },
    isOpened: isOpened
  }, ThreeSixty_jsx("div", {
    className: "ThreeSixty-clientName"
  }, clientName), ThreeSixty_jsx("div", {
    className: "ThreeSixty-lastVisitsLabel"
  }, lastVisitsLabel), ThreeSixty_jsx("div", {
    className: "ThreeSixty-lastVisits"
  }, lastVisits.map(function (lastVisit, index) {
    return ThreeSixty_jsx("div", {
      key: lastVisit.name + index,
      className: "ThreeSixty-lastVisit"
    }, ThreeSixty_jsx("div", null, lastVisit.name), ThreeSixty_jsx("div", {
      className: "whitespace-no-wrap"
    }, ThreeSixty_jsx("span", null, "\xA0-\xA0"), lastVisit.category.join(' / ')));
  })))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/three-sixty/ThreeSixtyContainer.jsx









var ThreeSixtyContainer_jsx = react_default.a.createElement;

function ThreeSixtyContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ThreeSixtyContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ThreeSixtyContainer_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ThreeSixtyContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function ThreeSixtyContainer_createSuper(Derived) { var hasNativeReflectConstruct = ThreeSixtyContainer_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function ThreeSixtyContainer_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }









var ThreeSixtyContainer_ThreeSixtyContainer = /*#__PURE__*/function (_PureComponent) {
  Object(inherits["a" /* default */])(ThreeSixtyContainer, _PureComponent);

  var _super = ThreeSixtyContainer_createSuper(ThreeSixtyContainer);

  function ThreeSixtyContainer(props, context) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ThreeSixtyContainer);

    _this = _super.call(this, props, context);

    var _URI$search = new URI_default.a(dist["windowWrapper"].getLocation() || '').search(true),
        cxoMainContactId = _URI$search.cxo_primarycontact,
        _URI$search$cxo_villa = _URI$search.cxo_village,
        cxoLastResorts = _URI$search$cxo_villa === void 0 ? [] : _URI$search$cxo_villa; // when there is always one village it's not an array so we need to force it


    var arrayCxoLastResorts = Array.prototype.concat(cxoLastResorts);
    _this.cxoMainContactId = cxoMainContactId;
    _this.state = {
      i18n: null,
      cxoMainContact: null,
      cxoLastResorts: arrayCxoLastResorts.map(function (resort) {
        var _resort$split = resort.split(' '),
            _resort$split2 = Object(slicedToArray["a" /* default */])(_resort$split, 2),
            resortId = _resort$split2[0],
            roomCategories = _resort$split2[1];

        return {
          id: resortId,
          name: resortId,
          category: roomCategories.split(',')
        };
      }),
      shouldRender: Object(sellerUtils["f" /* isSeller */])(context) && cxoMainContactId && cxoLastResorts.length > 0
    };
    return _this;
  }

  Object(createClass["a" /* default */])(ThreeSixtyContainer, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _yield$graphQLClient$, resorts, config, profile;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.state.shouldRender) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return graphqlClient["a" /* default */].runNoCacheQuery("{\n        resorts(resortIds: [\"".concat(this.state.cxoLastResorts.map(function (_ref) {
                  var id = _ref.id;
                  return id;
                }).join('","'), "\"]) {\n          id\n          name\n        }\n        config {\n          booking {\n            cxo {\n              v360 {\n                resortsAndRooms\n              }\n            }\n          }\n        }\n        profile(userId: \"").concat(this.cxoMainContactId, "\", throw401Error: true) {\n          firstName\n          lastName\n        }\n    }"), this.context);

              case 5:
                _yield$graphQLClient$ = _context.sent;
                resorts = _yield$graphQLClient$.resorts;
                config = _yield$graphQLClient$.config;
                profile = _yield$graphQLClient$.profile;
                this.setState({
                  i18n: config,
                  cxoMainContact: "".concat(profile.firstName, " ").concat(profile.lastName),
                  cxoLastResorts: this.state.cxoLastResorts.map(function (resort) {
                    return ThreeSixtyContainer_objectSpread(ThreeSixtyContainer_objectSpread({}, resort), {}, {
                      name: Object(lodash["get"])(resorts.find(function (_ref2) {
                        var id = _ref2.id;
                        return id === resort.id;
                      }), 'name', resort.id)
                    });
                  }),
                  shouldRender: true
                });
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](2);
                Object(sellerUtils["e" /* handle401GraphqlErrorSeller */])(_context.t0, this.context);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 12]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      if (!this.state.shouldRender || !this.state.cxoMainContact) {
        return null;
      }

      return ThreeSixtyContainer_jsx(ThreeSixty_ThreeSixty, {
        clientName: this.state.cxoMainContact,
        lastVisitsLabel: Object(lodash["get"])(this.state.i18n, 'booking.cxo.v360.resortsAndRooms') // $FlowFixMe
        ,
        lastVisits: this.state.cxoLastResorts
      });
    }
  }]);

  return ThreeSixtyContainer;
}(react["PureComponent"]);

Object(defineProperty["a" /* default */])(ThreeSixtyContainer_ThreeSixtyContainer, "contextType", ReactAppContext["a" /* default */]);
// EXTERNAL MODULE: ./src/errors/clientErrorHandler.js
var clientErrorHandler = __webpack_require__("aPQG");

// EXTERNAL MODULE: ./src/utils/date/dateUtils.js
var dateUtils = __webpack_require__("L73y");

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// EXTERNAL MODULE: ./src/utils/faceting/kidsValidationStateUtils.js
var kidsValidationStateUtils = __webpack_require__("cGFA");

// EXTERNAL MODULE: ./src/utils/uri/constants.js
var uri_constants = __webpack_require__("Sj1w");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var faceting_constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/constants.js
var adults_constants = __webpack_require__("ORYz");

// EXTERNAL MODULE: ./src/client/store/trip-information/kids/constants.js
var kids_constants = __webpack_require__("wQ38");

// EXTERNAL MODULE: ./src/client/store/calendar/calendar.helper.js
var calendar_helper = __webpack_require__("VtPb");

// CONCATENATED MODULE: ./src/client/store/getInitialReduxState.client.js


function getInitialReduxState_client_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function getInitialReduxState_client_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      getInitialReduxState_client_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      getInitialReduxState_client_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
















var LOCAL_STORAGE_STATE_KEY = 'state';

function stateFromLocalStorage(locale, state) {
  var serializedState = Object(local_storage_api["a" /* getFromLocalStorage */])("".concat(LOCAL_STORAGE_STATE_KEY, "-").concat(locale));
  if (!serializedState) return {};
  var localStorageState = Object(lodash["merge"])(JSON.parse(serializedState), {
    tripInformation: {}
  });
  var _localStorageState$tr = localStorageState.tripInformation.kids,
      kids = _localStorageState$tr === void 0 ? [] : _localStorageState$tr;
  return {
    faceting: getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, state.faceting), {}, {
      kidsValidationState: Object(kidsValidationStateUtils["b" /* getValidationStateFromKids */])(kids)
    }),
    tripInformation: {
      kids: kids.map(function (_ref) {
        var birthdate = _ref.birthdate;
        return getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */]), {}, {
          birthdate: birthdate
        });
      }),
      adults: kids.length > 0 ? Array(adults_constants["a" /* DEFAULT_ADULTS_NB */]).fill(adults_constants["b" /* DEFAULT_ADULT_VALUE */]) : []
    },
    seller: localStorageState.seller
  };
}

function stateFromCookies() {
  var encodedUserInfo = js_cookie_default.a.get(ple_utils_cookies["d" /* USER_INFO */]);
  return {
    userInfo: encodedUserInfo ? dist["oidc"].fromUriEncodedState(encodedUserInfo) : {}
  };
}

function parseCxoKids(cxoKids) {
  return cxoKids.length <= faceting_constants["u" /* KIDS_NUMBER_MAX */] ? cxoKids.map(function (_ref2) {
    var neolid = _ref2.neolid,
        birthdate = _ref2.birthdate;
    return {
      neolid: neolid,
      birthdate: birthdate
    };
  }) : [];
}

function parseCxoAdults(cxoAdults) {
  return cxoAdults.length <= faceting_constants["b" /* ADULTS_NUMBER_MAX */] ? cxoAdults.map(function (_ref3) {
    var neolid = _ref3.neolid,
        birthdate = _ref3.birthdate;
    return getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, adults_constants["b" /* DEFAULT_ADULT_VALUE */]), {}, {
      neolid: neolid,
      birthdate: birthdate
    });
  }) : [{}, {}];
}

function parseAdultsQueryParam(adultQueryParam) {
  var nbAdults = parseInt(adultQueryParam, 10);
  var hasAdults = Object(lodash["isInteger"])(nbAdults) && nbAdults <= faceting_constants["b" /* ADULTS_NUMBER_MAX */];
  return hasAdults ? Array(nbAdults).fill(adults_constants["b" /* DEFAULT_ADULT_VALUE */]) : [];
}

function stateFromQueryParams() {
  // NOTE: getCxoTravelers() and getNeolids() rely on queryparams
  var neolids = Object(sellerUtils["c" /* getNeolids */])();
  var queryParams = Object(uriUtils["h" /* getQueryParameters */])(dist["windowWrapper"].getLocation()) || {};
  var departureDate = queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]];
  var departureDateIsValid = Object(dateUtils["e" /* isYearsRangeValid */])(queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]], uri_constants["e" /* QUERY_DATE_FORMAT */], faceting_constants["l" /* DEPARTURE_DATE_MAX_DATE */]);
  var kids = Object(facetingUtils["h" /* unserializeKidsFromQueryParam */])(queryParams[uri_constants["h" /* QUERY_KIDS */]]);
  var adults = parseAdultsQueryParam(queryParams[uri_constants["j" /* QUERY_NUMBER_OF_ADULTS */]]);
  return {
    calendar: {
      selectedMonth: departureDateIsValid ? Object(calendar_helper["b" /* getDefaultSelectedMonth */])(departureDate) : undefined
    },
    // null states are explicitly omitted further
    faceting: {
      query: {
        label: queryParams[faceting_constants["A" /* QUERY_QUERY_PARAM */]] || ''
      },
      kidsValidationState: Object(kidsValidationStateUtils["b" /* getValidationStateFromKids */])(kids)
    },
    facetingTripInformation: neolids.length > 0 ? null : undefined,
    seller: neolids.length > 0 ? {
      neolids: neolids
    } : undefined,
    tripCriteria: {
      departureDate: departureDateIsValid ? Object(dateUtils["d" /* getTimestamp */])(departureDate, uri_constants["e" /* QUERY_DATE_FORMAT */]) : undefined,
      duration: parseInt(queryParams[uri_constants["g" /* QUERY_DURATION */]], 10) || null,
      departureCity: queryParams[uri_constants["k" /* QUERY_TRANSPORT */]]
    },
    tripInformation: {
      kids: kids,
      adults: kids.length > 0 && adults.length === 0 ? Array(adults_constants["a" /* DEFAULT_ADULTS_NB */]).fill(adults_constants["b" /* DEFAULT_ADULT_VALUE */]) : adults
    }
  };
}

function getSellerTripInformation() {
  // CMTA sellers
  var queryParams = Object(uriUtils["h" /* getQueryParameters */])(dist["windowWrapper"].getLocation()) || {};
  var cmtaQueryParam = queryParams[uri_constants["d" /* QUERY_CMTA */]];

  if (typeof cmtaQueryParam !== 'undefined') {
    var _stateFromQueryParams = stateFromQueryParams(),
        tripInformation = _stateFromQueryParams.tripInformation;

    return tripInformation;
  } // CXO sellers


  var cxoTravelers = Object(sellerUtils["b" /* getCxoTravelers */])() || [];

  if (cxoTravelers.length === 0) {
    return;
  }

  return {
    kids: parseCxoKids(cxoTravelers.filter(function (_ref4) {
      var isChild = _ref4.isChild;
      return isChild;
    })),
    adults: parseCxoAdults(cxoTravelers.filter(function (_ref5) {
      var isChild = _ref5.isChild;
      return !isChild;
    }))
  };
}

function cleanTripInfoKids(state) {
  if (!state.tripInformation) return state;
  var _state$tripInformatio = state.tripInformation.kids,
      kids = _state$tripInformatio === void 0 ? [] : _state$tripInformatio;
  var cleanedKids = kids.map(function (_ref6) {
    var neolid = _ref6.neolid,
        birthdate = _ref6.birthdate,
        _ref6$childcareInclud = _ref6.childcareIncluded,
        childcareIncluded = _ref6$childcareInclud === void 0 ? false : _ref6$childcareInclud;
    return {
      neolid: neolid,
      birthdate: birthdate,
      childcareIncluded: childcareIncluded
    };
  });
  return getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, state), {}, {
    tripInformation: getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, state.tripInformation), {}, {
      kids: cleanedKids
    })
  });
}

function getInitialReduxState(initialState, locale) {
  var state = getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, initialState), stateFromLocalStorage(locale, {})), stateFromCookies()); // NOTE: With merge() behavior, subvalues that are undefined won't override existing values
  // ie: merge({ a: 1, b: 2 }, { a: undefined, b: null }) returns { a: 1, b: null }


  state = Object(lodash["merge"])({}, state, stateFromQueryParams()); // for seller erase tripInformation

  state = getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, state), {}, {
    tripInformation: getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, state.tripInformation), getSellerTripInformation())
  });
  state = cleanTripInfoKids(state);
  state = Object(lodash["omitBy"])(state, function (value) {
    return value === null;
  });
  return state;
}
// EXTERNAL MODULE: ./src/client/store/constants.js
var store_constants = __webpack_require__("cvSI");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToHash.js
var scrollToHash = __webpack_require__("34at");

// EXTERNAL MODULE: ./src/client/store/global-loader/globalLoader.action.js
var globalLoader_action = __webpack_require__("R2jv");

// EXTERNAL MODULE: ./src/client/store/routing/constants.js
var routing_constants = __webpack_require__("Uq20");

// CONCATENATED MODULE: ./src/client/store/routing/routing.actions.js


function routingChange() {
  return Object(createAction["b" /* default */])(routing_constants["a" /* ROUTING_CHANGE */], {});
}
// CONCATENATED MODULE: ./src/client/app/RouteChangeListener.jsx










var hasNavigated = false;
var RouteChangeListener_RouteChangeListener = function RouteChangeListener() {
  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      history = _useRouter.history,
      location = _useRouter.location;

  var dispatch = Object(es["d" /* useDispatch */])();
  var previousLocation = Object(usePrevious["a" /* usePrevious */])(location);

  var _useContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  var scrollUnderNav = !isDesktop;
  var href = Object(uriUtils["b" /* convertLocationToHref */])(location);
  Object(react["useEffect"])(function () {
    dispatch(routingChange());

    if (location.hash) {
      scrollToHash["a" /* goToHash */](location.hash, scrollUnderNav);
    } else if (hasNavigated) {
      window.scrollTo(0, 0);
    }
  }, [href, location.hash]);
  Object(react["useEffect"])(function () {
    var showLoader = function showLoader(nextUri) {
      hasNavigated = true; // on the booking engine there is no loader between pages

      if (!(nextUri.startsWith('/booking/') && location.pathname.startsWith('/booking/'))) {
        var nextPath = new URI_default.a(nextUri).pathname();
        var previousPath = Object(uriUtils["c" /* convertLocationToURI */])(location).pathname();

        if (nextPath === previousPath) {
          dispatch(Object(globalLoader_action["d" /* startLoading */])('', false));
        } else {
          // startLoading second arg it here to handle scroll correctly after navigation
          // see Components/widgets/loading/Loading.jsx
          dispatch(Object(globalLoader_action["d" /* startLoading */])('', true));
        }
      }
    };

    var hideLoader = function hideLoader(nextUri) {
      // By default next triggers routeChangeComplete even on the first app mount
      // However, in the BookingEngine we show a loader while the content loads
      if (hasNavigated && !(nextUri.startsWith('/booking/') && previousLocation.pathname.startsWith('/booking/'))) {
        dispatch(Object(globalLoader_action["c" /* endLoading */])());
      }
    }; // Show the loader before each page transition, hide after


    history.events.on('routeChangeStart', showLoader);
    history.events.on('routeChangeComplete', hideLoader);
    return function () {
      history.events.off('routeChangeStart', showLoader);
      history.events.off('routeChangeComplete', hideLoader);
    };
  });
  return null;
};
// EXTERNAL MODULE: ./src/client/context/ToastContext.js
var ToastContext = __webpack_require__("waz2");

// EXTERNAL MODULE: ./src/client/router/routerContext.js
var routerContext = __webpack_require__("BncX");

// CONCATENATED MODULE: ./src/client/components/utils/responsive/constants.js
var APP_EVENTS = {
  MOUNTING: 'cm_app_mounting',
  MOUNTED: 'cm_app_mounted'
};
// EXTERNAL MODULE: ./src/client/components/utils/responsive/Responsive.helper.js
var Responsive_helper = __webpack_require__("GRjW");

// CONCATENATED MODULE: ./src/client/components/utils/responsive/Responsive.listener.js
/* eslint-env browser */

var componentsList = [];
var hasListener = false;

function shouldBreakpointChange(component, currentBreakpoint) {
  if (currentBreakpoint !== component.state.currentBreakpoint) {
    component.setState({
      currentBreakpoint: currentBreakpoint
    });
  }
}

function listener() {
  var currentBreakpoint = Object(Responsive_helper["a" /* getCurrentBreakpoint */])('', true);
  componentsList.map(function (component) {
    return shouldBreakpointChange(component, currentBreakpoint);
  });
}

function subscribe(component) {
  componentsList.push(component);

  if (!hasListener) {
    window.addEventListener('resize', listener);
    hasListener = true;
  }
}

function unsubscribe(component) {
  componentsList = componentsList.filter(function (item) {
    return item !== component;
  });

  if (!componentsList.length) {
    hasListener = false;
    window.removeEventListener('resize', listener);
  }
}


// EXTERNAL MODULE: ./src/client/components/utils/responsive/getCurrentResponsive.js
var getCurrentResponsive = __webpack_require__("ZCNJ");

// CONCATENATED MODULE: ./src/client/components/utils/responsive/ResponsiveLayout.jsx







var ResponsiveLayout_jsx = react["createElement"];

function ResponsiveLayout_createSuper(Derived) { var hasNativeReflectConstruct = ResponsiveLayout_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function ResponsiveLayout_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







 // prevent rerender of all component using ResponsiveContext when the breakpoint doesn't change

var memoizedGetCurrentResponsive = Object(lodash["memoize"])(getCurrentResponsive["a" /* default */]);

function sendEvent(name) {
  var event;

  if (typeof Event === 'function') {
    event = new Event(name);
  } else {
    event = document.createEvent('Event');
    event.initEvent(name, true, true);
  }

  document.dispatchEvent(event);
}

var ResponsiveLayout_ResponsiveLayout = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(ResponsiveLayout, _React$Component);

  var _super = ResponsiveLayout_createSuper(ResponsiveLayout);

  function ResponsiveLayout(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ResponsiveLayout);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      currentBreakpoint: Object(Responsive_helper["a" /* getCurrentBreakpoint */])(_this.props.userAgent || '', false),
      isAppMounted: false
    });

    if ( true && !window.cmAppMounted) {
      sendEvent(APP_EVENTS.MOUNTING);
    }

    return _this;
  }

  Object(createClass["a" /* default */])(ResponsiveLayout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      subscribe(this);
      this.setState({
        currentBreakpoint: Object(Responsive_helper["a" /* getCurrentBreakpoint */])(this.props.userAgent || '', true),
        isAppMounted: true
      });

      if (!window.cmAppMounted) {
        // Dispatch the info that the app is mounted
        window.cmAppMounted = true;
        sendEvent(APP_EVENTS.MOUNTED);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      unsubscribe(this);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          currentBreakpoint = _this$state.currentBreakpoint,
          isAppMounted = _this$state.isAppMounted;
      return ResponsiveLayout_jsx(responsive_responsiveContext["a" /* default */].Provider, {
        value: memoizedGetCurrentResponsive({
          currentBreakpoint: currentBreakpoint,
          isAppMounted: isAppMounted
        })
      }, children);
    }
  }]);

  return ResponsiveLayout;
}(react["Component"]);
// EXTERNAL MODULE: ./src/client/context/ResortListContext.js
var ResortListContext = __webpack_require__("7hcC");

// CONCATENATED MODULE: ./src/client/context/ResortListProvider.jsx







var ResortListProvider_jsx = react_default.a.createElement;

function ResortListProvider_createSuper(Derived) { var hasNativeReflectConstruct = ResortListProvider_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function ResortListProvider_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }



var ResortListProvider_ResortListProvider = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(ResortListProvider, _Component);

  var _super = ResortListProvider_createSuper(ResortListProvider);

  function ResortListProvider() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ResortListProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      resortList: [],
      setResortList: function setResortList(resortList) {
        _this.setState({
          resortList: resortList
        });
      }
    });

    return _this;
  }

  Object(createClass["a" /* default */])(ResortListProvider, [{
    key: "render",
    value: function render() {
      return ResortListProvider_jsx(ResortListContext["a" /* ResortListContext */].Provider, {
        value: this.state
      }, this.props.children);
    }
  }]);

  return ResortListProvider;
}(react["Component"]);
// EXTERNAL MODULE: ./src/client/context/DepartureCitiesContext.js
var DepartureCitiesContext = __webpack_require__("l5FB");

// CONCATENATED MODULE: ./src/client/context/DepartureCitiesProvider.jsx







var DepartureCitiesProvider_jsx = react_default.a.createElement;

function DepartureCitiesProvider_createSuper(Derived) { var hasNativeReflectConstruct = DepartureCitiesProvider_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function DepartureCitiesProvider_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var DepartureCitiesProvider_DepartureCitiesProvider = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(DepartureCitiesProvider, _Component);

  var _super = DepartureCitiesProvider_createSuper(DepartureCitiesProvider);

  function DepartureCitiesProvider() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, DepartureCitiesProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      departureCities: [],
      setDepartureCities: function setDepartureCities(departureCities) {
        _this.setState({
          departureCities: departureCities
        });
      }
    });

    return _this;
  }

  Object(createClass["a" /* default */])(DepartureCitiesProvider, [{
    key: "render",
    value: function render() {
      return DepartureCitiesProvider_jsx(DepartureCitiesContext["a" /* default */].Provider, {
        value: this.state
      }, this.props.children);
    }
  }]);

  return DepartureCitiesProvider;
}(react["Component"]);


// CONCATENATED MODULE: ./src/client/context/ABTestProvider.jsx








var ABTestProvider_jsx = react_default.a.createElement;

function ABTestProvider_createSuper(Derived) { var hasNativeReflectConstruct = ABTestProvider_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function ABTestProvider_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ABTestProvider_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ABTestProvider_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ABTestProvider_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ABTestProvider_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-env browser */





var ABTestProvider_isValidValues = function isValidValues(src, values) {
  return Object(lodash["isObject"])(values) && !Object(lodash["isEmpty"])(values) && !Object.entries(values).every(function (_ref) {
    var _ref2 = Object(slicedToArray["a" /* default */])(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return src[key] === value;
  });
};

var ABTEST_PREFIX = 'testAB.';
var ABTEST_EVENT = 'testAB';

var ABTestProvider_fetchABTestData = function fetchABTestData() {
  return Object(sessionStorageApi["a" /* getEntries */])().filter(function (_ref3) {
    var _ref4 = Object(slicedToArray["a" /* default */])(_ref3, 1),
        key = _ref4[0];

    return key.startsWith(ABTEST_PREFIX);
  }).reduce(function (acc, _ref5) {
    var _ref6 = Object(slicedToArray["a" /* default */])(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];

    return ABTestProvider_objectSpread(ABTestProvider_objectSpread({}, acc), {}, Object(defineProperty["a" /* default */])({}, key.replace(ABTEST_PREFIX, ''), value.toString()));
  }, {});
};

var ABTestProvider_ABTestProvider = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(ABTestProvider, _Component);

  var _super = ABTestProvider_createSuper(ABTestProvider);

  function ABTestProvider() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ABTestProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", ABTestProvider_objectSpread({}, ABTestProvider_fetchABTestData()));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleEvent", function (e) {
      /**
       * TODO
       * When REACT 16 ready
       * this.setState((prevState) => isValidValues(prevState, e.values) ? { ...e.values } : null);
       */
      if (ABTestProvider_isValidValues(_this.state, e.values)) {
        _this.setState(function () {
          return ABTestProvider_objectSpread({}, e.values);
        });
      }
    });

    return _this;
  }

  Object(createClass["a" /* default */])(ABTestProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener(ABTEST_EVENT, this.handleEvent, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener(ABTEST_EVENT, this.handleEvent, false);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return ABTestProvider_jsx(ABTestContext["a" /* ABTestContext */].Provider, {
        value: this.state
      }, children ? react["Children"].only(children) : null);
    }
  }]);

  return ABTestProvider;
}(react["Component"]);


// CONCATENATED MODULE: ./src/client/app/AppProviders.jsx
var AppProviders_jsx = react["createElement"];










var AppProviders_AppProviders = function AppProviders(_ref) {
  var children = _ref.children,
      appContext = _ref.appContext,
      pageContext = _ref.pageContext,
      reduxStore = _ref.reduxStore,
      routerContextValue = _ref.routerContextValue,
      toastRef = _ref.toastRef;
  return AppProviders_jsx(ReactAppContext["a" /* default */].Provider, {
    value: appContext
  }, AppProviders_jsx(context_pageContext["a" /* ReactPageContext */].Provider, {
    value: pageContext
  }, AppProviders_jsx(es["a" /* Provider */], {
    store: reduxStore
  }, AppProviders_jsx(ABTestProvider_ABTestProvider, null, AppProviders_jsx(routerContext["a" /* routerContext */].Provider, {
    value: routerContextValue
  }, AppProviders_jsx(ResponsiveLayout_ResponsiveLayout, {
    userAgent: appContext.userAgent
  }, AppProviders_jsx(DepartureCitiesProvider_DepartureCitiesProvider, null, AppProviders_jsx(ResortListProvider_ResortListProvider, null, AppProviders_jsx(ToastContext["a" /* ToastContext */].Provider, {
    value: {
      ref: toastRef
    }
  }, children)))))))));
};
// EXTERNAL MODULE: ./src/utils/status-code/statusCode.constants.js
var statusCode_constants = __webpack_require__("PSHn");

// EXTERNAL MODULE: ./src/client/store/toast/toast.actions.js
var toast_actions = __webpack_require__("7Z8V");

// EXTERNAL MODULE: ./src/client/components/frameworks/toast/Toast.jsx
var Toast = __webpack_require__("0x7Y");

// CONCATENATED MODULE: ./src/client/components/frameworks/toast/Toast.container.jsx



function Toast_container_mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = state.toast || {},
      shouldDisplay = _ref.shouldDisplay,
      label = _ref.label,
      icon = _ref.icon,
      color = _ref.color;

  return {
    visible: shouldDisplay,
    label: label,
    icon: icon,
    color: color
  };
}
var mapDispatchToProps = {
  onClose: toast_actions["b" /* closeToast */]
};
var ToastContainer = Object(es["c" /* connect */])(Toast_container_mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true
})(Toast["a" /* Toast */]);
// EXTERNAL MODULE: ./src/client/store/seller/sellerInfoReducer.js
var sellerInfoReducer = __webpack_require__("+2AQ");

// CONCATENATED MODULE: ./src/client/components/widgets/cmta/CMTA.jsx





var CMTA_CMTA = function CMTA() {
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var dispatch = Object(es["d" /* useDispatch */])();
  Object(react["useEffect"])(function () {
    if (!appContext.isCmta) {
      return;
    }

    graphqlClient["a" /* default */].runNoCacheQuery("{\n      sellerInfo {\n        email\n      }\n    }", appContext).then(function (data) {
      dispatch({
        type: sellerInfoReducer["a" /* GET_SELLER_EMAIL */],
        payload: data
      });
    });
  }, []);
  return null;
};
// CONCATENATED MODULE: ./pages/_app.js









var _app_jsx = react_default.a.createElement;

function _app_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _app_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      _app_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      _app_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = Object(getPrototypeOf["a" /* default */])(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return Object(possibleConstructorReturn["a" /* default */])(this, result);
  };
}










































 // $FlowFixMe issue with next typings

var _app_App = /*#__PURE__*/function (_NextApp) {
  Object(inherits["a" /* default */])(App, _NextApp);

  var _super = _createSuper2(App);

  Object(createClass["a" /* default */])(App, null, [{
    key: "getInitialProps",
    value: function () {
      var _getInitialProps = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref) {
        var Component, ctx, req, res, asPath, query, appContext, pageProps, reduxStore, currentUri, isUserQuickLogged, originalUrl, pageId, pageType, location, staticPageContext, layoutPromise, _require, getRedirect, RULES, _ref2, status, url, pageContext, layoutData, appContextLight;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Component = _ref.Component, ctx = _ref.ctx;
                req = ctx.req, res = ctx.res, asPath = ctx.asPath, query = ctx.query;
                appContext = req ? createAppContextFromReq_createAppContextFromReq(req) : getAppContext(); // If no appContext, we reload the page. It's occurring when navigating back from an error layer

                if (!appContext && true && Object(contextUtils["d" /* isStrictlyDevelopmentEnv */])(config_default.a)) {
                  window.location.reload();
                }

                pageProps = {}; // Get or Create the store with initialState from cookies
                // This allows you to set a custom default initialState

                reduxStore = getOrCreateStore(stateFromCookies());

                if (Component.requireAuthentication) {
                  currentUri = req ? Object(contextUtils["b" /* getCurrentUri */])(req) : new URI_default.a(window.location.href);
                  handleInvalidToken_handleInvalidToken({
                    appContext: appContext,
                    currentUri: currentUri,
                    res: res,
                    userInfo: Object(userInfo_selectors["a" /* userInfoSelector */])(reduxStore.getState())
                  });
                } // Provide the store to getInitialProps of pages


                ctx.reduxStore = reduxStore;
                isUserQuickLogged = appContext.isUserQuickLogged, originalUrl = appContext.originalUrl;
                pageId = Component.pageId;
                pageType = Component.pageType || Component.pageId || 'none';
                location = createRouterLocation_createRouterLocation({
                  asPath: asPath,
                  query: query,
                  originalUrl: originalUrl
                }); // There are two possibilities for the pageContext
                // - it's created in the getInitialProps of the page (DynamicPage.jsx)
                // - it's static, the properties depending on the pages can be statically resolved (e.g. pageId)
                // We create it before the getInitialProps and pass it to the getInitialProps because some
                // components might need it, like ThemeView which does render lines

                staticPageContext = {
                  pageId: pageId,
                  pageTitle: dist["constants"].WEBSITE_NAME,
                  pageDescription: '',
                  // usually we don't care about the statusCode in the pageContext, since a 404/500 will
                  // directly route us to a specific branch
                  statusCode: statusCode_constants["a" /* STATUS_CODE_200 */],
                  hrefLang: [],
                  pageMeta: {},
                  pageType: pageType || pageId || 'none',
                  siteSection: Object(utils["d" /* getSiteSection */])({
                    isUserQuickLogged: isUserQuickLogged,
                    pageType: pageType
                  })
                }; // Call here, await later to make this call and the getInitialProps one parallels

                layoutPromise = req ? Layout_query_fetchLayoutConfig(appContext) : Promise.resolve({});

                if (!Component.getInitialProps) {
                  _context.next = 53;
                  break;
                }

                _context.prev = 15;
                _context.next = 18;
                return Component.getInitialProps(_app_objectSpread(_app_objectSpread({}, ctx), {}, {
                  appContext: appContext,
                  pageContext: staticPageContext,
                  location: location
                }));

              case 18:
                pageProps = _context.sent;
                _context.next = 24;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context["catch"](15);
                pageProps = _context.t0;

              case 24:
                if (!pageProps.statusCode) {
                  _context.next = 53;
                  break;
                }

                if (!(pageProps.statusCode === statusCode_constants["d" /* STATUS_CODE_404 */])) {
                  _context.next = 53;
                  break;
                }

                if (true) {
                  _context.next = 47;
                  break;
                }

                _context.prev = 27;
                _require = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module '@clubmed/redirects'"); e.code = 'MODULE_NOT_FOUND'; throw e; }())), getRedirect = _require.getRedirect, RULES = _require.RULES;
                _context.next = 31;
                return getRedirect(config_default.a.get(), req, [RULES.B2C_CMS_CONTENT, RULES.GLOBAL_B2C, RULES.PRODUCT_SHORT_LINKS, RULES.LEGACY_B2C_NOT_FOUND]);

              case 31:
                _ref2 = _context.sent;
                status = _ref2.status;
                url = _ref2.url;
                return _context.abrupt("return", res.redirect(status, url));

              case 37:
                _context.prev = 37;
                _context.t1 = _context["catch"](27);
                _context.t2 = _app_objectSpread;
                _context.t3 = _app_objectSpread({}, pageProps);
                _context.next = 43;
                return not_found_NotFoundView.getInitialProps({
                  appContext: appContext
                });

              case 43:
                _context.t4 = _context.sent;
                pageProps = (0, _context.t2)(_context.t3, _context.t4);

              case 45:
                _context.next = 53;
                break;

              case 47:
                _context.t5 = _app_objectSpread;
                _context.t6 = _app_objectSpread({}, pageProps);
                _context.next = 51;
                return not_found_NotFoundView.getInitialProps({
                  appContext: appContext
                });

              case 51:
                _context.t7 = _context.sent;
                pageProps = (0, _context.t5)(_context.t6, _context.t7);

              case 53:
                if (pageProps.pageContext) {
                  pageContext = pageProps.pageContext;
                } else {
                  Object(invariant["a" /* invariant */])(pageId, "The page corresponding to the url ".concat(asPath, " doesn't have a pageId. This is an error."));
                  pageContext = _app_objectSpread(_app_objectSpread({}, staticPageContext), {}, {
                    statusCode: pageProps.statusCode || staticPageContext.statusCode
                  });
                } // Sync store with url, works fine on SSR to have
                // last version of state before rendering on frontend.


                if (false) {}

                _context.next = 57;
                return layoutPromise;

              case 57:
                layoutData = _context.sent;
                appContextLight = {
                  locale: appContext.locale,
                  originalUrl: appContext.originalUrl,
                  cookies: {// TODO is_mobile
                  }
                };

                if (false) {}

                return _context.abrupt("return", {
                  appContext: appContextLight,
                  pageContext: pageContext,
                  i18nData: Object(i18n["b" /* getAll */])(),
                  pageProps: pageProps,
                  layoutData: layoutData,
                  disableHeader: Object(sellerUtils["f" /* isSeller */])(appContext) || query.disableLayout === 'true' || (typeof Component.disableHeader === 'function' ? Component.disableHeader(appContext) : Component.disableHeader),
                  disableFooter: Object(sellerUtils["f" /* isSeller */])(appContext) || query.disableLayout === 'true' || (typeof Component.disableFooter === 'function' ? Component.disableHeader(appContext) : Component.disableFooter),
                  location: location,
                  initialReduxState: reduxStore.getState(),
                  statusCode: pageContext.statusCode
                });

              case 61:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[15, 21], [27, 37]]);
      }));

      function getInitialProps(_x) {
        return _getInitialProps.apply(this, arguments);
      }

      return getInitialProps;
    }()
  }]);

  function App(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, App); // $FlowFixMe issue with next typings


    _this = _super.call(this, props);
    _this.toastRef = /*#__PURE__*/Object(react["createRef"])();
    _this.appContext = true ? createOrUpdateAppContext_saveAppContext(props.appContext) : undefined; // Get or Create the store with initialState from cookies

    _this.reduxStore = getOrCreateStore(true ? getInitialReduxState(props.initialReduxState, _this.appContext.locale) : undefined);
    Object(i18n["e" /* setLocale */])(_this.appContext.locale.slice(0, 2)); // First time on the render it comes from the props, then it's there and won't have to be refeched

    _this.layoutData = props.layoutData || _this.layoutData;
    return _this;
  } // eslint-disable-next-line class-methods-use-this


  Object(createClass["a" /* default */])(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      Object(clientErrorHandler["c" /* start */])();
      nextRoutes_default.a.Router.events.on('routeChangeComplete', function () {
        // as shallow navigation may happen, ensure the store is synced with location.
        _this2.reduxStore.dispatch({
          type: store_constants["q" /* SYNC_WITH_LOCATION */],
          payload: {
            location: _this2.props.location,
            pageType: _this2.props.pageContext.pageType
          }
        });
      }); // https://github.com/zeit/next.js/issues/7814
      // Navigating back (clicking on the browser back button) triggers a getInitialProps every time
      // This makes change when changing of page. But we often do shallow-routing on a page to show a
      // layer (or to persist things in the url), but don' trigger getInitialProps
      // Sadly, back/forward means that we retrigger the getInitialProps, show the loader, etc.
      // So with this snippet we force same page navigation as shallow (since different pages skip
      // shallow routing)

      nextRoutes_default.a.Router.beforePopState(function (_ref3) {
        var options = _ref3.options; // this.props.location has not been updated yet, so we can check and prevent shallow navigation
        // between two different dynamic pages

        if (_this2.props.location.pathname === new URI_default.a(window.location.href).pathname()) {
          options.shallow = true;
        }

        return true;
      }); // Sync the state with the local storage

      this.reduxStore.subscribe(Object(lodash["throttle"])(function () {
        var state = _this2.reduxStore.getState();

        var persistedStore = JSON.stringify({
          tripInformation: {
            kids: Object(storeHelper["c" /* getKids */])(state)
          },
          seller: state.seller
        });
        Object(local_storage_api["d" /* setInLocalStorage */])("".concat(LOCAL_STORAGE_STATE_KEY, "-").concat(_this2.appContext.locale), persistedStore);
      }, 1000));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Component = _this$props.Component,
          pageContext = _this$props.pageContext,
          pageProps = _this$props.pageProps,
          i18nData = _this$props.i18nData,
          disableFooter = _this$props.disableFooter,
          disableHeader = _this$props.disableHeader,
          unUpdatedLocation = _this$props.location; // With shallow routing, the page is rerendered and the query params are updated, but
      // getInitialProps is not called. So we need to manually update the queryParams

      var location = createRouterLocation_updateShallowQueryParams({
        location: unUpdatedLocation,
        href: true ? window.location.href : undefined
      });
      var routerContextValue = {
        history: nextRoutes_default.a.Router,
        location: location
      };

      if (true) {
        Object(i18n["a" /* addTranslationKeys */])(i18nData);
      }

      return _app_jsx(react["Fragment"], null, _app_jsx(ErrorBoundary["a" /* ErrorBoundary */], {
        useNativeErrorHandling: true
      }, _app_jsx(head_default.a, null, _app_jsx("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
      }), _app_jsx("title", {
        key: "title"
      }, pageContext.pageTitle)), _app_jsx(AppProviders_AppProviders, {
        appContext: this.appContext,
        pageContext: pageContext,
        reduxStore: this.reduxStore,
        routerContextValue: routerContextValue,
        toastRef: this.toastRef
      }, _app_jsx(RouteChangeListener_RouteChangeListener, null), _app_jsx(HeadInfos_HeadInfos, null), _app_jsx(PriorityThirdPartyScripts_PriorityThirdPartyScripts, {
        key: "PriorityThirdPartyScripts"
      }), _app_jsx(ThreeSixtyContainer_ThreeSixtyContainer, null), _app_jsx(CMTA_CMTA, null), _app_jsx(Loading_Loading, null), _app_jsx(ErrorBoundary["a" /* ErrorBoundary */], null, _app_jsx(ChatbotContainer_ChatbotContainer, null)), _app_jsx(easy_testing_EasyTesting, null), _app_jsx("div", {
        id: pageContext.pageId || 'pageWrapper' // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id
        ,
        "data-cs-override-id": "page"
      }, _app_jsx(Layout_Layout, Object(esm_extends["a" /* default */])({}, this.layoutData, {
        disableHeader: disableHeader,
        disableFooter: disableFooter,
        isMicePage: dist["b2cPagesService"].isMicePage(pageContext.pageType)
      }), pageProps.statusCode === 404 ? _app_jsx(not_found_NotFoundView, pageProps) : _app_jsx(Component, pageProps))), _app_jsx(ToastContainer, {
        ref: this.toastRef
      }), _app_jsx(ThirdPartyScripts_ThirdPartyScripts, {
        key: "ThirdPartyScripts"
      }))));
    }
  }]);

  return App;
}(app_default.a); // eslint-disable-next-line import/no-default-export


/* harmony default export */ var _app = __webpack_exports__["default"] = (_app_App);

/***/ }),

/***/ "1bTl":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("Q7Yi"),
    isSymbol = __webpack_require__("vrF/");

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ "1bWg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setKids; });
/* unused harmony export updateKid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resetKids; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setKidsWithoutClearProposals; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wQ38");
/* eslint-disable flowtype/no-weak-types */



function setKids(kids) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_KIDS */ "c"], {
    kids: kids
  });
}

function setKidsWithoutClearProposals(kids) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS */ "d"], {
    kids: kids
  });
}

function resetKids() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_RESET_KIDS */ "b"]);
}

function updateKid(index, valuesToUpdate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_UPDATE_KID */ "e"], {
    index: index,
    valuesToUpdate: valuesToUpdate
  });
}



/***/ }),

/***/ "1dAi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (re) {
	return Object.prototype.toString.call(re) === '[object RegExp]';
};


/***/ }),

/***/ "1ih8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {
Object.defineProperty(exports, "__esModule", { value: true });
var BrowserInfo = /** @class */ (function () {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
    }
    return BrowserInfo;
}());
exports.BrowserInfo = BrowserInfo;
var NodeInfo = /** @class */ (function () {
    function NodeInfo(version) {
        this.version = version;
        this.name = 'node';
        this.os = process.platform;
    }
    return NodeInfo;
}());
exports.NodeInfo = NodeInfo;
var BotInfo = /** @class */ (function () {
    function BotInfo() {
        this.bot = true; // NOTE: deprecated test name instead
        this.name = 'bot';
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}());
exports.BotInfo = BotInfo;
// tslint:disable-next-line:max-line-length
var SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var SEARCHBOT_OS_REGEX = /(nuhk)|(Googlebot)|(Yammybot)|(Openbot)|(Slurp)|(MSNBot)|(Ask Jeeves\/Teoma)|(ia_archiver)/;
var REQUIRED_VERSION_PARTS = 3;
var userAgentRules = [
    ['aol', /AOLShield\/([0-9\._]+)/],
    ['edge', /Edge\/([0-9\._]+)/],
    ['yandexbrowser', /YaBrowser\/([0-9\._]+)/],
    ['vivaldi', /Vivaldi\/([0-9\.]+)/],
    ['kakaotalk', /KAKAOTALK\s([0-9\.]+)/],
    ['samsung', /SamsungBrowser\/([0-9\.]+)/],
    ['silk', /\bSilk\/([0-9._-]+)\b/],
    ['miui', /MiuiBrowser\/([0-9\.]+)$/],
    ['beaker', /BeakerBrowser\/([0-9\.]+)/],
    ['edge-chromium', /Edg\/([0-9\.]+)/],
    ['chromium-webview', /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
    ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
    ['phantomjs', /PhantomJS\/([0-9\.]+)(:?\s|$)/],
    ['crios', /CriOS\/([0-9\.]+)(:?\s|$)/],
    ['firefox', /Firefox\/([0-9\.]+)(?:\s|$)/],
    ['fxios', /FxiOS\/([0-9\.]+)/],
    ['opera-mini', /Opera Mini.*Version\/([0-9\.]+)/],
    ['opera', /Opera\/([0-9\.]+)(?:\s|$)/],
    ['opera', /OPR\/([0-9\.]+)(:?\s|$)/],
    ['ie', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],
    ['ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
    ['ie', /MSIE\s(7\.0)/],
    ['bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/],
    ['android', /Android\s([0-9\.]+)/],
    ['ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/],
    ['safari', /Version\/([0-9\._]+).*Safari/],
    ['facebook', /FBAV\/([0-9\.]+)/],
    ['instagram', /Instagram\s([0-9\.]+)/],
    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Mobile/],
    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Gecko\)$/],
    ['searchbot', SEARCHBOX_UA_REGEX],
];
var operatingSystemRules = [
    ['iOS', /iP(hone|od|ad)/],
    ['Android OS', /Android/],
    ['BlackBerry OS', /BlackBerry|BB10/],
    ['Windows Mobile', /IEMobile/],
    ['Amazon OS', /Kindle/],
    ['Windows 3.11', /Win16/],
    ['Windows 95', /(Windows 95)|(Win95)|(Windows_95)/],
    ['Windows 98', /(Windows 98)|(Win98)/],
    ['Windows 2000', /(Windows NT 5.0)|(Windows 2000)/],
    ['Windows XP', /(Windows NT 5.1)|(Windows XP)/],
    ['Windows Server 2003', /(Windows NT 5.2)/],
    ['Windows Vista', /(Windows NT 6.0)/],
    ['Windows 7', /(Windows NT 6.1)/],
    ['Windows 8', /(Windows NT 6.2)/],
    ['Windows 8.1', /(Windows NT 6.3)/],
    ['Windows 10', /(Windows NT 10.0)/],
    ['Windows ME', /Windows ME/],
    ['Open BSD', /OpenBSD/],
    ['Sun OS', /SunOS/],
    ['Chrome OS', /CrOS/],
    ['Linux', /(Linux)|(X11)/],
    ['Mac OS', /(Mac_PowerPC)|(Macintosh)/],
    ['QNX', /QNX/],
    ['BeOS', /BeOS/],
    ['OS/2', /OS\/2/],
    ['Search Bot', SEARCHBOT_OS_REGEX],
];
function detect(userAgent) {
    if (!!userAgent) {
        return parseUserAgent(userAgent);
    }
    if (typeof navigator !== 'undefined') {
        return parseUserAgent(navigator.userAgent);
    }
    return getNodeVersion();
}
exports.detect = detect;
function parseUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    var matchedRule = ua !== '' &&
        userAgentRules.reduce(function (matched, _a) {
            var browser = _a[0], regex = _a[1];
            if (matched) {
                return matched;
            }
            var uaMatch = regex.exec(ua);
            return !!uaMatch && [browser, uaMatch];
        }, false);
    if (!matchedRule) {
        return null;
    }
    var name = matchedRule[0], match = matchedRule[1];
    if (name === 'searchbot') {
        return new BotInfo();
    }
    var versionParts = match[1] && match[1].split(/[._]/).slice(0, 3);
    if (versionParts) {
        if (versionParts.length < REQUIRED_VERSION_PARTS) {
            versionParts = versionParts.concat(createVersionParts(REQUIRED_VERSION_PARTS - versionParts.length));
        }
    }
    else {
        versionParts = [];
    }
    return new BrowserInfo(name, versionParts.join('.'), detectOS(ua));
}
exports.parseUserAgent = parseUserAgent;
function detectOS(ua) {
    for (var ii = 0, count = operatingSystemRules.length; ii < count; ii++) {
        var _a = operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.test(ua);
        if (match) {
            return os;
        }
    }
    return null;
}
exports.detectOS = detectOS;
function getNodeVersion() {
    var isNode = typeof process !== 'undefined' && process.version;
    return isNode ? new NodeInfo(process.version.slice(1)) : null;
}
exports.getNodeVersion = getNodeVersion;
function createVersionParts(count) {
    var output = [];
    for (var ii = 0; ii < count; ii++) {
        output.push('0');
    }
    return output;
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("F63i")))

/***/ }),

/***/ "1iwb":
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ "1mr4":
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__("SJov"),
    hasPath = __webpack_require__("z+TE");

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),

/***/ "1qsz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isWinterResort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isWinterMountainResort; });
/* unused harmony export resortHasBeActivities */
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);


var WINTER_MOUNTAIN_RESORT = _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["constants"].WINTER_MOUNTAIN_RESORT;
function isWinterResort(resort) {
  var seasons = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(resort, 'seasons', []);
  return seasons.length === 1 && seasons.includes('WINTER') && Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(resort, 'type', '').toUpperCase() === 'VILLAGE';
}
function isWinterMountainResort(resort) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(resort, 'category') === WINTER_MOUNTAIN_RESORT;
}
var resortHasBeActivities = function resortHasBeActivities(resort) {
  return resort.activityCategories.leisure.some(function (_ref) {
    var subCategories = _ref.subCategories;
    return subCategories.length !== 0;
  });
};

/***/ }),

/***/ "2K7v":
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__("GSaD"),
    listCacheDelete = __webpack_require__("7jdC"),
    listCacheGet = __webpack_require__("BGmY"),
    listCacheHas = __webpack_require__("Lbah"),
    listCacheSet = __webpack_require__("2LuC");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ "2LZg":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__("5R7x");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("EIeC")(module)))

/***/ }),

/***/ "2LuC":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("3QVS");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ "2NJa":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("Q7Yi");

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ "2rns":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("lDSF");

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ "30WP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return open; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return close; });
function fetch(name) {
  return "FETCH_".concat(name);
}
function clear(name) {
  return "CLEAR_".concat(name);
}
function open(name) {
  return "OPEN_".concat(name);
}
function close(name) {
  return "CLOSE_".concat(name);
}

/***/ }),

/***/ "39HS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WebCallbackBlockLink; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _frameworks_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_block_link_BlockLink_themes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("uRnh");
/* harmony import */ var _WebCallbackTrigger__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("PZXw");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;






var WebCallbackBlockLink = function WebCallbackBlockLink(_ref) {
  var icon = _ref.icon,
      trackingData = _ref.trackingData,
      texts = _ref.texts,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  return __jsx(_WebCallbackTrigger__WEBPACK_IMPORTED_MODULE_5__[/* WebCallbackTrigger */ "a"], {
    trackingData: trackingData,
    theme: theme
  }, __jsx(_frameworks_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_3__[/* Icon */ "a"], {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('flex-shrink-0', _frameworks_block_link_BlockLink_themes__WEBPACK_IMPORTED_MODULE_4__[/* themes */ "a"][theme].thIcon),
    name: icon,
    width: _frameworks_block_link_BlockLink_themes__WEBPACK_IMPORTED_MODULE_4__[/* themes */ "a"][theme].thIconWidth
  }), __jsx("span", {
    className: "rtl:text-left"
  }, texts.map(function (text, idx) {
    return __jsx("div", {
      className: Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(_frameworks_block_link_BlockLink_themes__WEBPACK_IMPORTED_MODULE_4__[/* themes */ "a"][theme], "customText".concat(idx), ''),
      key: text
    }, text);
  })));
};

/***/ }),

/***/ "3JOw":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("lDSF"),
    root = __webpack_require__("jP+d");

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ "3QVS":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("t8ah");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ "47Eh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export shouldHideServicesPage */
/* unused harmony export shouldHideTransportPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getStepIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFilteredBreadcrumbPages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return navigateInBookingEngine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllProposalsIdWithAlternative; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z8xc");
/* harmony import */ var _components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("aWOT");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("oL6k");
/* harmony import */ var _utils_resort_resortUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("1qsz");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("nv//");



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}










var JOYVIEW_ROOM_ONLY = _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].PACKAGES.JOYVIEW_ROOM_ONLY;
var BASE_PATH = '/booking/';
var shouldHideServicesPage = function shouldHideServicesPage(selectedProposal, resort) {
  return !Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_8__[/* hasChildcare */ "p"])(selectedProposal) && !resort.isJoyview && selectedProposal.additionalServices.childcares.length === 0 || resort.isJoyview && !selectedProposal.alternativePackages && selectedProposal.packageId === JOYVIEW_ROOM_ONLY;
};
var shouldHideTransportPage = function shouldHideTransportPage(selectedProposal) {
  return !Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_8__[/* hasTransfer */ "s"])(selectedProposal) && !Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(selectedProposal, 'transports');
};
var getStepIndex = function getStepIndex(steps, bookingStep) {
  return steps.findIndex(function (step) {
    return step.name === bookingStep;
  });
}; // eslint-disable-next-line max-params

var getFilteredBreadcrumbPages = function getFilteredBreadcrumbPages(_ref) {
  var selectedProposal = _ref.selectedProposal,
      resort = _ref.resort,
      i18n = _ref.i18n,
      isActivitiesViewFeatureFlipped = _ref.isActivitiesViewFeatureFlipped,
      isOptionHoldOnlyFeatureFlipped = _ref.isOptionHoldOnlyFeatureFlipped,
      _ref$isSeller = _ref.isSeller,
      isSeller = _ref$isSeller === void 0 ? false : _ref$isSeller,
      _ref$isDelCredere = _ref.isDelCredere,
      isDelCredere = _ref$isDelCredere === void 0 ? false : _ref$isDelCredere;
  var activitiesView = isActivitiesViewFeatureFlipped && (selectedProposal.additionalServices.activities.some(function (activity) {
    return activity.productInfo.isIncluded === false;
  }) || selectedProposal.additionalServices.rentals.length > 0) ? {
    name: 'activities',
    path: "".concat(BASE_PATH, "activities"),
    actionGA: 'activities',
    labelGA: 'validateActivities',
    basePriceGALabel: 'basePriceActivities',
    icon: Object(_utils_resort_resortUtils__WEBPACK_IMPORTED_MODULE_9__[/* isWinterMountainResort */ "a"])(resort) ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].SKI : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].GOLF,
    showIcon: true,
    title: i18n.booking.activities.pageTitle,
    seoTitle: i18n.booking.activities.seo.title,
    gridSize: 'large'
  } : null;
  var isJoyview = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(resort, 'isJoyview');
  var breadcrumbPages = [{
    name: 'accommodation',
    path: "".concat(BASE_PATH, "accommodation"),
    eventPageName: 'accommodations',
    actionGA: 'accommodation',
    labelGA: 'validateAccommodation',
    basePriceGALabel: 'basePriceAccommodation',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].ACCOMODATIONS,
    showIcon: true,
    title: Object(_components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__[/* tAlt */ "c"])({
      resortKeyPath: 'booking.accommodation.pageTitle',
      cruiseKeyPath: 'booking.accommodation.pageTitleCruise',
      resort: resort
    }),
    seoTitle: i18n.booking.accommodation.seo.title,
    gridSize: 'large'
  }, _objectSpread(_objectSpread({
    name: 'transport',
    path: "".concat(BASE_PATH, "transport"),
    actionGA: 'transport',
    labelGA: 'validateTransport'
  }, Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(selectedProposal, 'transports') ? {
    icon: Object(_components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_6__[/* getTransportIcon */ "j"])(Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(selectedProposal, 'transports.inbound'), Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(selectedProposal, 'transports.outbound')),
    title: i18n.booking.transport.transportPageTitle,
    seoTitle: i18n.booking.transport.seo.title,
    basePriceGALabel: 'basePriceTransport'
  } : {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].TRANSFER,
    title: i18n.booking.transport.transferPageTitle,
    seoTitle: i18n.booking.transport.transfer.seo.title,
    basePriceGALabel: 'basePriceTransfer'
  }), {}, {
    showIcon: true,
    isToBeHidden: shouldHideTransportPage(selectedProposal)
  }), {
    name: 'services',
    path: "".concat(BASE_PATH, "services"),
    actionGA: isJoyview ? 'allInclusive' : 'service',
    labelGA: isJoyview ? 'validateAllInclusive' : 'validateServices',
    basePriceGALabel: 'basePriceServices',
    icon: isJoyview ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].DATE_PLUS : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CHILDREN,
    showIcon: true,
    title: isJoyview ? i18n.booking.services.pageTitleJoyview : i18n.booking.services.pageTitleChildcare,
    seoTitle: i18n.booking.services.seo.title,
    isToBeHidden: shouldHideServicesPage(selectedProposal, resort),
    gridSize: isJoyview ? 'small' : 'large'
  }, {
    name: 'participants',
    path: "".concat(BASE_PATH, "participants"),
    actionGA: 'participant',
    labelGA: 'validateParticipants',
    basePriceGALabel: 'basePricePaymentParticipants',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CONTACT,
    showIcon: true,
    title: i18n.booking.participants.pageTitle,
    seoTitle: i18n.booking.participants.seo.title,
    gridSize: 'mini'
  }, {
    name: 'summary',
    path: "".concat(BASE_PATH, "summary"),
    actionGA: 'summary',
    labelGA: 'validateSummary',
    basePriceGALabel: 'basePriceSummary',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].SUMMARY,
    showIcon: true,
    title: i18n.booking.summary.pageTitle,
    seoTitle: i18n.booking.summary.seo.title,
    gridSize: 'large'
  }];
  if (activitiesView) breadcrumbPages.splice(3, 0, activitiesView); // adds the banking step if the optionHoldOnly featureFlip is disabled

  if (!isOptionHoldOnlyFeatureFlipped) breadcrumbPages.push({
    name: 'banking',
    path: "".concat(BASE_PATH, "banking"),
    actionGA: 'banking',
    labelGA: 'validateBanking',
    basePriceGALabel: 'basePricePaymentBanking',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CREDIT_CARD,
    showIcon: !isSeller || isDelCredere,
    title: i18n.booking.banking.pageTitle,
    seoTitle: i18n.booking.banking.seo.title
  }); // $FlowFixMe Absolutely no clue of why

  return Object(lodash__WEBPACK_IMPORTED_MODULE_2__["reject"])(breadcrumbPages, 'isToBeHidden');
};
var navigateInBookingEngine = function navigateInBookingEngine(_ref2) {
  var location = _ref2.location,
      history = _ref2.history,
      _ref2$replace = _ref2.replace,
      replace = _ref2$replace === void 0 ? false : _ref2$replace;
  var nextUri = location instanceof urijs__WEBPACK_IMPORTED_MODULE_3___default.a ? location : Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_10__[/* convertLocationToURI */ "c"])(location);
  var fileName = nextUri.filename();
  var shownUri = nextUri.clone();
  nextUri.pathname('/booking').setQuery('bookingStep', fileName);
  var nextUrl = nextUri.resource().toString();
  var shownUrl = shownUri.resource().toString();

  if (replace) {
    history.replace(nextUrl, shownUrl);
  } else {
    history.push(nextUrl, shownUrl);
  }
};
var getAllProposalsIdWithAlternative = function getAllProposalsIdWithAlternative(proposal) {
  return [proposal.id].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(proposal.alternativePackages ? proposal.alternativePackages.map(function (alternativePackage) {
    return alternativePackage.proposalId;
  }) : []));
};

/***/ }),

/***/ "47go":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
}(this, function () {
    var STATE_OUTPUT       = 0,
        STATE_HTML         = 1,
        STATE_PRE_COMMENT  = 2,
        STATE_COMMENT      = 3,
        WHITESPACE         = /\s/,
        ALLOWED_TAGS_REGEX = /<(\w*)>/g;

    function striptags(html, allowableTags) {
        var html = html || '',
            state = STATE_OUTPUT,
            depth = 0,
            output = '',
            tagBuffer = '',
            inQuote = false,
            i, length, c;

        if (typeof allowableTags === 'string') {
            // Parse the string into an array of tags
            allowableTags = parseAllowableTags(allowableTags);
        } else if (!Array.isArray(allowableTags)) {
            // If it is not an array, explicitly set to null
            allowableTags = null;
        }

        for (i = 0, length = html.length; i < length; i++) {
            c = html[i];

            switch (c) {
                case '<': {
                    // ignore '<' if inside a quote
                    if (inQuote) {
                        break;
                    }

                    // '<' followed by a space is not a valid tag, continue
                    if (html[i + 1] == ' ') {
                        consumeCharacter(c);
                        break;
                    }

                    // change to STATE_HTML
                    if (state == STATE_OUTPUT) {
                        state = STATE_HTML;

                        consumeCharacter(c);
                        break;
                    }

                    // ignore additional '<' characters when inside a tag
                    if (state == STATE_HTML) {
                        depth++;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case '>': {
                    // something like this is happening: '<<>>'
                    if (depth) {
                        depth--;
                        break;
                    }

                    // ignore '>' if inside a quote
                    if (inQuote) {
                        break;
                    }

                    // an HTML tag was closed
                    if (state == STATE_HTML) {
                        inQuote = state = 0;

                        if (allowableTags) {
                            tagBuffer += '>';
                            flushTagBuffer();
                        }

                        break;
                    }

                    // '<!' met its ending '>'
                    if (state == STATE_PRE_COMMENT) {
                        inQuote = state = 0;
                        tagBuffer = '';
                        break;
                    }

                    // if last two characters were '--', then end comment
                    if (state == STATE_COMMENT &&
                        html[i - 1] == '-' &&
                        html[i - 2] == '-') {

                        inQuote = state = 0;
                        tagBuffer = '';
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                // catch both single and double quotes
                case '"':
                case '\'': {
                    if (state == STATE_HTML) {
                        if (inQuote == c) {
                            // end quote found
                            inQuote = false;
                        } else if (!inQuote) {
                            // start quote only if not already in one
                            inQuote = c;
                        }
                    }

                    consumeCharacter(c);
                    break;
                }

                case '!': {
                    if (state == STATE_HTML &&
                        html[i - 1] == '<') {

                        // looks like we might be starting a comment
                        state = STATE_PRE_COMMENT;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case '-': {
                    // if the previous two characters were '!-', this is a comment
                    if (state == STATE_PRE_COMMENT &&
                        html[i - 1] == '-' &&
                        html[i - 2] == '!') {

                        state = STATE_COMMENT;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case 'E':
                case 'e': {
                    // check for DOCTYPE, because it looks like a comment and isn't
                    if (state == STATE_PRE_COMMENT &&
                        html.substr(i - 6, 7).toLowerCase() == 'doctype') {

                        state = STATE_HTML;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                default: {
                    consumeCharacter(c);
                }
            }
        }

        function consumeCharacter(c) {
            if (state == STATE_OUTPUT) {
                output += c;
            } else if (allowableTags && state == STATE_HTML) {
                tagBuffer += c;
            }
        }

        function flushTagBuffer() {
            var normalized = '',
                nonWhitespaceSeen = false,
                i, length, c;

            normalizeTagBuffer:
            for (i = 0, length = tagBuffer.length; i < length; i++) {
                c = tagBuffer[i].toLowerCase();

                switch (c) {
                    case '<': {
                        break;
                    }

                    case '>': {
                        break normalizeTagBuffer;
                    }

                    case '/': {
                        nonWhitespaceSeen = true;
                        break;
                    }

                    default: {
                        if (!c.match(WHITESPACE)) {
                            nonWhitespaceSeen = true;
                            normalized += c;
                        } else if (nonWhitespaceSeen) {
                            break normalizeTagBuffer;
                        }
                    }
                }
            }

            if (allowableTags.indexOf(normalized) !== -1) {
                output += tagBuffer;
            }

            tagBuffer = '';
        }

        return output;
    }

    /**
     * Return an array containing tags that are allowed to pass through the
     * algorithm.
     *
     * @param string allowableTags A string of tags to allow (e.g. "<b><strong>").
     * @return array|null An array of allowed tags or null if none.
     */
    function parseAllowableTags(allowableTags) {
        var tagsArray = [],
            match;

        while ((match = ALLOWED_TAGS_REGEX.exec(allowableTags)) !== null) {
            tagsArray.push(match[1]);
        }

        return tagsArray.length !== 0 ? tagsArray : null;
    }

    return striptags;
}));


/***/ }),

/***/ "4Bi9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createReducer(initialState) {
  var handlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var handler = action && action.type && handlers ? handlers[action.type] : undefined; // if no action was provided, return the actual state

    if (!handler) {
      return state;
    }

    state = handler(state, action);
    return state;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createReducer);

/***/ }),

/***/ "4Db7":
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "4SQ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpinnerLabel; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


function SpinnerLabel(props) {
  var className = props.className,
      label = props.label;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'text-center font-brand leading-normal max-w-4/5 sm:max-w-3/5 mt-4 text-blue text-xl', {
      a11y: !label
    }),
    "aria-live": "polite"
  }, label ? label : 'Loading');
}

/***/ }),

/***/ "4oK2":
/***/ (function(module, exports, __webpack_require__) {

var encode = __webpack_require__("BRr/"),
    decode = __webpack_require__("oW49");

exports.decode = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
};

exports.decodeStrict = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
};

exports.encode = function(data, level){
	return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
};

exports.encodeXML = encode.XML;

exports.encodeHTML4 =
exports.encodeHTML5 =
exports.encodeHTML  = encode.HTML;

exports.decodeXML =
exports.decodeXMLStrict = decode.XML;

exports.decodeHTML4 =
exports.decodeHTML5 =
exports.decodeHTML = decode.HTML;

exports.decodeHTML4Strict =
exports.decodeHTML5Strict =
exports.decodeHTMLStrict = decode.HTMLStrict;

exports.escape = encode.escape;


/***/ }),

/***/ "4qke":
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__("tU/q"),
    getSymbols = __webpack_require__("WwbQ"),
    keys = __webpack_require__("DWlz");

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("ZHK4");
module.exports = __webpack_require__("7xIC");


/***/ }),

/***/ "5FP0":
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__("ubIY");

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ "5R7x":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq")))

/***/ }),

/***/ "66Hx":
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ "68C9":
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__("07TY");

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ "6MnY":
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__("lxRQ"),
    isIterateeCall = __webpack_require__("FHsl");

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ "6wD6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateTripDateCriteria; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");



function updateTripDateCriteria(options) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* UPDATE_TRIP_DATE_CRITERIA */ "t"], options);
}



/***/ }),

/***/ "7Z8V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSE_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closeToast; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");

var CLOSE_TOAST = 'CLOSE_TOAST';

function closeToast() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(CLOSE_TOAST);
}



/***/ }),

/***/ "7hcC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResortListContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var ResortListContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_0__["createContext"])({
  resortList: [],
  setResortList: function setResortList() {}
});

/***/ }),

/***/ "7jdC":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("3QVS");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ "8Jk/":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("ojcf"),
    keysIn = __webpack_require__("FQR9");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ "8PLQ":
/***/ (function(module) {

module.exports = JSON.parse("{\"Aacute\":\"Á\",\"aacute\":\"á\",\"Abreve\":\"Ă\",\"abreve\":\"ă\",\"ac\":\"∾\",\"acd\":\"∿\",\"acE\":\"∾̳\",\"Acirc\":\"Â\",\"acirc\":\"â\",\"acute\":\"´\",\"Acy\":\"А\",\"acy\":\"а\",\"AElig\":\"Æ\",\"aelig\":\"æ\",\"af\":\"⁡\",\"Afr\":\"𝔄\",\"afr\":\"𝔞\",\"Agrave\":\"À\",\"agrave\":\"à\",\"alefsym\":\"ℵ\",\"aleph\":\"ℵ\",\"Alpha\":\"Α\",\"alpha\":\"α\",\"Amacr\":\"Ā\",\"amacr\":\"ā\",\"amalg\":\"⨿\",\"amp\":\"&\",\"AMP\":\"&\",\"andand\":\"⩕\",\"And\":\"⩓\",\"and\":\"∧\",\"andd\":\"⩜\",\"andslope\":\"⩘\",\"andv\":\"⩚\",\"ang\":\"∠\",\"ange\":\"⦤\",\"angle\":\"∠\",\"angmsdaa\":\"⦨\",\"angmsdab\":\"⦩\",\"angmsdac\":\"⦪\",\"angmsdad\":\"⦫\",\"angmsdae\":\"⦬\",\"angmsdaf\":\"⦭\",\"angmsdag\":\"⦮\",\"angmsdah\":\"⦯\",\"angmsd\":\"∡\",\"angrt\":\"∟\",\"angrtvb\":\"⊾\",\"angrtvbd\":\"⦝\",\"angsph\":\"∢\",\"angst\":\"Å\",\"angzarr\":\"⍼\",\"Aogon\":\"Ą\",\"aogon\":\"ą\",\"Aopf\":\"𝔸\",\"aopf\":\"𝕒\",\"apacir\":\"⩯\",\"ap\":\"≈\",\"apE\":\"⩰\",\"ape\":\"≊\",\"apid\":\"≋\",\"apos\":\"'\",\"ApplyFunction\":\"⁡\",\"approx\":\"≈\",\"approxeq\":\"≊\",\"Aring\":\"Å\",\"aring\":\"å\",\"Ascr\":\"𝒜\",\"ascr\":\"𝒶\",\"Assign\":\"≔\",\"ast\":\"*\",\"asymp\":\"≈\",\"asympeq\":\"≍\",\"Atilde\":\"Ã\",\"atilde\":\"ã\",\"Auml\":\"Ä\",\"auml\":\"ä\",\"awconint\":\"∳\",\"awint\":\"⨑\",\"backcong\":\"≌\",\"backepsilon\":\"϶\",\"backprime\":\"‵\",\"backsim\":\"∽\",\"backsimeq\":\"⋍\",\"Backslash\":\"∖\",\"Barv\":\"⫧\",\"barvee\":\"⊽\",\"barwed\":\"⌅\",\"Barwed\":\"⌆\",\"barwedge\":\"⌅\",\"bbrk\":\"⎵\",\"bbrktbrk\":\"⎶\",\"bcong\":\"≌\",\"Bcy\":\"Б\",\"bcy\":\"б\",\"bdquo\":\"„\",\"becaus\":\"∵\",\"because\":\"∵\",\"Because\":\"∵\",\"bemptyv\":\"⦰\",\"bepsi\":\"϶\",\"bernou\":\"ℬ\",\"Bernoullis\":\"ℬ\",\"Beta\":\"Β\",\"beta\":\"β\",\"beth\":\"ℶ\",\"between\":\"≬\",\"Bfr\":\"𝔅\",\"bfr\":\"𝔟\",\"bigcap\":\"⋂\",\"bigcirc\":\"◯\",\"bigcup\":\"⋃\",\"bigodot\":\"⨀\",\"bigoplus\":\"⨁\",\"bigotimes\":\"⨂\",\"bigsqcup\":\"⨆\",\"bigstar\":\"★\",\"bigtriangledown\":\"▽\",\"bigtriangleup\":\"△\",\"biguplus\":\"⨄\",\"bigvee\":\"⋁\",\"bigwedge\":\"⋀\",\"bkarow\":\"⤍\",\"blacklozenge\":\"⧫\",\"blacksquare\":\"▪\",\"blacktriangle\":\"▴\",\"blacktriangledown\":\"▾\",\"blacktriangleleft\":\"◂\",\"blacktriangleright\":\"▸\",\"blank\":\"␣\",\"blk12\":\"▒\",\"blk14\":\"░\",\"blk34\":\"▓\",\"block\":\"█\",\"bne\":\"=⃥\",\"bnequiv\":\"≡⃥\",\"bNot\":\"⫭\",\"bnot\":\"⌐\",\"Bopf\":\"𝔹\",\"bopf\":\"𝕓\",\"bot\":\"⊥\",\"bottom\":\"⊥\",\"bowtie\":\"⋈\",\"boxbox\":\"⧉\",\"boxdl\":\"┐\",\"boxdL\":\"╕\",\"boxDl\":\"╖\",\"boxDL\":\"╗\",\"boxdr\":\"┌\",\"boxdR\":\"╒\",\"boxDr\":\"╓\",\"boxDR\":\"╔\",\"boxh\":\"─\",\"boxH\":\"═\",\"boxhd\":\"┬\",\"boxHd\":\"╤\",\"boxhD\":\"╥\",\"boxHD\":\"╦\",\"boxhu\":\"┴\",\"boxHu\":\"╧\",\"boxhU\":\"╨\",\"boxHU\":\"╩\",\"boxminus\":\"⊟\",\"boxplus\":\"⊞\",\"boxtimes\":\"⊠\",\"boxul\":\"┘\",\"boxuL\":\"╛\",\"boxUl\":\"╜\",\"boxUL\":\"╝\",\"boxur\":\"└\",\"boxuR\":\"╘\",\"boxUr\":\"╙\",\"boxUR\":\"╚\",\"boxv\":\"│\",\"boxV\":\"║\",\"boxvh\":\"┼\",\"boxvH\":\"╪\",\"boxVh\":\"╫\",\"boxVH\":\"╬\",\"boxvl\":\"┤\",\"boxvL\":\"╡\",\"boxVl\":\"╢\",\"boxVL\":\"╣\",\"boxvr\":\"├\",\"boxvR\":\"╞\",\"boxVr\":\"╟\",\"boxVR\":\"╠\",\"bprime\":\"‵\",\"breve\":\"˘\",\"Breve\":\"˘\",\"brvbar\":\"¦\",\"bscr\":\"𝒷\",\"Bscr\":\"ℬ\",\"bsemi\":\"⁏\",\"bsim\":\"∽\",\"bsime\":\"⋍\",\"bsolb\":\"⧅\",\"bsol\":\"\\\\\",\"bsolhsub\":\"⟈\",\"bull\":\"•\",\"bullet\":\"•\",\"bump\":\"≎\",\"bumpE\":\"⪮\",\"bumpe\":\"≏\",\"Bumpeq\":\"≎\",\"bumpeq\":\"≏\",\"Cacute\":\"Ć\",\"cacute\":\"ć\",\"capand\":\"⩄\",\"capbrcup\":\"⩉\",\"capcap\":\"⩋\",\"cap\":\"∩\",\"Cap\":\"⋒\",\"capcup\":\"⩇\",\"capdot\":\"⩀\",\"CapitalDifferentialD\":\"ⅅ\",\"caps\":\"∩︀\",\"caret\":\"⁁\",\"caron\":\"ˇ\",\"Cayleys\":\"ℭ\",\"ccaps\":\"⩍\",\"Ccaron\":\"Č\",\"ccaron\":\"č\",\"Ccedil\":\"Ç\",\"ccedil\":\"ç\",\"Ccirc\":\"Ĉ\",\"ccirc\":\"ĉ\",\"Cconint\":\"∰\",\"ccups\":\"⩌\",\"ccupssm\":\"⩐\",\"Cdot\":\"Ċ\",\"cdot\":\"ċ\",\"cedil\":\"¸\",\"Cedilla\":\"¸\",\"cemptyv\":\"⦲\",\"cent\":\"¢\",\"centerdot\":\"·\",\"CenterDot\":\"·\",\"cfr\":\"𝔠\",\"Cfr\":\"ℭ\",\"CHcy\":\"Ч\",\"chcy\":\"ч\",\"check\":\"✓\",\"checkmark\":\"✓\",\"Chi\":\"Χ\",\"chi\":\"χ\",\"circ\":\"ˆ\",\"circeq\":\"≗\",\"circlearrowleft\":\"↺\",\"circlearrowright\":\"↻\",\"circledast\":\"⊛\",\"circledcirc\":\"⊚\",\"circleddash\":\"⊝\",\"CircleDot\":\"⊙\",\"circledR\":\"®\",\"circledS\":\"Ⓢ\",\"CircleMinus\":\"⊖\",\"CirclePlus\":\"⊕\",\"CircleTimes\":\"⊗\",\"cir\":\"○\",\"cirE\":\"⧃\",\"cire\":\"≗\",\"cirfnint\":\"⨐\",\"cirmid\":\"⫯\",\"cirscir\":\"⧂\",\"ClockwiseContourIntegral\":\"∲\",\"CloseCurlyDoubleQuote\":\"”\",\"CloseCurlyQuote\":\"’\",\"clubs\":\"♣\",\"clubsuit\":\"♣\",\"colon\":\":\",\"Colon\":\"∷\",\"Colone\":\"⩴\",\"colone\":\"≔\",\"coloneq\":\"≔\",\"comma\":\",\",\"commat\":\"@\",\"comp\":\"∁\",\"compfn\":\"∘\",\"complement\":\"∁\",\"complexes\":\"ℂ\",\"cong\":\"≅\",\"congdot\":\"⩭\",\"Congruent\":\"≡\",\"conint\":\"∮\",\"Conint\":\"∯\",\"ContourIntegral\":\"∮\",\"copf\":\"𝕔\",\"Copf\":\"ℂ\",\"coprod\":\"∐\",\"Coproduct\":\"∐\",\"copy\":\"©\",\"COPY\":\"©\",\"copysr\":\"℗\",\"CounterClockwiseContourIntegral\":\"∳\",\"crarr\":\"↵\",\"cross\":\"✗\",\"Cross\":\"⨯\",\"Cscr\":\"𝒞\",\"cscr\":\"𝒸\",\"csub\":\"⫏\",\"csube\":\"⫑\",\"csup\":\"⫐\",\"csupe\":\"⫒\",\"ctdot\":\"⋯\",\"cudarrl\":\"⤸\",\"cudarrr\":\"⤵\",\"cuepr\":\"⋞\",\"cuesc\":\"⋟\",\"cularr\":\"↶\",\"cularrp\":\"⤽\",\"cupbrcap\":\"⩈\",\"cupcap\":\"⩆\",\"CupCap\":\"≍\",\"cup\":\"∪\",\"Cup\":\"⋓\",\"cupcup\":\"⩊\",\"cupdot\":\"⊍\",\"cupor\":\"⩅\",\"cups\":\"∪︀\",\"curarr\":\"↷\",\"curarrm\":\"⤼\",\"curlyeqprec\":\"⋞\",\"curlyeqsucc\":\"⋟\",\"curlyvee\":\"⋎\",\"curlywedge\":\"⋏\",\"curren\":\"¤\",\"curvearrowleft\":\"↶\",\"curvearrowright\":\"↷\",\"cuvee\":\"⋎\",\"cuwed\":\"⋏\",\"cwconint\":\"∲\",\"cwint\":\"∱\",\"cylcty\":\"⌭\",\"dagger\":\"†\",\"Dagger\":\"‡\",\"daleth\":\"ℸ\",\"darr\":\"↓\",\"Darr\":\"↡\",\"dArr\":\"⇓\",\"dash\":\"‐\",\"Dashv\":\"⫤\",\"dashv\":\"⊣\",\"dbkarow\":\"⤏\",\"dblac\":\"˝\",\"Dcaron\":\"Ď\",\"dcaron\":\"ď\",\"Dcy\":\"Д\",\"dcy\":\"д\",\"ddagger\":\"‡\",\"ddarr\":\"⇊\",\"DD\":\"ⅅ\",\"dd\":\"ⅆ\",\"DDotrahd\":\"⤑\",\"ddotseq\":\"⩷\",\"deg\":\"°\",\"Del\":\"∇\",\"Delta\":\"Δ\",\"delta\":\"δ\",\"demptyv\":\"⦱\",\"dfisht\":\"⥿\",\"Dfr\":\"𝔇\",\"dfr\":\"𝔡\",\"dHar\":\"⥥\",\"dharl\":\"⇃\",\"dharr\":\"⇂\",\"DiacriticalAcute\":\"´\",\"DiacriticalDot\":\"˙\",\"DiacriticalDoubleAcute\":\"˝\",\"DiacriticalGrave\":\"`\",\"DiacriticalTilde\":\"˜\",\"diam\":\"⋄\",\"diamond\":\"⋄\",\"Diamond\":\"⋄\",\"diamondsuit\":\"♦\",\"diams\":\"♦\",\"die\":\"¨\",\"DifferentialD\":\"ⅆ\",\"digamma\":\"ϝ\",\"disin\":\"⋲\",\"div\":\"÷\",\"divide\":\"÷\",\"divideontimes\":\"⋇\",\"divonx\":\"⋇\",\"DJcy\":\"Ђ\",\"djcy\":\"ђ\",\"dlcorn\":\"⌞\",\"dlcrop\":\"⌍\",\"dollar\":\"$\",\"Dopf\":\"𝔻\",\"dopf\":\"𝕕\",\"Dot\":\"¨\",\"dot\":\"˙\",\"DotDot\":\"⃜\",\"doteq\":\"≐\",\"doteqdot\":\"≑\",\"DotEqual\":\"≐\",\"dotminus\":\"∸\",\"dotplus\":\"∔\",\"dotsquare\":\"⊡\",\"doublebarwedge\":\"⌆\",\"DoubleContourIntegral\":\"∯\",\"DoubleDot\":\"¨\",\"DoubleDownArrow\":\"⇓\",\"DoubleLeftArrow\":\"⇐\",\"DoubleLeftRightArrow\":\"⇔\",\"DoubleLeftTee\":\"⫤\",\"DoubleLongLeftArrow\":\"⟸\",\"DoubleLongLeftRightArrow\":\"⟺\",\"DoubleLongRightArrow\":\"⟹\",\"DoubleRightArrow\":\"⇒\",\"DoubleRightTee\":\"⊨\",\"DoubleUpArrow\":\"⇑\",\"DoubleUpDownArrow\":\"⇕\",\"DoubleVerticalBar\":\"∥\",\"DownArrowBar\":\"⤓\",\"downarrow\":\"↓\",\"DownArrow\":\"↓\",\"Downarrow\":\"⇓\",\"DownArrowUpArrow\":\"⇵\",\"DownBreve\":\"̑\",\"downdownarrows\":\"⇊\",\"downharpoonleft\":\"⇃\",\"downharpoonright\":\"⇂\",\"DownLeftRightVector\":\"⥐\",\"DownLeftTeeVector\":\"⥞\",\"DownLeftVectorBar\":\"⥖\",\"DownLeftVector\":\"↽\",\"DownRightTeeVector\":\"⥟\",\"DownRightVectorBar\":\"⥗\",\"DownRightVector\":\"⇁\",\"DownTeeArrow\":\"↧\",\"DownTee\":\"⊤\",\"drbkarow\":\"⤐\",\"drcorn\":\"⌟\",\"drcrop\":\"⌌\",\"Dscr\":\"𝒟\",\"dscr\":\"𝒹\",\"DScy\":\"Ѕ\",\"dscy\":\"ѕ\",\"dsol\":\"⧶\",\"Dstrok\":\"Đ\",\"dstrok\":\"đ\",\"dtdot\":\"⋱\",\"dtri\":\"▿\",\"dtrif\":\"▾\",\"duarr\":\"⇵\",\"duhar\":\"⥯\",\"dwangle\":\"⦦\",\"DZcy\":\"Џ\",\"dzcy\":\"џ\",\"dzigrarr\":\"⟿\",\"Eacute\":\"É\",\"eacute\":\"é\",\"easter\":\"⩮\",\"Ecaron\":\"Ě\",\"ecaron\":\"ě\",\"Ecirc\":\"Ê\",\"ecirc\":\"ê\",\"ecir\":\"≖\",\"ecolon\":\"≕\",\"Ecy\":\"Э\",\"ecy\":\"э\",\"eDDot\":\"⩷\",\"Edot\":\"Ė\",\"edot\":\"ė\",\"eDot\":\"≑\",\"ee\":\"ⅇ\",\"efDot\":\"≒\",\"Efr\":\"𝔈\",\"efr\":\"𝔢\",\"eg\":\"⪚\",\"Egrave\":\"È\",\"egrave\":\"è\",\"egs\":\"⪖\",\"egsdot\":\"⪘\",\"el\":\"⪙\",\"Element\":\"∈\",\"elinters\":\"⏧\",\"ell\":\"ℓ\",\"els\":\"⪕\",\"elsdot\":\"⪗\",\"Emacr\":\"Ē\",\"emacr\":\"ē\",\"empty\":\"∅\",\"emptyset\":\"∅\",\"EmptySmallSquare\":\"◻\",\"emptyv\":\"∅\",\"EmptyVerySmallSquare\":\"▫\",\"emsp13\":\" \",\"emsp14\":\" \",\"emsp\":\" \",\"ENG\":\"Ŋ\",\"eng\":\"ŋ\",\"ensp\":\" \",\"Eogon\":\"Ę\",\"eogon\":\"ę\",\"Eopf\":\"𝔼\",\"eopf\":\"𝕖\",\"epar\":\"⋕\",\"eparsl\":\"⧣\",\"eplus\":\"⩱\",\"epsi\":\"ε\",\"Epsilon\":\"Ε\",\"epsilon\":\"ε\",\"epsiv\":\"ϵ\",\"eqcirc\":\"≖\",\"eqcolon\":\"≕\",\"eqsim\":\"≂\",\"eqslantgtr\":\"⪖\",\"eqslantless\":\"⪕\",\"Equal\":\"⩵\",\"equals\":\"=\",\"EqualTilde\":\"≂\",\"equest\":\"≟\",\"Equilibrium\":\"⇌\",\"equiv\":\"≡\",\"equivDD\":\"⩸\",\"eqvparsl\":\"⧥\",\"erarr\":\"⥱\",\"erDot\":\"≓\",\"escr\":\"ℯ\",\"Escr\":\"ℰ\",\"esdot\":\"≐\",\"Esim\":\"⩳\",\"esim\":\"≂\",\"Eta\":\"Η\",\"eta\":\"η\",\"ETH\":\"Ð\",\"eth\":\"ð\",\"Euml\":\"Ë\",\"euml\":\"ë\",\"euro\":\"€\",\"excl\":\"!\",\"exist\":\"∃\",\"Exists\":\"∃\",\"expectation\":\"ℰ\",\"exponentiale\":\"ⅇ\",\"ExponentialE\":\"ⅇ\",\"fallingdotseq\":\"≒\",\"Fcy\":\"Ф\",\"fcy\":\"ф\",\"female\":\"♀\",\"ffilig\":\"ﬃ\",\"fflig\":\"ﬀ\",\"ffllig\":\"ﬄ\",\"Ffr\":\"𝔉\",\"ffr\":\"𝔣\",\"filig\":\"ﬁ\",\"FilledSmallSquare\":\"◼\",\"FilledVerySmallSquare\":\"▪\",\"fjlig\":\"fj\",\"flat\":\"♭\",\"fllig\":\"ﬂ\",\"fltns\":\"▱\",\"fnof\":\"ƒ\",\"Fopf\":\"𝔽\",\"fopf\":\"𝕗\",\"forall\":\"∀\",\"ForAll\":\"∀\",\"fork\":\"⋔\",\"forkv\":\"⫙\",\"Fouriertrf\":\"ℱ\",\"fpartint\":\"⨍\",\"frac12\":\"½\",\"frac13\":\"⅓\",\"frac14\":\"¼\",\"frac15\":\"⅕\",\"frac16\":\"⅙\",\"frac18\":\"⅛\",\"frac23\":\"⅔\",\"frac25\":\"⅖\",\"frac34\":\"¾\",\"frac35\":\"⅗\",\"frac38\":\"⅜\",\"frac45\":\"⅘\",\"frac56\":\"⅚\",\"frac58\":\"⅝\",\"frac78\":\"⅞\",\"frasl\":\"⁄\",\"frown\":\"⌢\",\"fscr\":\"𝒻\",\"Fscr\":\"ℱ\",\"gacute\":\"ǵ\",\"Gamma\":\"Γ\",\"gamma\":\"γ\",\"Gammad\":\"Ϝ\",\"gammad\":\"ϝ\",\"gap\":\"⪆\",\"Gbreve\":\"Ğ\",\"gbreve\":\"ğ\",\"Gcedil\":\"Ģ\",\"Gcirc\":\"Ĝ\",\"gcirc\":\"ĝ\",\"Gcy\":\"Г\",\"gcy\":\"г\",\"Gdot\":\"Ġ\",\"gdot\":\"ġ\",\"ge\":\"≥\",\"gE\":\"≧\",\"gEl\":\"⪌\",\"gel\":\"⋛\",\"geq\":\"≥\",\"geqq\":\"≧\",\"geqslant\":\"⩾\",\"gescc\":\"⪩\",\"ges\":\"⩾\",\"gesdot\":\"⪀\",\"gesdoto\":\"⪂\",\"gesdotol\":\"⪄\",\"gesl\":\"⋛︀\",\"gesles\":\"⪔\",\"Gfr\":\"𝔊\",\"gfr\":\"𝔤\",\"gg\":\"≫\",\"Gg\":\"⋙\",\"ggg\":\"⋙\",\"gimel\":\"ℷ\",\"GJcy\":\"Ѓ\",\"gjcy\":\"ѓ\",\"gla\":\"⪥\",\"gl\":\"≷\",\"glE\":\"⪒\",\"glj\":\"⪤\",\"gnap\":\"⪊\",\"gnapprox\":\"⪊\",\"gne\":\"⪈\",\"gnE\":\"≩\",\"gneq\":\"⪈\",\"gneqq\":\"≩\",\"gnsim\":\"⋧\",\"Gopf\":\"𝔾\",\"gopf\":\"𝕘\",\"grave\":\"`\",\"GreaterEqual\":\"≥\",\"GreaterEqualLess\":\"⋛\",\"GreaterFullEqual\":\"≧\",\"GreaterGreater\":\"⪢\",\"GreaterLess\":\"≷\",\"GreaterSlantEqual\":\"⩾\",\"GreaterTilde\":\"≳\",\"Gscr\":\"𝒢\",\"gscr\":\"ℊ\",\"gsim\":\"≳\",\"gsime\":\"⪎\",\"gsiml\":\"⪐\",\"gtcc\":\"⪧\",\"gtcir\":\"⩺\",\"gt\":\">\",\"GT\":\">\",\"Gt\":\"≫\",\"gtdot\":\"⋗\",\"gtlPar\":\"⦕\",\"gtquest\":\"⩼\",\"gtrapprox\":\"⪆\",\"gtrarr\":\"⥸\",\"gtrdot\":\"⋗\",\"gtreqless\":\"⋛\",\"gtreqqless\":\"⪌\",\"gtrless\":\"≷\",\"gtrsim\":\"≳\",\"gvertneqq\":\"≩︀\",\"gvnE\":\"≩︀\",\"Hacek\":\"ˇ\",\"hairsp\":\" \",\"half\":\"½\",\"hamilt\":\"ℋ\",\"HARDcy\":\"Ъ\",\"hardcy\":\"ъ\",\"harrcir\":\"⥈\",\"harr\":\"↔\",\"hArr\":\"⇔\",\"harrw\":\"↭\",\"Hat\":\"^\",\"hbar\":\"ℏ\",\"Hcirc\":\"Ĥ\",\"hcirc\":\"ĥ\",\"hearts\":\"♥\",\"heartsuit\":\"♥\",\"hellip\":\"…\",\"hercon\":\"⊹\",\"hfr\":\"𝔥\",\"Hfr\":\"ℌ\",\"HilbertSpace\":\"ℋ\",\"hksearow\":\"⤥\",\"hkswarow\":\"⤦\",\"hoarr\":\"⇿\",\"homtht\":\"∻\",\"hookleftarrow\":\"↩\",\"hookrightarrow\":\"↪\",\"hopf\":\"𝕙\",\"Hopf\":\"ℍ\",\"horbar\":\"―\",\"HorizontalLine\":\"─\",\"hscr\":\"𝒽\",\"Hscr\":\"ℋ\",\"hslash\":\"ℏ\",\"Hstrok\":\"Ħ\",\"hstrok\":\"ħ\",\"HumpDownHump\":\"≎\",\"HumpEqual\":\"≏\",\"hybull\":\"⁃\",\"hyphen\":\"‐\",\"Iacute\":\"Í\",\"iacute\":\"í\",\"ic\":\"⁣\",\"Icirc\":\"Î\",\"icirc\":\"î\",\"Icy\":\"И\",\"icy\":\"и\",\"Idot\":\"İ\",\"IEcy\":\"Е\",\"iecy\":\"е\",\"iexcl\":\"¡\",\"iff\":\"⇔\",\"ifr\":\"𝔦\",\"Ifr\":\"ℑ\",\"Igrave\":\"Ì\",\"igrave\":\"ì\",\"ii\":\"ⅈ\",\"iiiint\":\"⨌\",\"iiint\":\"∭\",\"iinfin\":\"⧜\",\"iiota\":\"℩\",\"IJlig\":\"Ĳ\",\"ijlig\":\"ĳ\",\"Imacr\":\"Ī\",\"imacr\":\"ī\",\"image\":\"ℑ\",\"ImaginaryI\":\"ⅈ\",\"imagline\":\"ℐ\",\"imagpart\":\"ℑ\",\"imath\":\"ı\",\"Im\":\"ℑ\",\"imof\":\"⊷\",\"imped\":\"Ƶ\",\"Implies\":\"⇒\",\"incare\":\"℅\",\"in\":\"∈\",\"infin\":\"∞\",\"infintie\":\"⧝\",\"inodot\":\"ı\",\"intcal\":\"⊺\",\"int\":\"∫\",\"Int\":\"∬\",\"integers\":\"ℤ\",\"Integral\":\"∫\",\"intercal\":\"⊺\",\"Intersection\":\"⋂\",\"intlarhk\":\"⨗\",\"intprod\":\"⨼\",\"InvisibleComma\":\"⁣\",\"InvisibleTimes\":\"⁢\",\"IOcy\":\"Ё\",\"iocy\":\"ё\",\"Iogon\":\"Į\",\"iogon\":\"į\",\"Iopf\":\"𝕀\",\"iopf\":\"𝕚\",\"Iota\":\"Ι\",\"iota\":\"ι\",\"iprod\":\"⨼\",\"iquest\":\"¿\",\"iscr\":\"𝒾\",\"Iscr\":\"ℐ\",\"isin\":\"∈\",\"isindot\":\"⋵\",\"isinE\":\"⋹\",\"isins\":\"⋴\",\"isinsv\":\"⋳\",\"isinv\":\"∈\",\"it\":\"⁢\",\"Itilde\":\"Ĩ\",\"itilde\":\"ĩ\",\"Iukcy\":\"І\",\"iukcy\":\"і\",\"Iuml\":\"Ï\",\"iuml\":\"ï\",\"Jcirc\":\"Ĵ\",\"jcirc\":\"ĵ\",\"Jcy\":\"Й\",\"jcy\":\"й\",\"Jfr\":\"𝔍\",\"jfr\":\"𝔧\",\"jmath\":\"ȷ\",\"Jopf\":\"𝕁\",\"jopf\":\"𝕛\",\"Jscr\":\"𝒥\",\"jscr\":\"𝒿\",\"Jsercy\":\"Ј\",\"jsercy\":\"ј\",\"Jukcy\":\"Є\",\"jukcy\":\"є\",\"Kappa\":\"Κ\",\"kappa\":\"κ\",\"kappav\":\"ϰ\",\"Kcedil\":\"Ķ\",\"kcedil\":\"ķ\",\"Kcy\":\"К\",\"kcy\":\"к\",\"Kfr\":\"𝔎\",\"kfr\":\"𝔨\",\"kgreen\":\"ĸ\",\"KHcy\":\"Х\",\"khcy\":\"х\",\"KJcy\":\"Ќ\",\"kjcy\":\"ќ\",\"Kopf\":\"𝕂\",\"kopf\":\"𝕜\",\"Kscr\":\"𝒦\",\"kscr\":\"𝓀\",\"lAarr\":\"⇚\",\"Lacute\":\"Ĺ\",\"lacute\":\"ĺ\",\"laemptyv\":\"⦴\",\"lagran\":\"ℒ\",\"Lambda\":\"Λ\",\"lambda\":\"λ\",\"lang\":\"⟨\",\"Lang\":\"⟪\",\"langd\":\"⦑\",\"langle\":\"⟨\",\"lap\":\"⪅\",\"Laplacetrf\":\"ℒ\",\"laquo\":\"«\",\"larrb\":\"⇤\",\"larrbfs\":\"⤟\",\"larr\":\"←\",\"Larr\":\"↞\",\"lArr\":\"⇐\",\"larrfs\":\"⤝\",\"larrhk\":\"↩\",\"larrlp\":\"↫\",\"larrpl\":\"⤹\",\"larrsim\":\"⥳\",\"larrtl\":\"↢\",\"latail\":\"⤙\",\"lAtail\":\"⤛\",\"lat\":\"⪫\",\"late\":\"⪭\",\"lates\":\"⪭︀\",\"lbarr\":\"⤌\",\"lBarr\":\"⤎\",\"lbbrk\":\"❲\",\"lbrace\":\"{\",\"lbrack\":\"[\",\"lbrke\":\"⦋\",\"lbrksld\":\"⦏\",\"lbrkslu\":\"⦍\",\"Lcaron\":\"Ľ\",\"lcaron\":\"ľ\",\"Lcedil\":\"Ļ\",\"lcedil\":\"ļ\",\"lceil\":\"⌈\",\"lcub\":\"{\",\"Lcy\":\"Л\",\"lcy\":\"л\",\"ldca\":\"⤶\",\"ldquo\":\"“\",\"ldquor\":\"„\",\"ldrdhar\":\"⥧\",\"ldrushar\":\"⥋\",\"ldsh\":\"↲\",\"le\":\"≤\",\"lE\":\"≦\",\"LeftAngleBracket\":\"⟨\",\"LeftArrowBar\":\"⇤\",\"leftarrow\":\"←\",\"LeftArrow\":\"←\",\"Leftarrow\":\"⇐\",\"LeftArrowRightArrow\":\"⇆\",\"leftarrowtail\":\"↢\",\"LeftCeiling\":\"⌈\",\"LeftDoubleBracket\":\"⟦\",\"LeftDownTeeVector\":\"⥡\",\"LeftDownVectorBar\":\"⥙\",\"LeftDownVector\":\"⇃\",\"LeftFloor\":\"⌊\",\"leftharpoondown\":\"↽\",\"leftharpoonup\":\"↼\",\"leftleftarrows\":\"⇇\",\"leftrightarrow\":\"↔\",\"LeftRightArrow\":\"↔\",\"Leftrightarrow\":\"⇔\",\"leftrightarrows\":\"⇆\",\"leftrightharpoons\":\"⇋\",\"leftrightsquigarrow\":\"↭\",\"LeftRightVector\":\"⥎\",\"LeftTeeArrow\":\"↤\",\"LeftTee\":\"⊣\",\"LeftTeeVector\":\"⥚\",\"leftthreetimes\":\"⋋\",\"LeftTriangleBar\":\"⧏\",\"LeftTriangle\":\"⊲\",\"LeftTriangleEqual\":\"⊴\",\"LeftUpDownVector\":\"⥑\",\"LeftUpTeeVector\":\"⥠\",\"LeftUpVectorBar\":\"⥘\",\"LeftUpVector\":\"↿\",\"LeftVectorBar\":\"⥒\",\"LeftVector\":\"↼\",\"lEg\":\"⪋\",\"leg\":\"⋚\",\"leq\":\"≤\",\"leqq\":\"≦\",\"leqslant\":\"⩽\",\"lescc\":\"⪨\",\"les\":\"⩽\",\"lesdot\":\"⩿\",\"lesdoto\":\"⪁\",\"lesdotor\":\"⪃\",\"lesg\":\"⋚︀\",\"lesges\":\"⪓\",\"lessapprox\":\"⪅\",\"lessdot\":\"⋖\",\"lesseqgtr\":\"⋚\",\"lesseqqgtr\":\"⪋\",\"LessEqualGreater\":\"⋚\",\"LessFullEqual\":\"≦\",\"LessGreater\":\"≶\",\"lessgtr\":\"≶\",\"LessLess\":\"⪡\",\"lesssim\":\"≲\",\"LessSlantEqual\":\"⩽\",\"LessTilde\":\"≲\",\"lfisht\":\"⥼\",\"lfloor\":\"⌊\",\"Lfr\":\"𝔏\",\"lfr\":\"𝔩\",\"lg\":\"≶\",\"lgE\":\"⪑\",\"lHar\":\"⥢\",\"lhard\":\"↽\",\"lharu\":\"↼\",\"lharul\":\"⥪\",\"lhblk\":\"▄\",\"LJcy\":\"Љ\",\"ljcy\":\"љ\",\"llarr\":\"⇇\",\"ll\":\"≪\",\"Ll\":\"⋘\",\"llcorner\":\"⌞\",\"Lleftarrow\":\"⇚\",\"llhard\":\"⥫\",\"lltri\":\"◺\",\"Lmidot\":\"Ŀ\",\"lmidot\":\"ŀ\",\"lmoustache\":\"⎰\",\"lmoust\":\"⎰\",\"lnap\":\"⪉\",\"lnapprox\":\"⪉\",\"lne\":\"⪇\",\"lnE\":\"≨\",\"lneq\":\"⪇\",\"lneqq\":\"≨\",\"lnsim\":\"⋦\",\"loang\":\"⟬\",\"loarr\":\"⇽\",\"lobrk\":\"⟦\",\"longleftarrow\":\"⟵\",\"LongLeftArrow\":\"⟵\",\"Longleftarrow\":\"⟸\",\"longleftrightarrow\":\"⟷\",\"LongLeftRightArrow\":\"⟷\",\"Longleftrightarrow\":\"⟺\",\"longmapsto\":\"⟼\",\"longrightarrow\":\"⟶\",\"LongRightArrow\":\"⟶\",\"Longrightarrow\":\"⟹\",\"looparrowleft\":\"↫\",\"looparrowright\":\"↬\",\"lopar\":\"⦅\",\"Lopf\":\"𝕃\",\"lopf\":\"𝕝\",\"loplus\":\"⨭\",\"lotimes\":\"⨴\",\"lowast\":\"∗\",\"lowbar\":\"_\",\"LowerLeftArrow\":\"↙\",\"LowerRightArrow\":\"↘\",\"loz\":\"◊\",\"lozenge\":\"◊\",\"lozf\":\"⧫\",\"lpar\":\"(\",\"lparlt\":\"⦓\",\"lrarr\":\"⇆\",\"lrcorner\":\"⌟\",\"lrhar\":\"⇋\",\"lrhard\":\"⥭\",\"lrm\":\"‎\",\"lrtri\":\"⊿\",\"lsaquo\":\"‹\",\"lscr\":\"𝓁\",\"Lscr\":\"ℒ\",\"lsh\":\"↰\",\"Lsh\":\"↰\",\"lsim\":\"≲\",\"lsime\":\"⪍\",\"lsimg\":\"⪏\",\"lsqb\":\"[\",\"lsquo\":\"‘\",\"lsquor\":\"‚\",\"Lstrok\":\"Ł\",\"lstrok\":\"ł\",\"ltcc\":\"⪦\",\"ltcir\":\"⩹\",\"lt\":\"<\",\"LT\":\"<\",\"Lt\":\"≪\",\"ltdot\":\"⋖\",\"lthree\":\"⋋\",\"ltimes\":\"⋉\",\"ltlarr\":\"⥶\",\"ltquest\":\"⩻\",\"ltri\":\"◃\",\"ltrie\":\"⊴\",\"ltrif\":\"◂\",\"ltrPar\":\"⦖\",\"lurdshar\":\"⥊\",\"luruhar\":\"⥦\",\"lvertneqq\":\"≨︀\",\"lvnE\":\"≨︀\",\"macr\":\"¯\",\"male\":\"♂\",\"malt\":\"✠\",\"maltese\":\"✠\",\"Map\":\"⤅\",\"map\":\"↦\",\"mapsto\":\"↦\",\"mapstodown\":\"↧\",\"mapstoleft\":\"↤\",\"mapstoup\":\"↥\",\"marker\":\"▮\",\"mcomma\":\"⨩\",\"Mcy\":\"М\",\"mcy\":\"м\",\"mdash\":\"—\",\"mDDot\":\"∺\",\"measuredangle\":\"∡\",\"MediumSpace\":\" \",\"Mellintrf\":\"ℳ\",\"Mfr\":\"𝔐\",\"mfr\":\"𝔪\",\"mho\":\"℧\",\"micro\":\"µ\",\"midast\":\"*\",\"midcir\":\"⫰\",\"mid\":\"∣\",\"middot\":\"·\",\"minusb\":\"⊟\",\"minus\":\"−\",\"minusd\":\"∸\",\"minusdu\":\"⨪\",\"MinusPlus\":\"∓\",\"mlcp\":\"⫛\",\"mldr\":\"…\",\"mnplus\":\"∓\",\"models\":\"⊧\",\"Mopf\":\"𝕄\",\"mopf\":\"𝕞\",\"mp\":\"∓\",\"mscr\":\"𝓂\",\"Mscr\":\"ℳ\",\"mstpos\":\"∾\",\"Mu\":\"Μ\",\"mu\":\"μ\",\"multimap\":\"⊸\",\"mumap\":\"⊸\",\"nabla\":\"∇\",\"Nacute\":\"Ń\",\"nacute\":\"ń\",\"nang\":\"∠⃒\",\"nap\":\"≉\",\"napE\":\"⩰̸\",\"napid\":\"≋̸\",\"napos\":\"ŉ\",\"napprox\":\"≉\",\"natural\":\"♮\",\"naturals\":\"ℕ\",\"natur\":\"♮\",\"nbsp\":\" \",\"nbump\":\"≎̸\",\"nbumpe\":\"≏̸\",\"ncap\":\"⩃\",\"Ncaron\":\"Ň\",\"ncaron\":\"ň\",\"Ncedil\":\"Ņ\",\"ncedil\":\"ņ\",\"ncong\":\"≇\",\"ncongdot\":\"⩭̸\",\"ncup\":\"⩂\",\"Ncy\":\"Н\",\"ncy\":\"н\",\"ndash\":\"–\",\"nearhk\":\"⤤\",\"nearr\":\"↗\",\"neArr\":\"⇗\",\"nearrow\":\"↗\",\"ne\":\"≠\",\"nedot\":\"≐̸\",\"NegativeMediumSpace\":\"​\",\"NegativeThickSpace\":\"​\",\"NegativeThinSpace\":\"​\",\"NegativeVeryThinSpace\":\"​\",\"nequiv\":\"≢\",\"nesear\":\"⤨\",\"nesim\":\"≂̸\",\"NestedGreaterGreater\":\"≫\",\"NestedLessLess\":\"≪\",\"NewLine\":\"\\n\",\"nexist\":\"∄\",\"nexists\":\"∄\",\"Nfr\":\"𝔑\",\"nfr\":\"𝔫\",\"ngE\":\"≧̸\",\"nge\":\"≱\",\"ngeq\":\"≱\",\"ngeqq\":\"≧̸\",\"ngeqslant\":\"⩾̸\",\"nges\":\"⩾̸\",\"nGg\":\"⋙̸\",\"ngsim\":\"≵\",\"nGt\":\"≫⃒\",\"ngt\":\"≯\",\"ngtr\":\"≯\",\"nGtv\":\"≫̸\",\"nharr\":\"↮\",\"nhArr\":\"⇎\",\"nhpar\":\"⫲\",\"ni\":\"∋\",\"nis\":\"⋼\",\"nisd\":\"⋺\",\"niv\":\"∋\",\"NJcy\":\"Њ\",\"njcy\":\"њ\",\"nlarr\":\"↚\",\"nlArr\":\"⇍\",\"nldr\":\"‥\",\"nlE\":\"≦̸\",\"nle\":\"≰\",\"nleftarrow\":\"↚\",\"nLeftarrow\":\"⇍\",\"nleftrightarrow\":\"↮\",\"nLeftrightarrow\":\"⇎\",\"nleq\":\"≰\",\"nleqq\":\"≦̸\",\"nleqslant\":\"⩽̸\",\"nles\":\"⩽̸\",\"nless\":\"≮\",\"nLl\":\"⋘̸\",\"nlsim\":\"≴\",\"nLt\":\"≪⃒\",\"nlt\":\"≮\",\"nltri\":\"⋪\",\"nltrie\":\"⋬\",\"nLtv\":\"≪̸\",\"nmid\":\"∤\",\"NoBreak\":\"⁠\",\"NonBreakingSpace\":\" \",\"nopf\":\"𝕟\",\"Nopf\":\"ℕ\",\"Not\":\"⫬\",\"not\":\"¬\",\"NotCongruent\":\"≢\",\"NotCupCap\":\"≭\",\"NotDoubleVerticalBar\":\"∦\",\"NotElement\":\"∉\",\"NotEqual\":\"≠\",\"NotEqualTilde\":\"≂̸\",\"NotExists\":\"∄\",\"NotGreater\":\"≯\",\"NotGreaterEqual\":\"≱\",\"NotGreaterFullEqual\":\"≧̸\",\"NotGreaterGreater\":\"≫̸\",\"NotGreaterLess\":\"≹\",\"NotGreaterSlantEqual\":\"⩾̸\",\"NotGreaterTilde\":\"≵\",\"NotHumpDownHump\":\"≎̸\",\"NotHumpEqual\":\"≏̸\",\"notin\":\"∉\",\"notindot\":\"⋵̸\",\"notinE\":\"⋹̸\",\"notinva\":\"∉\",\"notinvb\":\"⋷\",\"notinvc\":\"⋶\",\"NotLeftTriangleBar\":\"⧏̸\",\"NotLeftTriangle\":\"⋪\",\"NotLeftTriangleEqual\":\"⋬\",\"NotLess\":\"≮\",\"NotLessEqual\":\"≰\",\"NotLessGreater\":\"≸\",\"NotLessLess\":\"≪̸\",\"NotLessSlantEqual\":\"⩽̸\",\"NotLessTilde\":\"≴\",\"NotNestedGreaterGreater\":\"⪢̸\",\"NotNestedLessLess\":\"⪡̸\",\"notni\":\"∌\",\"notniva\":\"∌\",\"notnivb\":\"⋾\",\"notnivc\":\"⋽\",\"NotPrecedes\":\"⊀\",\"NotPrecedesEqual\":\"⪯̸\",\"NotPrecedesSlantEqual\":\"⋠\",\"NotReverseElement\":\"∌\",\"NotRightTriangleBar\":\"⧐̸\",\"NotRightTriangle\":\"⋫\",\"NotRightTriangleEqual\":\"⋭\",\"NotSquareSubset\":\"⊏̸\",\"NotSquareSubsetEqual\":\"⋢\",\"NotSquareSuperset\":\"⊐̸\",\"NotSquareSupersetEqual\":\"⋣\",\"NotSubset\":\"⊂⃒\",\"NotSubsetEqual\":\"⊈\",\"NotSucceeds\":\"⊁\",\"NotSucceedsEqual\":\"⪰̸\",\"NotSucceedsSlantEqual\":\"⋡\",\"NotSucceedsTilde\":\"≿̸\",\"NotSuperset\":\"⊃⃒\",\"NotSupersetEqual\":\"⊉\",\"NotTilde\":\"≁\",\"NotTildeEqual\":\"≄\",\"NotTildeFullEqual\":\"≇\",\"NotTildeTilde\":\"≉\",\"NotVerticalBar\":\"∤\",\"nparallel\":\"∦\",\"npar\":\"∦\",\"nparsl\":\"⫽⃥\",\"npart\":\"∂̸\",\"npolint\":\"⨔\",\"npr\":\"⊀\",\"nprcue\":\"⋠\",\"nprec\":\"⊀\",\"npreceq\":\"⪯̸\",\"npre\":\"⪯̸\",\"nrarrc\":\"⤳̸\",\"nrarr\":\"↛\",\"nrArr\":\"⇏\",\"nrarrw\":\"↝̸\",\"nrightarrow\":\"↛\",\"nRightarrow\":\"⇏\",\"nrtri\":\"⋫\",\"nrtrie\":\"⋭\",\"nsc\":\"⊁\",\"nsccue\":\"⋡\",\"nsce\":\"⪰̸\",\"Nscr\":\"𝒩\",\"nscr\":\"𝓃\",\"nshortmid\":\"∤\",\"nshortparallel\":\"∦\",\"nsim\":\"≁\",\"nsime\":\"≄\",\"nsimeq\":\"≄\",\"nsmid\":\"∤\",\"nspar\":\"∦\",\"nsqsube\":\"⋢\",\"nsqsupe\":\"⋣\",\"nsub\":\"⊄\",\"nsubE\":\"⫅̸\",\"nsube\":\"⊈\",\"nsubset\":\"⊂⃒\",\"nsubseteq\":\"⊈\",\"nsubseteqq\":\"⫅̸\",\"nsucc\":\"⊁\",\"nsucceq\":\"⪰̸\",\"nsup\":\"⊅\",\"nsupE\":\"⫆̸\",\"nsupe\":\"⊉\",\"nsupset\":\"⊃⃒\",\"nsupseteq\":\"⊉\",\"nsupseteqq\":\"⫆̸\",\"ntgl\":\"≹\",\"Ntilde\":\"Ñ\",\"ntilde\":\"ñ\",\"ntlg\":\"≸\",\"ntriangleleft\":\"⋪\",\"ntrianglelefteq\":\"⋬\",\"ntriangleright\":\"⋫\",\"ntrianglerighteq\":\"⋭\",\"Nu\":\"Ν\",\"nu\":\"ν\",\"num\":\"#\",\"numero\":\"№\",\"numsp\":\" \",\"nvap\":\"≍⃒\",\"nvdash\":\"⊬\",\"nvDash\":\"⊭\",\"nVdash\":\"⊮\",\"nVDash\":\"⊯\",\"nvge\":\"≥⃒\",\"nvgt\":\">⃒\",\"nvHarr\":\"⤄\",\"nvinfin\":\"⧞\",\"nvlArr\":\"⤂\",\"nvle\":\"≤⃒\",\"nvlt\":\"<⃒\",\"nvltrie\":\"⊴⃒\",\"nvrArr\":\"⤃\",\"nvrtrie\":\"⊵⃒\",\"nvsim\":\"∼⃒\",\"nwarhk\":\"⤣\",\"nwarr\":\"↖\",\"nwArr\":\"⇖\",\"nwarrow\":\"↖\",\"nwnear\":\"⤧\",\"Oacute\":\"Ó\",\"oacute\":\"ó\",\"oast\":\"⊛\",\"Ocirc\":\"Ô\",\"ocirc\":\"ô\",\"ocir\":\"⊚\",\"Ocy\":\"О\",\"ocy\":\"о\",\"odash\":\"⊝\",\"Odblac\":\"Ő\",\"odblac\":\"ő\",\"odiv\":\"⨸\",\"odot\":\"⊙\",\"odsold\":\"⦼\",\"OElig\":\"Œ\",\"oelig\":\"œ\",\"ofcir\":\"⦿\",\"Ofr\":\"𝔒\",\"ofr\":\"𝔬\",\"ogon\":\"˛\",\"Ograve\":\"Ò\",\"ograve\":\"ò\",\"ogt\":\"⧁\",\"ohbar\":\"⦵\",\"ohm\":\"Ω\",\"oint\":\"∮\",\"olarr\":\"↺\",\"olcir\":\"⦾\",\"olcross\":\"⦻\",\"oline\":\"‾\",\"olt\":\"⧀\",\"Omacr\":\"Ō\",\"omacr\":\"ō\",\"Omega\":\"Ω\",\"omega\":\"ω\",\"Omicron\":\"Ο\",\"omicron\":\"ο\",\"omid\":\"⦶\",\"ominus\":\"⊖\",\"Oopf\":\"𝕆\",\"oopf\":\"𝕠\",\"opar\":\"⦷\",\"OpenCurlyDoubleQuote\":\"“\",\"OpenCurlyQuote\":\"‘\",\"operp\":\"⦹\",\"oplus\":\"⊕\",\"orarr\":\"↻\",\"Or\":\"⩔\",\"or\":\"∨\",\"ord\":\"⩝\",\"order\":\"ℴ\",\"orderof\":\"ℴ\",\"ordf\":\"ª\",\"ordm\":\"º\",\"origof\":\"⊶\",\"oror\":\"⩖\",\"orslope\":\"⩗\",\"orv\":\"⩛\",\"oS\":\"Ⓢ\",\"Oscr\":\"𝒪\",\"oscr\":\"ℴ\",\"Oslash\":\"Ø\",\"oslash\":\"ø\",\"osol\":\"⊘\",\"Otilde\":\"Õ\",\"otilde\":\"õ\",\"otimesas\":\"⨶\",\"Otimes\":\"⨷\",\"otimes\":\"⊗\",\"Ouml\":\"Ö\",\"ouml\":\"ö\",\"ovbar\":\"⌽\",\"OverBar\":\"‾\",\"OverBrace\":\"⏞\",\"OverBracket\":\"⎴\",\"OverParenthesis\":\"⏜\",\"para\":\"¶\",\"parallel\":\"∥\",\"par\":\"∥\",\"parsim\":\"⫳\",\"parsl\":\"⫽\",\"part\":\"∂\",\"PartialD\":\"∂\",\"Pcy\":\"П\",\"pcy\":\"п\",\"percnt\":\"%\",\"period\":\".\",\"permil\":\"‰\",\"perp\":\"⊥\",\"pertenk\":\"‱\",\"Pfr\":\"𝔓\",\"pfr\":\"𝔭\",\"Phi\":\"Φ\",\"phi\":\"φ\",\"phiv\":\"ϕ\",\"phmmat\":\"ℳ\",\"phone\":\"☎\",\"Pi\":\"Π\",\"pi\":\"π\",\"pitchfork\":\"⋔\",\"piv\":\"ϖ\",\"planck\":\"ℏ\",\"planckh\":\"ℎ\",\"plankv\":\"ℏ\",\"plusacir\":\"⨣\",\"plusb\":\"⊞\",\"pluscir\":\"⨢\",\"plus\":\"+\",\"plusdo\":\"∔\",\"plusdu\":\"⨥\",\"pluse\":\"⩲\",\"PlusMinus\":\"±\",\"plusmn\":\"±\",\"plussim\":\"⨦\",\"plustwo\":\"⨧\",\"pm\":\"±\",\"Poincareplane\":\"ℌ\",\"pointint\":\"⨕\",\"popf\":\"𝕡\",\"Popf\":\"ℙ\",\"pound\":\"£\",\"prap\":\"⪷\",\"Pr\":\"⪻\",\"pr\":\"≺\",\"prcue\":\"≼\",\"precapprox\":\"⪷\",\"prec\":\"≺\",\"preccurlyeq\":\"≼\",\"Precedes\":\"≺\",\"PrecedesEqual\":\"⪯\",\"PrecedesSlantEqual\":\"≼\",\"PrecedesTilde\":\"≾\",\"preceq\":\"⪯\",\"precnapprox\":\"⪹\",\"precneqq\":\"⪵\",\"precnsim\":\"⋨\",\"pre\":\"⪯\",\"prE\":\"⪳\",\"precsim\":\"≾\",\"prime\":\"′\",\"Prime\":\"″\",\"primes\":\"ℙ\",\"prnap\":\"⪹\",\"prnE\":\"⪵\",\"prnsim\":\"⋨\",\"prod\":\"∏\",\"Product\":\"∏\",\"profalar\":\"⌮\",\"profline\":\"⌒\",\"profsurf\":\"⌓\",\"prop\":\"∝\",\"Proportional\":\"∝\",\"Proportion\":\"∷\",\"propto\":\"∝\",\"prsim\":\"≾\",\"prurel\":\"⊰\",\"Pscr\":\"𝒫\",\"pscr\":\"𝓅\",\"Psi\":\"Ψ\",\"psi\":\"ψ\",\"puncsp\":\" \",\"Qfr\":\"𝔔\",\"qfr\":\"𝔮\",\"qint\":\"⨌\",\"qopf\":\"𝕢\",\"Qopf\":\"ℚ\",\"qprime\":\"⁗\",\"Qscr\":\"𝒬\",\"qscr\":\"𝓆\",\"quaternions\":\"ℍ\",\"quatint\":\"⨖\",\"quest\":\"?\",\"questeq\":\"≟\",\"quot\":\"\\\"\",\"QUOT\":\"\\\"\",\"rAarr\":\"⇛\",\"race\":\"∽̱\",\"Racute\":\"Ŕ\",\"racute\":\"ŕ\",\"radic\":\"√\",\"raemptyv\":\"⦳\",\"rang\":\"⟩\",\"Rang\":\"⟫\",\"rangd\":\"⦒\",\"range\":\"⦥\",\"rangle\":\"⟩\",\"raquo\":\"»\",\"rarrap\":\"⥵\",\"rarrb\":\"⇥\",\"rarrbfs\":\"⤠\",\"rarrc\":\"⤳\",\"rarr\":\"→\",\"Rarr\":\"↠\",\"rArr\":\"⇒\",\"rarrfs\":\"⤞\",\"rarrhk\":\"↪\",\"rarrlp\":\"↬\",\"rarrpl\":\"⥅\",\"rarrsim\":\"⥴\",\"Rarrtl\":\"⤖\",\"rarrtl\":\"↣\",\"rarrw\":\"↝\",\"ratail\":\"⤚\",\"rAtail\":\"⤜\",\"ratio\":\"∶\",\"rationals\":\"ℚ\",\"rbarr\":\"⤍\",\"rBarr\":\"⤏\",\"RBarr\":\"⤐\",\"rbbrk\":\"❳\",\"rbrace\":\"}\",\"rbrack\":\"]\",\"rbrke\":\"⦌\",\"rbrksld\":\"⦎\",\"rbrkslu\":\"⦐\",\"Rcaron\":\"Ř\",\"rcaron\":\"ř\",\"Rcedil\":\"Ŗ\",\"rcedil\":\"ŗ\",\"rceil\":\"⌉\",\"rcub\":\"}\",\"Rcy\":\"Р\",\"rcy\":\"р\",\"rdca\":\"⤷\",\"rdldhar\":\"⥩\",\"rdquo\":\"”\",\"rdquor\":\"”\",\"rdsh\":\"↳\",\"real\":\"ℜ\",\"realine\":\"ℛ\",\"realpart\":\"ℜ\",\"reals\":\"ℝ\",\"Re\":\"ℜ\",\"rect\":\"▭\",\"reg\":\"®\",\"REG\":\"®\",\"ReverseElement\":\"∋\",\"ReverseEquilibrium\":\"⇋\",\"ReverseUpEquilibrium\":\"⥯\",\"rfisht\":\"⥽\",\"rfloor\":\"⌋\",\"rfr\":\"𝔯\",\"Rfr\":\"ℜ\",\"rHar\":\"⥤\",\"rhard\":\"⇁\",\"rharu\":\"⇀\",\"rharul\":\"⥬\",\"Rho\":\"Ρ\",\"rho\":\"ρ\",\"rhov\":\"ϱ\",\"RightAngleBracket\":\"⟩\",\"RightArrowBar\":\"⇥\",\"rightarrow\":\"→\",\"RightArrow\":\"→\",\"Rightarrow\":\"⇒\",\"RightArrowLeftArrow\":\"⇄\",\"rightarrowtail\":\"↣\",\"RightCeiling\":\"⌉\",\"RightDoubleBracket\":\"⟧\",\"RightDownTeeVector\":\"⥝\",\"RightDownVectorBar\":\"⥕\",\"RightDownVector\":\"⇂\",\"RightFloor\":\"⌋\",\"rightharpoondown\":\"⇁\",\"rightharpoonup\":\"⇀\",\"rightleftarrows\":\"⇄\",\"rightleftharpoons\":\"⇌\",\"rightrightarrows\":\"⇉\",\"rightsquigarrow\":\"↝\",\"RightTeeArrow\":\"↦\",\"RightTee\":\"⊢\",\"RightTeeVector\":\"⥛\",\"rightthreetimes\":\"⋌\",\"RightTriangleBar\":\"⧐\",\"RightTriangle\":\"⊳\",\"RightTriangleEqual\":\"⊵\",\"RightUpDownVector\":\"⥏\",\"RightUpTeeVector\":\"⥜\",\"RightUpVectorBar\":\"⥔\",\"RightUpVector\":\"↾\",\"RightVectorBar\":\"⥓\",\"RightVector\":\"⇀\",\"ring\":\"˚\",\"risingdotseq\":\"≓\",\"rlarr\":\"⇄\",\"rlhar\":\"⇌\",\"rlm\":\"‏\",\"rmoustache\":\"⎱\",\"rmoust\":\"⎱\",\"rnmid\":\"⫮\",\"roang\":\"⟭\",\"roarr\":\"⇾\",\"robrk\":\"⟧\",\"ropar\":\"⦆\",\"ropf\":\"𝕣\",\"Ropf\":\"ℝ\",\"roplus\":\"⨮\",\"rotimes\":\"⨵\",\"RoundImplies\":\"⥰\",\"rpar\":\")\",\"rpargt\":\"⦔\",\"rppolint\":\"⨒\",\"rrarr\":\"⇉\",\"Rrightarrow\":\"⇛\",\"rsaquo\":\"›\",\"rscr\":\"𝓇\",\"Rscr\":\"ℛ\",\"rsh\":\"↱\",\"Rsh\":\"↱\",\"rsqb\":\"]\",\"rsquo\":\"’\",\"rsquor\":\"’\",\"rthree\":\"⋌\",\"rtimes\":\"⋊\",\"rtri\":\"▹\",\"rtrie\":\"⊵\",\"rtrif\":\"▸\",\"rtriltri\":\"⧎\",\"RuleDelayed\":\"⧴\",\"ruluhar\":\"⥨\",\"rx\":\"℞\",\"Sacute\":\"Ś\",\"sacute\":\"ś\",\"sbquo\":\"‚\",\"scap\":\"⪸\",\"Scaron\":\"Š\",\"scaron\":\"š\",\"Sc\":\"⪼\",\"sc\":\"≻\",\"sccue\":\"≽\",\"sce\":\"⪰\",\"scE\":\"⪴\",\"Scedil\":\"Ş\",\"scedil\":\"ş\",\"Scirc\":\"Ŝ\",\"scirc\":\"ŝ\",\"scnap\":\"⪺\",\"scnE\":\"⪶\",\"scnsim\":\"⋩\",\"scpolint\":\"⨓\",\"scsim\":\"≿\",\"Scy\":\"С\",\"scy\":\"с\",\"sdotb\":\"⊡\",\"sdot\":\"⋅\",\"sdote\":\"⩦\",\"searhk\":\"⤥\",\"searr\":\"↘\",\"seArr\":\"⇘\",\"searrow\":\"↘\",\"sect\":\"§\",\"semi\":\";\",\"seswar\":\"⤩\",\"setminus\":\"∖\",\"setmn\":\"∖\",\"sext\":\"✶\",\"Sfr\":\"𝔖\",\"sfr\":\"𝔰\",\"sfrown\":\"⌢\",\"sharp\":\"♯\",\"SHCHcy\":\"Щ\",\"shchcy\":\"щ\",\"SHcy\":\"Ш\",\"shcy\":\"ш\",\"ShortDownArrow\":\"↓\",\"ShortLeftArrow\":\"←\",\"shortmid\":\"∣\",\"shortparallel\":\"∥\",\"ShortRightArrow\":\"→\",\"ShortUpArrow\":\"↑\",\"shy\":\"­\",\"Sigma\":\"Σ\",\"sigma\":\"σ\",\"sigmaf\":\"ς\",\"sigmav\":\"ς\",\"sim\":\"∼\",\"simdot\":\"⩪\",\"sime\":\"≃\",\"simeq\":\"≃\",\"simg\":\"⪞\",\"simgE\":\"⪠\",\"siml\":\"⪝\",\"simlE\":\"⪟\",\"simne\":\"≆\",\"simplus\":\"⨤\",\"simrarr\":\"⥲\",\"slarr\":\"←\",\"SmallCircle\":\"∘\",\"smallsetminus\":\"∖\",\"smashp\":\"⨳\",\"smeparsl\":\"⧤\",\"smid\":\"∣\",\"smile\":\"⌣\",\"smt\":\"⪪\",\"smte\":\"⪬\",\"smtes\":\"⪬︀\",\"SOFTcy\":\"Ь\",\"softcy\":\"ь\",\"solbar\":\"⌿\",\"solb\":\"⧄\",\"sol\":\"/\",\"Sopf\":\"𝕊\",\"sopf\":\"𝕤\",\"spades\":\"♠\",\"spadesuit\":\"♠\",\"spar\":\"∥\",\"sqcap\":\"⊓\",\"sqcaps\":\"⊓︀\",\"sqcup\":\"⊔\",\"sqcups\":\"⊔︀\",\"Sqrt\":\"√\",\"sqsub\":\"⊏\",\"sqsube\":\"⊑\",\"sqsubset\":\"⊏\",\"sqsubseteq\":\"⊑\",\"sqsup\":\"⊐\",\"sqsupe\":\"⊒\",\"sqsupset\":\"⊐\",\"sqsupseteq\":\"⊒\",\"square\":\"□\",\"Square\":\"□\",\"SquareIntersection\":\"⊓\",\"SquareSubset\":\"⊏\",\"SquareSubsetEqual\":\"⊑\",\"SquareSuperset\":\"⊐\",\"SquareSupersetEqual\":\"⊒\",\"SquareUnion\":\"⊔\",\"squarf\":\"▪\",\"squ\":\"□\",\"squf\":\"▪\",\"srarr\":\"→\",\"Sscr\":\"𝒮\",\"sscr\":\"𝓈\",\"ssetmn\":\"∖\",\"ssmile\":\"⌣\",\"sstarf\":\"⋆\",\"Star\":\"⋆\",\"star\":\"☆\",\"starf\":\"★\",\"straightepsilon\":\"ϵ\",\"straightphi\":\"ϕ\",\"strns\":\"¯\",\"sub\":\"⊂\",\"Sub\":\"⋐\",\"subdot\":\"⪽\",\"subE\":\"⫅\",\"sube\":\"⊆\",\"subedot\":\"⫃\",\"submult\":\"⫁\",\"subnE\":\"⫋\",\"subne\":\"⊊\",\"subplus\":\"⪿\",\"subrarr\":\"⥹\",\"subset\":\"⊂\",\"Subset\":\"⋐\",\"subseteq\":\"⊆\",\"subseteqq\":\"⫅\",\"SubsetEqual\":\"⊆\",\"subsetneq\":\"⊊\",\"subsetneqq\":\"⫋\",\"subsim\":\"⫇\",\"subsub\":\"⫕\",\"subsup\":\"⫓\",\"succapprox\":\"⪸\",\"succ\":\"≻\",\"succcurlyeq\":\"≽\",\"Succeeds\":\"≻\",\"SucceedsEqual\":\"⪰\",\"SucceedsSlantEqual\":\"≽\",\"SucceedsTilde\":\"≿\",\"succeq\":\"⪰\",\"succnapprox\":\"⪺\",\"succneqq\":\"⪶\",\"succnsim\":\"⋩\",\"succsim\":\"≿\",\"SuchThat\":\"∋\",\"sum\":\"∑\",\"Sum\":\"∑\",\"sung\":\"♪\",\"sup1\":\"¹\",\"sup2\":\"²\",\"sup3\":\"³\",\"sup\":\"⊃\",\"Sup\":\"⋑\",\"supdot\":\"⪾\",\"supdsub\":\"⫘\",\"supE\":\"⫆\",\"supe\":\"⊇\",\"supedot\":\"⫄\",\"Superset\":\"⊃\",\"SupersetEqual\":\"⊇\",\"suphsol\":\"⟉\",\"suphsub\":\"⫗\",\"suplarr\":\"⥻\",\"supmult\":\"⫂\",\"supnE\":\"⫌\",\"supne\":\"⊋\",\"supplus\":\"⫀\",\"supset\":\"⊃\",\"Supset\":\"⋑\",\"supseteq\":\"⊇\",\"supseteqq\":\"⫆\",\"supsetneq\":\"⊋\",\"supsetneqq\":\"⫌\",\"supsim\":\"⫈\",\"supsub\":\"⫔\",\"supsup\":\"⫖\",\"swarhk\":\"⤦\",\"swarr\":\"↙\",\"swArr\":\"⇙\",\"swarrow\":\"↙\",\"swnwar\":\"⤪\",\"szlig\":\"ß\",\"Tab\":\"\\t\",\"target\":\"⌖\",\"Tau\":\"Τ\",\"tau\":\"τ\",\"tbrk\":\"⎴\",\"Tcaron\":\"Ť\",\"tcaron\":\"ť\",\"Tcedil\":\"Ţ\",\"tcedil\":\"ţ\",\"Tcy\":\"Т\",\"tcy\":\"т\",\"tdot\":\"⃛\",\"telrec\":\"⌕\",\"Tfr\":\"𝔗\",\"tfr\":\"𝔱\",\"there4\":\"∴\",\"therefore\":\"∴\",\"Therefore\":\"∴\",\"Theta\":\"Θ\",\"theta\":\"θ\",\"thetasym\":\"ϑ\",\"thetav\":\"ϑ\",\"thickapprox\":\"≈\",\"thicksim\":\"∼\",\"ThickSpace\":\"  \",\"ThinSpace\":\" \",\"thinsp\":\" \",\"thkap\":\"≈\",\"thksim\":\"∼\",\"THORN\":\"Þ\",\"thorn\":\"þ\",\"tilde\":\"˜\",\"Tilde\":\"∼\",\"TildeEqual\":\"≃\",\"TildeFullEqual\":\"≅\",\"TildeTilde\":\"≈\",\"timesbar\":\"⨱\",\"timesb\":\"⊠\",\"times\":\"×\",\"timesd\":\"⨰\",\"tint\":\"∭\",\"toea\":\"⤨\",\"topbot\":\"⌶\",\"topcir\":\"⫱\",\"top\":\"⊤\",\"Topf\":\"𝕋\",\"topf\":\"𝕥\",\"topfork\":\"⫚\",\"tosa\":\"⤩\",\"tprime\":\"‴\",\"trade\":\"™\",\"TRADE\":\"™\",\"triangle\":\"▵\",\"triangledown\":\"▿\",\"triangleleft\":\"◃\",\"trianglelefteq\":\"⊴\",\"triangleq\":\"≜\",\"triangleright\":\"▹\",\"trianglerighteq\":\"⊵\",\"tridot\":\"◬\",\"trie\":\"≜\",\"triminus\":\"⨺\",\"TripleDot\":\"⃛\",\"triplus\":\"⨹\",\"trisb\":\"⧍\",\"tritime\":\"⨻\",\"trpezium\":\"⏢\",\"Tscr\":\"𝒯\",\"tscr\":\"𝓉\",\"TScy\":\"Ц\",\"tscy\":\"ц\",\"TSHcy\":\"Ћ\",\"tshcy\":\"ћ\",\"Tstrok\":\"Ŧ\",\"tstrok\":\"ŧ\",\"twixt\":\"≬\",\"twoheadleftarrow\":\"↞\",\"twoheadrightarrow\":\"↠\",\"Uacute\":\"Ú\",\"uacute\":\"ú\",\"uarr\":\"↑\",\"Uarr\":\"↟\",\"uArr\":\"⇑\",\"Uarrocir\":\"⥉\",\"Ubrcy\":\"Ў\",\"ubrcy\":\"ў\",\"Ubreve\":\"Ŭ\",\"ubreve\":\"ŭ\",\"Ucirc\":\"Û\",\"ucirc\":\"û\",\"Ucy\":\"У\",\"ucy\":\"у\",\"udarr\":\"⇅\",\"Udblac\":\"Ű\",\"udblac\":\"ű\",\"udhar\":\"⥮\",\"ufisht\":\"⥾\",\"Ufr\":\"𝔘\",\"ufr\":\"𝔲\",\"Ugrave\":\"Ù\",\"ugrave\":\"ù\",\"uHar\":\"⥣\",\"uharl\":\"↿\",\"uharr\":\"↾\",\"uhblk\":\"▀\",\"ulcorn\":\"⌜\",\"ulcorner\":\"⌜\",\"ulcrop\":\"⌏\",\"ultri\":\"◸\",\"Umacr\":\"Ū\",\"umacr\":\"ū\",\"uml\":\"¨\",\"UnderBar\":\"_\",\"UnderBrace\":\"⏟\",\"UnderBracket\":\"⎵\",\"UnderParenthesis\":\"⏝\",\"Union\":\"⋃\",\"UnionPlus\":\"⊎\",\"Uogon\":\"Ų\",\"uogon\":\"ų\",\"Uopf\":\"𝕌\",\"uopf\":\"𝕦\",\"UpArrowBar\":\"⤒\",\"uparrow\":\"↑\",\"UpArrow\":\"↑\",\"Uparrow\":\"⇑\",\"UpArrowDownArrow\":\"⇅\",\"updownarrow\":\"↕\",\"UpDownArrow\":\"↕\",\"Updownarrow\":\"⇕\",\"UpEquilibrium\":\"⥮\",\"upharpoonleft\":\"↿\",\"upharpoonright\":\"↾\",\"uplus\":\"⊎\",\"UpperLeftArrow\":\"↖\",\"UpperRightArrow\":\"↗\",\"upsi\":\"υ\",\"Upsi\":\"ϒ\",\"upsih\":\"ϒ\",\"Upsilon\":\"Υ\",\"upsilon\":\"υ\",\"UpTeeArrow\":\"↥\",\"UpTee\":\"⊥\",\"upuparrows\":\"⇈\",\"urcorn\":\"⌝\",\"urcorner\":\"⌝\",\"urcrop\":\"⌎\",\"Uring\":\"Ů\",\"uring\":\"ů\",\"urtri\":\"◹\",\"Uscr\":\"𝒰\",\"uscr\":\"𝓊\",\"utdot\":\"⋰\",\"Utilde\":\"Ũ\",\"utilde\":\"ũ\",\"utri\":\"▵\",\"utrif\":\"▴\",\"uuarr\":\"⇈\",\"Uuml\":\"Ü\",\"uuml\":\"ü\",\"uwangle\":\"⦧\",\"vangrt\":\"⦜\",\"varepsilon\":\"ϵ\",\"varkappa\":\"ϰ\",\"varnothing\":\"∅\",\"varphi\":\"ϕ\",\"varpi\":\"ϖ\",\"varpropto\":\"∝\",\"varr\":\"↕\",\"vArr\":\"⇕\",\"varrho\":\"ϱ\",\"varsigma\":\"ς\",\"varsubsetneq\":\"⊊︀\",\"varsubsetneqq\":\"⫋︀\",\"varsupsetneq\":\"⊋︀\",\"varsupsetneqq\":\"⫌︀\",\"vartheta\":\"ϑ\",\"vartriangleleft\":\"⊲\",\"vartriangleright\":\"⊳\",\"vBar\":\"⫨\",\"Vbar\":\"⫫\",\"vBarv\":\"⫩\",\"Vcy\":\"В\",\"vcy\":\"в\",\"vdash\":\"⊢\",\"vDash\":\"⊨\",\"Vdash\":\"⊩\",\"VDash\":\"⊫\",\"Vdashl\":\"⫦\",\"veebar\":\"⊻\",\"vee\":\"∨\",\"Vee\":\"⋁\",\"veeeq\":\"≚\",\"vellip\":\"⋮\",\"verbar\":\"|\",\"Verbar\":\"‖\",\"vert\":\"|\",\"Vert\":\"‖\",\"VerticalBar\":\"∣\",\"VerticalLine\":\"|\",\"VerticalSeparator\":\"❘\",\"VerticalTilde\":\"≀\",\"VeryThinSpace\":\" \",\"Vfr\":\"𝔙\",\"vfr\":\"𝔳\",\"vltri\":\"⊲\",\"vnsub\":\"⊂⃒\",\"vnsup\":\"⊃⃒\",\"Vopf\":\"𝕍\",\"vopf\":\"𝕧\",\"vprop\":\"∝\",\"vrtri\":\"⊳\",\"Vscr\":\"𝒱\",\"vscr\":\"𝓋\",\"vsubnE\":\"⫋︀\",\"vsubne\":\"⊊︀\",\"vsupnE\":\"⫌︀\",\"vsupne\":\"⊋︀\",\"Vvdash\":\"⊪\",\"vzigzag\":\"⦚\",\"Wcirc\":\"Ŵ\",\"wcirc\":\"ŵ\",\"wedbar\":\"⩟\",\"wedge\":\"∧\",\"Wedge\":\"⋀\",\"wedgeq\":\"≙\",\"weierp\":\"℘\",\"Wfr\":\"𝔚\",\"wfr\":\"𝔴\",\"Wopf\":\"𝕎\",\"wopf\":\"𝕨\",\"wp\":\"℘\",\"wr\":\"≀\",\"wreath\":\"≀\",\"Wscr\":\"𝒲\",\"wscr\":\"𝓌\",\"xcap\":\"⋂\",\"xcirc\":\"◯\",\"xcup\":\"⋃\",\"xdtri\":\"▽\",\"Xfr\":\"𝔛\",\"xfr\":\"𝔵\",\"xharr\":\"⟷\",\"xhArr\":\"⟺\",\"Xi\":\"Ξ\",\"xi\":\"ξ\",\"xlarr\":\"⟵\",\"xlArr\":\"⟸\",\"xmap\":\"⟼\",\"xnis\":\"⋻\",\"xodot\":\"⨀\",\"Xopf\":\"𝕏\",\"xopf\":\"𝕩\",\"xoplus\":\"⨁\",\"xotime\":\"⨂\",\"xrarr\":\"⟶\",\"xrArr\":\"⟹\",\"Xscr\":\"𝒳\",\"xscr\":\"𝓍\",\"xsqcup\":\"⨆\",\"xuplus\":\"⨄\",\"xutri\":\"△\",\"xvee\":\"⋁\",\"xwedge\":\"⋀\",\"Yacute\":\"Ý\",\"yacute\":\"ý\",\"YAcy\":\"Я\",\"yacy\":\"я\",\"Ycirc\":\"Ŷ\",\"ycirc\":\"ŷ\",\"Ycy\":\"Ы\",\"ycy\":\"ы\",\"yen\":\"¥\",\"Yfr\":\"𝔜\",\"yfr\":\"𝔶\",\"YIcy\":\"Ї\",\"yicy\":\"ї\",\"Yopf\":\"𝕐\",\"yopf\":\"𝕪\",\"Yscr\":\"𝒴\",\"yscr\":\"𝓎\",\"YUcy\":\"Ю\",\"yucy\":\"ю\",\"yuml\":\"ÿ\",\"Yuml\":\"Ÿ\",\"Zacute\":\"Ź\",\"zacute\":\"ź\",\"Zcaron\":\"Ž\",\"zcaron\":\"ž\",\"Zcy\":\"З\",\"zcy\":\"з\",\"Zdot\":\"Ż\",\"zdot\":\"ż\",\"zeetrf\":\"ℨ\",\"ZeroWidthSpace\":\"​\",\"Zeta\":\"Ζ\",\"zeta\":\"ζ\",\"zfr\":\"𝔷\",\"Zfr\":\"ℨ\",\"ZHcy\":\"Ж\",\"zhcy\":\"ж\",\"zigrarr\":\"⇝\",\"zopf\":\"𝕫\",\"Zopf\":\"ℤ\",\"Zscr\":\"𝒵\",\"zscr\":\"𝓏\",\"zwj\":\"‍\",\"zwnj\":\"‌\"}");

/***/ }),

/***/ "9BC+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isPhoneNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return emailRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPhoneRegex; });
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_0__);
 // WARNING: iF this file is growing too much, think of replacing it with a library like Validator.js

function isPhoneNumber(stringToTest) {
  return /^[\d\s()+-.]+$/.test(stringToTest.trim());
}

var emailRegex = new RegExp(/^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/);

var getPhoneRegex = function getPhoneRegex(locale) {
  var _domainsService$getDo, _domainsService$getDo2;

  return new RegExp(((_domainsService$getDo = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_0___default.a.getDomain(locale)) === null || _domainsService$getDo === void 0 ? void 0 : (_domainsService$getDo2 = _domainsService$getDo.fields) === null || _domainsService$getDo2 === void 0 ? void 0 : _domainsService$getDo2.phoneNumber) || /^ *\+? *(?:[ \-()]*[0-9][ \-()]*){6,12}$/);
};



/***/ }),

/***/ "9KBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewsletterForm; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("luEP");
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(yup__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("kiXb");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Ub5k");
/* harmony import */ var _frameworks_grid_row_Grid_row_jsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("WzQP");
/* harmony import */ var _frameworks_grid_cell_Grid_cell_jsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("PCgT");
/* harmony import */ var _frameworks_formik_FormikInput_jsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("/HC4");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;







var CELL_GRID_ONE_THIRD = {
  M: 4
};
var subscriptionSchema = function subscriptionSchema() {
  return yup__WEBPACK_IMPORTED_MODULE_1__["object"]().shape({
    civility: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().required(Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('common.form.errors.requiredField')),
    firstName: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().max(20, Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('common.form.errors.fieldTooLong', {
      label: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.firstName'),
      maxlength: 20
    })) // regex to validate first / last name - no special characters, only letters, dashes, dots or apostrophs are allowed
    .matches(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/, Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('common.form.errors.noSpecialCharsField')).required(Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('common.form.errors.requiredField')),
    lastName: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().max(30, Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('common.form.errors.fieldTooLong', {
      label: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.lastName'),
      maxlength: 30
    })) // regex to validate first / last name - no special characters, only letters, dashes, dots or apostrophs are allowed
    .matches(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/, Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('common.form.errors.noSpecialCharsField')).required(Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('common.form.errors.requiredField')),
    unicodeFirstName: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().max(100),
    unicodeLastName: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().max(100),
    email: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().email(Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('common.form.errors.invalidEmailField')).required(Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('common.form.errors.requiredField'))
  });
};
function NewsletterForm() {
  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_0__["useContext"])(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"]);
  return __jsx(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null, __jsx(_frameworks_grid_row_Grid_row_jsx__WEBPACK_IMPORTED_MODULE_4__[/* GridRow */ "a"], {
    className: "mt-4 md:mt-0",
    hasTopGutters: false
  }, __jsx(_frameworks_grid_cell_Grid_cell_jsx__WEBPACK_IMPORTED_MODULE_5__[/* GridCell */ "a"], {
    cols: CELL_GRID_ONE_THIRD
  }, __jsx(_frameworks_formik_FormikInput_jsx__WEBPACK_IMPORTED_MODULE_6__[/* FormikInput */ "a"], {
    name: "civility",
    type: "select",
    isRequired: true,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.civility'),
    options: [{
      name: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.civility'),
      value: '',
      isDisabled: true
    }, {
      name: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('newsletter.signup.civilityMale'),
      value: 'M'
    }, {
      name: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('newsletter.signup.civilityFemale'),
      value: 'F'
    }]
  })), __jsx(_frameworks_grid_cell_Grid_cell_jsx__WEBPACK_IMPORTED_MODULE_5__[/* GridCell */ "a"], {
    className: "mt-4 md:mt-0",
    cols: CELL_GRID_ONE_THIRD
  }, __jsx(_frameworks_formik_FormikInput_jsx__WEBPACK_IMPORTED_MODULE_6__[/* FormikInput */ "a"], {
    name: "firstName",
    isRequired: true,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.firstName'),
    type: "text",
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.firstName')
  })), __jsx(_frameworks_grid_cell_Grid_cell_jsx__WEBPACK_IMPORTED_MODULE_5__[/* GridCell */ "a"], {
    className: "mt-4 md:mt-0",
    cols: CELL_GRID_ONE_THIRD
  }, __jsx(_frameworks_formik_FormikInput_jsx__WEBPACK_IMPORTED_MODULE_6__[/* FormikInput */ "a"], {
    name: "lastName",
    isRequired: true,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.lastName'),
    type: "text",
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.lastName')
  }))), appContext.displayUnicodeFields && __jsx(_frameworks_grid_row_Grid_row_jsx__WEBPACK_IMPORTED_MODULE_4__[/* GridRow */ "a"], {
    className: "mt-4",
    hasTopGutters: false
  }, __jsx(_frameworks_grid_cell_Grid_cell_jsx__WEBPACK_IMPORTED_MODULE_5__[/* GridCell */ "a"], {
    offsets: CELL_GRID_ONE_THIRD,
    cols: CELL_GRID_ONE_THIRD
  }, __jsx(_frameworks_formik_FormikInput_jsx__WEBPACK_IMPORTED_MODULE_6__[/* FormikInput */ "a"], {
    name: "unicodeFirstName",
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.unicodeFirstName'),
    type: "text",
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.unicodeFirstName')
  })), __jsx(_frameworks_grid_cell_Grid_cell_jsx__WEBPACK_IMPORTED_MODULE_5__[/* GridCell */ "a"], {
    className: "mt-4 md:mt-0",
    cols: CELL_GRID_ONE_THIRD
  }, __jsx(_frameworks_formik_FormikInput_jsx__WEBPACK_IMPORTED_MODULE_6__[/* FormikInput */ "a"], {
    name: "unicodeLastName",
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.unicodeLastName'),
    type: "text",
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.unicodeLastName')
  }))), __jsx(_frameworks_grid_row_Grid_row_jsx__WEBPACK_IMPORTED_MODULE_4__[/* GridRow */ "a"], {
    className: "mt-4",
    hasTopGutters: false
  }, __jsx(_frameworks_grid_cell_Grid_cell_jsx__WEBPACK_IMPORTED_MODULE_5__[/* GridCell */ "a"], {
    cols: {
      M: 12
    }
  }, __jsx(_frameworks_formik_FormikInput_jsx__WEBPACK_IMPORTED_MODULE_6__[/* FormikInput */ "a"], {
    name: "email",
    isRequired: true,
    type: "email",
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.email'),
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.email'),
    labelAdditionalInfo: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.additionalInfoEmail')
  }))));
}

/***/ }),

/***/ "9QcM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FACETING_CLEAR_FACETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FACETING_PRICES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FACETING_SEARCH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FACETING_LOAD_PRODUCTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FACETING_SET_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FACETING_SET_INITIAL_PRICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FACETING_SET_IS_DATE_REQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FACETING_SET_IS_SEARCH_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FACETING_SET_KIDS_VALIDATION_STATE; });
/* unused harmony export FACETING_SET_SCROLL_TO_RESULTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FACETING_SET_SEARCH_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FACETING_RESET_REDIRECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FACETING_RESET_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FACETING_TOGGLE_FACET_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FACETING_CHILDCARE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FACETING_UPDATE_FILTERS; });
var FACETING_CLEAR_FACETS = 'FACETING_CLEAR_FACETS';
var FACETING_PRICES_REQUEST = 'FACETING_PRICES_REQUEST';
var FACETING_SEARCH_REQUEST = 'FACETING_SEARCH_REQUEST';
var FACETING_LOAD_PRODUCTS_REQUEST = 'FACETING_LOAD_PRODUCTS_REQUEST';
var FACETING_SET_FILTERS = 'FACETING_SET_FILTERS';
var FACETING_SET_INITIAL_PRICES = 'FACETING_SET_INITIAL_PRICES';
var FACETING_SET_IS_DATE_REQUIRED = 'FACETING_SET_IS_DATE_REQUIRED';
var FACETING_SET_IS_SEARCH_ENABLED = 'FACETING_SET_IS_SEARCH_ENABLED';
var FACETING_SET_KIDS_VALIDATION_STATE = 'FACETING_SET_KIDS_VALIDATION_STATE';
var FACETING_SET_SCROLL_TO_RESULTS = 'FACETING_SCROLL_TO_RESULTS';
var FACETING_SET_SEARCH_QUERY = 'FACETING_SET_SEARCH_QUERY';
var FACETING_RESET_REDIRECTION = 'FACETING_RESET_REDIRECTION';
var FACETING_RESET_SEARCH = 'FACETING_RESET_SEARCH';
var FACETING_TOGGLE_FACET_SELECTED = 'FACETING_TOGGLE_FACET_SELECTED';
var FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE = 'FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE';
var FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON = 'FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON';
var FACETING_CHILDCARE_REQUEST = 'FACETING_CHILDCARE_REQUEST';
var FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE = 'FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE';
var FACETING_UPDATE_FILTERS = 'FACETING_UPDATE_FILTERS';

/***/ }),

/***/ "9XrK":
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__("1MRr"),
    baseUnary = __webpack_require__("id+h"),
    nodeUtil = __webpack_require__("2LZg");

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ "9sjr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatFooterLabelName; });
var CSS_TRACKING_MAPPING = {
  phoneBubble: 'clickToCall',
  callMeBack: 'webCallBack'
};
function formatFooterLabelName(id) {
  return CSS_TRACKING_MAPPING.hasOwnProperty(id) ? CSS_TRACKING_MAPPING[id] : id;
}

/***/ }),

/***/ "AVUi":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ "AbLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return usePrevious; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var usePrevious = function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  var ref = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])(); // Store current value in ref

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)

  return ref.current;
};

/***/ }),

/***/ "AzLH":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ "B3yO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return keywordsSelector; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);


var searchSelector = function searchSelector(_ref) {
  var search = _ref.search;
  return search || {};
};

var querySelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(searchSelector, function (_ref2) {
  var query = _ref2.query;
  return query || {};
});
var keywordsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(querySelector, function (_ref3) {
  var keywords = _ref3.keywords;
  return keywords;
});


/***/ }),

/***/ "BGmY":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("3QVS");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ "BKF0":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("jP+d");

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ "BRr/":
/***/ (function(module, exports, __webpack_require__) {

var inverseXML = getInverseObj(__webpack_require__("ZLJe")),
    xmlReplacer = getInverseReplacer(inverseXML);

exports.XML = getInverse(inverseXML, xmlReplacer);

var inverseHTML = getInverseObj(__webpack_require__("8PLQ")),
    htmlReplacer = getInverseReplacer(inverseHTML);

exports.HTML = getInverse(inverseHTML, htmlReplacer);

function getInverseObj(obj){
	return Object.keys(obj).sort().reduce(function(inverse, name){
		inverse[obj[name]] = "&" + name + ";";
		return inverse;
	}, {});
}

function getInverseReplacer(inverse){
	var single = [],
	    multiple = [];

	Object.keys(inverse).forEach(function(k){
		if(k.length === 1){
			single.push("\\" + k);
		} else {
			multiple.push(k);
		}
	});

	//TODO add ranges
	multiple.unshift("[" + single.join("") + "]");

	return new RegExp(multiple.join("|"), "g");
}

var re_nonASCII = /[^\0-\x7F]/g,
    re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;

function singleCharReplacer(c){
	return "&#x" + c.charCodeAt(0).toString(16).toUpperCase() + ";";
}

function astralReplacer(c){
	// http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	var high = c.charCodeAt(0);
	var low  = c.charCodeAt(1);
	var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
	return "&#x" + codePoint.toString(16).toUpperCase() + ";";
}

function getInverse(inverse, re){
	function func(name){
		return inverse[name];
	}

	return function(data){
		return data
				.replace(re, func)
				.replace(re_astralSymbols, astralReplacer)
				.replace(re_nonASCII, singleCharReplacer);
	};
}

var re_xmlChars = getInverseReplacer(inverseXML);

function escapeXML(data){
	return data
			.replace(re_xmlChars, singleCharReplacer)
			.replace(re_astralSymbols, astralReplacer)
			.replace(re_nonASCII, singleCharReplacer);
}

exports.escape = escapeXML;


/***/ }),

/***/ "Bio+":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("j++8");

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ "BlK1":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("ojcf"),
    getSymbolsIn = __webpack_require__("UR9l");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ "C5R2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDuration; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _duration_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("RBvG");


function setDuration(value) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_duration_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DURATION */ "c"], {
    value: value
  });
}

/***/ }),

/***/ "C8zB":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("j++8");

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ "C9cF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IS_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IS_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IS_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getProductBadgeIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getServiceAgesLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getServiceAgesLabelTranslateOptions; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _color_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("UCZK");


var IS_DISABLED = 'isDisabled';
var IS_ENABLED = 'isEnabled';
var IS_SELECTED = 'isSelected';

var getProductBadgeIcon = function getProductBadgeIcon(_ref) {
  var badgeIcon = _ref.badgeIcon,
      color = _ref.color,
      comfortLabel = _ref.comfortLabel;
  return {
    alt: comfortLabel || '',
    color: _color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].WHITE,
    colorBg: color,
    colorBorder: color,
    iconName: badgeIcon
  };
};

function getServiceAgesLabel(ageInMonths, i18n) {
  var min = ageInMonths.min,
      max = ageInMonths.max;

  if (min > 23) {
    return Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["messageFormat"])(i18n.booking.services.childcare.kidsAgeInYears).format({
      min: Math.floor(min / 12),
      max: max ? Math.floor(max / 12) : ''
    });
  }

  if (min < 23 && max && max > 23) {
    return Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["messageFormat"])(i18n.booking.services.childcare.kidsAgeInMonthsAndYears).format({
      min: min,
      max: Math.floor(max / 12)
    });
  }

  return Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["messageFormat"])(i18n.booking.services.childcare.kidsAgeInMonths).format({
    min: min,
    max: max
  });
}

function getServiceAgesLabelTranslateOptions(ageInMonths) {
  var min = ageInMonths.min,
      max = ageInMonths.max;

  if (min > 23) {
    return ['booking.services.childcare.kidsAgeInYears', {
      min: Math.floor(min / 12),
      max: max ? Math.floor(max / 12) : ''
    }];
  }

  if (min < 23 && max && max > 23) {
    return ['booking.services.childcare.kidsAgeInMonthsAndYears', {
      min: min,
      max: Math.floor(max / 12)
    }];
  }

  return ['booking.services.childcare.kidsAgeInMonths', {
    min: min,
    // $FlowFixMe 🤬
    max: max
  }];
}



/***/ }),

/***/ "CATK":
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__("YXT+"),
    isObjectLike = __webpack_require__("oS78");

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ "CDVU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_CUSTOMER_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_CUSTOMER_REJECTED; });
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__);

var FETCH_CUSTOMER = 'FETCH_CUSTOMER';
var FETCH_CUSTOMER_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_CUSTOMER);
var FETCH_CUSTOMER_REJECTED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_CUSTOMER);

/***/ }),

/***/ "CGZ2":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("j++8");

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ "CP21":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("jP+d");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ "Crz2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return init; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("9OUN");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var redux_thunk__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("V8Kl");
/* harmony import */ var _utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("igjW");
/* harmony import */ var _middlewares_authenticationMiddleware__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("u9tP");
/* harmony import */ var _rootReducer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("v315");









function getReduxMiddlewares() {
  return [redux_thunk__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"], redux_optimist_promise__WEBPACK_IMPORTED_MODULE_3___default()(), Object(_middlewares_authenticationMiddleware__WEBPACK_IMPORTED_MODULE_6__[/* createAuthenticationMiddleware */ "a"])()];
}

function init(initialState) {
  var enhancer = Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_5__[/* isStrictlyDevelopmentEnv */ "d"])(_config__WEBPACK_IMPORTED_MODULE_1___default.a) ? global.window && global.window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux__WEBPACK_IMPORTED_MODULE_2__[/* compose */ "d"] : redux__WEBPACK_IMPORTED_MODULE_2__[/* compose */ "d"];
  return Object(redux__WEBPACK_IMPORTED_MODULE_2__[/* createStore */ "e"])(_rootReducer__WEBPACK_IMPORTED_MODULE_7__[/* rootReducer */ "a"], initialState, enhancer(redux__WEBPACK_IMPORTED_MODULE_2__[/* applyMiddleware */ "a"].apply(void 0, Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(getReduxMiddlewares()))));
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq")))

/***/ }),

/***/ "CwJu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterAccommodations; });
/* unused harmony export sortAccommodations */
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("lZ21");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




function sortAccommodations(accommodationsSets) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["sortBy"])(accommodationsSets, function (set) {
    // sort accommodations by comfort level: Standard, Deluxe, Suite
    return _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_2__[/* ACCOMMODATION_COMFORT_ORDER */ "a"].indexOf(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(set, 'accommodations[0].categoryId'));
  }).map(function (set, index) {
    // accommodationSetNumber was set to index + 1 in accommodationsSetsReducer
    // need to be updated after filtering & sorting
    return _objectSpread(_objectSpread({}, set), {}, {
      accommodationSetNumber: index + 1
    });
  });
}

function filterAccommodations(proposal, accommodationsSets) {
  var proposalAccommodations = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(proposal, 'accommodations', []); // remove additional accommodation if already exists in selected proposal

  var filteredAccommodations = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["reject"])(accommodationsSets, function (_ref) {
    var accommodations = _ref.accommodations;
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEqual"])(accommodations, proposalAccommodations);
  }); // sort additional accommodations by comfort level: Standard, Deluxe, Suite

  return sortAccommodations(filteredAccommodations);
}



/***/ }),

/***/ "DWlz":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__("HUtr"),
    baseKeys = __webpack_require__("e/g/"),
    isArrayLike = __webpack_require__("gvfs");

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ "E3ZW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_CUSTOMER_SEARCH_RESULT; });
/* unused harmony export UNSET_CUSTOMER_SEARCH_RESULT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return customerSearch; });
var SET_CUSTOMER_SEARCH_RESULT = 'SET_CUSTOMER_SEARCH_RESULT';
var UNSET_CUSTOMER_SEARCH_RESULT = 'UNSET_CUSTOMER_SEARCH_RESULT';
var initialState = {};
var customerSearch = function customerSearch() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_CUSTOMER_SEARCH_RESULT:
      return action.payload;

    case UNSET_CUSTOMER_SEARCH_RESULT:
      return initialState;

    default:
      return state;
  }
};

/***/ }),

/***/ "EEuM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userInfoWrapper; });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("uDfI");
/* harmony import */ var _userInfo_selectors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("apzf");


var connector = Object(react_redux__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "c"])(function (state) {
  return {
    userInfo: Object(_userInfo_selectors__WEBPACK_IMPORTED_MODULE_1__[/* userInfoSelector */ "a"])(state)
  };
});
function userInfoWrapper(ComponentToWrap) {
  return connector(ComponentToWrap);
}

/***/ }),

/***/ "ELg1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductFlag_ProductFlag; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: ./src/client/components/frameworks/price/Price.jsx + 3 modules
var Price = __webpack_require__("IuYR");

// EXTERNAL MODULE: ./src/client/components/frameworks/pricing-table/PricingTable.jsx + 1 modules
var PricingTable = __webpack_require__("RCgv");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.themes.js
var themes = {
  thumbnail: {
    thPriceFrom: 'font-sans text-base text-gray-darker px-1'
  },
  compare: {
    thPriceFrom: 'font-sans text-sm md:text-base text-gray-darker px-1'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.jsx








var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }









var HEIGHT = '2.5rem';
var ProductFlag_ProductFlag = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(ProductFlag, _Component);

  var _super = _createSuper(ProductFlag);

  function ProductFlag(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ProductFlag);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "togglePackage", function () {
      _this.setState(function (prevState) {
        return {
          isPackageVisible: !prevState.isPackageVisible
        };
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClick", function () {
      var _this$props = _this.props,
          _this$props$onClick = _this$props.onClick,
          onClick = _this$props$onClick === void 0 ? lodash["noop"] : _this$props$onClick,
          isLinkDisabled = _this$props.isLinkDisabled;

      if (!isLinkDisabled && !_this.hasPrice()) {
        onClick();
      } else {
        _this.togglePackage();
      }
    });

    _this.state = {
      isPackageVisible: false
    };
    return _this;
  }

  Object(createClass["a" /* default */])(ProductFlag, [{
    key: "hasPrice",
    value: function hasPrice() {
      var _this$props2 = this.props,
          _this$props2$price = _this$props2.price,
          price = _this$props2$price === void 0 ? {} : _this$props2$price,
          isPriceLoading = _this$props2.isPriceLoading;
      return !isPriceLoading && (!!price.initialPrice || !!price.bestPrice);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          price = _this$props3.price,
          isPriceLoading = _this$props3.isPriceLoading,
          _this$props3$pricingT = _this$props3.pricingTable,
          pricingTable = _this$props3$pricingT === void 0 ? {} : _this$props3$pricingT,
          onClick = _this$props3.onClick,
          theme = _this$props3.theme;
      var thPriceFrom = themes[theme].thPriceFrom;

      var pricingTableButton = _objectSpread(_objectSpread({}, pricingTable.button), {}, {
        onClick: onClick
      });

      return !Object(lodash["isEmpty"])(price) ? __jsx("div", {
        style: {
          height: HEIGHT
        }
      }, __jsx("button", {
        className: "reset-button w-full whitespace-no-wrap",
        "data-testid": "ProductFlag-price",
        onClick: this.onClick,
        type: "button"
      }, __jsx("span", {
        className: "flex items-center justify-end w-full"
      }, Object(price_util["d" /* hasAtLeastOnePrice */])(this.props.price) ? __jsx("span", {
        className: thPriceFrom
      }, price.from) : null, __jsx(Price["a" /* Price */], Object(esm_extends["a" /* default */])({}, _objectSpread(_objectSpread({}, price), {}, {
        from: undefined
      }), {
        className: "flex items-center h-full rounded-tiny",
        isLoading: isPriceLoading,
        theme: theme
      }))), this.state.isPackageVisible ? __jsx(Modal["a" /* Modal */], {
        ariaLabel: pricingTable.label,
        className: "p-3",
        closeLabel: Object(i18n["f" /* t */])('common.close'),
        onClose: function onClose(e) {
          e.stopPropagation();

          _this2.togglePackage();
        },
        size: "auto"
      }, __jsx(PricingTable["a" /* PricingTable */], Object(esm_extends["a" /* default */])({}, pricingTable, {
        button: pricingTableButton
      }))) : null)) : null;
    }
  }]);

  return ProductFlag;
}(react["Component"]);

Object(defineProperty["a" /* default */])(ProductFlag_ProductFlag, "defaultProps", {
  hasTransport: false,
  isLinkDisabled: false,
  onClick: lodash["noop"],
  price: {},
  theme: 'thumbnail',
  pricingTable: {},
  isPriceLoading: false
});

/***/ }),

/***/ "EVz8":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("jP+d"),
    stubFalse = __webpack_require__("Khoy");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("EIeC")(module)))

/***/ }),

/***/ "Ey+l":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("Q7Yi"),
    isPrototype = __webpack_require__("RVBP"),
    nativeKeysIn = __webpack_require__("66Hx");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ "EzIG":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("dZwK");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ "FHsl":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("t8ah"),
    isArrayLike = __webpack_require__("gvfs"),
    isIndex = __webpack_require__("hIZU"),
    isObject = __webpack_require__("Q7Yi");

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ "FQR9":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__("HUtr"),
    baseKeysIn = __webpack_require__("Ey+l"),
    isArrayLike = __webpack_require__("gvfs");

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ "Fe0B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return grid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return generateProductLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generateLinkProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateCmtaLinkProp; });
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("igjW");



var grid = {
  mobile: 1,
  phablet: 2,
  tablet: 3,
  desktop: 3
};
var generateProductLink = function generateProductLink(url) {
  var offer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return offer && offer.seoName ? new urijs__WEBPACK_IMPORTED_MODULE_0___default.a(url).addSearch(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["appQueryParameters"].shopping.offer, _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["url"].encodePath(offer.seoName)).toString() : url;
};
var generateLinkProp = function generateLinkProp(url, offer) {
  return url ? {
    url: generateProductLink(url, offer),
    queryParamsToIgnore: offer ? [] : ['offer']
  } : undefined;
};

var formatResortName = function formatResortName(resortName) {
  if (resortName.match(/.*winter$/) || resortName.match(/.*summer$/)) {
    return resortName;
  }

  return "".concat(resortName, "-2");
};

var generateCmtaLinkProp = function generateCmtaLinkProp(url, originalUrl) {
  var resortName = '';
  var domain = 'clubmed.com';
  var subDomain = 'travelagents';
  var resortMatch = url && url.match(/\/r\/(.*)\//);

  if (resortMatch) {
    resortName = resortMatch[1];
  }

  var domainMatcher = originalUrl && originalUrl.match(/(clubmed\.[\.\w]+)\//);

  if (domainMatcher) {
    domain = domainMatcher[1];
  }

  var cmtaUrl = "https://".concat(subDomain, ".").concat(domain);

  if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_2__[/* isStrictlyIntegrationEnv */ "e"])()) {
    cmtaUrl = "https://".concat(subDomain, ".integ.").concat(domain);
  }

  if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_2__[/* isStrictlyStagingEnv */ "g"])()) {
    cmtaUrl = "https://".concat(subDomain, ".staging.").concat(domain);
  }

  var cmtaFullUrl = new urijs__WEBPACK_IMPORTED_MODULE_0___default.a(cmtaUrl).path("/resort/".concat(formatResortName(resortName), "/"));
  return {
    url: cmtaFullUrl.toString(),
    isExternalLink: true
  };
};

/***/ }),

/***/ "FtaI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sendTransaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useAbTasty; });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _router_useRouter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7jla");
/* harmony import */ var _third_party_thirdParty_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kD1E");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Ub5k");





var sendTransaction = function sendTransaction(_ref) {
  var id = _ref.id,
      affiliation = _ref.affiliation,
      revenue = _ref.revenue,
      currency = _ref.currency;
  var timeLimit = moment__WEBPACK_IMPORTED_MODULE_0___default()().add(5, 's');
  var waiter = setInterval(function () {
    var _window, _window$abtasty;

    if ((_window = window) === null || _window === void 0 ? void 0 : (_window$abtasty = _window.abtasty) === null || _window$abtasty === void 0 ? void 0 : _window$abtasty.send) {
      window.abtasty.send('transaction', {
        tid: id,
        // Transaction ID
        ta: affiliation,
        // Transaction Affiliation
        tr: revenue,
        // Transaction Revenue
        tc: currency // Transaction Currency

      });
      clearInterval(waiter);
    } else if (moment__WEBPACK_IMPORTED_MODULE_0___default()().isAfter(timeLimit)) {
      // clear after Maximum 5s, we assume that it should be there by then
      clearInterval(waiter);
    }
  }, 100);
};
var useAbTasty = function useAbTasty() {
  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"]);

  var _useRouter = Object(_router_useRouter__WEBPACK_IMPORTED_MODULE_2__[/* useRouter */ "a"])(),
      queryParams = _useRouter.location.queryParams;

  var tracking = Object(_third_party_thirdParty_utils__WEBPACK_IMPORTED_MODULE_3__[/* getConfigWithNoThirdPartySupport */ "a"])({
    locale: appContext.locale,
    name: 'tracking',
    queryParams: queryParams
  });
  var abTastyId = tracking.abtasty.id;

  if (appContext.isCmta) {
    abTastyId = tracking.abtasty.cmta.id;
  } else if (appContext.isDirectCxo || appContext.isIndirectCxo) {
    abTastyId = tracking.abtasty.cxo.id;
  }

  var isAbTastyActive = tracking && tracking.enabled && tracking.abtasty && tracking.abtasty.enabled && tracking.abtasty.host && !!abTastyId;
  var abTastyScriptUrl = isAbTastyActive ? "https://".concat(tracking.abtasty.host, "/").concat(abTastyId, ".js") : '';
  return {
    abTastyScriptUrl: abTastyScriptUrl,
    isAbTastyActive: isAbTastyActive
  };
};

/***/ }),

/***/ "G8Os":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ "GJxp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "listen", function() { return /* binding */ index_es_listen; });
__webpack_require__.d(__webpack_exports__, "subscribe", function() { return /* binding */ index_es_subscribe; });
__webpack_require__.d(__webpack_exports__, "unsubscribe", function() { return /* binding */ index_es_unsubscribe; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/subscribe-ui-event/node_modules/lodash/assign.js
var lodash_assign = __webpack_require__("KiAj");
var assign_default = /*#__PURE__*/__webpack_require__.n(lodash_assign);

// EXTERNAL MODULE: /home/circleci/project/node_modules/eventemitter3/index.js
var eventemitter3 = __webpack_require__("Gpi5");
var eventemitter3_default = /*#__PURE__*/__webpack_require__.n(eventemitter3);

// CONCATENATED MODULE: /home/circleci/project/node_modules/subscribe-ui-event/dist-es/lib/supportPassiveEvent.js
/* global window */

var passiveSupported = false; // eslint-disable-line import/no-mutable-exports

if (typeof window !== 'undefined') {
  try {
    var supportPassiveEvent_options = Object.defineProperty({}, 'passive', {
      get: function get() {
        passiveSupported = true;
      }
    });

    window.addEventListener('test', null, supportPassiveEvent_options);
  } catch (err) {} // eslint-disable-line no-empty
}

/* harmony default export */ var supportPassiveEvent = (passiveSupported);

// CONCATENATED MODULE: /home/circleci/project/node_modules/subscribe-ui-event/dist-es/globalVars.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */




/* harmony default export */ var globalVars = ({
  connections: {},
  EE: new eventemitter3_default.a(),
  enableResizeInfo: false,
  enableScrollInfo: false,
  listeners: {},
  removers: [],
  supportPassiveEvent: supportPassiveEvent
});

// CONCATENATED MODULE: /home/circleci/project/node_modules/subscribe-ui-event/dist-es/lib/listen.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */




var listen_supportPassiveEvent = globalVars.supportPassiveEvent;


var defaultEventOption = {
  capture: false,
  passive: false
};

/**
 * Cross-browser addEventListener.
 * @method listen
 * @param {Object} target - The target to add event listener.
 * @param {String} eventType - The event type.
 * @param {Function} handler - The event handler.
 * @param {Object} handler - The options object that specifies
 * characteristics about the event listener.
 * @return {Object} The object to be able to remove the handler.
 */
function listen(target, eventType, handler, options) {
  var add = 'addEventListener';
  var _remove = 'removeEventListener';
  var type = eventType;

  var eventOptions = listen_supportPassiveEvent ? assign_default()({}, defaultEventOption, options) : false;

  if (!target.addEventListener && target.attachEvent) {
    add = 'attachEvent';
    _remove = 'detachEvent';
    type = 'on' + eventType;
  }
  target[add](type, handler, eventOptions);

  return {
    remove: function remove() {
      target[_remove](eventType, handler);
    }
  };
}

/* harmony default export */ var lib_listen = (listen);

// CONCATENATED MODULE: /home/circleci/project/node_modules/subscribe-ui-event/dist-es/lib/leIE8.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global navigator, parseFloat */

// less then or equal to IE8
var leIE8 = false; // eslint-disable-line import/no-mutable-exports

if (typeof navigator !== 'undefined') {
  var matches = navigator.userAgent.match(/MSIE (\d+\.\d+)/);
  if (matches) {
    leIE8 = parseFloat(matches[1], 10) < 9;
  }
}

/* harmony default export */ var lib_leIE8 = (leIE8);

// EXTERNAL MODULE: /home/circleci/project/node_modules/subscribe-ui-event/node_modules/lodash/clone.js
var clone = __webpack_require__("Zq1u");
var clone_default = /*#__PURE__*/__webpack_require__.n(clone);

// EXTERNAL MODULE: /home/circleci/project/node_modules/subscribe-ui-event/node_modules/lodash/throttle.js
var lodash_throttle = __webpack_require__("olhj");
var throttle_default = /*#__PURE__*/__webpack_require__.n(lodash_throttle);

// EXTERNAL MODULE: /home/circleci/project/node_modules/subscribe-ui-event/node_modules/lodash/noop.js
var noop = __webpack_require__("VNuc");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// CONCATENATED MODULE: /home/circleci/project/node_modules/subscribe-ui-event/dist-es/AugmentedEvent.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document */



var resize = { // eslint-disable-line prefer-const
  width: 0,
  height: 0
};
var AugmentedEvent_scroll = { // eslint-disable-line prefer-const
  delta: 0,
  top: 0
};
var touch = { // eslint-disable-line prefer-const
  axisIntention: '',
  startX: 0,
  startY: 0,
  deltaX: 0,
  deltaY: 0
};

var INTENTION_THRESHOLD = 5;

var getXY = function getXY(pos) {
  var t = { x: 0, y: 0 }; // eslint-disable-line prefer-const
  var docBody = document.body;
  var docEl = document.documentElement;

  if (pos.pageX || pos.pageY) {
    t.x = pos.pageX;
    t.y = pos.pageY;
  } else {
    t.x = pos.clientX + docBody.scrollLeft + docEl.scrollLeft;
    t.y = pos.clientY + docBody.scrollTop + docEl.scrollTop;
  }

  return t;
};

/**
 * ArgmentedEvent will hold some global information, such like window scroll postion,
 * so that those information is only calculated once.
 * @param {Object} option - The option for SyntheticEvent
 */

var AugmentedEvent_AugmentedEvent = function () {
  function AugmentedEvent() {
    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, AugmentedEvent);

    var mainType = (option.mainType || '').toLowerCase();
    var subType = (option.subType || '').toLowerCase();

    this.mainType = mainType;
    this.subType = subType;
    this.type = mainType + subType.charAt(0).toUpperCase() + subType.slice(1) || '';
    this.scroll = AugmentedEvent_scroll;
    this.resize = resize;
    this.touch = touch;
  }

  _createClass(AugmentedEvent, [{
    key: 'update',
    value: function update(e) {
      var mainType = this.mainType,
          subType = this.subType;

      var docEl = document.documentElement;

      if (globalVars.enableScrollInfo && (mainType === 'scroll' || mainType === 'touchmove')) {
        var top = docEl.scrollTop + document.body.scrollTop;
        // Prevent delta from being 0
        if (top !== this.scroll.top) {
          this.scroll.delta = top - this.scroll.top;
          this.scroll.top = top;
        }
      }
      if (globalVars.enableResizeInfo && mainType === 'resize') {
        this.resize.width = window.innerWidth || docEl.clientWidth;
        this.resize.height = window.innerHeight || docEl.clientHeight;
      }
      if (globalVars.enableTouchInfo && e.touches && (mainType === 'touchstart' || mainType === 'touchmove' || mainType === 'touchend')) {
        var pos = void 0;
        var absX = void 0;
        var absY = void 0;
        if (mainType === 'touchstart' || subType === 'start') {
          pos = getXY(e.touches[0]);
          this.touch.axisIntention = '';
          this.touch.startX = pos.x;
          this.touch.startY = pos.y;
          this.touch.deltaX = 0;
          this.touch.deltaY = 0;
        } else if (mainType === 'touchmove') {
          pos = getXY(e.touches[0]);
          this.touch.deltaX = pos.x - this.touch.startX;
          this.touch.deltaY = pos.y - this.touch.startY;
          if (this.touch.axisIntention === '') {
            absX = Math.abs(this.touch.deltaX);
            absY = Math.abs(this.touch.deltaY);
            if (absX > INTENTION_THRESHOLD && absX >= absY) {
              this.touch.axisIntention = 'x';
            } else if (absY > INTENTION_THRESHOLD && absY > absX) {
              this.touch.axisIntention = 'y';
            }
          }
        }
      }
    }
  }]);

  return AugmentedEvent;
}();

/* harmony default export */ var dist_es_AugmentedEvent = (AugmentedEvent_AugmentedEvent);

// EXTERNAL MODULE: /home/circleci/project/node_modules/raf/index.js
var raf = __webpack_require__("0xii");
var raf_default = /*#__PURE__*/__webpack_require__.n(raf);

// CONCATENATED MODULE: /home/circleci/project/node_modules/subscribe-ui-event/dist-es/lib/rAFThrottle.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */



var getTime = Date.now ||
/* istanbul ignore next */function () {
  return new Date().getTime();
};

function rAFThrottle(func) {
  var throttle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;

  var context = void 0;
  var args = void 0;
  var last = 0;
  var requestId = 0;

  var later = function later() {
    var now = getTime();
    var remaining = throttle - (now - last);

    if (remaining <= 0) {
      last = now;
      requestId = 0;
      func.apply(context, args);
    } else {
      requestId = raf_default()(later);
    }
  };

  return function throttledFunc() {
    context = this;
    args = arguments; // eslint-disable-line prefer-rest-params

    if (!requestId) {
      requestId = raf_default()(later);
    }
  };
}

/* harmony default export */ var lib_rAFThrottle = (rAFThrottle);

// CONCATENATED MODULE: /home/circleci/project/node_modules/subscribe-ui-event/dist-es/constants.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var EVENT_END_DELAY = 100;
var DEFAULT_THROTTLE_RATE = 50;

// CONCATENATED MODULE: /home/circleci/project/node_modules/subscribe-ui-event/dist-es/mainEventConnectors.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document, setTimeout */











// constants


var connections = globalVars.connections,
    EE = globalVars.EE,
    listeners = globalVars.listeners,
    removers = globalVars.removers;

// global variables

var doc = void 0;
var win = void 0;
var body = void 0;
var hashId = 0;

if (typeof window !== 'undefined') {
  win = window;
  doc = win.document || document;
  body = doc.body;
}

function getHash(domNode) {
  return domNode.id || 'target-id-' + hashId++; // eslint-disable-line
}

/**
 * Connect a throttled event to a throttled main event, and return an event remover.
 * The number of connections to a throttled main event will be kept. If all throttled events
 * are removed, then remove throttled main event.
 * @method connectThrottle
 * @param {String} throttledEvent - A throttled event
 * @param {Function} cb - Callback function
 * @param {Object} ctx - The "this"
 * @param {String} throttledMainEvent - A throttled main event
 * @return {Object} An event remover
 */
function connectThrottle(throttledEvent, cb, ctx, throttledMainEvent) {
  EE.on(throttledEvent, cb || noop_default.a, ctx);
  throttledMainEvent = throttledMainEvent || throttledEvent;
  connections[throttledMainEvent] = (connections[throttledMainEvent] || 0) + 1;
  return {
    _type: throttledEvent,
    _cb: cb,
    _ctx: ctx,
    unsubscribe: function unsubscribe() {
      if (!this._type) {
        return;
      }

      EE.removeListener(throttledEvent, cb, ctx);
      connections[throttledMainEvent]--;
      if (connections[throttledMainEvent] === 0) {
        listeners[throttledMainEvent].remove();
        listeners[throttledMainEvent] = undefined;
      }

      this._type = undefined;
      this._cb = undefined;
      this._ctx = undefined;

      // remove the remover from removers array
      for (var i = removers.length - 1; i >= 0; i--) {
        var remover = removers[i];
        if (remover === this) {
          removers.splice(i, 1);
          break;
        }
      }
    }
  };
}

/**
 * Connect to event, event start and event end.
 * @method connectContinuousEvent
 * @param {Object} target - The target of a main event, window or document.
 * @param {String} mainEvent - A browser event, like scroll or resize.
 * @param {String} event - A subscribe event.
 * @param {Object} eventOptions - An options pass to event listener
 */
function connectContinuousEvent(target, mainEvent, event) {
  return function throttleEvent(throttleRate, cb, options, eventOptions) {
    var context = options.context;
    var domTarget = options.target;
    var domId = domTarget && getHash(domTarget);
    var targetPart = domId ? ':' + domId : '';

    var throttledStartEvent = mainEvent + 'Start:' + throttleRate + targetPart;
    var throttledEndEvent = mainEvent + 'End:' + throttleRate + targetPart;
    var throttledMainEvent = mainEvent + ':' + throttleRate + targetPart;
    var throttledEvent = event + ':' + throttleRate + targetPart;

    var remover = connectThrottle(throttledEvent, cb, context, throttledMainEvent);
    removers.push(remover);

    if (listeners[throttledMainEvent]) {
      return remover;
    }

    var ae = {
      start: new dist_es_AugmentedEvent({ mainType: mainEvent, subType: 'start' }), // start
      main: new dist_es_AugmentedEvent({ mainType: mainEvent }), // main
      end: new dist_es_AugmentedEvent({ mainType: mainEvent, subType: 'end' })
    };

    // No throttle for throttleRate = 0
    // end
    if (throttleRate === 'raf') {
      throttleRate = 16; // Set as a number for setTimeout later.
      handler = lib_rAFThrottle(handler);
    } else if (throttleRate > 0) {
      handler = throttle_default()(handler, throttleRate);
    }

    var timer = void 0;
    function endCallback(e) {
      ae.end.update(e);
      EE.emit(throttledEndEvent, e, ae.end);
      timer = null;
    }
    function handler(e) {
      if (!timer) {
        ae.start.update(e);
        EE.emit(throttledStartEvent, e, ae.start);
      }
      clearTimeout(timer);

      ae.main.update(e);
      EE.emit(throttledMainEvent, e, ae.main);
      if (!lib_leIE8) {
        timer = setTimeout(endCallback.bind(null, e), throttleRate + EVENT_END_DELAY);
      } else {
        // For browser less then and equal to IE8, event object need to be cloned for setTimeout.
        timer = setTimeout(function () {
          endCallback(clone_default()(e));
        }, throttleRate + EVENT_END_DELAY);
      }
    }

    listeners[throttledMainEvent] = lib_listen(domTarget || target, mainEvent, handler, eventOptions);
    return remover;
  };
}

function connectDiscreteEvent(target, event) {
  return function throttleEvent(throttleRate, cb, options, eventOptions) {
    var context = options.context;
    var domTarget = options.target;
    var domId = domTarget && getHash(domTarget);

    // no throttling for discrete event
    var throttledEvent = event + ':0' + (domId ? ':' + domId : '');

    var remover = connectThrottle(throttledEvent, cb, context);
    removers.push(remover);

    if (listeners[throttledEvent]) {
      return remover;
    }

    var ae = new dist_es_AugmentedEvent({ mainType: event });

    function handler(e) {
      ae.update(e);
      EE.emit(throttledEvent, e, ae);
    }

    listeners[throttledEvent] = lib_listen(domTarget || target, event, handler, eventOptions);
    return remover;
  };
}

/* harmony default export */ var mainEventConnectors = ({
  scrollStart: connectContinuousEvent(win, 'scroll', 'scrollStart'),
  scrollEnd: connectContinuousEvent(win, 'scroll', 'scrollEnd'),
  scroll: connectContinuousEvent(win, 'scroll', 'scroll'),
  resizeStart: connectContinuousEvent(win, 'resize', 'resizeStart'),
  resizeEnd: connectContinuousEvent(win, 'resize', 'resizeEnd'),
  resize: connectContinuousEvent(win, 'resize', 'resize'),
  visibilitychange: connectDiscreteEvent(doc, 'visibilitychange'),
  touchmoveStart: connectContinuousEvent(body, 'touchmove', 'touchmoveStart'),
  touchmoveEnd: connectContinuousEvent(body, 'touchmove', 'touchmoveEnd'),
  touchmove: connectContinuousEvent(body, 'touchmove', 'touchmove'),
  touchstart: connectDiscreteEvent(body, 'touchstart'),
  touchend: connectDiscreteEvent(body, 'touchend')
});

// CONCATENATED MODULE: /home/circleci/project/node_modules/subscribe-ui-event/dist-es/subscribe.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


 // less then or equal to IE8


// constants


/**
 * Subscribe to UI events.
 * @method subscribe
 * @param {String} type - The type of event.
 * @param {Function} cb - The callback function.
 * @param {Object} options.context - The caller.
 * @param {Number} options.throttleRate - The amount of time for throttling.
 * @param {Boolean} options.useRAF - Use rAF for throttling if true.
 * @param {Object} options.eventOptions - Option to pass to event listener
 * @return {Object} The object with unsubscribe function.
 */
function subscribe(type, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var useRAF = options.useRAF || false;
  var throttleRate = parseInt(options.throttleRate, 10);
  var eventOptions = options.eventOptions;

  if (isNaN(throttleRate)) {
    throttleRate = DEFAULT_THROTTLE_RATE;
  }

  if (useRAF) {
    throttleRate = 'raf';
  }

  // turn off throttle if the browser is IE8 or less, because window.event will be reset
  // when using any delayed function, i.g., setTimeout, or rAF.
  if (lib_leIE8) {
    throttleRate = 0;
  }

  // once those variables enabled, then never disabled.
  globalVars.enableScrollInfo = globalVars.enableScrollInfo || options.enableScrollInfo || false;
  globalVars.enableResizeInfo = globalVars.enableResizeInfo || options.enableResizeInfo || false;
  globalVars.enableTouchInfo = globalVars.enableTouchInfo || options.enableTouchInfo || false;

  return mainEventConnectors[type](throttleRate, cb, options, eventOptions);
}

/* harmony default export */ var dist_es_subscribe = (subscribe);

// CONCATENATED MODULE: /home/circleci/project/node_modules/subscribe-ui-event/dist-es/unsubscribe.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */



var unsubscribe_removers = globalVars.removers;

/**
 * Unsubscribe to UI events.
 * @method unsubscribe
 * @param {String} type - The type of event.
 * @param {Function} cb - The callback function.
 */

function unsubscribe(type, cb) {
  var remover = void 0;
  for (var i = unsubscribe_removers.length - 1; i >= 0; i -= 1) {
    remover = unsubscribe_removers[i];
    if (remover._cb === cb && remover._type.indexOf(type) >= 0) {
      remover.unsubscribe();
      unsubscribe_removers.splice(i, 1);
    }
  }
}

/* harmony default export */ var dist_es_unsubscribe = (unsubscribe);

// CONCATENATED MODULE: /home/circleci/project/node_modules/subscribe-ui-event/index.es.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */





var IS_CLIENT = typeof window !== 'undefined';

function warn() {
  if (false) {}
}

var index_es_listen = IS_CLIENT ? lib_listen : warn;
var index_es_subscribe = IS_CLIENT ? dist_es_subscribe : warn;
var index_es_unsubscribe = IS_CLIENT ? dist_es_unsubscribe : warn;


/***/ }),

/***/ "GMiS":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("ojcf"),
    keys = __webpack_require__("DWlz");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ "GSaD":
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ "GZgf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRICE_OF_STAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESET_PRICE_OF_STAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_INCLUSIVE_SERVICES_REQUEST; });
var PRICE_OF_STAY_REQUEST = 'PRICE_OF_STAY_REQUEST';
var RESET_PRICE_OF_STAY = 'RESET_PRICE_OF_STAY';
var ALL_INCLUSIVE_SERVICES_REQUEST = 'ALL_INCLUSIVE_SERVICES_REQUEST';

/***/ }),

/***/ "Gpi5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */
function addListener(emitter, event, fn, context, once) {
  if (typeof fn !== 'function') {
    throw new TypeError('The listener must be a function');
  }

  var listener = new EE(fn, context || emitter, once)
    , evt = prefix ? prefix + event : event;

  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
  else emitter._events[evt] = [emitter._events[evt], listener];

  return emitter;
}

/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */
function clearEvent(emitter, evt) {
  if (--emitter._eventsCount === 0) emitter._events = new Events();
  else delete emitter._events[evt];
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */
EventEmitter.prototype.listeners = function listeners(event) {
  var evt = prefix ? prefix + event : event
    , handlers = this._events[evt];

  if (!handlers) return [];
  if (handlers.fn) return [handlers.fn];

  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
    ee[i] = handlers[i].fn;
  }

  return ee;
};

/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */
EventEmitter.prototype.listenerCount = function listenerCount(event) {
  var evt = prefix ? prefix + event : event
    , listeners = this._events[evt];

  if (!listeners) return 0;
  if (listeners.fn) return 1;
  return listeners.length;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  return addListener(this, event, fn, context, false);
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  return addListener(this, event, fn, context, true);
};

/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    clearEvent(this, evt);
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
      listeners.fn === fn &&
      (!once || listeners.once) &&
      (!context || listeners.context === context)
    ) {
      clearEvent(this, evt);
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
        listeners[i].fn !== fn ||
        (once && !listeners[i].once) ||
        (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else clearEvent(this, evt);
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) clearEvent(this, evt);
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),

/***/ "Gqxm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _responsiveContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("/Mt0");







var __jsx = react__WEBPACK_IMPORTED_MODULE_7__["createElement"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




function Responsiveness(WrappedComponent) {
  var Responsive = /*#__PURE__*/function (_React$Component) {
    Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(Responsive, _React$Component);

    var _super = _createSuper(Responsive);

    function Responsive() {
      Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(this, Responsive);

      return _super.apply(this, arguments);
    }

    Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(Responsive, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            forwardRef = _this$props.forwardRef,
            rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_this$props, ["forwardRef"]);

        return __jsx(_responsiveContext__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].Consumer, null, function (responsive) {
          return __jsx(WrappedComponent, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
            ref: forwardRef
          }, rest, {
            responsive: responsive
          }));
        });
      }
    }]);

    return Responsive;
  }(react__WEBPACK_IMPORTED_MODULE_7__["Component"]); //$FlowFixMe


  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__["forwardRef"](function (props, ref) {
    return __jsx(Responsive, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, props, {
      forwardRef: ref
    }));
  });
}

/* harmony default export */ __webpack_exports__["a"] = (Responsiveness);

/***/ }),

/***/ "Gy6l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ArrowButton; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// CONCATENATED MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.themes.js



var themes = {
  "default": function _default(_ref) {
    var _ref$color = _ref.color,
        color = _ref$color === void 0 ? colors["a" /* COLORS */].GRAY_DARKER : _ref$color,
        _ref$colorBg = _ref.colorBg,
        colorBg = _ref$colorBg === void 0 ? colors["a" /* COLORS */].WHITE : _ref$colorBg,
        isDisabled = _ref.isDisabled;
    var colorsClasses = isDisabled ? 'bg-gray-light cursor-default pointer-events-none text-gray-medium' : "bg-".concat(colorBg, " focus:bg-").concat(colorBg, "-active hover:bg-").concat(colorBg, "-active text-").concat(color);
    return {
      thRoot: classnames_default()(colorsClasses, 'reset-button block flex items-center justify-center leading-none rounded-tiny text-sm transition-colors'),
      thIconName: icons["a" /* ICONS */].BOLDER_ARROW_FORTH_LEFT,
      thLabel: 'a11y'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx
var __jsx = react_default.a.createElement;





function ArrowButton(props) {
  var className = props.className,
      color = props.color,
      colorBg = props.colorBg,
      hasNoRtl = props.hasNoRtl,
      isDisabled = props.isDisabled,
      label = props.label,
      onClick = props.onClick,
      onMouseDown = props.onMouseDown,
      onMouseUp = props.onMouseUp,
      _props$rotation = props.rotation,
      rotation = _props$rotation === void 0 ? 0 : _props$rotation,
      _props$size = props.size,
      size = _props$size === void 0 ? 28 : _props$size,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      title = props.title,
      trackingData = props.trackingData;

  var _themes$theme = themes[theme]({
    color: color,
    colorBg: colorBg,
    isDisabled: isDisabled
  }),
      thIconName = _themes$theme.thIconName,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;

  var style = {
    height: size,
    width: size
  };
  return __jsx(TrackClick["a" /* TrackClick */], {
    "aria-disabled": isDisabled,
    as: "button",
    className: classnames_default()(className, thRoot),
    onClick: onClick,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    style: style,
    title: title,
    trackingData: trackingData,
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    hasRtl: !hasNoRtl,
    name: thIconName,
    rotation: rotation,
    width: "1em"
  }), label && __jsx("span", {
    className: thLabel
  }, label));
}

/***/ }),

/***/ "H4OD":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("4Db7");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "HUtr":
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__("Z1ta"),
    isArguments = __webpack_require__("lZQm"),
    isArray = __webpack_require__("tEYP"),
    isBuffer = __webpack_require__("EVz8"),
    isIndex = __webpack_require__("hIZU"),
    isTypedArray = __webpack_require__("sarX");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ "HaU7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regeneratorRuntime = __webpack_require__("IebI");

var _classCallCheck = __webpack_require__("zQIG");

var _createClass = __webpack_require__("8mBC");

var _inherits = __webpack_require__("I/kN");

var _possibleConstructorReturn = __webpack_require__("cMav");

var _getPrototypeOf = __webpack_require__("pSQP");

var _asyncToGenerator = __webpack_require__("4mCN");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _interopRequireDefault = __webpack_require__("Y3ZS");

exports.__esModule = true;
exports.Container = Container;
exports.createUrl = createUrl;
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__("ERkP"));

var _utils = __webpack_require__("fvxO");

exports.AppInitialProps = _utils.AppInitialProps;
exports.NextWebVitalsMetric = _utils.NextWebVitalsMetric;
/**
* `App` component is used for initialize of pages. It allows for overwriting and full control of the `page` initialization.
* This allows for keeping state between navigation, custom error handling, injecting additional data.
*/

function appGetInitialProps(_x) {
  return _appGetInitialProps.apply(this, arguments);
}

function _appGetInitialProps() {
  _appGetInitialProps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var Component, ctx, pageProps;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Component = _ref.Component, ctx = _ref.ctx;
            _context.next = 3;
            return (0, _utils.loadGetInitialProps)(Component, ctx);

          case 3:
            pageProps = _context.sent;
            return _context.abrupt("return", {
              pageProps: pageProps
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _appGetInitialProps.apply(this, arguments);
}

var App = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(App, _react$default$Compon);

  var _super = _createSuper(App);

  function App() {
    _classCallCheck(this, App);

    return _super.apply(this, arguments);
  }

  _createClass(App, [{
    key: "componentDidCatch",
    // Kept here for backwards compatibility.
    // When someone ended App they could call `super.componentDidCatch`.
    // @deprecated This method is no longer needed. Errors are caught at the top level
    value: function componentDidCatch(error, _errorInfo) {
      throw error;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          router = _this$props.router,
          Component = _this$props.Component,
          pageProps = _this$props.pageProps,
          __N_SSG = _this$props.__N_SSG,
          __N_SSP = _this$props.__N_SSP;
      return /*#__PURE__*/_react["default"].createElement(Component, Object.assign({}, pageProps, // we don't add the legacy URL prop if it's using non-legacy
      // methods like getStaticProps and getServerSideProps
      !(__N_SSG || __N_SSP) ? {
        url: createUrl(router)
      } : {}));
    }
  }]);

  return App;
}(_react["default"].Component);

exports["default"] = App;
App.origGetInitialProps = appGetInitialProps;
App.getInitialProps = appGetInitialProps;
var warnContainer;
var warnUrl;

if (false) {} // @deprecated noop for now until removal


function Container(p) {
  if (false) {}
  return p.children;
}

function createUrl(router) {
  // This is to make sure we don't references the router object at call time
  var pathname = router.pathname,
      asPath = router.asPath,
      query = router.query;
  return {
    get query() {
      if (false) {}
      return query;
    },

    get pathname() {
      if (false) {}
      return pathname;
    },

    get asPath() {
      if (false) {}
      return asPath;
    },

    back: function back() {
      if (false) {}
      router.back();
    },
    push: function push(url, as) {
      if (false) {}
      return router.push(url, as);
    },
    pushTo: function pushTo(href, as) {
      if (false) {}
      var pushRoute = as ? href : '';
      var pushUrl = as || href;
      return router.push(pushRoute, pushUrl);
    },
    replace: function replace(url, as) {
      if (false) {}
      return router.replace(url, as);
    },
    replaceTo: function replaceTo(href, as) {
      if (false) {}
      var replaceRoute = as ? href : '';
      var replaceUrl = as || href;
      return router.replace(replaceRoute, replaceUrl);
    }
  };
}

/***/ }),

/***/ "HcXJ":
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "HvnH":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("Q7Yi"),
    now = __webpack_require__("BKF0"),
    toNumber = __webpack_require__("1bTl");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ "IuYR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Price_Price; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// CONCATENATED MODULE: ./src/client/components/frameworks/price-item/PriceItem.themes.js
var themes = {
  best: {
    "package": {
      root: 'font-bold leading-one text-center',
      label: 'block font-sans text-gray-darker text-base uppercase',
      value: 'block text-turquoise text-5xl',
      longValue: 'block text-turquoise text-3xl'
    },
    thumbnail: {
      root: 'text-base flex items-center',
      label: 'font-sans text-gray-darker',
      value: 'leading-tight text-2xl underline px-1',
      longValue: 'leading-tight text-2xl underline'
    },
    instagram: {
      root: 'text-sm sm:text-base',
      label: 'font-sans',
      value: 'leading-tight text-md underline font-bold',
      longValue: 'leading-tight text-2xl underline'
    },
    ticket: {
      root: 'leading-one font-bold',
      label: 'align-top font-sans inline-block text-sm',
      value: 'border-b-2 border-current font-sans inline-block text-3xl',
      longValue: 'border-b-2 border-current font-sans inline-block text-3xl'
    },
    remote: {
      root: 'leading-one font-bold px-1 flex items-center',
      label: 'align-top font-sans inline-block text-sm pr-1 rtl:pr-1',
      value: 'font-sans inline-block text-3xl',
      longValue: 'font-sans inline-block text-3xl'
    },
    joyviewRemote: {
      root: 'leading-one font-bold px-1 flex items-center',
      label: 'align-top font-sans inline-block text-sm pr-1 rtl:pr-1',
      value: 'font-sans inline-block text-3xl',
      longValue: 'font-sans inline-block text-3xl'
    },
    compare: {
      root: 'text-base flex items-center',
      label: 'font-sans text-gray-darker',
      value: 'leading-tight text-xl md:text-2xl underline px-1',
      longValue: 'leading-tight text-2xl underline'
    }
  },
  initial: {
    "package": {
      root: 'block font-bold leading-tight text-center',
      label: 'inline-block font-sans text-gray-darker text-base',
      value: 'inline-block line-through text-gray-darker text-base',
      longValue: 'block line-through text-gray-darker text-base'
    },
    thumbnail: {
      root: 'inline-block lowercase text-md',
      label: 'hidden',
      value: 'line-through uppercase',
      longValue: 'line-through uppercase'
    },
    ticket: {
      root: 'font-bold text-sm',
      label: 'font-sans',
      value: 'font-sans line-through',
      longValue: 'font-sans line-through'
    },
    remote: {
      root: 'font-bold text-md text-grenadine',
      label: 'font-sans',
      value: 'font-sans line-through',
      longValue: 'font-sans line-through'
    },
    joyviewRemote: {
      root: 'font-bold text-md text-grenadine',
      label: 'font-sans',
      value: 'font-sans line-through',
      longValue: 'font-sans line-through'
    },
    instagram: {
      root: 'text-sm sm:text-base',
      label: 'font-sans',
      value: 'font-sans line-through',
      longValue: 'font-sans line-through'
    },
    compare: {
      root: 'inline-block lowercase text-md',
      label: 'hidden',
      value: 'line-through uppercase',
      longValue: 'line-through uppercase'
    }
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price-item/PriceItem.jsx
var __jsx = react_default.a.createElement;




function PriceItem(props) {
  var className = props.className,
      formattedValue = props.formattedValue,
      label = props.label,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'package' : _props$theme,
      _props$type = props.type,
      type = _props$type === void 0 ? 'best' : _props$type,
      _props$value = props.value,
      value = _props$value === void 0 ? 0 : _props$value,
      _props$isValueClickab = props.isValueClickable,
      isValueClickable = _props$isValueClickab === void 0 ? false : _props$isValueClickab;
  if (!value || !formattedValue) return null;
  var classes = classnames_default()(className, themes[type][theme].root);
  var valueClasses = Object(price_util["f" /* isLongFormat */])(value) ? themes[type][theme].longValue : themes[type][theme].value;
  return __jsx("span", {
    className: classes
  }, !!label && __jsx("span", {
    className: themes[type][theme].label,
    "data-testid": "PriceItem-label"
  }, label), !!label && !!formattedValue && __jsx("span", null, " "), __jsx("span", {
    className: classnames_default()(valueClasses, {
      'underline cursor-pointer': isValueClickable
    }),
    "data-testid": "PriceItem-value"
  }, formattedValue));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/utils/currency-config-for-locale/currencyConfigForLocale.js
var currencyConfigForLocale = __webpack_require__("wz9x");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// CONCATENATED MODULE: ./src/client/components/frameworks/price/Price.themes.js
var Price_themes_themes = {
  "package": {
    root: 'overflow-hidden',
    unit: 'block font-sans font-bold text-center text-sm uppercase',
    viewRates: 'flex font-bold font-sans justify-center leading-tight text-center text-md',
    viewRatesLabel: 'rtl:ml-2'
  },
  thumbnail: {
    priceRoot: 'font-brand flex items-center',
    root: 'flex items-center leading-half overflow-hidden pt-1 pb-2',
    unit: 'inline-block font-sans text-base text-gray-darker',
    initialPrice: 'text-grenadine -order-1 -mb-1',
    viewRates: 'flex items-center underline font-sans leading-one text-base',
    viewRatesIcon: 'hidden',
    viewRatesLabel: 'rtl:ml-1'
  },
  instagram: {
    priceRoot: 'font-brand text-inherit',
    root: 'w-full flex items-center leading-half truncate text-white',
    unit: 'inline-block font-sans text-sm sm:text-base',
    initialPrice: 'text-grenadine',
    viewRates: 'flex items-center underline font-sans leading-one text-sm sm:text-base',
    viewRatesIcon: 'hidden',
    viewRatesLabel: 'rtl:ml-1'
  },
  ticket: {
    root: 'overflow-hidden',
    unit: 'font-bold font-sans inline-block text-sm',
    viewRates: 'flex items-center font-bold font-sans leading-one text-xl',
    viewRatesLabel: 'rtl:ml-2'
  },
  remote: {
    root: 'overflow-hidden text-blue flex',
    unit: 'font-bold font-sans inline-block text-sm',
    viewRates: 'flex items-center font-bold font-sans leading-one text-xl',
    viewRatesLabel: 'rtl:ml-2',
    initialPrice: '-order-1',
    priceRoot: 'flex items-center'
  },
  joyviewRemote: {
    root: 'overflow-hidden text-waterGreen flex',
    unit: 'font-bold font-sans inline-block text-sm',
    viewRates: 'flex items-center font-bold font-sans leading-one text-xl',
    viewRatesLabel: 'rtl:ml-2',
    initialPrice: '-order-1',
    priceRoot: 'flex items-center'
  },
  compare: {
    priceRoot: 'font-brand flex items-center w-full',
    root: 'flex items-center leading-half overflow-hidden pt-1',
    unit: 'inline-block font-sans text-sm md:text-base text-gray-darker truncate leading-one',
    initialPrice: 'text-grenadine -order-1 -mb-1',
    viewRates: 'flex items-center underline font-sans leading-one text-sm md:text-base',
    viewRatesIcon: 'hidden',
    viewRatesLabel: 'rtl:ml-1'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/Price.jsx







var Price_jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }











var Price_Price = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(Price, _Component);

  var _super = _createSuper(Price);

  function Price() {
    Object(classCallCheck["a" /* default */])(this, Price);

    return _super.apply(this, arguments);
  }

  Object(createClass["a" /* default */])(Price, [{
    key: "hasDiscount",
    value: function hasDiscount() {
      var _this$props = this.props,
          _this$props$bestPrice = _this$props.bestPrice,
          bestPrice = _this$props$bestPrice === void 0 ? {} : _this$props$bestPrice,
          _this$props$initialPr = _this$props.initialPrice,
          initialPrice = _this$props$initialPr === void 0 ? {} : _this$props$initialPr;
      return Object(price_util["e" /* hasPrice */])(initialPrice) && Object(price_util["e" /* hasPrice */])(bestPrice) && initialPrice.value !== bestPrice.value;
    }
  }, {
    key: "renderViewRate",
    value: function renderViewRate() {
      var _this$props2 = this.props,
          theme = _this$props2.theme,
          viewRates = _this$props2.viewRates;
      return Price_jsx("div", {
        className: Price_themes_themes[theme].viewRates
      }, Price_jsx(Icon["a" /* Icon */], {
        className: Price_themes_themes[theme].viewRatesIcon,
        name: icons["a" /* ICONS */].DATE,
        width: "1em"
      }), Price_jsx("span", {
        className: Price_themes_themes[theme].viewRatesLabel,
        "data-testid": "Price-viewRate"
      }, viewRates));
    }
  }, {
    key: "renderUnit",
    value: function renderUnit() {
      var _this$props3 = this.props,
          theme = _this$props3.theme,
          unit = _this$props3.unit,
          withAsterisk = _this$props3.withAsterisk;
      return unit ? Price_jsx("span", {
        className: Price_themes_themes[theme].unit,
        "data-testid": "Price-unit"
      }, unit, withAsterisk && Price_jsx("sup", null, "*")) : null;
    }
  }, {
    key: "renderNoDiscount",
    value: function renderNoDiscount() {
      var _this$props4 = this.props,
          bestPrice = _this$props4.bestPrice,
          from = _this$props4.from,
          initialPrice = _this$props4.initialPrice,
          theme = _this$props4.theme,
          isValueClickable = _this$props4.isValueClickable,
          withInstalment = _this$props4.withInstalment;
      var price;

      if (Object(price_util["e" /* hasPrice */])(initialPrice)) {
        price = initialPrice;
      } else if (Object(price_util["e" /* hasPrice */])(bestPrice)) {
        price = bestPrice;
      }

      return Price_jsx(react["Fragment"], null, Price_jsx(PriceItem, Object(esm_extends["a" /* default */])({
        label: from,
        theme: theme,
        type: "best"
      }, price, {
        formattedValue: withInstalment ? Object(price_util["b" /* getInstalmentPrice */])(price, this.context.locale) : price && price.formattedValue,
        className: Price_themes_themes[theme].price,
        isValueClickable: isValueClickable
      })), Price_jsx("span", null, " "), this.renderUnit());
    }
  }, {
    key: "renderDiscount",
    value: function renderDiscount() {
      var _this$props5 = this.props,
          bestPrice = _this$props5.bestPrice,
          from = _this$props5.from,
          hasInitialPrice = _this$props5.hasInitialPrice,
          _this$props5$initialP = _this$props5.initialPrice,
          initialPrice = _this$props5$initialP === void 0 ? {} : _this$props5$initialP,
          instead = _this$props5.instead,
          theme = _this$props5.theme,
          isValueClickable = _this$props5.isValueClickable,
          withInstalment = _this$props5.withInstalment;
      var displayInstalment = withInstalment && Object(i18n["c" /* getKeyValue */])('common.price.displayInstalmentsPrice');
      var locale = this.context.locale;
      return Price_jsx(react["Fragment"], null, Price_jsx(PriceItem, Object(esm_extends["a" /* default */])({
        label: from,
        theme: theme,
        type: "best"
      }, bestPrice, {
        formattedValue: withInstalment ? Object(price_util["b" /* getInstalmentPrice */])(bestPrice, locale) : bestPrice && bestPrice.formattedValue,
        className: Price_themes_themes[theme].price,
        isValueClickable: isValueClickable
      })), Price_jsx("span", null, " "), hasInitialPrice && Price_jsx(PriceItem, Object(esm_extends["a" /* default */])({
        label: instead,
        theme: theme,
        type: "initial"
      }, initialPrice, {
        formattedValue: displayInstalment && initialPrice && ['pt-BR', 'es-AR'].includes(locale) ? Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(Math.trunc(initialPrice.value), locale, initialPrice.currency, {
          precision: 0
        }) : initialPrice && initialPrice.formattedValue,
        className: Price_themes_themes[theme].initialPrice
      })), Price_jsx("span", null, " "), this.renderUnit());
    }
  }, {
    key: "renderPrice",
    value: function renderPrice() {
      return this.hasDiscount() ? this.renderDiscount() : this.renderNoDiscount();
    }
  }, {
    key: "renderContent",
    value: function renderContent(displayPrice) {
      var isLoading = this.props.isLoading;

      if (isLoading) {
        return Price_jsx("div", {
          className: "loadingDots",
          "data-testid": "Price-loader"
        });
      }

      if (displayPrice) {
        return this.renderPrice();
      }

      return this.renderViewRate();
    }
  }, {
    key: "render",
    value: function render() {
      var displayPrice = Object(price_util["d" /* hasAtLeastOnePrice */])(this.props);

      if (!displayPrice && !this.props.viewRates) {
        return null;
      }

      var _this$props6 = this.props,
          className = _this$props6.className,
          containerStyle = _this$props6.containerStyle,
          style = _this$props6.style,
          theme = _this$props6.theme,
          onClick = _this$props6.onClick;
      var classes = classnames_default()(className, Price_themes_themes[theme].root, {
        'reset-button': !!onClick
      });
      var TagName = onClick ? 'button' : 'div';
      return Price_jsx(TagName, {
        className: classes,
        style: containerStyle,
        onClick: onClick
      }, Price_jsx("div", {
        className: Price_themes_themes[theme].priceRoot,
        style: style
      }, this.renderContent(displayPrice)));
    }
  }]);

  return Price;
}(react["Component"]);

Object(defineProperty["a" /* default */])(Price_Price, "contextType", ReactAppContext["a" /* default */]);

Object(defineProperty["a" /* default */])(Price_Price, "defaultProps", {
  containerStyle: {
    minHeight: '2.5rem'
  },
  hasInitialPrice: true,
  isLoading: false,
  theme: 'package',
  isValueClickable: false,
  withAsterisk: true,
  withInstalment: true
});

/***/ }),

/***/ "J77r":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("lDSF"),
    root = __webpack_require__("jP+d");

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ "JG32":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("dZwK");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ "JPie":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("aWzz");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var focus_lock_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("R6jJ");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("s5tn");






var AutoFocusInside = function AutoFocusInside(_ref) {
  var disabled = _ref.disabled,
      children = _ref.children,
      className = _ref.className;
  return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, Object(_util__WEBPACK_IMPORTED_MODULE_4__[/* inlineProp */ "b"])(focus_lock_constants__WEBPACK_IMPORTED_MODULE_3__[/* FOCUS_AUTO */ "b"], !disabled), {
    className: className
  }), children);
};

AutoFocusInside.propTypes =  false ? undefined : {};
AutoFocusInside.defaultProps = {
  disabled: false,
  className: undefined
};
/* harmony default export */ __webpack_exports__["a"] = (AutoFocusInside);

/***/ }),

/***/ "JU27":
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__("N8jz"),
    ListCache = __webpack_require__("2K7v"),
    Map = __webpack_require__("McKP");

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ "JYyW":
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__("VAV/");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ "Kb9x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_VALIDATION_SCHEMA; });
var UPDATE_VALIDATION_SCHEMA = 'UPDATE_VALIDATION_SCHEMA';

/***/ }),

/***/ "Khd+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("HaU7")


/***/ }),

/***/ "Khoy":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "KiAj":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("pfIK"),
    copyObject = __webpack_require__("ojcf"),
    createAssigner = __webpack_require__("6MnY"),
    isArrayLike = __webpack_require__("gvfs"),
    isPrototype = __webpack_require__("RVBP"),
    keys = __webpack_require__("DWlz");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),

/***/ "KicR":
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__("5FP0");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ "KxdP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMFORT_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EXTRA_FEATURES_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONFIGURATION_CATEGORY; });
/* unused harmony export matchConfiguration */
/* unused harmony export matchComfort */
/* unused harmony export matchExtraFeatures */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createFilters; });
/* unused harmony export createConfigurationFilters */
/* unused harmony export createComfortFilters */
/* unused harmony export createExtraFeaturesFilters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return unselectCategory; });
/* unused harmony export REDUCED_MOBILITY_FILTER_ID */
/* unused harmony export matchExtraFeaturesReducedMobility */
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fGyu");
/* harmony import */ var shortid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("MIfU");
/* harmony import */ var shortid__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(shortid__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("h/fj");
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("lZ21");
/* harmony import */ var _components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("aWOT");



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}







var COMFORT_CATEGORY = 'accommodations';
var EXTRA_FEATURES_CATEGORY = 'extra';
var CONFIGURATION_CATEGORY = 'configuration';
var REDUCED_MOBILITY_FILTER_ID = 'reduced_mobility_access';

var matchConfiguration = function matchConfiguration(accommodations, roomType) {
  return accommodations.some(function (accommodation) {
    return accommodation.roomType === roomType;
  });
};

var matchComfort = function matchComfort(accommodations, categoryId) {
  return accommodations.some(function (accommodation) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(accommodation, 'categories').find(function (category) {
      return Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(category, 'id') === categoryId;
    });
  });
};

var matchExtraFeatures = function matchExtraFeatures(accommodations, strengthId) {
  return accommodations.some(function (accommodation) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(accommodation, 'view.id', null) === strengthId || Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(accommodation, 'strengths', []).find(function (strength) {
      return Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(strength, 'id') === strengthId;
    });
  });
};

var matchExtraFeaturesReducedMobility = function matchExtraFeaturesReducedMobility(accommodations) {
  return accommodations.some(function (accommodation) {
    return accommodation.reducedMobilityAccess;
  });
};

function createConfigurationFilters(accommodationsSets, resort) {
  var accommodations = Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["pipe"])([Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["map"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["path"])('accommodations')), lodash_fp__WEBPACK_IMPORTED_MODULE_4__["flatten"], Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["uniqBy"])('roomType')])(accommodationsSets);
  return accommodations.map(function (_ref) {
    var roomType = _ref.roomType;
    return {
      id: shortid__WEBPACK_IMPORTED_MODULE_2___default.a.generate(),
      category: CONFIGURATION_CATEGORY,
      match: matchConfiguration,
      className: 'additionalAccommodationsFilters',
      meta: {
        label: Object(_components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__[/* tAlt */ "c"])({
          resortKeyPath: "filters.configuration.".concat(_utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_6__[/* ROOM_TYPE */ "e"][roomType]),
          cruiseKeyPath: "filters.configuration.".concat(_utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_6__[/* CABIN_TYPE */ "b"][roomType]),
          resort: resort
        }),
        icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"][roomType],
        iconClassName: "icon--".concat(roomType),
        iconInheritColor: true
      },
      path: 'accommodations',
      selected: false,
      value: roomType
    };
  });
}

function createComfortFilters(accommodationsSets) {
  var accommodations = Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["pipe"])([Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["map"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["path"])('accommodations')), lodash_fp__WEBPACK_IMPORTED_MODULE_4__["flatten"], lodash_fp__WEBPACK_IMPORTED_MODULE_4__["compact"], Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["uniqBy"])('categoryId')])(accommodationsSets);
  var comfortSeen = [];
  return accommodations.map(function (accommodation) {
    /**
     * in some cases we have differents categories with same comfort type
     * it causes a duplicate filter
     * Concat comfort type & category, as label for teh second one
     */
    var comfortType = accommodation.comfortType,
        category = accommodation.category;
    var label = comfortSeen.includes(comfortType) ? "".concat(comfortType, " ").concat(category) : comfortType || category;
    comfortSeen.push(accommodation.comfortType);
    return {
      id: shortid__WEBPACK_IMPORTED_MODULE_2___default.a.generate(),
      category: COMFORT_CATEGORY,
      match: matchComfort,
      className: 'additionalAccommodationsFilters',
      meta: {
        label: label
      },
      path: 'accommodations',
      selected: false,
      value: accommodation.categoryId
    };
  });
}

function createExtraFeaturesFilters(accommodationsSets, i18n) {
  var accommodations = Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["pipe"])([Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["map"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["path"])('accommodations')), lodash_fp__WEBPACK_IMPORTED_MODULE_4__["flatten"], Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["uniqBy"])('id')])(accommodationsSets);
  var strengths = Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["pipe"])([Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["map"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["path"])('strengths')), lodash_fp__WEBPACK_IMPORTED_MODULE_4__["flatten"], lodash_fp__WEBPACK_IMPORTED_MODULE_4__["compact"], Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["uniqBy"])('id')])(accommodations);
  var views = Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["pipe"])([Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["map"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["path"])('view')), lodash_fp__WEBPACK_IMPORTED_MODULE_4__["compact"], Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["uniqBy"])('id')])(accommodations);
  var reducedMobityAccess = accommodations.some(function (accommodation) {
    return accommodation.reducedMobilityAccess;
  }) ? [{
    id: REDUCED_MOBILITY_FILTER_ID,
    label: i18n.filters.reducedMobility
  }] : [];
  var features = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(strengths), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(views), reducedMobityAccess);
  return features.map(function (feature) {
    return {
      id: shortid__WEBPACK_IMPORTED_MODULE_2___default.a.generate(),
      category: EXTRA_FEATURES_CATEGORY,
      match: feature.id === REDUCED_MOBILITY_FILTER_ID ? matchExtraFeaturesReducedMobility : matchExtraFeatures,
      meta: {
        label: feature.label,
        icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"][feature.id],
        iconClassName: "icon--".concat(feature.id),
        iconInheritColor: true
      },
      path: 'accommodations',
      selected: false,
      value: feature.id
    };
  });
}

function createFilters(accommodationsSets, i18n, resort) {
  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(createExtraFeaturesFilters(accommodationsSets, i18n)), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(createConfigurationFilters(accommodationsSets, resort)), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(createComfortFilters(accommodationsSets)));
}

function unselectCategory(filters) {
  return function (category) {
    return filters.map(function (filter) {
      return _objectSpread(_objectSpread({}, filter), {}, {
        selected: filter.category === category ? false : filter.selected
      });
    });
  };
}



/***/ }),

/***/ "Ky/o":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("2rns");

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ "Lbah":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("3QVS");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ "McKP":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("lDSF"),
    root = __webpack_require__("jP+d");

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ "N8jz":
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__("zjgX"),
    hashDelete = __webpack_require__("SHsq"),
    hashGet = __webpack_require__("EzIG"),
    hashHas = __webpack_require__("JG32"),
    hashSet = __webpack_require__("qmjq");

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ "N9he":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("rnJz"),
    isObjectLike = __webpack_require__("oS78");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ "Nhxn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return attributesToString; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var stringify_object__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("pPFN");
/* harmony import */ var stringify_object__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(stringify_object__WEBPACK_IMPORTED_MODULE_1__);
/* eslint-disable no-duplicate-imports  */


function attributesToString(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.keys(data).reduce(function (acc, key) {
    if (options.ignoreUndefined && data[key] === undefined) {
      return '';
    }

    var value = data[key] === null ? '' : data[key];
    var dataToString = Array.isArray(value) || Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isBoolean"])(value) || Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isObject"])(value) ? stringify_object__WEBPACK_IMPORTED_MODULE_1___default()(value, {
      singleQuotes: false,
      inlineCharacterLimit: 1024,
      filter: function filter(o, p) {
        return options.ignoreUndefined ? o[p] !== undefined : true;
      }
    }) : "\"".concat(value, "\"");
    return "".concat(acc).concat(key, " : ").concat(dataToString, " ");
  }, '');
}

/***/ }),

/***/ "NrqW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useTrackSearchResults; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("uDfI");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _FacetSearch_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("hPQF");
/* harmony import */ var _store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("vIa8");
/* harmony import */ var _store_search_search_selector__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("B3yO");
/* harmony import */ var _store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("RBO1");
/* harmony import */ var _store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("Jsmy");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("829J");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("sRdV");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("sW3P");
/* harmony import */ var _utils_tracking_resort__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("zCbR");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}













var useTrackSearchResults = function useTrackSearchResults() {
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_10__[/* useTracking */ "a"])();
  var adults = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_8__[/* getAdults */ "a"])(state) || [];
  });
  var departureCity = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_7__[/* getDepartureCity */ "a"])(state);
  });
  var departureDate = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_7__[/* getDepartureDate */ "b"])(state);
  });
  var duration = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_7__[/* getTripDuration */ "c"])(state);
  });

  var _useSelector = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_5__[/* facetingCriteriaSelector */ "c"])(state);
  }),
      _useSelector$filters = _useSelector.filters,
      filters = _useSelector$filters === void 0 ? [] : _useSelector$filters;

  var keywords = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_search_search_selector__WEBPACK_IMPORTED_MODULE_6__[/* keywordsSelector */ "a"])(state);
  });
  var kids = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_8__[/* getKids */ "c"])(state) || [];
  });
  var products = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_5__[/* filteredProductsSelector */ "g"])(state) || [];
  });
  var productsCount = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_5__[/* filteredProductsCountSelector */ "e"])(state) || 0;
  });
  var query = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (_ref) {
    var faceting = _ref.faceting;
    return faceting.query || {};
  });
  var redirection = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (_ref2) {
    var faceting = _ref2.faceting;
    return faceting.redirection;
  });
  var isFromAutoComplete = Boolean(query.type);
  var nbAdults = adults.length;
  var nbKids = kids.length;
  var nbParticipants = nbAdults + nbKids;
  var searchTerms = isFromAutoComplete || query.label ? query.label : keywords;
  var withFilter = Boolean(nbKids > 0 || duration || departureDate || departureCity || filters.length > 0);

  var executeTracking = function executeTracking(payload) {
    var searchResorts = products.map(function (product) {
      return {
        resortCode: product.id,
        resortName: product.name,
        resortTrident: product.comfort,
        resortCountry: product.destination ? product.destination.country : null,
        resortRegion: product.destination ? product.destination.area : null,
        resortAdult: nbAdults,
        resortChildren: nbKids,
        resortDepartureCityCode: departureCity,
        resortSeasonType: product.seasonName || 'Summer',
        resortUrlImage: product.image,
        versionBooking: 'responsive',
        resortSeason: departureDate && Object(_utils_tracking_resort__WEBPACK_IMPORTED_MODULE_12__[/* isSummer */ "e"])(new Date(departureDate)) ? 'Summer' : 'Winter',
        resortYearSeason: moment__WEBPACK_IMPORTED_MODULE_3___default()(departureDate).format('YYYY')
      };
    }); // $FlowFixMe

    track(_objectSpread({
      event: _tracking_constants__WEBPACK_IMPORTED_MODULE_9__[/* VIRTUAL_PAGE_LOAD */ "y"],
      internalSearchEngineNbResults: redirection ? 'redirection' : productsCount,
      pageName: 'shopping_home_search',
      resortAdult: nbAdults,
      resortChildren: nbKids,
      resortDepartureCityCode: departureCity,
      resortNightNumber: duration,
      resortTotalParticipant: nbParticipants,
      resortTransport: departureCity ? 'with Transport' : null,
      searchDate: moment__WEBPACK_IMPORTED_MODULE_3___default()().format(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_11__[/* DATE_FORMAT */ "g"]),
      searchDepartureDate: departureDate ? moment__WEBPACK_IMPORTED_MODULE_3___default()(departureDate).format(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_11__[/* DATE_FORMAT */ "g"]) : null,
      searchDestinationArea: Object(_FacetSearch_utils__WEBPACK_IMPORTED_MODULE_4__[/* getFacetsAsString */ "d"])(filters, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_11__[/* DESTINATIONS_FACET_ID */ "o"]),
      searchDestinationCountry: Object(_FacetSearch_utils__WEBPACK_IMPORTED_MODULE_4__[/* getFacetsAsString */ "d"])(filters, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_11__[/* COUNTRIES_FACET_ID */ "f"]),
      searchFilter: withFilter ? 'withFilter' : 'withoutFilter',
      searchRequestType: isFromAutoComplete ? 'Autocomplete' : 'Nocomplete',
      searchTerms: searchTerms || '',
      // $FlowFixMe - Could not get around an issue with Array<TrackingSearchResort>
      searchResorts: searchResorts
    }, payload)); // Reset searchReferrer after each pageView is sent.
    // If searchReferrer === "null", GTM will set it to "search"

    track({
      event: 'PUSH',
      searchReferrer: 'null'
    });
  };

  return executeTracking;
};

/***/ }),

/***/ "Onl6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlockLink; });
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _tracking_track_click_TrackClick_jsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("NJJ8");
/* harmony import */ var _icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("qBqs");
/* harmony import */ var _BlockLink_themes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("uRnh");






var __jsx = react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







var BlockLink = /*#__PURE__*/function (_PureComponent) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(BlockLink, _PureComponent);

  var _super = _createSuper(BlockLink);

  function BlockLink() {
    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this, BlockLink);

    return _super.apply(this, arguments);
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(BlockLink, [{
    key: "renderTexts",
    value: function renderTexts() {
      var texts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var classes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var theme = this.props.theme;
      return texts.filter(function (text) {
        return !Object(lodash__WEBPACK_IMPORTED_MODULE_7__["isEmpty"])(text);
      }).map(function (text, idx) {
        return __jsx("div", {
          className: classnames__WEBPACK_IMPORTED_MODULE_8___default()("BlockLink-text-".concat(idx), classes, Object(lodash__WEBPACK_IMPORTED_MODULE_7__["get"])(_BlockLink_themes__WEBPACK_IMPORTED_MODULE_11__[/* themes */ "a"][theme], "customText".concat(idx), '')),
          "data-testid": "BlockLink-text",
          key: idx
        }, text);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          icon = _this$props.icon,
          onClick = _this$props.onClick,
          secondaryTexts = _this$props.secondaryTexts,
          target = _this$props.target,
          texts = _this$props.texts,
          theme = _this$props.theme,
          trackingData = _this$props.trackingData,
          _this$props$url = _this$props.url,
          url = _this$props$url === void 0 ? '' : _this$props$url;
      var title = (texts || []).filter(function (t) {
        return typeof t === 'string';
      }).join(' ');
      var linkTarget = url.startsWith('tel:') ? '' : target;
      var _themes$theme = _BlockLink_themes__WEBPACK_IMPORTED_MODULE_11__[/* themes */ "a"][theme],
          thIcon = _themes$theme.thIcon,
          thIconWidth = _themes$theme.thIconWidth,
          thRoot = _themes$theme.thRoot,
          thSText = _themes$theme.thSText;
      var classes = classnames__WEBPACK_IMPORTED_MODULE_8___default()(className, thRoot);
      return !Object(lodash__WEBPACK_IMPORTED_MODULE_7__["isEmpty"])(texts) || icon ? __jsx(_tracking_track_click_TrackClick_jsx__WEBPACK_IMPORTED_MODULE_9__[/* TrackClick */ "a"], {
        as: "a",
        className: classes,
        href: url,
        onClick: onClick,
        rel: "noopener noreferrer",
        target: linkTarget,
        title: title,
        trackingData: trackingData
      }, __jsx(_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_10__[/* Icon */ "a"], {
        className: classnames__WEBPACK_IMPORTED_MODULE_8___default()('flex-shrink-0', thIcon),
        name: icon,
        width: thIconWidth
      }), !Object(lodash__WEBPACK_IMPORTED_MODULE_7__["isEmpty"])(texts) && __jsx("span", null, this.renderTexts(texts), this.renderTexts(secondaryTexts, thSText))) : null;
    }
  }]);

  return BlockLink;
}(react__WEBPACK_IMPORTED_MODULE_6__["PureComponent"]);

Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(BlockLink, "defaultProps", {
  target: '_blank',
  theme: 'default',
  onClick: function onClick() {}
});

/***/ }),

/***/ "PCgT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GridCell; });
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("I6kL");






var __jsx = react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






function getClass(prop, key, css) {
  // $FlowFixMe
  return prop.hasOwnProperty(key) && Object(lodash__WEBPACK_IMPORTED_MODULE_8__["isInteger"])(prop[key]) && prop[key] > 0 ? " ".concat(key).concat(css).concat(prop[key]) : '';
}

function getResponsiveClasses(_ref) {
  var _ref$cols = _ref.cols,
      cols = _ref$cols === void 0 ? _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__[/* DEFAULT_CELL_COLS */ "b"] : _ref$cols,
      _ref$offsets = _ref.offsets,
      offsets = _ref$offsets === void 0 ? {} : _ref$offsets;

  var cellCols = _objectSpread(_objectSpread({}, _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__[/* DEFAULT_CELL_COLS */ "b"]), cols);

  return Object.keys(_utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__[/* BREAKPOINTS */ "a"]).map(function (key) {
    return getClass(cellCols, _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__[/* BREAKPOINTS */ "a"][key], '-GridCell--') + getClass(offsets, _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__[/* BREAKPOINTS */ "a"][key], '-GridCell--offset-');
  }).join('');
}

var GridCell = /*#__PURE__*/function (_React$Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(GridCell, _React$Component);

  var _super = _createSuper(GridCell);

  function GridCell() {
    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this, GridCell);

    return _super.apply(this, arguments);
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(GridCell, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          id = _this$props.id;
      if (!react__WEBPACK_IMPORTED_MODULE_6__["Children"].count(children)) return null;
      return __jsx("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_7___default()(className, 'flex-1 max-w-full', "GridCell".concat(getResponsiveClasses(this.props))),
        id: id
      }, children);
    }
  }]);

  return GridCell;
}(react__WEBPACK_IMPORTED_MODULE_6___default.a.Component);

/***/ }),

/***/ "PFCZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_DEPARTURE_CITY; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cvSI");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _constants__WEBPACK_IMPORTED_MODULE_0__["r"]; });


var DEFAULT_DEPARTURE_CITY = 'NO';

/***/ }),

/***/ "PSHn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STATUS_CODE_200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STATUS_CODE_400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STATUS_CODE_401; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STATUS_CODE_404; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return STATUS_CODE_409; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return STATUS_CODE_500; });
var STATUS_CODE_200 = 200;
var STATUS_CODE_400 = 400;
var STATUS_CODE_401 = 401;
var STATUS_CODE_404 = 404;
var STATUS_CODE_409 = 409;
var STATUS_CODE_500 = 500;

/***/ }),

/***/ "PZXw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ WebCallbackTrigger; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/context/pageContext.js
var context_pageContext = __webpack_require__("RPju");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: ./src/client/components/frameworks/side-panel/SidePanel.jsx + 1 modules
var SidePanel = __webpack_require__("p7XS");

// EXTERNAL MODULE: ./src/client/components/frameworks/block-link/BlockLink.themes.js
var BlockLink_themes = __webpack_require__("uRnh");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /home/circleci/project/node_modules/formik/dist/formik.esm.js + 115 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/webcallback/WebCallbackFields.jsx

var __jsx = react_default.a.createElement;





function GroupedSelect(_ref) {
  var fieldName = _ref.fieldName,
      position = _ref.position,
      width = _ref.width,
      options = _ref.options,
      onChange = _ref.onChange;
  return __jsx(formik_esm["b" /* Field */], {
    name: fieldName
  }, function (_ref2) {
    var field = _ref2.field,
        errors = _ref2.form.errors;
    return __jsx("div", {
      className: classnames_default()("relative inline-block w-".concat(width, " border-1 overflow-hidden"), {
        'border-r-0': position === 'left',
        'rounded-l-small': position === 'left',
        'rounded-r-small': position === 'right',
        'border-emerald': !errors[field.name],
        'border-red': errors[field.name]
      })
    }, __jsx("select", Object(esm_extends["a" /* default */])({
      autoComplete: "off",
      className: "reset-input reset-select relative text-current w-full bg-white px-3 py-2"
    }, field, onChange ? {
      onChange: onChange
    } : null), options.map(function (_ref3) {
      var value = _ref3.value,
          name = _ref3.name;
      return __jsx("option", {
        key: name,
        value: value
      }, name);
    })), __jsx("div", {
      className: "absolute flex h-full items-center top-0 rtl:right-0 pointer-events-none px-2 text-current"
    }, __jsx(Icon["a" /* Icon */], {
      name: icons["a" /* ICONS */].SELECT,
      width: "0.75rem"
    })));
  });
}
function GroupedInput(_ref4) {
  var fieldName = _ref4.fieldName,
      position = _ref4.position,
      width = _ref4.width,
      _ref4$type = _ref4.type,
      type = _ref4$type === void 0 ? 'text' : _ref4$type,
      _ref4$required = _ref4.required,
      required = _ref4$required === void 0 ? false : _ref4$required;
  return __jsx(formik_esm["b" /* Field */], {
    name: fieldName
  }, function (_ref5) {
    var field = _ref5.field,
        _ref5$form = _ref5.form,
        touched = _ref5$form.touched,
        errors = _ref5$form.errors;
    return __jsx("input", Object(esm_extends["a" /* default */])({
      type: type,
      required: required
    }, field, {
      className: classnames_default()("outline-none shadows-none inline-block w-".concat(width, " px-3 py-2 align-top text-current bg-white border-1"), {
        'border-r-0': position === 'left',
        'rounded-l-small': position === 'left',
        'rounded-r-small': position === 'right',
        'border-gray-medium': !touched[field.name],
        'border-emerald': touched[field.name] && !errors[field.name],
        'border-red': touched[field.name] && errors[field.name]
      })
    }));
  });
}
// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /home/circleci/project/node_modules/moment/moment.js
var moment = __webpack_require__("wgY5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// CONCATENATED MODULE: ./src/client/components/widgets/webcallback/WebCallbackForm.utils.js




/* eslint-disable space-before-function-paren */






var ACCOUNT_ID = config_default.a.get('freespee.accountId');
var AGENT_NUMBER = config_default.a.get('freespee.agentNumber');
var AGENT_NUMBER_ID = config_default.a.get('freespee.agentNumberId');
var CALLER_ID = config_default.a.get('freespee.callerId') || '';
var CUSTOMER_ID = config_default.a.get('freespee.customerId');
var FREESPEE_DATE_FORMAT = 'YYYY-MM-DD';
var FREESPEE_TIME_FORMAT = 'HH:mm:ss';
var FREESPEE_DATETIME_FORMAT = "".concat(FREESPEE_DATE_FORMAT, " ").concat(FREESPEE_TIME_FORMAT);
var DISPLAY_TIME_FORMAT = 'HH:mm';
var RETRIES = '2';
var RETRY_INTERVAL = '120';
var ASAP_TIME = 'ASAP';
var CALLBACK_STATUS = {
  UNSCHEDULED: 'unscheduled',
  SCHEDULED: 'scheduled',
  ERROR: 'error'
};
var PHONE_PREFIXES = [{
  countryCode: 'AL',
  value: 355,
  name: '+355 (AL)'
}, {
  countryCode: 'AR',
  value: 54,
  name: '+54 (AR)'
}, {
  countryCode: 'AT',
  value: 43,
  name: '+43 (AT)'
}, {
  countryCode: 'AU',
  value: 61,
  name: '+61 (AU)'
}, {
  countryCode: 'BA',
  value: 387,
  name: '+387 (BA)'
}, {
  countryCode: 'BE',
  value: 32,
  name: '+32 (BE)'
}, {
  countryCode: 'BG',
  value: 359,
  name: '+359 (BG)'
}, {
  countryCode: 'BR',
  value: 55,
  name: '+55 (BR)'
}, {
  countryCode: 'CA',
  value: 1,
  name: '+1 (CA)'
}, {
  countryCode: 'CH',
  value: 41,
  name: '+41 (CH)'
}, {
  countryCode: 'CL',
  value: 56,
  name: '+56 (CL)'
}, {
  countryCode: 'CN',
  value: 86,
  name: '+86 (CN)'
}, {
  countryCode: 'CY',
  value: 357,
  name: '+357 (CY)'
}, {
  countryCode: 'CZ',
  value: 420,
  name: '+420 (CZ)'
}, {
  countryCode: 'DE',
  value: 49,
  name: '+49 (DE)'
}, {
  countryCode: 'DK',
  value: 45,
  name: '+45 (DK)'
}, {
  countryCode: 'EE',
  value: 372,
  name: '+372 (EE)'
}, {
  countryCode: 'EG',
  value: 20,
  name: '+20 (EG)'
}, {
  countryCode: 'ES',
  value: 34,
  name: '+34 (ES)'
}, {
  countryCode: 'FI',
  value: 358,
  name: '+358 (FI)'
}, {
  countryCode: 'FR',
  value: 33,
  name: '+33 (FR)'
}, {
  countryCode: 'GB',
  value: 44,
  name: '+44 (GB)'
}, {
  countryCode: 'GI',
  value: 350,
  name: '+350 (GI)'
}, {
  countryCode: 'GR',
  value: 30,
  name: '+30 (GR)'
}, {
  countryCode: 'HK',
  value: 852,
  name: '+852 (HK)'
}, {
  countryCode: 'HR',
  value: 385,
  name: '+385 (HR)'
}, {
  countryCode: 'HU',
  value: 36,
  name: '+36 (HU)'
}, {
  countryCode: 'IE',
  value: 353,
  name: '+353 (IE)'
}, {
  countryCode: 'IL',
  value: 972,
  name: '+972 (IL)'
}, {
  countryCode: 'IN',
  value: 91,
  name: '+91 (IN)'
}, {
  countryCode: 'IR',
  value: 98,
  name: '+98 (IR)'
}, {
  countryCode: 'IS',
  value: 354,
  name: '+354 (IS)'
}, {
  countryCode: 'IT',
  value: 39,
  name: '+39 (IT)'
}, {
  countryCode: 'JP',
  value: 81,
  name: '+81 (JP)'
}, {
  countryCode: 'LB',
  value: 961,
  name: '+961 (LB)'
}, {
  countryCode: 'LT',
  value: 370,
  name: '+370 (LT)'
}, {
  countryCode: 'LU',
  value: 352,
  name: '+352 (LU)'
}, {
  countryCode: 'LV',
  value: 371,
  name: '+371 (LV)'
}, {
  countryCode: 'MC',
  value: 377,
  name: '+377 (MC)'
}, {
  countryCode: 'MD',
  value: 373,
  name: '+373 (MD)'
}, {
  countryCode: 'MT',
  value: 356,
  name: '+356 (MT)'
}, {
  countryCode: 'MX',
  value: 52,
  name: '+52 (MX)'
}, {
  countryCode: 'NL',
  value: 31,
  name: '+31 (NL)'
}, {
  countryCode: 'NO',
  value: 47,
  name: '+47 (NO)'
}, {
  countryCode: 'NZ',
  value: 64,
  name: '+64 (NZ)'
}, {
  countryCode: 'PA',
  value: 507,
  name: '+507 (PA)'
}, {
  countryCode: 'PE',
  value: 51,
  name: '+51 (PE)'
}, {
  countryCode: 'PK',
  value: 92,
  name: '+92 (PK)'
}, {
  countryCode: 'PL',
  value: 48,
  name: '+48 (PL)'
}, {
  countryCode: 'PT',
  value: 351,
  name: '+351 (PT)'
}, {
  countryCode: 'RO',
  value: 40,
  name: '+40 (RO)'
}, {
  countryCode: 'RS',
  value: 381,
  name: '+381 (RS)'
}, {
  countryCode: 'RU',
  value: 7,
  name: '+7 (RU)'
}, {
  countryCode: 'SE',
  value: 46,
  name: '+46 (SE)'
}, {
  countryCode: 'SG',
  value: 65,
  name: '+65 (SG)'
}, {
  countryCode: 'SI',
  value: 386,
  name: '+386 (SI)'
}, {
  countryCode: 'SK',
  value: 421,
  name: '+421 (SK)'
}, {
  countryCode: 'TH',
  value: 66,
  name: '+66 (TH)'
}, {
  countryCode: 'TR',
  value: 90,
  name: '+90 (TR)'
}, {
  countryCode: 'US',
  value: 1,
  name: '+1 (US)'
}, {
  countryCode: 'ZA',
  value: 27,
  name: '+27 (ZA)'
}];

function hasNameInSlots(slots, name) {
  return slots.some(function (slot) {
    return slot.name === name;
  });
}

var WebCallbackForm_utils_getTimeSlots = function getTimeSlots(_ref) {
  var openingTimesPerDay = _ref.openingTimesPerDay,
      i18n = _ref.i18n;
  if (!openingTimesPerDay) return [];
  var openDays = Object.keys(openingTimesPerDay);
  var asap = i18n.asap,
      today = i18n.today,
      tomorrow = i18n.tomorrow;
  var maxDaysInTheFuture = 7;

  var daysOfWeek = Object(toConsumableArray["a" /* default */])(Array(maxDaysInTheFuture).keys()).map(function (day) {
    return moment_default()().utc().add(day, 'd').locale('en').format('ddd').toLowerCase();
  });

  return Object(toConsumableArray["a" /* default */])(Array(maxDaysInTheFuture).keys()).filter(function (day) {
    var dayOfWeek = moment_default()().utc().add(day, 'd').locale('en').format('ddd');
    return openDays.includes(dayOfWeek.toLowerCase());
  }).map(function (day, idx) {
    var slots = [];
    var dayLabel = daysOfWeek[day];
    var openingTimes = openingTimesPerDay[dayLabel];
    var now = moment_default.a.utc().add(day, 'd');
    var dayOfWeek = now.calendar(null, {
      sameDay: "[".concat(Object(lodash["upperFirst"])(today), "]"),
      nextDay: "[".concat(Object(lodash["upperFirst"])(tomorrow), "]"),
      nextWeek: 'dddd',
      sameElse: 'dddd'
    });
    openingTimes === null || openingTimes === void 0 ? void 0 : openingTimes.forEach(function (openingTime) {
      var _openingTime$from$spl = openingTime.from.split(':'),
          _openingTime$from$spl2 = Object(slicedToArray["a" /* default */])(_openingTime$from$spl, 2),
          beginHour = _openingTime$from$spl2[0],
          beginMinute = _openingTime$from$spl2[1];

      var begin = moment_default.a.utc().startOf('day').hour(parseInt(beginHour, 10)).minute(parseInt(beginMinute, 10));

      var _openingTime$to$split = openingTime.to.split(':'),
          _openingTime$to$split2 = Object(slicedToArray["a" /* default */])(_openingTime$to$split, 2),
          endHour = _openingTime$to$split2[0],
          endMinute = _openingTime$to$split2[1];

      var end = moment_default.a.utc().startOf('day').hour(parseInt(endHour, 10)).minute(parseInt(endMinute, 10));
      var current = begin;

      if (idx === 0) {
        current = moment_default.a.max(now, begin).add(1, 'h').startOf('h');

        if (!hasNameInSlots(slots, Object(lodash["upperFirst"])(asap))) {
          slots.push({
            value: ASAP_TIME,
            name: Object(lodash["upperFirst"])(asap)
          });
        }
      }

      while (current.isBefore(end)) {
        var value = current.format(FREESPEE_DATETIME_FORMAT);
        var slotStart = current.format(DISPLAY_TIME_FORMAT);
        current.add(30, 'm');
        var slotEnd = current.format(DISPLAY_TIME_FORMAT);
        var name = "".concat(slotStart, " - ").concat(slotEnd);

        if (!hasNameInSlots(slots, name)) {
          slots.push({
            value: value,
            name: name
          });
        }
      }
    });
    return {
      value: now.format(FREESPEE_DATE_FORMAT),
      name: Object(lodash["upperFirst"])(dayOfWeek),
      slots: slots
    };
  });
};

function concatIntervalsPerDay(openingTimesPerDay, weekday) {
  var _weekday$intervals;

  if (!(weekday === null || weekday === void 0 ? void 0 : weekday.intervals)) return openingTimesPerDay;
  var openingTimeInterval = weekday === null || weekday === void 0 ? void 0 : (_weekday$intervals = weekday.intervals) === null || _weekday$intervals === void 0 ? void 0 : _weekday$intervals.map(function (interval) {
    return {
      from: interval === null || interval === void 0 ? void 0 : interval.openingTime,
      to: interval === null || interval === void 0 ? void 0 : interval.closingTime
    };
  });

  if (openingTimesPerDay[weekday === null || weekday === void 0 ? void 0 : weekday.day]) {
    openingTimesPerDay[weekday === null || weekday === void 0 ? void 0 : weekday.day] = openingTimesPerDay[weekday === null || weekday === void 0 ? void 0 : weekday.day].concat(openingTimeInterval);
  } else {
    openingTimesPerDay[weekday === null || weekday === void 0 ? void 0 : weekday.day] = openingTimeInterval;
  }

  return openingTimesPerDay;
}

var fetchOpeningHours = /*#__PURE__*/function () {
  var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref2, appContext) {
    var setOpeningTimesPerDay, query, data, _openingTimesPerDay;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setOpeningTimesPerDay = _ref2.setOpeningTimesPerDay;
            query = "query {\n    webCallbackHours(customerId: \"".concat(CUSTOMER_ID, "\") {\n      weekdays {\n        day\n        intervals {\n          openingTime\n          closingTime\n        }\n      }\n    }\n  }");
            _context.prev = 2;
            _context.next = 5;
            return graphqlClient["a" /* default */].runQuery(query, appContext, {
              requestName: requestDictionary["Nd" /* WIDGET_WEBCALLBACK_OPENING_HOURS */]
            });

          case 5:
            data = _context.sent;
            _openingTimesPerDay = data.webCallbackHours.weekdays.reduce(concatIntervalsPerDay, {});
            if (_openingTimesPerDay && !Object(lodash["isEmpty"])(_openingTimesPerDay)) setOpeningTimesPerDay(_openingTimesPerDay);
            _context.next = 12;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](2);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 10]]);
  }));

  return function fetchOpeningHours(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();
var submitCallback = /*#__PURE__*/function () {
  var _ref5 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(_ref4, appContext) {
    var scheduled, requesterNumber, setCallbackStatus, setSubmitting, schedule, query, _ref6, webCallback;

    return regenerator_default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            scheduled = _ref4.scheduled, requesterNumber = _ref4.requesterNumber, setCallbackStatus = _ref4.setCallbackStatus, setSubmitting = _ref4.setSubmitting;
            schedule = scheduled ? "\"".concat(scheduled, "\"") : 'null';
            query = "mutation {\n    webCallback(\n      agentNumber: \"".concat(AGENT_NUMBER, "\",\n      callerId: \"").concat(CALLER_ID, "\",\n      customerId: \"").concat(CUSTOMER_ID, "\",\n      webCallbackInput: {\n        requesterNumber: \"").concat(requesterNumber, "\",\n        scheduled: ").concat(schedule, ",\n        retries: ").concat(RETRIES, ",\n        retryInterval: ").concat(RETRY_INTERVAL, "\n      }) {\n      ... on WebCallback {\n        id\n        type\n        agentNumber\n        callerId\n        requesterNumber\n        retries\n        retryInterval\n      }\n      ... on WebCallbackError {\n        errorCode\n        errorDescription\n        errorKey\n        errorValue        \n      }\n    }\n  }");
            _context2.prev = 3;
            _context2.next = 6;
            return graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
              requestName: requestDictionary["Od" /* WIDGET_WEBCALLBACK_SCHEDULE_CALL */]
            });

          case 6:
            _ref6 = _context2.sent;
            webCallback = _ref6.webCallback;

            if (webCallback.errorCode) {
              setCallbackStatus(CALLBACK_STATUS.ERROR);
            } else {
              setCallbackStatus(CALLBACK_STATUS.SCHEDULED);
            }

            _context2.next = 14;
            break;

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](3);
            setCallbackStatus(CALLBACK_STATUS.ERROR);

          case 14:
            _context2.prev = 14;
            setSubmitting(false);
            return _context2.finish(14);

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 11, 14, 17]]);
  }));

  return function submitCallback(_x3, _x4) {
    return _ref5.apply(this, arguments);
  };
}();
var requestCallback = function requestCallback(_ref7) {
  var scheduled = _ref7.scheduled,
      requesterNumber = _ref7.requesterNumber,
      requesterNumberPrefix = _ref7.requesterNumberPrefix,
      setCallbackStatus = _ref7.setCallbackStatus,
      setSubmitting = _ref7.setSubmitting;

  try {
    window.__fs_dncs_instance.requestCallback(ACCOUNT_ID, // AVD_ID
    AGENT_NUMBER_ID, // Answering_number_id
    requesterNumberPrefix, // Country_code
    requesterNumber, // customer_phonenr
    CALLER_ID, // caller_id
    {}, // custom_*
    scheduled ? scheduled : null, // call_time,
    function (ref, data) {
      var status = data.status,
          callId = data.call_uuid;

      if (status === 'ok' && callId) {
        setCallbackStatus(CALLBACK_STATUS.SCHEDULED);
      } else {
        setCallbackStatus(CALLBACK_STATUS.ERROR);
      }

      setSubmitting(false);
    }, null, RETRIES // retries
    );
  } catch (error) {
    setCallbackStatus(CALLBACK_STATUS.ERROR);
    setSubmitting(false);
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/webcallback/WebCallbackForm.jsx


var WebCallbackForm_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var DEFAULT_OPENING_TIME = '10:00:00';
var DEFAULT_CLOSING_TIME = '18:00:00';
var DEFAULT_OPENING_TIMES_PER_DAY = {
  mon: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  tue: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  wed: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  thu: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  fri: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  sat: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  sun: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }]
};
function WebCallbackForm(_ref) {
  var _currentDay$slots, _currentDay$slots$;

  var callbackStatus = _ref.callbackStatus,
      setCallbackStatus = _ref.setCallbackStatus,
      trackingData = _ref.trackingData;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);
  var track = Object(useTracking["a" /* useTracking */])(); // These are UTC times, like what Freespee returns in from_time, to_time.

  var _useState = Object(react["useState"])(DEFAULT_OPENING_TIMES_PER_DAY),
      openingTimesPerDay = _useState[0],
      setOpeningTimesPerDay = _useState[1];

  var timeSlots = Object(react["useMemo"])(function () {
    return WebCallbackForm_utils_getTimeSlots({
      openingTimesPerDay: openingTimesPerDay,
      i18n: {
        asap: Object(src_i18n["f" /* t */])('common.dateTime.asap'),
        today: Object(src_i18n["f" /* t */])('common.dateTime.today'),
        tomorrow: Object(src_i18n["f" /* t */])('common.dateTime.tomorrow')
      }
    });
  }, [openingTimesPerDay]);

  var _timeSlots = Object(slicedToArray["a" /* default */])(timeSlots, 1),
      initialDay = _timeSlots[0];

  var _useState2 = Object(react["useState"])(initialDay),
      currentDay = _useState2[0],
      setCurrentDay = _useState2[1];

  Object(react["useEffect"])(function () {
    fetchOpeningHours({
      setOpeningTimesPerDay: setOpeningTimesPerDay
    }, appContext);
  }, []);
  Object(react["useEffect"])(function () {
    var _timeSlots2 = Object(slicedToArray["a" /* default */])(timeSlots, 1),
        newDay = _timeSlots2[0];

    setCurrentDay(newDay);
  }, [timeSlots]);
  if (!currentDay) return null;
  var localPhonePrefix = PHONE_PREFIXES.find(function (prefix) {
    var country = appContext.locale.split('-')[1];
    return country === prefix.countryCode;
  });
  var initialPhonePrefix = localPhonePrefix || PHONE_PREFIXES.find(function (prefix) {
    return prefix.countryCode === 'FR';
  }) || {};

  var changeDay = function changeDay(event, setFieldValue) {
    var dayValue = event.target.value;
    var newDay = timeSlots.find(function (slot) {
      return slot.value === dayValue;
    });

    if (newDay) {
      setCurrentDay(newDay);
      setFieldValue('slotDay', newDay.value, false);
    }
  };

  return WebCallbackForm_jsx(formik_esm["d" /* Formik */], {
    initialValues: {
      slotDay: currentDay.value,
      slotTime: currentDay === null || currentDay === void 0 ? void 0 : (_currentDay$slots = currentDay.slots) === null || _currentDay$slots === void 0 ? void 0 : (_currentDay$slots$ = _currentDay$slots[0]) === null || _currentDay$slots$ === void 0 ? void 0 : _currentDay$slots$.value,
      phonePrefix: initialPhonePrefix.value,
      phoneNumber: ''
    },
    validate: function validate(_ref2) {
      var phoneNumber = _ref2.phoneNumber;
      var errors = {};

      if (!phoneNumber) {
        errors.phoneNumber = 'Phone number is required';
      } // https://www.twilio.com/docs/glossary/what-e164


      if (!/^[1-9]\d{1,14}$/.test(phoneNumber)) {
        errors.phoneNumber = 'Phone number is not valid';
      }

      return errors;
    },
    onSubmit: function onSubmit(formValues, _ref3) {
      var setSubmitting = _ref3.setSubmitting;
      var slotTime = formValues.slotTime,
          phonePrefix = formValues.phonePrefix,
          phoneNumber = formValues.phoneNumber;
      requestCallback({
        scheduled: slotTime === ASAP_TIME ? null : slotTime,
        requesterNumber: "+".concat(phonePrefix).concat(phoneNumber),
        requesterNumberPrefix: phonePrefix,
        setCallbackStatus: setCallbackStatus,
        setSubmitting: setSubmitting
      });
      track(_objectSpread({
        categoryGA: pageContext.pageId,
        labelGA: tracking_constants["A" /* WEB_CALLBACK_SUBMIT */]
      }, trackingData));
    }
  }, function (_ref4) {
    var isValid = _ref4.isValid,
        isSubmitting = _ref4.isSubmitting,
        setFieldValue = _ref4.setFieldValue;
    var isDisabled = callbackStatus !== CALLBACK_STATUS.UNSCHEDULED || !isValid;
    return WebCallbackForm_jsx(formik_esm["c" /* Form */], {
      "data-testid": "web-callback-form",
      className: "h-full"
    }, WebCallbackForm_jsx("div", {
      className: "flex flex-col justify-between h-full w-full bg-gray-200"
    }, WebCallbackForm_jsx("div", {
      className: "w-full bg-ardoise",
      style: {
        backgroundImage: "url(\"".concat(Object(src_i18n["f" /* t */])('webCallback.picture'), "\")"),
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        height: '150px'
      }
    }), WebCallbackForm_jsx("div", {
      className: "flex-auto px-6 py-5"
    }, WebCallbackForm_jsx("h3", {
      className: "my-0",
      id: constants["z" /* ID_MODAL_HEADER__SHOPPING__WEBCALLBACK_TRIGGER */]
    }, Object(src_i18n["f" /* t */])('webCallback.title')), WebCallbackForm_jsx("p", null, Object(src_i18n["f" /* t */])('webCallback.subtitle')), callbackStatus !== CALLBACK_STATUS.UNSCHEDULED ? WebCallbackForm_jsx(Notification["a" /* Notification */], {
      color: callbackStatus === CALLBACK_STATUS.SCHEDULED ? colors["a" /* COLORS */].SUCCESS : colors["a" /* COLORS */].WARNING,
      hasBorder: true,
      icon: callbackStatus === CALLBACK_STATUS.SCHEDULED ? icons["a" /* ICONS */].SMALL_CIRCLE_CHECK : icons["a" /* ICONS */].CIRCLED_CROSS,
      iconWidth: "1rem"
    }, WebCallbackForm_jsx("p", {
      className: "m-0 text-base text-".concat(callbackStatus === CALLBACK_STATUS.SCHEDULED ? colors["a" /* COLORS */].SUCCESS : colors["a" /* COLORS */].WARNING)
    }, callbackStatus === CALLBACK_STATUS.SCHEDULED ? Object(src_i18n["f" /* t */])('webCallback.successMessage') : Object(src_i18n["f" /* t */])('webCallback.errorMessage'))) : WebCallbackForm_jsx(react["Fragment"], null, WebCallbackForm_jsx("div", {
      className: "inline-block w-full md:w-3/5 mb-3 md:pr-2"
    }, WebCallbackForm_jsx("label", {
      className: "block w-full p-1 text-sm"
    }, Object(src_i18n["f" /* t */])('webCallback.timeLabel')), WebCallbackForm_jsx(GroupedSelect, {
      fieldName: "slotDay",
      position: "left",
      width: "2/5" // $FlowFixMe
      ,
      options: timeSlots,
      onChange: function onChange(e) {
        return changeDay(e, setFieldValue);
      }
    }), WebCallbackForm_jsx(GroupedSelect, {
      fieldName: "slotTime",
      position: "right",
      width: "3/5" // $FlowFixMe
      ,
      options: currentDay.slots
    })), WebCallbackForm_jsx("div", {
      className: "inline-block w-full md:w-2/5 mb-3"
    }, WebCallbackForm_jsx("label", {
      className: "block w-full p-1 text-sm"
    }, Object(src_i18n["f" /* t */])('webCallback.phoneLabel')), WebCallbackForm_jsx(GroupedSelect, {
      fieldName: "phonePrefix",
      position: "left",
      width: "1/2",
      options: PHONE_PREFIXES
    }), WebCallbackForm_jsx(GroupedInput, {
      fieldName: "phoneNumber",
      position: "right",
      width: "1/2",
      type: "tel",
      required: true
    })))), WebCallbackForm_jsx("div", {
      className: "flex justify-end px-6 w-full",
      style: {
        minHeight: '3.75rem'
      }
    }, callbackStatus === CALLBACK_STATUS.UNSCHEDULED ? WebCallbackForm_jsx(Button["a" /* Button */], {
      className: "self-center w-full md:w-1/2 text-center",
      type: "submit",
      isLoading: isSubmitting,
      isDisabled: isDisabled
    }, Object(src_i18n["f" /* t */])('webCallback.callToAction')) : null)));
  });
}
// CONCATENATED MODULE: ./src/client/components/widgets/webcallback/WebCallbackTrigger.jsx

var WebCallbackTrigger_jsx = react_default.a.createElement;

function WebCallbackTrigger_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function WebCallbackTrigger_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { WebCallbackTrigger_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { WebCallbackTrigger_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














function WebCallbackTrigger(_ref) {
  var trackingData = _ref.trackingData,
      children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isTablet = _useContext.isTablet,
      isAppMounted = _useContext.isAppMounted;

  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);
  var track = Object(useTracking["a" /* useTracking */])();

  var _useState = Object(react["useState"])(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = Object(react["useState"])(CALLBACK_STATUS.UNSCHEDULED),
      callbackStatus = _useState2[0],
      setCallbackStatus = _useState2[1];

  var webCallbackModal = isOpen ? WebCallbackTrigger_jsx(Modal["a" /* Modal */], {
    ariaLabel: Object(src_i18n["f" /* t */])('webCallback.title'),
    ariaLabelledby: constants["z" /* ID_MODAL_HEADER__SHOPPING__WEBCALLBACK_TRIGGER */],
    closeLabel: Object(src_i18n["f" /* t */])('common.close'),
    onClose: function onClose() {
      return setIsOpen(false);
    }
  }, WebCallbackTrigger_jsx(WebCallbackForm, {
    callbackStatus: callbackStatus,
    setCallbackStatus: setCallbackStatus,
    trackingData: trackingData
  })) : null;

  var webCallbackDrawer = WebCallbackTrigger_jsx(SidePanel["a" /* SidePanel */], {
    ariaLabel: Object(src_i18n["f" /* t */])('webCallback.title'),
    ariaLabelledby: constants["z" /* ID_MODAL_HEADER__SHOPPING__WEBCALLBACK_TRIGGER */],
    closeLabel: Object(src_i18n["f" /* t */])('common.close'),
    isExpanded: isOpen,
    onClose: function onClose() {
      return setIsOpen(false);
    }
  }, WebCallbackTrigger_jsx("div", {
    className: "h-full w-full fadeIn"
  }, WebCallbackTrigger_jsx(WebCallbackForm, {
    callbackStatus: callbackStatus,
    setCallbackStatus: setCallbackStatus,
    trackingData: trackingData
  })));

  var webCallbackPopin = isTablet ? webCallbackModal : webCallbackDrawer;
  return WebCallbackTrigger_jsx(react["Fragment"], null, isAppMounted ? webCallbackPopin : null, WebCallbackTrigger_jsx("button", {
    type: "button",
    className: classnames_default()(BlockLink_themes["a" /* themes */][theme].thRoot, 'bg-transparent'),
    onClick: function onClick() {
      setCallbackStatus(CALLBACK_STATUS.UNSCHEDULED);
      setIsOpen(true);

      if (isOpen === false && trackingData) {
        track(WebCallbackTrigger_objectSpread({
          categoryGA: pageContext.pageId,
          labelGA: tracking_constants["z" /* WEB_CALLBACK_OPEN */]
        }, trackingData));
      }
    }
  }, children));
}

/***/ }),

/***/ "Phb7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document */



var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__("ERkP");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("aWzz");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _subscribeUiEvent = __webpack_require__("GJxp");

var _classnames = __webpack_require__("O94r");

var _classnames2 = _interopRequireDefault(_classnames);

var _shallowequal = __webpack_require__("Pu0A");

var _shallowequal2 = _interopRequireDefault(_shallowequal);

// constants
var STATUS_ORIGINAL = 0; // The default status, locating at the original position.
var STATUS_RELEASED = 1; // The released status, locating at somewhere on document but not default one.
var STATUS_FIXED = 2; // The sticky status, locating fixed to the top or the bottom of screen.

var TRANSFORM_PROP = 'transform';

// global variable for all instances
var doc;
var docBody;
var docEl;
var canEnableTransforms = true; // Use transform by default, so no Sticky on lower-end browser when no Modernizr
var M;
var scrollDelta = 0;
var win;
var winHeight = -1;

var Sticky = (function (_Component) {
    _inherits(Sticky, _Component);

    function Sticky(props, context) {
        _classCallCheck(this, Sticky);

        _get(Object.getPrototypeOf(Sticky.prototype), 'constructor', this).call(this, props, context);
        this.handleResize = this.handleResize.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleScrollStart = this.handleScrollStart.bind(this);
        this.delta = 0;
        this.stickyTop = 0;
        this.stickyBottom = 0;
        this.frozen = false;
        this.skipNextScrollEvent = false;
        this.scrollTop = -1;

        this.bottomBoundaryTarget;
        this.topTarget;
        this.subscribers;

        this.state = {
            top: 0, // A top offset from viewport top where Sticky sticks to when scrolling up
            bottom: 0, // A bottom offset from viewport top where Sticky sticks to when scrolling down
            width: 0, // Sticky width
            height: 0, // Sticky height
            x: 0, // The original x of Sticky
            y: 0, // The original y of Sticky
            topBoundary: 0, // The top boundary on document
            bottomBoundary: Infinity, // The bottom boundary on document
            status: STATUS_ORIGINAL, // The Sticky status
            pos: 0, // Real y-axis offset for rendering position-fixed and position-relative
            activated: false // once browser info is available after mounted, it becomes true to avoid checksum error
        };
    }

    _createClass(Sticky, [{
        key: 'getTargetHeight',
        value: function getTargetHeight(target) {
            return target && target.offsetHeight || 0;
        }
    }, {
        key: 'getTopPosition',
        value: function getTopPosition(top) {
            // a top argument can be provided to override reading from the props
            top = top || this.props.top || 0;
            if (typeof top === 'string') {
                if (!this.topTarget) {
                    this.topTarget = doc.querySelector(top);
                }
                top = this.getTargetHeight(this.topTarget);
            }
            return top;
        }
    }, {
        key: 'getTargetBottom',
        value: function getTargetBottom(target) {
            if (!target) {
                return -1;
            }
            var rect = target.getBoundingClientRect();
            return this.scrollTop + rect.bottom;
        }
    }, {
        key: 'getBottomBoundary',
        value: function getBottomBoundary(bottomBoundary) {
            // a bottomBoundary can be provided to avoid reading from the props
            var boundary = bottomBoundary || this.props.bottomBoundary;

            // TODO, bottomBoundary was an object, depricate it later.
            if (typeof boundary === 'object') {
                boundary = boundary.value || boundary.target || 0;
            }

            if (typeof boundary === 'string') {
                if (!this.bottomBoundaryTarget) {
                    this.bottomBoundaryTarget = doc.querySelector(boundary);
                }
                boundary = this.getTargetBottom(this.bottomBoundaryTarget);
            }
            return boundary && boundary > 0 ? boundary : Infinity;
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.setState({
                status: STATUS_ORIGINAL,
                pos: 0
            });
        }
    }, {
        key: 'release',
        value: function release(pos) {
            this.setState({
                status: STATUS_RELEASED,
                pos: pos - this.state.y
            });
        }
    }, {
        key: 'fix',
        value: function fix(pos) {
            this.setState({
                status: STATUS_FIXED,
                pos: pos
            });
        }

        /**
         * Update the initial position, width, and height. It should update whenever children change.
         * @param {Object} options optional top and bottomBoundary new values
         */
    }, {
        key: 'updateInitialDimension',
        value: function updateInitialDimension(options) {
            options = options || {};

            var outerRect = this.outerElement.getBoundingClientRect();
            var innerRect = this.innerElement.getBoundingClientRect();

            var width = outerRect.width || outerRect.right - outerRect.left;
            var height = innerRect.height || innerRect.bottom - innerRect.top;;
            var outerY = outerRect.top + this.scrollTop;

            this.setState({
                top: this.getTopPosition(options.top),
                bottom: Math.min(this.state.top + height, winHeight),
                width: width,
                height: height,
                x: outerRect.left,
                y: outerY,
                bottomBoundary: this.getBottomBoundary(options.bottomBoundary),
                topBoundary: outerY
            });
        }
    }, {
        key: 'handleResize',
        value: function handleResize(e, ae) {
            if (this.props.shouldFreeze()) {
                return;
            }

            winHeight = ae.resize.height;
            this.updateInitialDimension();
            this.update();
        }
    }, {
        key: 'handleScrollStart',
        value: function handleScrollStart(e, ae) {
            this.frozen = this.props.shouldFreeze();

            if (this.frozen) {
                return;
            }

            if (this.scrollTop === ae.scroll.top) {
                // Scroll position hasn't changed,
                // do nothing
                this.skipNextScrollEvent = true;
            } else {
                this.scrollTop = ae.scroll.top;
                this.updateInitialDimension();
            }
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(e, ae) {
            // Scroll doesn't need to be handled
            if (this.skipNextScrollEvent) {
                this.skipNextScrollEvent = false;
                return;
            }

            scrollDelta = ae.scroll.delta;
            this.scrollTop = ae.scroll.top;
            this.update();
        }

        /**
         * Update Sticky position.
         */
    }, {
        key: 'update',
        value: function update() {
            var disabled = !this.props.enabled || this.state.bottomBoundary - this.state.topBoundary <= this.state.height || this.state.width === 0 && this.state.height === 0;

            if (disabled) {
                if (this.state.status !== STATUS_ORIGINAL) {
                    this.reset();
                }
                return;
            }

            var delta = scrollDelta;
            // "top" and "bottom" are the positions that this.state.top and this.state.bottom project
            // on document from viewport.
            var top = this.scrollTop + this.state.top;
            var bottom = this.scrollTop + this.state.bottom;

            // There are 2 principles to make sure Sticky won't get wrong so much:
            // 1. Reset Sticky to the original postion when "top" <= topBoundary
            // 2. Release Sticky to the bottom boundary when "bottom" >= bottomBoundary
            if (top <= this.state.topBoundary) {
                // #1
                this.reset();
            } else if (bottom >= this.state.bottomBoundary) {
                // #2
                this.stickyBottom = this.state.bottomBoundary;
                this.stickyTop = this.stickyBottom - this.state.height;
                this.release(this.stickyTop);
            } else {
                if (this.state.height > winHeight - this.state.top) {
                    // In this case, Sticky is higher then viewport minus top offset
                    switch (this.state.status) {
                        case STATUS_ORIGINAL:
                            this.release(this.state.y);
                            this.stickyTop = this.state.y;
                            this.stickyBottom = this.stickyTop + this.state.height;
                        // Commentting out "break" is on purpose, because there is a chance to transit to FIXED
                        // from ORIGINAL when calling window.scrollTo().
                        // break;
                        case STATUS_RELEASED:
                            // If "top" and "bottom" are inbetween stickyTop and stickyBottom, then Sticky is in
                            // RELEASE status. Otherwise, it changes to FIXED status, and its bottom sticks to
                            // viewport bottom when scrolling down, or its top sticks to viewport top when scrolling up.
                            this.stickyBottom = this.stickyTop + this.state.height;
                            if (delta > 0 && bottom > this.stickyBottom) {
                                this.fix(this.state.bottom - this.state.height);
                            } else if (delta < 0 && top < this.stickyTop) {
                                this.fix(this.state.top);
                            }
                            break;
                        case STATUS_FIXED:
                            var toRelease = true;
                            var pos = this.state.pos;
                            var height = this.state.height;
                            // In regular cases, when Sticky is in FIXED status,
                            // 1. it's top will stick to the screen top,
                            // 2. it's bottom will stick to the screen bottom,
                            // 3. if not the cases above, then it's height gets changed
                            if (delta > 0 && pos === this.state.top) {
                                // case 1, and scrolling down
                                this.stickyTop = top - delta;
                                this.stickyBottom = this.stickyTop + height;
                            } else if (delta < 0 && pos === this.state.bottom - height) {
                                // case 2, and scrolling up
                                this.stickyBottom = bottom - delta;
                                this.stickyTop = this.stickyBottom - height;
                            } else if (pos !== this.state.bottom - height && pos !== this.state.top) {
                                // case 3
                                // This case only happens when Sticky's bottom sticks to the screen bottom and
                                // its height gets changed. Sticky should be in RELEASE status and update its
                                // sticky bottom by calculating how much height it changed.
                                var deltaHeight = pos + height - this.state.bottom;
                                this.stickyBottom = bottom - delta + deltaHeight;
                                this.stickyTop = this.stickyBottom - height;
                            } else {
                                toRelease = false;
                            }

                            if (toRelease) {
                                this.release(this.stickyTop);
                            }
                            break;
                    }
                } else {
                    // In this case, Sticky is shorter then viewport minus top offset
                    // and will always fix to the top offset of viewport
                    this.fix(this.state.top);
                }
            }
            this.delta = delta;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var _this = this;

            if (prevState.status !== this.state.status && this.props.onStateChange) {
                this.props.onStateChange({ status: this.state.status });
            }
            var arePropsChanged = !(0, _shallowequal2['default'])(this.props, prevProps);
            if (arePropsChanged) {
                // if the props for enabling are toggled, then trigger the update or reset depending on the current props
                if (prevProps.enabled !== this.props.enabled) {
                    if (this.props.enabled) {
                        this.setState({ activated: true }, function () {
                            _this.updateInitialDimension();
                            _this.update();
                        });
                    } else {
                        this.setState({ activated: false }, function () {
                            _this.reset();
                        });
                    }
                }
                // if the top or bottomBoundary props were changed, then trigger the update
                else if (prevProps.top !== this.props.top || prevProps.bottomBoundary !== this.props.bottomBoundary) {
                        this.updateInitialDimension();
                        this.update();
                    }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var subscribers = this.subscribers || [];
            for (var i = subscribers.length - 1; i >= 0; i--) {
                this.subscribers[i].unsubscribe();
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            // Only initialize the globals if this is the first
            // time this component type has been mounted
            if (!win) {
                win = window;
                doc = document;
                docEl = doc.documentElement;
                docBody = doc.body;
                winHeight = win.innerHeight || docEl.clientHeight;
                M = window.Modernizr;
                // No Sticky on lower-end browser when no Modernizr
                if (M && M.prefixed) {
                    canEnableTransforms = M.csstransforms3d;
                    TRANSFORM_PROP = M.prefixed('transform');
                }
            }

            // when mount, the scrollTop is not necessary on the top
            this.scrollTop = docBody.scrollTop + docEl.scrollTop;

            if (this.props.enabled) {
                this.setState({ activated: true });
                this.updateInitialDimension();
                this.update();
            }
            // bind the listeners regardless if initially enabled - allows the component to toggle sticky functionality
            this.subscribers = [(0, _subscribeUiEvent.subscribe)('scrollStart', this.handleScrollStart.bind(this), { useRAF: true }), (0, _subscribeUiEvent.subscribe)('scroll', this.handleScroll.bind(this), { useRAF: true, enableScrollInfo: true }), (0, _subscribeUiEvent.subscribe)('resize', this.handleResize.bind(this), { enableResizeInfo: true })];
        }
    }, {
        key: 'translate',
        value: function translate(style, pos) {
            var enableTransforms = canEnableTransforms && this.props.enableTransforms;
            if (enableTransforms && this.state.activated) {
                style[TRANSFORM_PROP] = 'translate3d(0,' + Math.round(pos) + 'px,0)';
            } else {
                style.top = pos + 'px';
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return !this.props.shouldFreeze() && !((0, _shallowequal2['default'])(this.props, nextProps) && (0, _shallowequal2['default'])(this.state, nextState));
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames,
                _this2 = this;

            // TODO, "overflow: auto" prevents collapse, need a good way to get children height
            var innerStyle = {
                position: this.state.status === STATUS_FIXED ? 'fixed' : 'relative',
                top: this.state.status === STATUS_FIXED ? '0px' : '',
                zIndex: this.props.innerZ
            };
            var outerStyle = {};

            // always use translate3d to enhance the performance
            this.translate(innerStyle, this.state.pos);
            if (this.state.status !== STATUS_ORIGINAL) {
                innerStyle.width = this.state.width + 'px';
                outerStyle.height = this.state.height + 'px';
            }

            var outerClasses = (0, _classnames2['default'])('sticky-outer-wrapper', this.props.className, (_classNames = {}, _defineProperty(_classNames, this.props.activeClass, this.state.status === STATUS_FIXED), _defineProperty(_classNames, this.props.releasedClass, this.state.status === STATUS_RELEASED), _classNames));

            var children = this.props.children;

            return _react2['default'].createElement(
                'div',
                { ref: function (outer) {
                        _this2.outerElement = outer;
                    }, className: outerClasses, style: outerStyle },
                _react2['default'].createElement(
                    'div',
                    { ref: function (inner) {
                            _this2.innerElement = inner;
                        }, className: ['sticky-inner-wrapper', this.props.innerClass].join(' '), style: innerStyle },
                    typeof children === 'function' ? children({ status: this.state.status }) : children
                )
            );
        }
    }]);

    return Sticky;
})(_react.Component);

Sticky.displayName = 'Sticky';

Sticky.defaultProps = {
    shouldFreeze: function shouldFreeze() {
        return false;
    },
    enabled: true,
    top: 0,
    bottomBoundary: 0,
    enableTransforms: true,
    activeClass: 'active',
    releasedClass: 'released',
    onStateChange: null,
    innerClass: ''
};

/**
 * @param {Bool} enabled A switch to enable or disable Sticky.
 * @param {String/Number} top A top offset px for Sticky. Could be a selector representing a node
 *        whose height should serve as the top offset.
 * @param {String/Number} bottomBoundary A bottom boundary px on document where Sticky will stop.
 *        Could be a selector representing a node whose bottom should serve as the bottom boudary.
 */
Sticky.propTypes = {
    enabled: _propTypes2['default'].bool,
    top: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
    bottomBoundary: _propTypes2['default'].oneOfType([_propTypes2['default'].object, // TODO, may remove
    _propTypes2['default'].string, _propTypes2['default'].number]),
    enableTransforms: _propTypes2['default'].bool,
    activeClass: _propTypes2['default'].string,
    releasedClass: _propTypes2['default'].string,
    innerClass: _propTypes2['default'].string,
    onStateChange: _propTypes2['default'].func,
    shouldFreeze: _propTypes2['default'].func,
    innerZ: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])
};

Sticky.STATUS_ORIGINAL = STATUS_ORIGINAL;
Sticky.STATUS_RELEASED = STATUS_RELEASED;
Sticky.STATUS_FIXED = STATUS_FIXED;

module.exports = Sticky;


/***/ }),

/***/ "Pu0A":
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ "Q7Yi":
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "Qmkj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESORT_PRODUCT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getResultItem; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fGyu");
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("47go");
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(striptags__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("UCZK");
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("SPKZ");



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






var COMFORT_EXCLUSIVE = 5;
var REGEXP_DYNAMIC_CRUISE = /^CM2C_\d{8}_\d{8}$/;
var RESORT_PRODUCT_TYPE = 'resort';

function getType(item) {
  return item.product_id ? RESORT_PRODUCT_TYPE : item.type || '';
}

function isItemResort(item) {
  return getType(item) === RESORT_PRODUCT_TYPE;
}

function getLabel(item) {
  var label = striptags__WEBPACK_IMPORTED_MODULE_2___default()(item.value || '', '<span>');
  return isItemResort(item) && item.sibling_id ? "".concat(label, " - ").concat(item.season || '') : label;
}

function isCruise(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].PRODUCT_TYPES.CRUISE;
}

function isDynamicCruise(item) {
  return isCruise(item) && REGEXP_DYNAMIC_CRUISE.test(item.product_id || '');
}

function isJoyview(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].PRODUCT_TYPES.JOYVIEW;
}

function isTour(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].PRODUCT_TYPES.TOUR;
}

function isVilla(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].PRODUCT_TYPES.VILLA;
}

function isExclusiveComfort(item) {
  return Number(item.comfort_level) >= COMFORT_EXCLUSIVE;
}

function isExclusiveCollection(item) {
  return isVilla(item) || isCruise(item) || isExclusiveComfort(item);
}

function getProductId(item) {
  return isItemResort(item) ? item.product_id : null;
}

function getProductSeason(item) {
  return _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["resortAction"].getSeasonInfos(item.sibling_id ? item.season_id : _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].ALL_YEAR);
}

function getProductUrl(item) {
  var productUrl = new urijs__WEBPACK_IMPORTED_MODULE_3___default.a('/');

  if (isDynamicCruise(item)) {
    var segments = ['c'].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])((item.product_id || '').split('_')));
    productUrl.segment(segments);
  } else if (isTour(item)) {
    productUrl.segment('i').segment(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["url"].encodePath(item.title)).segment(getProductSeason(item));
  } else {
    productUrl.segment('r').segment(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["url"].encodePath(item.title)).segment(getProductSeason(item));
  }

  return productUrl.toString();
}

function getLink(item) {
  return isItemResort(item) ? getProductUrl(item) : undefined;
}

function getHeadlines(item) {
  return isItemResort(item) ? {
    subLabel1: Array.isArray(item.destination_country) ? item.destination_country.join(', ') : item.destination_country,
    subLabel2: item.destination_area,
    image: item.immersive_image,
    productId: item.product_id,
    productType: item.type,
    comfortLevel: item.comfort_level,
    season: Array.isArray(item.season) ? '' : item.season
  } : {};
}

function getIcon(item) {
  var comfortLevel = item.comfort_level || 1;

  switch (item.type) {
    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].PRODUCT_TYPES.CRUISE:
      return _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].CRUISE;

    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].PRODUCT_TYPES.JOYVIEW:
      return _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].TRIDENT_JOYVIEW;

    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].PRODUCT_TYPES.TOUR:
      return _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].TOUR;

    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].PRODUCT_TYPES.RESORT:
    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].PRODUCT_TYPES.VILLA:
      return comfortLevel === String(COMFORT_EXCLUSIVE) ? null : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"]["TRIDENT".concat(comfortLevel)];

    default:
      return item.type === 'activity' ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].ACTIVITIES : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].ADDRESS;
  }
}

function getColor(item) {
  if (isExclusiveCollection(item)) {
    return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].DEEP_BLUE;
  }

  if (isJoyview(item)) {
    return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].WATER_GREEN;
  }

  return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].BLUE;
}

var getTagsColor = function getTagsColor(item) {
  var seasonName = Array.isArray(item.seasons_id) ? '' : item.seasons_id;

  if (seasonName === _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].SEASONS.SUMMER) {
    return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].ORANGE;
  }

  if (isTour(item) || isCruise(item)) {
    return getColor(item);
  }

  return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].BLUE;
};

function getResultItem(item) {
  return _objectSpread({
    icon: getIcon(item),
    id: getProductId(item) || getLabel(item),
    isExclusiveCollection: isExclusiveCollection(item),
    label: getLabel(item),
    link: getLink(item),
    productColor: getColor(item),
    product_id: getProductId(item),
    tagsColor: getTagsColor(item),
    type: getType(item)
  }, getHeadlines(item));
}

/***/ }),

/***/ "Qosd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return POPIN_NEWSLETTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NEWSLETTER_SUBSCRIPTION_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PopinNewsletter; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("uDfI");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ljKo");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Ub5k");
/* harmony import */ var _utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("/Mt0");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("kiXb");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("sRdV");
/* harmony import */ var _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("YZTm");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("UCZK");
/* harmony import */ var _profile_info_newsletter_subscription_NewsletterSubscription_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("p9RO");
/* harmony import */ var _views_newsletter_newsletterActions__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("TnNS");
/* harmony import */ var _utils_ratios_ratios_utils_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("u/u4");
/* harmony import */ var _frameworks_button_Button_jsx__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_form_errors_FormErrors_jsx__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("8miM");
/* harmony import */ var _frameworks_formik_FormikInput_jsx__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("/HC4");
/* harmony import */ var _frameworks_image_Image_jsx__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("0IQ5");
/* harmony import */ var _frameworks_modal_Modal_jsx__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("EvYw");
/* harmony import */ var _frameworks_text_Text_jsx__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("qqKu");
/* harmony import */ var _frameworks_title_Title_jsx__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("MWZw");
/* harmony import */ var _newsletter_form_NewsletterForm_jsx__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("9KBE");



var __jsx = react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }























var POPIN_NEWSLETTER = 'POPIN_NEWSLETTER';
var NEWSLETTER_SUBSCRIPTION_VALIDATION = 'NEWSLETTER_SUBSCRIPTION_VALIDATION';
function PopinNewsletter(_ref) {
  var _ref$checkboxes = _ref.checkboxes,
      checkboxes = _ref$checkboxes === void 0 ? [] : _ref$checkboxes,
      _ref$legalInformation = _ref.legalInformations,
      legalInformations = _ref$legalInformation === void 0 ? [] : _ref$legalInformation,
      onClose = _ref.onClose;
  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_3__["useContext"])(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"]);
  var defaultPayload = {
    categoryGA: 'newsletter',
    actionGA: 'shopping'
  };
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_10__[/* useTracking */ "a"])(defaultPayload);

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])([]),
      submitErrors = _useState[0],
      setSubmitErrors = _useState[1];

  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_4__[/* useDispatch */ "d"])();

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_3__["useContext"])(_utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"]),
      isTablet = _useContext.isTablet;

  var labelConfirmation = "".concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "f"])('newsletter.confirmation.headline'), " \n ").concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "f"])('newsletter.confirmation.description'));
  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    return track({
      labelGA: 'displayPopin'
    });
  }, []);
  return __jsx(_frameworks_modal_Modal_jsx__WEBPACK_IMPORTED_MODULE_21__[/* Modal */ "a"], {
    ariaLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "f"])('newsletter.popin.title'),
    ariaLabelledby: _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_11__[/* ID_MODAL_HEADER__PLE__NEWSLETTER */ "y"],
    backdropColor: "#000",
    closeLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "f"])('common.close'),
    onClose: onClose,
    size: "large"
  }, __jsx(_frameworks_image_Image_jsx__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"], {
    className: "w-full sm:w-12/25 md:w-1/3 h-full flex-shrink-0 sm:absolute",
    imageUrl: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "f"])('newsletter.popin.imageUrl'),
    mandatoryWidthAndHeight: isTablet ? {
      w: 320,
      h: 700
    } : {
      w: 500,
      h: 200
    },
    ratioKey: _utils_ratios_ratios_utils_js__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"].XS
  }), __jsx("div", {
    className: "PopinNewsletter-content m-6"
  }, __jsx(_frameworks_title_Title_jsx__WEBPACK_IMPORTED_MODULE_23__[/* Title */ "a"], {
    iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_12__[/* ICONS */ "a"].NEWSLETTER,
    id: _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_11__[/* ID_MODAL_HEADER__PLE__NEWSLETTER */ "y"],
    theme: "title-brand-2",
    iconSize: "1.5rem",
    iconColor: _utils_color_colors__WEBPACK_IMPORTED_MODULE_13__[/* COLORS */ "a"].BLUE
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "f"])('newsletter.popin.title')), __jsx(_frameworks_text_Text_jsx__WEBPACK_IMPORTED_MODULE_22__[/* Text */ "a"], {
    className: "mt-2 mb-3",
    text: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "f"])('newsletter.popin.subtitle')
  }), __jsx(formik__WEBPACK_IMPORTED_MODULE_6__[/* Formik */ "d"], {
    validationSchema: _newsletter_form_NewsletterForm_jsx__WEBPACK_IMPORTED_MODULE_24__[/* subscriptionSchema */ "b"],
    initialValues: _objectSpread({}, checkboxes.reduce(function (newslettersCheckbox, newsletter) {
      newslettersCheckbox[newsletter.id] = false;
      return newslettersCheckbox;
    }, {})),
    onSubmit: /*#__PURE__*/function () {
      var _ref2 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(values) {
        var response, error;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(_views_newsletter_newsletterActions__WEBPACK_IMPORTED_MODULE_15__[/* submitSubscriptionForm */ "b"])({
                  appContext: appContext,
                  data: Object(_views_newsletter_newsletterActions__WEBPACK_IMPORTED_MODULE_15__[/* formatedData */ "a"])(values),
                  isSubscription: true
                });

              case 2:
                response = _context.sent;
                track({
                  labelGA: 'registrationPopin',
                  user: {
                    neolaneID: Object(lodash__WEBPACK_IMPORTED_MODULE_5__["get"])(response, 'subscription.neolaneId')
                  }
                });
                error = Object(lodash__WEBPACK_IMPORTED_MODULE_5__["get"])(response, 'subscription.error.errorDescription', '');

                if (Object(lodash__WEBPACK_IMPORTED_MODULE_5__["isEmpty"])(error)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", setSubmitErrors([error]));

              case 7:
                dispatch({
                  type: NEWSLETTER_SUBSCRIPTION_VALIDATION,
                  payload: {
                    toastLabel: labelConfirmation
                  }
                });
                onClose && onClose();

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }()
  }, function (_ref3) {
    var setFieldValue = _ref3.setFieldValue,
        isValid = _ref3.isValid;
    return __jsx(formik__WEBPACK_IMPORTED_MODULE_6__[/* Form */ "c"], null, __jsx(_newsletter_form_NewsletterForm_jsx__WEBPACK_IMPORTED_MODULE_24__[/* NewsletterForm */ "a"], null), checkboxes.map(function (checkbox) {
      return __jsx("div", {
        className: "mt-4",
        key: checkbox.id
      }, __jsx(_frameworks_formik_FormikInput_jsx__WEBPACK_IMPORTED_MODULE_19__[/* FormikInput */ "a"], {
        name: checkbox.id,
        type: "checkbox",
        label: checkbox.description,
        value: checkbox.id,
        onChange: function onChange(e) {
          return Object(_profile_info_newsletter_subscription_NewsletterSubscription_utils__WEBPACK_IMPORTED_MODULE_14__[/* onCheckboxChange */ "b"])(e.target, setFieldValue);
        }
      }));
    }), __jsx("div", {
      className: "mt-4 text-right"
    }, !Object(lodash__WEBPACK_IMPORTED_MODULE_5__["isEmpty"])(submitErrors) && __jsx(_frameworks_form_errors_FormErrors_jsx__WEBPACK_IMPORTED_MODULE_18__[/* FormErrors */ "a"], {
      texts: submitErrors
    }), __jsx(_frameworks_button_Button_jsx__WEBPACK_IMPORTED_MODULE_17__[/* Button */ "a"], {
      type: "submit",
      colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_13__[/* COLORS */ "a"].BLUE,
      colorBorder: _utils_color_colors__WEBPACK_IMPORTED_MODULE_13__[/* COLORS */ "a"].BLUE,
      isDisabled: !isValid
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "f"])('newsletter.popin.cta'))));
  }), __jsx("div", {
    className: "mt-4"
  }, legalInformations.map(function (info) {
    return !Object(lodash__WEBPACK_IMPORTED_MODULE_5__["isEmpty"])(info.description) ? __jsx("div", {
      key: "LegalInfo-".concat(info.id)
    }, __jsx(_frameworks_text_Text_jsx__WEBPACK_IMPORTED_MODULE_22__[/* Text */ "a"], {
      theme: "text-sans-2",
      text: info.description
    })) : null;
  }))));
}

/***/ }),

/***/ "R2jv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return START_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return startLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return endLoading; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");

var START_LOADING = 'START_LOADING';
var END_LOADING = 'END_LOADING';

function endLoading() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(END_LOADING, {});
}

function startLoading(globalLoaderLabel, isNavigation) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(START_LOADING, {
    globalLoaderLabel: globalLoaderLabel,
    isNavigation: isNavigation
  });
}



/***/ }),

/***/ "R3QM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_BOOKING_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_BOOKING_DETAILS_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_BOOKING_DETAILS_REJECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLEAR_BOOKING_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_BOOKING_ATTENDEES_PACKAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_BOOKING_ATTENDEES_PACKAGE_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_BOOKING_ATTENDEES_PACKAGE_REJECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_BOOKING_ATTENDEES_PACKAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_BOOKING_PRICE_AND_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FETCH_BOOKING_PRICE_AND_PAYMENT_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_BOOKING_PRICE_AND_PAYMENT_REJECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR_BOOKING_PRICE_AND_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FETCH_BOOKING_STAY_FORMALITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FETCH_BOOKING_STAY_FORMALITIES_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FETCH_BOOKING_STAY_FORMALITIES_REJECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CLEAR_BOOKING_STAY_FORMALITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FETCH_BOOKING_TRANSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return FETCH_BOOKING_TRANSPORT_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FETCH_BOOKING_TRANSPORT_REJECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CLEAR_BOOKING_TRANSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return OPEN_CHILDCARE_INFORMATIONS_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CLOSE_CHILDCARE_INFORMATIONS_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL_RESOLVED; });
/* unused harmony export FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL_REJECTED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLEAR_PACKAGE_UPSELL_INFORMATIONS_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return OPEN_PACKAGE_UPSELL_INFORMATIONS_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CLOSE_PACKAGE_UPSELL_INFORMATIONS_MODAL; });
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("30WP");


var BOOKING_DETAILS = 'BOOKING_DETAILS';
var BOOKING_ATTENDEES_PACKAGE = 'BOOKING_ATTENDEES_PACKAGE';
var BOOKING_PRICE_AND_PAYMENT = 'BOOKING_PRICE_AND_PAYMENT';
var BOOKING_STAY_FORMALITIES = 'BOOKING_STAY_FORMALITIES';
var BOOKING_TRANSPORT = 'BOOKING_TRANSPORT';
var CHILDCARE_INFORMATIONS_MODAL = 'CHILDCARE_INFORMATIONS_MODAL';
var PACKAGE_UPSELL_INFORMATIONS_MODAL = 'PACKAGE_UPSELL_INFORMATIONS_MODAL';
var FETCH_BOOKING_DETAILS = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* fetch */ "c"])(BOOKING_DETAILS);
var FETCH_BOOKING_DETAILS_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_BOOKING_DETAILS);
var FETCH_BOOKING_DETAILS_REJECTED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_BOOKING_DETAILS);
var CLEAR_BOOKING_DETAILS = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* clear */ "a"])(BOOKING_DETAILS);
var FETCH_BOOKING_ATTENDEES_PACKAGE = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* fetch */ "c"])(BOOKING_ATTENDEES_PACKAGE);
var FETCH_BOOKING_ATTENDEES_PACKAGE_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_BOOKING_ATTENDEES_PACKAGE);
var FETCH_BOOKING_ATTENDEES_PACKAGE_REJECTED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_BOOKING_ATTENDEES_PACKAGE);
var CLEAR_BOOKING_ATTENDEES_PACKAGE = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* clear */ "a"])(BOOKING_ATTENDEES_PACKAGE);
var FETCH_BOOKING_PRICE_AND_PAYMENT = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* fetch */ "c"])(BOOKING_PRICE_AND_PAYMENT);
var FETCH_BOOKING_PRICE_AND_PAYMENT_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_BOOKING_PRICE_AND_PAYMENT);
var FETCH_BOOKING_PRICE_AND_PAYMENT_REJECTED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_BOOKING_PRICE_AND_PAYMENT);
var CLEAR_BOOKING_PRICE_AND_PAYMENT = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* clear */ "a"])(BOOKING_PRICE_AND_PAYMENT);
var FETCH_BOOKING_STAY_FORMALITIES = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* fetch */ "c"])(BOOKING_STAY_FORMALITIES);
var FETCH_BOOKING_STAY_FORMALITIES_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_BOOKING_STAY_FORMALITIES);
var FETCH_BOOKING_STAY_FORMALITIES_REJECTED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_BOOKING_STAY_FORMALITIES);
var CLEAR_BOOKING_STAY_FORMALITIES = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* clear */ "a"])(BOOKING_STAY_FORMALITIES);
var FETCH_BOOKING_TRANSPORT = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* fetch */ "c"])(BOOKING_TRANSPORT);
var FETCH_BOOKING_TRANSPORT_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_BOOKING_TRANSPORT);
var FETCH_BOOKING_TRANSPORT_REJECTED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_BOOKING_TRANSPORT);
var CLEAR_BOOKING_TRANSPORT = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* clear */ "a"])(BOOKING_TRANSPORT);
var OPEN_CHILDCARE_INFORMATIONS_MODAL = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* open */ "d"])(CHILDCARE_INFORMATIONS_MODAL);
var CLOSE_CHILDCARE_INFORMATIONS_MODAL = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* close */ "b"])(CHILDCARE_INFORMATIONS_MODAL);
var FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* fetch */ "c"])(PACKAGE_UPSELL_INFORMATIONS_MODAL);
var FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL);
var FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL_REJECTED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL);
var CLEAR_PACKAGE_UPSELL_INFORMATIONS_MODAL = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* clear */ "a"])(PACKAGE_UPSELL_INFORMATIONS_MODAL);
var OPEN_PACKAGE_UPSELL_INFORMATIONS_MODAL = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* open */ "d"])(PACKAGE_UPSELL_INFORMATIONS_MODAL);
var CLOSE_PACKAGE_UPSELL_INFORMATIONS_MODAL = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* close */ "b"])(PACKAGE_UPSELL_INFORMATIONS_MODAL);

/***/ }),

/***/ "RBO1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDepartureCity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureDate; });
/* unused harmony export getMainContactOptinEmail */
/* unused harmony export getMainContactOptinSms */
/* unused harmony export getMainContactOptinFosun */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTripDuration; });
/* unused harmony export getMainContactOptinMail */
/* unused harmony export getMainContactOptinPhone */
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);


var tripCriteriaSelector = function tripCriteriaSelector(_ref) {
  var tripCriteria = _ref.tripCriteria;
  return tripCriteria || {};
};

var mainContactSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref2) {
  var mainContact = _ref2.mainContact;
  return mainContact || {};
});
var getDepartureCity = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref3) {
  var departureCity = _ref3.departureCity;
  return departureCity;
});
var getDepartureDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref4) {
  var departureDate = _ref4.departureDate;
  return departureDate;
});
var getMainContactOptinEmail = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref5) {
  var optinEmail = _ref5.optinEmail;
  return optinEmail;
});
var getMainContactOptinSms = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref6) {
  var optinSms = _ref6.optinSms;
  return optinSms;
});
var getMainContactOptinMail = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref7) {
  var optinMail = _ref7.optinMail;
  return optinMail;
});
var getMainContactOptinPhone = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref8) {
  var optinPhone = _ref8.optinPhone;
  return optinPhone;
});
var getMainContactOptinFosun = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref9) {
  var optinFosun = _ref9.optinFosun;
  return optinFosun;
});
var getTripDuration = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref10) {
  var duration = _ref10.duration;
  return duration;
});


/***/ }),

/***/ "RBvG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRIP_INFORMATION_SET_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_TRIP_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_NO_DURATION; });
var TRIP_INFORMATION_SET_DURATION = 'TRIP_INFORMATION_SET_DURATION';
var DEFAULT_TRIP_DURATION = 7;
var DEFAULT_NO_DURATION = null;

/***/ }),

/***/ "RCgv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ PricingTable; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/price/Price.jsx + 3 modules
var Price = __webpack_require__("IuYR");

// CONCATENATED MODULE: ./src/client/components/frameworks/pricing-table/PricingTable.themes.js
var themes = {
  "default": {
    thRoot: 'bg-white p-3',
    thHeader: 'border-b-1 border-gray-light mb-3 pb-2',
    thPriceTheme: 'package',
    thNoPriceLabel: 'font-bold font-sans my-4 text-center text-base text-gray-darker',
    thLabel: 'font-bold font-sans mb-0 mt-2 text-center text-gray-darker text-md',
    thIconsList: 'list-none p-0 flex flex-wrap items-center my-3 text-gray-medium',
    thIconsListItem: 'w-1/4 text-center',
    thIconWidth: '1.625rem',
    thInfosList: 'list-none p-0 font-sans my-1 text-gray-darker text-base',
    thInfosListItem: 'list-disc',
    thButton: 'mt-3 w-full'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/pricing-table/PricingTable.jsx

var __jsx = react_default.a.createElement;









function PricingTable(props) {
  var button = props.button,
      className = props.className,
      icons = props.icons,
      infos = props.infos,
      label = props.label,
      _props$noPriceLabel = props.noPriceLabel,
      noPriceLabel = _props$noPriceLabel === void 0 ? '' : _props$noPriceLabel,
      price = props.price,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme;
  var _themes$theme = themes[theme],
      thButton = _themes$theme.thButton,
      thHeader = _themes$theme.thHeader,
      thIconsList = _themes$theme.thIconsList,
      thIconsListItem = _themes$theme.thIconsListItem,
      thIconWidth = _themes$theme.thIconWidth,
      thInfosList = _themes$theme.thInfosList,
      thInfosListItem = _themes$theme.thInfosListItem,
      thLabel = _themes$theme.thLabel,
      thNoPriceLabel = _themes$theme.thNoPriceLabel,
      thPriceTheme = _themes$theme.thPriceTheme,
      thRoot = _themes$theme.thRoot;
  return __jsx("section", {
    className: classnames_default()(className, thRoot)
  }, __jsx("header", {
    className: thHeader
  }, Object(price_util["d" /* hasAtLeastOnePrice */])(price) ? __jsx(Price["a" /* Price */], Object(esm_extends["a" /* default */])({}, price, {
    theme: thPriceTheme
  })) : __jsx("p", {
    "data-testid": "PricingTable-noPriceLabel",
    className: thNoPriceLabel
  }, noPriceLabel), !!label && __jsx("p", {
    "data-testid": "PricingTable-label",
    className: thLabel
  }, label)), !Object(lodash["isEmpty"])(icons) && __jsx("ul", {
    className: thIconsList
  }, icons.map(function (icon) {
    return __jsx("li", {
      className: thIconsListItem,
      key: icon
    }, __jsx(Icon["a" /* Icon */], {
      name: icon,
      width: thIconWidth
    }));
  })), !Object(lodash["isEmpty"])(infos) && __jsx("ul", {
    className: thInfosList
  }, infos.map(function (info) {
    return __jsx("li", {
      "data-testid": "PricingTable-info",
      className: thInfosListItem,
      key: info
    }, info);
  })), __jsx(Button["a" /* Button */], Object(esm_extends["a" /* default */])({
    className: thButton,
    colorBg: colors["a" /* COLORS */].BOOKING,
    colorBorder: colors["a" /* COLORS */].BOOKING,
    size: "small"
  }, button)));
}

/***/ }),

/***/ "RVBP":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ "RlE+":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("ojcf"),
    getSymbols = __webpack_require__("WwbQ");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ "SHsq":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ "SIwd":
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__("5FP0");

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ "SJov":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),

/***/ "T26A":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("2K7v");

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ "TnNS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatedData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return submitSubscriptionForm; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Nhxn");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






function filterObjectWithMapping(data) {
  var rules = {
    email: 'email',
    civility: 'gender',
    firstName: 'firstName',
    lastName: 'lastName',
    unicodeFirstName: 'unicodeFirstName',
    unicodeLastName: 'unicodeLastName',
    subscriptions: 'newsletterSubscriptions',
    conditions: 'legalInformations'
  };
  return Object.keys(data).reduce(function (result, currentAttribute) {
    var mappedField = rules[currentAttribute];

    if (!Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(mappedField)) {
      result[mappedField] = data[currentAttribute];
    }

    return result;
  }, {});
}

var LIST_INPUTS = ['civility', 'firstName', 'lastName', 'email', 'unicodeFirstName', 'unicodeLastName'];
var formatedData = function formatedData(values) {
  var subscriptions = Object.keys(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["omitBy"])(values, function (value) {
    return value === false;
  }));
  return _objectSpread(_objectSpread({}, values), {}, {
    subscriptions: lodash__WEBPACK_IMPORTED_MODULE_1__["without"].apply(void 0, [subscriptions].concat(LIST_INPUTS))
  });
};
function submitSubscriptionForm(_ref) {
  var appContext = _ref.appContext,
      subscriptionId = _ref.subscriptionId,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      isSubscription = _ref.isSubscription;
  var filteredData = filterObjectWithMapping(data);

  if (!Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(subscriptionId)) {
    filteredData.subscriptionId = subscriptionId;
  }

  filteredData.isSubscription = isSubscription;
  var selection = Object(_utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_4__[/* attributesToString */ "a"])(filteredData);
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runNoCacheQuery("mutation RootMutationType {subscription (".concat(selection, ") { id neolaneId error { errorDescription }}}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* NEWSLETTER_SUBMIT_SUBSCRIPTION */ "Lc"]
  });
}

/***/ }),

/***/ "U9LJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var buildings = [{
  id: 'floors',
  source: 'buildingsSource',
  type: 'fill-extrusion',
  filter: ['!=', 'building_id', ''],
  interactive: false,
  paint: {
    'fill-extrusion-color': {
      base: 1,
      type: 'exponential',
      property: 'level',
      stops: [[0, 'hsl(47, 43%, 55%)'], [1, 'hsl(48, 45%, 62%)'], [2, 'hsl(48, 49%, 69%)'], [3, 'hsl(47, 55%, 76%)'], [4, 'hsl(49, 64%, 84%)'], [5, 'hsl(49, 64%, 84%)']]
    },
    'fill-extrusion-opacity': 1,
    'fill-extrusion-height': {
      base: 1,
      type: 'exponential',
      property: 'height',
      stops: [[0, 0], [100, 100]]
    },
    'fill-extrusion-base': {
      base: 1,
      type: 'exponential',
      property: 'min_height',
      stops: [[0, 0], [100, 100]]
    }
  }
}, {
  id: 'floors_current',
  source: 'buildingsSource',
  type: 'fill-extrusion',
  filter: ['all', ['==', 'building_id', ''], ['<=', 'level', 999]],
  paint: {
    'fill-extrusion-color': {
      base: 1,
      type: 'exponential',
      property: 'level',
      stops: [[0, 'hsl(208, 38%, 52%)'], [1, 'hsl(208, 42%, 59%)'], [2, 'hsl(207, 47%, 66%)'], [3, 'hsl(206, 55%, 73%)'], [4, 'hsl(204, 70%, 79%)'], [5, 'hsl(201, 97%, 86%)']]
    },
    'fill-extrusion-opacity': 1,
    'fill-extrusion-height': {
      base: 1,
      type: 'exponential',
      property: 'height',
      stops: [[0, 0], [100, 100]]
    },
    'fill-extrusion-base': {
      base: 1,
      type: 'exponential',
      property: 'min_height',
      stops: [[0, 0], [100, 100]]
    }
  }
}, {
  id: 'floors_current_dimmed',
  source: 'buildingsSource',
  type: 'fill-extrusion',
  filter: ['all', ['==', 'building_id', ''], ['>', 'level', 999]],
  paint: {
    'fill-extrusion-color': {
      base: 1,
      type: 'exponential',
      property: 'level',
      stops: [[0, 'hsl(208, 38%, 52%)'], [1, 'hsl(208, 42%, 59%)'], [2, 'hsl(207, 47%, 66%)'], [3, 'hsl(206, 55%, 73%)'], [4, 'hsl(204, 70%, 79%)'], [5, 'hsl(201, 97%, 86%)']]
    },
    'fill-extrusion-opacity': 0.3,
    'fill-extrusion-height': {
      base: 1,
      type: 'exponential',
      property: 'height',
      stops: [[0, 0], [100, 100]]
    },
    'fill-extrusion-base': {
      base: 1,
      type: 'exponential',
      property: 'min_height',
      stops: [[0, 0], [100, 100]]
    }
  }
}, {
  id: 'floors_highlight',
  source: 'buildingsSource',
  type: 'fill-extrusion',
  filter: ['==', 'building_id', ''],
  paint: {
    'fill-extrusion-color': {
      base: 1,
      type: 'exponential',
      property: 'level',
      stops: [[0, 'hsl(208, 38%, 52%)'], [1, 'hsl(208, 42%, 59%)'], [2, 'hsl(207, 47%, 66%)'], [3, 'hsl(206, 55%, 73%)'], [4, 'hsl(204, 70%, 79%)'], [5, 'hsl(201, 97%, 86%)']]
    },
    'fill-extrusion-height': {
      base: 1,
      type: 'exponential',
      property: 'height',
      stops: [[0, 0], [100, 100]]
    },
    'fill-extrusion-base': {
      base: 1,
      type: 'exponential',
      property: 'min_height',
      stops: [[0, 0], [100, 100]]
    }
  }
}];
/* harmony default export */ __webpack_exports__["a"] = (buildings);

/***/ }),

/***/ "UR9l":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("rL40"),
    getPrototype = __webpack_require__("lBGg"),
    getSymbols = __webpack_require__("WwbQ"),
    stubArray = __webpack_require__("HcXJ");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ "Uq20":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ROUTING_CHANGE; });
var ROUTING_CHANGE = 'ROUTING_CHANGE';

/***/ }),

/***/ "V8Kl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),

/***/ "VAV/":
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ "VGTs":
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ "VHif":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Badge_Badge; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/badge/Badge.themes.js

var variants = {
  diamond: {
    root: ' rotate-45',
    item: ' -rotate-45'
  },
  pill: {
    root: ' rounded-full',
    item: ''
  }
};
var themes = {
  "default": function _default(_ref) {
    var _ref$colorBg = _ref.colorBg,
        colorBg = _ref$colorBg === void 0 ? colors["a" /* COLORS */].BLUE : _ref$colorBg,
        _ref$colorBorder = _ref.colorBorder,
        colorBorder = _ref$colorBorder === void 0 ? colors["a" /* COLORS */].BLUE : _ref$colorBorder,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref$color,
        hasShadow = _ref.hasShadow,
        variant = _ref.variant;
    return {
      thRoot: "bg-".concat(colorBg, " border-").concat(colorBorder, " text-").concat(color, " border-2 flex-none inline-flex items-center justify-center leading-none overflow-hidden relative").concat(hasShadow ? ' shadow' : '').concat(variant ? variants[variant].root : ''),
      thImage: "absolute inset-0 ".concat(variant ? variants[variant].item : ''),
      thIcon: "absolute flex items-center justify-center inset-0".concat(variant ? variants[variant].item : ''),
      thIconSize: '65%',
      thLabel: "absolute flex items-center justify-center leading-tight overflow-hidden inset-0 text-center ".concat(variant ? variants[variant].item : ''),
      thLabelStyle: {
        fontSize: '1em'
      }
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/badge/Badge.jsx
var __jsx = react_default.a.createElement;





var Badge_Badge = function Badge(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      colorBg = _ref.colorBg,
      colorBorder = _ref.colorBorder,
      color = _ref.color,
      hasShadow = _ref.hasShadow,
      iconName = _ref.iconName,
      iconSize = _ref.iconSize,
      imageSrc = _ref.imageSrc,
      label = _ref.label,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 50 : _ref$size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      variant = _ref.variant;

  if (!iconName && !imageSrc && !label) {
    return null;
  }

  var _themes$theme = themes[theme]({
    colorBg: colorBg,
    colorBorder: colorBorder,
    color: color,
    hasShadow: hasShadow,
    variant: variant
  }),
      thIcon = _themes$theme.thIcon,
      thIconSize = _themes$theme.thIconSize,
      thImage = _themes$theme.thImage,
      thLabel = _themes$theme.thLabel,
      thLabelStyle = _themes$theme.thLabelStyle,
      thRoot = _themes$theme.thRoot;

  var styles = {
    width: size,
    height: size
  };
  var imageSize = {
    w: size,
    h: size
  };
  return __jsx("div", {
    className: classnames_default()(className, thRoot),
    style: styles
  }, !!imageSrc && __jsx("div", {
    className: thImage
  }, __jsx(Image["a" /* default */], {
    altMsg: alt,
    forceImage: true,
    imageUrl: imageSrc,
    mandatoryWidthAndHeight: imageSize
  })), !!iconName && __jsx("div", {
    className: thIcon
  }, __jsx(Icon["a" /* Icon */], {
    alt: alt,
    name: iconName,
    title: alt,
    width: iconSize || thIconSize
  })), !!label && __jsx("div", {
    className: thLabel,
    style: thLabelStyle
  }, label));
};

/***/ }),

/***/ "VNuc":
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ "VtPb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INITIAL_MONTH; });
/* unused harmony export calendarQuery */
/* unused harmony export bookableDatesQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return queryFetchCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return queryFetchBookableDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDefaultSelectedMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSelectedMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPricesByDays; });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Sj1w");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("nv//");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ldK3");






var NO_TRANSPORT_VALUE = 'NO';
var DATE_FORMAT = 'YYYYMM';
var INITIAL_MONTH = 0;
function calendarQuery(args) {
  var resortId = args.resortId,
      duration = args.duration,
      departureCity = args.departureCity,
      urgentisationRate = args.urgentisationRate;
  return "\n      calendar(resortId: \"".concat(resortId, "\", duration: \"").concat(duration, "\", departureCity: \"").concat(departureCity, "\") {\n        basePrice {\n          currency\n          bestPrice {\n            value\n            currency\n            formattedValue\n          }\n          initialPrice {\n            value\n            currency\n            formattedValue\n          }\n          unit\n        }\n        blocks {\n          hasPrice\n          id\n          name\n          price {\n            value\n            currency\n            formattedValue\n          }\n          shortName\n          year\n        }\n        firstAvailableMonthIndex\n        months {\n          id\n          days {\n            dayContent {\n              arrivalDate\n              availability\n              canGoToBooking\n              id\n              isCurrentMonth\n              name\n              number\n              offer(urgentisationRate: ").concat(urgentisationRate, ")\n              shortName\n            }\n            priceConfig {\n              bestPrice(forceAdultPerTrip: true) { value formattedValue }\n              currency\n              initialPrice(forceAdultPerTrip: true) { value formattedValue }\n              isBestPriceMonth\n              termsAndConditions {\n                accommodationComfortLabel\n                departureCity {\n                  value\n                  name\n                }\n                departureDate\n                duration\n                numberOfAdults\n              }\n              rawUnit\n              unit\n            }\n          }\n        }\n        weekDays\n      }\n    ");
}
function bookableDatesQuery(_ref) {
  var departureCity = _ref.departureCity,
      departureDate = _ref.departureDate,
      lastDate = _ref.lastDate,
      productId = _ref.productId;
  return "\n    bookableDates(productId: \"".concat(productId, "\", departureDate: \"").concat(departureDate, "\", lastDate: \"").concat(lastDate, "\", departureCity: \"").concat(departureCity, "\") {\n      months {\n        id\n        days {\n          id\n          availabilities {\n            status\n            durations\n          }\n        }\n      }\n    }\n  ");
}
function queryFetchCalendar(appContext, options) {
  var locale = appContext.locale;
  var _options$resortId = options.resortId,
      resortId = _options$resortId === void 0 ? '' : _options$resortId,
      _options$transport = options.transport,
      transport = _options$transport === void 0 ? '' : _options$transport,
      duration = options.duration,
      urgentisationRate = options.urgentisationRate;
  var calendarQueryArgs = {
    locale: locale,
    resortId: resortId,
    departureCity: transport || NO_TRANSPORT_VALUE,
    duration: duration,
    urgentisationRate: urgentisationRate
  };
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery("query {".concat(calendarQuery(calendarQueryArgs), "}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* STATE_PRODUCT_CALENDAR */ "Cd"]
  }).then(function (_ref2) {
    var calendar = _ref2.calendar;
    return {
      calendar: calendar
    };
  });
}
function queryFetchBookableDates(appContext, options) {
  var _options$productId = options.productId,
      productId = _options$productId === void 0 ? '' : _options$productId,
      _options$departureDat = options.departureDate,
      departureDate = _options$departureDat === void 0 ? '' : _options$departureDat,
      _options$departureCit = options.departureCity,
      departureCity = _options$departureCit === void 0 ? '' : _options$departureCit,
      _options$lastDate = options.lastDate,
      lastDate = _options$lastDate === void 0 ? '' : _options$lastDate;
  var bookableDatesQueryArs = {
    productId: productId,
    departureDate: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* timestampToApiDate */ "k"])(departureDate || '') || '',
    lastDate: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* timestampToApiDate */ "k"])(lastDate || '') || '',
    departureCity: departureCity
  };
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery("query {".concat(bookableDatesQuery(bookableDatesQueryArs), "}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* STATE_PRODUCT_BOOKABLE_DATES */ "Bd"]
  }).then(function (_ref3) {
    var bookableDates = _ref3.bookableDates;
    return {
      bookableDates: bookableDates
    };
  });
}
function getDefaultSelectedMonth() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var momentDate = value ? moment__WEBPACK_IMPORTED_MODULE_0___default()(value, format) : moment__WEBPACK_IMPORTED_MODULE_0___default()();
  return parseInt(momentDate.format(DATE_FORMAT), 10);
}
function getSelectedMonth(calendar, previousSelectedMonth) {
  var _calendar$months; // The query date param prevails


  var dateQueryParam = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_4__[/* getSpecificQueryParam */ "i"])(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_3__[/* QUERY_DEPARTURE_DATE */ "f"]);

  if (dateQueryParam) {
    return getDefaultSelectedMonth(dateQueryParam);
  }

  var firstCalendarMonth = ((_calendar$months = calendar.months) === null || _calendar$months === void 0 ? void 0 : _calendar$months[0].id) || getDefaultSelectedMonth();
  var firstAvailableMonthIndex = calendar.firstAvailableMonthIndex || INITIAL_MONTH;
  var firstAvailableMonth = parseInt(moment__WEBPACK_IMPORTED_MODULE_0___default()(firstCalendarMonth, DATE_FORMAT).add(firstAvailableMonthIndex, 'months').format(DATE_FORMAT), 10); // The previously selected month remains selected unless the first available dates are later

  if (previousSelectedMonth > firstAvailableMonth) {
    return previousSelectedMonth;
  }

  return firstAvailableMonth;
}
function getPricesByDays(calendar) {
  var prices = {};

  if (calendar.months) {
    calendar.months.forEach(function (_ref4) {
      var days = _ref4.days;

      if (days) {
        days.forEach(function (_ref5) {
          var dayContent = _ref5.dayContent,
              priceConfig = _ref5.priceConfig;

          var _ref6 = dayContent || {},
              availability = _ref6.availability,
              id = _ref6.id,
              offer = _ref6.offer;

          var isBestPrice = priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.isBestPriceMonth;
          var unit = priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.unit;

          if (id) {
            var _priceConfig$initialP, _priceConfig$bestPric;

            var closed = availability === 'closed';
            var exclusivity = availability === 'exclusivity';
            var noDeparture = availability === 'noDeparture';
            var noFlight = availability === 'noFlight';
            var full = availability === 'full';
            var noAvailability = availability === '';
            var available = availability === 'available' || availability === 'unknown';
            var lastAvailability = offer === 'urgentisation';
            prices[id] = {
              availability: availability,
              available: available,
              closed: closed,
              exclusivity: exclusivity,
              full: full,
              isBestPrice: isBestPrice,
              lastAvailability: lastAvailability,
              noAvailability: noAvailability,
              noDeparture: noDeparture,
              noFlight: noFlight,
              oldPrice: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$initialP = priceConfig.initialPrice) === null || _priceConfig$initialP === void 0 ? void 0 : _priceConfig$initialP.formattedValue) || null,
              price: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$bestPric = priceConfig.bestPrice) === null || _priceConfig$bestPric === void 0 ? void 0 : _priceConfig$bestPric.formattedValue) || null,
              unit: unit
            };
          }
        });
      }
    });
  }

  return prices;
}

/***/ }),

/***/ "WwbQ":
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__("AzLH"),
    stubArray = __webpack_require__("HcXJ");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ "WzQP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GridRow; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("I6kL");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;




function getResponsiveClasses(grid) {
  return Object.keys(_utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"]).map(function (key) {
    if (grid.hasOwnProperty(key)) {
      return " ".concat(_utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"][key], "-GridRow--").concat(grid[_utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"][key]]); // fit, full, 1of2, 1of3
    }
  }).join('');
}

function GridRow(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$grid = _ref.grid,
      grid = _ref$grid === void 0 ? {} : _ref$grid,
      _ref$hasLeftGutters = _ref.hasLeftGutters,
      hasLeftGutters = _ref$hasLeftGutters === void 0 ? true : _ref$hasLeftGutters,
      _ref$hasTopGutters = _ref.hasTopGutters,
      hasTopGutters = _ref$hasTopGutters === void 0 ? true : _ref$hasTopGutters;
  if (!react__WEBPACK_IMPORTED_MODULE_0__["Children"].count(children)) return null;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'flex flex-wrap', {
      'GridRow--leftGutters': hasLeftGutters,
      'GridRow--topGutters': hasTopGutters
    }, getResponsiveClasses(grid))
  }, children);
}

/***/ }),

/***/ "XHSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export savePaymentTrackingDatas */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getPaymentTrackingDatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return makeBuildPrePaymentUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildPrePaymentUrlAndRedirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getFormData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return extractPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDevice; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lz_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("O2W8");
/* harmony import */ var lz_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lz_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("fYnN");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("U2CP");
/* harmony import */ var _utils_ple_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("6jSF");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("CcNa");
/* harmony import */ var _PrePayment_queries__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("19WB");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}












function initPayment(payload, appContext) {
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].runNoCacheQuery(Object(_PrePayment_queries__WEBPACK_IMPORTED_MODULE_10__[/* getInitPaymentQuery */ "b"])(payload), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_9__[/* PAYMENT_INIT */ "Yc"]
  }).then(function (_ref) {
    var prePayment = _ref.prePayment;
    return prePayment || {};
  });
}

function buildPrePaymentUrl() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var locale = arguments.length > 1 ? arguments[1] : undefined;
  var t = payload ? lz_string__WEBPACK_IMPORTED_MODULE_2___default.a.compressToEncodedURIComponent(JSON.stringify(payload)) : '';
  var query = {
    t: t,
    locale: locale
  };
  return new urijs__WEBPACK_IMPORTED_MODULE_1___default.a(_routes_routeBuilder__WEBPACK_IMPORTED_MODULE_6__[/* urlPattern */ "b"]('prePayment')).query(query).toString();
}

function savePaymentTrackingDatas(orderId, values) {
  js_cookie__WEBPACK_IMPORTED_MODULE_3___default.a.set('PRE_PAYMENT_INFOS-' + orderId, _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["oidc"].toUriEncodedState(values));
}
function getPaymentTrackingDatas(orderId) {
  var value = js_cookie__WEBPACK_IMPORTED_MODULE_3___default.a.get("PRE_PAYMENT_INFOS-".concat(orderId));
  return value ? _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["oidc"].fromUriEncodedState(value) : null;
}
function makeBuildPrePaymentUrl(appContext) {
  return function createPrePaymentUrl() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return initPayment(params, appContext).then(function (datas) {
      var payload = _objectSpread(_objectSpread({}, params), datas);

      if (params.urlRedirectionIfNothingToPay && datas.amount === 0) {
        if (params.beforeRedirect) {
          params.beforeRedirect();
        }

        return params.urlRedirectionIfNothingToPay;
      }

      return buildPrePaymentUrl(payload, Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(appContext, 'locale'));
    });
  };
}
function buildPrePaymentUrlAndRedirect(_ref2) {
  var appContext = _ref2.appContext,
      history = _ref2.history,
      location = _ref2.location,
      _ref2$payload = _ref2.payload,
      payload = _ref2$payload === void 0 ? {} : _ref2$payload,
      _ref2$isFreeDeposit = _ref2.isFreeDeposit,
      isFreeDeposit = _ref2$isFreeDeposit === void 0 ? false : _ref2$isFreeDeposit;
  return makeBuildPrePaymentUrl(appContext)(payload).then(function (url) {
    history.pushRoute(isFreeDeposit ? new urijs__WEBPACK_IMPORTED_MODULE_1___default.a(url).addQuery('freedeposit').toString() : url);
  })["catch"](function (err) {
    if (_utils_ple_utils__WEBPACK_IMPORTED_MODULE_7__[/* hasAuthResponseError */ "l"](err)) {
      _utils_ple_utils__WEBPACK_IMPORTED_MODULE_7__[/* redirectOnLoginPage */ "o"]({
        locale: appContext.locale,
        redirectPath: location.pathname
      });
      return;
    }

    if (_utils_ple_utils__WEBPACK_IMPORTED_MODULE_7__[/* hasNotFoundError */ "m"](err)) {
      _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].setLocation('/404');
      return;
    }

    throw err;
  });
}
function getFormData(params, appContext) {
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].runNoCacheQuery(Object(_PrePayment_queries__WEBPACK_IMPORTED_MODULE_10__[/* getFormDataQuery */ "a"])(params), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_9__[/* PAYMENT_PRE_GET_FORM_DATA */ "dd"]
  });
}
function extractPayload(payload) {
  if (!payload) {
    return null;
  }

  var value = null;

  try {
    value = lz_string__WEBPACK_IMPORTED_MODULE_2___default.a.decompressFromEncodedURIComponent(payload);
    return JSON.parse(value);
  } catch (e) {
    console.error('extractPayload', e, ' for value:', value); // eslint-disable-line no-console

    return null;
  }
}
function getDevice(responsive) {
  if (responsive.isDesktop) return 'DESKTOP';
  if (responsive.isTablet) return 'TABLET';
  return 'MOBILE';
}

/***/ }),

/***/ "XSvm":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ "XTOr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Product_Product; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLinkUtil.js + 1 modules
var DynamicLinkUtil = __webpack_require__("Mkub");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.utils.js
var Product_utils = __webpack_require__("Fe0B");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// CONCATENATED MODULE: ./src/client/components/widgets/offer-discount/OfferDiscount.jsx

var __jsx = react_default.a.createElement;



function OfferDiscount(props) {
  var className = props.className,
      _props$discount = props.discount,
      discount = _props$discount === void 0 ? {} : _props$discount,
      _props$i18n = props.i18n,
      i18n = _props$i18n === void 0 ? {} : _props$i18n;
  var offerName = discount && discount.offerName || i18n.defaultLabel || '';
  var color = discount && discount.offerColor || i18n.defaultColor || '';
  return Object(lodash["get"])(discount, 'amount.value') ? __jsx("div", {
    className: classnames_default()(className, 'bg-current font-bold p-1 text-center text-sm uppercase', Object(defineProperty["a" /* default */])({}, "text-".concat(color), color)),
    style: {
      backgroundColor: color
    }
  }, __jsx("span", {
    className: "text-white"
  }, offerName)) : null;
}
// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/Availability.jsx
var Availability_jsx = react_default.a.createElement;




function computeAvailabilityStatus(_ref) {
  var availability = _ref.availability,
      remainingStock = _ref.remainingStock;

  switch (true) {
    case availability === 'UNAVAILABLE':
    case availability === 'AVAILABLE' && remainingStock === 0:
      return 'unavailable';

    case availability === 'AVAILABLE' && remainingStock !== null && +remainingStock < 10:
    case availability === 'PARTIAL':
      return 'remaining';

    case availability === 'AVAILABLE':
      return 'available';

    default:
      return 'unknown';
  }
}

function Availability(_ref2) {
  var availability = _ref2.availability,
      remainingStock = _ref2.remainingStock,
      config = _ref2.config;
  var availabilityStatus = computeAvailabilityStatus({
    availability: availability,
    remainingStock: remainingStock
  });

  var _ref3 = config[availabilityStatus] || {},
      label = _ref3.label,
      color = _ref3.color,
      icon = _ref3.icon;

  return label ? Availability_jsx("span", {
    "data-testid": "availability-status-wrapper",
    className: "text-".concat(color, " flex items-center justify-center")
  }, icon && Availability_jsx(Icon["a" /* Icon */], {
    className: "mr-1",
    name: icon,
    width: "0.8rem"
  }), Availability_jsx("span", {
    "data-testid": "availability-status-text",
    className: "my-0"
  }, Object(dist["messageFormat"])(label).format({
    count: remainingStock
  }))) : null;
}
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/AvailabilityAge.jsx
var AvailabilityAge_jsx = react_default.a.createElement;



var shouldShowAgeInMonth = function shouldShowAgeInMonth(ageInNumberOfMonths) {
  return ageInNumberOfMonths <= 23;
};

var shouldShowAgeInYearsRange = function shouldShowAgeInYearsRange(ageMin, ageMax) {
  return !(Math.floor(ageMin / 12) === Math.floor(ageMax / 12));
};

function AvailabilityAge(_ref) {
  var ageMax = _ref.ageMax,
      ageMin = _ref.ageMin,
      childcareLabel = _ref.childcareLabel,
      monthsLabel = _ref.monthsLabel,
      yearLabel = _ref.yearLabel,
      yearsLabel = _ref.yearsLabel;
  var message = '';

  if (shouldShowAgeInMonth(ageMax)) {
    message = Object(dist["messageFormat"])(monthsLabel).format({
      min: ageMin,
      max: ageMax
    });
  } else if (shouldShowAgeInYearsRange(ageMin, ageMax)) {
    message = Object(dist["messageFormat"])(yearsLabel).format({
      min: Math.floor(ageMin / 12),
      max: Math.floor(ageMax / 12)
    });
  } else {
    // Shows a single year age
    message = Object(dist["messageFormat"])(yearLabel).format({
      fixed: Math.floor(ageMin / 12)
    });
  }

  return AvailabilityAge_jsx(react["Fragment"], null, "".concat(childcareLabel, " "), AvailabilityAge_jsx("span", {
    className: "whitespace-no-wrap font-normal"
  }, message));
}
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/productChildcareAvailabilities.jsx
var productChildcareAvailabilities_jsx = react_default.a.createElement;




var productChildcareAvailabilities_ProductChildcareAvailabilities = function ProductChildcareAvailabilities(props) {
  var availableLabel = props.availableLabel,
      childcareLabel = props.childcareLabel,
      items = props.items,
      monthsLabel = props.monthsLabel,
      remainingLabel = props.remainingLabel,
      unavailableLabel = props.unavailableLabel,
      unknownLabel = props.unknownLabel,
      yearLabel = props.yearLabel,
      yearsLabel = props.yearsLabel;
  var renderConfig = {
    available: {
      label: availableLabel,
      icon: icons["a" /* ICONS */].SMALL_CHECK,
      color: 'emerald'
    },
    remaining: {
      label: remainingLabel,
      color: 'orange',
      icon: icons["a" /* ICONS */].WARNING
    },
    unavailable: {
      label: unavailableLabel,
      color: 'red',
      icon: icons["a" /* ICONS */].SMALL_CROSS
    },
    unknown: {
      label: unknownLabel,
      color: 'gray-medium'
    }
  };
  return productChildcareAvailabilities_jsx("div", {
    className: "relative text-base font-bold py-2"
  }, items.map(function (_ref) {
    var id = _ref.id,
        ageMin = _ref.ageMin,
        ageMax = _ref.ageMax,
        availability = _ref.availability,
        remainingStock = _ref.remainingStock;
    return productChildcareAvailabilities_jsx("div", {
      key: id,
      className: "flex items-center justify-between text-gray-darker mb-3"
    }, productChildcareAvailabilities_jsx("p", {
      className: "my-0 font-bold"
    }, productChildcareAvailabilities_jsx(AvailabilityAge, {
      ageMax: ageMax,
      ageMin: ageMin,
      childcareLabel: childcareLabel,
      monthsLabel: monthsLabel,
      yearLabel: yearLabel,
      yearsLabel: yearsLabel
    })), productChildcareAvailabilities_jsx("p", {
      className: "flex my-0"
    }, productChildcareAvailabilities_jsx(Availability, {
      availability: availability,
      remainingStock: remainingStock,
      config: renderConfig
    })));
  }));
};
// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-comparison/ProductComparison.jsx

var ProductComparison_jsx = react_default.a.createElement;





function ProductComparison(props) {
  var children = props.children,
      className = props.className,
      eligibilityLabel = props.eligibilityLabel,
      isEligible = props.isEligible,
      label = props.label,
      onComparisonClick = props.onComparisonClick,
      _props$status = props.status,
      status = _props$status === void 0 ? product_utils["b" /* IS_ENABLED */] : _props$status;
  if (!react["Children"].count(children)) return null;
  if (!isEligible) return ProductComparison_jsx("div", {
    className: "relative"
  }, children, ProductComparison_jsx("div", {
    className: "absolute bg-overlay-white-60 flex font-bold items-center justify-center inset-0 p-5 text-base text-center z-1"
  }, eligibilityLabel));
  var isSelectable = status !== product_utils["a" /* IS_DISABLED */];
  var isSelected = status === product_utils["c" /* IS_SELECTED */];
  var buttonProps = isSelectable ? {
    onClick: onComparisonClick,
    type: 'button',
    title: label
  } : null;
  var TagName = isSelectable ? 'button' : 'div';
  return ProductComparison_jsx(TagName, Object(esm_extends["a" /* default */])({
    className: classnames_default()(className, 'relative', 'reset-button')
  }, buttonProps), children, ProductComparison_jsx("div", {
    className: classnames_default()('absolute', 'bg-overlay-gray-darker-40', 'flex items-center', 'justify-center', 'p-4', 'inset-0', 'text-white', 'z-1', 'rounded-tiny', {
      'cursor-pointer': isSelectable
    })
  }, isSelectable && ProductComparison_jsx("div", {
    className: classnames_default()('flex flex-col', 'items-center', 'opacity-100', 'p-2', 'rounded-full', 'border-2', 'transition-colors', {
      'bg-transparent border-white': !isSelected
    }, {
      'bg-emerald border-emerald': isSelected
    })
  }, ProductComparison_jsx(Icon["a" /* Icon */], {
    name: isSelected ? icons["a" /* ICONS */].CHECK : icons["a" /* ICONS */].PLUS,
    width: "1.25rem"
  }))));
}
// EXTERNAL MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.jsx + 1 modules
var ProductFlag = __webpack_require__("ELg1");

// EXTERNAL MODULE: ./src/client/components/widgets/product/product-header/ProductHeader.jsx
var ProductHeader = __webpack_require__("hgS3");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/image-slideshow/ImageSlideShow.jsx
var ImageSlideShow = __webpack_require__("DQFb");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-thumbnail/ProductThumbnail.jsx

var ProductThumbnail_jsx = react_default.a.createElement;










var OPENING_STATUS = dist["constants"].OPENING_STATUS;
var ProductThumbnail_ProductThumbnail = /*#__PURE__*/Object(react["memo"])(function ProductThumbnail(props) {
  var closedLabel = props.closedLabel,
      className = props.className,
      hasBorder = props.hasBorder,
      hasTransport = props.hasTransport,
      isLinkDisabled = props.isLinkDisabled,
      link = props.link,
      nextLabel = props.nextLabel,
      openingStatus = props.openingStatus,
      openingSoonLabel = props.openingSoonLabel,
      _props$pictures = props.pictures,
      pictures = _props$pictures === void 0 ? [] : _props$pictures,
      previousLabel = props.previousLabel,
      productTags = props.productTags,
      _props$tagsColor = props.tagsColor,
      tagsColor = _props$tagsColor === void 0 ? colors["a" /* COLORS */].BLUE : _props$tagsColor,
      transportLabel = props.transportLabel,
      isSliderDisabled = props.isSliderDisabled,
      hasLazyLoading = props.hasLazyLoading;
  var TagName = isLinkDisabled ? 'div' : DynamicLink["a" /* default */];
  var defaultPicture = pictures[0] || {};
  return ProductThumbnail_jsx(TagName, Object(esm_extends["a" /* default */])({
    className: classnames_default()('block', 'image-responsive-cell', 'relative', className)
  }, isLinkDisabled ? null : link), !isSliderDisabled && pictures.length > 1 && openingStatus !== OPENING_STATUS.CLOSED ? ProductThumbnail_jsx(ImageSlideShow["a" /* ImageSlideShow */], {
    hasInsetBorder: hasBorder,
    hasLazyLoading: true,
    media: pictures,
    nextLabel: nextLabel,
    previousLabel: previousLabel,
    ratio: ratios_utils["a" /* default */].XL
  }) : ProductThumbnail_jsx(Image["a" /* default */], {
    altMsg: defaultPicture.alt,
    className: classnames_default()({
      'inset-border-after': hasBorder
    }),
    imageUrl: defaultPicture.src,
    key: defaultPicture.src,
    groupKey: "thumbnails",
    ratioKey: ratios_utils["a" /* default */].XL,
    hasLazyLoading: hasLazyLoading
  }), hasTransport && ProductThumbnail_jsx("div", {
    className: "bg-blue inline-flex items-center overflow-hidden p-2 text-xs text-white uppercase absolute top-0 rtl:right-0 mt-5 rtl:mr-5 rounded-tiny font-brand uppercase",
    "data-testid": "ProductThumbnail-transport"
  }, ProductThumbnail_jsx(Icon["a" /* Icon */], {
    className: "flex-shrink-0 rtl:mr-1",
    name: icons["a" /* ICONS */].TRANSPORT,
    width: "calc(10rem / 16)"
  }), ProductThumbnail_jsx("div", {
    className: "leading-tight text-xxs",
    "data-testid": "ProductThumbnail-transportLabel"
  }, transportLabel)), openingStatus === OPENING_STATUS.OPENING_SOON && ProductThumbnail_jsx("div", {
    className: "bg-orange inline-flex items-center overflow-hidden p-2 text-xs text-white uppercase absolute top-0 rtl:right-0 mt-5 rtl:mr-5 rounded-tiny font-bold",
    "data-testid": "ProductThumbnail-openingSoon"
  }, ProductThumbnail_jsx("div", {
    className: "leading-tight text-xxs",
    "data-testid": "ProductThumbnail-openingSoonlabel"
  }, openingSoonLabel)), openingStatus === OPENING_STATUS.CLOSED && ProductThumbnail_jsx("div", {
    className: "absolute bg-overlay-black-60 font-bold inline-flex items-center justify-center overflow-hidden inset-0 rounded-tiny text-white text-xl uppercase",
    "data-testid": "ProductThumbnail-closed"
  }, ProductThumbnail_jsx("div", {
    "data-testid": "ProductThumbnail-closedLabel"
  }, closedLabel)), !!productTags && ProductThumbnail_jsx("div", {
    "data-testid": "ProductThumbnail-bottomTags",
    className: classnames_default()("bg-".concat(tagsColor), 'absolute leading-one font-brand uppercase left-1/2 bottom-0 p-2 mb-5 rounded-tiny text-center text-white text-xs -translate-x-50 whitespace-no-wrap max-w-9/10 truncate z-1')
  }, productTags));
});
// CONCATENATED MODULE: ./src/client/components/widgets/product/Product.jsx


var Product_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




















var Product_Product = function Product(_ref) {
  var _ref$callToAction = _ref.callToAction,
      callToAction = _ref$callToAction === void 0 ? {} : _ref$callToAction,
      childcare = _ref.childcare,
      className = _ref.className,
      comparison = _ref.comparison,
      flag = _ref.flag,
      hasComparison = _ref.hasComparison,
      hasDiscount = _ref.hasDiscount,
      _ref$hasFadeIn = _ref.hasFadeIn,
      hasFadeIn = _ref$hasFadeIn === void 0 ? true : _ref$hasFadeIn,
      hasLazyLoading = _ref.hasLazyLoading,
      header = _ref.header,
      isLinkDisabled = _ref.isLinkDisabled,
      offer = _ref.offer,
      offerDiscount = _ref.offerDiscount,
      onClick = _ref.onClick,
      onComparisonClick = _ref.onComparisonClick,
      thumbnail = _ref.thumbnail,
      url = _ref.url;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      history = _useRouter.history;

  var ProductHeaderWrapper = hasComparison ? ProductComparison : react["Fragment"];
  var linkShouldBeDisabled = isLinkDisabled || hasComparison;

  var goOnResort = function goOnResort() {
    var newHistoryState = new DynamicLinkUtil["a" /* default */](dist["windowWrapper"].getLocation(), url ? Object(Product_utils["c" /* generateProductLink */])(url, offer) : '');
    history.pushRoute(newHistoryState.toString());
  };

  var productHeader = Product_jsx(ProductHeader["a" /* ProductHeader */], Object(esm_extends["a" /* default */])({}, header, {
    className: "pt-5",
    isLinkDisabled: linkShouldBeDisabled,
    link: appContext.isCmta ? Object(Product_utils["a" /* generateCmtaLinkProp */])(url, appContext.originalUrl) : Object(Product_utils["b" /* generateLinkProp */])(url, offer)
  }));

  return Product_jsx("article", {
    className: classnames_default()(className, 'fadeInLong flex flex-col relative', {
      fadeInLong: hasFadeIn
    }),
    onClick: onClick
  }, Product_jsx(ProductHeaderWrapper, hasComparison ? _objectSpread(_objectSpread({}, comparison), {}, {
    onComparisonClick: onComparisonClick
  }) : {}, Product_jsx("div", {
    className: "relative",
    "data-testid": "Product-Header-Wrapper"
  }, hasDiscount && // $FlowFixMe
  Product_jsx(OfferDiscount, Object(esm_extends["a" /* default */])({}, offerDiscount, {
    className: "absolute opacity-75 inset-x-0 z-1"
  })), Product_jsx(ProductThumbnail_ProductThumbnail, Object(esm_extends["a" /* default */])({
    className: classnames_default()('rounded-tiny', 'overflow-hidden')
  }, thumbnail, {
    hasLazyLoading: hasLazyLoading,
    isLinkDisabled: true,
    nextLabel: Object(src_i18n["f" /* t */])('common.next'),
    previousLabel: Object(src_i18n["f" /* t */])('common.previous')
  })), !hasComparison ? productHeader : null)), hasComparison ? productHeader : null, Product_jsx(ProductFlag["a" /* ProductFlag */], Object(esm_extends["a" /* default */])({}, flag, {
    isLinkDisabled: linkShouldBeDisabled,
    onClick: goOnResort
  })), !!callToAction.label && Product_jsx(Button["a" /* Button */], Object(esm_extends["a" /* default */])({}, callToAction, {
    className: "mt-2 w-full",
    colorBg: linkShouldBeDisabled ? colors["a" /* COLORS */].INFO : colors["a" /* COLORS */].BLUE,
    colorBorder: linkShouldBeDisabled ? colors["a" /* COLORS */].INFO : colors["a" /* COLORS */].BLUE,
    iconRight: {
      name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH
    },
    isDisabled: linkShouldBeDisabled,
    onClick: goOnResort
  }), callToAction.label), Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('faceting.childcare') && childcare && !Object(lodash["isEmpty"])(childcare.items) && Product_jsx(productChildcareAvailabilities_ProductChildcareAvailabilities, childcare));
};

/***/ }),

/***/ "YXT+":
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__("J77r"),
    Map = __webpack_require__("McKP"),
    Promise = __webpack_require__("3JOw"),
    Set = __webpack_require__("weY2"),
    WeakMap = __webpack_require__("tJ/X"),
    baseGetTag = __webpack_require__("rnJz"),
    toSource = __webpack_require__("AVUi");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ "YZTm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ID_LAYER_HEADER__BE__ACCOMMODATIONS_DESKTOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ID_LAYER_HEADER__BE__ACCOMMODATIONS_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ID_LAYER_HEADER__BE__CATEGORY_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ID_LAYER_HEADER__BE__CHOOSE_EQUIPEMENT; });
/* unused harmony export ID_LAYER_HEADER__BE__MOBILE_FILTERS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ID_LAYER_HEADER__BE__SELLER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ID_LAYER_HEADER__BE__TRANSPORTS_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ID_LAYER_HEADER__BE__OTHER_PROPOSALS_MOBILE; });
/* unused harmony export ID_LAYER_HEADER__PLE__PYR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ID_LAYER_HEADER__PLE__PYR_AGENCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ID_LAYER_HEADER__PLE__PYR_RESORT_ONLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ID_LAYER_HEADER__PLE__PYR_ROOM_RESORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ID_MODAL_HEADER__BE__BUSINESS_CLASS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ID_MODAL_HEADER__BE__OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return ID_MODAL_HEADER__BE__PROMO_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return ID_MODAL_HEADER__BE__SHARE_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ID_MODAL_HEADER__BE__MISMATCH_COUNTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return ID_MODAL_HEADER__PLE__LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ID_MODAL_HEADER__BE__CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return ID_MODAL_HEADER__PLE__NEWSLETTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return ID_MODAL_HEADER__SHOPPING__WEBCALLBACK_TRIGGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return ID_SIDEPANEL_HEADER__SHOPPING__WIBILONG_NARROW; });
// Layers header IDs
var ID_LAYER_HEADER__BE__ACCOMMODATIONS_DESKTOP = 'AccommodationsDesktopLayerHeaderId';
var ID_LAYER_HEADER__BE__ACCOMMODATIONS_MOBILE = 'AccommodationsMobileLayerHeaderId';
var ID_LAYER_HEADER__BE__CATEGORY_LIST = 'CategoryListLayerHeaderId';
var ID_LAYER_HEADER__BE__CHOOSE_EQUIPEMENT = 'ChooseEquipmentLayerHeaderId';
var ID_LAYER_HEADER__BE__MOBILE_FILTERS = 'MobileFiltersLayerHeaderId';
var ID_LAYER_HEADER__BE__SELLER = 'SellerLayerHeaderId';
var ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP = 'TransportsDesktopLayerHeaderId';
var ID_LAYER_HEADER__BE__TRANSPORTS_MOBILE = 'TransportsMobileLayerHeaderId';
var ID_LAYER_HEADER__BE__OTHER_PROPOSALS_MOBILE = 'OtherProposalsMobileLayerHeaderId';
var ID_LAYER_HEADER__PLE__PYR = 'PickYourRoomLayerHeaderId';
var ID_LAYER_HEADER__PLE__PYR_AGENCY = 'PickYourRoomAgencyLayerHeaderId';
var ID_LAYER_HEADER__PLE__PYR_RESORT_ONLY = 'PYRResortOnlyLayerHeaderId';
var ID_LAYER_HEADER__PLE__PYR_ROOM_RESORT = 'PickYourRoomResortLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES = 'CookiePreferencesLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL = 'CriteriaModalLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER = 'CriteriaTriggerLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS = 'PriceRemoteDetailsLayerHeaderId'; // Modals header IDs

var ID_MODAL_HEADER__BE__BUSINESS_CLASS = 'BusinessClassModalHeaderId';
var ID_MODAL_HEADER__BE__OPTION = 'OptionModalHeaderId';
var ID_MODAL_HEADER__BE__PROMO_CODE = 'PromoCodeModalHeaderId';
var ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION = 'SaveCriteriaConfirmationModalHeaderId';
var ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN = 'SaveCriteriaLoginModalHeaderId';
var ID_MODAL_HEADER__BE__SHARE_CONTEXT = 'ShareContextModalHeaderId';
var ID_MODAL_HEADER__BE__MISMATCH_COUNTRY = 'MismatchCountryModalHeaderId';
var ID_MODAL_HEADER__PLE__LOGIN = 'ParticipantsLoginToPleModalHeaderId';
var ID_MODAL_HEADER__BE__CUSTOMER = 'ParticipantsCustomerModalHeaderId';
var ID_MODAL_HEADER__PLE__NEWSLETTER = 'NewsletterModalHeaderId';
var ID_MODAL_HEADER__SHOPPING__WEBCALLBACK_TRIGGER = 'WebCallBackTriggerModalHeaderId'; // SidePanel header IDs

var ID_SIDEPANEL_HEADER__SHOPPING__WIBILONG_NARROW = 'WibilongNarrowSidePanelHeaderId';

/***/ }),

/***/ "YfuU":
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__("2NJa"),
    getPrototype = __webpack_require__("lBGg"),
    isPrototype = __webpack_require__("RVBP");

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ "YjXp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputSwitch_InputSwitch; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /home/circleci/project/node_modules/shortid/index.js
var shortid = __webpack_require__("MIfU");
var shortid_default = /*#__PURE__*/__webpack_require__.n(shortid);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/form/form.util.js
var form_util = __webpack_require__("1P7A");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.themes.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var DEFAULT_SIZES = {
  small: 15,
  medium: 23,
  large: 23
};
var themes = {
  "default": function _default(props) {
    var color = props.color,
        isChecked = props.isChecked,
        isDisabled = props.isDisabled,
        isReadOnly = props.isReadOnly,
        size = props.size,
        validationState = props.validationState;
    return {
      thRoot: 'flex items-center',
      thLabel: classnames_default()('flex items-center text-base px-3', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), {
        'font-bold text-blue text-lg': size === 'large',
        'text-emerald': validationState === 'IS_VALID' && !isReadOnly && !isDisabled,
        'text-red': validationState === 'IS_INVALID' && !isReadOnly && !isDisabled
      }),
      thChecked: classnames_default()('leading-none bg-white border-1 border-solid border-gray-medium flex-shrink-0 p-px rounded-tiny', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), {
        'text-blue': isChecked,
        'bg-gray-light opacity-25': isDisabled
      }),
      thCheckedStyle: {
        width: DEFAULT_SIZES[size],
        height: DEFAULT_SIZES[size]
      },
      thLoading: 'rtl:ml-2 flex items-center leading-none',
      thSwitch: classnames_default()('reset-button border-2 flex items-center transition-all', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), Object(defineProperty["a" /* default */])({
        'bg-gray-light border-gray-light': isDisabled,
        'bg-gray-darker border-gray-darker': !isChecked && !isDisabled
      }, "bg-".concat(color, " border-").concat(color), isChecked && !isDisabled)),
      thSwitchStyle: {
        width: 58,
        padding: '0 1px',
        height: 30,
        borderRadius: 30
      },
      thSwitchToggler: classnames_default()('bg-white block leading-none flex items-center justify-center rounded-half transition-all', Object(defineProperty["a" /* default */])({
        'rtl:translate-x-100': isChecked
      }, "text-".concat(color), isChecked && !isDisabled)),
      thSwitchTogglerStyle: {
        width: 28,
        height: 28
      }
    };
  },
  bubble: function bubble(props) {
    var isChecked = props.isChecked,
        isDisabled = props.isDisabled,
        isReadOnly = props.isReadOnly,
        validationState = props.validationState;
    return {
      thRoot: 'relative',
      thLabel: classnames_default()('flex items-center justify-center shadow border-1 rounded py-3 px-5 text-base text-center transition-colors', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), {
        'bg-white': !isDisabled,
        'bg-gray-light border-gray-light opacity-50': isDisabled,
        'border-gray-light': !isChecked && validationState === 'NOT_VALIDATED',
        'border-current text-blue': isChecked && validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
        'border-current text-emerald': validationState === 'IS_VALID' && !isReadOnly && !isDisabled,
        'border-current text-red': validationState === 'IS_INVALID' && !isReadOnly && !isDisabled
      }),
      thChecked: 'hidden',
      thLoading: 'absolute flex h-full items-center leading-none left-1/2 -translate-x-50'
    };
  },
  bubble2: function bubble2(props) {
    var isChecked = props.isChecked,
        isDisabled = props.isDisabled,
        isReadOnly = props.isReadOnly,
        validationState = props.validationState;
    return {
      thRoot: 'relative',
      thLabel: classnames_default()('flex items-center justify-center border-1 rounded py-1 px-1 text-base text-center transition-colors', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), {
        'bg-white': !isChecked,
        'border-gray-light opacity-50': isDisabled && !isChecked,
        'border-gray-light': !isChecked && validationState === 'NOT_VALIDATED',
        'border-blue text-white bg-blue': isChecked && validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
        'border-current text-emerald': validationState === 'IS_VALID' && !isReadOnly && !isDisabled,
        'border-current text-red': validationState === 'IS_INVALID' && !isReadOnly && !isDisabled,
        'border-blue text-white bg-blue opacity-50': isDisabled && isChecked
      }),
      thChecked: 'hidden',
      thLoading: 'absolute flex h-full items-center leading-none left-1/2 -translate-x-50'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.jsx







var __jsx = react_default.a.createElement;

function InputSwitch_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function InputSwitch_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { InputSwitch_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { InputSwitch_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }











var InputSwitch_InputSwitch = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputSwitch, _Component);

  var _super = _createSuper(InputSwitch);

  function InputSwitch(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputSwitch);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function () {
      var _this$props = _this.props,
          isDisabled = _this$props.isDisabled,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? '' : _this$props$name,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? lodash["noop"] : _this$props$onChange,
          _this$props$value = _this$props.value,
          value = _this$props$value === void 0 ? '' : _this$props$value;

      if (!isReadOnly && !isDisabled && !isLoading) {
        var isChecked = !_this.state.isChecked;

        _this.setState({
          isChecked: isChecked
        }, function () {
          return onChange(name, isChecked, value);
        });
      }
    });

    _this.state = {
      isChecked: props.isChecked || false
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputSwitch, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isChecked !== this.props.isChecked) {
        this.setState({
          isChecked: this.props.isChecked
        });
      }
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      var _this$props2 = this.props,
          _this$props2$iconChec = _this$props2.iconChecked,
          iconChecked = _this$props2$iconChec === void 0 ? null : _this$props2$iconChec,
          _this$props2$iconUnCh = _this$props2.iconUnChecked,
          iconUnChecked = _this$props2$iconUnCh === void 0 ? null : _this$props2$iconUnCh;
      return this.state.isChecked ? iconChecked : iconUnChecked;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          ariaDescribedby = _this$props3.ariaDescribedby,
          ariaLabelledby = _this$props3.ariaLabelledby,
          className = _this$props3.className,
          _this$props3$id = _this$props3.id,
          id = _this$props3$id === void 0 ? "InputSwitch_".concat(shortid_default.a.generate()) : _this$props3$id,
          isDisabled = _this$props3.isDisabled,
          isLoading = _this$props3.isLoading,
          isReadOnly = _this$props3.isReadOnly,
          isRequired = _this$props3.isRequired,
          isSwitch = _this$props3.isSwitch,
          label = _this$props3.label,
          labelClassName = _this$props3.labelClassName,
          name = _this$props3.name,
          onClick = _this$props3.onClick,
          theme = _this$props3.theme,
          value = _this$props3.value,
          dataTestId = _this$props3.dataTestId;
      var isChecked = this.state.isChecked;

      var _themes$theme = themes[theme](InputSwitch_objectSpread({
        isChecked: isChecked
      }, this.props)),
          thChecked = _themes$theme.thChecked,
          thCheckedStyle = _themes$theme.thCheckedStyle,
          thLabel = _themes$theme.thLabel,
          thLoading = _themes$theme.thLoading,
          thRoot = _themes$theme.thRoot,
          thSwitch = _themes$theme.thSwitch,
          thSwitchStyle = _themes$theme.thSwitchStyle,
          thSwitchToggler = _themes$theme.thSwitchToggler,
          thSwitchTogglerStyle = _themes$theme.thSwitchTogglerStyle;

      return __jsx("div", {
        "data-testid": dataTestId,
        className: classnames_default()(className, thRoot)
      }, isSwitch ? __jsx("button", {
        "aria-checked": isChecked,
        "aria-describedby": ariaDescribedby,
        "aria-disabled": isDisabled,
        "aria-labelledby": ariaLabelledby,
        className: thSwitch,
        "data-testid": id,
        onClick: this.onChange,
        role: "checkbox",
        style: thSwitchStyle,
        type: "button"
      }, __jsx("span", {
        className: thSwitchToggler,
        style: thSwitchTogglerStyle
      }, isChecked ? __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].CHECK
      }) : __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].CROSS,
        width: "0.7rem"
      }))) : __jsx("button", {
        "aria-checked": isChecked,
        "aria-describedby": ariaDescribedby,
        "aria-disabled": isDisabled,
        "aria-labelledby": ariaLabelledby,
        className: classnames_default()('reset-button', thChecked),
        "data-testid": id,
        disabled: isDisabled,
        onClick: this.onChange,
        role: "checkbox",
        style: thCheckedStyle,
        type: "button"
      }, __jsx(Icon["a" /* Icon */], {
        name: this.getIcon(),
        width: "100%"
      })), __jsx("input", {
        checked: isChecked,
        className: "hidden",
        disabled: isDisabled,
        id: id,
        label: label,
        name: name,
        onChange: this.onChange,
        onClick: onClick,
        required: isRequired,
        type: "checkbox",
        value: value
      }), isLoading && !isDisabled && !isReadOnly && __jsx("div", {
        className: thLoading
      }, __jsx(Spinner["a" /* Spinner */], {
        size: "small"
      })), !!label && __jsx("label", {
        className: classnames_default()(labelClassName, thLabel),
        htmlFor: id
      }, Object(lodash["isString"])(label) ? Object(form_util["b" /* getFormattedLabel */])(label, isRequired) : label));
    }
  }]);

  return InputSwitch;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputSwitch_InputSwitch, "defaultProps", {
  color: colors["a" /* COLORS */].BLUE,
  iconChecked: icons["a" /* ICONS */].CHECK,
  iconUnChecked: null,
  isDisabled: false,
  isLoading: false,
  size: 'medium',
  theme: 'default',
  validationState: 'NOT_VALIDATED'
});

/***/ }),

/***/ "Z1ta":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ "ZHK4":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__("1TCz");
      }
    ]);
  

/***/ }),

/***/ "ZLJe":
/***/ (function(module) {

module.exports = JSON.parse("{\"amp\":\"&\",\"apos\":\"'\",\"gt\":\">\",\"lt\":\"<\",\"quot\":\"\\\"\"}");

/***/ }),

/***/ "ZP80":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FETCH_PREBOOKING_TRAVELERS; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ fetchPrebookingTravelers; });

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/BookingAttendeesProfile.fragment.js
var BookingAttendeesProfile_fragment = __webpack_require__("SQLw");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.query.js
var BookingEngine_query = __webpack_require__("MAH5");

// CONCATENATED MODULE: ./src/client/store/prebooking-form/prebookingform.queries.js


function travelerProfilesQuery(_ref) {
  var adults = _ref.adults,
      kids = _ref.kids;
  return "\n    {\n      ".concat(Object(BookingEngine_query["a" /* getCxoAttendeesData */])({
    adultsAttendeesIds: adults,
    kidsAttendeesIds: kids
  }), "\n    }\n    ").concat(adults && adults[0] || kids && kids[0] ? BookingAttendeesProfile_fragment["a" /* default */] : '', "\n  ");
}
// CONCATENATED MODULE: ./src/client/store/prebooking-form/prebookingform.action.js





var FETCH_PREBOOKING_TRAVELERS = 'FETCH_PREBOOKING_TRAVELERS';
function fetchPrebookingTravelers(params, appContext) {
  return function (dispatch) {
    if (!params.adults || params.adults.length === 0) {
      return Promise.reject();
    }

    var query = travelerProfilesQuery(params);
    var promise = graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
      requestName: requestDictionary["gb" /* CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_TRAVELERS */]
    })["catch"](function (error) {
      if (error.errors && error.errors.some(function (e) {
        return e.statusCode === 401;
      })) {
        Object(sellerUtils["e" /* handle401GraphqlErrorSeller */])(error, appContext);
      }

      return {};
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(FETCH_PREBOOKING_TRAVELERS, params, {
      optimist: true,
      promise: promise
    }));
  };
}

/***/ }),

/***/ "ZoZw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PYR_MAP_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOAD_STYLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_POLYGONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_RESORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HIGHLIGHT_BUILDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TOGGLE_BUILDING_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RESET_BUILDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SELECT_MAP_FLOOR_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FIT_BOUNDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return reducer; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_widgets_pick_your_room_wrapper_map_gl_styles_buildings_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("U9LJ");
/* harmony import */ var _app_pickYourRoom_reducer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ogu6");



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var PYR_MAP_ERROR = 'PYR_MAP_ERROR';
var LOAD_STYLE = 'LOAD_STYLE';
var LOAD_POLYGONS = 'LOAD_POLYGONS';
var SET_RESORT = 'SET_RESORT_PYR';
var HIGHLIGHT_BUILDING = 'HIGHLIGHT_BUILDING';
var TOGGLE_BUILDING_SELECTION = 'TOGGLE_BUILDING_SELECTION';
var RESET_BUILDING = 'RESET_BUILDING';
var SELECT_MAP_FLOOR_LEVEL = 'SELECT_MAP_FLOOR_LEVEL';
var FIT_BOUNDS = 'FIT_BOUNDS';
var initialState = {
  mapStyle: null,
  maxBounds: null,
  amenities: [],
  geoJSON: null,
  currentBounds: null,
  highlightedBuildingId: ''
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case PYR_MAP_ERROR:
      {
        var error = action.payload.error;
        return _objectSpread(_objectSpread({}, state), {}, {
          error: error
        });
      }

    case LOAD_STYLE:
      {
        var mapStyle = action.payload.mapStyle;
        return _objectSpread(_objectSpread({}, state), {}, {
          mapStyle: mapStyle
        });
      }

    case SET_RESORT:
      {
        var resortData = action.payload.resortData;

        if (!resortData) {
          return state;
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          baseViewport: resortData.initialViewport,
          targetViewport: resortData.targetViewport,
          maxBounds: resortData.maxBounds,
          amenities: resortData.amenities.features
        });
      }

    case LOAD_POLYGONS:
      {
        var geoJSON = action.payload.geojson;
        var _mapStyle = state.mapStyle;
        var layers = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_mapStyle.layers || []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_components_widgets_pick_your_room_wrapper_map_gl_styles_buildings_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"] || []));
        var layerIndexes = {
          floors: layers.findIndex(function (layer) {
            return layer.id === 'floors';
          }),
          floorsCurrent: layers.findIndex(function (layer) {
            return layer.id === 'floors_current';
          }),
          floorsCurrentDimmed: layers.findIndex(function (layer) {
            return layer.id === 'floors_current_dimmed';
          }),
          floorsHighlight: layers.findIndex(function (layer) {
            return layer.id === 'floors_highlight';
          })
        };
        var newMapStyle = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["cloneDeep"])(state.mapStyle);
        newMapStyle.sources.buildingsSource = {
          type: 'geojson',
          data: geoJSON
        };
        return _objectSpread(_objectSpread({}, state), {}, {
          geoJSON: geoJSON,
          layerIndexes: layerIndexes,
          mapStyle: _objectSpread(_objectSpread({}, newMapStyle), {}, {
            layers: layers
          })
        });
      }

    case _app_pickYourRoom_reducer__WEBPACK_IMPORTED_MODULE_4__[/* SELECT_BUILDING */ "i"]:
      {
        var buildingId = action.payload.buildingId;
        var _layerIndexes = state.layerIndexes,
            _mapStyle2 = state.mapStyle;

        var _newMapStyle = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["cloneDeep"])(_mapStyle2);

        _newMapStyle.layers[_layerIndexes.floors].filter[2] = buildingId;
        _newMapStyle.layers[_layerIndexes.floorsCurrent].filter[1][2] = buildingId;
        _newMapStyle.layers[_layerIndexes.floorsCurrentDimmed].filter[1][2] = buildingId;
        return _objectSpread(_objectSpread({}, state), {}, {
          mapStyle: _objectSpread(_objectSpread({}, _mapStyle2), _newMapStyle)
        });
      }

    case RESET_BUILDING:
      {
        var _layerIndexes2 = state.layerIndexes,
            _mapStyle3 = state.mapStyle;

        var _newMapStyle2 = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["cloneDeep"])(_mapStyle3);

        _newMapStyle2.layers[_layerIndexes2.floors].filter[2] = '';
        _newMapStyle2.layers[_layerIndexes2.floorsCurrent].filter[1][2] = '';
        _newMapStyle2.layers[_layerIndexes2.floorsCurrentDimmed].filter[1][2] = '';
        return _objectSpread(_objectSpread({}, state), {}, {
          mapStyle: _objectSpread(_objectSpread({}, _mapStyle3), _newMapStyle2),
          highlightedBuildingId: ''
        });
      }

    case SELECT_MAP_FLOOR_LEVEL:
      {
        var _layerIndexes3 = state.layerIndexes,
            _mapStyle4 = state.mapStyle;
        var level = action.payload.level;

        var _newMapStyle3 = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["cloneDeep"])(_mapStyle4);

        _newMapStyle3.layers[_layerIndexes3.floorsCurrent].filter[2][2] = level;
        _newMapStyle3.layers[_layerIndexes3.floorsCurrentDimmed].filter[2][2] = level;
        return _objectSpread(_objectSpread({}, state), {}, {
          mapStyle: _objectSpread(_objectSpread({}, _mapStyle4), _newMapStyle3)
        });
      }

    case HIGHLIGHT_BUILDING:
      {
        var _layerIndexes4 = state.layerIndexes,
            _mapStyle5 = state.mapStyle;
        var _buildingId = action.payload.buildingId;

        var _newMapStyle4 = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["cloneDeep"])(_mapStyle5);

        _newMapStyle4.layers[_layerIndexes4.floorsHighlight].filter[2] = _buildingId;
        return _objectSpread(_objectSpread({}, state), {}, {
          mapStyle: _objectSpread(_objectSpread({}, _mapStyle5), _newMapStyle4),
          highlightedBuildingId: _buildingId
        });
      }

    case TOGGLE_BUILDING_SELECTION:
      {
        var _layerIndexes5 = state.layerIndexes,
            _mapStyle6 = state.mapStyle;
        var allow = action.payload.allow;

        var _newMapStyle5 = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["cloneDeep"])(_mapStyle6);

        _newMapStyle5.layers[_layerIndexes5.floors].interactive = allow;
        return _objectSpread(_objectSpread({}, state), {}, {
          mapStyle: _newMapStyle5
        });
      }

    case FIT_BOUNDS:
      {
        var bounds = action.payload.bounds;
        return _objectSpread(_objectSpread({}, state), {}, {
          currentBounds: bounds
        });
      }

    default:
      {
        return state;
      }
  }
}

/***/ }),

/***/ "Zq1u":
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__("rhE9");

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),

/***/ "aUQU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useAutocomplete; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zygG");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Ub5k");
/* harmony import */ var _use_debounce_useDebounce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ngAq");
/* harmony import */ var _client_store_utils_autocompleteItemHelper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Qmkj");
/* harmony import */ var _utils_pertimm_client__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("y316");








function useAutocomplete() {
  var keywords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_3__["useContext"])(_client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"]);

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])(keywords),
      autocompleteQuery = _useState[0],
      setAutocompleteQuery = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])([]),
      autocompleteResults = _useState2[0],
      setAutocompleteResults = _useState2[1];

  var _useDebounce = Object(_use_debounce_useDebounce__WEBPACK_IMPORTED_MODULE_5__[/* useDebounce */ "a"])([autocompleteQuery], 300),
      _useDebounce2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_useDebounce, 1),
      debouncedAutocompleteQuery = _useDebounce2[0]; // This effect is used to fetch autocomplete suggestions when the query changes (with a 300ms debounce)


  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee() {
        var _ref2, _ref2$answers, answers, results;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return Object(_utils_pertimm_client__WEBPACK_IMPORTED_MODULE_7__[/* suggest */ "d"])({
                  criteria: {
                    keywords: debouncedAutocompleteQuery
                  },
                  appContext: appContext
                });

              case 3:
                _ref2 = _context.sent;
                _ref2$answers = _ref2.answers;
                answers = _ref2$answers === void 0 ? [] : _ref2$answers;
                results = answers.map(_client_store_utils_autocompleteItemHelper__WEBPACK_IMPORTED_MODULE_6__[/* getResultItem */ "b"]);
                setAutocompleteResults(results);
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                setAutocompleteResults([]);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 10]]);
      }));

      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();

    if (debouncedAutocompleteQuery) {
      fetchData();
    } else {
      setAutocompleteResults([]);
    }
  }, [debouncedAutocompleteQuery]);
  return {
    autocompleteQuery: autocompleteQuery,
    setAutocompleteQuery: setAutocompleteQuery,
    autocompleteResults: autocompleteResults,
    setAutocompleteResults: setAutocompleteResults
  };
}

/***/ }),

/***/ "aZXx":
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ "bvyN":
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__("/30y"),
    isObjectLike = __webpack_require__("tLQN");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ "c/N2":
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ "cGFA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getValidationStateFromKid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getValidationStateFromKids; });
/* unused harmony export updateValidationStateForKid */
/* unused harmony export addOrRemoveKidFromValidationState */
/* unused harmony export addOrRemoveKidFromKidsList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasKidWithoutAValidBirthdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasOnlyValidKids; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return invalidateNotValidatedKids; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wQ38");
/* harmony import */ var _facetingUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("kNiU");
/* harmony import */ var _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("45yR");




var getValidationStateFromKid = function getValidationStateFromKid(kid) {
  return kid.birthdate && Object(_facetingUtils__WEBPACK_IMPORTED_MODULE_2__[/* isKidMinor */ "f"])(kid.birthdate) ? _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_VALID */ "b"] : _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_INVALID */ "a"];
};
var getValidationStateFromKids = function getValidationStateFromKids() {
  var kids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return kids.map(getValidationStateFromKid);
};
var updateValidationStateForKid = function updateValidationStateForKid(_ref) {
  var index = _ref.index,
      kid = _ref.kid,
      _ref$kidsValidationSt = _ref.kidsValidationState,
      kidsValidationState = _ref$kidsValidationSt === void 0 ? [] : _ref$kidsValidationSt;
  var validationState = getValidationStateFromKid(kid);
  return kidsValidationState.map(function (kidValidation, indexKid) {
    var isNewKid = kidValidation === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* NOT_VALIDATED */ "c"];
    var kidNeedsValidation = !!kid.birthdate || !isNewKid;
    return indexKid === index && kidNeedsValidation ? validationState : kidValidation;
  });
};
var addOrRemoveKidFromValidationState = function addOrRemoveKidFromValidationState(_ref2) {
  var _ref2$currentState = _ref2.currentState,
      currentState = _ref2$currentState === void 0 ? [] : _ref2$currentState,
      kidsNumber = _ref2.kidsNumber;

  if (kidsNumber > currentState.length) {
    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(currentState), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Array(kidsNumber - currentState.length).fill(_client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_1__[/* VALIDATION_STATE_ENUM */ "f"].notvalidated)));
  }

  if (kidsNumber < currentState.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(currentState.slice(0, kidsNumber));
  }

  return currentState;
};
var addOrRemoveKidFromKidsList = function addOrRemoveKidFromKidsList(args) {
  var _args$kids = args.kids,
      kids = _args$kids === void 0 ? [] : _args$kids,
      kidsNumber = args.kidsNumber;

  if (kidsNumber > kids.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(kids).concat(Array(kidsNumber - kids.length).fill().map(function () {
      return _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_1__[/* DEFAULT_KID_VALUE */ "a"];
    }));
  }

  if (kidsNumber < kids.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(kids.slice(0, kidsNumber));
  }

  return kids;
};
var hasKidWithoutAValidBirthdate = function hasKidWithoutAValidBirthdate(kidsValidationState) {
  return Boolean(kidsValidationState && kidsValidationState.find(function (kid) {
    return kid === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_INVALID */ "a"];
  }));
};
var hasOnlyValidKids = function hasOnlyValidKids(kidsValidationState) {
  return kidsValidationState.every(function (kid) {
    return kid === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_VALID */ "b"];
  });
};
var invalidateNotValidatedKids = function invalidateNotValidatedKids(kidsValidationState) {
  return kidsValidationState.reduce(function (acc, current) {
    if (current === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* NOT_VALIDATED */ "c"]) {
      return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(acc), [_client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_INVALID */ "a"]]);
    }

    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(acc), [current]);
  }, []);
};

/***/ }),

/***/ "cHMM":
/***/ (function(module, exports, __webpack_require__) {

var decodeMap = __webpack_require__("tRRp");

module.exports = decodeCodePoint;

// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint){

	if((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF){
		return "\uFFFD";
	}

	if(codePoint in decodeMap){
		codePoint = decodeMap[codePoint];
	}

	var output = "";

	if(codePoint > 0xFFFF){
		codePoint -= 0x10000;
		output += String.fromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
		codePoint = 0xDC00 | codePoint & 0x3FF;
	}

	output += String.fromCharCode(codePoint);
	return output;
}


/***/ }),

/***/ "cdYD":
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__("tU/q"),
    getSymbolsIn = __webpack_require__("UR9l"),
    keysIn = __webpack_require__("FQR9");

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ "ceQO":
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__("5FP0"),
    cloneDataView = __webpack_require__("KicR"),
    cloneRegExp = __webpack_require__("c/N2"),
    cloneSymbol = __webpack_require__("kE5G"),
    cloneTypedArray = __webpack_require__("SIwd");

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ "cvSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SYNC_WITH_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SEARCH_SET_KEYWORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return TRIP_INFORMATION_SET_DEPARTURE_CITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return TRIP_INFORMATION_SET_DEPARTURE_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_USER_PAST_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_USER_PAST_TRIPS_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return RESET_USER_PAST_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_USER_FUTURE_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_USER_FUTURE_TRIPS_FETCHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_USER_FUTURE_TRIPS_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return RESET_USER_FUTURE_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_USER_SEARCHES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_USER_SEARCHES_RESOLVED; });
/* unused harmony export SET_PARTICIPANTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_CALENDAR_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_BOOKABLE_DATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_BOOKABLE_DATES_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALENDAR_CHANGE_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLEAR_CALENDAR; });
/* unused harmony export QUOTATION_FORM_UPDATE */
/* unused harmony export QUOTATION_FORM_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return UPDATE_TRIP_DATE_CRITERIA; });
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__);

var SYNC_WITH_LOCATION = 'SYNC_WITH_LOCATION';
var SEARCH_SET_KEYWORDS = 'SEARCH_SET_KEYWORDS';
var TRIP_INFORMATION_SET_DEPARTURE_CITY = 'TRIP_INFORMATION_SET_DEPARTURE_CITY';
var TRIP_INFORMATION_SET_DEPARTURE_DATE = 'TRIP_INFORMATION_SET_DEPARTURE_DATE';
var FETCH_USER_PAST_TRIPS = 'FETCH_USER_PAST_TRIPS';
var FETCH_USER_PAST_TRIPS_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_PAST_TRIPS);
var RESET_USER_PAST_TRIPS = 'RESET_USER_PAST_TRIPS';
var FETCH_USER_FUTURE_TRIPS = 'FETCH_USER_FUTURE_TRIPS';
var FETCH_USER_FUTURE_TRIPS_FETCHED = 'FETCH_USER_FUTURE_TRIPS_FETCHED';
var FETCH_USER_FUTURE_TRIPS_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_FUTURE_TRIPS);
var RESET_USER_FUTURE_TRIPS = 'RESET_USER_FUTURE_TRIPS';
var FETCH_USER_SEARCHES = 'FETCH_USER_SEARCHES';
var FETCH_USER_SEARCHES_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_SEARCHES);
var SET_PARTICIPANTS = 'SET_PARTICIPANTS';
var FETCH_CALENDAR = 'FETCH_CALENDAR';
var FETCH_CALENDAR_ABORT = 'FETCH_CALENDAR_ABORT';
var FETCH_BOOKABLE_DATES = 'FETCH_BOOKABLE_DATES';
var FETCH_BOOKABLE_DATES_ABORT = 'FETCH_BOOKABLE_DATES_ABORT';
var CALENDAR_CHANGE_MONTH = 'CALENDAR_CHANGE_MONTH';
var CLEAR_CALENDAR = 'CLEAR_CALENDAR';
var QUOTATION_FORM_UPDATE = 'QUOTATION_FORM_UPDATE';
var QUOTATION_FORM_REQUEST = 'QUOTATION_FORM_REQUEST';
var UPDATE_TRIP_DATE_CRITERIA = 'UPDATE_TRIP_DATE_CRITERIA';

/***/ }),

/***/ "d9/u":
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ "dGB2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CABIN_CLASS_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COMPANIES_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LAYOVERS_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TIME_RANGES_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CABIN_CLASS_ECO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CABIN_CLASS_BUSINESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ZERO_LAYOVERS_ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ONE_LAYOVERS_ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TWO_LAYOVERS_ICON; });
var CABIN_CLASS_CATEGORY = 'cabinClass';
var COMPANIES_CATEGORY = 'companies';
var LAYOVERS_CATEGORY = 'layovers';
var TIME_RANGES_CATEGORY = 'timeRanges';
var CABIN_CLASS_ECO = 'ECO';
var CABIN_CLASS_BUSINESS = 'BUSINESS';
var ZERO_LAYOVERS_ICON = 'noStop';
var ONE_LAYOVERS_ICON = '1Stop';
var TWO_LAYOVERS_ICON = '2Stops';

/***/ }),

/***/ "dZwK":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("lDSF");

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ "e/g/":
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__("RVBP"),
    nativeKeys = __webpack_require__("H4OD");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ "f4mQ":
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ "fBdL":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("2K7v"),
    stackClear = __webpack_require__("T26A"),
    stackDelete = __webpack_require__("nkaD"),
    stackGet = __webpack_require__("d9/u"),
    stackHas = __webpack_require__("VGTs"),
    stackSet = __webpack_require__("+Ugr");

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ "fYnN":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ "fflk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDepartureDate; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");



function setDepartureDate(departureDate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DEPARTURE_DATE */ "s"], {
    departureDate: departureDate
  });
}



/***/ }),

/***/ "gvfs":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("sWQB"),
    isLength = __webpack_require__("XSvm");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ "gyFy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("Phb7");


/***/ }),

/***/ "hIZU":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ "hPQF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FACET_QUERY_PARAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return navigateToSearchPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return navigateToResortPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return currentUrlContainsSearchQueryParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return currentUrlHasNoQueryParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getFacetsAsString; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("U2CP");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("sW3P");
/* harmony import */ var _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kNiU");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("Sj1w");
/* harmony import */ var _utils_uri_redirectUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("k9PE");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("nv//");








var FACET_QUERY_PARAMS = [_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DEPARTURE_DATE */ "f"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DURATION */ "g"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_KIDS */ "h"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* QUERY_QUERY_PARAM */ "A"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_TRANSPORT */ "k"]];

var computeQueryParamsForUrl = function computeQueryParamsForUrl(args) {
  var _ref;

  var criteriaKeysToPersist = args.criteriaKeysToPersist,
      searchCriteria = args.searchCriteria;
  var formattedDate = searchCriteria.departureDate && Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_4__[/* getDepartureDateDisplayValue */ "d"])(Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_4__[/* formatDepartureDateForStore */ "a"])(searchCriteria.departureDate, ''));
  var searchQuery = searchCriteria.query ? searchCriteria.query.label : '';
  return _ref = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DEPARTURE_DATE */ "f"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DEPARTURE_DATE */ "f"]) && formattedDate || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DURATION */ "g"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DURATION */ "g"]) && searchCriteria.duration || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_TRANSPORT */ "k"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_TRANSPORT */ "k"]) && searchCriteria.departureCity || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* QUERY_QUERY_PARAM */ "A"], criteriaKeysToPersist.includes(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* QUERY_QUERY_PARAM */ "A"]) && (searchCriteria.keywords || searchQuery) || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_KIDS */ "h"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_KIDS */ "h"]) && searchCriteria.kids.length > 0 && Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_4__[/* serializeKidsToQueryParam */ "g"])({
    kids: searchCriteria.kids,
    kidsValidationState: searchCriteria.kidsValidationState
  }) || undefined), _ref;
};

var navigateToSearchPage = function navigateToSearchPage(args) {
  var criteriaKeysToPersist = args.criteriaKeysToPersist,
      location = args.location,
      searchCriteria = args.searchCriteria,
      searchPageRouteName = args.searchPageRouteName;
  var queryParams = computeQueryParamsForUrl({
    criteriaKeysToPersist: criteriaKeysToPersist,
    searchCriteria: searchCriteria
  }); // NOTE: URI.setQuery() does not remove existing queries

  var searchPageUrl = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_7__[/* convertLocationToURI */ "c"])(location).setQuery(queryParams);
  var previousPathname = searchPageUrl.pathname();
  var pathname = searchPageRouteName ? _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_2__[/* urlPattern */ "b"](searchPageRouteName) : null;

  if (pathname) {
    searchPageUrl.pathname(pathname);
  }

  var isShallow = searchPageUrl.pathname() === previousPathname;
  _utils_uri_redirectUtils__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].redirectTo()(searchPageUrl, {
    shallow: isShallow
  });
};
var navigateToResortPage = function navigateToResortPage(args) {
  var location = args.location,
      query = args.query,
      searchCriteria = args.searchCriteria;
  var queryParams = computeQueryParamsForUrl({
    criteriaKeysToPersist: [_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DEPARTURE_DATE */ "f"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DURATION */ "g"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_TRANSPORT */ "k"]],
    searchCriteria: searchCriteria
  });
  var resortPageUrl = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_7__[/* convertLocationToURI */ "c"])(location).pathname(query.link).setQuery(queryParams);
  _utils_uri_redirectUtils__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].redirectTo()(resortPageUrl);
};
var currentUrlContainsSearchQueryParam = function currentUrlContainsSearchQueryParam(location) {
  return !Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(location.queryParams[_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* QUERY_QUERY_PARAM */ "A"]]);
};
var currentUrlHasNoQueryParams = function currentUrlHasNoQueryParams(location) {
  return FACET_QUERY_PARAMS.every(function (queryKey) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(location.queryParams[queryKey]);
  });
};
var getFacetsAsString = function getFacetsAsString(filters, facetCategoryId) {
  var facetsInCategory = filters.filter(function (filter) {
    return filter.id === facetCategoryId;
  });

  if (facetsInCategory.length === 0) {
    return null;
  }

  return facetsInCategory.map(function (filter) {
    return filter.name;
  }).join('|');
};

/***/ }),

/***/ "hUtE":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("j++8");

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ "hfZn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ABTestContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var ABTestContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext({});

/***/ }),

/***/ "hgS3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductHeader; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");
/* harmony import */ var _frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("VHif");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("i5Mr");
/* harmony import */ var _exclusive_collection_badge_ECBadge__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Itgl");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("MWZw");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;







var ICONS_HEIGHT = 32;
var ProductHeader = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_1__["memo"])(function ProductHeader(props) {
  var badge = props.badge,
      _props$badgeColor = props.badgeColor,
      badgeColor = _props$badgeColor === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].BLUE : _props$badgeColor,
      _props$badgeIcon = props.badgeIcon,
      badgeIcon = _props$badgeIcon === void 0 ? {} : _props$badgeIcon,
      className = props.className,
      hasECLogo = props.hasECLogo,
      _props$heading = props.heading,
      heading = _props$heading === void 0 ? {} : _props$heading,
      isLinkDisabled = props.isLinkDisabled,
      link = props.link;
  var _heading$title = heading.title,
      title = _heading$title === void 0 ? '' : _heading$title,
      _heading$subtitle = heading.subtitle,
      subtitle = _heading$subtitle === void 0 ? '' : _heading$subtitle;
  var TagName = isLinkDisabled ? 'div' : _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"];
  return __jsx("header", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, 'flex')
  }, __jsx(TagName, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    className: "reset-anchor flex w-full z-1 min-w-0",
    "data-testid": "ProductHeader-link"
  }, isLinkDisabled ? null : link), !isLinkDisabled && __jsx("div", {
    className: "absolute inset-0",
    "data-testid": "ProductHeader-link-overlay"
  }), __jsx("div", {
    className: "relative flex-1 flex flex-col-reverse justify-center -mb-px overflow-hidden rtl:pr-1"
  }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_7__[/* Title */ "a"], {
    className: "flex items-center font-brand leading-one text-lg",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].GRAY_DARKER,
    hasEllipsis: true,
    hLevel: 2,
    role: "presentation",
    theme: "none"
  }, title), __jsx("div", {
    className: "flex"
  }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_7__[/* Title */ "a"], {
    className: "flex min-w-0 items-center font-bold font-sans text-sm uppercase tracking-tight",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].GRAY_MEDIUM,
    hasEllipsis: true,
    hLevel: 3,
    role: "presentation",
    theme: "none"
  }, subtitle), !!badge && __jsx("div", {
    "data-testid": "ProductHeader-seasonBadge",
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("bg-".concat(badgeColor), 'leading-one p-1 font-bold uppercase rounded-tiny text-center text-white text-xs whitespace-no-wrap rtl:ml-2')
  }, __jsx("div", {
    className: "-mb-px"
  }, badge))))), __jsx(_frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_4__[/* Badge */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, badgeIcon, {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('rounded-tiny', {
      'rtl:mr-1': hasECLogo
    }),
    size: ICONS_HEIGHT
  })), hasECLogo && __jsx(_exclusive_collection_badge_ECBadge__WEBPACK_IMPORTED_MODULE_6__[/* ECBadge */ "a"], {
    className: "flex-none",
    height: ICONS_HEIGHT,
    iconWidth: "95%"
  }));
});

/***/ }),

/***/ "id+h":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ "igjW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentUri; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isProduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isStrictlyProductionEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isStrictlyStagingEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isStrictlyIntegrationEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isStrictlyTestEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isStrictlyDevelopmentEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentLocale; });
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_2__);



function getCurrentUri(req) {
  return new urijs__WEBPACK_IMPORTED_MODULE_0___default.a(decodeURI(req.originalUrl)).protocol(req.protocol).host(req.get('host'));
}
function isProduction() {
  return _config__WEBPACK_IMPORTED_MODULE_2___default.a.get('DEPLOYMENT_ENV') === 'production';
}
function isStrictlyProductionEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && (cfg.get('DEPLOYMENT_ENV') === 'production' || cfg.get('DEPLOYMENT_ENV') === 'prod');
}
function isStrictlyStagingEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'staging';
}
function isStrictlyIntegrationEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'integration';
}
function isStrictlyTestEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'test';
}
function isStrictlyDevelopmentEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'development' || cfg.get('NODE_ENV') === 'dev';
}
function getCurrentLocale(requestedLocale, hostname) {
  if (requestedLocale) {
    return requestedLocale;
  }

  var domainServiceForHostname = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1___default.a.forHostname(hostname);
  return domainServiceForHostname.getDefaultLocale();
}

/***/ }),

/***/ "imxd":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "j++8":
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__("aZXx");

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ "jD8k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TextLink; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/text-link/TextLink.themes.js

var themes = {
  "default": function _default(_ref) {
    var _ref$color = _ref.color,
        color = _ref$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref$color;
    return {
      thIconWidth: '.7em',
      thRoot: "text-".concat(color, " font-bold font-sans leading-normal text-base focus:underline hover:underline"),
      thLabel: '',
      thIconLeft: 'rtl:mr-2',
      thIconRight: 'rtl:ml-2'
    };
  },
  fancy: function fancy(_ref2) {
    var _ref2$color = _ref2.color,
        color = _ref2$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref2$color;
    return {
      thIconWidth: '0.4375rem',
      thRoot: "text-".concat(color, " font-bold font-sans leading-normal text-sm"),
      thLabel: '',
      thIconLeft: 'rtl:mr-2',
      thIconRight: 'rtl:ml-2'
    };
  },
  solid: function solid(_ref3) {
    var _ref3$color = _ref3.color,
        color = _ref3$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref3$color;
    return {
      thIconWidth: '1em',
      thRoot: "text-".concat(color, " bg-current font-bold font-sans leading-one p-3 rounded-tiny text-base uppercase"),
      thLabel: 'text-white',
      thIconLeft: 'text-white rtl:mr-2',
      thIconRight: 'text-white rtl:ml-2'
    };
  },
  simple: function simple(_ref4) {
    var _ref4$color = _ref4.color,
        color = _ref4$color === void 0 ? colors["a" /* COLORS */].GRAY_DARKER : _ref4$color;
    return {
      thIconWidth: '1em',
      thRoot: "text-".concat(color, " font-sans leading-loose self-start rtl:ml-auto text-base underline"),
      thLabel: '',
      thIconLeft: 'rtl:mr-2',
      thIconRight: 'rtl:ml-2'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx

var __jsx = react_default.a.createElement;







function TextLink(props) {
  var ariaHidden = props.ariaHidden,
      ariaLabel = props.ariaLabel,
      className = props.className,
      color = props.color,
      iconLeftName = props.iconLeftName,
      _props$iconRightName = props.iconRightName,
      iconRightName = _props$iconRightName === void 0 ? icons["a" /* ICONS */].BOLDER_ARROW_FORTH : _props$iconRightName,
      isExternalLink = props.isExternalLink,
      label = props.label,
      onClick = props.onClick,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
      target = props.target,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      trackingData = props.trackingData,
      url = props.url;
  if (!label) return null;

  var _themes$theme = themes[theme]({
    color: color
  }),
      thIconLeft = _themes$theme.thIconLeft,
      thIconRight = _themes$theme.thIconRight,
      thIconWidth = _themes$theme.thIconWidth,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;

  return __jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({
    "aria-hidden": ariaHidden,
    "aria-label": ariaLabel,
    as: url ? DynamicLink["a" /* default */] : 'button',
    className: classnames_default()(className, 'reset-button inline-flex items-center', thRoot),
    onClick: onClick,
    tabIndex: tabIndex,
    target: target,
    trackingData: trackingData
  }, url ? {
    url: url,
    isExternalLink: isExternalLink
  } : {
    type: 'button'
  }), !!iconLeftName && __jsx(Icon["a" /* Icon */], {
    className: thIconLeft,
    hasRtl: true,
    name: iconLeftName,
    width: thIconWidth
  }), __jsx("span", {
    className: thLabel
  }, label), !!iconRightName && __jsx(Icon["a" /* Icon */], {
    className: thIconRight,
    hasRtl: true,
    name: iconRightName,
    width: thIconWidth
  }));
}

/***/ }),

/***/ "jP+d":
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__("5R7x");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "jbji":
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__("w5oF"),
    defineProperty = __webpack_require__("2rns"),
    identity = __webpack_require__("00cE");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ "kD/R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_BOOKING_CART; });
/* unused harmony export getBookingCartQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchBookingCart; });
/* unused harmony export removeService */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateBookingCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateBookingCartSequencially; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateBookingCartAll; });
/* harmony import */ var _store_utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Nhxn");




var FETCH_BOOKING_CART = 'FETCH_BOOKING_CART';
var UPDATE_BOOKING_CART = 'UPDATE_BOOKING_CART';
var cartQuery = "\n    cart {\n        childcares {\n            id\n            productId\n            label\n            type\n            attendees {\n                id\n                price\n            }\n            startDate\n            endDate\n            schedules {\n              startDate\n              endDate\n              attendees {\n                id\n                price\n              }\n            }\n        }\n        transfers {\n          id\n          productId\n          type\n          label\n          schedules {\n            startDate\n            endDate\n            attendees {\n              id\n              price\n            }\n          }\n        }\n        rentals {\n          id\n          productId\n          type\n          schedules {\n            startDate\n            endDate\n            attendees {\n              id\n              price\n            }\n          }\n          attendees {\n            id\n            schedules {\n              price {\n                value\n              }\n              startDate\n              endDate\n            }\n          }\n        }\n        activities {\n          id\n          productId\n          type\n          schedules {\n            startDate\n            endDate\n            attendees {\n              id\n              price\n            }\n          }\n        }\n        pickRoom { \n          id\n          type\n          accommodations {\n            id \n            rooms {\n              id\n            }\n          }\n        }\n        price {\n            total {\n                formattedValue(precision: 2)\n                value\n                currency\n            }\n            currency\n            detail {\n              service\n              amount\n            }\n        }\n        isEmpty\n    }\n";
var getBookingCartQuery = function getBookingCartQuery(bookingId) {
  return "query {\n        userBooking(bookingId : \"".concat(bookingId, "\") {\n          ").concat(cartQuery, "\n        }\n    }");
};
var fetchBookingCart = function fetchBookingCart(stay, context) {
  return function (dispatch) {
    return dispatch(Object(_store_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(FETCH_BOOKING_CART, {
      stay: stay
    }, {
      optimist: true,
      promise: _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runNoCacheQuery(getBookingCartQuery(stay.bookingId), context, {
        requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_GET_BOOKING_CART */ "h"]
      })
    }));
  };
};

var addService = function addService(_ref) {
  var id = _ref.id,
      bookingId = _ref.bookingId,
      schedules = _ref.schedules,
      accommodations = _ref.accommodations,
      serviceName = _ref.serviceName;
  return "mutation {\n            addServiceCart(\n             bookingId : \"".concat(bookingId, "\",\n             serviceCart: {\n                 id: \"").concat(id, "\",\n                 ").concat(schedules ? Object(_utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_3__[/* attributesToString */ "a"])({
    schedules: schedules
  }) : '', "\n                 ").concat(accommodations ? Object(_utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_3__[/* attributesToString */ "a"])({
    accommodations: accommodations
  }) : '', "\n             }\n             serviceName: \"").concat(serviceName, "\") {\n                ").concat(cartQuery, "\n             }\n          }");
};

var removeService = function removeService(id, bookingId) {
  return "mutation {\n              removeServiceCart(\n               bookingId : \"".concat(bookingId, "\",\n               itemId: \"").concat(id, "\")\n               {\n                ").concat(cartQuery, "\n               }\n            }");
};
var updateBookingCart = function updateBookingCart(_ref2) {
  var id = _ref2.id,
      bookingId = _ref2.bookingId,
      schedules = _ref2.schedules,
      accommodations = _ref2.accommodations,
      serviceName = _ref2.serviceName,
      context = _ref2.context,
      action = _ref2.action,
      successMsg = _ref2.successMsg;
  return function (dispatch) {
    return dispatch(Object(_store_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(UPDATE_BOOKING_CART, {
      id: id,
      toastLabel: successMsg
    }, {
      optimist: true,
      promise: _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runNoCacheQuery(action === 'update' ? addService({
        id: id,
        bookingId: bookingId,
        schedules: schedules,
        accommodations: accommodations,
        serviceName: serviceName
      }) : removeService(id, bookingId), context, {
        requestName: action === 'update' ? _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_UPDATE_BOOKING_CART */ "T"] : _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_REMOVE_BOOKING_CART_ITEM */ "Q"]
      })
    }));
  };
};
var updateBookingCartSequencially = function updateBookingCartSequencially(params) {
  if (params.length === 0) {
    return Promise.resolve();
  }

  var _params$ = params[0],
      id = _params$.id,
      bookingId = _params$.bookingId,
      schedules = _params$.schedules,
      accommodations = _params$.accommodations,
      serviceName = _params$.serviceName,
      context = _params$.context,
      action = _params$.action;
  var promise = _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runNoCacheQuery(action === 'update' ? addService({
    id: id,
    bookingId: bookingId,
    schedules: schedules,
    accommodations: accommodations,
    serviceName: serviceName
  }) : removeService(id, bookingId), context, {
    requestName: action === 'update' ? _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_UPDATE_BOOKING_CART */ "T"] : _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_REMOVE_BOOKING_CART_ITEM */ "Q"]
  });
  return promise.then(function () {
    return updateBookingCartSequencially(params.slice(1));
  });
};
var updateBookingCartAll = function updateBookingCartAll(params) {
  return Promise.all(params.map(function (_ref3) {
    var id = _ref3.id,
        bookingId = _ref3.bookingId,
        schedules = _ref3.schedules,
        accommodations = _ref3.accommodations,
        serviceName = _ref3.serviceName,
        context = _ref3.context,
        action = _ref3.action;
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runNoCacheQuery(action === 'update' ? addService({
      id: id,
      bookingId: bookingId,
      schedules: schedules,
      accommodations: accommodations,
      serviceName: serviceName
    }) : removeService(id, bookingId), context, {
      requestName: action === 'update' ? _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_UPDATE_BOOKING_CART */ "T"] : _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_REMOVE_BOOKING_CART_ITEM */ "Q"]
    });
  }));
};

/***/ }),

/***/ "kD1E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getConfigWithNoThirdPartySupport; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_has__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1mr4");
/* harmony import */ var lodash_has__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_has__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_3__);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



 // makes inexact to allow other query params

var shouldIgnoreThirdParty = function shouldIgnoreThirdParty(queryParams) {
  return lodash_has__WEBPACK_IMPORTED_MODULE_1___default()(queryParams, _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["appQueryParameters"].noThirdParty);
};

var appLocaleConfig;
var getConfigWithNoThirdPartySupport = function getConfigWithNoThirdPartySupport(_ref) {
  var name = _ref.name,
      locale = _ref.locale,
      queryParams = _ref.queryParams; // cache if on browser

  if (!appLocaleConfig || false) {
    appLocaleConfig = _config__WEBPACK_IMPORTED_MODULE_3___default.a.locale(locale);
  }

  var originalConfig = appLocaleConfig.get(name);
  return shouldIgnoreThirdParty(queryParams) ? _objectSpread(_objectSpread({}, originalConfig), {}, {
    enabled: false
  }) : originalConfig;
};

/***/ }),

/***/ "kE5G":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("CP21");

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ "kHWL":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("rnJz"),
    isLength = __webpack_require__("XSvm"),
    isObjectLike = __webpack_require__("oS78");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ "kNiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return serializeKidsToQueryParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDepartureDateDisplayValue; });
/* unused harmony export findFacetCategoryById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatDepartureDateForStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getChildcareFacets; });
/* unused harmony export getChildren */
/* unused harmony export getFormattedDepartureDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDepartureCities; });
/* unused harmony export getSelectedDepartureCity */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isDateInThePast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isKidMinor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return unserializeKidsFromQueryParam; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("wQ38");
/* harmony import */ var _uri_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Sj1w");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("sW3P");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}







function findFacetCategoryById(facets, facetCategoryId) {
  return facets.find(function (facetCategory) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(facetCategory, 'id') === facetCategoryId;
  });
}

function _getFacetValues(facets, categoryId) {
  var category = findFacetCategoryById(facets, categoryId);
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(category, 'list', []);
}

function getChildcareFacets(facets) {
  return _getFacetValues(facets, _constants__WEBPACK_IMPORTED_MODULE_5__[/* CHILDCARE_FACET_ID */ "e"]);
}

function getDepartureCities(facets) {
  return _getFacetValues(facets, _constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_CITY_FACET_ID */ "j"]);
}

function getSelectedDepartureCity(facets) {
  var selectedCity = getDepartureCities(facets).find(function (facet) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(facet, 'selected');
  });
  return selectedCity ? Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(selectedCity, 'name') : null;
}

function formatDepartureDateForStore(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants__WEBPACK_IMPORTED_MODULE_5__[/* DATE_FORMAT */ "g"];
  return date !== null ? moment__WEBPACK_IMPORTED_MODULE_2___default()(date, format).valueOf() : null;
}

function getDepartureDateDisplayValue() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var momentDate = moment__WEBPACK_IMPORTED_MODULE_2___default()(date);
  return momentDate.isValid() ? momentDate.format(_constants__WEBPACK_IMPORTED_MODULE_5__[/* DATE_FORMAT */ "g"]) : '';
}

function isDateInThePast(timestampDate) {
  return timestampDate ? moment__WEBPACK_IMPORTED_MODULE_2___default()(timestampDate).isBefore() : false;
}

function getFormattedDepartureDate(date, dateFormat) {
  return date ? moment__WEBPACK_IMPORTED_MODULE_2___default()(date).format(dateFormat) : '';
}

function isKidMinor(birthdate) {
  if (!birthdate) {
    return false;
  }

  var minBirthdate = moment__WEBPACK_IMPORTED_MODULE_2___default()().subtract(18, 'years');
  var momentBirthdate = moment__WEBPACK_IMPORTED_MODULE_2___default()(birthdate);
  return momentBirthdate.isValid() && momentBirthdate.isBetween(minBirthdate, moment__WEBPACK_IMPORTED_MODULE_2___default()());
}

function getChildren(numberOfChildren, childrenBirthdates) {
  if (Number.isInteger(numberOfChildren) && numberOfChildren >= 0 && numberOfChildren <= _constants__WEBPACK_IMPORTED_MODULE_5__[/* KIDS_NUMBER_MAX */ "u"]) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["times"])(numberOfChildren, function (idx) {
      return childrenBirthdates && childrenBirthdates.length > idx ? {
        birthdate: moment__WEBPACK_IMPORTED_MODULE_2___default()(childrenBirthdates[idx], 'YYYYMMDD', true).valueOf(),
        childcareIncluded: false
      } : {
        childcareIncluded: false
      };
    });
  }

  return null;
}

function unserializeKidsFromQueryParam(value) {
  if (!value) return [];
  var kidsNumber = Number(value); // NOTE: DO NOT USE parseInt() !!! parseInt('2010-12-10c') will return 2010 ...

  if (kidsNumber > _constants__WEBPACK_IMPORTED_MODULE_5__[/* KIDS_NUMBER_MAX */ "u"]) {
    return [];
  }

  if (Number.isInteger(kidsNumber)) return new Array(kidsNumber).fill(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__[/* DEFAULT_KID_VALUE */ "a"]));
  var kids = value.split(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_KIDS_DELIMITER */ "i"]).map(function (serializedKidString) {
    var hasChildcareFlag = serializedKidString.substr(-1) === _uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_CHILDCARE_FLAG */ "c"];
    var strBirthdate = serializedKidString.replace(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_CHILDCARE_FLAG */ "c"], '');
    var birthdate = moment__WEBPACK_IMPORTED_MODULE_2___default()(strBirthdate, _uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_DATE_FORMAT */ "e"], true);
    var childcareIncluded = birthdate.isValid() ? hasChildcareFlag : _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__[/* DEFAULT_KID_VALUE */ "a"].childcareIncluded;
    return _objectSpread(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__[/* DEFAULT_KID_VALUE */ "a"]), {}, {
      childcareIncluded: childcareIncluded,
      birthdate: birthdate.isValid() ? birthdate.valueOf() : undefined
    });
  });
  return kids.length > _constants__WEBPACK_IMPORTED_MODULE_5__[/* KIDS_NUMBER_MAX */ "u"] ? [] : kids;
}
/**
 * Helper to serialize kids array as a URI query parameter.
 *
 * Example of returns:
 *
 * - `kids=1` (1 kid, no birthdate)
 * - `kids=2010-10-30` (1 kid, with birthdate)
 * - `kids=_` (2 kids)
 * - `kids=2010-10-30=_` (2 kids, 1 birthdate)
 * - `kids=2010-10-30c=___`
 * - `kids=2010-10-30c_2009-04-01!`
 */


var serializeKidsToQueryParam = function serializeKidsToQueryParam(params) {
  var kids = params.kids,
      kidsValidationState = params.kidsValidationState;
  var serializedKids = kids.map(function (_ref, index) {
    var birthdate = _ref.birthdate,
        childcareIncluded = _ref.childcareIncluded;

    if (!kidsValidationState || kidsValidationState[index] !== _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__[/* VALIDATION_STATE_ENUM */ "f"].valid) {
      return '';
    }

    var formattedBirthdate = moment__WEBPACK_IMPORTED_MODULE_2___default()(birthdate).format(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_DATE_FORMAT */ "e"]);

    if (childcareIncluded) {
      return "".concat(formattedBirthdate).concat(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_CHILDCARE_FLAG */ "c"]);
    }

    return formattedBirthdate;
  }).filter(function (birthdate) {
    return birthdate !== '';
  });
  return serializedKids.join(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_KIDS_DELIMITER */ "i"]);
};


/***/ }),

/***/ "kWb8":
/***/ (function(module) {

module.exports = JSON.parse("{\"Aacute\":\"Á\",\"aacute\":\"á\",\"Acirc\":\"Â\",\"acirc\":\"â\",\"acute\":\"´\",\"AElig\":\"Æ\",\"aelig\":\"æ\",\"Agrave\":\"À\",\"agrave\":\"à\",\"amp\":\"&\",\"AMP\":\"&\",\"Aring\":\"Å\",\"aring\":\"å\",\"Atilde\":\"Ã\",\"atilde\":\"ã\",\"Auml\":\"Ä\",\"auml\":\"ä\",\"brvbar\":\"¦\",\"Ccedil\":\"Ç\",\"ccedil\":\"ç\",\"cedil\":\"¸\",\"cent\":\"¢\",\"copy\":\"©\",\"COPY\":\"©\",\"curren\":\"¤\",\"deg\":\"°\",\"divide\":\"÷\",\"Eacute\":\"É\",\"eacute\":\"é\",\"Ecirc\":\"Ê\",\"ecirc\":\"ê\",\"Egrave\":\"È\",\"egrave\":\"è\",\"ETH\":\"Ð\",\"eth\":\"ð\",\"Euml\":\"Ë\",\"euml\":\"ë\",\"frac12\":\"½\",\"frac14\":\"¼\",\"frac34\":\"¾\",\"gt\":\">\",\"GT\":\">\",\"Iacute\":\"Í\",\"iacute\":\"í\",\"Icirc\":\"Î\",\"icirc\":\"î\",\"iexcl\":\"¡\",\"Igrave\":\"Ì\",\"igrave\":\"ì\",\"iquest\":\"¿\",\"Iuml\":\"Ï\",\"iuml\":\"ï\",\"laquo\":\"«\",\"lt\":\"<\",\"LT\":\"<\",\"macr\":\"¯\",\"micro\":\"µ\",\"middot\":\"·\",\"nbsp\":\" \",\"not\":\"¬\",\"Ntilde\":\"Ñ\",\"ntilde\":\"ñ\",\"Oacute\":\"Ó\",\"oacute\":\"ó\",\"Ocirc\":\"Ô\",\"ocirc\":\"ô\",\"Ograve\":\"Ò\",\"ograve\":\"ò\",\"ordf\":\"ª\",\"ordm\":\"º\",\"Oslash\":\"Ø\",\"oslash\":\"ø\",\"Otilde\":\"Õ\",\"otilde\":\"õ\",\"Ouml\":\"Ö\",\"ouml\":\"ö\",\"para\":\"¶\",\"plusmn\":\"±\",\"pound\":\"£\",\"quot\":\"\\\"\",\"QUOT\":\"\\\"\",\"raquo\":\"»\",\"reg\":\"®\",\"REG\":\"®\",\"sect\":\"§\",\"shy\":\"­\",\"sup1\":\"¹\",\"sup2\":\"²\",\"sup3\":\"³\",\"szlig\":\"ß\",\"THORN\":\"Þ\",\"thorn\":\"þ\",\"times\":\"×\",\"Uacute\":\"Ú\",\"uacute\":\"ú\",\"Ucirc\":\"Û\",\"ucirc\":\"û\",\"Ugrave\":\"Ù\",\"ugrave\":\"ù\",\"uml\":\"¨\",\"Uuml\":\"Ü\",\"uuml\":\"ü\",\"Yacute\":\"Ý\",\"yacute\":\"ý\",\"yen\":\"¥\",\"yuml\":\"ÿ\"}");

/***/ }),

/***/ "kWbI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useTrackQueryChange; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _context_pageContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("RPju");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("sRdV");
/* harmony import */ var _tracking_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("zwLB");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var useTrackQueryChange = function useTrackQueryChange() {
  var pageContext = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(_context_pageContext__WEBPACK_IMPORTED_MODULE_2__[/* ReactPageContext */ "a"]);
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_3__[/* useTracking */ "a"])();

  var executeTracking = function executeTracking(query, payload) {
    if (query) {
      var isFromAutoComplete = Boolean(query.type);
      track(_objectSpread({
        categoryGA: pageContext.pageId,
        actionGA: 'search',
        labelGA: Object(_tracking_utils__WEBPACK_IMPORTED_MODULE_4__[/* getSearchMappedTypeForLabelGA */ "c"])(query.type),
        internalSearchEngineNbResults: '',
        searchReferrer: pageContext.pageId,
        searchRequestType: isFromAutoComplete ? 'Autocomplete' : 'Nocomplete',
        searchTerms: query.label || null
      }, payload));
    }
  };

  return executeTracking;
};

/***/ }),

/***/ "l5FB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["a"] = (/*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_0__["createContext"])({
  departureCities: [],
  setDepartureCities: function setDepartureCities() {}
}));

/***/ }),

/***/ "lBGg":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("4Db7");

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ "lDSF":
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__("1KeW"),
    getValue = __webpack_require__("f4mQ");

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ "lEjn":
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__("CATK"),
    baseUnary = __webpack_require__("id+h"),
    nodeUtil = __webpack_require__("2LZg");

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ "lZQm":
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__("N9he"),
    isObjectLike = __webpack_require__("oS78");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ "loSl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return toggleFacet; });
/* unused harmony export changeKids */
/* unused harmony export changeKidsNumberWith */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeKidsNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeDepartureCity; });
/* unused harmony export changeDepartureDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clearDepartureDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setSearchQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return clearTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeSearchQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setInitialProductPrices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setKidsValidationState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return clearFacets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return resetRedirection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return resetSearch; });
/* unused harmony export setFilters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return updateFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return resetCriteria; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return resetCalendarCriteria; });
/* unused harmony export setIsDateRequired */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setIsSearchEnabled; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("uDfI");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("rJ95");
/* harmony import */ var _search_query_searchQuery_action__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("0ibg");
/* harmony import */ var _search_search_selector__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("B3yO");
/* harmony import */ var _trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("wQ38");
/* harmony import */ var _trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("1bWg");
/* harmony import */ var _trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("fflk");
/* harmony import */ var _trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("+mhw");
/* harmony import */ var _trip_date_criteria_tripDateCriteria_action__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("6wD6");
/* harmony import */ var _trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("C5R2");
/* harmony import */ var _trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("RBvG");
/* harmony import */ var _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("Jsmy");
/* harmony import */ var _faceting_selector__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("vIa8");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("9QcM");





function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

















function setActiveFacet(categoryId, value, isSelected) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_TOGGLE_FACET_SELECTED */ "o"], {
    categoryId: categoryId,
    value: value,
    isSelected: isSelected
  });
}

function toggleFacet(_ref) {
  var categoryId = _ref.categoryId,
      isSelected = _ref.isSelected,
      value = _ref.value;
  return setActiveFacet(categoryId, value, isSelected);
}
function changeKids(value) {
  return function (dispatch, getState) {
    var oldKids = Object(_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_16__[/* getKids */ "c"])(getState());
    var newKids = value.map(function (kid, index) {
      return _objectSpread(_objectSpread({}, kid), {}, {
        neolid: Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(oldKids, "[".concat(index, "].neolid"))
      });
    });
    return dispatch(Object(_trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_10__[/* setKids */ "b"])(newKids));
  };
}

function _changeKidsSize(kids, newSize) {
  var emptyKids = Object(lodash__WEBPACK_IMPORTED_MODULE_4__["times"])(newSize - kids.length, function () {
    return _objectSpread({}, _trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_9__[/* DEFAULT_KID_VALUE */ "a"]);
  });

  if (newSize < kids.length) {
    return kids.slice(0, newSize);
  }

  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(kids), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(emptyKids));
} // use this export when testing.


var changeKidsNumberWith = function changeKidsNumberWith(changeKidsFunc) {
  return function changeKidsNumber(value) {
    return function (dispatch, getState) {
      var kids = Object(_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_16__[/* getKids */ "c"])(getState());

      var newKids = _changeKidsSize(kids, value);

      return dispatch(changeKidsFunc(newKids));
    };
  };
}; // use this export in app code.

var changeKidsNumber = changeKidsNumberWith(changeKids);
function changeDepartureCity(value) {
  return Object(_trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_12__[/* setDepartureCity */ "a"])({
    value: value
  });
}
function changeDepartureDate(_ref2) {
  var value = _ref2.value;
  return Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_11__[/* setDepartureDate */ "a"])(value);
}
var clearDepartureDate = function clearDepartureDate() {
  return Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_11__[/* setDepartureDate */ "a"])(null);
};
var setSearchQuery = function setSearchQuery() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    label: ''
  };
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_SEARCH_QUERY */ "n"], {
    value: query
  });
};
function clearTripDuration() {
  return Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_14__[/* setDuration */ "a"])(_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEFAULT_NO_DURATION */ "a"]);
}
function changeSearchQuery(value) {
  return function (dispatch, getState) {
    var store = getState();
    var keywords = Object(_search_search_selector__WEBPACK_IMPORTED_MODULE_8__[/* keywordsSelector */ "a"])(store);
    var searchQuery = Object(_faceting_selector__WEBPACK_IMPORTED_MODULE_17__[/* searchQuerySelector */ "m"])(getState());
    Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* batch */ "b"])(function () {
      if (keywords) {
        dispatch(Object(_search_query_searchQuery_action__WEBPACK_IMPORTED_MODULE_7__[/* setKeywords */ "a"])(''));
      }

      if (searchQuery.label !== value.label) {
        dispatch(setSearchQuery(value));
      }
    });
  };
}
function changeTripDuration(value) {
  return Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_14__[/* setDuration */ "a"])(value);
}
function setInitialProductPrices(initialProductPrices) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_INITIAL_PRICES */ "i"], {
    initialProductPrices: initialProductPrices
  });
}
function setKidsValidationState(kidsValidationState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_KIDS_VALIDATION_STATE */ "l"], {
    kidsValidationState: kidsValidationState
  });
}
function clearFacets(categoryId) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_CLEAR_FACETS */ "b"], {
    categoryId: categoryId
  });
}
function resetRedirection() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_RESET_REDIRECTION */ "e"]);
}
function resetSearch() {
  return /*#__PURE__*/function () {
    var _ref3 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(dispatch) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_RESET_SEARCH */ "f"])));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
}
function setFilters(filters) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_FILTERS */ "h"], {
    filters: filters
  });
}
function updateFilters(filters) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_UPDATE_FILTERS */ "r"], {
    filters: filters
  });
}
function resetCriteria() {
  return /*#__PURE__*/function () {
    var _ref4 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee2(dispatch) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* batch */ "b"])(function () {
                dispatch(Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_11__[/* setDepartureDate */ "a"])(null));
                dispatch(Object(_trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_12__[/* setDepartureCity */ "a"])({
                  value: null
                }));
                dispatch(Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_14__[/* setDuration */ "a"])(_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEFAULT_NO_DURATION */ "a"]));
                dispatch(updateFilters([]));
                dispatch(setSearchQuery({
                  label: ''
                }));
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
}
function resetCalendarCriteria() {
  return /*#__PURE__*/function () {
    var _ref5 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee3(dispatch) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* batch */ "b"])(function () {
                dispatch(Object(_trip_date_criteria_tripDateCriteria_action__WEBPACK_IMPORTED_MODULE_13__[/* updateTripDateCriteria */ "a"])({
                  day: null
                }));
                dispatch(Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_11__[/* setDepartureDate */ "a"])(null));
                dispatch(Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_14__[/* setDuration */ "a"])(_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEFAULT_NO_DURATION */ "a"]));
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }();
}
function setIsDateRequired(isDateRequired) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_IS_DATE_REQUIRED */ "j"], {
    isDateRequired: isDateRequired
  });
}
function setIsSearchEnabled(isSearchEnabled) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_IS_SEARCH_ENABLED */ "k"], {
    isSearchEnabled: isSearchEnabled
  });
}

/***/ }),

/***/ "lxRQ":
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__("00cE"),
    overRest = __webpack_require__("JYyW"),
    setToString = __webpack_require__("/NZD");

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ "ngAq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useDebounce; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
 // Our hook

function useDebounce(values, delay) {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(values),
      debouncedValue = _useState[0],
      setDebouncedValue = _useState[1];

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    var handler = setTimeout(function () {
      setDebouncedValue(values);
    }, delay);
    return function () {
      clearTimeout(handler);
    };
  }, values);
  return debouncedValue;
}

/***/ }),

/***/ "nkaD":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ "nz94":
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ "oG87":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorBoundary; });
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _errors_clientErrorHandler__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("aPQG");






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }



var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(ErrorBoundary, _React$Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(ErrorBoundary, [{
    key: "componentDidCatch",
    // eslint-disable-next-line class-methods-use-this
    value: function componentDidCatch(error, info) {
      Object(_errors_clientErrorHandler__WEBPACK_IMPORTED_MODULE_6__[/* handleComponentError */ "a"])(error, info);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError && !this.props.useNativeErrorHandling) {
        return null;
      }

      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundary;
}(react__WEBPACK_IMPORTED_MODULE_5___default.a.Component);

/***/ }),

/***/ "oS78":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "oS9k":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ "oW49":
/***/ (function(module, exports, __webpack_require__) {

var entityMap = __webpack_require__("8PLQ"),
    legacyMap = __webpack_require__("kWb8"),
    xmlMap    = __webpack_require__("ZLJe"),
    decodeCodePoint = __webpack_require__("cHMM");

var decodeXMLStrict  = getStrictDecoder(xmlMap),
    decodeHTMLStrict = getStrictDecoder(entityMap);

function getStrictDecoder(map){
	var keys = Object.keys(map).join("|"),
	    replace = getReplacer(map);

	keys += "|#[xX][\\da-fA-F]+|#\\d+";

	var re = new RegExp("&(?:" + keys + ");", "g");

	return function(str){
		return String(str).replace(re, replace);
	};
}

var decodeHTML = (function(){
	var legacy = Object.keys(legacyMap)
		.sort(sorter);

	var keys = Object.keys(entityMap)
		.sort(sorter);

	for(var i = 0, j = 0; i < keys.length; i++){
		if(legacy[j] === keys[i]){
			keys[i] += ";?";
			j++;
		} else {
			keys[i] += ";";
		}
	}

	var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
	    replace = getReplacer(entityMap);

	function replacer(str){
		if(str.substr(-1) !== ";") str += ";";
		return replace(str);
	}

	//TODO consider creating a merged map
	return function(str){
		return String(str).replace(re, replacer);
	};
}());

function sorter(a, b){
	return a < b ? 1 : -1;
}

function getReplacer(map){
	return function replace(str){
		if(str.charAt(1) === "#"){
			if(str.charAt(2) === "X" || str.charAt(2) === "x"){
				return decodeCodePoint(parseInt(str.substr(3), 16));
			}
			return decodeCodePoint(parseInt(str.substr(2), 10));
		}
		return map[str.slice(1, -1)];
	};
}

module.exports = {
	XML: decodeXMLStrict,
	HTML: decodeHTML,
	HTMLStrict: decodeHTMLStrict
};

/***/ }),

/***/ "oZU8":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("CP21");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ "ogu6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOAD_RESORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOADING_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOADING_RESORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LOAD_SELECTABLE_ROOMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOADING_SELECTABLE_ROOMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPLETE_INTRO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_ROOM_SELECTION_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SELECT_BUILDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SELECT_FLOOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SELECT_ROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HIGHLIGHT_ROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CUSTOMER_FIDELITY_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return reducer; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("m0zD");
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_logger__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_widgets_cart_bookingCart_reducer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("xl1w");



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var initialState = {
  completedIntro: false,
  resort: null,
  stayWithVendor: null,
  selectableRooms: [],
  selectableRoomsUnitPrice: null,
  currentSelectedRoomIndex: null,
  currentSelectableRoomIds: [],
  currentSelectableFloorIds: [],
  currentSelectableBuildingIds: [],
  filteredBuildings: [],
  selectedBuildingId: null,
  filteredFloors: [],
  selectedFloorId: null,
  filteredRoomsForCurrentFloor: [],
  filteredRooms: [],
  selectedRooms: [],
  numRoomsLeftToPick: null,
  highlightedRoom: null,
  isLoadingResort: false,
  isLoadingSelectableRooms: false,
  resortPYRMail: null,
  errors: null,
  roomsInCart: []
};
var LOAD_RESORT = 'LOAD_RESORT';
var LOADING_ERROR = 'LOADING_ERROR';
var LOADING_RESORT = 'LOADING_RESORT';
var LOAD_SELECTABLE_ROOMS = 'LOAD_SELECTABLE_ROOMS';
var LOADING_SELECTABLE_ROOMS = 'LOADING_SELECTABLE_ROOMS';
var COMPLETE_INTRO = 'COMPLETE_INTRO';
var SET_ROOM_SELECTION_INDEX = 'SET_ROOM_SELECTION_INDEX';
var SELECT_BUILDING = 'SELECT_BUILDING';
var SELECT_FLOOR = 'SELECT_FLOOR';
var SELECT_ROOM = 'SELECT_ROOM';
var HIGHLIGHT_ROOM = 'HIGHLIGHT_ROOM';
var CUSTOMER_FIDELITY_STATUS = 'CUSTOMER_FIDELITY_STATUS';

function getResortFeatures(state) {
  return state.resort && state.resort.rooms_geo_json.features || [];
}

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case CUSTOMER_FIDELITY_STATUS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          fidelityStatus: action.payload
        });
      }

    case LOADING_RESORT:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingResort: true
        });
      }

    case LOADING_ERROR:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingResort: false
        });
      }

    case LOAD_RESORT:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          resort: action.payload,
          isLoadingResort: false
        });
      }

    case LOADING_SELECTABLE_ROOMS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingSelectableRooms: true
        });
      }

    case LOAD_SELECTABLE_ROOMS:
      {
        var _action$payload = action.payload,
            stayWithVendor = _action$payload.stayWithVendor,
            roomSelectionServices = _action$payload.roomSelectionServices,
            errors = _action$payload.errors,
            resortPYRMail = _action$payload.resortPYRMail;
        var selectableRooms = (roomSelectionServices || []).reduce(function (acc, roomSelectionService) {
          return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(acc), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(new Array(roomSelectionService.quantity).fill(_objectSpread(_objectSpread({}, roomSelectionService.accommodations[0]), {}, {
            _serviceId: roomSelectionService.id,
            _unitPrice: roomSelectionService.unit_price
          }))));
        }, []);

        if (state.roomsInCart.length > 0) {
          var selectedRooms = state.roomsInCart.map(function (roomId) {
            return getResortFeatures(state).find(function (geoRoom) {
              return geoRoom.properties.id === roomId;
            });
          });
          return _objectSpread(_objectSpread({}, state), {}, {
            isLoadingSelectableRooms: false,
            stayWithVendor: stayWithVendor,
            selectableRooms: selectableRooms,
            errors: errors,
            resortPYRMail: resortPYRMail,
            selectedRooms: selectedRooms,
            numRoomsLeftToPick: selectableRooms.length - selectedRooms.length,
            highlightedRoom: null
          });
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingSelectableRooms: false,
          stayWithVendor: stayWithVendor,
          selectableRooms: selectableRooms,
          numRoomsLeftToPick: selectableRooms.length,
          errors: errors,
          resortPYRMail: resortPYRMail
        });
      }

    case COMPLETE_INTRO:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          completedIntro: true
        });
      }

    case SET_ROOM_SELECTION_INDEX:
      {
        var roomIndex = action.payload.roomIndex;
        var features = getResortFeatures(state);

        if (typeof roomIndex === 'undefined' || roomIndex === null) {
          return _objectSpread(_objectSpread({}, state), {}, {
            currentSelectedRoomIndex: null,
            currentSelectableRoomIds: [],
            currentSelectableFloorIds: [],
            currentSelectableBuildingIds: [],
            filteredBuildings: [],
            selectedBuildingId: null,
            filteredFloors: [],
            selectedFloorId: null,
            filteredRoomsForCurrentFloor: [],
            filteredRooms: []
          });
        }

        var isRoomSelected = function isRoomSelected(roomId) {
          return state.selectedRooms.some(function (selectedRoomItem) {
            return selectedRoomItem && selectedRoomItem.properties.id === roomId;
          });
        }; // collect all ids for the current selectable room


        var currentSelectableRoomIds = state.selectableRooms[roomIndex].rooms.map(function (room) {
          return room.id;
        }).filter(function (roomId) {
          return !isRoomSelected(roomId);
        }); // collect properties and geometries for those rooms

        var currentSelectableRooms = features.filter(function (room) {
          return currentSelectableRoomIds.indexOf(room.properties.id) > -1;
        }); // collect properties and geometries for those rooms
        // $FlowFixMe

        var currentSelectableFloorIds = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["uniq"])(currentSelectableRooms.map(function (room) {
          return room.properties.floor_id;
        })); // collect all building ids that contain those floors
        // $FlowFixMe

        var currentSelectableBuildingIds = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["uniq"])((state.resort && state.resort.floors || []).filter(function (floor) {
          return currentSelectableFloorIds.indexOf(floor.id) > -1;
        }).map(function (floor) {
          return floor.building_id;
        }));
        var filteredBuildings = (state.resort && state.resort.buildings || []).filter(function (building) {
          return currentSelectableBuildingIds.indexOf(building.id) > -1;
        });

        if (filteredBuildings.length === 0) {
          _logger__WEBPACK_IMPORTED_MODULE_3___default.a.warn('SET_ROOM_SELECTION_INDEX no building found for building.id', 'currentSelectableBuildingIds:', currentSelectableBuildingIds, 'state.resort.buildings:', state.resort && state.resort.buildings);
          _logger__WEBPACK_IMPORTED_MODULE_3___default.a.warn('currentSelectableBuildingIds:', currentSelectableBuildingIds, 'currentSelectableFloorIds:', currentSelectableFloorIds, 'currentSelectableRooms:', currentSelectableRooms, 'currentSelectableRoomIds:', currentSelectableRoomIds);
        }

        var filteredRooms = features.filter(function (room) {
          return currentSelectableRoomIds.indexOf(room.properties.id) > -1;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          currentSelectedRoomIndex: roomIndex,
          currentSelectableRoomIds: currentSelectableRoomIds,
          currentSelectableFloorIds: currentSelectableFloorIds,
          currentSelectableBuildingIds: currentSelectableBuildingIds,
          filteredBuildings: filteredBuildings,
          selectedBuildingId: null,
          filteredFloors: [],
          selectedFloorId: null,
          filteredRoomsForCurrentFloor: [],
          filteredRooms: filteredRooms
        });
      }

    case SELECT_BUILDING:
      {
        var buildingId = action.payload.buildingId;
        var filteredFloors = (state.resort && state.resort.floors || []).filter(function (floor) {
          return state.currentSelectableFloorIds.indexOf(floor.id) > -1 && floor.building_id === buildingId;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedBuildingId: buildingId,
          filteredFloors: filteredFloors
        });
      }

    case SELECT_FLOOR:
      {
        var floorId = action.payload.floorId;
        var filteredRoomsForCurrentFloor = getResortFeatures(state).filter(function (room) {
          return state.currentSelectableRoomIds.indexOf(room.properties.id) > -1 && room.properties.floor_id === floorId;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedFloorId: floorId,
          filteredRoomsForCurrentFloor: filteredRoomsForCurrentFloor
        });
      }

    case SELECT_ROOM:
      {
        var roomId = action.payload.roomId;

        var selectedRoom = _objectSpread({}, getResortFeatures(state).find(function (geoRoom) {
          return geoRoom.properties.id === roomId;
        }));

        var _selectedRooms = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(state.selectedRooms);

        if (state.currentSelectedRoomIndex || state.currentSelectedRoomIndex === 0) {
          _selectedRooms[state.currentSelectedRoomIndex] = selectedRoom;
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          selectedRooms: _selectedRooms,
          numRoomsLeftToPick: state.selectableRooms.length - _selectedRooms.filter(function (r) {
            return r !== undefined;
          }).length,
          highlightedRoom: null
        });
      }

    case HIGHLIGHT_ROOM:
      {
        var _roomId = action.payload.roomId;
        var highlightedRoom = _roomId === undefined ? null : _objectSpread({}, getResortFeatures(state).find(function (room) {
          return room.properties.id === _roomId;
        }));
        return _objectSpread(_objectSpread({}, state), {}, {
          highlightedRoom: highlightedRoom
        });
      }

    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_4__["resolve"])(_components_widgets_cart_bookingCart_reducer__WEBPACK_IMPORTED_MODULE_5__[/* FETCH_BOOKING_CART */ "a"]):
      {
        var payload = action.payload;
        var roomIds = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(payload, 'userBooking.cart.pickRoom', []).reduce(function (acc, srv) {
          return acc.concat(srv.accommodations.reduce(function (r, a) {
            return r.concat(a.rooms.map(function (_ref) {
              var id = _ref.id;
              return id;
            }));
          }, []));
        }, []);

        if (getResortFeatures(state).length === 0) {
          return _objectSpread(_objectSpread({}, state), {}, {
            roomsInCart: roomIds
          });
        } else {
          var _selectedRooms2 = roomIds.map(function (roomId) {
            return getResortFeatures(state).find(function (geoRoom) {
              return geoRoom.properties.id === roomId;
            });
          });

          return _objectSpread(_objectSpread({}, state), {}, {
            selectedRooms: _selectedRooms2,
            numRoomsLeftToPick: state.selectableRooms.length - _selectedRooms2.length,
            highlightedRoom: null
          });
        }
      }

    default:
      {
        return state;
      }
  }
}

/***/ }),

/***/ "ojcf":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("pfIK"),
    baseAssignValue = __webpack_require__("Ky/o");

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ "okv5":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("jP+d");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("EIeC")(module)))

/***/ }),

/***/ "olhj":
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__("HvnH"),
    isObject = __webpack_require__("Q7Yi");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ "p7XS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ SidePanel_SidePanel; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__("pKEY");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-focus-on/dist/es2015/Combination.js + 8 modules
var Combination = __webpack_require__("Qt1m");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-focus-lock/dist/es2015/AutoFocusInside.js
var AutoFocusInside = __webpack_require__("JPie");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/body-locker/BodyLocker.jsx
var BodyLocker = __webpack_require__("DHMe");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// CONCATENATED MODULE: ./src/client/components/frameworks/side-panel/SidePanel.themes.js
var themes = {
  "default": {
    thRoot: 'bg-white',
    thCloseButton: 'reset-button bg-white cursor-pointer leading-none m-5 p-4 rounded-full text-gray-darker text-md',
    thCloseButtonLabel: 'a11y'
  }
};
var POSITIONS_CLASSES = {
  top: {
    pin: 'inset-x-0 top-0',
    transform: '-translate-y-100',
    style: {
      maxHeight: 'calc(100% - 100px)'
    },
    button: 'bottom-0 rtl:right-0 rtl:slideInRight'
  },
  bottom: {
    pin: 'inset-x-0 bottom-0',
    transform: 'translate-y-100',
    style: {
      maxHeight: 'calc(100% - 100px)'
    },
    button: 'top-0 rtl:right-0 rtl:slideInRight'
  },
  left: {
    pin: 'inset-y-0 left-0',
    transform: '-translate-x-100',
    style: {
      maxWidth: 'calc(100vw - 100px)'
    },
    button: 'top-0 right-0'
  },
  right: {
    pin: 'inset-y-0 right-0',
    transform: 'translate-x-100',
    style: {
      maxWidth: 'calc(100vw - 100px)'
    },
    button: 'top-0 left-0'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/side-panel/SidePanel.jsx

var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var SidePanel_SidePanel = function SidePanel(_ref) {
  var _classnames;

  var ariaLabel = _ref.ariaLabel,
      ariaLabelledby = _ref.ariaLabelledby,
      _ref$backdropColor = _ref.backdropColor,
      backdropColor = _ref$backdropColor === void 0 ? '#000' : _ref$backdropColor,
      _ref$backdropOpacity = _ref.backdropOpacity,
      backdropOpacity = _ref$backdropOpacity === void 0 ? 0.8 : _ref$backdropOpacity,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      height = _ref.height,
      isExpanded = _ref.isExpanded,
      onClose = _ref.onClose,
      _ref$portalName = _ref.portalName,
      portalName = _ref$portalName === void 0 ? Portal_constants["d" /* OVER_BOT */] : _ref$portalName,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottom' : _ref$position,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var sidePanelBodyref = Object(react["useRef"])();
  var onScroll = Object(lodash["throttle"])(function () {
    Object(lib["forceCheck"])();
  }, 250);
  Object(react["useEffect"])(function () {
    // $FlowFixMe
    sidePanelBodyref && sidePanelBodyref.current && sidePanelBodyref.current.addEventListener('scroll', onScroll);
    return function () {
      // $FlowFixMe
      sidePanelBodyref && sidePanelBodyref.current && sidePanelBodyref.current.removeEventListener('scroll', onScroll);
    };
  }, []);
  Object(react["useEffect"])(function () {
    if (isExpanded) {
      Object(lib["forceCheck"])();
    }
  }, [isExpanded]);

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thCloseButton = _themes$theme.thCloseButton,
      thCloseButtonLabel = _themes$theme.thCloseButtonLabel,
      thRoot = _themes$theme.thRoot;
  var positionClasses = POSITIONS_CLASSES[position];
  var closeBtnSidePanel = closeLabel && ariaLabel ? [closeLabel, ariaLabel].join(' ') : closeLabel;
  return __jsx(Portal["a" /* default */], {
    name: portalName
  }, __jsx(BodyLocker["a" /* BodyLocker */], {
    isLocked: isExpanded
  }, isExpanded && __jsx("div", {
    className: "fadeIn fixed h-screen inset-0",
    "data-testid": "SidePanel-backdrop",
    style: {
      backgroundColor: backdropColor,
      opacity: backdropOpacity
    }
  }), __jsx("div", {
    "aria-hidden": !isExpanded,
    "aria-label": ariaLabelledby ? null : ariaLabel,
    "aria-labelledby": ariaLabelledby,
    role: "dialog"
  }, __jsx("div", {
    role: "document"
  }, __jsx(Combination["a" /* FocusOn */], {
    allowPinchZoom: true,
    enabled: isExpanded,
    onClickOutside: onClose,
    onEscapeKey: onClose
  }, isExpanded && __jsx(AutoFocusInside["a" /* default */], null, __jsx("button", {
    className: classnames_default()('fixed z-2', thCloseButton, positionClasses.button),
    onClick: onClose,
    type: "button"
  }, closeBtnSidePanel && __jsx("span", {
    className: thCloseButtonLabel
  }, closeBtnSidePanel), __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "1em"
  }))), __jsx("aside", {
    className: classnames_default()(className, thRoot, positionClasses.pin, 'fixed h-full overflow-y-scroll transition-all w-full z-1', (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, positionClasses.transform, !isExpanded), Object(defineProperty["a" /* default */])(_classnames, 'translate-0', isExpanded), _classnames)),
    ref: sidePanelBodyref,
    style: _objectSpread({
      height: height
    }, positionClasses.style)
  }, isExpanded && children))))));
};

/***/ }),

/***/ "p9RO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLegalInformationTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return trackForYouClub; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return onCheckboxChange; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("d1HQ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);




var findLegalInformation = function findLegalInformation(ref, legalInformations) {
  return legalInformations && legalInformations.find(function (_ref) {
    var legalInfoRef = _ref.ref;
    return legalInfoRef === ref;
  });
};

var getLegalInformationTitle = function getLegalInformationTitle(ref, legalInformations) {
  return (findLegalInformation(ref, legalInformations) || {}).title || ref;
};
var trackForYouClub = function trackForYouClub(context) {
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_1__[/* setDataLayer */ "b"]({
    event: 'eventGA',
    categoryGA: 'PLE',
    actionGA: 'CTA_optin_foryouclub',
    labelGA: 'profilePage'
  }, context);
};
var CLUBMED = 'CLUBMED';
var PARTNERS = 'PARTNERS';
var FOSUN_PARTNERS = 'FOSUN_PARTNERS';
var FORYOUCLUB = 'FORYOUCLUB';
function onCheckboxChange(checkbox, setFieldValue) {
  var _fields;

  var fields = (_fields = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_fields, CLUBMED, {
    checked: [CLUBMED],
    unchecked: [CLUBMED, PARTNERS]
  }), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_fields, PARTNERS, {
    checked: [CLUBMED, PARTNERS],
    unchecked: [PARTNERS]
  }), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_fields, FOSUN_PARTNERS, {
    checked: [FOSUN_PARTNERS],
    unchecked: [FOSUN_PARTNERS]
  }), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_fields, FORYOUCLUB, {
    checked: [FORYOUCLUB],
    unchecked: [FORYOUCLUB]
  }), _fields);

  if (checkbox.checked) {
    Object(lodash__WEBPACK_IMPORTED_MODULE_2__["difference"])(fields[checkbox.name].checked, [checkbox.name]).map(function (id) {
      return setFieldValue(id, true);
    });
  } else {
    Object(lodash__WEBPACK_IMPORTED_MODULE_2__["difference"])(fields[checkbox.name].unchecked, [checkbox.name]).map(function (id) {
      return setFieldValue(id, false);
    });
  }
}

/***/ }),

/***/ "pFHV":
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__("JU27"),
    mapCacheDelete = __webpack_require__("CGZ2"),
    mapCacheGet = __webpack_require__("Bio+"),
    mapCacheHas = __webpack_require__("hUtE"),
    mapCacheSet = __webpack_require__("C8zB");

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ "pPFN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isRegexp = __webpack_require__("1dAi");
var isPlainObj = __webpack_require__("I8qj");

module.exports = function (val, opts, pad) {
	var seen = [];

	return (function stringify(val, opts, pad) {
		opts = opts || {};
		opts.indent = opts.indent || '\t';
		pad = pad || '';
		var tokens;
		if(opts.inlineCharacterLimit == void 0) {
			tokens = {
				newLine: '\n',
				newLineOrSpace: '\n',
				pad: pad,
				indent: pad + opts.indent
			};
		} else {
			tokens = {
				newLine: '@@__STRINGIFY_OBJECT_NEW_LINE__@@',
				newLineOrSpace: '@@__STRINGIFY_OBJECT_NEW_LINE_OR_SPACE__@@',
				pad: '@@__STRINGIFY_OBJECT_PAD__@@',
				indent: '@@__STRINGIFY_OBJECT_INDENT__@@'
			}
		}
		var expandWhiteSpace = function(string) {
			if (opts.inlineCharacterLimit == void 0) { return string; }
			var oneLined = string.
				replace(new RegExp(tokens.newLine, 'g'), '').
				replace(new RegExp(tokens.newLineOrSpace, 'g'), ' ').
				replace(new RegExp(tokens.pad + '|' + tokens.indent, 'g'), '');

			if(oneLined.length <= opts.inlineCharacterLimit) {
				return oneLined;
			} else {
				return string.
					replace(new RegExp(tokens.newLine + '|' + tokens.newLineOrSpace, 'g'), '\n').
					replace(new RegExp(tokens.pad, 'g'), pad).
					replace(new RegExp(tokens.indent, 'g'), pad + opts.indent);
			}
		};

		if (seen.indexOf(val) !== -1) {
			return '"[Circular]"';
		}

		if (val === null ||
			val === undefined ||
			typeof val === 'number' ||
			typeof val === 'boolean' ||
			typeof val === 'function' ||
			isRegexp(val)) {
			return String(val);
		}

		if (val instanceof Date) {
			return 'new Date(\'' + val.toISOString() + '\')';
		}

		if (Array.isArray(val)) {
			if (val.length === 0) {
				return '[]';
			}

			seen.push(val);

			var ret = '[' + tokens.newLine + val.map(function (el, i) {
				var eol = val.length - 1 === i ? tokens.newLine : ',' + tokens.newLineOrSpace;
				return tokens.indent + stringify(el, opts, pad + opts.indent) + eol;
			}).join('') + tokens.pad + ']';

			seen.pop(val);

			return expandWhiteSpace(ret);
		}

		if (isPlainObj(val)) {
			var objKeys = Object.keys(val);

			if (objKeys.length === 0) {
				return '{}';
			}

			seen.push(val);

			var ret = '{' + tokens.newLine + objKeys.map(function (el, i) {
				if (opts.filter && !opts.filter(val, el)) {
					return '';
				}

				var eol = objKeys.length - 1 === i ? tokens.newLine : ',' + tokens.newLineOrSpace;
				var key = /^[a-z$_][a-z$_0-9]*$/i.test(el) ? el : stringify(el, opts);
				return tokens.indent + key + ': ' + stringify(val[el], opts, pad + opts.indent) + eol;
			}).join('') + tokens.pad + '}';

			seen.pop(val);

			return expandWhiteSpace(ret);
		}

		val = String(val).replace(/[\r\n]/g, function (x) {
			return x === '\n' ? '\\n' : '\\r';
		});

		if (opts.singleQuotes === false) {
			return '"' + val.replace(/"/g, '\\\"') + '"';
		}

		return '\'' + val.replace(/'/g, '\\\'') + '\'';
	})(val, opts, pad);
};


/***/ }),

/***/ "pfIK":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("Ky/o"),
    eq = __webpack_require__("t8ah");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ "pnw1":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ "qd7E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SIGNOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return signout; });
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fYnN");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("H6pA");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rJ95");



var SIGNOUT = 'SIGNOUT';

function cleanCookies() {
  js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.remove(_utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_1__[/* USER_INFO */ "d"]);
}

function signout() {
  cleanCookies();
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_2__[/* default */ "b"])(SIGNOUT);
}

/***/ }),

/***/ "qmjq":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("dZwK");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ "rAD9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_QUICKLOGIN_INFOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESET_QUICKLOGIN_INFOS; });
var UPDATE_QUICKLOGIN_INFOS = 'UPDATE_QUICKLOGIN_INFOS';
var RESET_QUICKLOGIN_INFOS = 'RESET_QUICKLOGIN_INFOS';

/***/ }),

/***/ "rL40":
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ "rhE9":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("fBdL"),
    arrayEach = __webpack_require__("oS9k"),
    assignValue = __webpack_require__("pfIK"),
    baseAssign = __webpack_require__("GMiS"),
    baseAssignIn = __webpack_require__("8Jk/"),
    cloneBuffer = __webpack_require__("okv5"),
    copyArray = __webpack_require__("nz94"),
    copySymbols = __webpack_require__("RlE+"),
    copySymbolsIn = __webpack_require__("BlK1"),
    getAllKeys = __webpack_require__("4qke"),
    getAllKeysIn = __webpack_require__("cdYD"),
    getTag = __webpack_require__("YXT+"),
    initCloneArray = __webpack_require__("G8Os"),
    initCloneByTag = __webpack_require__("ceQO"),
    initCloneObject = __webpack_require__("YfuU"),
    isArray = __webpack_require__("tEYP"),
    isBuffer = __webpack_require__("EVz8"),
    isMap = __webpack_require__("9XrK"),
    isObject = __webpack_require__("Q7Yi"),
    isSet = __webpack_require__("lEjn"),
    keys = __webpack_require__("DWlz");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ "rnJz":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("CP21"),
    getRawTag = __webpack_require__("oZU8"),
    objectToString = __webpack_require__("imxd");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ "sRdV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useTracking; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("Ub5k");
/* harmony import */ var _context_pageContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("RPju");
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("d1HQ");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("829J");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






var useTracking = function useTracking(defaultPayload) {
  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"]);
  var pageContext = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(_context_pageContext__WEBPACK_IMPORTED_MODULE_3__[/* ReactPageContext */ "a"]);

  var payload = _objectSpread(_objectSpread({}, _constants__WEBPACK_IMPORTED_MODULE_5__[/* GA_DEFAULT_PAYLOAD */ "i"]), {}, {
    siteSection: pageContext.siteSection
  }, defaultPayload);

  return function (trackPayload) {
    ___WEBPACK_IMPORTED_MODULE_4__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, payload), trackPayload), appContext, pageContext.pageType);
  };
};

/***/ }),

/***/ "sW3P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADULTS_ONLY_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADULTS_NUMBER_MIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADULTS_NUMBER_MAX; });
/* unused harmony export AREA_FACET_PREFIX_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHILDCARE_FACET_ID; });
/* unused harmony export COUNTRY_FACET_PREFIX_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DATE_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DEFAULT_DEPARTURE_CITY_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DEPARTURE_CITY_FACET_ID; });
/* unused harmony export DEPARTURE_DATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DEPARTURE_DATE_MAX_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DEPARTURE_DATE_MAX_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DEPARTURE_DATE_MIN_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DURATION_FACET; });
/* unused harmony export KIDS_FACET_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return KIDS_NUMBER_MAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return LOCALE_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return MAX_NUMBER_OF_SELECTED_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return OFFER_ID_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return PRODUCT_FACET_ID; });
/* unused harmony export WHEN_FACET_ID */
/* unused harmony export WHERE_FACET_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVITIES_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DESTINATIONS_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return COUNTRIES_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return TYPES_OF_STAY_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FACET_COMFORT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return QUERY_QUERY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return PRODUCTS_TO_COMPARE_QUERY_PARAM; });
/* unused harmony export FACET_QUERY_PARAMS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DEFAULT_CHILDCARE_FACETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FILTERABLE_FACETS_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FILTERABLE_FACETS_TRACKING_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FILTERABLE_FACETS_TEMPLATE_CONFIG; });
/* unused harmony export FACETS */
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("SPKZ");


var ADULTS_ONLY_FACET_ID = 'facette_adult_only';
var ADULTS_NUMBER_MIN = 1;
var ADULTS_NUMBER_MAX = 6;
var AREA_FACET_PREFIX_ID = 'AREA';
var CHILDCARE_FACET_ID = 'facette_childcare_age_in_month';
var COUNTRY_FACET_PREFIX_ID = 'COUNTRY';
var DATE_FORMAT = 'YYYY-MM-DD';
var DEFAULT_DEPARTURE_CITY_VALUE = 'NO';
var DEPARTURE_CITY_FACET_ID = 'facette_departure_city';
var DEPARTURE_DATE = 'date';
var DEPARTURE_DATE_MAX_DATE = {
  years: 2
};
var DEPARTURE_DATE_MAX_FACET_ID = 'departure_date_max';
var DEPARTURE_DATE_MIN_FACET_ID = 'departure_date_min';
var DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH = 6;
var DURATION_FACET = 'facette_duration';
var KIDS_FACET_ID = 'facette_kids';
var KIDS_NUMBER_MAX = 5;
var LOCALE_FACET_ID = 'locale';
var MAX_NUMBER_OF_SELECTED_PRODUCTS = 3;
var OFFER_ID_FACET_ID = 'facette_offer_id';
var PRODUCT_FACET_ID = 'product_id';
var WHEN_FACET_ID = 'facette_when';
var WHERE_FACET_ID = 'facette_where';
var ACTIVITIES_FACET_ID = 'activities_tree';
var DESTINATIONS_FACET_ID = 'destinations_tree';
var COUNTRIES_FACET_ID = 'facette_destination_country';
var TYPES_OF_STAY_FACET_ID = 'facette_type';
var FACET_COMFORT_ID = 'facette_comfort_label';
var QUERY_QUERY_PARAM = 'search';
var PRODUCTS_TO_COMPARE_QUERY_PARAM = _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["appQueryParameters"].productsComparison.productIds;
var FACET_QUERY_PARAMS = [{
  id: 'destination',
  facetId: COUNTRIES_FACET_ID
}, {
  id: 'departure_city',
  facetId: DEPARTURE_CITY_FACET_ID
}];
var DEFAULT_CHILDCARE_FACETS = ['132-215', '24-47', '4-23', '48-131'];
var FILTERABLE_FACETS_IDS = [ACTIVITIES_FACET_ID, DESTINATIONS_FACET_ID, COUNTRIES_FACET_ID, TYPES_OF_STAY_FACET_ID, FACET_COMFORT_ID];
var FILTERABLE_FACETS_TRACKING_CONFIG = [{
  id: ACTIVITIES_FACET_ID,
  trackingPrefixLabel: 'activities'
}, {
  id: DESTINATIONS_FACET_ID,
  trackingPrefixLabel: 'destinations'
}, {
  id: COUNTRIES_FACET_ID,
  trackingPrefixLabel: 'destinations'
}, {
  id: TYPES_OF_STAY_FACET_ID,
  trackingPrefixLabel: 'typeofstay'
}, {
  id: FACET_COMFORT_ID,
  trackingPrefixLabel: 'comfort'
}];
var FILTERABLE_FACETS_TEMPLATE_CONFIG = [{
  id: DESTINATIONS_FACET_ID,
  dataLabel: 'where',
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].EARTH_PLANE,
  facetLists: [{
    deep: false,
    id: DESTINATIONS_FACET_ID,
    titleLabel: 'faceting.where.destinationTitle'
  }, {
    deep: false,
    id: COUNTRIES_FACET_ID,
    titleLabel: 'faceting.where.countriesTitle'
  }],
  titleLabel: 'faceting.where.title'
}, {
  id: ACTIVITIES_FACET_ID,
  dataLabel: 'activities',
  facetLists: [{
    deep: true,
    id: ACTIVITIES_FACET_ID
  }],
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].ACTIVITIES,
  titleLabel: 'faceting.activities.title'
}, {
  id: TYPES_OF_STAY_FACET_ID,
  dataLabel: 'typeofstay',
  facetLists: [{
    deep: false,
    id: TYPES_OF_STAY_FACET_ID,
    facetLabels: 'faceting.typesOfStay'
  }],
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].BEACH,
  titleLabel: 'faceting.typesOfStay.title',
  trackingPrefixLabel: 'typeofstay'
}, {
  id: FACET_COMFORT_ID,
  dataLabel: 'comfort',
  facetLists: [{
    deep: false,
    id: FACET_COMFORT_ID
  }],
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].TRIDENT1,
  titleLabel: 'faceting.comfort.title'
}];
var FACETS = {
  when: 'when',
  who: 'who',
  where: 'where'
};

/***/ }),

/***/ "sWQB":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("rnJz"),
    isObject = __webpack_require__("Q7Yi");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ "sarX":
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__("kHWL"),
    baseUnary = __webpack_require__("id+h"),
    nodeUtil = __webpack_require__("2LZg");

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ "t0L4":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ "t8ah":
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "tEYP":
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ "tJ/X":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("lDSF"),
    root = __webpack_require__("jP+d");

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ "tRRp":
/***/ (function(module) {

module.exports = JSON.parse("{\"0\":65533,\"128\":8364,\"130\":8218,\"131\":402,\"132\":8222,\"133\":8230,\"134\":8224,\"135\":8225,\"136\":710,\"137\":8240,\"138\":352,\"139\":8249,\"140\":338,\"142\":381,\"145\":8216,\"146\":8217,\"147\":8220,\"148\":8221,\"149\":8226,\"150\":8211,\"151\":8212,\"152\":732,\"153\":8482,\"154\":353,\"155\":8250,\"156\":339,\"158\":382,\"159\":376}");

/***/ }),

/***/ "tU/q":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("rL40"),
    isArray = __webpack_require__("tEYP");

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ "u9tP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createAuthenticationMiddleware; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("m0zD");
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_logger__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_ple_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("6jSF");



function createAuthenticationMiddleware() {
  return function () {
    return function (next) {
      return function (action) {
        try {
          var _action$meta; // Works only on rejected optimistic actions, with a redirect_uri in payload's meta
          // $FlowFixMe


          var redirectUri = (_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : _action$meta.redirect_uri;

          if (!!redirectUri && _utils_ple_utils__WEBPACK_IMPORTED_MODULE_2__[/* hasAuthResponseError */ "l"](action.payload)) {
            _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["windowWrapper"].setLocation(redirectUri);
          }
        } catch (e) {
          _logger__WEBPACK_IMPORTED_MODULE_1___default.a.warn(e);
        }

        return next(action);
      };
    };
  };
}

/***/ }),

/***/ "uGNg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_SELECTED_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SELECT_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectProposal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearSelectedProposal; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rJ95");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nv//");
/* harmony import */ var _views_booking_BookingEngine_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("47Eh");




var SELECT_PROPOSAL = 'SELECT_PROPOSAL';
var CLEAR_SELECTED_PROPOSAL = 'CLEAR_SELECTED_PROPOSAL';

function clearSelectedProposal() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(CLEAR_SELECTED_PROPOSAL, {});
}

function selectProposal(proposalId, location, history) {
  var updatedUri = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_2__[/* convertLocationToURI */ "c"])(location).setQuery(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["appQueryParameters"].booking.selectedProposalId, proposalId);
  Object(_views_booking_BookingEngine_utils__WEBPACK_IMPORTED_MODULE_3__[/* navigateInBookingEngine */ "d"])({
    location: updatedUri,
    history: history,
    replace: true
  });
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(SELECT_PROPOSAL, {
    proposalId: proposalId
  });
}



/***/ }),

/***/ "uLWw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: Grid

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/Responsive.jsx
var Responsive = __webpack_require__("Gqxm");

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// CONCATENATED MODULE: ./src/client/components/frameworks/more-results/MoreResults.themes.js
var themes = {
  "default": {
    thRoot: 'flex w-full pt-2',
    thContent: 'bg-white flex flex-wrap content-center h-full w-full',
    thButton: 'absolute bottom-0 flex inset-x-0 justify-center',
    thPlaceholders: 'relative w-full'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/more-results/MoreResults.jsx
var __jsx = react_default.a.createElement;







var PLACEHOLDER_URLS = ['http://ns.clubmed.com/it/2019/shop/dummy.png', 'http://ns.clubmed.com/it/2019/shop/dummy2.png', 'http://ns.clubmed.com/it/2019/shop/dummy3.png'];
var MoreResults_MoreResults = function MoreResults(_ref) {
  var className = _ref.className,
      isLoading = _ref.isLoading,
      _ref$number = _ref.number,
      number = _ref$number === void 0 ? 0 : _ref$number,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? lodash["noop"] : _ref$onClick,
      text = _ref.text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      grid = _ref.grid,
      maxPlaceholders = _ref.maxPlaceholders;

  if (!number) {
    return null;
  }

  var _themes$theme = themes[theme],
      thContent = _themes$theme.thContent,
      thButton = _themes$theme.thButton,
      thPlaceholders = _themes$theme.thPlaceholders,
      thRoot = _themes$theme.thRoot;

  var renderPlaceholders = function renderPlaceholders() {
    var placeholders = [];

    for (var i = 0; i < number && i < maxPlaceholders; i++) {
      placeholders.push(__jsx(Image["a" /* default */], {
        className: classnames_default()('fadeIn px-2 align-bottom', grid),
        imageUrl: PLACEHOLDER_URLS[i],
        mandatoryWidthAndHeight: {
          w: 760,
          h: 'auto'
        },
        key: PLACEHOLDER_URLS[i]
      }));
    }

    return placeholders;
  };

  return __jsx("div", {
    className: classnames_default()(className, thRoot)
  }, __jsx("div", {
    className: thContent
  }, __jsx("div", {
    className: thPlaceholders
  }, renderPlaceholders(), __jsx("div", {
    style: {
      position: 'absolute',
      bottom: '0',
      left: '0',
      right: '0',
      top: '0',
      background: 'linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%)'
    }
  })), __jsx("div", {
    className: thButton
  }, __jsx(Button["a" /* Button */], {
    onClick: onClick,
    dataTestId: "more-results-btn",
    iconRight: {
      name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH
    },
    minWidth: "220px",
    isLoading: isLoading
  }, __jsx("span", {
    "data-testid": "Moreresults-number"
  }, number), " ", text))));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/grid/Grid.jsx









var Grid_jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






function getWidth() {
  var fraction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return fraction < 2 || fraction > 6 ? 'w-full' : "w-1/".concat(fraction);
}

function filterContext(hasOneRemaining, itemsByLine, isSeeMoreVisible) {
  return function (item, index) {
    if (isSeeMoreVisible) {
      return index < itemsByLine;
    }

    return true;
  };
}

var Grid_Grid = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(Grid, _Component);

  var _super = _createSuper(Grid);

  function Grid() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Grid);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      isExpanded: !_this.props.hasSeeMore
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClickSeeMore", function () {
      var _this$props = _this.props,
          _this$props$totalNumb = _this$props.totalNumberToDisplay,
          totalNumberToDisplay = _this$props$totalNumb === void 0 ? 0 : _this$props$totalNumb,
          _this$props$getChildr = _this$props.getChildren,
          getChildren = _this$props$getChildr === void 0 ? function () {
        return Promise.resolve({});
      } : _this$props$getChildr,
          _this$props$isSynchro = _this$props.isSynchronousGrid,
          isSynchronousGrid = _this$props$isSynchro === void 0 ? false : _this$props$isSynchro;

      if (isSynchronousGrid || totalNumberToDisplay === _this.getItemsByLine()) {
        _this.setState({
          isExpanded: true
        });
      }

      if (totalNumberToDisplay > _this.getItemsByLine()) {
        getChildren();
      }
    });

    return _this;
  }

  Object(createClass["a" /* default */])(Grid, [{
    key: "getGrid",
    value: function getGrid() {
      var _this$props$grid = this.props.grid,
          grid = _this$props$grid === void 0 ? {} : _this$props$grid;
      var desktop = grid.desktop,
          tablet = grid.tablet,
          phablet = grid.phablet,
          mobile = grid.mobile;
      return "".concat(getWidth(mobile), " sm:").concat(getWidth(phablet), " md:").concat(getWidth(tablet), " lg:").concat(getWidth(desktop));
    }
  }, {
    key: "getItemsByLine",
    value: function getItemsByLine() {
      var _this$props2 = this.props,
          _this$props2$display = _this$props2.display,
          display = _this$props2$display === void 0 ? {} : _this$props2$display,
          _this$props2$responsi = _this$props2.responsive,
          responsive = _this$props2$responsi === void 0 ? {} : _this$props2$responsi;
      var _display$desktop = display.desktop,
          desktop = _display$desktop === void 0 ? 1 : _display$desktop,
          _display$tablet = display.tablet,
          tablet = _display$tablet === void 0 ? 1 : _display$tablet,
          _display$phablet = display.phablet,
          phablet = _display$phablet === void 0 ? 1 : _display$phablet,
          _display$mobile = display.mobile,
          mobile = _display$mobile === void 0 ? 1 : _display$mobile;
      var _responsive$isBrowser = responsive.isBrowserGreaterThan,
          isBrowserGreaterThan = _responsive$isBrowser === void 0 ? {} : _responsive$isBrowser;

      if (isBrowserGreaterThan.M && desktop > -1) {
        return desktop;
      }

      if (isBrowserGreaterThan.S && tablet > -1) {
        return tablet;
      }

      if (isBrowserGreaterThan.XS && phablet > -1) {
        return phablet;
      }

      return mobile;
    }
  }, {
    key: "getNumberOfItemsByLineExcludingSeeMore",
    value: function getNumberOfItemsByLineExcludingSeeMore() {
      return this.getItemsByLine();
    }
  }, {
    key: "getRest",
    value: function getRest() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          totalNumberToDisplay = _this$props3.totalNumberToDisplay;
      return totalNumberToDisplay ? totalNumberToDisplay - this.getItemsByLine() : react["Children"].count(children) - this.getItemsByLine();
    }
  }, {
    key: "getSeeMore",
    value: function getSeeMore() {
      var _this$props4 = this.props,
          hasSeeMore = _this$props4.hasSeeMore,
          isLoading = _this$props4.isLoading,
          seeMore = _this$props4.seeMore;
      return hasSeeMore && this.getRest() > 0 && !this.state.isExpanded ? Grid_jsx(MoreResults_MoreResults, Object(esm_extends["a" /* default */])({}, seeMore, {
        className: "h-full",
        isLoading: isLoading,
        number: this.getRest(),
        onClick: this.onClickSeeMore,
        grid: this.getGrid(),
        maxPlaceholders: this.getItemsByLine()
      })) : null;
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var _this2 = this;

      var hasOneRemaining = this.getRest() === 1;
      var filterItem = filterContext(hasOneRemaining, this.getNumberOfItemsByLineExcludingSeeMore(), !this.state.isExpanded);
      return react["Children"].toArray(this.props.children).filter(filterItem).map(function (item) {
        return Grid_jsx("div", {
          className: classnames_default()('fadeIn p-2 pb-3', _this2.getGrid()),
          "data-testid": "Grid-item",
          key: item.key
        }, item);
      });
    }
  }, {
    key: "getItems",
    value: function getItems() {
      return [].concat(Object(toConsumableArray["a" /* default */])(this.getChildren()), [this.getSeeMore()]).filter(function (i) {
        return i;
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var isLoading = _ref.isLoading;

      if (isLoading && !this.props.isLoading && !this.state.isExpanded) {
        this.setState({
          isExpanded: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      var items = this.getItems();
      return items.length ? Grid_jsx("div", {
        className: classnames_default()(className, 'flex flex-wrap -m-2')
      }, items.map(function (item, index) {
        return (
          /* eslint-disable react/no-array-index-key */
          Grid_jsx(react["Fragment"], {
            key: index
          }, item)
        );
      })) : null;
    }
  }]);

  return Grid;
}(react["Component"]);

Object(defineProperty["a" /* default */])(Grid_Grid, "defaultProps", {
  display: {
    mobile: 1,
    phablet: 2,
    tablet: 3,
    desktop: 3
  },
  getChildren: function getChildren() {
    return Promise.resolve({});
  },
  grid: {
    mobile: 1,
    phablet: 2,
    tablet: 3,
    desktop: 3
  }
});

/* harmony default export */ var grid_Grid = __webpack_exports__["a"] = (Object(Responsive["a" /* default */])(Grid_Grid));

/***/ }),

/***/ "uRnh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themes; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var footerLite = {
  thRoot: 'cursor-pointer flex flex-col sm:flex-row items-center sm:items-start font-bold font-sans leading-tight no-underline text-center sm:text-initial text-md text-blue',
  thIcon: 'text-blue mb-1 sm:mb-0 sm:rtl:mr-3',
  thIconWidth: '1.5625rem',
  thSText: 'hidden sm:block font-normal text-base text-gray-darker'
};
var themes = {
  "default": {
    thRoot: 'cursor-pointer flex items-center font-bold font-sans leading-one no-underline text-sm text-white',
    thIcon: 'rtl:mr-1',
    thIconWidth: '2.5rem',
    thSText: 'text-base uppercase',
    thCustomText1: 'text-base uppercase'
  },
  black: {
    thRoot: 'flex justify-end items-center font-bold font-sans leading-tight no-underline text-initial text-gray-darker text-md',
    thIcon: 'text-gray-darker mb-1 sm:mb-0 sm:rtl:mr-3',
    thIconWidth: '2rem',
    thCustomText2: 'text-booking'
  },
  footerLite: footerLite,
  contact: {
    thRoot: 'flex flex-col sm:flex-row items-center sm:items-start font-bold font-sans leading-tight no-underline text-center sm:text-initial text-md',
    thIcon: 'text-blue mb-1 sm:mb-0 sm:rtl:mr-3',
    thIconWidth: '1.75rem',
    thSText: 'hidden sm:block font-normal text-base text-gray-light'
  },
  contact2: {
    thRoot: 'flex flex-col sm:flex-row items-center sm:items-start font-bold font-sans leading-tight no-underline text-center sm:text-initial text-md',
    thIcon: 'text-blue mb-1 sm:mb-0 sm:rtl:mr-3',
    thIconWidth: '3rem',
    thCustomText1: 'font-normal text-base text-gray-light',
    thCustomText2: 'font-normal text-base text-gray-darker'
  },
  smallFooterLite: _objectSpread(_objectSpread({}, footerLite), {}, {
    thIconWidth: '1.2rem'
  }),
  search: {
    thRoot: 'cursor-pointer items-center font-sans no-underline text-sm text-white'
  }
};

/***/ }),

/***/ "ubIY":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("jP+d");

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ "ubam":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROFILE_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return notifyProfileChanged; });
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fYnN");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("H6pA");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("rJ95");




var PROFILE_CHANGED = 'PLE_PROFILE_CHANGED';

function refreshCookie(_ref) {
  var firstName = _ref.firstName,
      lastName = _ref.lastName,
      unicodeFirstName = _ref.unicodeFirstName,
      unicodeLastName = _ref.unicodeLastName;
  js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.set(_utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_2__[/* USER_INFO */ "d"], _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["oidc"].toUriEncodedState({
    firstName: firstName,
    lastName: lastName,
    unicodeFirstName: unicodeFirstName,
    unicodeLastName: unicodeLastName
  }));
}

function notifyProfileChanged(newProfile) {
  refreshCookie(newProfile);
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_3__[/* default */ "b"])(PROFILE_CHANGED, newProfile);
}

/***/ }),

/***/ "unIT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_DATA_SCORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATA_SCORE_SESSION_STORAGE_KEY; });
var SET_DATA_SCORE = 'SET_DATA_SCORE';
var DATA_SCORE_SESSION_STORAGE_KEY = 'cmLeadScore';


/***/ }),

/***/ "v315":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ rootReducer; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/redux/es/redux.js
var redux = __webpack_require__("9OUN");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/session-storage-api/sessionStorageApi.js
var sessionStorageApi = __webpack_require__("9NGo");

// EXTERNAL MODULE: ./src/client/store/lead-info/constants.js
var constants = __webpack_require__("unIT");

// CONCATENATED MODULE: ./src/client/store/lead-info/leadInfo.reducer.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var initialState = {
  score: parseFloat(Object(sessionStorageApi["b" /* getFromSessionStorage */])(constants["a" /* DATA_SCORE_SESSION_STORAGE_KEY */])) || 0
};

var leadInfo_reducer_leadInfosReducer = function leadInfosReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      payload = action.payload;

  if (type === constants["b" /* SET_DATA_SCORE */]) {
    return _objectSpread(_objectSpread({}, state), {}, {
      score: payload.score
    });
  }

  return state;
};


// EXTERNAL MODULE: ./src/client/store/booking/customer-search/customerSearch.reducer.js
var customerSearch_reducer = __webpack_require__("E3ZW");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /home/circleci/project/node_modules/redux-optimist-promise/build/index.js
var build = __webpack_require__("b0q8");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/client/store/trip-information/kids/constants.js
var kids_constants = __webpack_require__("wQ38");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/constants.js
var adults_constants = __webpack_require__("ORYz");

// EXTERNAL MODULE: ./src/client/store/constants.js
var store_constants = __webpack_require__("cvSI");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/constants.js
var proposals_constants = __webpack_require__("UIAR");

// CONCATENATED MODULE: ./src/client/store/booking/proposals/proposals.reducer.utils.js


function proposals_reducer_utils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function proposals_reducer_utils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      proposals_reducer_utils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      proposals_reducer_utils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



function getTransportsWithTransfer(proposal) {
  return proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal.transports), {}, {
    inbound: proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, Object(lodash["get"])(proposal, 'transports.inbound')), {}, {
      transferIncluded: true
    }),
    outbound: proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, Object(lodash["get"])(proposal, 'transports.outbound')), {}, {
      transferIncluded: true
    })
  });
}

function setTransferIncludedInProposal(proposal) {
  return proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal), Object(lodash["has"])(proposal, 'transports.inbound') && Object(lodash["has"])(proposal, 'transports.outbound') ? {
    transports: getTransportsWithTransfer(proposal)
  } : null);
}

function updateProposal(proposalId, state, updateFn) {
  var indexToUpdate = state.findIndex(function (p) {
    return Object(lodash["get"])(p, 'id') === proposalId;
  });
  return indexToUpdate !== -1 ? state.map(function (proposal, index) {
    return index === indexToUpdate ? updateFn(proposal) : proposal;
  }) : state;
}

function updateTransfers(state, proposalFields) {
  if (Object(lodash["isEmpty"])(proposalFields)) return state;

  var updateFn = function updateFn(proposal) {
    var currentProposal = proposalFields.find(function (_ref) {
      var id = _ref.id;
      return id === Object(lodash["get"])(proposal, 'id');
    }) || {};
    var price = currentProposal.price,
        availableTransfers = currentProposal.availableTransfers,
        paymentSchedule = currentProposal.paymentSchedule,
        selectedTransfers = currentProposal.selectedTransfers;
    return proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal), {}, {
      price: proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal.price), price),
      paymentSchedule: paymentSchedule,
      availableTransfers: availableTransfers || proposal.availableTransfers,
      selectedTransfers: selectedTransfers || proposal.selectedTransfers
    });
  };

  return state.map(updateFn);
}

function updateTransportError(state, proposalId, error) {
  var updateFn = function updateFn(proposal) {
    return proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal), {}, {
      transports: proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal.transports), {}, {
        error: error
      })
    });
  }; // $FlowFixMe


  return updateProposal(proposalId, state, updateFn);
}

function updateAttendees(state, proposalFields) {
  if (!proposalFields) return state;
  var price = proposalFields.price,
      attendees = proposalFields.attendees;

  var updateFn = function updateFn(proposal) {
    return proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal), {}, {
      price: price,
      attendees: proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal.attendees), {}, {
        list: attendees.list
      })
    });
  }; // $FlowFixMe


  return updateProposal(proposalFields.id, state, updateFn);
}


// CONCATENATED MODULE: ./src/client/store/booking/proposals/proposals.reducer.js



function proposals_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function proposals_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      proposals_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      proposals_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}










var proposals_reducer_initialState = [];
function proposalsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : proposals_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case proposals_constants["p" /* PREPARE_BE */]:
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
      {
        var proposals = Object(lodash["get"])(action, 'payload.proposals.proposals', []).map(setTransferIncludedInProposal).sort(proposalUtils["b" /* compareProposalsByComfort */]);
        var errors = Object(lodash["get"])(action, 'payload.proposals.errors', []);
        return [].concat(Object(toConsumableArray["a" /* default */])(proposals), Object(toConsumableArray["a" /* default */])(errors));
      }

    case Object(build["resolve"])(proposals_constants["m" /* FETCH_SELECTED_PROPOSAL_PAYMENT */]):
      {
        var paymentSchedule = action.payload.proposal.paymentSchedule;
        var selectedProposalId = Object(lodash["get"])(action, 'meta.payload.selectedProposalId');
        return state.map(function (proposal) {
          return proposal.id === selectedProposalId ? proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), {}, {
            paymentSchedule: paymentSchedule
          }) : proposal;
        });
      }

    case Object(build["reject"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
      {
        // $FlowFixMe
        return [{
          errorCode: 500
        }];
      }

    case proposals_constants["w" /* SET_PROPOSALS */]:
      return Object(lodash["get"])(action, 'payload.proposals');

    case Object(build["resolve"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
      return action.payload.addAccommodation || state;

    case proposals_constants["y" /* UPDATE_ATTENDEES */]:
      return updateAttendees(state, Object(lodash["get"])(action, 'payload.proposal'));

    case proposals_constants["j" /* FETCH_PROPOSALS */]:
    case proposals_constants["f" /* CLEAR_PROPOSALS */]:
    case kids_constants["c" /* TRIP_INFORMATION_SET_KIDS */]:
    case adults_constants["e" /* TRIP_INFORMATION_SET_ADULTS_NUMBER */]:
    case store_constants["t" /* UPDATE_TRIP_DATE_CRITERIA */]:
      return proposals_reducer_initialState;

    case Object(build["resolve"])(proposals_constants["d" /* ADD_TRANSFER_TO_PROPOSALS */]):
      {
        var transfersAdded = Object(lodash["get"])(action, 'payload', []).map(function (item) {
          return Object(lodash["get"])(item, 'addTransfer');
        }).flat();
        return updateTransfers(state, transfersAdded);
      }

    case Object(build["resolve"])(proposals_constants["s" /* REMOVE_TRANSFER_FROM_PROPOSALS */]):
      {
        var transfersRemoved = Object(lodash["get"])(action, 'payload', []).map(function (item) {
          return Object(lodash["get"])(item, 'removeTransfer');
        }).flat();
        return updateTransfers(state, transfersRemoved);
      }

    case Object(build["resolve"])(proposals_constants["e" /* ADD_TRANSPORT */]):
      {
        if (!action.payload.addTransport) {
          return state;
        }

        return action.payload.addTransport.map(function (proposal) {
          return setTransferIncludedInProposal(proposal);
        });
      }

    case Object(build["reject"])(proposals_constants["e" /* ADD_TRANSPORT */]):
      var transportExpiredError = Object(lodash["get"])(action, 'payload.errors', []).find(function (error) {
        return Object(lodash["get"])(error, 'statusCode') === 400;
      });
      var proposalId = Object(lodash["get"])(action, 'meta.payload.proposalId');
      var errorInfo = Object(lodash["pick"])(transportExpiredError, ['statusCode', 'message']);
      return transportExpiredError ? updateTransportError(state, proposalId, errorInfo) : state;

    case Object(build["resolve"])(proposals_constants["v" /* SET_PROMO_CODE */]):
      return state.map(function (proposal) {
        if (proposal.id === Object(lodash["get"])(action, 'payload.promoCodeProposal.id')) {
          return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), {}, {
            price: proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal.price), {}, {
              aggregateDiscount: Object(lodash["get"])(action, 'payload.promoCodeProposal.price.aggregateDiscount'),
              aggregateDiscountPromoCode: Object(lodash["get"])(action, 'payload.promoCodeProposal.price.aggregateDiscountPromoCode'),
              promoCode: Object(lodash["get"])(action, 'payload.promoCodeProposal.price.promoCode'),
              total: Object(lodash["get"])(action, 'payload.promoCodeProposal.price.total')
            }),
            paymentSchedule: Object(lodash["get"])(action, 'payload.promoCodeProposal.paymentSchedule')
          });
        }

        return proposal;
      });

    case proposals_constants["z" /* UPDATE_INSURANCES */]:
      var proposalFields = Object(lodash["get"])(action, 'payload.modifyInsurances.proposal');
      if (!proposalFields) return state;
      return updateProposal(proposalFields.id, state, function (proposal) {
        return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), {}, {
          listInsurances: Object(toConsumableArray["a" /* default */])(proposalFields.listInsurances),
          price: proposalFields.price,
          paymentSchedule: proposalFields.paymentSchedule
        });
      });

    case proposals_constants["g" /* DELETE_INSURANCES */]:
      var proposalDeleteInsurances = Object(lodash["get"])(action, 'payload.deleteInsurances.proposal');
      if (!proposalDeleteInsurances) return state;
      return updateProposal(proposalDeleteInsurances.id, state, function (proposal) {
        return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), {}, {
          listInsurances: Object(toConsumableArray["a" /* default */])(proposalDeleteInsurances.listInsurances),
          price: proposalDeleteInsurances.price,
          paymentSchedule: proposalDeleteInsurances.paymentSchedule
        });
      });

    case proposals_constants["u" /* SAVE_DONATION_TO_PROPOSALS */]:
      return state.map(function (proposal) {
        return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), {}, {
          price: proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal.price), {}, {
            donation: action.payload
          })
        });
      });

    case Object(build["resolve"])(proposals_constants["c" /* ADD_SERVICE */]):
    case Object(build["resolve"])(proposals_constants["A" /* UPDATE_SERVICES */]):
    case Object(build["resolve"])(proposals_constants["h" /* DELETE_SERVICE */]):
      {
        // $FlowFixMe
        var data = Object.values(action.payload)[0];
        return state.map(function (proposal, proposalIndex) {
          return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), data[proposalIndex]);
        });
      }

    case Object(build["resolve"])(proposals_constants["x" /* SWITCH_PROPOSALS_OFFERS */]):
      return state.map(function (proposal) {
        var proposalData = action.payload.proposals.find(function (_ref) {
          var id = _ref.id;
          return id === proposal.id;
        });

        if (proposalData) {
          return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), proposalData);
        }

        return proposals_reducer_objectSpread({}, proposal);
      });

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/proposals/insurance/insurance.reducer.js

var insurance_reducer_initialState = {
  isAdded: false,
  isDeleted: false
};
var insurance_reducer_insuranceReducer = function insuranceReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : insurance_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case proposals_constants["n" /* INSURANCE_ADDED */]:
      return {
        isDeleted: false,
        isAdded: true
      };

    case proposals_constants["o" /* INSURANCE_DELETED */]:
      return {
        isAdded: false,
        isDeleted: true
      };

    default:
      return state;
  }
};
// CONCATENATED MODULE: ./src/client/store/booking/resort/resort.reducer.js






var resort_reducer_initialState = null;
function resortReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : resort_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
      {
        return Object(lodash["get"])(action, 'payload.proposals.resort', null);
      }

    case proposals_constants["p" /* PREPARE_BE */]:
      return Object(lodash["get"])(action, 'payload.resort', null);

    case proposals_constants["j" /* FETCH_PROPOSALS */]:
    case proposals_constants["f" /* CLEAR_PROPOSALS */]:
    case kids_constants["c" /* TRIP_INFORMATION_SET_KIDS */]:
    case adults_constants["e" /* TRIP_INFORMATION_SET_ADULTS_NUMBER */]:
    case store_constants["t" /* UPDATE_TRIP_DATE_CRITERIA */]:
      return resort_reducer_initialState;

    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/client/store/booking/selected-proposal-id/selectedProposalId.action.js
var selectedProposalId_action = __webpack_require__("uGNg");

// CONCATENATED MODULE: ./src/client/store/booking/selected-proposal-id/selectedProposalId.reducer.js



var selectedProposalId_reducer_initialState = null;

function selectedProposalIdReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : selectedProposalId_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case proposals_constants["p" /* PREPARE_BE */]:
    case selectedProposalId_action["b" /* SELECT_PROPOSAL */]:
      return Object(lodash["get"])(action, 'payload.proposalId');

    case selectedProposalId_action["a" /* CLEAR_SELECTED_PROPOSAL */]:
      return selectedProposalId_reducer_initialState;

    default:
      return state;
  }
}

/* harmony default export */ var selectedProposalId_reducer = (selectedProposalIdReducer);
// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-city/constants.js
var departure_city_constants = __webpack_require__("PFCZ");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/duration/duration.constants.js
var duration_constants = __webpack_require__("RBvG");

// CONCATENATED MODULE: ./src/client/store/booking/best-proposal-id/bestProposalId.reducer.js










var bestProposalId_reducer_initialState = null;
function bestProposalIdReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bestProposalId_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
      {
        var proposals = Object(toConsumableArray["a" /* default */])(Object(lodash["get"])(action, 'payload.proposals.proposals', [])).sort(proposalUtils["b" /* compareProposalsByComfort */]);

        return Object(lodash["get"])(proposals, '[0].id', null);
      }

    case proposals_constants["w" /* SET_PROPOSALS */]:
      {
        return Object(lodash["get"])(action, 'payload.proposals[0].id', null);
      }

    case Object(build["reject"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case proposals_constants["f" /* CLEAR_PROPOSALS */]:
    case duration_constants["c" /* TRIP_INFORMATION_SET_DURATION */]:
    case departure_city_constants["b" /* TRIP_INFORMATION_SET_DEPARTURE_CITY */]:
    case kids_constants["c" /* TRIP_INFORMATION_SET_KIDS */]:
    case adults_constants["e" /* TRIP_INFORMATION_SET_ADULTS_NUMBER */]:
    case store_constants["t" /* UPDATE_TRIP_DATE_CRITERIA */]:
      {
        return bestProposalId_reducer_initialState;
      }

    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/client/store/booking/additional-accommodations/additionalAccommodations.action.js
var additionalAccommodations_action = __webpack_require__("06Jt");

// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/is-loading/isLoading.reducer.js



var isLoading_reducer_initialState = false;

function isLoadingReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isLoading_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
      return true;

    case Object(build["reject"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
    case Object(build["resolve"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
      return false;

    default:
      return state;
  }
}

/* harmony default export */ var isLoading_reducer = (isLoadingReducer);
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/accommodations-sets/accommodationsSets.reducer.js


function accommodationsSets_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function accommodationsSets_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      accommodationsSets_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      accommodationsSets_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var accommodationsSets_reducer_initialState = [];

function accommodationsSetsReducer() {
  var _action$payload;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : accommodationsSets_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case additionalAccommodations_action["a" /* CLEAR_ADDITIONAL_ACCOMMODATIONS */]:
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
      return accommodationsSets_reducer_initialState;

    case Object(build["resolve"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
      return ((action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.additionalAccommodations) || []).
      /**
       * Sometimes we get a corner case from API responses where arrangement accommodation does not match any of resort accommodations
       * In this case we could get and accommodationsSet with empty accommodations field... It makes no sense to display it to the user
       * See https://github.com/ClubMediterranee/cm-b2c/issues/14959
       */
      filter(function (additionalAccommodationSet) {
        return additionalAccommodationSet.accommodations && additionalAccommodationSet.accommodations.length > 0;
      }).map(function (accommodation, index) {
        return accommodationsSets_reducer_objectSpread(accommodationsSets_reducer_objectSpread({}, accommodation), {}, {
          accommodationSetNumber: index + 1
        });
      });

    default:
      return state;
  }
}

/* harmony default export */ var accommodationsSets_reducer = (accommodationsSetsReducer);
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/error/error.reducer.js



var error_reducer_initialState = null;

function additionalAccommodationsErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : error_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
      return error_reducer_initialState;

    case Object(build["reject"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
      var error = Object(lodash["get"])(action, 'payload.errors[0]', {});
      return {
        statusCode: error.statusCode || 500,
        message: error.message || 'UNKNOWN ERROR'
      };

    default:
      return state;
  }
}

/* harmony default export */ var error_reducer = (additionalAccommodationsErrorReducer);
// EXTERNAL MODULE: ./src/client/components/widgets/additional-accommodations/AdditionalAccommodationsUtils.js
var AdditionalAccommodationsUtils = __webpack_require__("CwJu");

// EXTERNAL MODULE: ./src/utils/accommodation/accommodation.constants.js
var accommodation_constants = __webpack_require__("lZ21");

// CONCATENATED MODULE: ./src/client/store/filters/filtersHelper.js



function filtersHelper_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function filtersHelper_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      filtersHelper_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      filtersHelper_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var defaultMatch = function defaultMatch(a, b) {
  return a === b;
};

function _getMatcher(filter) {
  return filter.match || defaultMatch;
}

function _matchFilter(data) {
  return function (filter) {
    var dataValue = Object(lodash["get"])(data, filter.path);
    var filterValue = filter.value;
    return _getMatcher(filter)(dataValue, filterValue);
  };
}

function _toggleFilter(filters) {
  return function (toggledFilter) {
    return filters.map(function (filter) {
      var shouldToggleFilter = filter.path === toggledFilter.path && filter.value === toggledFilter.value;
      return filtersHelper_objectSpread(filtersHelper_objectSpread({}, filter), {}, {
        selected: shouldToggleFilter ? !filter.selected : filter.selected
      });
    });
  };
}

function _filterDataSet(dataSet, filters) {
  var condition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return true;
  };
  var activeFilters = filters.filter(function (f) {
    return condition(f) === true;
  });
  return dataSet.filter(function (data) {
    var match = _matchFilter(data);

    return Object(lodash["isEmpty"])(activeFilters) || activeFilters.some(function (activeFilter) {
      return match(activeFilter);
    });
  });
}

function _removeUnusedFilters(filters) {
  return filters.map(function (filter) {
    return filter.selected === true && filter.matchedOccurrences === 0 ? filtersHelper_objectSpread(filtersHelper_objectSpread({}, filter), {}, {
      selected: false
    }) : filter;
  });
}

function filterDataSetWithSelectedAndMatchedFilters(dataSet, filters) {
  return _filterDataSet(dataSet, filters, function (filter) {
    return filter.selected && Object(lodash["get"])(filter, 'matchedOccurrences', 0) > 0;
  });
}

function getDataSetIfFilterWasSelected(dataSet, filter) {
  return _filterDataSet(dataSet, [filter]);
}

function getFiltersWithMatchedOccurrences(dataSet) {
  return function (filters) {
    // First, we group all filters by their path
    var filtersByCategory = Object(lodash["groupBy"])(filters, 'category');
    return filters.map(function (filter) {
      // Then, for every filter, we get all data objects matching all active filters in all other categories
      var matchedResultsInOtherCategories = Object.keys(filtersByCategory).filter(function (category) {
        return category !== filter.category;
      }).map(function (filterKey) {
        return filterDataSetWithSelectedAndMatchedFilters(dataSet, Object(lodash["get"])(filtersByCategory, filterKey));
      }); // Then, we activate the current filter (whether its current activation state) and get all data objects matching only this filter

      var matchedResultsForCurrentFilter = getDataSetIfFilterWasSelected(dataSet, filter); // Finally, The intersection gives us the list of results matching all our active filters
      // prettier-ignore

      var matchedOccurrences = ( // $FlowFixMe
      lodash["intersectionBy"].apply(void 0, Object(toConsumableArray["a" /* default */])(matchedResultsInOtherCategories).concat([matchedResultsForCurrentFilter, 'id'])) || []).length;
      return filtersHelper_objectSpread(filtersHelper_objectSpread({}, filter), {}, {
        matchedOccurrences: matchedOccurrences
      });
    });
  };
}

function _activateFilter(filters, valuesToActivate) {
  return filters.map(function (filter) {
    var matchedOccurrences = Object(lodash["get"])(filter, 'matchedOccurrences', 0);

    if (matchedOccurrences > 0 && valuesToActivate.includes(filter.value)) {
      return filtersHelper_objectSpread(filtersHelper_objectSpread({}, filter), {}, {
        selected: true
      });
    }

    return filter;
  });
}

function getPreselectedFilters(filters, selectedProposal) {
  var accommodationFilters = filters.filter(function (f) {
    return f.category === 'accommodations' && Object(lodash["get"])(f, 'matchedOccurrences', 0) > 0;
  }); // categoryId is the comfort level of the room, used as value for comfort filters

  var selectedProposalComfort = Object(lodash["get"])(selectedProposal, 'accommodations[0].categoryId');
  var selectedProposalComfortOrder = accommodation_constants["a" /* ACCOMMODATION_COMFORT_ORDER */].indexOf(selectedProposalComfort); // at first, activate filters equal to selected proposal comfort level
  // and those with higher comfort level

  var higherComfortCodes = Object(lodash["slice"])(accommodation_constants["a" /* ACCOMMODATION_COMFORT_ORDER */], selectedProposalComfortOrder);
  var filtersToActivate = higherComfortCodes.filter(function (code) {
    return Object(lodash["find"])(accommodationFilters, {
      value: code
    });
  }); // if no equal or higher comfort level filter found,
  // activate the one below the selected proposal comfort level

  if (filtersToActivate.length === 0) {
    var lowerComfortCodes = Object(lodash["take"])(accommodation_constants["a" /* ACCOMMODATION_COMFORT_ORDER */], selectedProposalComfortOrder); // use findLast to start from the end of the array
    // and get the highest comfort level possible

    var codeToActivate = Object(lodash["findLast"])(lowerComfortCodes, function (code) {
      return Object(lodash["find"])(accommodationFilters, {
        value: code
      });
    });
    codeToActivate && filtersToActivate.push(codeToActivate);
  }

  switch (selectedProposalComfort) {
    // if selected proposal comfort level is club, club seaside view
    // or superior (default state), do not activate any filter
    case '000017': // club

    case '000048': // club seaside view

    case '000061':
      // superior
      return filters;

    default:
      return _activateFilter(filters, filtersToActivate);
  }
}

function toggleFilter(dataSet) {
  return function (filters, toggledFilter) {
    var updateMatchOccurrences = getFiltersWithMatchedOccurrences(dataSet);

    var updatedToggleFilters = _toggleFilter(filters)(toggledFilter);

    var updatedOccurrencesFilters = updateMatchOccurrences(updatedToggleFilters);
    return _removeUnusedFilters(updatedOccurrencesFilters);
  };
}

function filterDataSet(dataSet, filters) {
  if (!filters) {
    return dataSet;
  }

  var filtersByCategory = Object(lodash["groupBy"])(filters, 'category');
  return Object.keys(filtersByCategory) // $FlowFixMe
  .reduce(function (filteredResults, category) {
    return filterDataSetWithSelectedAndMatchedFilters(filteredResults, filtersByCategory[category]);
  }, dataSet);
}


// EXTERNAL MODULE: ./src/client/store/booking/additional-accommodations/filters/filterUtils.js
var filterUtils = __webpack_require__("KxdP");

// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/filters/filters.reducer.js





var filters_reducer_initialState = null;
function filtersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : filters_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var additionalAccommodations = Object(lodash["get"])(action, 'payload.additionalAccommodations') || [];
  var proposal = Object(lodash["get"])(action, 'payload.selectedProposal') || null; // remove initial accommodation (related to selected proposal) from additional accommodations

  var filteredAdditionalAccommodations = proposal && additionalAccommodations.length ? Object(AdditionalAccommodationsUtils["a" /* filterAccommodations */])(proposal, additionalAccommodations) : additionalAccommodations;
  var getFiltersWithOccurrences = getFiltersWithMatchedOccurrences(filteredAdditionalAccommodations);

  switch (action.type) {
    case additionalAccommodations_action["a" /* CLEAR_ADDITIONAL_ACCOMMODATIONS */]:
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
      return filters_reducer_initialState;

    case additionalAccommodations_action["b" /* CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS */]:
      var _action$payload = action.payload,
          i18n = _action$payload.i18n,
          selectedProposal = _action$payload.selectedProposal,
          shouldPreselectFilters = _action$payload.shouldPreselectFilters,
          resort = _action$payload.resort;
      var filters = Object(filterUtils["d" /* createFilters */])(filteredAdditionalAccommodations, i18n, resort);
      var filtersWithOccurences = getFiltersWithOccurrences(filters);
      return filtersWithOccurences && shouldPreselectFilters ? getPreselectedFilters(filtersWithOccurences, selectedProposal) : filtersWithOccurences;

    case additionalAccommodations_action["d" /* TOGGLE_ACCOMMODATIONS_FILTER */]:
      var filter = action.payload.filter;
      return toggleFilter(filteredAdditionalAccommodations)(state || [], filter);

    case additionalAccommodations_action["e" /* UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY */]:
      var category = action.payload.category;
      var updatedFilters = Object(filterUtils["e" /* unselectCategory */])(state || [])(category);
      return getFiltersWithOccurrences(updatedFilters);

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/is-data-fetched/isDataFetched.reducer.js


var isDataFetched_reducer_initialState = false;
function isDataFetched() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isDataFetched_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
    case additionalAccommodations_action["a" /* CLEAR_ADDITIONAL_ACCOMMODATIONS */]:
      return false;

    case Object(build["reject"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
    case Object(build["resolve"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
      return true;

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/filtered-accommodations/filteredAccommodations.reducer.js



var filteredAccommodations_reducer_initialState = null;

function filteredAccommodationsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : filteredAccommodations_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var additionalAccommodations = Object(lodash["get"])(action, 'payload.additionalAccommodations') || [];
  var filters = Object(lodash["get"])(action, 'payload.filters') || [];

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalAccommodations_action["a" /* CLEAR_ADDITIONAL_ACCOMMODATIONS */]:
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
      return filteredAccommodations_reducer_initialState;

    case additionalAccommodations_action["f" /* UPDATE_FILTERED_ACCOMMODATIONS_RESULTS */]:
      return filterDataSet(additionalAccommodations, filters);

    default:
      return state;
  }
}

/* harmony default export */ var filteredAccommodations_reducer = (filteredAccommodationsReducer);
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/additionalAccommodations.reducer.js







var additionalAccommodations_reducer_additionalAccommodations = Object(redux["c" /* combineReducers */])({
  error: error_reducer,
  isLoading: isLoading_reducer,
  accommodationsSets: accommodationsSets_reducer,
  filters: filtersReducer,
  filteredAccommodations: filteredAccommodations_reducer,
  isDataFetched: isDataFetched
});
// EXTERNAL MODULE: ./src/client/store/booking/additional-transports/additionalTransports.action.js
var additionalTransports_action = __webpack_require__("04nu");

// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/is-loading/isLoading.reducer.js



var is_loading_isLoading_reducer_initialState = false;

function isLoading_reducer_isLoadingReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : is_loading_isLoading_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]:
      return true;

    case additionalTransports_action["b" /* CREATE_ADDITIONAL_TRANSPORTS_FILTERS */]:
    case Object(build["reject"])(additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]):
      return false;

    default:
      return state;
  }
}

/* harmony default export */ var is_loading_isLoading_reducer = (isLoading_reducer_isLoadingReducer);
// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/transports/transports.reducer.js


function transports_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function transports_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      transports_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      transports_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var transports_reducer_initialState = null;

function transportsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : transports_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalTransports_action["a" /* CLEAR_ADDITIONAL_TRANSPORTS */]:
      return transports_reducer_initialState;

    case additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]:
      return transports_reducer_initialState;

    case Object(build["resolve"])(additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]):
      return Object(lodash["get"])(action, 'payload.additionalTransports', []).map(function (transport, index) {
        return transports_reducer_objectSpread(transports_reducer_objectSpread({}, transport), {}, {
          transportNumber: index + 1
        });
      });

    default:
      return state;
  }
}

/* harmony default export */ var transports_reducer = (transportsReducer);
// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/error/error.reducer.js



var error_error_reducer_initialState = null;

function additionalTransportsErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : error_error_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]:
      return error_error_reducer_initialState;

    case Object(build["reject"])(additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]):
      var error = Object(lodash["get"])(action, 'payload.errors[0]', {});
      return {
        statusCode: error.statusCode || 500,
        message: error.message || 'UNKNOWN ERROR'
      };

    default:
      return state;
  }
}

/* harmony default export */ var error_error_reducer = (additionalTransportsErrorReducer);
// EXTERNAL MODULE: /home/circleci/project/node_modules/shortid/index.js
var shortid = __webpack_require__("MIfU");
var shortid_default = /*#__PURE__*/__webpack_require__.n(shortid);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/fp.js
var fp = __webpack_require__("h/fj");

// EXTERNAL MODULE: ./src/utils/transport/additionalTransports.constants.js
var additionalTransports_constants = __webpack_require__("dGB2");

// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/filters/filterUtils.js



function filterUtils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function filterUtils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      filterUtils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      filterUtils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






function geIntValue(time) {
  return time.hours * 60 + time.minutes;
}

function isTimeBefore(time, refTime) {
  return geIntValue(time) < geIntValue(refTime);
}

function isTimeAfter(time, refTime) {
  return geIntValue(time) >= geIntValue(refTime);
}

function isTimeInRange(time) {
  return function (timeRange) {
    return isTimeAfter(time, timeRange.start) && isTimeBefore(time, timeRange.end);
  };
}

function timeRangeValueToString(_ref) {
  var hours = _ref.hours,
      minutes = _ref.minutes;
  return "".concat(hours, ":").concat(minutes < 10 ? "0".concat(minutes) : minutes);
}

function timeRangeToString(time) {
  return "".concat(timeRangeValueToString(time.start), " - ").concat(timeRangeValueToString(time.end));
}

var STRICT_EQUALITY_MATCHER = function STRICT_EQUALITY_MATCHER(a, b) {
  return a === b;
};

var ARRAY_INCLUSION_MATCHER = function ARRAY_INCLUSION_MATCHER(array, item) {
  return array.includes(item);
};

var COMPANIES_MATCHER = function COMPANIES_MATCHER(companies, companyId) {
  return !!companies.find(function (c) {
    return c.id === companyId;
  });
};

var TIME_RANGE_MATCHER = function TIME_RANGE_MATCHER(time, timeRange) {
  return isTimeInRange(time)(timeRange);
};

function createCompaniesFilters(transports) {
  var companies = Object(fp["pipe"])([Object(fp["map"])(Object(fp["path"])('filterValues.companies')), fp["flatten"], fp["compact"], Object(fp["uniqBy"])('id')])(transports);
  return companies.map(function (company) {
    return {
      id: shortid_default.a.generate(),
      category: additionalTransports_constants["d" /* COMPANIES_CATEGORY */],
      match: COMPANIES_MATCHER,
      meta: {
        imageUrl: company.logo,
        label: company.label
      },
      path: 'filterValues.companies',
      selected: false,
      value: company.id
    };
  });
}

function getLayoversInfo(i18n) {
  return function (layovers) {
    switch (layovers) {
      case 0:
        return {
          label: Object(lodash["get"])(i18n, 'filters.layovers.direct'),
          icon: additionalTransports_constants["i" /* ZERO_LAYOVERS_ICON */]
        };

      case 1:
        return {
          label: "".concat(layovers, " ").concat(Object(lodash["get"])(i18n, 'filters.layovers.stop.label_1')),
          icon: additionalTransports_constants["f" /* ONE_LAYOVERS_ICON */]
        };

      default:
        return {
          label: "".concat(layovers, " ").concat(Object(lodash["get"])(i18n, 'filters.layovers.stop.label_n')),
          icon: additionalTransports_constants["h" /* TWO_LAYOVERS_ICON */]
        };
    }
  };
}

function createLayoversFilters(transports, i18n) {
  var layoversInfo = getLayoversInfo(i18n);
  var layovers = Object(fp["pipe"])([Object(fp["map"])(Object(fp["path"])('filterValues.layovers')), Object(fp["filter"])(fp["isNumber"]), Object(fp["sortBy"])(fp["identity"]), fp["sortedUniq"]])(transports);
  return layovers.map(function (layover) {
    var _layoversInfo = layoversInfo(layover),
        label = _layoversInfo.label,
        icon = _layoversInfo.icon;

    return {
      id: shortid_default.a.generate(),
      category: additionalTransports_constants["e" /* LAYOVERS_CATEGORY */],
      match: STRICT_EQUALITY_MATCHER,
      meta: {
        icon: icon,
        label: label
      },
      path: 'filterValues.layovers',
      selected: false,
      value: layover
    };
  });
}

function getTimeRangeTransformations(timeRanges) {
  return function (pathValue) {
    function getTimeRange(time) {
      return time && timeRanges.find(isTimeInRange(time));
    }

    return [Object(fp["map"])(Object(fp["path"])(pathValue)), Object(fp["map"])(getTimeRange), fp["compact"], fp["uniq"], Object(fp["sortBy"])(function (timeRange) {
      return timeRange.start.hours;
    })];
  };
}

function createTimeRangeFilters(transports, timeRanges) {
  return function (pathValue) {
    var values = Object(fp["pipe"])(getTimeRangeTransformations(timeRanges)(pathValue))(transports);
    return values.map(function (value) {
      return {
        id: shortid_default.a.generate(),
        category: additionalTransports_constants["g" /* TIME_RANGES_CATEGORY */],
        match: TIME_RANGE_MATCHER,
        meta: {
          icon: value.icon,
          label: value.label,
          subLabel: timeRangeToString(value)
        },
        path: pathValue,
        selected: false,
        value: value
      };
    });
  };
}

function createCabinClassFilters(transports, i18n) {
  var cabinClassPath = 'filterValues.cabinClasses';
  var cabinClasses = Object(fp["pipe"])([Object(fp["map"])(Object(fp["path"])('filterValues.cabinClasses')), fp["compact"]])(transports);
  return !Object(lodash["isEmpty"])(cabinClasses) ? [{
    id: shortid_default.a.generate(),
    category: additionalTransports_constants["b" /* CABIN_CLASS_CATEGORY */],
    match: ARRAY_INCLUSION_MATCHER,
    meta: {
      label: Object(lodash["get"])(i18n, 'filters.cabinClass.economy')
    },
    path: cabinClassPath,
    selected: false,
    value: additionalTransports_constants["c" /* CABIN_CLASS_ECO */] // temporairement en dur car on ne récupère que des ECO pour les vols

  }, {
    id: shortid_default.a.generate(),
    category: additionalTransports_constants["b" /* CABIN_CLASS_CATEGORY */],
    match: ARRAY_INCLUSION_MATCHER,
    meta: {
      label: Object(lodash["get"])(i18n, 'filters.cabinClass.business')
    },
    path: cabinClassPath,
    selected: false,
    value: additionalTransports_constants["a" /* CABIN_CLASS_BUSINESS */]
  }] : [];
}

function createFilters(transports, timeRanges, i18n) {
  var timeRangeFilters = createTimeRangeFilters(transports, timeRanges);
  return [].concat(Object(toConsumableArray["a" /* default */])(createCabinClassFilters(transports, i18n)), Object(toConsumableArray["a" /* default */])(createCompaniesFilters(transports)), Object(toConsumableArray["a" /* default */])(createLayoversFilters(transports, i18n)), Object(toConsumableArray["a" /* default */])(timeRangeFilters('filterValues.inboundDepartureTime')), Object(toConsumableArray["a" /* default */])(timeRangeFilters('filterValues.inboundArrivalTime')), Object(toConsumableArray["a" /* default */])(timeRangeFilters('filterValues.outboundDepartureTime')), Object(toConsumableArray["a" /* default */])(timeRangeFilters('filterValues.outboundArrivalTime')));
}

function unselectCategory(filters) {
  return function (category) {
    return filters.map(function (f) {
      return filterUtils_objectSpread(filterUtils_objectSpread({}, f), {}, {
        selected: f.category === category ? false : f.selected
      });
    });
  };
}

function unselectFilters(filters, filtersToDisable) {
  return filters.map(function (f) {
    var filterToDisable = filtersToDisable.find(function (_ref2) {
      var id = _ref2.id;
      return id === f.id;
    });
    return filterUtils_objectSpread(filterUtils_objectSpread({}, f), {}, {
      selected: filterToDisable ? false : f.selected
    });
  });
}


// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/filters/filters.reducer.js




var filters_filters_reducer_initialState = null;
function filters_reducer_filtersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : filters_filters_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var additionalTransports = Object(lodash["get"])(action, 'payload.additionalTransports') || [];
  var getFiltersWithOccurrences = getFiltersWithMatchedOccurrences(additionalTransports);

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalTransports_action["a" /* CLEAR_ADDITIONAL_TRANSPORTS */]:
    case additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]:
      return filters_filters_reducer_initialState;

    case additionalTransports_action["b" /* CREATE_ADDITIONAL_TRANSPORTS_FILTERS */]:
      var i18n = Object(lodash["get"])(action, 'payload.i18n') || {};
      var timeRanges = Object(lodash["get"])(i18n, 'filters.departureArrival.timeRanges') || [];
      var filters = createFilters(additionalTransports, timeRanges, i18n);
      return getFiltersWithOccurrences(filters);

    case additionalTransports_action["f" /* TOGGLE_FILTER */]:
      var filter = Object(lodash["get"])(action, 'payload.filter');
      return toggleFilter(additionalTransports)(state || [], filter);

    case additionalTransports_action["g" /* UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY */]:
      var category = Object(lodash["get"])(action, 'payload.category', '');
      var updatedFilters = unselectCategory(state || [])(category);
      return getFiltersWithOccurrences(updatedFilters);

    case additionalTransports_action["c" /* DISABLE_FILTERS */]:
      var filtersToDisable = Object(lodash["get"])(action, 'payload.filters', []);
      return getFiltersWithOccurrences(unselectFilters(state || [], filtersToDisable));

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/filtered-transports/filteredTransports.reducer.js



var filteredTransports_reducer_initialState = null;

function filteredTransportsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : filteredTransports_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var additionalTransports = Object(lodash["get"])(action, 'payload.additionalTransports') || [];
  var filters = Object(lodash["get"])(action, 'payload.filters') || [];

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalTransports_action["a" /* CLEAR_ADDITIONAL_TRANSPORTS */]:
    case additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]:
      return filteredTransports_reducer_initialState;

    case additionalTransports_action["e" /* SORT_ADDITIONAL_TRANSPORTS */]:
      var sorterPath = Object(lodash["get"])(action, 'payload.sorter.path');
      return Object(lodash["sortBy"])(filterDataSet(additionalTransports, filters), sorterPath);

    case additionalTransports_action["h" /* UPDATE_FILTERED_RESULTS */]:
      return filterDataSet(additionalTransports, filters);

    default:
      return state;
  }
}

/* harmony default export */ var filteredTransports_reducer = (filteredTransportsReducer);
// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/sorters/constants.js
var sorterByPrice = {
  selected: false,
  id: 'best-price',
  name: 'sortByBestPrices',
  path: 'totalDifferentialPrice.value'
};
var sorterByRecommendation = {
  selected: false,
  id: 'recommendation',
  name: 'sortByRecommendation',
  path: ''
};

// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/sorters/sorters.reducer.js


function sorters_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function sorters_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      sorters_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      sorters_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var sorters_reducer_initialState = [sorters_reducer_objectSpread(sorters_reducer_objectSpread({}, sorterByRecommendation), {}, {
  selected: true
}), sorterByPrice];
function sortersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sorters_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalTransports_action["a" /* CLEAR_ADDITIONAL_TRANSPORTS */]:
      return sorters_reducer_initialState;

    case additionalTransports_action["e" /* SORT_ADDITIONAL_TRANSPORTS */]:
      var selectedSorterId = Object(lodash["get"])(action, 'payload.sorter.id');
      return state.map(function (sorter) {
        return sorters_reducer_objectSpread(sorters_reducer_objectSpread({}, sorter), {}, {
          selected: sorter.id === selectedSorterId
        });
      });

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/additionalTransports.reducer.js







/* harmony default export */ var additionalTransports_reducer = (Object(redux["c" /* combineReducers */])({
  error: error_error_reducer,
  isLoading: is_loading_isLoading_reducer,
  transports: transports_reducer,
  filters: filters_reducer_filtersReducer,
  sorters: sortersReducer,
  filteredTransports: filteredTransports_reducer
}));
// CONCATENATED MODULE: ./src/client/store/booking/payment-providers/paymentProviders.reducer.js



var paymentProviders_reducer_initialState = [];

function paymentProvidersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : paymentProviders_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
    case Object(build["resolve"])(proposals_constants["m" /* FETCH_SELECTED_PROPOSAL_PAYMENT */]):
      return Object(lodash["get"])(action, 'payload.paymentProviders', paymentProviders_reducer_initialState);

    default:
      return state;
  }
}

/* harmony default export */ var paymentProviders_reducer = (paymentProvidersReducer);
// CONCATENATED MODULE: ./src/client/store/booking/booking-engine-entry/bookingEngineEntry.reducer.js

var bookingEngineEntry_reducer_initialState = null;
function bookingEngineEntry() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bookingEngineEntry_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case proposals_constants["j" /* FETCH_PROPOSALS */]:
      {
        return action.payload.bookingEngineEntry;
      }

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/attendees/attendees.reducer.js



function attendees_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function attendees_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      attendees_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      attendees_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var attendees_reducer_initialState = {
  adultsAttendees: [],
  kidsAttendees: []
};
function attendeesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : attendees_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case proposals_constants["p" /* PREPARE_BE */]:
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
      {
        var _action$payload = action.payload,
            adultsAttendees = _action$payload.adultsAttendees,
            kidsAttendees = _action$payload.kidsAttendees;
        return attendees_reducer_objectSpread(attendees_reducer_objectSpread({}, state), {}, {
          adultsAttendees: adultsAttendees ? [].concat(Object(toConsumableArray["a" /* default */])(state.adultsAttendees), Object(toConsumableArray["a" /* default */])(adultsAttendees)) : state.adultsAttendees,
          kidsAttendees: kidsAttendees ? [].concat(Object(toConsumableArray["a" /* default */])(state.kidsAttendees), Object(toConsumableArray["a" /* default */])(kidsAttendees)) : state.kidsAttendees
        });
      }

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/suggestions/suggestions.reducer.js


function suggestions_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function suggestions_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      suggestions_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      suggestions_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var suggestions_reducer_initialState = {
  dates: [],
  durations: [],
  resorts: []
};
function suggestionsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : suggestions_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
      {
        var dates = Object(lodash["get"])(action, 'payload.proposals.dateSuggestion', []);
        var durations = Object(lodash["get"])(action, 'payload.proposals.durationSuggestions', []);
        var resorts = Object(lodash["get"])(action, 'payload.proposals.suggestions', []);
        return suggestions_reducer_objectSpread(suggestions_reducer_objectSpread({}, state), {}, {
          dates: dates,
          resorts: resorts,
          durations: durations
        });
      }

    case proposals_constants["f" /* CLEAR_PROPOSALS */]:
      return suggestions_reducer_initialState;

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/booking.reducer.js













var booking = Object(redux["c" /* combineReducers */])({
  additionalAccommodations: additionalAccommodations_reducer_additionalAccommodations,
  additionalTransports: additionalTransports_reducer,
  attendees: attendeesReducer,
  bestProposalId: bestProposalIdReducer,
  bookingEngineEntry: bookingEngineEntry,
  customerSearch: customerSearch_reducer["b" /* customerSearch */],
  insurance: insurance_reducer_insuranceReducer,
  paymentProviders: paymentProviders_reducer,
  proposals: proposalsReducer,
  resort: resortReducer,
  selectedProposalId: selectedProposalId_reducer,
  suggestions: suggestionsReducer
});
// EXTERNAL MODULE: ./src/utils/uri/constants.js
var uri_constants = __webpack_require__("Sj1w");

// EXTERNAL MODULE: ./src/client/store/utils/createReducer.js
var createReducer = __webpack_require__("4Bi9");

// EXTERNAL MODULE: ./src/client/store/calendar/calendar.helper.js
var calendar_helper = __webpack_require__("VtPb");

// CONCATENATED MODULE: ./src/client/store/calendar/calendar.reducer.js


var _createReducer;

function calendar_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function calendar_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      calendar_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      calendar_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}







var calendar_reducer_initialState = {
  basePrice: null,
  byDays: {},
  calendar: {},
  isLoading: true,
  errorResponse: {},
  selectedMonth: Object(calendar_helper["b" /* getDefaultSelectedMonth */])(),
  lastRequestId: -1
};
var calendarReducer = Object(createReducer["a" /* default */])(calendar_reducer_initialState, (_createReducer = {}, Object(defineProperty["a" /* default */])(_createReducer, store_constants["q" /* SYNC_WITH_LOCATION */], function (state, action) {
  var _action$payload$locat = action.payload.location.queryParams,
      queryParams = _action$payload$locat === void 0 ? {} : _action$payload$locat;

  if (!queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]]) {
    return state;
  }

  var selectedMonth = Object(calendar_helper["b" /* getDefaultSelectedMonth */])(queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]] || state.selectedMonth, uri_constants["e" /* QUERY_DATE_FORMAT */]);
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    selectedMonth: selectedMonth
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["e" /* FETCH_CALENDAR */], function (state, action) {
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    isLoading: true,
    lastRequestId: Object(lodash["get"])(action, 'optimist.id', -1)
  });
}), Object(defineProperty["a" /* default */])(_createReducer, Object(build["resolve"])(store_constants["e" /* FETCH_CALENDAR */]), function (state, action) {
  var _action$optimist = action.optimist;
  _action$optimist = _action$optimist === void 0 ? {} : _action$optimist;
  var _action$optimist$id = _action$optimist.id,
      id = _action$optimist$id === void 0 ? -1 : _action$optimist$id,
      calendar = action.payload.calendar; // If there is another request in progress

  if (id !== state.lastRequestId || !calendar) {
    return state;
  }

  var selectedMonth = state.selectedMonth;
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    basePrice: calendar.basePrice,
    byDays: Object(calendar_helper["c" /* getPricesByDays */])(calendar),
    calendar: calendar,
    selectedMonth: Object(calendar_helper["d" /* getSelectedMonth */])(calendar, selectedMonth),
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(_createReducer, Object(build["reject"])(store_constants["e" /* FETCH_CALENDAR */]), function (state, action) {
  var errors = action.payload.errors || '';
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    byDays: {},
    errorResponse: {
      errors: errors
    },
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["c" /* FETCH_BOOKABLE_DATES */], function (state, action) {
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    bookableDatesLoading: true,
    lastRequestId: Object(lodash["get"])(action, 'optimist.id', -1)
  });
}), Object(defineProperty["a" /* default */])(_createReducer, Object(build["resolve"])(store_constants["c" /* FETCH_BOOKABLE_DATES */]), function (state, action) {
  var _action$optimist2 = action.optimist;
  _action$optimist2 = _action$optimist2 === void 0 ? {} : _action$optimist2;
  var _action$optimist2$id = _action$optimist2.id,
      id = _action$optimist2$id === void 0 ? -1 : _action$optimist2$id,
      bookableDates = action.payload.bookableDates;

  if (id !== state.lastRequestId || !bookableDates) {
    return state;
  }

  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    bookableDates: bookableDates,
    bookableDatesLoading: false
  });
}), Object(defineProperty["a" /* default */])(_createReducer, Object(build["reject"])(store_constants["c" /* FETCH_BOOKABLE_DATES */]), function (state, action) {
  var errors = action.payload.errors || '';
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    bookableDates: {},
    errorResponse: {
      errors: errors
    },
    bookableDatesLoading: false
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["a" /* CALENDAR_CHANGE_MONTH */], function (state, action) {
  var selectedMonth = action.payload.selectedMonth || calendar_helper["a" /* INITIAL_MONTH */];
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    selectedMonth: selectedMonth
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["b" /* CLEAR_CALENDAR */], function () {
  return calendar_reducer_initialState;
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["s" /* TRIP_INFORMATION_SET_DEPARTURE_DATE */], function (state, action) {
  if (!action.payload.departureDate) {
    return state;
  }

  var selectedMonth = Object(calendar_helper["b" /* getDefaultSelectedMonth */])(action.payload.departureDate);
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    selectedMonth: selectedMonth
  });
}), _createReducer));
// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/store/cms/cms.actions.js
var cms_actions = __webpack_require__("pP7N");

// CONCATENATED MODULE: ./src/client/store/cms/cms.reducer.js


function cms_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function cms_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      cms_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      cms_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var cms_reducer_initialState = {};
function cmsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : cms_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case Object(build["resolve"])(cms_actions["a" /* GET_BOOKING_ENGINE_I18N */]):
    case cms_actions["b" /* SET_CMS */]:
      {
        var data = Object(lodash["merge"])({}, state, cms_reducer_objectSpread(cms_reducer_objectSpread(cms_reducer_objectSpread({}, Object(lodash["get"])(action, 'payload.config', {})), Object(lodash["get"])(action, 'payload.legalInformations', {})), {}, {
          paymentProviders: Object(lodash["get"])(action, 'payload.paymentProviders', {})
        }));
        Object(src_i18n["a" /* addTranslationKeys */])(data);
        return data;
      }

    default:
      return state;
  }
}
// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./node_modules/entities/index.js
var entities = __webpack_require__("4oK2");

// EXTERNAL MODULE: ./src/utils/date/dateUtils.js
var dateUtils = __webpack_require__("L73y");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var faceting_constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/client/store/faceting/constants.js
var store_faceting_constants = __webpack_require__("9QcM");

// CONCATENATED MODULE: ./src/client/store/faceting/faceting.reducer.js




var faceting_reducer_createReducer;

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return typeof key === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function faceting_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function faceting_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      faceting_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      faceting_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}









var IGNORED_FILTERS_IDS = [faceting_constants["z" /* PRODUCT_FACET_ID */], faceting_constants["m" /* DEPARTURE_DATE_MAX_FACET_ID */], faceting_constants["v" /* LOCALE_FACET_ID */], faceting_constants["f" /* COUNTRIES_FACET_ID */]];

function catalogFacetItemToState(item) {
  return {
    label: item.i18n,
    value: item.filter,
    count: item.freq
  };
} // Pertimm will always send `interpretation_explanation.interpretations` dates
// in the format 'DD/MM/YYYY', for any locale


var PERTIMM_INTERPRETATION_DATE_FORMAT = 'DD/MM/YYYY';
var PERTIMM_DEPARTURE_MIN_DATE = 'departure_date_min';
var PERTIMM_DEPARTURE_MAX_DATE = 'departure_date_max';
/**
 * Takes the Pertimm catalog of facets and restructure it before storage in redux store.
 */

function catalogToState() {
  var catalogs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var catalogIdsAsList = [faceting_constants["j" /* DEPARTURE_CITY_FACET_ID */], faceting_constants["f" /* COUNTRIES_FACET_ID */], faceting_constants["e" /* CHILDCARE_FACET_ID */], faceting_constants["B" /* TYPES_OF_STAY_FACET_ID */], faceting_constants["q" /* FACET_COMFORT_ID */], faceting_constants["p" /* DURATION_FACET */]];
  var catalogIdsAsTree = [faceting_constants["a" /* ACTIVITIES_FACET_ID */], faceting_constants["o" /* DESTINATIONS_FACET_ID */]];
  var facetsAsList = catalogs.filter(function (catalog) {
    return catalogIdsAsList.includes(catalog.id);
  }).map(function (_ref) {
    var id = _ref.id,
        name = _ref.name,
        list = _ref.list;
    return {
      id: id,
      name: name,
      // $FlowFixMe
      list: list.map(catalogFacetItemToState)
    };
  });
  var facetsAsTree = catalogs.filter(function (catalog) {
    return catalogIdsAsTree.includes(catalog.id);
  }).map(function (_ref2) {
    var id = _ref2.id,
        name = _ref2.name,
        tree = _ref2.tree;
    return {
      id: id,
      name: name,
      // $FlowFixMe
      list: tree.map(function (list) {
        return faceting_reducer_objectSpread(faceting_reducer_objectSpread({
          id: list.name
        }, catalogFacetItemToState(list)), {}, {
          list: list.tree.map(catalogFacetItemToState)
        });
      })
    };
  });
  return facetsAsList.concat(facetsAsTree);
}
function filtersToActiveFacetsState() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return filters.reduce(function (acc, filter) {
    var categoryId = filter.id;

    if (faceting_constants["r" /* FILTERABLE_FACETS_IDS */].includes(categoryId)) {
      return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, acc), {}, Object(defineProperty["a" /* default */])({}, categoryId, faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, acc[categoryId]), {}, Object(defineProperty["a" /* default */])({}, filter.value, true))));
    }

    return acc;
  }, {});
}

function sanitizeFilters(filters) {
  return filters.filter(function (filter) {
    return !Object(lodash["includes"])(IGNORED_FILTERS_IDS, Object(lodash["get"])(filter, 'id'));
  });
}

function filtersToState() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return sanitizeFilters(filters).map(function (filter) {
    return {
      id: Object(lodash["get"])(filter, 'id'),
      name: Object(lodash["get"])(filter, 'value'),
      label: Object(lodash["get"])(filter, 'value_i18n'),
      selected: true
    };
  });
}

function parseBanners() {
  var banners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  try {
    return banners.map(function (banner) {
      return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, banner), {}, {
        content: JSON.parse(banner.content)
      });
    });
  } catch (e) {
    return [];
  }
}

function removeUnselectedFiltersFromActiveFacetsState() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var activeFacetsState = arguments.length > 1 ? arguments[1] : undefined;

  var activeFacets = faceting_reducer_objectSpread({}, activeFacetsState);

  var newActiveFacets = {};

  if (filters.length) {
    var _loop = function _loop(categoryId) {
      if (activeFacets.hasOwnProperty(categoryId)) {
        var categoryIdFilter = Object(toConsumableArray["a" /* default */])(filters).filter(function (_ref3) {
          var id = _ref3.id;
          return id === categoryId;
        });

        if (categoryIdFilter.length) {
          newActiveFacets[categoryId] = {};

          var _loop2 = function _loop2(categoryName) {
            if (activeFacets[categoryId].hasOwnProperty(categoryName) && // $FlowFixMe
            categoryIdFilter.some(function (_ref4) {
              var name = _ref4.name,
                  id = _ref4.id;
              return name === categoryName && id === categoryId;
            })) {
              newActiveFacets[categoryId][categoryName] = activeFacets[categoryId][categoryName];
            }
          };

          for (var categoryName in activeFacets[categoryId]) {
            _loop2(categoryName);
          }
        }
      }
    };

    for (var categoryId in activeFacets) {
      _loop(categoryId);
    }
  }

  return newActiveFacets;
}
var faceting_reducer_initialState = {
  // Special pertimm marchandising rules with pre-parameterized criteria
  // such as `minDate` / `maxDate` for some user queries such as `noel`.
  pertimmInterpretations: {},
  products: [],
  recommandedProducts: [],
  facets: [],
  activeFacets: {},
  childcareAvailabilities: [],
  filters: [],
  query: {
    label: ''
  },
  redirection: null,
  scrollToResults: false,
  isLoading: true,
  isPriceLoading: true,
  isLoadingChildcareAvailabilities: false,
  isSearchEnabled: false,
  isSelectionModeEnabled: false,
  kidsValidationState: [],
  productsSelectedForComparison: [],
  prices: [],
  noResults: false,
  lastRequestId: -1,
  lastRecommandedRequestId: -1,
  isDateRequired: false
};
var facetingReducer = Object(createReducer["a" /* default */])(faceting_reducer_initialState, (faceting_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["e" /* FACETING_RESET_REDIRECTION */], function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    redirection: null
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["f" /* FACETING_RESET_SEARCH */], function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    products: [],
    prices: [],
    childcareAvailabilities: [],
    redirection: null,
    scrollToResults: false,
    isLoading: true,
    noResults: false,
    searchIsEnabled: false
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["c" /* FACETING_LOAD_PRODUCTS_REQUEST */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    childcareAvailabilities: [],
    isLoading: true,
    lastRecommandedRequestId: Object(lodash["get"])(action, 'optimist.id', -1),
    recommandedProducts: [],
    noResults: true,
    prices: []
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["resolve"])(store_faceting_constants["c" /* FACETING_LOAD_PRODUCTS_REQUEST */]), function (state, action) {
  var _action$optimist; // If there is another request in progress


  if ((action === null || action === void 0 ? void 0 : (_action$optimist = action.optimist) === null || _action$optimist === void 0 ? void 0 : _action$optimist.id) !== state.lastRecommandedRequestId) {
    return state;
  }

  var resorts = action.payload.resorts;
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    recommandedProducts: resorts,
    noResults: true
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["reject"])(store_faceting_constants["c" /* FACETING_LOAD_PRODUCTS_REQUEST */]), function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    noResults: true
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["g" /* FACETING_SEARCH_REQUEST */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    childcareAvailabilities: [],
    isLoading: true,
    lastRequestId: Object(lodash["get"])(action, 'optimist.id', -1),
    noResults: false,
    prices: []
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["resolve"])(store_faceting_constants["g" /* FACETING_SEARCH_REQUEST */]), function (state, action) {
  // If there is another request in progress
  if (Object(lodash["get"])(action, 'optimist.id') !== state.lastRequestId) {
    return state;
  }

  var products = action.payload.search.products;
  var productsSelectedForComparison = Object(lodash["get"])(state, 'productsSelectedForComparison', []).filter(function (selectedProductId) {
    return products.some(function (product) {
      return product.id === selectedProductId;
    });
  });
  var pertimmInterpretations = Object(lodash["get"])(action.payload, 'interpretation_explanation.interpretations', []).reduce(function (acc, interpretation) {
    if (interpretation.filter_name === PERTIMM_DEPARTURE_MIN_DATE) {
      acc.minDate = Object(dateUtils["d" /* getTimestamp */])(interpretation.filter_value, PERTIMM_INTERPRETATION_DATE_FORMAT);
    }

    if (interpretation.filter_name === PERTIMM_DEPARTURE_MAX_DATE) {
      acc.maxDate = Object(dateUtils["d" /* getTimestamp */])(interpretation.filter_value, PERTIMM_INTERPRETATION_DATE_FORMAT);
    }

    return acc;
  }, {});
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    banners: parseBanners(action.payload.banners),
    pertimmInterpretations: pertimmInterpretations,
    // If the catalog of facets is empty (e.g. "no results"), keep the previous state
    facets: !Object(lodash["isEmpty"])(action.payload.catalogs) ? catalogToState(action.payload.catalogs) : state.facets,
    activeFacets: filtersToActiveFacetsState(action.payload.filters),
    isLoading: false,
    filters: filtersToState(action.payload.filters),
    products: products,
    query: faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state.query), {}, {
      label: Object(entities["decodeHTML"])(action.payload.query)
    }),
    redirection: action.payload.redirection,
    productsSelectedForComparison: productsSelectedForComparison,
    noResults: !action.payload.redirection && products.length === 0
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["reject"])(store_faceting_constants["g" /* FACETING_SEARCH_REQUEST */]), function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    noResults: true
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["d" /* FACETING_PRICES_REQUEST */], function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isPriceLoading: true,
    prices: []
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["resolve"])(store_faceting_constants["d" /* FACETING_PRICES_REQUEST */]), function (state, action) {
  var resorts = action.payload.resorts;
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isPriceLoading: false,
    prices: resorts,
    scrollToResults: false
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["reject"])(store_faceting_constants["d" /* FACETING_PRICES_REQUEST */]), function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isPriceLoading: false,
    prices: [],
    scrollToResults: true
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["a" /* FACETING_CHILDCARE_REQUEST */], function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isLoadingChildcareAvailabilities: true,
    childcareAvailabilities: []
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["resolve"])(store_faceting_constants["a" /* FACETING_CHILDCARE_REQUEST */]), function (state, action) {
  var childcareSearch = action.payload.childcareSearch;
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isLoadingChildcareAvailabilities: false,
    childcareAvailabilities: childcareSearch
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["reject"])(store_faceting_constants["a" /* FACETING_CHILDCARE_REQUEST */]), function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isLoadingChildcareAvailabilities: false,
    childcareAvailabilities: []
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["h" /* FACETING_SET_FILTERS */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    filters: action.payload.filters
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["i" /* FACETING_SET_INITIAL_PRICES */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    prices: action.payload.initialProductPrices,
    isPriceLoading: false
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["k" /* FACETING_SET_IS_SEARCH_ENABLED */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isSearchEnabled: action.payload.isSearchEnabled
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["l" /* FACETING_SET_KIDS_VALIDATION_STATE */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    kidsValidationState: action.payload.kidsValidationState
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["m" /* FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isSelectionModeEnabled: action.payload.enable,
    productsSelectedForComparison: []
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["q" /* FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON */], function (state, action) {
  var productsCurrentlySelected = Object(lodash["get"])(state, 'productsSelectedForComparison');
  var productToBeToggled = Object(lodash["get"])(action, 'payload.productId', null);

  if (!productToBeToggled) {
    return state;
  }

  if (Object(lodash["includes"])(productsCurrentlySelected, productToBeToggled)) {
    return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
      productsSelectedForComparison: productsCurrentlySelected.filter(function (p) {
        return p !== productToBeToggled;
      })
    });
  }

  if (productsCurrentlySelected.length < faceting_constants["w" /* MAX_NUMBER_OF_SELECTED_PRODUCTS */]) {
    return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
      productsSelectedForComparison: [].concat(Object(toConsumableArray["a" /* default */])(productsCurrentlySelected), [productToBeToggled])
    });
  }

  return state;
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_constants["q" /* SYNC_WITH_LOCATION */], function (state, action) {
  var _action$payload = action.payload;
  _action$payload = _action$payload === void 0 ? {} : _action$payload;
  var queryParams = _action$payload.location.queryParams;

  if (!queryParams[faceting_constants["A" /* QUERY_QUERY_PARAM */]]) {
    return state;
  }

  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    query: faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state.query), {}, {
      label: queryParams[faceting_constants["A" /* QUERY_QUERY_PARAM */]]
    })
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["n" /* FACETING_SET_SEARCH_QUERY */], function (state, _ref5) {
  var value = _ref5.payload.value;

  if (Object(lodash["isUndefined"])(value)) {
    return state;
  }

  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    query: faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, value), {}, {
      label: Object(entities["decodeHTML"])(value.label)
    })
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["b" /* FACETING_CLEAR_FACETS */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    activeFacets: faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state.activeFacets), {}, Object(defineProperty["a" /* default */])({}, action.payload.categoryId, {}))
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["o" /* FACETING_TOGGLE_FACET_SELECTED */], function (state, action) {
  var facet = action.payload;
  var categoryActiveFacets = state.activeFacets[facet.categoryId];
  var newState;

  if (facet.isSelected) {
    // lodash/fp
    // return set(`activeFacets.${facet.category}.${facet.value}`, action.payload.isSelected, state);
    newState = faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, categoryActiveFacets), {}, Object(defineProperty["a" /* default */])({}, facet.value, facet.isSelected));
  } else {
    var _facet$value = facet.value,
        _ = categoryActiveFacets[_facet$value],
        rest = Object(objectWithoutProperties["a" /* default */])(categoryActiveFacets, [_facet$value].map(_toPropertyKey)); // eslint-disable-line


    newState = rest;
  }

  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    activeFacets: faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state.activeFacets), {}, Object(defineProperty["a" /* default */])({}, facet.categoryId, faceting_reducer_objectSpread({}, newState)))
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["j" /* FACETING_SET_IS_DATE_REQUIRED */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isDateRequired: action.payload.isDateRequired
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["r" /* FACETING_UPDATE_FILTERS */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    filters: action.payload.filters,
    activeFacets: removeUnselectedFiltersFromActiveFacetsState( // $FlowFixMe
    action.payload.filters, state.activeFacets)
  });
}), faceting_reducer_createReducer));
// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// CONCATENATED MODULE: ./src/client/store/faceting-trip-information/facetingTripInformation.reducer.js






var facetingTripInformation_reducer_initialState = {
  departureCities: []
};
var facetingTripInformation = Object(createReducer["a" /* default */])(facetingTripInformation_reducer_initialState, Object(defineProperty["a" /* default */])({}, Object(build["resolve"])(store_faceting_constants["g" /* FACETING_SEARCH_REQUEST */]), function (state, action) {
  return {
    departureCities: Object(facetingUtils["c" /* getDepartureCities */])(Object(lodash["get"])(action, 'payload.catalogs', []))
  };
}));
/* harmony default export */ var facetingTripInformation_reducer = (facetingTripInformation);
// EXTERNAL MODULE: ./src/client/store/global-loader/globalLoader.action.js
var globalLoader_action = __webpack_require__("R2jv");

// CONCATENATED MODULE: ./src/client/store/global-loader/label/label.reducer.js




var label_reducer_initialState = '';
/* harmony default export */ var label_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : label_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case globalLoader_action["b" /* START_LOADING */]:
    case proposals_constants["a" /* ADD_ACCOMMODATION */]:
    case proposals_constants["e" /* ADD_TRANSPORT */]:
    case proposals_constants["j" /* FETCH_PROPOSALS */]:
    case proposals_constants["l" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]:
      return Object(lodash["get"])(action, 'payload.globalLoaderLabel', null);

    case globalLoader_action["a" /* END_LOADING */]:
    case Object(build["resolve"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case Object(build["reject"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case Object(build["resolve"])(proposals_constants["e" /* ADD_TRANSPORT */]):
    case Object(build["reject"])(proposals_constants["e" /* ADD_TRANSPORT */]):
    case Object(build["reject"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["l" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]):
    case Object(build["reject"])(proposals_constants["l" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]):
      return label_reducer_initialState;

    default:
      return state;
  }
});
// CONCATENATED MODULE: ./src/client/store/global-loader/navigation/navigation.reducer.js

var navigation_reducer_initialState = false;
var navigation_reducer_isNavigation = function isNavigation() {
  var _action$payload;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigation_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action === null || action === void 0 ? void 0 : action.type) {
    case globalLoader_action["b" /* START_LOADING */]:
      return !!(action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.isNavigation);

    case globalLoader_action["a" /* END_LOADING */]:
      return navigation_reducer_initialState;

    default:
      return state;
  }
};
// CONCATENATED MODULE: ./src/client/store/global-loader/should-display/shouldDisplay.reducer.js




var shouldDisplay_reducer_initialState = false;
/* harmony default export */ var shouldDisplay_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : shouldDisplay_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case globalLoader_action["b" /* START_LOADING */]:
    case proposals_constants["a" /* ADD_ACCOMMODATION */]:
    case proposals_constants["e" /* ADD_TRANSPORT */]:
    case proposals_constants["j" /* FETCH_PROPOSALS */]:
    case proposals_constants["m" /* FETCH_SELECTED_PROPOSAL_PAYMENT */]:
    case proposals_constants["t" /* SAVE_CUSTOMER_PROPOSAL */]:
    case proposals_constants["l" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]:
      return true;

    case globalLoader_action["a" /* END_LOADING */]:
    case Object(build["resolve"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case Object(build["reject"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case Object(build["resolve"])(proposals_constants["e" /* ADD_TRANSPORT */]):
    case Object(build["reject"])(proposals_constants["e" /* ADD_TRANSPORT */]):
    case Object(build["reject"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["m" /* FETCH_SELECTED_PROPOSAL_PAYMENT */]):
    case Object(build["reject"])(proposals_constants["m" /* FETCH_SELECTED_PROPOSAL_PAYMENT */]):
    case Object(build["resolve"])(proposals_constants["t" /* SAVE_CUSTOMER_PROPOSAL */]):
    case Object(build["reject"])(proposals_constants["t" /* SAVE_CUSTOMER_PROPOSAL */]):
    case Object(build["resolve"])(proposals_constants["l" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]):
    case Object(build["reject"])(proposals_constants["l" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]):
      return false;

    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
      return Object(lodash["get"])(action, 'payload.proposals.errors') ? false : state;

    default:
      return state;
  }
});
// CONCATENATED MODULE: ./src/client/store/global-loader/globalLoader.reducer.js




/* harmony default export */ var globalLoader_reducer = (Object(redux["c" /* combineReducers */])({
  isNavigation: navigation_reducer_isNavigation,
  label: label_reducer,
  shouldDisplay: shouldDisplay_reducer
}));
// EXTERNAL MODULE: ./src/client/components/widgets/profile-info/travel-companions/travelCompanions.reducer.js
var travelCompanions_reducer = __webpack_require__("xAOE");

// CONCATENATED MODULE: ./src/client/components/widgets/childcare-layer/ChildcareLayer.reducer.js


var ChildcareLayer_reducer_createReducer;

function ChildcareLayer_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function ChildcareLayer_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ChildcareLayer_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ChildcareLayer_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var FETCH_BOOKING_CHILDCARE = 'FETCH_BOOKING_CHILDCARE';
var UPDATE_CART = 'UPDATE_CART';
var ChildcareLayer_reducer_initialState = {
  data: [],
  isLoading: false,
  isLoaded: false,
  errorResponse: {}
};
var childcareLayerReducer = Object(createReducer["a" /* default */])(ChildcareLayer_reducer_initialState, (ChildcareLayer_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(ChildcareLayer_reducer_createReducer, FETCH_BOOKING_CHILDCARE, function (state) {
  return ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(ChildcareLayer_reducer_createReducer, Object(build["resolve"])(FETCH_BOOKING_CHILDCARE), function (state, action) {
  return ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    data: Object(lodash["get"])(action, 'payload', {}),
    errorResponse: {}
  });
}), Object(defineProperty["a" /* default */])(ChildcareLayer_reducer_createReducer, Object(build["reject"])(FETCH_BOOKING_CHILDCARE), function (state, action) {
  return ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: false,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(ChildcareLayer_reducer_createReducer, Object(build["resolve"])(UPDATE_CART), function (state, action) {
  return ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread({}, state), {}, {
    data: ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread({}, state.data), {}, {
      userBooking: ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread({}, state.data.userBooking), action.payload.addServiceCart), action.payload.removeServiceCart)
    })
  });
}), Object(defineProperty["a" /* default */])(ChildcareLayer_reducer_createReducer, Object(build["reject"])(UPDATE_CART), function (state, action) {
  return ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread({}, state), {}, {
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), ChildcareLayer_reducer_createReducer));
// EXTERNAL MODULE: ./src/client/components/widgets/cart/bookingCart.reducer.js
var bookingCart_reducer = __webpack_require__("xl1w");

// EXTERNAL MODULE: ./src/client/store/member-space/booking/booking.constants.js
var booking_constants = __webpack_require__("R3QM");

// CONCATENATED MODULE: ./src/client/store/member-space/booking/details/details.reducer.js


var details_reducer_createReducer;

function details_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function details_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      details_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      details_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */





var details_reducer_initialState = {
  data: null,
  isLoading: true,
  isLoaded: false,
  isOnError: false,
  errorResponse: null
};
/* harmony default export */ var details_reducer = (Object(createReducer["a" /* default */])(details_reducer_initialState, (details_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(details_reducer_createReducer, booking_constants["l" /* FETCH_BOOKING_DETAILS */], function (state) {
  return details_reducer_objectSpread(details_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(details_reducer_createReducer, booking_constants["n" /* FETCH_BOOKING_DETAILS_RESOLVED */], function (state, action) {
  return details_reducer_objectSpread(details_reducer_objectSpread({}, state), {}, {
    data: Object(lodash["get"])(action, 'payload.userBooking'),
    isLoaded: true,
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(details_reducer_createReducer, booking_constants["m" /* FETCH_BOOKING_DETAILS_REJECTED */], function (state, action) {
  return details_reducer_objectSpread(details_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    isOnError: true,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(details_reducer_createReducer, booking_constants["b" /* CLEAR_BOOKING_DETAILS */], function () {
  return details_reducer_initialState;
}), details_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/booking/package/package.reducer.js


var package_reducer_createReducer;

function package_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function package_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      package_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      package_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */





var package_reducer_initialState = {
  data: null,
  isLoading: false,
  isLoaded: false,
  isOnError: false,
  errorResponse: null
};
/* harmony default export */ var package_reducer = (Object(createReducer["a" /* default */])(package_reducer_initialState, (package_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(package_reducer_createReducer, booking_constants["i" /* FETCH_BOOKING_ATTENDEES_PACKAGE */], function (state) {
  return package_reducer_objectSpread(package_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(package_reducer_createReducer, booking_constants["k" /* FETCH_BOOKING_ATTENDEES_PACKAGE_RESOLVED */], function (state, action) {
  return package_reducer_objectSpread(package_reducer_objectSpread({}, state), {}, {
    data: {
      attendees: Object(lodash["get"])(action, 'payload.userBooking.attendees') || [],
      "package": Object(lodash["get"])(action, 'payload.package')
    },
    isLoaded: true,
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(package_reducer_createReducer, booking_constants["j" /* FETCH_BOOKING_ATTENDEES_PACKAGE_REJECTED */], function (state, action) {
  return package_reducer_objectSpread(package_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    isOnError: true,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(package_reducer_createReducer, booking_constants["a" /* CLEAR_BOOKING_ATTENDEES_PACKAGE */], function () {
  return package_reducer_initialState;
}), package_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/booking/price-and-payment/priceAndPayment.reducer.js


var priceAndPayment_reducer_createReducer;

function priceAndPayment_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function priceAndPayment_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      priceAndPayment_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      priceAndPayment_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */





var priceAndPayment_reducer_initialState = {
  data: null,
  isLoading: false,
  isLoaded: false,
  isOnError: false,
  errorResponse: null
};
/* harmony default export */ var priceAndPayment_reducer = (Object(createReducer["a" /* default */])(priceAndPayment_reducer_initialState, (priceAndPayment_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(priceAndPayment_reducer_createReducer, booking_constants["o" /* FETCH_BOOKING_PRICE_AND_PAYMENT */], function (state) {
  return priceAndPayment_reducer_objectSpread(priceAndPayment_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(priceAndPayment_reducer_createReducer, booking_constants["q" /* FETCH_BOOKING_PRICE_AND_PAYMENT_RESOLVED */], function (state, action) {
  return priceAndPayment_reducer_objectSpread(priceAndPayment_reducer_objectSpread({}, state), {}, {
    data: priceAndPayment_reducer_objectSpread(priceAndPayment_reducer_objectSpread({}, state.data), {}, {
      priceDetails: Object(lodash["get"])(action, 'payload.userBooking.priceDetails'),
      paymentDetails: Object(lodash["get"])(action, 'payload.userBooking.paymentDetails')
    }),
    isLoaded: true,
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(priceAndPayment_reducer_createReducer, booking_constants["p" /* FETCH_BOOKING_PRICE_AND_PAYMENT_REJECTED */], function (state, action) {
  return priceAndPayment_reducer_objectSpread(priceAndPayment_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    isOnError: true,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(priceAndPayment_reducer_createReducer, booking_constants["c" /* CLEAR_BOOKING_PRICE_AND_PAYMENT */], function () {
  return priceAndPayment_reducer_initialState;
}), priceAndPayment_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/booking/transport/transport.reducer.js


var transport_reducer_createReducer;

function transport_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function transport_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      transport_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      transport_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */





var transport_reducer_initialState = {
  data: null,
  isLoading: false,
  isLoaded: false,
  isOnError: false,
  errorResponse: null
};
/* harmony default export */ var transport_reducer = (Object(createReducer["a" /* default */])(transport_reducer_initialState, (transport_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(transport_reducer_createReducer, booking_constants["u" /* FETCH_BOOKING_TRANSPORT */], function (state) {
  return transport_reducer_objectSpread(transport_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(transport_reducer_createReducer, booking_constants["w" /* FETCH_BOOKING_TRANSPORT_RESOLVED */], function (state, action) {
  return transport_reducer_objectSpread(transport_reducer_objectSpread({}, state), {}, {
    data: Object(lodash["get"])(action, 'payload.userBooking.transports'),
    isLoaded: true,
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(transport_reducer_createReducer, booking_constants["v" /* FETCH_BOOKING_TRANSPORT_REJECTED */], function (state, action) {
  return transport_reducer_objectSpread(transport_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    isOnError: true,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(transport_reducer_createReducer, booking_constants["e" /* CLEAR_BOOKING_TRANSPORT */], function () {
  return transport_reducer_initialState;
}), transport_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/booking/modals/childcare/childcare.reducer.js


var childcare_reducer_createReducer;

function childcare_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function childcare_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      childcare_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      childcare_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */




var childcare_reducer_initialState = {
  data: {
    isVisible: false,
    activity: null
  }
};
/* harmony default export */ var childcare_reducer = (Object(createReducer["a" /* default */])(childcare_reducer_initialState, (childcare_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(childcare_reducer_createReducer, booking_constants["z" /* OPEN_CHILDCARE_INFORMATIONS_MODAL */], function (state, _ref) {
  var payload = _ref.payload;
  return childcare_reducer_objectSpread(childcare_reducer_objectSpread({}, state), {}, {
    data: childcare_reducer_objectSpread(childcare_reducer_objectSpread({}, state.data), {}, {
      isVisible: true,
      activity: payload.activity
    })
  });
}), Object(defineProperty["a" /* default */])(childcare_reducer_createReducer, booking_constants["g" /* CLOSE_CHILDCARE_INFORMATIONS_MODAL */], function () {
  return childcare_reducer_initialState;
}), childcare_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/booking/modals/package-upsell/packageUpsell.reducer.js


var packageUpsell_reducer_createReducer;

function packageUpsell_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function packageUpsell_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      packageUpsell_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      packageUpsell_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */





var packageUpsell_reducer_initialState = {
  content: null,
  isOpen: false
};
/* harmony default export */ var packageUpsell_reducer = (Object(createReducer["a" /* default */])(packageUpsell_reducer_initialState, (packageUpsell_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(packageUpsell_reducer_createReducer, booking_constants["A" /* OPEN_PACKAGE_UPSELL_INFORMATIONS_MODAL */], function (state, _ref) {
  var payload = _ref.payload;
  return packageUpsell_reducer_objectSpread(packageUpsell_reducer_objectSpread({}, state), {}, {
    isOpen: true,
    content: Object(lodash["get"])(state, "package_".concat(payload.productId, "_").concat(payload.packageId))
  });
}), Object(defineProperty["a" /* default */])(packageUpsell_reducer_createReducer, booking_constants["h" /* CLOSE_PACKAGE_UPSELL_INFORMATIONS_MODAL */], function (state) {
  return packageUpsell_reducer_objectSpread(packageUpsell_reducer_objectSpread({}, state), {}, {
    isOpen: false,
    content: null
  });
}), Object(defineProperty["a" /* default */])(packageUpsell_reducer_createReducer, booking_constants["y" /* FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL_RESOLVED */], function (state, _ref2) {
  var payload = _ref2.payload;
  return packageUpsell_reducer_objectSpread(packageUpsell_reducer_objectSpread({}, state), {}, Object(defineProperty["a" /* default */])({}, "package_".concat(payload["package"].productId, "_").concat(payload["package"].id), payload["package"]));
}), Object(defineProperty["a" /* default */])(packageUpsell_reducer_createReducer, booking_constants["f" /* CLEAR_PACKAGE_UPSELL_INFORMATIONS_MODAL */], function () {
  return packageUpsell_reducer_initialState;
}), packageUpsell_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/booking/modals/modals.reducer.js



/* harmony default export */ var modals_reducer = (Object(redux["c" /* combineReducers */])({
  childcare: childcare_reducer,
  packageUpsell: packageUpsell_reducer
}));
// CONCATENATED MODULE: ./src/client/store/member-space/booking/stay-formalities/stayFormalities.reducer.js


var stayFormalities_reducer_createReducer;

function stayFormalities_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function stayFormalities_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      stayFormalities_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      stayFormalities_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */





var stayFormalities_reducer_initialState = {
  data: null,
  isLoading: false,
  isLoaded: false,
  isOnError: false,
  errorResponse: null
};
/* harmony default export */ var stayFormalities_reducer = (Object(createReducer["a" /* default */])(stayFormalities_reducer_initialState, (stayFormalities_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(stayFormalities_reducer_createReducer, booking_constants["r" /* FETCH_BOOKING_STAY_FORMALITIES */], function (state) {
  return stayFormalities_reducer_objectSpread(stayFormalities_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(stayFormalities_reducer_createReducer, booking_constants["t" /* FETCH_BOOKING_STAY_FORMALITIES_RESOLVED */], function (state, action) {
  return stayFormalities_reducer_objectSpread(stayFormalities_reducer_objectSpread({}, state), {}, {
    data: Object(lodash["get"])(action, 'payload.userBooking.stayFormalities') || [],
    isLoaded: true,
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(stayFormalities_reducer_createReducer, booking_constants["s" /* FETCH_BOOKING_STAY_FORMALITIES_REJECTED */], function (state, action) {
  return stayFormalities_reducer_objectSpread(stayFormalities_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    isOnError: true,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(stayFormalities_reducer_createReducer, booking_constants["d" /* CLEAR_BOOKING_STAY_FORMALITIES */], function () {
  return stayFormalities_reducer_initialState;
}), stayFormalities_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/booking/booking.reducer.js







/* harmony default export */ var booking_reducer = (Object(redux["c" /* combineReducers */])({
  details: details_reducer,
  packageUpsell: package_reducer,
  priceAndPayment: priceAndPayment_reducer,
  transport: transport_reducer,
  modals: modals_reducer,
  stayFormalities: stayFormalities_reducer
}));
// EXTERNAL MODULE: ./src/client/store/member-space/constants.helper.js
var constants_helper = __webpack_require__("30WP");

// CONCATENATED MODULE: ./src/client/store/member-space/pre-payment/prePayment.constants.js


var PRE_PAYMENT_DETAILS = 'PRE_PAYMENT/DETAILS';
var PRE_PAYMENT_PAYLOAD_DATAS = 'PRE_PAYMENT/PAYLOAD_DATAS';
var FETCH_PRE_PAYMENT_DETAILS = Object(constants_helper["c" /* fetch */])(PRE_PAYMENT_DETAILS);
var FETCH_PRE_PAYMENT_DETAILS_RESOLVED = Object(build["resolve"])(FETCH_PRE_PAYMENT_DETAILS);
var FETCH_PRE_PAYMENT_DETAILS_REJECTED = Object(build["reject"])(FETCH_PRE_PAYMENT_DETAILS);
var CLEAR_PRE_PAYMENT_DETAILS = Object(constants_helper["a" /* clear */])(PRE_PAYMENT_DETAILS);
var SET_PRE_PAYMENT_PROVIDER = 'SET_PRE_PAYMENT_PROVIDER';
var SET_PRE_PAYMENT_PAYMENT_METHOD_ID = 'SET_PRE_PAYMENT_PAYMENT_METHOD_ID';
var SET_PRE_PAYMENT_PAYMENT_METHOD_CONDITION_ID = 'SET_PRE_PAYMENT_PAYMENT_METHOD_CONDITION_ID';
var CLEAR_PRE_PAYMENT_BUTTON = 'CLEAR_PRE_PAYMENT_BUTTON';
var FETCH_PRE_PAYMENT_PAYLOAD_DATAS = Object(constants_helper["c" /* fetch */])(PRE_PAYMENT_PAYLOAD_DATAS);
var FETCH_PRE_PAYMENT_PAYLOAD_DATAS_RESOLVED = Object(build["resolve"])(FETCH_PRE_PAYMENT_PAYLOAD_DATAS);
var FETCH_PRE_PAYMENT_PAYLOAD_DATAS_REJECTED = Object(build["reject"])(FETCH_PRE_PAYMENT_PAYLOAD_DATAS);
var CLEAR_PRE_PAYMENT_PAYLOAD_DATAS = Object(constants_helper["a" /* clear */])(PRE_PAYMENT_PAYLOAD_DATAS);
// CONCATENATED MODULE: ./src/client/store/member-space/pre-payment/details/details.reducer.js


var details_details_reducer_createReducer;

function details_details_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function details_details_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      details_details_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      details_details_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var details_details_reducer_initialState = {
  data: null,
  isLoading: true,
  isLoaded: false,
  isOnError: false,
  errorResponse: null
};
/* harmony default export */ var details_details_reducer = (Object(createReducer["a" /* default */])(details_details_reducer_initialState, (details_details_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(details_details_reducer_createReducer, FETCH_PRE_PAYMENT_DETAILS, function (state) {
  return details_details_reducer_objectSpread(details_details_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(details_details_reducer_createReducer, FETCH_PRE_PAYMENT_DETAILS_RESOLVED, function (state, action) {
  return details_details_reducer_objectSpread(details_details_reducer_objectSpread({}, state), {}, {
    data: Object(lodash["get"])(action, 'payload'),
    isLoaded: true,
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(details_details_reducer_createReducer, FETCH_PRE_PAYMENT_DETAILS_REJECTED, function (state, action) {
  return details_details_reducer_objectSpread(details_details_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    isOnError: true,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(details_details_reducer_createReducer, CLEAR_PRE_PAYMENT_DETAILS, function () {
  return details_details_reducer_initialState;
}), details_details_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/pre-payment/button/button.reducer.js


var button_reducer_createReducer;

function button_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function button_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      button_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      button_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var button_reducer_initialState = {
  selectedProviderId: null,
  paymentMethodId: null,
  paymentConditionId: null
};
/* harmony default export */ var button_reducer = (Object(createReducer["a" /* default */])(button_reducer_initialState, (button_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(button_reducer_createReducer, SET_PRE_PAYMENT_PROVIDER, function (state, _ref) {
  var payload = _ref.payload;
  return button_reducer_objectSpread(button_reducer_objectSpread({}, state), {}, {
    selectedProviderId: payload.providerId
  });
}), Object(defineProperty["a" /* default */])(button_reducer_createReducer, SET_PRE_PAYMENT_PAYMENT_METHOD_ID, function (state, _ref2) {
  var payload = _ref2.payload;
  return button_reducer_objectSpread(button_reducer_objectSpread({}, state), {}, {
    paymentMethodId: payload.id
  });
}), Object(defineProperty["a" /* default */])(button_reducer_createReducer, SET_PRE_PAYMENT_PAYMENT_METHOD_CONDITION_ID, function (state, _ref3) {
  var payload = _ref3.payload;
  return button_reducer_objectSpread(button_reducer_objectSpread({}, state), {}, {
    paymentConditionId: payload.conditionId
  });
}), Object(defineProperty["a" /* default */])(button_reducer_createReducer, CLEAR_PRE_PAYMENT_BUTTON, function () {
  return button_reducer_initialState;
}), button_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/pre-payment/prePayment.reducer.js



/* harmony default export */ var prePayment_reducer = (Object(redux["c" /* combineReducers */])({
  details: details_details_reducer,
  button: button_reducer
}));
// EXTERNAL MODULE: ./src/client/store/member-space/customer/customer.constants.js
var customer_constants = __webpack_require__("CDVU");

// CONCATENATED MODULE: ./src/client/store/member-space/customer/customer.reducer.js


var customer_reducer_createReducer;

function customer_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function customer_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      customer_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      customer_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var customer_reducer_initialState = {
  data: null,
  isLoading: false,
  isLoaded: false,
  isOnError: false,
  errorResponse: null
};
/* harmony default export */ var customer_reducer = (Object(createReducer["a" /* default */])(customer_reducer_initialState, (customer_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(customer_reducer_createReducer, customer_constants["a" /* FETCH_CUSTOMER */], function (state) {
  return customer_reducer_objectSpread(customer_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(customer_reducer_createReducer, customer_constants["c" /* FETCH_CUSTOMER_RESOLVED */], function (state, action) {
  return customer_reducer_objectSpread(customer_reducer_objectSpread({}, state), {}, {
    data: Object(lodash["get"])(action, 'payload'),
    isLoaded: true,
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(customer_reducer_createReducer, customer_constants["b" /* FETCH_CUSTOMER_REJECTED */], function (state, action) {
  return customer_reducer_objectSpread(customer_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    isOnError: true,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), customer_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/user-searches/userSearches.reducer.js


var userSearches_reducer_createReducer;

function userSearches_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function userSearches_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      userSearches_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      userSearches_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */






var userSearches_reducer_initialState = {
  data: {
    bookings: []
  },
  isLoading: false,
  isLoaded: false,
  errorResponse: {}
};
/* harmony default export */ var userSearches_reducer = (Object(createReducer["a" /* default */])(userSearches_reducer_initialState, (userSearches_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(userSearches_reducer_createReducer, store_constants["l" /* FETCH_USER_SEARCHES */], function (state) {
  return userSearches_reducer_objectSpread(userSearches_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(userSearches_reducer_createReducer, store_constants["m" /* FETCH_USER_SEARCHES_RESOLVED */], function (state, action) {
  var fetchedTripsList = Object(lodash["get"])(action, 'payload.bookings', []);
  return userSearches_reducer_objectSpread(userSearches_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    data: {
      bookings: fetchedTripsList
    }
  });
}), Object(defineProperty["a" /* default */])(userSearches_reducer_createReducer, Object(build["reject"])(store_constants["l" /* FETCH_USER_SEARCHES */]), function (state, action) {
  return userSearches_reducer_objectSpread(userSearches_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: false,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), userSearches_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/future-trips/futureTrips.reducer.js


var futureTrips_reducer_createReducer;

function futureTrips_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function futureTrips_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      futureTrips_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      futureTrips_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */






var futureTrips_reducer_initialState = {
  data: {
    bookings: []
  },
  isLoading: false,
  isLoaded: false,
  errorResponse: {},
  hasNextPage: false,
  currentPage: 1,
  nextPage: 2
};
/* harmony default export */ var futureTrips_reducer = (Object(createReducer["a" /* default */])(futureTrips_reducer_initialState, (futureTrips_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(futureTrips_reducer_createReducer, store_constants["h" /* FETCH_USER_FUTURE_TRIPS_FETCHED */], function (state, action) {
  return futureTrips_reducer_objectSpread(futureTrips_reducer_objectSpread({}, state), {}, {
    data: {
      bookings: Object(lodash["get"])(action, 'payload.bookings.data', [])
    }
  });
}), Object(defineProperty["a" /* default */])(futureTrips_reducer_createReducer, store_constants["g" /* FETCH_USER_FUTURE_TRIPS */], function (state) {
  return futureTrips_reducer_objectSpread(futureTrips_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(futureTrips_reducer_createReducer, store_constants["i" /* FETCH_USER_FUTURE_TRIPS_RESOLVED */], function (state, action) {
  var hasNextPage = Object(lodash["get"])(action, 'payload.userBookings.pageInfo.hasNextPage');
  var currentPage = Object(lodash["get"])(action, 'payload.userBookings.pageInfo.currentPage');
  var fetchedTripsList = Object(lodash["get"])(action, 'payload.userBookings.data', []);
  var trips = Object(lodash["get"])(state, 'data.bookings').concat(fetchedTripsList);
  return futureTrips_reducer_objectSpread(futureTrips_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    data: {
      bookings: trips
    },
    hasNextPage: hasNextPage,
    currentPage: currentPage,
    nextPage: currentPage + 1
  });
}), Object(defineProperty["a" /* default */])(futureTrips_reducer_createReducer, Object(build["reject"])(store_constants["g" /* FETCH_USER_FUTURE_TRIPS */]), function (state, action) {
  return futureTrips_reducer_objectSpread(futureTrips_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: false,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(futureTrips_reducer_createReducer, store_constants["n" /* RESET_USER_FUTURE_TRIPS */], function () {
  return futureTrips_reducer_initialState;
}), futureTrips_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/past-trips/pastTrips.reducer.js


var pastTrips_reducer_createReducer;

function pastTrips_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function pastTrips_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      pastTrips_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      pastTrips_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */






var pastTrips_reducer_initialState = {
  data: {
    bookings: []
  },
  isLoading: false,
  isLoaded: false,
  errorResponse: {},
  hasNextPage: false,
  currentPage: 1,
  nextPage: 2
};
/* harmony default export */ var pastTrips_reducer = (Object(createReducer["a" /* default */])(pastTrips_reducer_initialState, (pastTrips_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(pastTrips_reducer_createReducer, store_constants["j" /* FETCH_USER_PAST_TRIPS */], function (state) {
  return pastTrips_reducer_objectSpread(pastTrips_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(pastTrips_reducer_createReducer, store_constants["k" /* FETCH_USER_PAST_TRIPS_RESOLVED */], function (state, action) {
  var hasNextPage = Object(lodash["get"])(action, 'payload.userBookings.pageInfo.hasNextPage');
  var currentPage = Object(lodash["get"])(action, 'payload.userBookings.pageInfo.currentPage');
  var fetchedPastTripsList = Object(lodash["get"])(action, 'payload.userBookings.data', []);
  var pastTrips = Object(lodash["get"])(state, 'data.bookings').concat(fetchedPastTripsList);
  return pastTrips_reducer_objectSpread(pastTrips_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    data: {
      bookings: pastTrips
    },
    hasNextPage: hasNextPage,
    currentPage: currentPage,
    nextPage: currentPage + 1
  });
}), Object(defineProperty["a" /* default */])(pastTrips_reducer_createReducer, Object(build["reject"])(store_constants["j" /* FETCH_USER_PAST_TRIPS */]), function (state, action) {
  return pastTrips_reducer_objectSpread(pastTrips_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: false,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(pastTrips_reducer_createReducer, store_constants["o" /* RESET_USER_PAST_TRIPS */], function () {
  return pastTrips_reducer_initialState;
}), pastTrips_reducer_createReducer)));
// EXTERNAL MODULE: ./src/client/store/member-space/quick-login/quickLogin.constants.js
var quickLogin_constants = __webpack_require__("rAD9");

// CONCATENATED MODULE: ./src/client/store/member-space/quick-login/quickLogin.reducer.js


var quickLogin_reducer_createReducer;




var quickLogin_reducer_initialState = {
  bookingId: null,
  stayId: null
};
var quickLogin = Object(createReducer["a" /* default */])(quickLogin_reducer_initialState, (quickLogin_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(quickLogin_reducer_createReducer, quickLogin_constants["b" /* UPDATE_QUICKLOGIN_INFOS */], function (state, _ref) {
  var payload = _ref.payload;
  return {
    bookingId: Object(lodash["get"])(payload, 'bookingId') || null,
    stayId: Object(lodash["get"])(payload, 'stayId') || null
  };
}), Object(defineProperty["a" /* default */])(quickLogin_reducer_createReducer, quickLogin_constants["a" /* RESET_QUICKLOGIN_INFOS */], function () {
  return quickLogin_reducer_initialState;
}), quickLogin_reducer_createReducer));
// CONCATENATED MODULE: ./src/client/store/member-space/memberSpace.reducer.js











var memberSpace = Object(redux["c" /* combineReducers */])({
  booking: booking_reducer,
  prePayment: prePayment_reducer,
  customer: customer_reducer,
  userSearches: userSearches_reducer,
  futureTrips: futureTrips_reducer,
  pastTrips: pastTrips_reducer,
  travelCompanions: travelCompanions_reducer["b" /* default */],
  quickLogin: quickLogin,
  bookingChildcare: childcareLayerReducer,
  bookingCart: bookingCart_reducer["b" /* bookingCartReducer */]
});
// EXTERNAL MODULE: ./src/client/store/pick-your-room/app/pickYourRoom.reducer.js
var pickYourRoom_reducer = __webpack_require__("ogu6");

// EXTERNAL MODULE: ./src/client/store/pick-your-room/map/map.reducer.js
var map_reducer = __webpack_require__("ZoZw");

// CONCATENATED MODULE: ./src/client/store/pick-your-room/pickYourRoom.reducer.js



var pickYourRoom = Object(redux["c" /* combineReducers */])({
  app: pickYourRoom_reducer["m" /* default */],
  mapper: map_reducer["j" /* default */]
});
/* harmony default export */ var pick_your_room_pickYourRoom_reducer = (pickYourRoom);
// CONCATENATED MODULE: ./src/client/store/search/query/searchQuery.reducer.js


function searchQuery_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function searchQuery_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      searchQuery_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      searchQuery_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */





var searchQuery_reducer_initialState = {
  keywords: ''
};
var searchQueryReducer = Object(createReducer["a" /* default */])(searchQuery_reducer_initialState, Object(defineProperty["a" /* default */])({}, store_constants["p" /* SEARCH_SET_KEYWORDS */], function (state, action) {
  return searchQuery_reducer_objectSpread(searchQuery_reducer_objectSpread({}, state), {}, {
    keywords: Object(lodash["get"])(action, 'payload.keywords')
  });
}));
// CONCATENATED MODULE: ./src/client/store/search/search.reducer.js


var searchReducer = Object(redux["c" /* combineReducers */])({
  query: searchQueryReducer
});
// CONCATENATED MODULE: ./src/client/store/seller/neolidsReducer.js
var neolidsReducer_initialState = [];
var neolidsReducer = function neolidsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : neolidsReducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined; // there is just a switch with a default case because data is initialized in src/client/store/getInitialReduxState.client.js
  // and is never changed after that (data come from query params)

  switch (action.type) {
    default:
      return state;
  }
};
// EXTERNAL MODULE: ./src/client/store/seller/sellerInfoReducer.js
var sellerInfoReducer = __webpack_require__("+2AQ");

// CONCATENATED MODULE: ./src/client/store/seller/sellerReducer.js



/* harmony default export */ var sellerReducer = (Object(redux["c" /* combineReducers */])({
  neolids: neolidsReducer,
  sellerInfo: sellerInfoReducer["b" /* sellerInfoReducer */]
}));
// EXTERNAL MODULE: ./src/client/store/user-info/actions/signout.js
var signout = __webpack_require__("qd7E");

// CONCATENATED MODULE: ./src/client/store/trip-criteria/departure-city/departureCity.reducer.js





var departureCity_reducer_initialState = null;

function departureCityReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : departureCity_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case store_constants["q" /* SYNC_WITH_LOCATION */]:
      var _ref = action || {},
          _ref$payload = _ref.payload;

      _ref$payload = _ref$payload === void 0 ? {} : _ref$payload;
      var queryParams = _ref$payload.location.queryParams; // in cases where params is not in the url, we should just keep the state as it is.

      return queryParams[uri_constants["k" /* QUERY_TRANSPORT */]] ? queryParams[uri_constants["k" /* QUERY_TRANSPORT */]] : state;

    case departure_city_constants["b" /* TRIP_INFORMATION_SET_DEPARTURE_CITY */]:
      return Object(lodash["get"])(action, 'payload.value', departure_city_constants["a" /* DEFAULT_DEPARTURE_CITY */]);

    case signout["a" /* SIGNOUT */]:
      return departureCity_reducer_initialState;

    default:
      return state;
  }
}

/* harmony default export */ var departureCity_reducer = (departureCityReducer);
// CONCATENATED MODULE: ./src/client/store/trip-criteria/departure-date/departureDate.reducer.js




var departureDate_reducer_initialState = null;

function departureDateReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : departureDate_reducer_initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case store_constants["q" /* SYNC_WITH_LOCATION */]:
      // in cases where params is not in the url, we should just keep the state as it is.
      return payload.location.queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]] ? Object(dateUtils["d" /* getTimestamp */])(payload.location.queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]], uri_constants["e" /* QUERY_DATE_FORMAT */]) : state;

    case store_constants["s" /* TRIP_INFORMATION_SET_DEPARTURE_DATE */]:
      return Object(lodash["get"])(payload, 'departureDate');

    default:
      return state;
  }
}

/* harmony default export */ var departureDate_reducer = (departureDateReducer);
// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// CONCATENATED MODULE: ./src/client/store/trip-criteria/duration/duration.reducer.js
/* eslint-disable no-duplicate-imports */








var duration_reducer_initialState = null;
function tripDurationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : duration_reducer_initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case store_constants["q" /* SYNC_WITH_LOCATION */]:
      {
        var _ref2 = payload,
            queryParams = _ref2.location.queryParams;
        if (queryParams[uri_constants["g" /* QUERY_DURATION */]]) return parseInt(queryParams[uri_constants["g" /* QUERY_DURATION */]], 10);
        return state ? state : duration_constants["a" /* DEFAULT_NO_DURATION */];
      }

    case duration_constants["c" /* TRIP_INFORMATION_SET_DURATION */]:
      var _ref3 = payload,
          value = _ref3.value;

      if (value === duration_constants["a" /* DEFAULT_NO_DURATION */]) {
        return null;
      }

      return Number(value) || state;

    case Object(build["resolve"])(store_faceting_constants["g" /* FACETING_SEARCH_REQUEST */]):
      var _ref4 = payload,
          search = _ref4.search;
      var products = search ? search.products : [];
      var durationQueryParam = Object(uriUtils["i" /* getSpecificQueryParam */])(uri_constants["g" /* QUERY_DURATION */]);
      var defaultDuration = durationQueryParam ? Number(durationQueryParam) : state;
      var durationFromPrice = Object(lodash["get"])(products, '0.price.termsAndConditions.duration');
      return durationFromPrice ? Number(durationFromPrice) : defaultDuration;

    case signout["a" /* SIGNOUT */]:
      return duration_reducer_initialState;

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/trip-criteria/tripCriteria.reducer.js




/* harmony default export */ var tripCriteria_reducer = (Object(redux["c" /* combineReducers */])({
  departureCity: departureCity_reducer,
  departureDate: departureDate_reducer,
  duration: tripDurationReducer
}));
// CONCATENATED MODULE: ./src/client/store/trip-date-criteria/tripDateCriteria.reducer.js


var tripDateCriteria_reducer_createReducer;








var tripDateCriteria_reducer_initialState = {
  departureDate: null,
  arrivalDate: null
};
/* harmony default export */ var tripDateCriteria_reducer = (Object(createReducer["a" /* default */])(tripDateCriteria_reducer_initialState, (tripDateCriteria_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(tripDateCriteria_reducer_createReducer, store_constants["q" /* SYNC_WITH_LOCATION */], function (state, _ref) {
  var payload = _ref.payload;

  if (!payload.location.queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]]) {
    return state;
  }

  var formattedDate = Object(dateUtils["b" /* formatDate */])('YYYYMMDD')(payload.location.queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]], uri_constants["e" /* QUERY_DATE_FORMAT */]);
  return {
    arrivalDate: Number(formattedDate),
    departureDate: Number(formattedDate)
  };
}), Object(defineProperty["a" /* default */])(tripDateCriteria_reducer_createReducer, Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]), function (state, action) {
  var proposal = action.payload.proposals.proposals && action.payload.proposals.proposals[0];

  if (proposal) {
    var _ref2 = action.payload.proposals.proposals ? action.payload.proposals.proposals[0] : tripDateCriteria_reducer_initialState,
        arrivalDate = _ref2.arrivalDate,
        departureDate = _ref2.departureDate;

    return {
      arrivalDate: Number(arrivalDate),
      departureDate: Number(departureDate)
    };
  }

  return state;
}), Object(defineProperty["a" /* default */])(tripDateCriteria_reducer_createReducer, store_constants["t" /* UPDATE_TRIP_DATE_CRITERIA */], function (state, action) {
  var day = Object(lodash["get"])(action, 'payload.day', {});
  var departureDate = Number(Object(lodash["get"])(day, 'id')) || null;
  var arrivalDate = Number(Object(lodash["get"])(day, 'arrivalDate', departureDate)) || null;
  return {
    departureDate: departureDate,
    arrivalDate: arrivalDate
  };
}), tripDateCriteria_reducer_createReducer)));
// EXTERNAL MODULE: ./src/client/store/price-remote/constants.js
var price_remote_constants = __webpack_require__("GZgf");

// CONCATENATED MODULE: ./src/client/store/price-remote/price-of-stay/priceOfStay.reducer.js


var priceOfStay_reducer_createReducer;

function priceOfStay_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function priceOfStay_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      priceOfStay_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      priceOfStay_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var priceOfStay_reducer_initialState = {
  isLoading: true,
  data: null,
  error: null,
  lastRequestId: -1
};
var priceOfStayReducer = Object(createReducer["a" /* default */])(priceOfStay_reducer_initialState, (priceOfStay_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(priceOfStay_reducer_createReducer, price_remote_constants["b" /* PRICE_OF_STAY_REQUEST */], function (state, action) {
  return priceOfStay_reducer_objectSpread(priceOfStay_reducer_objectSpread({}, state), {}, {
    isLoading: true,
    lastRequestId: Object(lodash["get"])(action, 'optimist.id', -1)
  });
}), Object(defineProperty["a" /* default */])(priceOfStay_reducer_createReducer, Object(build["resolve"])(price_remote_constants["b" /* PRICE_OF_STAY_REQUEST */]), function (state, action) {
  // If there is another request in progress
  if (Object(lodash["get"])(action, 'optimist.id', -1) !== state.lastRequestId) {
    return state;
  }

  var priceOfStay = action.payload.priceOfStay;

  if (priceOfStay && priceOfStay.errors) {
    return priceOfStay_reducer_objectSpread(priceOfStay_reducer_objectSpread({}, state), {}, {
      isLoading: false,
      data: null,
      error: priceOfStay.errors
    });
  }

  return priceOfStay_reducer_objectSpread(priceOfStay_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    data: priceOfStay,
    error: null
  });
}), Object(defineProperty["a" /* default */])(priceOfStay_reducer_createReducer, Object(build["reject"])(price_remote_constants["b" /* PRICE_OF_STAY_REQUEST */]), function (state) {
  return priceOfStay_reducer_objectSpread(priceOfStay_reducer_objectSpread({}, state), {}, {
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(priceOfStay_reducer_createReducer, price_remote_constants["c" /* RESET_PRICE_OF_STAY */], function (state) {
  return priceOfStay_reducer_objectSpread(priceOfStay_reducer_objectSpread({}, state), {}, {
    error: null,
    data: null
  });
}), priceOfStay_reducer_createReducer));
// CONCATENATED MODULE: ./src/client/store/price-remote/all-inclusive-services/allInclusiveServices.reducer.js


var allInclusiveServices_reducer_createReducer;

function allInclusiveServices_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function allInclusiveServices_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      allInclusiveServices_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      allInclusiveServices_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var allInclusiveServices_reducer_initialState = {
  isLoading: true,
  data: [],
  lastRequestId: -1
};
var allInclusiveServicesReducer = Object(createReducer["a" /* default */])(allInclusiveServices_reducer_initialState, (allInclusiveServices_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(allInclusiveServices_reducer_createReducer, price_remote_constants["a" /* ALL_INCLUSIVE_SERVICES_REQUEST */], function (state, action) {
  return allInclusiveServices_reducer_objectSpread(allInclusiveServices_reducer_objectSpread({}, state), {}, {
    isLoading: true,
    lastRequestId: Object(lodash["get"])(action, 'optimist.id', -1)
  });
}), Object(defineProperty["a" /* default */])(allInclusiveServices_reducer_createReducer, Object(build["resolve"])(price_remote_constants["a" /* ALL_INCLUSIVE_SERVICES_REQUEST */]), function (state, action) {
  // If there is another request in progress
  if (Object(lodash["get"])(action, 'optimist.id', -1) !== state.lastRequestId) {
    return state;
  }

  return allInclusiveServices_reducer_objectSpread(allInclusiveServices_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    data: action.payload.allInclusiveServices
  });
}), Object(defineProperty["a" /* default */])(allInclusiveServices_reducer_createReducer, Object(build["reject"])(price_remote_constants["a" /* ALL_INCLUSIVE_SERVICES_REQUEST */]), function (state) {
  return allInclusiveServices_reducer_objectSpread(allInclusiveServices_reducer_objectSpread({}, state), {}, {
    isLoading: false
  });
}), allInclusiveServices_reducer_createReducer));
// CONCATENATED MODULE: ./src/client/store/price-remote/priceRemote.reducer.js



var priceRemoteReducer = Object(redux["c" /* combineReducers */])({
  allInclusiveServices: allInclusiveServicesReducer,
  priceOfStay: priceOfStayReducer
});
// EXTERNAL MODULE: ./src/client/store/priceTicket/constants.js
var priceTicket_constants = __webpack_require__("0OJc");

// CONCATENATED MODULE: ./src/client/store/priceTicket/priceTicket.reducer.js


var priceTicket_reducer_createReducer;

function priceTicket_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function priceTicket_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      priceTicket_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      priceTicket_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var priceTicket_reducer_initialState = {
  isLoading: true,
  price: {}
};
/* harmony default export */ var priceTicket_reducer = (Object(createReducer["a" /* default */])(priceTicket_reducer_initialState, (priceTicket_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(priceTicket_reducer_createReducer, priceTicket_constants["a" /* default */], function (state) {
  return priceTicket_reducer_objectSpread(priceTicket_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(priceTicket_reducer_createReducer, Object(build["resolve"])(priceTicket_constants["a" /* default */]), function (state, action) {
  var price = Object(lodash["get"])(action, 'payload.price') || {};
  return {
    isLoading: false,
    price: price
  };
}), Object(defineProperty["a" /* default */])(priceTicket_reducer_createReducer, Object(build["reject"])(priceTicket_constants["a" /* default */]), function (state) {
  return priceTicket_reducer_objectSpread(priceTicket_reducer_objectSpread({}, state), {}, {
    isLoading: false
  });
}), priceTicket_reducer_createReducer)));
// EXTERNAL MODULE: ./src/client/store/prebooking-form/prebookingform.action.js + 1 modules
var prebookingform_action = __webpack_require__("ZP80");

// CONCATENATED MODULE: ./src/client/store/trip-information/tripInformation.action.js
var TRIP_INFORMATION_UPDATE_PARTICIPANTS_LAST_NAME = 'TRIP_INFORMATION_UPDATE_PARTICIPANTS_LAST_NAME';

function setParticipantsLastNameWithMainContacts(userInfos, adultCount, kidCount) {
  return {
    type: TRIP_INFORMATION_UPDATE_PARTICIPANTS_LAST_NAME,
    payload: {
      userInfos: userInfos,
      adultCount: adultCount,
      kidCount: kidCount
    }
  };
}


// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// CONCATENATED MODULE: ./src/client/store/trip-information/kids/kids.reducer.js



function kids_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function kids_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      kids_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      kids_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable flowtype/no-weak-types */











var kids_reducer_initialState = [];

function updateKid(state, action) {
  var _get = Object(lodash["get"])(action, 'payload'),
      index = _get.index,
      valuesToUpdate = _get.valuesToUpdate;

  if (!Number.isFinite(index)) {
    return state;
  }

  var kidsState = state || [];
  return Array(index >= kidsState.length ? index + 1 : kidsState.length).fill(kids_reducer_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */])).map(function (defaultKid, i) {
    if (i !== index) return kidsState[i] ? kidsState[i] : kids_reducer_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */]);
    return kids_reducer_objectSpread(kids_reducer_objectSpread({}, kids_reducer_objectSpread({}, kidsState[i] ? kidsState[i] : defaultKid)), valuesToUpdate);
  });
}

function updateKidsWithMainContactLastName(state, action) {
  var _action$payload = action.payload,
      userInfos = _action$payload.userInfos,
      kidCount = _action$payload.kidCount;

  if (userInfos.lastName === '') {
    return state;
  }

  var kids = state || [];
  return Array(kidCount).fill(kids_reducer_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */])).map(function (defaultKid, i) {
    return kids_reducer_objectSpread(kids_reducer_objectSpread(kids_reducer_objectSpread({}, defaultKid), kids[i]), {}, {
      lastName: kids[i] && !Object(lodash["isEmpty"])(kids[i].lastName) ? kids[i].lastName : userInfos.lastName
    });
  });
}

var kids_reducer_updateKids = function updateKids(state, _ref) {
  var payload = _ref.payload;

  if (!payload.kidsAttendees) {
    return state.map(function (kid) {
      return {
        birthdate: kid.birthdate,
        neolid: kid.neolid,
        childcareIncluded: kid.childcareIncluded,
        mainContactId: undefined
      };
    });
  }

  return state.map(function (kid, index) {
    var _get2 = Object(lodash["get"])(payload, "kidsAttendees[".concat(index, "]"), {}),
        birthdate = _get2.birthdate,
        restAttendeeData = Object(objectWithoutProperties["a" /* default */])(_get2, ["birthdate"]);

    return kids_reducer_objectSpread(kids_reducer_objectSpread({}, restAttendeeData), {}, {
      birthdate: kid.birthdate,
      neolid: kid.neolid,
      childcareIncluded: kid.childcareIncluded,
      mainContactId: undefined
    });
  });
};

function kidsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : kids_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case kids_constants["e" /* TRIP_INFORMATION_UPDATE_KID */]:
      return updateKid(state, action);

    case TRIP_INFORMATION_UPDATE_PARTICIPANTS_LAST_NAME:
      return updateKidsWithMainContactLastName(state, action);

    case kids_constants["c" /* TRIP_INFORMATION_SET_KIDS */]:
      {
        var kids = Object(lodash["get"])(action, 'payload.kids') || [];
        return kids.map(function (kid) {
          return kid || kids_reducer_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */]);
        });
      }

    case kids_constants["d" /* TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS */]:
      {
        var _kids = Object(lodash["get"])(action, 'payload.kids') || [];

        return _kids.map(function (kid, index) {
          return kid ? kids_reducer_objectSpread(kids_reducer_objectSpread(kids_reducer_objectSpread({}, state[index]), kid), {}, {
            birthdate: typeof kid.birthdate === 'string' ? Object(apiDate["d" /* apiDateToTimestamp */])(kid.birthdate) : kid.birthdate,
            neolid: kid.neolid || Object(lodash["get"])(state[index], 'neolid'),
            mainContactId: kid.neolid ? undefined : kid.mainContactId
          }) : kids_reducer_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */]);
        });
      }

    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
    case Object(build["resolve"])(prebookingform_action["a" /* FETCH_PREBOOKING_TRAVELERS */]):
    case adults_constants["d" /* SET_ATTENDEES */]:
      return kids_reducer_updateKids(state, action);

    case proposals_constants["y" /* UPDATE_ATTENDEES */]:
      {
        if (!action.payload.attendees) {
          return state;
        }

        return state.map(function (kid) {
          var updatedKid = action.payload.attendees.find(function (_ref2) {
            var id = _ref2.id;
            return id === kid.id;
          }) || {};
          return kids_reducer_objectSpread(kids_reducer_objectSpread({}, kid), {}, {
            neolid: updatedKid.customerId,
            gmNumber: updatedKid.gmNumber
          });
        });
      }

    case kids_constants["b" /* TRIP_INFORMATION_RESET_KIDS */]:
      return kids_reducer_initialState;

    case signout["a" /* SIGNOUT */]:
      return kids_reducer_initialState;

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/trip-information/adults/adults.reducer.js



function adults_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function adults_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      adults_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      adults_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}









var adults_reducer_initialState = [];

function updateAdult(state, action) {
  var _get = Object(lodash["get"])(action, 'payload'),
      index = _get.index,
      valuesToUpdate = _get.valuesToUpdate;

  if (!Number.isFinite(index)) {
    return state;
  }

  var adults = state || [];
  return Array(index >= adults.length ? index + 1 : adults.length).fill(adults_reducer_objectSpread({}, adults_constants["b" /* DEFAULT_ADULT_VALUE */])).map(function (defaultAdult, i) {
    if (i !== index) return adults[i] ? adults[i] : adults_reducer_objectSpread({}, adults_constants["b" /* DEFAULT_ADULT_VALUE */]);
    return adults_reducer_objectSpread(adults_reducer_objectSpread({}, adults_reducer_objectSpread({}, adults[i] ? adults[i] : defaultAdult)), valuesToUpdate);
  });
}

function setAdultsWithMainContactLastName(state, action) {
  var _action$payload = action.payload,
      userInfos = _action$payload.userInfos,
      adultCount = _action$payload.adultCount;
  var lastName = userInfos.lastName;

  if (lastName === '') {
    return state;
  }

  var adults = state || [];
  return Array(adultCount).fill(adults_reducer_objectSpread({}, adults_constants["b" /* DEFAULT_ADULT_VALUE */])).map(function (defaultAdult, i) {
    // First adult = mainContact so update it with userInfosData
    if (i === 0) {
      return adults_reducer_objectSpread(adults_reducer_objectSpread(adults_reducer_objectSpread({}, defaultAdult), adults[i]), Object(lodash["pick"])(userInfos, ['lastName', 'firstName', 'birthdate', 'email', 'civility', 'unicodeFirstName', 'unicodeLastName']));
    }

    return adults_reducer_objectSpread(adults_reducer_objectSpread(adults_reducer_objectSpread({}, defaultAdult), adults[i]), {}, {
      lastName: adults[i] && !Object(lodash["isEmpty"])(adults[i].lastName) ? adults[i].lastName : userInfos.lastName
    });
  });
}

function setAdultsNumber(state, action) {
  var adultsNumber = Object(lodash["get"])(action, 'payload.adultsNumber');

  if (adultsNumber === 0) {
    return [];
  }

  if (!Number.isFinite(adultsNumber)) {
    return state;
  }

  var adults = state || [];
  return Array(adultsNumber).fill(adults_reducer_objectSpread({}, adults_constants["b" /* DEFAULT_ADULT_VALUE */])).map(function (defaultAdult, i) {
    return adults_reducer_objectSpread({}, adults[i] ? adults[i] : defaultAdult);
  });
}

var adults_reducer_setAdults = function setAdults(state, _ref) {
  var payload = _ref.payload;

  if (!payload.adultsAttendees) {
    return state.map(function (adult) {
      return {
        neolid: adult.neolid
      };
    });
  }

  return state.map(function (adult, index) {
    var _ref2 = payload.adultsAttendees[index] || {},
        birthdate = _ref2.birthdate,
        homePhoneNumber = _ref2.homePhoneNumber,
        mobilePhoneNumber = _ref2.mobilePhoneNumber,
        restAttendeeData = Object(objectWithoutProperties["a" /* default */])(_ref2, ["birthdate", "homePhoneNumber", "mobilePhoneNumber"]);

    return adults_reducer_objectSpread(adults_reducer_objectSpread({}, restAttendeeData), {}, {
      birthdate: birthdate ? Object(apiDate["d" /* apiDateToTimestamp */])(birthdate) : null,
      phoneNumber: mobilePhoneNumber || homePhoneNumber,
      neolid: adult.neolid
    });
  });
};

function adultsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : adults_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case adults_constants["f" /* TRIP_INFORMATION_UPDATE_ADULT */]:
      return updateAdult(state, action);

    case TRIP_INFORMATION_UPDATE_PARTICIPANTS_LAST_NAME:
      return setAdultsWithMainContactLastName(state, action);

    case adults_constants["e" /* TRIP_INFORMATION_SET_ADULTS_NUMBER */]:
      return setAdultsNumber(state, action);

    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
    case Object(build["resolve"])(prebookingform_action["a" /* FETCH_PREBOOKING_TRAVELERS */]):
    case adults_constants["d" /* SET_ATTENDEES */]:
      return adults_reducer_setAdults(state, action);

    case proposals_constants["y" /* UPDATE_ATTENDEES */]:
      {
        if (!action.payload.attendees) {
          return state;
        }

        return state.map(function (adult) {
          var updatedAdult = action.payload.attendees.find(function (_ref3) {
            var id = _ref3.id;
            return id === adult.id;
          }) || {};
          return adults_reducer_objectSpread(adults_reducer_objectSpread({}, adult), {}, {
            neolid: updatedAdult.customerId,
            gmNumber: updatedAdult.gmNumber,
            mainContactId: undefined
          });
        });
      }

    case adults_constants["c" /* SET_ADULTS */]:
      return action.payload.map(function (adult, index) {
        return adults_reducer_objectSpread(adults_reducer_objectSpread(adults_reducer_objectSpread({}, state[index]), adult), {}, {
          mainContactId: adult.neolid ? undefined : adult.mainContactId,
          neolid: adult.neolid || Object(lodash["get"])(state[index], 'neolid')
        }, adult.address ? {
          address: adults_reducer_objectSpread(adults_reducer_objectSpread({}, Object(lodash["get"])(state[index], 'address')), adult.address)
        } : null);
      });

    case signout["a" /* SIGNOUT */]:
      return adults_reducer_initialState;

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/trip-information/tripInformation.reducer.js



/* harmony default export */ var tripInformation_reducer = (Object(redux["c" /* combineReducers */])({
  kids: kidsReducer,
  adults: adultsReducer
}));
// EXTERNAL MODULE: ./src/client/store/routing/constants.js
var routing_constants = __webpack_require__("Uq20");

// EXTERNAL MODULE: ./src/client/components/widgets/cart/bookingCart.actions.js
var bookingCart_actions = __webpack_require__("kD/R");

// EXTERNAL MODULE: ./src/client/components/widgets/popin-newsletter/PopinNewsletter.jsx
var PopinNewsletter = __webpack_require__("Qosd");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/store/toast/toast.actions.js
var toast_actions = __webpack_require__("7Z8V");

// CONCATENATED MODULE: ./src/client/store/toast/toast.reducer.js


function toast_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function toast_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      toast_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      toast_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}












var toast_reducer_initialState = {
  shouldDisplay: false,
  label: '',
  icon: icons["a" /* ICONS */].CONFIRMATION,
  color: colors["a" /* COLORS */].WATER_GREEN
};
var toast_reducer_toast = function toast() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : toast_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Object(build["resolve"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case Object(build["resolve"])(proposals_constants["e" /* ADD_TRANSPORT */]):
      return {
        shouldDisplay: true,
        label: Object(lodash["get"])(action, 'payload.toastLabel') || Object(lodash["get"])(action, 'meta.payload.toastLabel') || '',
        icon: icons["a" /* ICONS */].CONFIRMATION,
        color: colors["a" /* COLORS */].WATER_GREEN
      };

    case proposals_constants["i" /* DISPLAY_TOAST_ON_CONTEXT_SHARE */]:
    case PopinNewsletter["a" /* NEWSLETTER_SUBSCRIPTION_VALIDATION */]:
      return {
        shouldDisplay: true,
        label: Object(lodash["get"])(action, 'payload.toastLabel') || Object(lodash["get"])(action, 'meta.payload.toastLabel') || '',
        icon: icons["a" /* ICONS */].CONFIRMATION,
        color: colors["a" /* COLORS */].WATER_GREEN
      };

    case Object(build["resolve"])(proposals_constants["c" /* ADD_SERVICE */]):
    case Object(build["resolve"])(proposals_constants["A" /* UPDATE_SERVICES */]):
    case Object(build["resolve"])(proposals_constants["h" /* DELETE_SERVICE */]):
    case Object(build["resolve"])(bookingCart_actions["a" /* UPDATE_BOOKING_CART */]):
    case 'PICK_YOUR_ROOM_AGENCY_SUCCESS':
      return {
        shouldDisplay: !!(Object(lodash["get"])(action, 'payload.toastLabel') || Object(lodash["get"])(action, 'meta.payload.toastLabel')),
        label: Object(lodash["get"])(action, 'payload.toastLabel') || Object(lodash["get"])(action, 'meta.payload.toastLabel') || '',
        icon: icons["a" /* ICONS */].CONFIRMATION,
        color: colors["a" /* COLORS */].WATER_GREEN
      };

    case 'PICK_YOUR_ROOM_AGENCY':
      return {
        shouldDisplay: !!Object(lodash["get"])(action, 'payload.toastLabel'),
        label: Object(lodash["get"])(action, 'payload.toastLabel') || Object(lodash["get"])(action, 'meta.payload.toastLabel') || '',
        icon: icons["a" /* ICONS */].CIRCLED_CROSS,
        color: colors["a" /* COLORS */].WATER_GREEN
      };

    case 'PAYMENT_BUTTON_ERROR':
    case proposals_constants["b" /* ADD_ACCOMMODATION_ERROR */]:
      return {
        shouldDisplay: !!action.payload.toastLabel,
        label: action.payload.toastLabel,
        icon: icons["a" /* ICONS */].CIRCLED_CROSS,
        color: colors["a" /* COLORS */].RED
      };

    case proposals_constants["A" /* UPDATE_SERVICES */]:
    case proposals_constants["h" /* DELETE_SERVICE */]:
      return toast_reducer_objectSpread(toast_reducer_objectSpread({}, state), {}, {
        shouldDisplay: false
      });

    case toast_actions["a" /* CLOSE_TOAST */]:
    case routing_constants["a" /* ROUTING_CHANGE */]:
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
    case additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]:
      return toast_reducer_objectSpread(toast_reducer_objectSpread({}, state), {}, {
        shouldDisplay: false
      });

    default:
      return state;
  }
};
// EXTERNAL MODULE: ./src/client/store/user-info/actions/notifyProfileChanged.js
var notifyProfileChanged = __webpack_require__("ubam");

// CONCATENATED MODULE: ./src/client/store/user-info/reducers/userInfoReducer.js


function userInfoReducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function userInfoReducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      userInfoReducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      userInfoReducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}







var MAIN_CONTACT_INDEX = 0; // $FlowFixMe known flow bug. Faultly rejects empty object.

var userInfoReducer_initialState = {};
function userInfoReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userInfoReducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case signout["a" /* SIGNOUT */]:
      return userInfoReducer_initialState;

    case notifyProfileChanged["a" /* PROFILE_CHANGED */]:
      return userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, state), action.payload);

    case adults_constants["d" /* SET_ATTENDEES */]:
    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
      var profile = action.payload.profile; // If profile is null, it means that the user is not logged or its token is not valid
      // and existing userInfo and no profile seems weird, but the token being short lived, it can
      // happen
      // address is nullable

      if (profile) {
        return userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, state), profile);
      }

      return state;

    case adults_constants["f" /* TRIP_INFORMATION_UPDATE_ADULT */]:
      if (Object(lodash["isEmpty"])(state)) return state;
      var _action$payload = action.payload,
          index = _action$payload.index,
          valuesToUpdate = _action$payload.valuesToUpdate;
      var updatedDateOfBirth = Object(lodash["get"])(valuesToUpdate, 'birthdate');
      var optinEmail = Object(lodash["get"])(valuesToUpdate, 'optinEmail');
      var optinSms = Object(lodash["get"])(valuesToUpdate, 'optinSms');
      var optinMail = Object(lodash["get"])(valuesToUpdate, 'optinMail');
      var optinPhone = Object(lodash["get"])(valuesToUpdate, 'optinPhone');
      var optinClubmedPlus = Object(lodash["get"])(valuesToUpdate, 'optinClubmedPlus');
      if (index !== MAIN_CONTACT_INDEX) return state;
      var newState = state;

      if (updatedDateOfBirth) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          updatedDateOfBirth: updatedDateOfBirth
        });
      }

      if (!Object(lodash["isNil"])(optinEmail)) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          optinEmail: optinEmail
        });
      }

      if (!Object(lodash["isNil"])(optinSms)) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          optinSms: optinSms
        });
      }

      if (!Object(lodash["isNil"])(optinMail)) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          optinMail: optinMail
        });
      }

      if (!Object(lodash["isNil"])(optinPhone)) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          optinPhone: optinPhone
        });
      }

      if (!Object(lodash["isNil"])(optinClubmedPlus)) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          optinClubmedPlus: optinClubmedPlus
        });
      }

      return newState;

    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/client/store/validation-schema/constants.js
var validation_schema_constants = __webpack_require__("Kb9x");

// CONCATENATED MODULE: ./src/client/store/validation-schema/validationSchema.reducer.js


function validationSchema_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function validationSchema_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      validationSchema_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      validationSchema_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var validationSchema_reducer_initialState = {
  'profile.address': []
};

var validationSchema_reducer_reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : validationSchema_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
    case validation_schema_constants["a" /* UPDATE_VALIDATION_SCHEMA */]:
      {
        var validationSchema = action.payload.validationSchema;
        if (!validationSchema) return state;
        var addressEntry = validationSchema.find(function (entry) {
          return entry.name === 'address';
        });
        return addressEntry ? {
          'profile.address': addressEntry.fields.map(function (validation) {
            return validationSchema_reducer_objectSpread(validationSchema_reducer_objectSpread({}, validation), {}, {
              validators: validation.validators.map(function (validator) {
                return validator.name === 'pattern' ? {
                  name: 'pattern',
                  value: new RegExp(validator.value)
                } : validator;
              })
            });
          })
        } : state;
      }

    default:
      return state;
  }
};

/* harmony default export */ var validationSchema_reducer = (validationSchema_reducer_reducer);
// CONCATENATED MODULE: ./src/client/store/rootReducer.js




















var rootReducer = Object(redux["c" /* combineReducers */])({
  booking: booking,
  calendar: calendarReducer,
  cms: cmsReducer,
  faceting: facetingReducer,
  facetingTripInformation: facetingTripInformation_reducer,
  globalLoader: globalLoader_reducer,
  memberSpace: memberSpace,
  pickYourRoom: pick_your_room_pickYourRoom_reducer,
  priceRemote: priceRemoteReducer,
  priceTicket: priceTicket_reducer,
  search: searchReducer,
  seller: sellerReducer,
  tripDateCriteria: tripDateCriteria_reducer,
  tripInformation: tripInformation_reducer,
  userInfo: userInfoReducer,
  leadInfos: leadInfo_reducer_leadInfosReducer,
  tripCriteria: tripCriteria_reducer,
  toast: toast_reducer_toast,
  validationSchema: validationSchema_reducer
});

/***/ }),

/***/ "vIa8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ activeFacetsSelector; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ bannersSelector; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ facetingCriteriaSelector; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ facetsSelector; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ filteredProductsSelector; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ recommandedProductsSelector; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ filteredProductsCountSelector; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ filteredProductsSeasonsSelector; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ filtersSelector; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ getFacetingProductIds; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ getFiltersSelector; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ getKidsValidationState; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ searchQuerySelector; });

// UNUSED EXPORTS: facetingSelector, facetingPricesSelector

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /home/circleci/project/node_modules/reselect/lib/index.js
var lib = __webpack_require__("hqKg");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /home/circleci/project/node_modules/moment/moment.js
var moment = __webpack_require__("wgY5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var constants = __webpack_require__("sW3P");

// CONCATENATED MODULE: ./src/utils/faceting/facetingFilters.js





var facetingFilters_FacetFilters = /*#__PURE__*/function () {
  function FacetFilters(list) {
    Object(classCallCheck["a" /* default */])(this, FacetFilters);

    this._list = list || [];
  }

  Object(createClass["a" /* default */])(FacetFilters, [{
    key: "addFilter",
    value: function addFilter(filter) {
      this._list.push({
        id: filter.id,
        name: filter.name
      });

      return this;
    }
  }, {
    key: "addFilters",
    value: function addFilters(filters) {
      if (filters) {
        filters.map(this.addFilter.bind(this));
      }

      return this;
    }
  }, {
    key: "removeFilters",
    value: function removeFilters(ids) {
      this._list = this._list.filter(function (item) {
        return !Object(lodash["includes"])(ids, item.id);
      });
      return this;
    }
  }, {
    key: "addChildcareFilters",
    value: function addChildcareFilters(args) {
      var kids = args.kids,
          _args$childcareFacets = args.childcareFacets,
          facets = _args$childcareFacets === void 0 ? [] : _args$childcareFacets,
          departureDate = args.departureDate;
      var childcareFacets = Object(lodash["isEmpty"])(facets) ? constants["h" /* DEFAULT_CHILDCARE_FACETS */].map(function (f) {
        return {
          label: f,
          value: f
        };
      }) : facets;
      var childcareRanges = childcareFacets.map(function (_ref) {
        var name = _ref.label;
        var facetRange = name.split('-');
        return {
          name: name,
          min: parseInt(facetRange[0], 10),
          max: parseInt(facetRange[1], 10)
        };
      });
      var childcareFilters = kids.filter(function (_ref2) {
        var birthdate = _ref2.birthdate;
        return Object(lodash["isNumber"])(birthdate);
      }).filter(function (_ref3) {
        var childcareIncluded = _ref3.childcareIncluded;
        return childcareIncluded;
      }).map(function (_ref4) {
        var birthdate = _ref4.birthdate; // if no departureDate is given, the kid's age is calculated for a departureDate in 6 months

        var defaultDepartureDate = function defaultDepartureDate() {
          return moment_default()().add(constants["k" /* DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH */], 'months').valueOf();
        };

        var kidAgeInMonths = moment_default()(departureDate || defaultDepartureDate()).diff(moment_default()(birthdate), 'months');
        var matchingFacet = childcareRanges.find(function (_ref5) {
          var min = _ref5.min,
              max = _ref5.max;
          return Object(lodash["inRange"])(kidAgeInMonths, min, max + 1);
        }); // lodash inRange exludes the max value

        if (!matchingFacet || !matchingFacet.name) {
          return null;
        }

        return {
          id: constants["e" /* CHILDCARE_FACET_ID */],
          name: matchingFacet.name
        };
      }).filter(Boolean);
      this._list = this._list.concat(Object(lodash["uniqWith"])(childcareFilters, lodash["isEqual"]));
      return this;
    }
  }, {
    key: "addAdultOnlyFilter",
    value: function addAdultOnlyFilter() {
      var kids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return Object(lodash["isEmpty"])(kids) ? this : this.addFilter({
        id: constants["d" /* ADULTS_ONLY_FACET_ID */],
        name: false
      });
    }
  }, {
    key: "value",
    value: function value() {
      return this._list.map(function (item) {
        return Object(lodash["pick"])(item, ['id', 'name']);
      });
    }
  }]);

  return FacetFilters;
}();
// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var storeHelper = __webpack_require__("Jsmy");

// CONCATENATED MODULE: ./src/client/store/faceting/faceting.selector.js


/* eslint-disable max-params */








var facetingSelector = function facetingSelector(_ref) {
  var faceting = _ref.faceting;
  return faceting || {};
};

var activeFacetsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref2) {
  var activeFacets = _ref2.activeFacets;
  return activeFacets || {};
});
var searchQuerySelector = Object(lib["createSelector"])(facetingSelector, function (_ref3) {
  var query = _ref3.query;
  return query || {
    label: ''
  };
});
var facetsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref4) {
  var facets = _ref4.facets;
  return facets || [];
});
var filtersSelector = Object(lib["createSelector"])(facetingSelector, function (_ref5) {
  var filters = _ref5.filters;
  return filters || [];
});
var facetingPricesSelector = Object(lib["createSelector"])(facetingSelector, function (_ref6) {
  var prices = _ref6.prices;
  return prices;
});
var filteredProductsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref7) {
  var _ref7$products = _ref7.products,
      products = _ref7$products === void 0 ? [] : _ref7$products;
  return products;
});
var recommandedProductsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref8) {
  var _ref8$recommandedProd = _ref8.recommandedProducts,
      recommandedProducts = _ref8$recommandedProd === void 0 ? [] : _ref8$recommandedProd;
  return recommandedProducts;
});
var bannersSelector = Object(lib["createSelector"])(facetingSelector, function (_ref9) {
  var banners = _ref9.banners;
  return banners || [];
});
var filteredProductsCountSelector = Object(lib["createSelector"])(facetingSelector, function (_ref10) {
  var _ref10$products = _ref10.products,
      products = _ref10$products === void 0 ? [] : _ref10$products;
  return products.length;
});
var filteredProductsSeasonsSelector = Object(lib["createSelector"])(filteredProductsSelector, function () {
  var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return products.reduce(function (seasons, product) {
    return seasons.includes(product.seasonName) ? seasons : [].concat(Object(toConsumableArray["a" /* default */])(seasons), [product.seasonName]);
  }, []);
});
var getFacetingProductIds = Object(lib["createSelector"])(filteredProductsSelector, function () {
  var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return products.map(function (_ref11) {
    var id = _ref11.id;
    return id;
  });
});
var getKidsValidationState = Object(lib["createSelector"])(facetingSelector, function (_ref12) {
  var _ref12$kidsValidation = _ref12.kidsValidationState,
      kidsValidationState = _ref12$kidsValidation === void 0 ? [] : _ref12$kidsValidation;
  return kidsValidationState;
});
/**
 * Returns an array of objects [{id: <filter_name>, name: <filter_value>}]
 * representing active facets to send to Pertimm.
 *
 * Example:
 * ```json
 * [
 *   { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 * ]
 * ```
 */

var activeFacetsCriteriaSelector = Object(lib["createSelector"])(activeFacetsSelector, function (activeFacets) {
  return Object.keys(activeFacets).reduce(function (acc, categoryId) {
    Object.entries(activeFacets[categoryId]).map(function (_ref13) {
      var _ref14 = Object(slicedToArray["a" /* default */])(_ref13, 2),
          filter = _ref14[0],
          isSelected = _ref14[1];

      if (isSelected) {
        acc.push({
          id: categoryId,
          name: filter
        });
      }
    });
    return acc;
  }, []);
});
/**
 * Returns an array of objects [{id: <filter_name>, name: <filter_value>}]
 * containing aggregation of both facets and criterias to send to Pertimm.
 *
 * Example:
 * ```json
 * [
 *   { id: 'facette_adult_only', name: false },
 *   { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 * ]
 * ```
 */

var getFiltersSelector = Object(lib["createSelector"])(storeHelper["c" /* getKids */], tripCriteria_selector["b" /* getDepartureDate */], activeFacetsCriteriaSelector, filtersSelector, tripCriteria_selector["a" /* getDepartureCity */], facetsSelector, function (kids, departureDate, activeFacets, filters, departureCity, facets) {
  var allFilters = new facetingFilters_FacetFilters(filters).removeFilters([constants["a" /* ACTIVITIES_FACET_ID */], constants["d" /* ADULTS_ONLY_FACET_ID */], constants["e" /* CHILDCARE_FACET_ID */], constants["j" /* DEPARTURE_CITY_FACET_ID */]].concat(Object(toConsumableArray["a" /* default */])(constants["r" /* FILTERABLE_FACETS_IDS */]))).addAdultOnlyFilter(kids).addChildcareFilters({
    kids: kids,
    childcareFacets: Object(facetingUtils["b" /* getChildcareFacets */])(facets),
    departureDate: departureDate
  }).addFilters(activeFacets);

  if (departureCity) {
    allFilters.addFilter({
      id: constants["j" /* DEPARTURE_CITY_FACET_ID */],
      name: departureCity
    });
  }

  return allFilters.value();
});
/**
 * Returns an object with an aggregation of criterias for Pertimm:
 *
 * Example:
 * ```json
 * {
 *    departureDate: '',
 *    tripDuration: '7',
 *    filters: [
 *      { id: 'facette_departure_city',  name: 'PAR' },
 *      { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 *    ]
 * }
 * ```
 */

var facetingCriteriaSelector = Object(lib["createSelector"])([tripCriteria_selector["b" /* getDepartureDate */], tripCriteria_selector["c" /* getTripDuration */], getFiltersSelector, storeHelper["c" /* getKids */]], function (departureDate, tripDuration, filters, kids) {
  return {
    departureDate: departureDate,
    tripDuration: tripDuration,
    filters: filters,
    kids: kids
  };
});


/***/ }),

/***/ "vrF/":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("rnJz"),
    isObjectLike = __webpack_require__("oS78");

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ "w5oF":
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ "wQ38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRIP_INFORMATION_SET_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIP_INFORMATION_UPDATE_KID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRIP_INFORMATION_RESET_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_KID_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VALIDATION_STATE_ENUM; });
var TRIP_INFORMATION_SET_KIDS = 'TRIP_INFORMATION_UPDATE_KIDS';
var TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS = 'TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS';
var TRIP_INFORMATION_UPDATE_KID = 'TRIP_INFORMATION_UPDATE_KID';
var TRIP_INFORMATION_RESET_KIDS = 'TRIP_INFORMATION_RESET_KID';
var DEFAULT_KID_VALUE = {
  birthdate: undefined,
  neolid: undefined,
  childcareIncluded: true
};
var VALIDATION_STATE_ENUM = Object.freeze({
  valid: 'IS_VALID',
  invalid: 'IS_INVALID',
  notvalidated: 'NOT_VALIDATED'
});

/***/ }),

/***/ "weY2":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("lDSF"),
    root = __webpack_require__("jP+d");

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ "xAOE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_TRAVEL_COMPANIONS_RESOLVED; });
/* unused harmony export initialState */
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _store_utils_createReducer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("4Bi9");


var _createReducer;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var FETCH_TRAVEL_COMPANIONS = 'FETCH_TRAVEL_COMPANIONS';
var UPDATE_TRAVEL_COMPANION = 'UPDATE_TRAVEL_COMPANION';
var FETCH_TRAVEL_COMPANIONS_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["resolve"])(FETCH_TRAVEL_COMPANIONS);
var initialState = {
  data: [],
  isLoading: false,
  isLoaded: false,
  errorResponse: {}
};
/* harmony default export */ __webpack_exports__["b"] = (Object(_store_utils_createReducer__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(initialState, (_createReducer = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_createReducer, FETCH_TRAVEL_COMPANIONS, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_createReducer, FETCH_TRAVEL_COMPANIONS_RESOLVED, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    data: Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(action, 'payload.travelCompanions', [])
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_createReducer, Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["reject"])(FETCH_TRAVEL_COMPANIONS), function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: false,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_createReducer, UPDATE_TRAVEL_COMPANION, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    data: action.payload
  });
}), _createReducer)));

/***/ }),

/***/ "xl1w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_BOOKING_CART; });
/* unused harmony export initialState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bookingCartReducer; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var FETCH_BOOKING_CART = 'FETCH_BOOKING_CART';
var UPDATE_BOOKING_CART = 'UPDATE_BOOKING_CART';
var initialState = {
  data: {},
  errorResponse: {},
  editingServiceId: '',
  stay: {}
};
var bookingCartReducer = function bookingCartReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case FETCH_BOOKING_CART:
      return _objectSpread(_objectSpread({}, state), {}, {
        stay: action.payload.stay
      });

    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["resolve"])(FETCH_BOOKING_CART):
      return _objectSpread(_objectSpread({}, state), {}, {
        data: Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(action, 'payload', {}),
        errorResponse: {}
      });

    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["reject"])(FETCH_BOOKING_CART):
      return _objectSpread(_objectSpread({}, state), {}, {
        errorResponse: {
          errors: action.payload.errors
        }
      });

    case UPDATE_BOOKING_CART:
      return _objectSpread(_objectSpread({}, state), {}, {
        editingServiceId: action.payload.id
      });

    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["resolve"])(UPDATE_BOOKING_CART):
      return _objectSpread(_objectSpread({}, state), {}, {
        editingServiceId: '',
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          userBooking: _objectSpread(_objectSpread(_objectSpread({}, state.data.userBooking), action.payload.addServiceCart), action.payload.removeServiceCart)
        })
      });

    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["reject"])(UPDATE_BOOKING_CART):
      return _objectSpread(_objectSpread({}, state), {}, {
        editingServiceId: '',
        errorResponse: {
          errors: action.payload.errors
        }
      });

    default:
      return state;
  }
};

/***/ }),

/***/ "y316":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ suggest; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ search; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ searchWithFacets; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ getIdsFromProducts; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /home/circleci/project/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var constants = __webpack_require__("sW3P");

// CONCATENATED MODULE: ./src/utils/pertimm-client/filters.js




var FILTER_PARAM = 'filters';
function composeFiltersAsPayload() {
  for (var _len = arguments.length, filters = new Array(_len), _key = 0; _key < _len; _key++) {
    filters[_key] = arguments[_key];
  }

  var formData = Object(lodash["flattenDeep"])(filters).reduce(function (acc, _ref) {
    var name = _ref.name,
        value = _ref.value,
        operation = _ref.operation;
    if (value) acc.push("".concat(FILTER_PARAM, "[").concat(name, "][values][]=").concat(URI_default.a.encode(value)));

    if (value && operation) {
      acc.push("".concat(FILTER_PARAM, "[").concat(name, "][operations][]=").concat(URI_default.a.encode(operation)));
    }

    return acc;
  }, []);
  return formData.join('&');
}

function buildFilters(_ref2) {
  var name = _ref2.name,
      value = _ref2.value,
      operation = _ref2.operation;
  return value ? [{
    name: name,
    value: value,
    operation: operation
  }] : [];
}

function getLocaleFilters(locale) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  return buildFilters({
    name: constants["v" /* LOCALE_FACET_ID */],
    value: locale,
    operation: operation
  });
}
function getDepartureDateFilters(departureDate) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  return [].concat(Object(toConsumableArray["a" /* default */])(buildFilters({
    name: constants["n" /* DEPARTURE_DATE_MIN_FACET_ID */],
    value: departureDate,
    operation: operation
  })), Object(toConsumableArray["a" /* default */])(buildFilters({
    name: constants["m" /* DEPARTURE_DATE_MAX_FACET_ID */],
    value: departureDate,
    operation: operation
  })));
}
function getDepartureCityFilters(_ref3) {
  var _ref3$facets = _ref3.facets,
      facets = _ref3$facets === void 0 ? [] : _ref3$facets,
      _ref3$defaultValue = _ref3.defaultValue,
      defaultValue = _ref3$defaultValue === void 0 ? '' : _ref3$defaultValue,
      _ref3$operation = _ref3.operation,
      operation = _ref3$operation === void 0 ? 'and' : _ref3$operation;
  var departureCityFacet = Object(lodash["findLast"])(facets, function (_ref4) {
    var id = _ref4.id;
    return id === constants["j" /* DEPARTURE_CITY_FACET_ID */];
  }) || {};
  var value = departureCityFacet.name || defaultValue;
  return buildFilters({
    name: constants["j" /* DEPARTURE_CITY_FACET_ID */],
    value: value,
    operation: operation
  });
}
function getDurationFilters(duration) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  return buildFilters({
    name: constants["p" /* DURATION_FACET */],
    value: duration,
    operation: operation
  });
}

function getProductIdFilters(id) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'or';
  return buildFilters({
    name: constants["z" /* PRODUCT_FACET_ID */],
    value: id,
    operation: operation
  });
}

function getProductIdsFilters() {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var operation = arguments.length > 1 ? arguments[1] : undefined;
  return Object(lodash["flatten"])(ids.map(function (id) {
    return getProductIdFilters(id, operation);
  }));
}
function getOfferFilters(offerId) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  return buildFilters({
    name: constants["x" /* OFFER_ID_FACET_ID */],
    value: offerId,
    operation: operation
  });
}
var FACETS_TO_OMIT = [constants["n" /* DEPARTURE_DATE_MIN_FACET_ID */], constants["m" /* DEPARTURE_DATE_MAX_FACET_ID */], constants["j" /* DEPARTURE_CITY_FACET_ID */], constants["p" /* DURATION_FACET */]];
function getFacetsFilters() {
  var facets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  var filters = facets.filter(function (facet) {
    return !FACETS_TO_OMIT.includes(facet.id);
  }).map(function (facet) {
    return buildFilters({
      name: facet.id,
      value: facet.name,
      operation: operation
    });
  });
  return Object(lodash["flatten"])(filters);
}
// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/axios/index.js
var axios = __webpack_require__("ggb3");

// EXTERNAL MODULE: /home/circleci/project/node_modules/error.js/index.js
var error_js = __webpack_require__("x5Ag");
var error_js_default = /*#__PURE__*/__webpack_require__.n(error_js);

// CONCATENATED MODULE: ./src/utils/pertimm-client/request.js



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var PertimmRequestFailed = error_js_default.a.create({
  name: 'PertimmRequestFailed',
  message: 'The Pertimm request failed'
});

var request_getAxiosConfig = function getAxiosConfig() {
  var proxyConfig = config_default.a.get('pertimm.proxy');
  var httpsAgent;

  if (false) {}

  return {
    httpsAgent: httpsAgent,
    proxy: httpsAgent ? false : undefined
  };
};

var START_INDEX_PARAM = 'res_sf';

function recursivePostRequest(_ref) {
  var axiosConfig = _ref.axiosConfig,
      url = _ref.url,
      payload = _ref.payload,
      queryparams = _ref.queryparams,
      acc = _ref.acc;
  return Object(axios["request"])(_objectSpread(_objectSpread({}, axiosConfig), {}, {
    method: 'POST',
    url: url,
    data: payload,
    params: queryparams
  })).then(function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        data = _ref2.data;

    if (!acc) acc = _objectSpread({}, data);else acc.answers = [].concat(Object(toConsumableArray["a" /* default */])(acc.answers), Object(toConsumableArray["a" /* default */])(data.answers || []));
    var nextStart = Number(data.start_answer) + Number(data.returned_answers_count) - 1;
    var hasMoreAnswers = nextStart + 1 < Number(data.available_answers_count);
    return hasMoreAnswers ? recursivePostRequest({
      axiosConfig: axiosConfig,
      url: url,
      payload: payload,
      queryparams: _objectSpread(_objectSpread({}, queryparams), {}, Object(defineProperty["a" /* default */])({}, START_INDEX_PARAM, nextStart)),
      acc: acc
    }) : acc;
  })["catch"](function () {
    var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _error$response = error.response;
    _error$response = _error$response === void 0 ? {} : _error$response;
    var _error$response$statu = _error$response.status,
        status = _error$response$statu === void 0 ? 500 : _error$response$statu,
        _error$response$data = _error$response.data,
        data = _error$response$data === void 0 ? '' : _error$response$data;
    throw new PertimmRequestFailed({
      statusCode: status,
      errors: data
    });
  });
}

function postSearchRequest(_ref3) {
  var _objectSpread3;

  var locale = _ref3.locale,
      _ref3$payload = _ref3.payload,
      payload = _ref3$payload === void 0 ? '' : _ref3$payload,
      _ref3$queryparams = _ref3.queryparams,
      queryparams = _ref3$queryparams === void 0 ? {} : _ref3$queryparams;
  return recursivePostRequest({
    url: config_default.a.get('pertimm.apiUrl'),
    axiosConfig: request_getAxiosConfig(),
    payload: payload,
    queryparams: _objectSpread((_objectSpread3 = {
      enable_interpretation_explanation: true
    }, Object(defineProperty["a" /* default */])(_objectSpread3, START_INDEX_PARAM, 0), Object(defineProperty["a" /* default */])(_objectSpread3, "search_locale", locale), Object(defineProperty["a" /* default */])(_objectSpread3, "user_locale", locale), _objectSpread3), queryparams),
    acc: undefined
  });
}
// CONCATENATED MODULE: ./src/utils/pertimm-client/index.js





var ACTIONS = {
  WORD_WHEEL: 'wordWheel',
  PERTIMM_SEARCH: 'pertimmSearch'
};
var pertimm_client_getApiKey = Object(lodash["memoize"])(function getApiKey(appContext) {
  return config_default.a.get( // eslint-disable-next-line no-nested-ternary
  appContext.isCmta ? 'api.cm_ta_api_key' : Object(sellerUtils["f" /* isSeller */])(appContext) ? 'api.seller.api_key' : 'api.api_key');
});

function suggest(_ref) {
  var appContext = _ref.appContext,
      _ref$criteria = _ref.criteria,
      criteria = _ref$criteria === void 0 ? {} : _ref$criteria;
  var departureDate = criteria.departureDate,
      _criteria$keywords = criteria.keywords,
      keywords = _criteria$keywords === void 0 ? '' : _criteria$keywords;
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.WORD_WHEEL,
      max_suggests: config_default.a.get('pertimm.max_suggests'),
      enable_interpretation_explanation: 'true',
      query: keywords
    },
    payload: composeFiltersAsPayload(getDepartureDateFilters(departureDate))
  });
}

function search(_ref2) {
  var appContext = _ref2.appContext,
      _ref2$criteria = _ref2.criteria,
      criteria = _ref2$criteria === void 0 ? {} : _ref2$criteria;
  var departureDate = criteria.departureDate,
      _criteria$keywords2 = criteria.keywords,
      keywords = _criteria$keywords2 === void 0 ? '' : _criteria$keywords2;
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.PERTIMM_SEARCH,
      max_files: config_default.a.get('pertimm.max_files'),
      format: 'json',
      query: keywords
    },
    payload: composeFiltersAsPayload(getDepartureDateFilters(departureDate), getLocaleFilters(appContext.locale))
  });
}

function searchWithFacets(_ref3) {
  var _ref3$criteria = _ref3.criteria,
      criteria = _ref3$criteria === void 0 ? {} : _ref3$criteria,
      appContext = _ref3.appContext;
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.PERTIMM_SEARCH,
      max_files: config_default.a.get('pertimm.max_files'),
      format: 'json',
      query: criteria.query || '',
      'contexts[boutique]': criteria.boutique,
      'contexts[screenSize]': criteria.screenSize
    },
    payload: composeFiltersAsPayload(getDepartureDateFilters(criteria.departureDate), getLocaleFilters(appContext.locale), getDepartureCityFilters({
      facets: criteria.filters,
      defaultValue: criteria.defaultDepartureCity
    }), getDurationFilters(criteria.tripDuration), getProductIdsFilters(criteria.productIds), getFacetsFilters(criteria.filters), getOfferFilters(criteria.offerId))
  });
}

function getIdsFromProducts(appContext) {
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.PERTIMM_SEARCH,
      max_files: config_default.a.get('pertimm.max_files'),
      format: 'json',
      disable_catalogs: 1
    },
    payload: composeFiltersAsPayload(getLocaleFilters(appContext.locale))
  }).then(function () {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref4$answers = _ref4.answers,
        answers = _ref4$answers === void 0 ? [] : _ref4$answers;

    return answers.map(function (result) {
      return Object(lodash["get"])(result, 'meta.product_id[0]');
    });
  });
}



/***/ }),

/***/ "z+TE":
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__("xoyU"),
    isArguments = __webpack_require__("bvyN"),
    isArray = __webpack_require__("wxYD"),
    isIndex = __webpack_require__("pnw1"),
    isLength = __webpack_require__("t0L4"),
    toKey = __webpack_require__("Ypsa");

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ "z8xc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TRAIN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PLANE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getFindSectionTransportTypeFn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getDiffAbsoluteDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getWayLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getMinBaggageWeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatConnectionLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return hasOnlyPlanes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return tripsHaveSchedules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return transformMinutesInHours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getTransportIcon; });
/* unused harmony export hasCancellationPolicy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCancellationPolicyDescription; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("oL6k");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");






var TRAIN = 'TRAIN';
var BOAT = 'BOAT';
var PLANE = 'PLANE';

function getDiffAbsoluteDays(fromDate, toDate) {
  var fromMoment = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_3__[/* momentFromApiDate */ "g"])(fromDate);
  var toMoment = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_3__[/* momentFromApiDate */ "g"])(toDate);

  if (fromMoment.isValid() && toMoment.isValid()) {
    return toMoment.diff(fromMoment, 'days');
  }
}

function formatTime(time, format) {
  var renderedTime = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_3__[/* momentFromApiTime */ "h"])(time).format(format);
  return renderedTime !== 'Invalid date' ? renderedTime : null;
}

function getWayLabel(i18n, way) {
  if (way === 'INBOUND') return i18n.common.transport.inboundLabel;
  if (way === 'OUTBOUND') return i18n.common.transport.outboundLabel;
  return null;
}

function getMinBaggageWeight(sections) {
  if (Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(sections)) {
    return {};
  } // $FlowFixMe


  var minBaggageWeightForSection = sections.reduce(function (a, b) {
    if (!Object(lodash__WEBPACK_IMPORTED_MODULE_0__["has"])(a, 'transport.baggage.weight')) {
      return b;
    }

    if (!Object(lodash__WEBPACK_IMPORTED_MODULE_0__["has"])(b, 'transport.baggage.weight')) {
      return a;
    }

    var baggageWeightA = a.transport.baggage.weight ? Number(a.transport.baggage.weight.replace(/(\d+).*/, '$1')) : NaN;
    var baggageWeightB = b.transport.baggage.weight ? Number(b.transport.baggage.weight.replace(/(\d+).*/, '$1')) : NaN;

    if (!baggageWeightA || !baggageWeightB) {
      return null;
    }

    return baggageWeightA < baggageWeightB ? a : b;
  });
  return minBaggageWeightForSection ? minBaggageWeightForSection.transport.baggage : {};
}

function formatConnectionLabel(label, duration) {
  var durationAsNumber = duration ? +duration : 0;
  var durationFormated = moment__WEBPACK_IMPORTED_MODULE_1___default.a.utc(moment__WEBPACK_IMPORTED_MODULE_1___default.a.duration(durationAsNumber, 'minutes').asMilliseconds());
  return Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["messageFormat"])('{label} {duration}').format({
    label: label,
    duration: "".concat(durationFormated.format('HH'), "h").concat(durationFormated.format('mm'))
  });
}

function getStep(i18n) {
  var timeFormat = i18n.common.timeFormat;
  var transportConnectionLabel = i18n.common.transport.connection;
  return function (step) {
    var connectionDuration = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'connectionDurationInMin');
    var stopOverDuration = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'stopDurationInMin');
    var information = !Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(stopOverDuration) || !Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(connectionDuration) ? formatConnectionLabel(transportConnectionLabel, stopOverDuration || connectionDuration) : null;
    return {
      id: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'transport.reference'),
      type: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'transport.type'),
      information: information,
      operator: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'transport.companyOperator.label'),
      operatorId: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'transport.companyOperator.id'),
      operatorLogo: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'transport.companyOperator.logo'),
      start: {
        label: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'departure.airportLabel'),
        time: formatTime(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'departure.time'), timeFormat),
        date: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'departure.date')
      },
      end: {
        label: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'arrival.airportLabel'),
        time: formatTime(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'arrival.time'), timeFormat),
        date: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'arrival.date')
      },
      technicalStops: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'technicalStops')
    };
  };
}

function hasBoat(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.every(function (section) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(section, 'transport.type') === BOAT;
  });
}

function hasTrain(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.some(function (section) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(section, 'transport.type') === TRAIN;
  });
}

function hasOnlyPlanes(inboundFlight, outboundFlight) {
  return !(hasTrain(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(inboundFlight, 'travelSections')) || hasTrain(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(outboundFlight, 'travelSections')) || hasBoat(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(inboundFlight, 'travelSections')) || hasBoat(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(outboundFlight, 'travelSections')));
}

function getTransportIcon(inboundFlight, outboundFlight) {
  var isTrain = hasTrain(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(inboundFlight, 'travelSections')) && hasTrain(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(outboundFlight, 'travelSections'));

  if (isTrain) {
    return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].TRAIN;
  }

  var isBoat = hasBoat(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(inboundFlight, 'travelSections')) && hasBoat(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(outboundFlight, 'travelSections'));

  if (isBoat) {
    return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].BOAT;
  }

  return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].TRANSPORT;
}

function tripHasSchedules(travelSections) {
  return !Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(travelSections) ? (travelSections || []).some(function (section) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(section, 'arrival.time') || Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(section, 'departure.time');
  }) : false;
}

function tripsHaveSchedules(inboundFlight, outboundFlight) {
  return tripHasSchedules(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(inboundFlight, 'travelSections')) || tripHasSchedules(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(outboundFlight, 'travelSections'));
}

function transformMinutesInHours(minutes) {
  var numberMinutes = Number(minutes);
  return Math.floor(numberMinutes / 60) + 'h' + (numberMinutes % 60).toString().padStart(2, '0');
}

function hasCancellationPolicy(transport) {
  return Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_4__[/* isCharterFlight */ "u"])(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(transport, 'inbound.cancellationPolicyType')) || Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_4__[/* isCharterFlight */ "u"])(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(transport, 'outbound.cancellationPolicyType'));
}

var getCancellationPolicyDescription = function getCancellationPolicyDescription(transport, i18n) {
  if (hasCancellationPolicy(transport)) {
    var _i18n$bookingProcess$;

    return (_i18n$bookingProcess$ = i18n.bookingProcess.find(function (legalInformation) {
      return legalInformation.id === (transport.inbound.cancellationPolicyType || transport.outbound.cancellationPolicyType);
    })) === null || _i18n$bookingProcess$ === void 0 ? void 0 : _i18n$bookingProcess$.description;
  }
};

var getFindSectionTransportTypeFn = function getFindSectionTransportTypeFn(transportType) {
  return function (_ref) {
    var type = _ref.transport.type;
    return type === transportType;
  };
};


/***/ }),

/***/ "zCbR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACKING_PREFIX_MAPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTrackingTransport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureCityCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDepartureCityName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isSummer; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _client_tracking_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("829J");



var WITH_TRANSPORT = 'with Transport';
var WITHOUT_TRANSPORT = 'without Transport';
var NO_DEPARTURE_CITY = 'NO';
var TRACKING_PREFIX_MAPPING = {
  ACTIVITIES: 'activities',
  CHILDCARE: 'childcare',
  WELLNESS: 'wellness'
};
function getTrackingTransport(departureCityCode) {
  return departureCityCode && Object(lodash__WEBPACK_IMPORTED_MODULE_0__["toUpper"])(departureCityCode) !== NO_DEPARTURE_CITY ? WITH_TRANSPORT : WITHOUT_TRANSPORT;
}
function getDepartureCityCode(departureCityCode) {
  return departureCityCode && Object(lodash__WEBPACK_IMPORTED_MODULE_0__["toUpper"])(departureCityCode) !== NO_DEPARTURE_CITY ? departureCityCode : WITHOUT_TRANSPORT;
}
function getDepartureCityName(departureCityCode, departureCityName) {
  return departureCityName && departureCityCode && Object(lodash__WEBPACK_IMPORTED_MODULE_0__["toUpper"])(departureCityCode) !== NO_DEPARTURE_CITY ? departureCityName : '';
}
function isSummer(date) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["inRange"])(Number(moment__WEBPACK_IMPORTED_MODULE_1___default()(date).format('MMDD')), _client_tracking_constants__WEBPACK_IMPORTED_MODULE_2__[/* SUMMER_DATE_START */ "x"], _client_tracking_constants__WEBPACK_IMPORTED_MODULE_2__[/* SUMMER_DATE_END */ "w"]);
}

/***/ }),

/***/ "zjgX":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("dZwK");

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ "zwLB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPLECategoryGA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPLEPaymentConfirmationSiteSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSearchMappedTypeForLabelGA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSiteSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return noCase; });
/* unused harmony export pascalCase */
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("829J");



var PAGE_TYPES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["b2cPagesService"].PAGE_TYPES;
function getPLECategoryGA(isUserQuickLogged) {
  return isUserQuickLogged ? _constants__WEBPACK_IMPORTED_MODULE_2__[/* PLE_QUICK */ "n"] : _constants__WEBPACK_IMPORTED_MODULE_2__[/* PLE */ "l"];
}
function getPLEPaymentConfirmationSiteSection(isUserQuickLogged) {
  return isUserQuickLogged ? _constants__WEBPACK_IMPORTED_MODULE_2__[/* PLE_QUICK_OPTION */ "o"] : _constants__WEBPACK_IMPORTED_MODULE_2__[/* PLE_OPTION */ "m"];
}
function getSearchMappedTypeForLabelGA(type) {
  return _constants__WEBPACK_IMPORTED_MODULE_2__[/* SEARCH_LABEL_GA_MAP */ "r"][type || 'none'];
}
function getSiteSection(_ref) {
  var _ref$isUserQuickLogge = _ref.isUserQuickLogged,
      isUserQuickLogged = _ref$isUserQuickLogge === void 0 ? false : _ref$isUserQuickLogge,
      pageType = _ref.pageType;

  switch (pageType) {
    case PAGE_TYPES.DESTINATION_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.DESTINATION));

    case PAGE_TYPES.HOME_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.HOME));

    case PAGE_TYPES.LANDING_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.LANDING));

    case PAGE_TYPES.RESORT_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.RESORT));

    case PAGE_TYPES.PREBOOKING:
      var siteSection = pageType.split('-')[0];
      return "Shopping_".concat(pascalCase(siteSection));

    case _constants__WEBPACK_IMPORTED_MODULE_2__[/* STATIC_PAGE_TYPES */ "v"].BE:
      return _constants__WEBPACK_IMPORTED_MODULE_2__[/* BE */ "a"];

    case _constants__WEBPACK_IMPORTED_MODULE_2__[/* STATIC_PAGE_TYPES */ "v"].PLE:
      return getPLECategoryGA(isUserQuickLogged);

    case _constants__WEBPACK_IMPORTED_MODULE_2__[/* STATIC_PAGE_TYPES */ "v"].PLE_PAYMENT_CONFIRMATION:
      return getPLEPaymentConfirmationSiteSection(isUserQuickLogged);

    default:
      return "Shopping_".concat(pascalCase(pageType));
  }
}
function noCase(string) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["flow"])(lodash__WEBPACK_IMPORTED_MODULE_0__["startCase"], lodash__WEBPACK_IMPORTED_MODULE_0__["toLower"])(string);
}
function pascalCase(string) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["flow"])(lodash__WEBPACK_IMPORTED_MODULE_0__["camelCase"], lodash__WEBPACK_IMPORTED_MODULE_0__["upperFirst"])(string);
}

/***/ })

},[[5,0,1,2,5,51,3,4,6,7,8,9,10,11,12,15,13,18,17,16,19,21,23,22,27,28,50]]]);